export type Maybe<T> = T | null;
export type Exact<T extends { [key: string]: unknown }> = { [K in keyof T]: T[K] };
export type MakeOptional<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]?: Maybe<T[SubKey]> };
export type MakeMaybe<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]: Maybe<T[SubKey]> };
/** All built-in and custom scalars, mapped to their actual values */
export type Scalars = {
  ID: string;
  String: string;
  Boolean: boolean;
  Int: number;
  Float: number;
  AddressId: any;
  UserId: any;
  ApprovalRequestId: any;
  ApprovalRequestEntryId: any;
  /** Date and time component in ISO-8601. See https://en.wikipedia.org/wiki/ISO_8601 */
  Date: any;
  AnyId: any;
  ContactId: any;
  MediaId: any;
  MerchantId: any;
  BrandId: any;
  CategoryId: any;
  ExpertProfileId: any;
  ProfileHighlightTypeId: any;
  SellableId: any;
  BigDecimal: any;
  /** javax.money.CurrencyUnit stored in ISO 4217 currency code standard, which use 3 letter codes */
  CurrencyUnit: any;
  SellablePriceSourceId: any;
  FulfillmentChannelId: any;
  AttributeSchemaRevisionId: any;
  AttributeSchemaId: any;
  ImportedIdentityId: any;
  AttributeValidatorReferenceId: any;
  /** Native types to graphql-java */
  Long: any;
  /** Only time in ISO-8601. See https://en.wikipedia.org/wiki/ISO_8601#Times */
  Time: any;
  LeadId: any;
  ExpertCuratedItemId: any;
  ConversationId: any;
  LeadLabelId: any;
  DealRequestId: any;
  PathFlowId: any;
  ConsumerExpertReviewId: any;
  ExpertApplicationId: any;
  ExpertHiringFlowStageId: any;
  ExpertHiringFlowId: any;
  DepartmentId: any;
  BusinessUserTeamId: any;
  ArticleRevisionId: any;
  ArticleId: any;
  ArticleContentBlockId: any;
  SellableTopListId: any;
  ExpertCuratedItemNoteId: any;
  ExpertCuratedItemNoteHistoryId: any;
  ExpertHiringFeedbackId: any;
  BusinessUserId: any;
  /** Date only component in ISO-8601. See https://en.wikipedia.org/wiki/ISO_8601#Calendar_dates */
  LocalDate: any;
  PathFlowPageId: any;
  BroadcastOfferId: any;
  OrderId: any;
  ShippingCarrierId: any;
  TransactionId: any;
  PaymentSourceId: any;
  PaymentProcessorAccountId: any;
  OrderLineItemId: any;
  SellableTermsId: any;
  FulfillmentOrderId: any;
  FulfillmentCenterId: any;
  FulfillmentShipmentMethodId: any;
  OrderRefundId: any;
  OrderEscalationId: any;
  OperatorId: any;
  SupportConversationId: any;
  TicketId: any;
  TicketActivityId: any;
  PostCartOrderActivityId: any;
  ExpertCuratedOrderId: any;
  FlightPlanId: any;
  FlightPlanLegId: any;
  AirportId: any;
  ScheduledPaymentId: any;
  PromotionId: any;
  PromotionRuleReferenceId: any;
  PromotionActionReferenceId: any;
  SimpleCuratedOrderId: any;
  ShippingGroupId: any;
  DealId: any;
  LeadNoteId: any;
  ExpertRecommendationId: any;
  SystemCuratedItemSurveyId: any;
  SystemCuratedItemId: any;
  LeadEscalationId: any;
  LeadConversationStarterActivityId: any;
  ConversationStarterDefinitionId: any;
  LeadTrainingScenarioId: any;
  MessageDeliveryLogId: any;
  TriggerId: any;
  TriggerNodeId: any;
  LeadCampaignId: any;
  CampaignId: any;
  CampaignAudienceId: any;
  CampaignAudienceIntegrationId: any;
  TriggerVersionHistoryId: any;
  CommTemplateTypeId: any;
  CommTemplateId: any;
  CommTemplateVersionHistoryId: any;
  LeadActivityId: any;
  SupportTaskActivityId: any;
  SupportTaskId: any;
  SavedSellableId: any;
  ConsumerSellableReactionId: any;
  SellableExpertCuratedItemNoteStatsId: any;
  SellableQuestionId: any;
  ConversationSnippetId: any;
  AwayAutoReplyId: any;
  LedgerAccountId: any;
  LedgerEntryId: any;
  BusinessUserActivityId: any;
  PayStructureId: any;
  PayStructureRevisionId: any;
  SchedulingTypeId: any;
  LocalTime: any;
  ShiftId: any;
  ShiftSlotId: any;
  LeadSurgeId: any;
  SchedulingDepartmentId: any;
  BusinessAccountId: any;
  ReferralCodeId: any;
  UserActivityId: any;
  ApprovalRequestSubmitDraftId: any;
  SessionId: any;
  CommTemplateFragmentId: any;
  CommTemplateFragmentVersionHistoryId: any;
  UserRegistrationId: any;
  PendingAccessContactId: any;
  FrontendTaskId: any;
  CallActivityId: any;
  GuestConversationSequenceId: any;
  PathSchemaRevisionId: any;
  PathSchemaId: any;
  PathSchemaFragmentRevisionId: any;
  PathSchemaFragmentId: any;
  PathEditorStateId: any;
  PathNodeId: any;
  PathSchemaOperationLogEntryId: any;
  PathConditionOperandRepositoryId: any;
  PathConditionOperandRepositoryEntryId: any;
  TagId: any;
  ExpertApplicationFolderId: any;
  ExpertReferralId: any;
  ExpertRankComputationLogId: any;
  SellableResearchLinkId: any;
  SellableCustomOfferRuleId: any;
  QuickReplyId: any;
  ExpertLeadFolderId: any;
  PredictedLifeTimeValueId: any;
  LeadCampaignRecipientId: any;
  SavedSearchId: any;
  ContentSelectionRuleId: any;
  ReportId: any;
  ExpertCuratedItemActivationId: any;
  ExpertCuratedOrderListActivationId: any;
  SuggestedAlternativeSellableId: any;
  ExpertCuratedActivityFeedItemId: any;
  SavedExpertCuratedItemsId: any;
  RecommendedListDefinitionId: any;
  ConfigEntryId: any;
  ExternalAdCampaignId: any;
  ExternalAdGroupId: any;
  SupportTaskFolderId: any;
  SellableInventoryItemId: any;
  PayoutId: any;
  PayLineItemId: any;
  RawSellableSourceId: any;
  RawSellableId: any;
  StandardizedSellableId: any;
  ProductCatalogRevisionId: any;
  ProductCatalogId: any;
  ProductCatalogGroupRevisionId: any;
  ProductCatalogGroupId: any;
  StandardizedSellableGroupId: any;
  RawSellableStandardizationRuleId: any;
  StandardizedSellableGroupCandidateId: any;
  SchedulingDemandForecastId: any;
  SchedulingUserAvailabilityId: any;
  ShiftSlotUserViewId: any;
  ShipmentPricingModelId: any;
  ReferralCodeShareId: any;
  ExperimentId: any;
  BookingId: any;
  SellableTopListDefinitionId: any;
  LedgerTransactionId: any;
  GiftCardId: any;
  PartnerUserId: any;
  IncomingCallId: any;
  PathQuestionSchemaId: any;
  PathListQuestionSchemaChoiceId: any;
  PathBranchRuleId: any;
  PathGraphFlowId: any;
  /** The scalar type for multipart file uploads. It should be used for input only. */
  Upload: any;
  SellableQuestionCandidateId: any;
};

export type AcceptEscalationInput = {
  id: Scalars['LeadEscalationId'];
  /** If set to true, the escalation will be close immediately regardless if the accepting expert takes any action or not */
  close?: Maybe<Scalars['Boolean']>;
};

export type AcceptEscalationResult = {
  __typename: 'AcceptEscalationResult';
  status: AcceptEscalationResultStatus;
  escalation: LeadEscalation;
  hasError: Scalars['Boolean'];
  errorMessage?: Maybe<Scalars['String']>;
};

export enum AcceptEscalationResultStatus {
  NOT_ALLOWED = 'NOT_ALLOWED',
  ACCEPTED = 'ACCEPTED',
  ALREADY_CLAIMED = 'ALREADY_CLAIMED',
  ESCALATION_CLOSED = 'ESCALATION_CLOSED'
}

export type AcceptProposedShiftsInput = {
  sourceRangeStart: Scalars['Date'];
  sourceRangeEnd: Scalars['Date'];
  schedulingTypeId: Scalars['SchedulingTypeId'];
};

export type AcceptProposedShiftsPayload = {
  __typename: 'AcceptProposedShiftsPayload';
  acceptedShifts: Scalars['Int'];
};

export enum AcceptRequestMode {
  ALWAYS = 'ALWAYS',
  WHEN_ACTIVATED = 'WHEN_ACTIVATED',
  WHEN_ACTIVATED_AND_AS_BACKUP = 'WHEN_ACTIVATED_AND_AS_BACKUP'
}

export type AcceptStandardizedSellableGroupCandidateInput = {
  id: Scalars['StandardizedSellableGroupCandidateId'];
};

export type AcceptStandardizedSellableGroupCandidatePayload = {
  __typename: 'AcceptStandardizedSellableGroupCandidatePayload';
  candidate: StandardizedSellableGroupCandidate;
};

export type AcceptSurgeShiftInput = {
  expertId: Scalars['BusinessUserId'];
  leadSurgeId: Scalars['LeadSurgeId'];
};

export type AcceptSurgeShiftPayload = {
  __typename: 'AcceptSurgeShiftPayload';
  hasError: Scalars['Boolean'];
  errorMessage?: Maybe<Scalars['String']>;
  shift?: Maybe<Shift>;
};

export type AccountExistsCreateAccountPathNodeFlowViewModelError = ErrorMessage & {
  __typename: 'AccountExistsCreateAccountPathNodeFlowViewModelError';
  errorMessage: Scalars['String'];
};

export type ActivateExpertCuratedOrderAsBookableInput = {
  id: Scalars['ExpertCuratedOrderId'];
};

export type ActivateExpertCuratedOrderAsBookablePayload = {
  __typename: 'ActivateExpertCuratedOrderAsBookablePayload';
  /**
   * The expert curated order that was activated if `hasError` is `false`, or the latest state of the still draft expert
   * curated order
   */
  expertCuratedOrder: ExpertCuratedOrder;
  /** If there was an error activating the curated order */
  hasError: Scalars['Boolean'];
  /** User displayable message for why the activation failed */
  errorMessage?: Maybe<Scalars['String']>;
};

export type ActivateExpertCuratedOrdersForLeadInput = {
  leadId: Scalars['LeadId'];
};

export type ActivateExpertCuratedOrdersForLeadPayload = {
  __typename: 'ActivateExpertCuratedOrdersForLeadPayload';
  /** If successful, hasError will be false, and activation will be present */
  activation?: Maybe<ExpertCuratedOrderListActivation>;
  /**
   * If there were any errors encountered while activating the curated orders. If true, `errors` will be non empty,
   * and/or errorMessage will have a top level error message
   */
  hasError: Scalars['Boolean'];
  /** Individual errors for each expert curated order */
  errors: Array<ExpertCuratedOrderActivationError>;
  /**
   * Top level error that's not associated with a particular ExpertCuratedOrder. This is mutually exclusive with
   * `errors` that contain errors for particular expert curated orders.
   */
  errorMessage?: Maybe<Scalars['String']>;
};

export type ActivateExpertInput = {
  id: Scalars['BusinessUserId'];
};

export type ActivateExpertPayload = {
  __typename: 'ActivateExpertPayload';
  error?: Maybe<Scalars['String']>;
  businessUser: BusinessUser;
};

export type ActivateFlightPlanInput = {
  id: Scalars['FlightPlanId'];
};

export type ActivateFlightPlanPayload = {
  __typename: 'ActivateFlightPlanPayload';
  flightPlan: FlightPlan;
  errorCode?: Maybe<FlightPlanEditErrorCode>;
  hasError: Scalars['Boolean'];
  errorMessage?: Maybe<Scalars['String']>;
};

export type ActivateGuestConversationSequenceInput = {
  id: Scalars['GuestConversationSequenceId'];
};

export type ActivateGuestConversationSequencePayload = {
  __typename: 'ActivateGuestConversationSequencePayload';
  sequence: GuestConversationSequence;
};

export type ActivatePayStructureRevisionInput = {
  id: Scalars['PayStructureRevisionId'];
  effectiveNow: Scalars['Boolean'];
};

export type ActivatePromotionInput = {
  id: Scalars['PromotionId'];
};

export type ActivatePromotionPayload = {
  __typename: 'ActivatePromotionPayload';
  promotion: Promotion;
  /**
   * The promotion that was previously active with the same promotion code, but was deactivated as a result of
   * `promotion` being activated.
   */
  replacedPromotion?: Maybe<Promotion>;
};

export type AddAddressInput = {
  userId: Scalars['UserId'];
  addressFieldInput?: Maybe<AddressFieldInput>;
};

export type AddAddresssPayload = {
  __typename: 'AddAddresssPayload';
  address?: Maybe<Address>;
  error?: Maybe<Scalars['String']>;
};

export type AddArticleRevisionTagInput = {
  id: Scalars['ArticleRevisionId'];
  tag: Scalars['String'];
};

export type AddBlacklistChannelAddressInput = {
  type: MessagingChannelType;
  address: Scalars['String'];
};

export type AddBlacklistChannelAddressPayload = {
  __typename: 'AddBlacklistChannelAddressPayload';
  hasError: Scalars['Boolean'];
};

export type AddCampaignAudienceIntegrationInput = {
  campaignAudienceId: Scalars['CampaignAudienceId'];
  externalPlatform: CampaignAudienceExternalPlatform;
  facebook?: Maybe<CampaignAudienceFacebookIntegrationInput>;
};

export type AddCampaignAudienceIntegrationPayload = {
  __typename: 'AddCampaignAudienceIntegrationPayload';
  campaignAudience: CampaignAudience;
  hasError: Scalars['Boolean'];
  errorMessage?: Maybe<Scalars['String']>;
};

export type AddChannelTemplateInput = {
  templateId: Scalars['CommTemplateId'];
  channelType: ChannelType;
};

export type AddCommentByExpertInput = {
  ticketId: Scalars['TicketId'];
  comment: Scalars['String'];
  leadId: Scalars['LeadId'];
};

export type AddCommentInput = {
  ticketId: Scalars['TicketId'];
  comment: Scalars['String'];
  commentType?: Maybe<TicketCommentType>;
};

export type AddCuratedItemToSavedCurationInput = {
  id: Scalars['SavedExpertCuratedItemsId'];
  expertId: Scalars['BusinessUserId'];
  sellableId: Scalars['SellableId'];
  fulfillmentNotes?: Maybe<ExpertCuratedItemFulfillmentNotesInput>;
};

export type AddCuratedItemToSavedCurationPayload = {
  __typename: 'AddCuratedItemToSavedCurationPayload';
  savedExpertCuratedItems?: Maybe<SavedExpertCuratedItems>;
  error?: Maybe<Scalars['String']>;
  hasError: Scalars['Boolean'];
};

export type AddEscalationLabelInput = {
  escalationId: Scalars['OrderEscalationId'];
  escalationLabel: OrderEscalationLabel;
};

export type AddEscalationOperatorNoteInput = {
  escalationId: Scalars['OrderEscalationId'];
  note: Scalars['String'];
};

export type AddExpertApplicationNoteInput = {
  applicationId: Scalars['ExpertApplicationId'];
  note: Scalars['String'];
};

export type AddExpertApplicationReviewInput = {
  applicationId: Scalars['ExpertApplicationId'];
  rating: ExpertApplicationRating;
  reason?: Maybe<Scalars['String']>;
};

export type AddExpertApplicationReviewPayload = {
  __typename: 'AddExpertApplicationReviewPayload';
  application: ExpertApplication;
};

export type AddExpertCuratedItemToCartInput = {
  id: Scalars['ExpertCuratedItemId'];
};

export type AddExpertCuratedItemToCartPayload = {
  __typename: 'AddExpertCuratedItemToCartPayload';
  expertCuratedItem: ExpertCuratedItem;
  order: Order;
  errors?: Maybe<Array<Scalars['String']>>;
};

export type AddExpertSpecialCareTagInput = {
  expertId: Scalars['BusinessUserId'];
  careType: Scalars['String'];
};

export type AddGuestConversationSequenceMessageInput = {
  sequenceId: Scalars['GuestConversationSequenceId'];
  templateName: Scalars['String'];
  richCardType?: Maybe<MessageRichCardType>;
};

export type AddGuestConversationSequenceMessagePayload = {
  __typename: 'AddGuestConversationSequenceMessagePayload';
  sequence: GuestConversationSequence;
};

export type AddItemsToOrderInput = {
  /** If omitted, user context will be assumed and the user's current cart will be operated on */
  id?: Maybe<Scalars['OrderId']>;
  /** Simplified API that only adds sellables */
  sellableIds?: Maybe<Array<Scalars['SellableId']>>;
  sellables?: Maybe<Array<AddItemsToOrderSellableInput>>;
};

export type AddItemsToOrderPayload = {
  __typename: 'AddItemsToOrderPayload';
  order: Order;
  error?: Maybe<Scalars['String']>;
};

export type AddItemsToOrderSellableInput = {
  sellableId: Scalars['SellableId'];
  /** Quantity of items to add; defaults to 1 if omitted */
  quantity?: Maybe<Scalars['Int']>;
  /**
   * Expert only property; if this line item is explicitly marked as not taxable.
   * Note that by this being `false` does not mean this line item is guaranteed to be taxed - it just means the
   * natural taxation logic will apply to this item.
   */
  nonTaxable?: Maybe<Scalars['Boolean']>;
  /** Expert only property; override the sellable price with a custom one */
  priceOverride?: Maybe<MonetaryAmountInput>;
};

export type AddLeadSpecialCareTagInput = {
  leadId: Scalars['LeadId'];
  careType: Scalars['String'];
};

export type AddManualAdjustmentPayLineItemsInput = {
  payoutId: Scalars['PayoutId'];
  adjustments: Array<ManualAdjustmentPayLineItemInput>;
};

export type AddOfferToCartInput = {
  id: Scalars['BroadcastOfferId'];
};

export type AddOfferToCartPayload = {
  __typename: 'AddOfferToCartPayload';
  order: Order;
};

export type AddOperatorNoteInput = {
  orderId: Scalars['OrderId'];
  title?: Maybe<Scalars['String']>;
  note: Scalars['String'];
  emailSupport?: Maybe<Scalars['Boolean']>;
  lineItemId?: Maybe<Scalars['OrderLineItemId']>;
};

export type AddOrderReturnShipmentTrackingInput = {
  orderRefundId: Scalars['OrderRefundId'];
  shippingCarrierId: Scalars['ShippingCarrierId'];
  trackingNumber: Scalars['String'];
  shippingStatus?: Maybe<ShippingStatus>;
};

export type AddProfileHighlightInput = {
  expertProfileId: Scalars['ExpertProfileId'];
  highlight: ProfileHighlightInput;
};

export type AddPromotionToOrderInput = {
  id: Scalars['OrderId'];
  promotionCode: Scalars['String'];
};

export type AddPromotionToOrderPayload = {
  __typename: 'AddPromotionToOrderPayload';
  order: Order;
  hasError: Scalars['Boolean'];
  errorMessage?: Maybe<Scalars['String']>;
};

/**
 * Use Address if you want to save Address data in a separate collection vs PostalAddress,
 * which is used as an embeddable object
 * All new implementations should prefer Address going forward as they allows reusablity of Addresses
 */
export type Address = AddressFields & {
  __typename: 'Address';
  addresseeName?: Maybe<Scalars['String']>;
  businessName?: Maybe<Scalars['String']>;
  line1?: Maybe<Scalars['String']>;
  line2?: Maybe<Scalars['String']>;
  city?: Maybe<Scalars['String']>;
  state?: Maybe<Scalars['String']>;
  country?: Maybe<Scalars['String']>;
  countryDetails?: Maybe<Country>;
  postalCode: Scalars['String'];
  securityCode?: Maybe<Scalars['String']>;
  phoneNumber?: Maybe<Scalars['String']>;
  parsedPhoneNumber?: Maybe<ParsedPhoneNumber>;
  id: Scalars['AddressId'];
  userId: Scalars['UserId'];
  active: Scalars['Boolean'];
  userFriendlyName?: Maybe<Scalars['String']>;
  isDefault?: Maybe<Scalars['Boolean']>;
};

export type AddressFieldInput = {
  reusableAddress?: Maybe<Scalars['Boolean']>;
  addresseeName: Scalars['String'];
  businessName?: Maybe<Scalars['String']>;
  line1: Scalars['String'];
  line2?: Maybe<Scalars['String']>;
  city: Scalars['String'];
  state?: Maybe<Scalars['String']>;
  country: Scalars['String'];
  postalCode: Scalars['String'];
  securityCode?: Maybe<Scalars['String']>;
  phoneNumber?: Maybe<Scalars['String']>;
  userFriendlyName?: Maybe<Scalars['String']>;
  isDefault?: Maybe<Scalars['Boolean']>;
};

export type AddressFields = {
  addresseeName?: Maybe<Scalars['String']>;
  businessName?: Maybe<Scalars['String']>;
  line1?: Maybe<Scalars['String']>;
  line2?: Maybe<Scalars['String']>;
  city?: Maybe<Scalars['String']>;
  state?: Maybe<Scalars['String']>;
  country?: Maybe<Scalars['String']>;
  countryDetails?: Maybe<Country>;
  postalCode: Scalars['String'];
};


/** Either addressId or addressFieldInput must be provided */
export type AddressInput = {
  addressId?: Maybe<Scalars['AddressId']>;
  addressFieldInput?: Maybe<AddressFieldInput>;
};

export type AddScheduleReportInput = {
  reportId: Scalars['ReportId'];
  refreshIntervalInMinutes: Scalars['Int'];
  runImmediately: Scalars['Boolean'];
};

export type AddSupportToLeadConversationInput = {
  leadId: Scalars['LeadId'];
};

export type AddSupportToLeadConversationPayload = {
  __typename: 'AddSupportToLeadConversationPayload';
  success: Scalars['Boolean'];
  lead?: Maybe<Lead>;
};

export type AddTipToOrderInput = {
  id: Scalars['OrderId'];
  tip: MonetaryAmountInput;
  /**
   * It is required to indicate which expert receives the tip. All entries in this array must add up to 100%.
   * Use `recommendTipPercentagesForOrder` to get recommended experts and tip percentages
   */
  tipPercentages: Array<ExpertTipPercentageInput>;
};

export type AddTipToOrderPayload = {
  __typename: 'AddTipToOrderPayload';
  order: Order;
};

export type AddUserInfoForLeadInput = {
  leadId: Scalars['LeadId'];
  firstName: Scalars['String'];
  lastName?: Maybe<Scalars['String']>;
  emailAddress?: Maybe<Scalars['String']>;
  phoneNumber?: Maybe<Scalars['String']>;
};

export type AddUserInfoForLeadPayload = {
  __typename: 'AddUserInfoForLeadPayload';
  lead: Lead;
};

export type AdjustRequestedRefundAmountInput = {
  orderRefundId: Scalars['OrderRefundId'];
  requestedAmount: MonetaryAmountInput;
  lineItemRefunds?: Maybe<Array<OrderLineItemRefundInput>>;
  refundReason?: Maybe<OrderRefundReason>;
  commissionTreatment?: Maybe<ExpertCommissionRefundTreatment>;
};

export type AdministrativeArea = {
  __typename: 'AdministrativeArea';
  /** country code this administrative area is associated with, e.g.: "US", "AU", etc */
  countryCode: Scalars['String'];
  /** the code for this administrative area, e.g.: "CA" for California in US */
  code: Scalars['String'];
  /** the display name for this administrative area, e.g.: "California" */
  displayName: Scalars['String'];
};

export type AffirmAccount = PaymentProcessorAccount & {
  __typename: 'AffirmAccount';
  id: Scalars['PaymentProcessorAccountId'];
  createdAt: Scalars['Date'];
  updatedAt: Scalars['Date'];
  type: PaymentProcessorType;
  userId: Scalars['UserId'];
  paymentSources: Array<PaymentSource>;
  /** This is same as email but with Affirm prefix, as the Affirm doesn't return an Id in the response. */
  externalAccountId?: Maybe<Scalars['String']>;
  name?: Maybe<Scalars['String']>;
  description?: Maybe<Scalars['String']>;
  email?: Maybe<Scalars['String']>;
};

export type AffirmPaymentSource = PaymentSource & {
  __typename: 'AffirmPaymentSource';
  id: Scalars['PaymentSourceId'];
  createdAt: Scalars['Date'];
  updatedAt: Scalars['Date'];
  externalSourceId: Scalars['String'];
  type: PaymentProcessorType;
  usage: PaymentSourceUsage;
  status: PaymentSourceStatus;
  userId: Scalars['UserId'];
  billingAddress?: Maybe<Address>;
  paymentEntity: PaymentEntity;
  isDefault: Scalars['Boolean'];
};

export type AfterPayAccount = PaymentProcessorAccount & {
  __typename: 'AfterPayAccount';
  id: Scalars['PaymentProcessorAccountId'];
  createdAt: Scalars['Date'];
  updatedAt: Scalars['Date'];
  type: PaymentProcessorType;
  userId: Scalars['UserId'];
  paymentSources: Array<PaymentSource>;
  /** This is same as email but with Afterpay prefix, as the Afterpay doesn't return an Id in the response. */
  externalAccountId?: Maybe<Scalars['String']>;
  name?: Maybe<Scalars['String']>;
  description?: Maybe<Scalars['String']>;
  email?: Maybe<Scalars['String']>;
};

export type AfterpayPaymentSource = PaymentSource & {
  __typename: 'AfterpayPaymentSource';
  id: Scalars['PaymentSourceId'];
  createdAt: Scalars['Date'];
  updatedAt: Scalars['Date'];
  externalSourceId: Scalars['String'];
  type: PaymentProcessorType;
  usage: PaymentSourceUsage;
  status: PaymentSourceStatus;
  userId: Scalars['UserId'];
  billingAddress?: Maybe<Address>;
  paymentEntity: PaymentEntity;
  isDefault: Scalars['Boolean'];
};

export type AggregateExpertReport = {
  __typename: 'AggregateExpertReport';
  globalStats: GlobalStatsAggregateExpertReport;
  globalStatsNew: GlobalStats;
  categoryBrandStats: Array<BrandStatsAggregateExpertReport>;
  categoryGroupedBrandStats: CategoryGroupedBrandStatsAggregateExpertReport;
  departmentBrandStats: Array<BrandStatsAggregateExpertReport>;
};


export type AggregateExpertReportCategoryBrandStatsArgs = {
  categoryId: Scalars['CategoryId'];
  limit?: Maybe<Scalars['Int']>;
};


export type AggregateExpertReportCategoryGroupedBrandStatsArgs = {
  departmentId: Scalars['DepartmentId'];
};


export type AggregateExpertReportDepartmentBrandStatsArgs = {
  departmentId: Scalars['DepartmentId'];
  limit?: Maybe<Scalars['Int']>;
};

export type Airport = {
  __typename: 'Airport';
  id: Scalars['AirportId'];
  type: AirportType;
  active: Scalars['Boolean'];
  name: Scalars['String'];
  latitudeDegree: Scalars['Float'];
  longitudeDegree: Scalars['Float'];
  continentCode: Scalars['String'];
  countryCode: Scalars['String'];
  zoneId: Scalars['String'];
  dataSourceCode: Scalars['String'];
  iataCode?: Maybe<Scalars['String']>;
  icaoCode?: Maybe<Scalars['String']>;
  displayCode: Scalars['String'];
};


export enum AirportType {
  LARGE_AIRPORT = 'LARGE_AIRPORT',
  MEDIUM_AIRPORT = 'MEDIUM_AIRPORT',
  SMALL_AIRPORT = 'SMALL_AIRPORT'
}

export type AirportTypeaheadHit = {
  __typename: 'AirportTypeaheadHit';
  id: Scalars['AirportId'];
  /** The matched text string in the indexed keywords */
  text: Scalars['String'];
  /** The airport name */
  name: Scalars['String'];
  dataSourceCode: Scalars['String'];
  iataCode?: Maybe<Scalars['String']>;
  icaoCode?: Maybe<Scalars['String']>;
  displayCode: Scalars['String'];
  airport: Airport;
};

export type AirportTypeaheadPayload = {
  __typename: 'AirportTypeaheadPayload';
  hits: Array<AirportTypeaheadHit>;
};

export type AirportTypeaheadQuery = {
  prefixSearch?: Maybe<Scalars['String']>;
};

export type AlreadyCompletedNavigatePathGraphFlowError = ErrorMessage & {
  __typename: 'AlreadyCompletedNavigatePathGraphFlowError';
  errorMessage: Scalars['String'];
};

export type AlreadyCreatedProductCatalogDraftFromSellableError = ErrorMessage & {
  __typename: 'AlreadyCreatedProductCatalogDraftFromSellableError';
  errorMessage: Scalars['String'];
};

export type AlreadyCreatedProductCatalogGroupDraftFromSellableError = ErrorMessage & {
  __typename: 'AlreadyCreatedProductCatalogGroupDraftFromSellableError';
  errorMessage: Scalars['String'];
};

export type AlreadySubmittedApprovalRequestCreationError = ErrorMessage & {
  __typename: 'AlreadySubmittedApprovalRequestCreationError';
  errorMessage: Scalars['String'];
  approvalRequest: ApprovalRequest;
};

export type AlreadySubmittedApprovalRequestSubmitDraftEditError = ErrorMessage & {
  __typename: 'AlreadySubmittedApprovalRequestSubmitDraftEditError';
  errorMessage: Scalars['String'];
  approvalRequest: ApprovalRequest;
};

export type AlwaysTrueConditionDefinition = ConditionDefinition & {
  __typename: 'AlwaysTrueConditionDefinition';
  type: ConditionType;
};

export type AmazonSellablePriceSource = SellablePriceSource & {
  __typename: 'AmazonSellablePriceSource';
  id: Scalars['SellablePriceSourceId'];
  type: SellablePriceSourceType;
  sellable: Sellable;
  price?: Maybe<MonetaryAmount>;
  bestOfferPrice?: Maybe<MonetaryAmount>;
  cost?: Maybe<MonetaryAmount>;
  expiresAt?: Maybe<Scalars['Date']>;
  fulfillmentChannel?: Maybe<FulfillmentChannel>;
  canRefresh: Scalars['Boolean'];
  willRefresh: Scalars['Boolean'];
  asin: Scalars['String'];
  estimatedAvailableAt?: Maybe<Scalars['Date']>;
};

/**
 * Flat amount taken off the order. This is implemented by taking the amount off of line items that meet
 * `Promotion.rules` criteria. If the amount off is more than the cost of the line items, the promotion will not be
 * applied as its assumed it's an error in defining the promotion action.
 */
export type AmountOffOrderPromotionActionReference = PromotionActionReference & {
  __typename: 'AmountOffOrderPromotionActionReference';
  id: Scalars['PromotionActionReferenceId'];
  type: PromotionActionType;
  /** Total amount off order; amount greater than zero */
  amountOff: MonetaryAmount;
};

/** See `AmountOffOrderPromotionActionReference` for documentation */
export type AmountOffOrderPromotionActionReferenceInput = {
  /** Total amount off order; amount greater than zero */
  amountOff: MonetaryAmountInput;
};


export type ApplyExternalAdBudgetInput = {
  categoryId: Scalars['CategoryId'];
};

export type ApplyExternalAdBudgetPayload = {
  __typename: 'ApplyExternalAdBudgetPayload';
  hasError: Scalars['Boolean'];
};

export type ApplyFinishRedirectPathNodeFlowViewModelSuccess = {
  __typename: 'ApplyFinishRedirectPathNodeFlowViewModelSuccess';
  application: ExpertApplication;
};

export type ApplyStoreCreditToOrderInput = {
  id: Scalars['OrderId'];
};

export type ApplyStoreCreditToOrderPayload = {
  __typename: 'ApplyStoreCreditToOrderPayload';
  order: Order;
  error?: Maybe<Scalars['String']>;
};

export type ApprovableEntityDependencyResolutionError = NotEligibleStateApprovableEntityDependencyResolutionError | NotFoundApprovableEntityDependencyResolutionError | RecursiveUsageApprovableEntityDependencyResolutionError;

export type ApprovableEntityNotReadyApprovalRequestCreationError = ErrorMessage & {
  __typename: 'ApprovableEntityNotReadyApprovalRequestCreationError';
  errorMessage: Scalars['String'];
  entity?: Maybe<ApprovalRequestEntity>;
};

export enum ApprovableEntityState {
  DRAFT = 'DRAFT',
  IN_REVIEW = 'IN_REVIEW',
  PUBLISHED = 'PUBLISHED',
  ARCHIVED = 'ARCHIVED'
}

export type ApprovableEntitySwitchToPublishFailedApprovalRequestPublishError = ApprovalRequestPublishError & ErrorMessage & {
  __typename: 'ApprovableEntitySwitchToPublishFailedApprovalRequestPublishError';
  errorMessage: Scalars['String'];
  breadcrumbTrail: Array<ApprovalRequest>;
  approvalRequest: ApprovalRequest;
  entity?: Maybe<ApprovalRequestEntity>;
};

export type ApprovalEntitiesChangedApprovalRequestCreationError = ErrorMessage & {
  __typename: 'ApprovalEntitiesChangedApprovalRequestCreationError';
  errorMessage: Scalars['String'];
  approvalRequestSubmitDraft: ApprovalRequestSubmitDraft;
};

export type ApprovalRequest = {
  __typename: 'ApprovalRequest';
  id: Scalars['ApprovalRequestId'];
  state: ApprovalRequestState;
  reviewStatus?: Maybe<ApprovalReviewStatus>;
  entries: Array<ApprovalRequestActivityEntry>;
  /** Latest `SubmitForReviewApprovalRequestActivityEntryDetail` in `entries` */
  submitForReviewEntryDetail: SubmitForReviewApprovalRequestActivityEntryDetail;
  usages: Array<ApprovalRequest>;
};

export type ApprovalRequestActivityEntry = {
  __typename: 'ApprovalRequestActivityEntry';
  id: Scalars['ApprovalRequestEntryId'];
  createdAt: Scalars['Date'];
  updatedAt: Scalars['Date'];
  createdBy: ApprovalRequestAuthor;
  detail: ApprovalRequestActivityEntryDetail;
};

export type ApprovalRequestActivityEntryDetail = {
  entryType: ApprovalRequestActivityEntryType;
};

export enum ApprovalRequestActivityEntryType {
  SUBMIT_FOR_REVIEW = 'SUBMIT_FOR_REVIEW',
  COMMENT = 'COMMENT',
  APPROVE = 'APPROVE',
  REJECT = 'REJECT',
  PUBLISH = 'PUBLISH',
  CLOSE = 'CLOSE'
}

export type ApprovalRequestAuthor = Operator | SystemUser;

export type ApprovalRequestCreationError = AlreadySubmittedApprovalRequestCreationError | ApprovalEntitiesChangedApprovalRequestCreationError | DependencyResolutionFailedApprovalRequestCreationError | ApprovableEntityNotReadyApprovalRequestCreationError | ArchiveFailedApprovalRequestCreationError;

export type ApprovalRequestEntity = {
  id: Scalars['AnyId'];
  entityType: ApprovalRequestEntityType;
  entityTypeDisplayName: Scalars['String'];
  displayName?: Maybe<Scalars['String']>;
};

export enum ApprovalRequestEntityType {
  PATH_SCHEMA = 'PATH_SCHEMA',
  PATH_SCHEMA_FRAGMENT = 'PATH_SCHEMA_FRAGMENT',
  ATTRIBUTE_SCHEMA = 'ATTRIBUTE_SCHEMA'
}



export type ApprovalRequestPublishError = {
  errorMessage: Scalars['String'];
  breadcrumbTrail: Array<ApprovalRequest>;
  approvalRequest: ApprovalRequest;
};

export enum ApprovalRequestState {
  PREPARING_REVIEW = 'PREPARING_REVIEW',
  IN_REVIEW = 'IN_REVIEW',
  PUBLISHING = 'PUBLISHING',
  PUBLISHED = 'PUBLISHED',
  CLOSING = 'CLOSING',
  CLOSED = 'CLOSED'
}

export type ApprovalRequestSubmitDraft = {
  __typename: 'ApprovalRequestSubmitDraft';
  id: Scalars['ApprovalRequestSubmitDraftId'];
  submitted: Scalars['Boolean'];
  entity?: Maybe<ApprovalRequestEntity>;
  createdBy: ApprovalRequestAuthor;
  description?: Maybe<Scalars['String']>;
  dependencies: Array<ApprovalRequestSubmitDraftDependency>;
};

export type ApprovalRequestSubmitDraftDependency = {
  __typename: 'ApprovalRequestSubmitDraftDependency';
  id: Scalars['AnyId'];
  entity?: Maybe<ApprovalRequestEntity>;
  state: ApprovalRequestSubmitDraftDependencyState;
  dependencies: Array<ApprovalRequestSubmitDraftDependencyReference>;
  usages: Array<ApprovalRequestSubmitDraftDependencyReference>;
};

export type ApprovalRequestSubmitDraftDependencyReference = {
  __typename: 'ApprovalRequestSubmitDraftDependencyReference';
  id: Scalars['String'];
  entity?: Maybe<ApprovalRequestEntity>;
  state: ApprovalRequestSubmitDraftDependencyState;
};

export enum ApprovalRequestSubmitDraftDependencyState {
  INCLUDED = 'INCLUDED',
  EXCLUDED = 'EXCLUDED',
  REQUIRED = 'REQUIRED'
}

export type ApprovalRequestSubmitDraftEditError = AlreadySubmittedApprovalRequestSubmitDraftEditError | DependencyRequiredApprovalRequestSubmitDraftEditError | NoSuchDependencyApprovalRequestSubmitDraftEditError;


export enum ApprovalReviewStatus {
  APPROVED = 'APPROVED',
  REJECTED = 'REJECTED'
}

export type ApproveApprovalRequestActivityEntryDetail = ApprovalRequestActivityEntryDetail & {
  __typename: 'ApproveApprovalRequestActivityEntryDetail';
  entryType: ApprovalRequestActivityEntryType;
};

export type ApproveApprovalRequestError = DefaultErrorMessage;

export type ApproveApprovalRequestInput = {
  approvalRequestId: Scalars['ApprovalRequestId'];
  /** If provided, will create a comment entry before the approval entry */
  comment?: Maybe<Scalars['String']>;
};

export type ApproveApprovalRequestPayload = {
  __typename: 'ApproveApprovalRequestPayload';
  approvalRequest?: Maybe<ApprovalRequest>;
  error?: Maybe<ApproveApprovalRequestError>;
};

export type ApproveExpertApplicationInput = {
  applicationId: Scalars['ExpertApplicationId'];
  expectedCompletionDate?: Maybe<Scalars['LocalDate']>;
};

export type ApproveExpertApplicationPayload = {
  __typename: 'ApproveExpertApplicationPayload';
  error?: Maybe<Scalars['String']>;
  application: ExpertApplication;
};

export type ApproveExpertCuratedItemNoteInput = {
  id: Scalars['ExpertCuratedItemNoteId'];
  changedById: Scalars['OperatorId'];
};

export type ApproveExpertCuratedItemNotePayload = {
  __typename: 'ApproveExpertCuratedItemNotePayload';
  expertCuratedItemNote?: Maybe<ExpertCuratedItemNote>;
  hasError: Scalars['Boolean'];
  errorMessage?: Maybe<Scalars['String']>;
};

export type ApproveSellableQuestionCandidateInput = {
  sellableIds: Array<Scalars['SellableId']>;
  messageId: Scalars['String'];
  conversationId: Scalars['ConversationId'];
  questionTitle: Scalars['String'];
  messages: Array<ConversationSnippetMessageInput>;
};

export type ApproveSellableQuestionCandidatePayload = {
  __typename: 'ApproveSellableQuestionCandidatePayload';
  candidates: Array<SellableQuestionCandidate>;
  errorMessage?: Maybe<Scalars['String']>;
};

export type ArchiveArticleInput = {
  articleId: Scalars['ArticleId'];
};

export type ArchiveArticlePayload = {
  __typename: 'ArchiveArticlePayload';
  articleRevision?: Maybe<ArticleRevision>;
  errorMessage?: Maybe<Scalars['String']>;
  hasError: Scalars['Boolean'];
};

export type ArchiveCampaignAudienceInput = {
  id: Scalars['CampaignAudienceId'];
};

export type ArchiveCampaignAudiencePayload = {
  __typename: 'ArchiveCampaignAudiencePayload';
  campaignAudience: CampaignAudience;
  hasError: Scalars['Boolean'];
  errorMessage?: Maybe<Scalars['String']>;
};

export type ArchivedProductCatalogGroupPublishError = ErrorMessage & {
  __typename: 'ArchivedProductCatalogGroupPublishError';
  errorMessage: Scalars['String'];
  revisions: Array<ProductCatalogGroupRevision>;
};

export type ArchivedProductCatalogPublishError = ErrorMessage & {
  __typename: 'ArchivedProductCatalogPublishError';
  errorMessage: Scalars['String'];
  revisions: Array<ProductCatalogRevision>;
};

export type ArchiveExperimentInput = {
  id: Scalars['ExperimentId'];
  ignoreUsages?: Maybe<Scalars['Boolean']>;
};

export type ArchiveExperimentPayload = {
  __typename: 'ArchiveExperimentPayload';
  experiment: ExperimentDefinition;
  errorMessage?: Maybe<Scalars['String']>;
  hasError: Scalars['Boolean'];
};

export type ArchiveFailedApprovalRequestCreationError = ErrorMessage & {
  __typename: 'ArchiveFailedApprovalRequestCreationError';
  errorMessage: Scalars['String'];
  entity?: Maybe<ApprovalRequestEntity>;
};

export type ArchiveProductCatalogGroupRevisionInput = {
  revisionId: Scalars['ProductCatalogGroupRevisionId'];
  requestedById: Scalars['AnyId'];
};

export type ArchiveProductCatalogGroupRevisionPayload = {
  __typename: 'ArchiveProductCatalogGroupRevisionPayload';
  revision: ProductCatalogGroupRevision;
  error?: Maybe<ProductCatalogGroupArchiveRevisionError>;
};

export type ArchiveProductCatalogRevisionInput = {
  revisionId: Scalars['ProductCatalogRevisionId'];
  requestedById: Scalars['AnyId'];
};

export type ArchiveProductCatalogRevisionPayload = {
  __typename: 'ArchiveProductCatalogRevisionPayload';
  revision: ProductCatalogRevision;
  error?: Maybe<ProductCatalogArchiveRevisionError>;
};

export type ArchiveSellableTopListInput = {
  id: Scalars['SellableTopListDefinitionId'];
};

export type ArchiveTriggerInput = {
  triggerId: Scalars['TriggerId'];
  notes?: Maybe<Scalars['String']>;
};

export type ArchiveTriggerPayload = {
  __typename: 'ArchiveTriggerPayload';
  triggersArchived: Array<Trigger>;
  error?: Maybe<Scalars['String']>;
};

export type ArticleAuthor = User | BusinessUser | Operator;

export type ArticleContentBlock = {
  id: Scalars['ArticleContentBlockId'];
  type: ArticleContentBlockType;
};


export type ArticleContentBlockInput = {
  richText?: Maybe<ArticleRichTextContentBlockInput>;
  mediaFile?: Maybe<ArticleMediaFileContentBlockInput>;
  embedMedia?: Maybe<ArticleEmbedMediaContentBlockInput>;
  sellable?: Maybe<ArticleSellableContentBlockInput>;
  sellableList?: Maybe<ArticleSellableListContentBlockInput>;
};

export enum ArticleContentBlockType {
  RICH_TEXT = 'RICH_TEXT',
  MEDIA_FILE = 'MEDIA_FILE',
  EMBED_MEDIA = 'EMBED_MEDIA',
  SELLABLE = 'SELLABLE',
  SELLABLE_LIST = 'SELLABLE_LIST'
}

export type ArticleEmbedMediaContentBlock = ArticleContentBlock & {
  __typename: 'ArticleEmbedMediaContentBlock';
  id: Scalars['ArticleContentBlockId'];
  type: ArticleContentBlockType;
  media?: Maybe<EmbedMedia>;
};

export type ArticleEmbedMediaContentBlockInput = {
  media?: Maybe<EmbedMediaInput>;
};


export type ArticleMedia = {
  __typename: 'ArticleMedia';
  media: MediaFile;
  alternativeText?: Maybe<Scalars['String']>;
  title?: Maybe<Scalars['String']>;
};

export type ArticleMediaFileContentBlock = ArticleContentBlock & {
  __typename: 'ArticleMediaFileContentBlock';
  id: Scalars['ArticleContentBlockId'];
  type: ArticleContentBlockType;
  media?: Maybe<ArticleMedia>;
};

export type ArticleMediaFileContentBlockInput = {
  media?: Maybe<ArticleMediaInput>;
};

export type ArticleMediaInput = {
  mediaId: Scalars['MediaId'];
  alternativeText?: Maybe<Scalars['String']>;
  title?: Maybe<Scalars['String']>;
};

export type ArticleNavigation = {
  __typename: 'ArticleNavigation';
  id: Scalars['String'];
  sections: Array<ArticleNavigationSection>;
};


export type ArticleNavigationSectionsArgs = {
  limit?: Maybe<Scalars['Int']>;
};

export type ArticleNavigationLink = {
  __typename: 'ArticleNavigationLink';
  facets: Array<FacetSelectionPayload>;
  sortBy: ArticleSort;
  sortOrder: SortOrder;
};

export type ArticleNavigationSection = {
  __typename: 'ArticleNavigationSection';
  id: Scalars['String'];
  displayName: Scalars['String'];
  articles: Array<ArticleRevision>;
  link: ArticleNavigationLink;
};


export type ArticleNavigationSectionArticlesArgs = {
  limit?: Maybe<Scalars['Int']>;
};

export type ArticleRevision = {
  __typename: 'ArticleRevision';
  id: Scalars['ArticleRevisionId'];
  articleId: Scalars['ArticleId'];
  categories: Array<Category>;
  brands: Array<Brand>;
  friendlyId: Scalars['String'];
  slug: Scalars['String'];
  revisionNumber: Scalars['Int'];
  superseded?: Maybe<ArticleRevision>;
  authors: Array<ArticleAuthor>;
  state: ArticleRevisionState;
  attributes: Array<Attribute>;
  tags: Array<Scalars['String']>;
  title: Scalars['String'];
  featuredImage?: Maybe<ArticleMedia>;
  summaryText?: Maybe<Scalars['String']>;
  contentBlocks: Array<ArticleContentBlock>;
  /** The date when this revision was published, if it is published or was published before (e.g. published then archived) */
  publishedAt?: Maybe<Scalars['Date']>;
  updatedBy: Identity;
  updatedAt: Scalars['Date'];
  stats: ArticleStats;
  relatedArticles: Array<ArticleRevision>;
};


export type ArticleRevisionRelatedArticlesArgs = {
  limit?: Maybe<Scalars['Int']>;
};


export enum ArticleRevisionState {
  DRAFT = 'DRAFT',
  PUBLISHED = 'PUBLISHED',
  ARCHIVED = 'ARCHIVED'
}

export type ArticleRichTextContentBlock = ArticleContentBlock & {
  __typename: 'ArticleRichTextContentBlock';
  id: Scalars['ArticleContentBlockId'];
  type: ArticleContentBlockType;
  markdown: Scalars['String'];
};

export type ArticleRichTextContentBlockInput = {
  markdown: Scalars['String'];
};

export type ArticleSearchConnection = {
  __typename: 'ArticleSearchConnection';
  facets: Array<DisplayFacet>;
  edges: Array<ArticleSearchEdge>;
  pageInfo: PageInfo;
  count: Scalars['Int'];
};

export type ArticleSearchEdge = {
  __typename: 'ArticleSearchEdge';
  node: ArticleRevision;
  cursor: Scalars['String'];
};

export type ArticleSearchRequest = {
  facets?: Maybe<Array<FacetSelection>>;
  title?: Maybe<Scalars['String']>;
  tag?: Maybe<Scalars['String']>;
  keywords?: Maybe<Scalars['String']>;
  authorIds?: Maybe<Array<Scalars['AnyId']>>;
  categoryIds?: Maybe<Array<Scalars['CategoryId']>>;
  attributes?: Maybe<Array<AttributeInput>>;
  state?: Maybe<ArticleRevisionState>;
  maxFacetTerms?: Maybe<Scalars['Int']>;
};

export type ArticleSellableContentBlock = ArticleContentBlock & {
  __typename: 'ArticleSellableContentBlock';
  id: Scalars['ArticleContentBlockId'];
  type: ArticleContentBlockType;
  sellable?: Maybe<Sellable>;
};

export type ArticleSellableContentBlockInput = {
  sellableId?: Maybe<Scalars['SellableId']>;
};

export type ArticleSellableListContentBlock = ArticleContentBlock & {
  __typename: 'ArticleSellableListContentBlock';
  id: Scalars['ArticleContentBlockId'];
  type: ArticleContentBlockType;
  sellables: Array<Sellable>;
};

export type ArticleSellableListContentBlockInput = {
  sellableIds: Array<Scalars['SellableId']>;
};

export enum ArticleSort {
  /** The date when it is first published */
  FIRST_PUBLISHED = 'FIRST_PUBLISHED',
  /** The date when it is last updated */
  LAST_UPDATED = 'LAST_UPDATED',
  /** The view count */
  VIEW_COUNT = 'VIEW_COUNT',
  /** Relevance score computed from sellables that match users intent */
  RELEVANCE = 'RELEVANCE'
}

export type ArticleStats = {
  __typename: 'ArticleStats';
  id: Scalars['ArticleId'];
  viewCount: Scalars['Long'];
};

export type AssignEscalationInput = {
  escalationId: Scalars['OrderEscalationId'];
  assignedToId: Scalars['OperatorId'];
};

export type AssignFulfillmentOperatorInput = {
  orderId: Scalars['OrderId'];
  operatorId: Scalars['OperatorId'];
};

export type AssignSupportTaskActivity = SupportTaskActivity & {
  __typename: 'AssignSupportTaskActivity';
  id: Scalars['SupportTaskActivityId'];
  supportTask: SupportTask;
  action: SupportTaskAction;
  actor: SupportTaskActor;
  consumer: User;
  lead?: Maybe<Lead>;
  occurredAt: Scalars['Date'];
  assignedTo: Operator;
};

export type AssignSupportTaskInput = {
  supportTaskId: Scalars['SupportTaskId'];
  assigneeId?: Maybe<Scalars['OperatorId']>;
};

export type AssignSupportTaskPayload = {
  __typename: 'AssignSupportTaskPayload';
  supportTask?: Maybe<SupportTask>;
  error?: Maybe<Scalars['String']>;
};

export type AssignTicketInput = {
  ticketId: Scalars['TicketId'];
  assignToId: Scalars['AnyId'];
};

export type AssumeBusinessUserIdentityInput = {
  businessUserId: Scalars['BusinessUserId'];
};

export type AssumeBusinessUserIdentityPayload = EncodedAuthenticationTokensPayload & {
  __typename: 'AssumeBusinessUserIdentityPayload';
  myself?: Maybe<Myself>;
  encodedAuthenticationTokens?: Maybe<EncodedAuthenticationTokens>;
};

export type AssumeConsumerIdentityInput = {
  userId: Scalars['UserId'];
};

export type AssumeConsumerIdentityPayload = EncodedAuthenticationTokensPayload & {
  __typename: 'AssumeConsumerIdentityPayload';
  user?: Maybe<User>;
  myself?: Maybe<Myself>;
  encodedAuthenticationTokens?: Maybe<EncodedAuthenticationTokens>;
};

export type AssumeOperatorIdentityInput = {
  operatorId: Scalars['OperatorId'];
};

export type AssumeOperatorIdentityPayload = EncodedAuthenticationTokensPayload & {
  __typename: 'AssumeOperatorIdentityPayload';
  operator?: Maybe<Operator>;
  myself?: Maybe<Myself>;
  encodedAuthenticationTokens?: Maybe<EncodedAuthenticationTokens>;
};

export type AssumePartnerUserIdentityInput = {
  partnerUserId: Scalars['PartnerUserId'];
};

export type AssumePartnerUserIdentityPayload = EncodedAuthenticationTokensPayload & {
  __typename: 'AssumePartnerUserIdentityPayload';
  myself?: Maybe<Myself>;
  encodedAuthenticationTokens?: Maybe<EncodedAuthenticationTokens>;
};

export type AttentionNeededLeadChanged = {
  __typename: 'AttentionNeededLeadChanged';
  lead: Lead;
  count: Scalars['Int'];
  type: AttentionNeededLeadChangeType;
};

export enum AttentionNeededLeadChangeType {
  ADD = 'ADD',
  REMOVE = 'REMOVE',
  UPDATE = 'UPDATE'
}

export type AttentionNeededLeadCountChanged = {
  __typename: 'AttentionNeededLeadCountChanged';
  count: Scalars['Int'];
};

export type Attribute = {
  __typename: 'Attribute';
  schema: AttributeSchemaRevision;
  values: Array<AttributeValue>;
  formatted?: Maybe<FormattedAttribute>;
};

export type AttributedHtmlTextViewModel = {
  __typename: 'AttributedHtmlTextViewModel';
  /**
   * This text can be HTML so the client shouldn't escape it (will be pre-sanitized by the server)
   * Text can have placeholders in the form of <%Key%>, where "Key" is present in attributes key
   * property.
   */
  text: Scalars['String'];
  attributes?: Maybe<Array<AttributedHtmlTextViewModelAttribute>>;
};

export type AttributedHtmlTextViewModelAttribute = {
  __typename: 'AttributedHtmlTextViewModelAttribute';
  key: Scalars['String'];
  type: AttributedHtmlTextViewModelAttributeType;
  image?: Maybe<ImageViewModel>;
};

export enum AttributedHtmlTextViewModelAttributeType {
  /** Denotes this attribute is an image view model */
  IMAGE = 'IMAGE'
}

export type AttributeEnumEntry = {
  __typename: 'AttributeEnumEntry';
  name: Scalars['String'];
  displayName: Scalars['String'];
  subDisplayName?: Maybe<Scalars['String']>;
  category?: Maybe<Category>;
  proCon: Scalars['Boolean'];
  proConDisplayName?: Maybe<Scalars['String']>;
  deprecated?: Maybe<AttributeEnumEntryDeprecated>;
  draft: Scalars['Boolean'];
};

export type AttributeEnumEntryDeprecated = {
  __typename: 'AttributeEnumEntryDeprecated';
  by: AttributeSchemaAuthor;
  at: Scalars['Date'];
  reasonMessage?: Maybe<Scalars['String']>;
};

export type AttributeEnumEntryDoesNotExistExpertCuratedItemProsAndConsEditError = ErrorMessage & {
  __typename: 'AttributeEnumEntryDoesNotExistExpertCuratedItemProsAndConsEditError';
  errorMessage: Scalars['String'];
  proCon: IndividualSellableAttributeProCon;
};

/** AttributeFunction is used to assign and classify an Attribute with a special purpose */
export enum AttributeFunction {
  /**
   * Primary Attributes define the importance of the Attribute for identifying a product or a Service
   * This can manifest itself as fundamental User intent about a specific product or service or can be associated with a
   * Sellable specification.  Someone looking for a road bike or Golf Wedges or Charter in Miami.
   * 
   * A Path should be restricted to very few Primary Functions. It should be thought of as one thing that differentiates
   * a Sellable from others
   * 
   * Some examples of Primary Attributes include:
   * 1. Bike Type
   * 2. Golf Club type
   * 3. Charter Location
   */
  PRIMARY = 'PRIMARY',
  /**
   * Secondary Attributes define other useful information that can be used to further narrow down the specificity of
   * a product or service or a Sellable Variation.
   * 
   * Someone looking for a 56 cm Carbon fiber bike or Burton Men's Snowboard
   * 
   * Some examples of secondary Attributes include:
   * 1. Bike Size
   * 2. Dominant Hand
   * 3. Ski/Snowboard Length
   * 4. Gender preferences
   * 5. Brand preferences
   */
  SECONDARY = 'SECONDARY',
  /** For attributes associated with a User, this includes personal information like phone number, email etc */
  PERSONAL_INFORMATION = 'PERSONAL_INFORMATION',
  /**
   * Defines an Attribute that is of Accessory type associated with a Parent Sellable path.
   * Some examples include:
   * 1. Bike Helmets
   * 2. Snowboard/Ski Goggles
   */
  ACCESSORY = 'ACCESSORY',
  /**
   * TAGGABLE function is used to identify the Attributes to show as taggable suggestions to the experts
   * when saving ExpertCuratedItems
   */
  TAGGABLE = 'TAGGABLE',
  /**
   * Whether the parent entity which contains this attribute should be considered for building the sitemap index.
   * For example, when building the sitemap urls for SERP pages, only the attributes of sellable that have this function
   * will be considered.
   */
  SITEMAP_INDEXABLE = 'SITEMAP_INDEXABLE',
  /** Attribute that is used for expert matching.  It can be used for attributes on lead and expert. */
  EXPERT_MATCHING = 'EXPERT_MATCHING'
}

/**
 * Exploded union of attribute values.
 * See corresponding AttributeValue* types that correspond with AttributeType to see which fields to fill out
 * depending on which enum type is used
 */
export type AttributeInput = {
  name: Scalars['String'];
  type: AttributeType;
  decimal?: Maybe<Scalars['BigDecimal']>;
  decimals?: Maybe<Array<Scalars['BigDecimal']>>;
  integer?: Maybe<Scalars['Long']>;
  integers?: Maybe<Array<Scalars['Long']>>;
  minInteger?: Maybe<Scalars['Long']>;
  maxInteger?: Maybe<Scalars['Long']>;
  minDecimal?: Maybe<Scalars['BigDecimal']>;
  maxDecimal?: Maybe<Scalars['BigDecimal']>;
  text?: Maybe<Scalars['String']>;
  texts?: Maybe<Array<Scalars['String']>>;
  enumerationValue?: Maybe<Scalars['String']>;
  enumerationValues?: Maybe<Array<Scalars['String']>>;
  idValue?: Maybe<Scalars['AnyId']>;
  idValues?: Maybe<Array<Scalars['AnyId']>>;
};

export type AttributeName = {
  __typename: 'AttributeName';
  name: Scalars['String'];
};

export type AttributeSchemaApprovalRequestEntity = ApprovalRequestEntity & {
  __typename: 'AttributeSchemaApprovalRequestEntity';
  id: Scalars['AnyId'];
  entityType: ApprovalRequestEntityType;
  entityTypeDisplayName: Scalars['String'];
  displayName: Scalars['String'];
  attributeSchemaRevision: AttributeSchemaRevision;
};

export type AttributeSchemaAuthor = Operator | SystemUser | ImportedIdentity;


export type AttributeSchemaMetadata = {
  type: AttributeSchemaMetadataType;
};

export type AttributeSchemaMetadataInput = {
  googleShoppingFeed?: Maybe<GoogleShoppingFeedAttributeSchemaMetadataInput>;
  hidden?: Maybe<HiddenAttributeSchemaMetadataInput>;
  searchFacetNameAlias?: Maybe<SearchFacetNameAliasAttributeSchemaMetadataInput>;
  searchFacetCappedNumeric?: Maybe<SearchFacetCappedNumericAttributeSchemaMetadataInput>;
  searchFacetDecimalScale?: Maybe<SearchFacetDecimalScaleAttributeSchemaMetadataInput>;
  searchFacetFixedIntegerBucket?: Maybe<SearchFacetFixedIntegerBucketAttributeSchemaMetadataInput>;
  searchFacetHistogramBucket?: Maybe<SearchFacetHistogramBucketAttributeSchemaMetadataInput>;
  expertNote?: Maybe<ExpertNoteAttributeSchemaMetadataInput>;
  searchFilterField?: Maybe<SearchFilterFieldAttributeSchemaMetadataInput>;
  proCon?: Maybe<ProConAttributeSchemaMetadataInput>;
};

export enum AttributeSchemaMetadataType {
  GOOGLE_SHOPPING_FEED = 'GOOGLE_SHOPPING_FEED',
  HIDDEN = 'HIDDEN',
  SEARCH_FACET_NAME_ALIAS = 'SEARCH_FACET_NAME_ALIAS',
  SEARCH_FACET_CAPPED_NUMERIC = 'SEARCH_FACET_CAPPED_NUMERIC',
  SEARCH_FACET_DECIMAL_SCALE = 'SEARCH_FACET_DECIMAL_SCALE',
  SEARCH_FACET_FIXED_INTEGER_BUCKET = 'SEARCH_FACET_FIXED_INTEGER_BUCKET',
  SEARCH_FACET_HISTOGRAM_BUCKET = 'SEARCH_FACET_HISTOGRAM_BUCKET',
  MISSING_ATTRIBUTE = 'MISSING_ATTRIBUTE',
  EXPERT_NOTE = 'EXPERT_NOTE',
  SEARCH_FILTER_FIELD = 'SEARCH_FILTER_FIELD',
  PRO_CON = 'PRO_CON'
}

export type AttributeSchemaRevision = {
  __typename: 'AttributeSchemaRevision';
  id: Scalars['AttributeSchemaRevisionId'];
  historyId: Scalars['AttributeSchemaId'];
  name: Scalars['String'];
  displayName: Scalars['String'];
  description?: Maybe<Scalars['String']>;
  type: AttributeType;
  createdBy: AttributeSchemaAuthor;
  createdAt: Scalars['Date'];
  validators: Array<AttributeValidatorReference>;
  metadatas: Array<AttributeSchemaMetadata>;
  /** Only valid for enumeration attribute types */
  enumEntries: Array<AttributeEnumEntry>;
  attributeFunctions: Array<AttributeFunction>;
  attributeSearchFunctions: Array<AttributeSearchFunction>;
  categories: Array<Category>;
  state: AttributeSchemaRevisionState;
  deprecated?: Maybe<AttributeSchemaRevisionDeprecated>;
  published?: Maybe<AttributeSchemaRevisionPublished>;
  replacedAt?: Maybe<Scalars['Date']>;
  revisionNumber: Scalars['Int'];
  revisionHistory: Array<AttributeSchemaRevision>;
  /** Previous item this item is replacing (if state is draft) / replaced (if state is not draft) */
  superseded?: Maybe<AttributeSchemaRevision>;
  /** The revision replacing this revision; may be in draft state */
  replacedBy?: Maybe<AttributeSchemaRevision>;
  /**
   * Custom freemarker template used to render attribute display values. If omitted, a reasonable default for the attribute
   * type will be used.
   */
  displayTemplate?: Maybe<Scalars['String']>;
  approvalRequest?: Maybe<ApprovalRequest>;
};

export type AttributeSchemaRevisionDeprecated = {
  __typename: 'AttributeSchemaRevisionDeprecated';
  by: AttributeSchemaAuthor;
  at: Scalars['Date'];
  replacedBy?: Maybe<AttributeSchemaRevision>;
  reasonMessage?: Maybe<Scalars['String']>;
};


export type AttributeSchemaRevisionOrAttributeName = AttributeSchemaRevision | AttributeName;

export type AttributeSchemaRevisionPayload = {
  hasError: Scalars['Boolean'];
  errorMessage?: Maybe<Scalars['String']>;
  attributeSchemaRevision?: Maybe<AttributeSchemaRevision>;
};

export type AttributeSchemaRevisionPublished = {
  __typename: 'AttributeSchemaRevisionPublished';
  by: AttributeSchemaAuthor;
  at: Scalars['Date'];
};

export enum AttributeSchemaRevisionQueryDraftFilter {
  /** Show all drafts and non drafts */
  INCLUDE = 'INCLUDE',
  /** Show drafts that are newly created (not from replacing an existing attribute schema revision) and non drafts */
  INCLUDE_CREATED_DRAFT = 'INCLUDE_CREATED_DRAFT',
  /** Only show drafts (and no non drafts) */
  ONLY = 'ONLY',
  /** Show no drafts; only non drafts */
  NONE = 'NONE'
}

export type AttributeSchemaRevisionQueryInput = {
  categoryIds?: Maybe<Array<Scalars['CategoryId']>>;
  keywords?: Maybe<Scalars['String']>;
  includeChildCategories?: Maybe<Scalars['Boolean']>;
  includeParentCategories?: Maybe<Scalars['Boolean']>;
  draftFilter?: Maybe<AttributeSchemaRevisionQueryDraftFilter>;
  attributeTypes?: Maybe<Array<AttributeType>>;
};

export enum AttributeSchemaRevisionSort {
  NAME = 'NAME',
  CREATED_AT = 'CREATED_AT',
  KEYWORD_RELEVANCE = 'KEYWORD_RELEVANCE'
}

export type AttributeSchemaRevisionsPagination = {
  __typename: 'AttributeSchemaRevisionsPagination';
  attributeSchemaRevisions: Array<AttributeSchemaRevision>;
  count: Scalars['Long'];
};

export enum AttributeSchemaRevisionState {
  DRAFT = 'DRAFT',
  IN_REVIEW = 'IN_REVIEW',
  PUBLISHED = 'PUBLISHED',
  REPLACED = 'REPLACED'
}

export type AttributeSchemaValidator = {
  __typename: 'AttributeSchemaValidator';
  validatorType: AttributeValidatorType;
  /** If null, that means this validator applies to all attribute types */
  attributeType?: Maybe<AttributeType>;
};

/**
 * AttributeSearchFunction is used to assist the Search system to identify whether a particular Attribute
 * is relevant for the Search(ing) of the Parent entity to which it belongs and how it should be treated for indexing
 * and other search operations.
 */
export enum AttributeSearchFunction {
  /** Marks an Attribute to be indexed as a Facet */
  FACET = 'FACET',
  /**
   * By default the AttributeType is used to structure the facets into their types and when the facet results
   * are parsed they are mapped based on the type specific aggregations.
   * This results in the bucketed aggregation for keyword/string types and stats aggregation for the numeric types
   * that gives a range of values instead of buckets.
   * In some cases, we might want to override the behavior of these types, for example if you we want to see the
   * numeric values as bucket values instead of range.
   * 
   * Use this type to perform such transformation during indexing or search queries.
   * The values will be automatically converted to their stringified value both during indexing and query.
   */
  OVERRIDE_FACET_TYPE_AS_KEYWORD = 'OVERRIDE_FACET_TYPE_AS_KEYWORD',
  /**
   * When a RawAttribute is linked to this specific attribute's AttributeSchemaRevision, the raw attribute value will
   * be used as a keyword facet type.
   * 
   * This is useful for when the standardized {@link Attribute} is a number, but the raw attribute contains more context
   * that is lost. For example, snowboard sizes have multiple variants at the same size, e.g.: "159W" for "wide".
   * 
   * If there is no matching raw attribute, this attribute will not be indexed.
   */
  OVERRIDE_FACET_RAW_ATTRIBUTE_AS_KEYWORD = 'OVERRIDE_FACET_RAW_ATTRIBUTE_AS_KEYWORD',
  /**
   * Used to Order display facet terms by their values in ascending order
   * Does not apply to range attributes
   */
  ORDER_FACET_TERMS_BY_LO_HI = 'ORDER_FACET_TERMS_BY_LO_HI',
  /**
   * Similar to ORDER_FACET_TERMS_BY_LO_HI, except that the keyword will be sorted numerically first (extracting
   * any numeric portion out of the keyword), and then alphabetically.
   */
  ORDER_FACET_TERMS_BY_LO_HI_AS_NUMERIC = 'ORDER_FACET_TERMS_BY_LO_HI_AS_NUMERIC',
  /**
   * Used to Order display facet terms by their values in descending order.
   * Does not apply to range attributes
   */
  ORDER_FACET_TERMS_BY_HI_LO = 'ORDER_FACET_TERMS_BY_HI_LO',
  /**
   * Orders display facet terms by the order they're defined in the attribute enum definition.
   * Only applies to enum attributes.
   */
  ORDER_FACET_TERMS_BY_ENUM_DEFINITION_ORDER = 'ORDER_FACET_TERMS_BY_ENUM_DEFINITION_ORDER'
}

/**
 * There is a 1:1 correlation between AttributeType and a GraphQL type.
 * The corresponding GraphQL type declaration name is ("AttributeValue" + pascalCaseOf(AttributeType))
 */
export enum AttributeType {
  INTEGER = 'INTEGER',
  INTEGER_RANGE = 'INTEGER_RANGE',
  DECIMAL = 'DECIMAL',
  DECIMAL_RANGE = 'DECIMAL_RANGE',
  TEXT = 'TEXT',
  ENUMERATION = 'ENUMERATION',
  LOCAL_DATE = 'LOCAL_DATE',
  LOCAL_DATE_RANGE = 'LOCAL_DATE_RANGE',
  LOCAL_TIME = 'LOCAL_TIME',
  LOCAL_TIME_RANGE = 'LOCAL_TIME_RANGE',
  LOCAL_DATE_TIME = 'LOCAL_DATE_TIME',
  LOCAL_DATE_TIME_RANGE = 'LOCAL_DATE_TIME_RANGE',
  ZONE_ID = 'ZONE_ID',
  ID = 'ID'
}

export type AttributeValidatorReference = {
  id: Scalars['AttributeValidatorReferenceId'];
  type: AttributeValidatorType;
};


export type AttributeValidatorReferenceInput = {
  characterCount?: Maybe<CharacterCountAttributeValidatorReferenceInput>;
  contactAvailable?: Maybe<ContactAvailableAttributeValidatorReferenceInput>;
  idEntityType?: Maybe<IdEntityTypeAttributeValidatorReferenceInput>;
  inRangeDecimal?: Maybe<InRangeDecimalAttributeValidatorReferenceInput>;
  inRangeInteger?: Maybe<InRangeIntegerAttributeValidatorReferenceInput>;
  oAuthTokenNotMapped?: Maybe<OAuthTokenNotMappedAttributeValidatorReferenceInput>;
  regex?: Maybe<RegexAttributeValidatorReferenceInput>;
  smsCapablePhoneNumber?: Maybe<SmsCapablePhoneNumberAttributeValidatorReferenceInput>;
  validEmailAddress?: Maybe<ValidEmailAddressAttributeValidatorReferenceInput>;
};

export enum AttributeValidatorType {
  CHARACTER_COUNT = 'CHARACTER_COUNT',
  IN_RANGE_INTEGER = 'IN_RANGE_INTEGER',
  IN_RANGE_DECIMAL = 'IN_RANGE_DECIMAL',
  REGEX = 'REGEX',
  /**
   * Validate either if the given attribute which represents a contact (phone number, email, etc) is available, or
   * belongs to the logged in user.
   * Only validates text attributes
   */
  CONTACT_AVAILABLE = 'CONTACT_AVAILABLE',
  /** Ensure the phone number is SMS capable. */
  SMS_CAPABLE_PHONE_NUMBER = 'SMS_CAPABLE_PHONE_NUMBER',
  /** Ensure the email address is valid */
  VALID_EMAIL_ADDRESS = 'VALID_EMAIL_ADDRESS',
  /**
   * Ensure the OAuth token is not mapped to a user, or mapped to the logged in user.
   * Only validates text attributes
   */
  OAUTH_TOKEN_NOT_MAPPED = 'OAUTH_TOKEN_NOT_MAPPED',
  /**
   * Ensure the Id is of a certain type.
   * Only validates id attributes
   */
  ID_ENTITY_TYPE = 'ID_ENTITY_TYPE'
}

export type AttributeValue = AttributeValueInteger | AttributeValueIntegerRange | AttributeValueDecimal | AttributeValueDecimalRange | AttributeValueText | AttributeValueEnumeration | AttributeValueDate | AttributeValueDateRange | AttributeValueTime | AttributeValueTimeRange | AttributeValueDateTime | AttributeValueDateTimeRange | AttributeValueZoneId | AttributeValueId;

export type AttributeValueCommandInput = {
  type: PathAttributeValueType;
  staticAttributes?: Maybe<Array<AttributeInput>>;
};

export type AttributeValueDate = {
  __typename: 'AttributeValueDate';
  date: Scalars['Date'];
};

export type AttributeValueDateRange = {
  __typename: 'AttributeValueDateRange';
  minDate?: Maybe<Scalars['Date']>;
  maxDate?: Maybe<Scalars['Date']>;
};

export type AttributeValueDateTime = {
  __typename: 'AttributeValueDateTime';
  dateTime: Scalars['Date'];
};

export type AttributeValueDateTimeRange = {
  __typename: 'AttributeValueDateTimeRange';
  minDateTime?: Maybe<Scalars['Date']>;
  maxDateTime?: Maybe<Scalars['Date']>;
};

export type AttributeValueDecimal = {
  __typename: 'AttributeValueDecimal';
  decimal: Scalars['BigDecimal'];
};

export type AttributeValueDecimalRange = {
  __typename: 'AttributeValueDecimalRange';
  minDecimal?: Maybe<Scalars['BigDecimal']>;
  maxDecimal?: Maybe<Scalars['BigDecimal']>;
};

export type AttributeValueEnumeration = {
  __typename: 'AttributeValueEnumeration';
  enumerationValue: Scalars['String'];
  enumerationValueDescription: Scalars['String'];
};

export type AttributeValueId = {
  __typename: 'AttributeValueId';
  id?: Maybe<Scalars['AnyId']>;
};

export type AttributeValueInteger = {
  __typename: 'AttributeValueInteger';
  integer: Scalars['Long'];
};

export type AttributeValueIntegerRange = {
  __typename: 'AttributeValueIntegerRange';
  minInteger?: Maybe<Scalars['Long']>;
  maxInteger?: Maybe<Scalars['Long']>;
};

export type AttributeValueText = {
  __typename: 'AttributeValueText';
  text: Scalars['String'];
};

export type AttributeValueTime = {
  __typename: 'AttributeValueTime';
  time: Scalars['Time'];
};

export type AttributeValueTimeRange = {
  __typename: 'AttributeValueTimeRange';
  minTime?: Maybe<Scalars['Time']>;
  maxTime?: Maybe<Scalars['Time']>;
};

export type AttributeValueZoneId = {
  __typename: 'AttributeValueZoneId';
  zoneId?: Maybe<Scalars['String']>;
};

export type AuthenticateByExternalOAuthTokenInput = {
  type: OAuthType;
  token: Scalars['String'];
};

export type AuthenticateByExternalOAuthTokenPayload = EncodedAuthenticationTokensPayload & {
  __typename: 'AuthenticateByExternalOAuthTokenPayload';
  result: AuthenticationResult;
  user?: Maybe<User>;
  message?: Maybe<Scalars['String']>;
  encodedAuthenticationTokens?: Maybe<EncodedAuthenticationTokens>;
};

export type AuthenticationInput = {
  handle?: Maybe<Scalars['String']>;
  handleType?: Maybe<HandleType>;
  handleId?: Maybe<Scalars['AnyId']>;
  challenge: Scalars['String'];
};

export enum AuthenticationMethod {
  NO_PASSWORD = 'NO_PASSWORD',
  PASSWORD = 'PASSWORD',
  CHALLENGE = 'CHALLENGE',
  LOGIN_TOKEN = 'LOGIN_TOKEN',
  EXTERNAL_OAUTH = 'EXTERNAL_OAUTH'
}

export enum AuthenticationResult {
  SUCCESS = 'SUCCESS',
  FAILURE = 'FAILURE',
  CHALLENGE = 'CHALLENGE'
}

export type AuthenticationResultPayload = EncodedAuthenticationTokensPayload & {
  __typename: 'AuthenticationResultPayload';
  result: AuthenticationResult;
  user?: Maybe<User>;
  message?: Maybe<Scalars['String']>;
  encodedAuthenticationTokens?: Maybe<EncodedAuthenticationTokens>;
};

export type AuthenticationSessionState = {
  __typename: 'AuthenticationSessionState';
  handle?: Maybe<Scalars['String']>;
  handleId?: Maybe<Scalars['AnyId']>;
  loginChallengeType?: Maybe<ChallengeType>;
  resetPasswordChallengeVerified: Scalars['Boolean'];
};

export type AvailabilityByFulfillmentCenter = {
  __typename: 'AvailabilityByFulfillmentCenter';
  fulfillmentCenter: FulfillmentCenter;
  /** Items available to order on our site from this Fulfillment Center */
  count: Scalars['Int'];
  /** flag to incidicate explicitly marked available for pre-order inventory item */
  preOrderPermitted: Scalars['Boolean'];
  /**
   * Indicates whether this item is available for pre-order
   * this field is derived from the estimated availability date and whether this was previously marked as pre-order
   */
  availableForPreOrder: Scalars['Boolean'];
  /** Estimate is the value configured by the admin */
  estimatedAvailableAt?: Maybe<Scalars['Date']>;
  /** Actual value is derived based on real availability of inventory count */
  actualAvailableAt?: Maybe<Scalars['Date']>;
};

export type AwayAutoReply = {
  __typename: 'AwayAutoReply';
  id: Scalars['AwayAutoReplyId'];
  effectiveFrom: Scalars['Date'];
  effectiveUntil: Scalars['Date'];
  status: AwayAutoReplyStatus;
  message: Scalars['String'];
};


export enum AwayAutoReplyStatus {
  PENDING = 'PENDING',
  ACTIVE = 'ACTIVE',
  EXPIRED = 'EXPIRED'
}

export type BackgroundFacetImageMetadata = FacetImageMetadata & {
  __typename: 'BackgroundFacetImageMetadata';
  type: FacetImageType;
  imageUrl: Scalars['String'];
};

export type BankCheckPaymentEntity = PaymentEntity & {
  __typename: 'BankCheckPaymentEntity';
  paymentMethod: PaymentMethod;
  bankName: Scalars['String'];
  recipientName: Scalars['String'];
  accountNumber: Scalars['String'];
  amount: MonetaryAmount;
};

export type BasicPathFlowPageMetadata = PathFlowPageMetadata & {
  __typename: 'BasicPathFlowPageMetadata';
  type: PathFlowPageMetadataType;
};

export type BatchUpdateSellableInput = {
  id: Array<Scalars['SellableId']>;
  /** strike out price of this sellable */
  originalPrice?: Maybe<MonetaryAmountInput>;
  /** default price we sell to consumer */
  salePrice?: Maybe<MonetaryAmountInput>;
  /** best offer price we sell to consumer which is not publically shown */
  bestOfferPrice?: Maybe<MonetaryAmountInput>;
  /** title */
  title?: Maybe<Scalars['String']>;
  /** description in markdown format */
  descriptionMarkdown?: Maybe<Scalars['String']>;
  /** images */
  imageIds?: Maybe<Array<Scalars['MediaId']>>;
  /** external videos */
  externalVideoUrls?: Maybe<Array<Scalars['String']>>;
  /** brochure */
  brochureUrl?: Maybe<Scalars['String']>;
  /** update slug to the title, may update even if the title is not updated */
  updateSlug?: Maybe<Scalars['Boolean']>;
  /** if the update should be applied to all other variants in the group */
  allVariants?: Maybe<Scalars['Boolean']>;
};


export type BigDecimalRange = {
  __typename: 'BigDecimalRange';
  from?: Maybe<Scalars['BigDecimal']>;
  to?: Maybe<Scalars['BigDecimal']>;
};

export type BigDecimalRangeInput = {
  from?: Maybe<Scalars['BigDecimal']>;
  to?: Maybe<Scalars['BigDecimal']>;
};

export type Booking = {
  __typename: 'Booking';
  id: Scalars['BookingId'];
  createdAt: Scalars['Date'];
  order: Order;
  state: BookingState;
};

export type BookingEdge = {
  __typename: 'BookingEdge';
  node: Booking;
  cursor: Scalars['String'];
};


export type BookingsConnection = {
  __typename: 'BookingsConnection';
  facets: Array<DisplayFacet>;
  edges: Array<BookingEdge>;
  pageInfo: PageInfo;
  count: Scalars['Int'];
};

export type BookingSearchQueryInput = {
  orderIds?: Maybe<Scalars['OrderId']>;
  bookingState?: Maybe<BookingState>;
  facets?: Maybe<Array<FacetSelection>>;
  facetedSearch: Scalars['Boolean'];
};

export enum BookingSearchSort {
  DEFAULT = 'DEFAULT',
  ORDER_CREATE_AT = 'ORDER_CREATE_AT'
}

export enum BookingState {
  TRIP_COMPLETED = 'TRIP_COMPLETED',
  TRIP_UPCOMING = 'TRIP_UPCOMING',
  VERIFYING_PAYMENT = 'VERIFYING_PAYMENT'
}

export type BranchContainerPathNodeConfig = PathNodeConfig & {
  __typename: 'BranchContainerPathNodeConfig';
  configType: PathNodeConfigType;
  rules: Array<BranchRulePathNodeConfig>;
};

export type BranchContainerPathNodeConfigAddRuleEditorCommandInput = {
  _?: Maybe<Scalars['Boolean']>;
};

export type BranchContainerPathNodeConfigCreateEditorCommandInput = {
  _?: Maybe<Scalars['Boolean']>;
};

export type BranchContainerPathNodeConfigRemoveRulesEditorCommandInput = {
  ruleIds: Array<Scalars['PathBranchRuleId']>;
};

export type BranchContainerPathNodeConfigSortRulesEditorCommandInput = {
  ruleIds: Array<Scalars['PathBranchRuleId']>;
};

export type BranchContainerPathNodeConfigUpdateRuleEditorCommandInput = {
  ruleId: Scalars['PathBranchRuleId'];
  condition: PathConditionEditorCommandInput;
};

export type BranchFallbackRulePathNodeConfig = PathNodeConfig & {
  __typename: 'BranchFallbackRulePathNodeConfig';
  configType: PathNodeConfigType;
};

export type BranchRulePathEditorValidationErrorTarget = PathEditorValidationErrorTarget & {
  __typename: 'BranchRulePathEditorValidationErrorTarget';
  id: Scalars['String'];
  targetType: PathEditorValidationErrorTargetType;
  branchRuleId: Scalars['PathBranchRuleId'];
};

export type BranchRulePathNodeConfig = PathNodeConfig & {
  __typename: 'BranchRulePathNodeConfig';
  configType: PathNodeConfigType;
  ruleId: Scalars['PathBranchRuleId'];
  condition?: Maybe<PathCondition>;
};

export type BranchRulePathNodeConfigUpdateEditorCommandInput = {
  condition: PathConditionEditorCommandInput;
};

export type Brand = {
  __typename: 'Brand';
  id: Scalars['BrandId'];
  name: Scalars['String'];
  displayName: Scalars['String'];
  active: Scalars['Boolean'];
  slug: Scalars['String'];
  logo?: Maybe<MediaFile>;
};

export type BrandConnection = {
  __typename: 'BrandConnection';
  edges: Array<BrandEdge>;
  pageInfo: PageInfo;
};

export type BrandEdge = {
  __typename: 'BrandEdge';
  node: Brand;
  cursor: Scalars['String'];
};


export type BrandStatsAggregateExpertReport = {
  __typename: 'BrandStatsAggregateExpertReport';
  category: Category;
  brand: Brand;
  recommendedThisWeek: Scalars['Int'];
  recommendedLastWeek: Scalars['Int'];
  rankLast7Days: Scalars['Int'];
  rankLastWeek7Days: Scalars['Int'];
};

export type BrandTypeaheadHit = {
  __typename: 'BrandTypeaheadHit';
  id: Scalars['BrandId'];
  /** The matched text string in the indexed keywords */
  text: Scalars['String'];
  /** The brand name */
  name: Scalars['String'];
  /** The brand display name */
  displayName: Scalars['String'];
  brand: Brand;
};

export type BrandTypeaheadPayload = {
  __typename: 'BrandTypeaheadPayload';
  hits: Array<BrandTypeaheadHit>;
};

export type BrandTypeaheadQuery = {
  prefixSearch: Scalars['String'];
};

export type BrandUploadTaskPayload = {
  __typename: 'BrandUploadTaskPayload';
  numRowsProcessed: Scalars['Int'];
  numRowsIgnored: Scalars['Int'];
  numBrandsCreated: Scalars['Int'];
  numBrandsUpdated: Scalars['Int'];
  errorRows: Array<Scalars['Int']>;
  googleSpreadsheetId: Scalars['String'];
};

export type BridgeExpertApplicantPhoneCallInput = {
  fromMessagingUserId: Scalars['AnyId'];
  applicationId: Scalars['ExpertApplicationId'];
};

export type BridgeLeadPhoneCallInput = {
  fromMessagingUserId: Scalars['AnyId'];
  leadId: Scalars['LeadId'];
};

export type BridgePhoneCallInput = {
  conversationId: Scalars['ConversationId'];
  fromMessagingUserId: Scalars['AnyId'];
  toMessagingUserId: Scalars['AnyId'];
};

export type BridgePhoneCallPayload = {
  __typename: 'BridgePhoneCallPayload';
  success: Scalars['Boolean'];
};

export type BroadcastOffer = {
  __typename: 'BroadcastOffer';
  id: Scalars['BroadcastOfferId'];
  conversation?: Maybe<Conversation>;
  type?: Maybe<BroadcastOfferType>;
  title: Scalars['String'];
  description?: Maybe<Scalars['String']>;
  state: OfferState;
  createdBy: BusinessUser;
  createdFor: User;
  expiresAt?: Maybe<Scalars['Date']>;
  price: Money;
  originalPrice?: Maybe<Money>;
  originalPriceSource?: Maybe<Scalars['String']>;
  tax?: Maybe<Money>;
  freeAddOns: Array<OfferAddOn>;
  images: Array<MediaFile>;
  videos: Array<MediaFile>;
  publicOffer: Scalars['Boolean'];
  publicOfferUrl?: Maybe<Scalars['String']>;
  terms?: Maybe<OfferTerms>;
  brand?: Maybe<Brand>;
  comments?: Maybe<Scalars['String']>;
  order?: Maybe<Order>;
  totalCost: Money;
  shippingCost?: Maybe<Money>;
  discount?: Maybe<Scalars['Float']>;
  deal?: Maybe<Deal>;
  sellable?: Maybe<Sellable>;
  lastViewedAt?: Maybe<Scalars['Date']>;
  userDocuments: Array<MediaFile>;
  consumerUrl: Scalars['String'];
  canAddToCart: Scalars['Boolean'];
};


export enum BroadcastOfferType {
  PRODUCT = 'PRODUCT',
  SERVICE = 'SERVICE'
}

export type BsonObject = {
  __typename: 'BsonObject';
  version: Scalars['Int'];
  data: Scalars['String'];
};

/** Buckets of values and counts that are individually selectable */
export type BucketedDisplayFacet = DisplayFacet & {
  __typename: 'BucketedDisplayFacet';
  /** Name to display in the UI for this facet */
  displayName: Scalars['String'];
  /** Internal name that should be provided back to FacetSelection.name when selecting facet values */
  name: Scalars['String'];
  /**
   * Alias for this facet if one exist. Aliases provide a semi user friendly name that can be used
   * in the urls for example.
   */
  alias?: Maybe<Scalars['String']>;
  /** Facet buckets */
  buckets: Array<IndividualBucketedDisplayFacet>;
  typeaheadMetadata: FacetTypeaheadMetadata;
};

/** Display facet for buckets with range values */
export type BucketedRangeDisplayFacet = DisplayFacet & {
  __typename: 'BucketedRangeDisplayFacet';
  /** Name to display in the UI for this facet */
  displayName: Scalars['String'];
  /** Internal name that should be provided back to FacetSelection.name when selecting facet values */
  name: Scalars['String'];
  /**
   * Alias for this facet if one exist. Aliases provide a semi user friendly name that can be used
   * in the urls for example.
   */
  alias?: Maybe<Scalars['String']>;
  /** Facet buckets */
  buckets: Array<IndividualBucketedRangeDisplayFacet>;
};

export type BulkAssignTicketsInput = {
  ticketIds: Array<Scalars['TicketId']>;
  assignToId: Scalars['AnyId'];
};

export type BulkRemoveSellableAttributeInput = {
  requests: Array<RemoveSellableAttributeInput>;
};

export type BulkRemoveSellableAttributePayload = {
  __typename: 'BulkRemoveSellableAttributePayload';
  sellables: Array<Sellable>;
  error?: Maybe<BulkSellableRemoveAttributeError>;
};

export type BulkRemoveSellableRawAttributeInput = {
  requests: Array<RemoveSellableRawAttributeInput>;
};

export type BulkRemoveSellableRawAttributePayload = {
  __typename: 'BulkRemoveSellableRawAttributePayload';
  sellables: Array<Sellable>;
  error?: Maybe<BulkSellableRemoveRawAttributeError>;
};

export type BulkResolveTicketsInput = {
  ticketIds: Array<Scalars['TicketId']>;
};

export type BulkSellableRemoveAttributeError = NotFullyAppliedSellableEditError | VariationDimensionSellableRemoveAttributeError;

export type BulkSellableRemoveRawAttributeError = NotFullyAppliedSellableEditError | VariationDimensionSellableRemoveAttributeError;

export type BulkSetSellableAttributeError = NotFullyAppliedSellableEditError;

export type BulkSetSellableAttributeInput = {
  requests: Array<SetSellableAttributeInput>;
};

export type BulkSetSellableAttributePayload = {
  __typename: 'BulkSetSellableAttributePayload';
  sellables: Array<Sellable>;
  error?: Maybe<BulkSetSellableAttributeError>;
};

export type BulkSetSellableRawAttributeError = NotFullyAppliedSellableEditError;

export type BulkSetSellableRawAttributeInput = {
  requests: Array<SetSellableRawAttributeInput>;
};

export type BulkSetSellableRawAttributePayload = {
  __typename: 'BulkSetSellableRawAttributePayload';
  sellables: Array<Sellable>;
  error?: Maybe<BulkSetSellableRawAttributeError>;
};

export type BulkSetTicketDueDateInput = {
  ticketIds: Array<Scalars['TicketId']>;
  dueDate: Scalars['Date'];
};

export type BulkUpdatePayoutPayload = {
  __typename: 'BulkUpdatePayoutPayload';
  results: Array<UpdatePayoutPayload>;
};

export type BulkUpdateSellableInput = {
  batches: Array<BatchUpdateSellableInput>;
};

export type BulkUpdateSellablePayload = {
  __typename: 'BulkUpdateSellablePayload';
  sellables: Array<Sellable>;
  errorMessage?: Maybe<Scalars['String']>;
  hasError: Scalars['Boolean'];
};

export type BulkUpdateTicketsPayload = {
  __typename: 'BulkUpdateTicketsPayload';
  succeeded: Scalars['Int'];
  failed: Scalars['Int'];
  ticketsUpdated: Array<Ticket>;
};

export type BusinessAccount = {
  __typename: 'BusinessAccount';
  id: Scalars['BusinessAccountId'];
  name: Scalars['String'];
  merchant?: Maybe<Merchant>;
};


export type BusinessUser = {
  __typename: 'BusinessUser';
  /**
   * This needs to AnyId instead of BusinessUserId since it is used with other identity objects such as User
   * in a few union type.  Graphql will complain if the same field return different types
   */
  id: Scalars['AnyId'];
  facetValue: Scalars['String'];
  firstName: Scalars['String'];
  lastName: Scalars['String'];
  displayName: Scalars['String'];
  shortName: Scalars['String'];
  user: User;
  contacts: Array<Contact>;
  /** @deprecated Use messagingUser.id */
  messagingUserId: Scalars['AnyId'];
  messagingUser: MessagingUser;
  permissions: Array<Permission>;
  roles: Array<Scalars['String']>;
  isExpert: Scalars['Boolean'];
  /** If the expert has the expertApplicant role */
  isExpertApplicant: Scalars['Boolean'];
  /** If the expert is being actively onboarded. Derived from both expert state and role */
  isActiveExpertApplicant: Scalars['Boolean'];
  isArticleAuthor: Scalars['Boolean'];
  isOverloaded: Scalars['Boolean'];
  isStandbyAllowed: Scalars['Boolean'];
  expertAttributes: BusinessUserExpertAttributes;
  expertProfile?: Maybe<ExpertProfile>;
  articleAuthorProfile?: Maybe<ExpertProfile>;
  presence: PresenceStatus;
  active: Scalars['Boolean'];
  state: BusinessUserState;
  team?: Maybe<BusinessUserTeam>;
  profileUrl: Scalars['String'];
  /**
   * This might be null because not all the expert are eligible for referral. For example, pending experts don't have
   * vanity id and are not eligible for referral
   */
  referralUrl?: Maybe<Scalars['String']>;
  profileSetupUrl: Scalars['String'];
  profileShareUrl: Scalars['String'];
  consumerReviewUrl: Scalars['String'];
  assignedAddresses: Array<ChannelAddress>;
  assignedAddress?: Maybe<Scalars['String']>;
  department: Department;
  existingLeadForConsumer?: Maybe<Lead>;
  featured: Scalars['Boolean'];
  delisted: Scalars['Boolean'];
  spotlightExpert: Scalars['Boolean'];
  contactCardUrl: Scalars['String'];
  deactivated: Scalars['Boolean'];
  performance?: Maybe<ExpertPerformance>;
  timeZone: Scalars['String'];
  zoneId: Scalars['String'];
  internal: Scalars['Boolean'];
  activeOrPendingAwayAutoReply?: Maybe<AwayAutoReply>;
  expertPresence: ExpertPresence;
  experimentAttributes: Array<ExperimentSubjectAttribute>;
  location?: Maybe<UserLocation>;
  consumerExpertReviewConnection: ConsumerExpertReviewConnection;
  vanityId?: Maybe<Scalars['String']>;
  expertStats?: Maybe<ExpertStats>;
  expertApplicationReviewEnabled: Scalars['Boolean'];
  expertApplication?: Maybe<ExpertApplication>;
  performanceStatistics?: Maybe<ExpertPerformanceStatistics>;
  discountCashAccount: LedgerAccount;
  /**
   * this flag indicate if the expert can accept broadcast at this point based on
   * broadcast lead eligibility and the current shift status
   */
  canAcceptBroadcastLeads: Scalars['Boolean'];
  /** @deprecated Use newLeadEligibility */
  canAcquireNewLeads: Scalars['Boolean'];
  broadcastLeadEligibilitySetting: ExpertLeadEligibility;
  newLeadEligibilitySetting: ExpertLeadEligibility;
  activityConnection: BusinessUserActivityConnection;
  payStructure?: Maybe<PayStructure>;
  schedulingUser?: Maybe<SchedulingUser>;
  schedulingDepartment?: Maybe<SchedulingDepartment>;
  /** @deprecated use specialCareTags */
  skiTripExpert: Scalars['Boolean'];
  specialCareTags: Array<Scalars['String']>;
};


export type BusinessUserAssignedAddressArgs = {
  type: MessagingChannelType;
};


export type BusinessUserConsumerExpertReviewConnectionArgs = {
  after?: Maybe<Scalars['String']>;
  first?: Maybe<Scalars['Int']>;
  before?: Maybe<Scalars['String']>;
  last?: Maybe<Scalars['Int']>;
};


export type BusinessUserActivityConnectionArgs = {
  after?: Maybe<Scalars['String']>;
  first?: Maybe<Scalars['Int']>;
  before?: Maybe<Scalars['String']>;
  last?: Maybe<Scalars['Int']>;
};

export type BusinessUserActivity = {
  id: Scalars['BusinessUserActivityId'];
  type: BusinessUserActivityType;
  occurredAt: Scalars['Date'];
};

export type BusinessUserActivityConnection = {
  __typename: 'BusinessUserActivityConnection';
  edges: Array<BusinessUserActivityEdge>;
  pageInfo: PageInfo;
};

export type BusinessUserActivityEdge = {
  __typename: 'BusinessUserActivityEdge';
  node: BusinessUserActivity;
  cursor: Scalars['String'];
};


export enum BusinessUserActivityType {
  START_RECEIVING_LEADS = 'START_RECEIVING_LEADS',
  STOP_RECEIVING_LEADS = 'STOP_RECEIVING_LEADS',
  START_ON_CALL = 'START_ON_CALL',
  STOP_ON_CALL = 'STOP_ON_CALL',
  EXPERT_DEACTIVATED = 'EXPERT_DEACTIVATED',
  EXPERT_ACTIVATED = 'EXPERT_ACTIVATED',
  EXPERT_LEAD_GATE_ADDED = 'EXPERT_LEAD_GATE_ADDED',
  EXPERT_LEAD_GATE_REMOVED = 'EXPERT_LEAD_GATE_REMOVED'
}

export type BusinessUserExpertAttributes = {
  __typename: 'BusinessUserExpertAttributes';
  categories: Array<Category>;
  category: Category;
  specialtyCategory?: Maybe<Category>;
  acceptRequestMode: AcceptRequestMode;
  newMessageNotificationMode: ExpertNotificationMode;
  broadcastLeadNotificationMode: ExpertNotificationMode;
  assistExpert: Scalars['Boolean'];
  placeholderExpert: Scalars['Boolean'];
  /** @deprecated Use businessUser.expertPresence */
  onCallExpert: Scalars['Boolean'];
  /** @deprecated Use businessUser.expertPresence */
  acceptingNewRequests: Scalars['Boolean'];
  broadcastLeadClaimDisabled: Scalars['Boolean'];
  expertApplicationReviewEnabled: Scalars['Boolean'];
  endOfShiftSurveyTakenAt?: Maybe<Scalars['Date']>;
  standbyAllowedOverride?: Maybe<Scalars['Boolean']>;
  leadGates: Array<ExpertLeadGate>;
  newExpertLeadGate?: Maybe<ExpertLeadGate>;
};


export enum BusinessUserState {
  ACTIVE = 'ACTIVE',
  DEACTIVATING = 'DEACTIVATING',
  DEACTIVATED = 'DEACTIVATED',
  PENDING = 'PENDING'
}

export type BusinessUserTeam = {
  __typename: 'BusinessUserTeam';
  id: Scalars['BusinessUserTeamId'];
  department: Department;
  name: Scalars['String'];
  members: Array<BusinessUser>;
  leaders: Array<BusinessUser>;
  teamLeadCommissionEligible: Scalars['Boolean'];
};

export type BusinessUserTeamFilterInput = {
  departmentIds?: Maybe<Array<Scalars['DepartmentId']>>;
  nameKeyword?: Maybe<Scalars['String']>;
  namePrefix?: Maybe<Scalars['String']>;
};


export type BusinessUserTeamsPagination = {
  __typename: 'BusinessUserTeamsPagination';
  teams: Array<BusinessUserTeam>;
  count: Scalars['Int'];
};

export type CallActivity = {
  __typename: 'CallActivity';
  id: Scalars['CallActivityId'];
  fromNumber: Scalars['String'];
  toNumber: Scalars['String'];
  forwardedToNumber?: Maybe<Scalars['String']>;
  callee: CallParticipant;
  caller?: Maybe<CallParticipant>;
  calledAt: Scalars['Date'];
  durationInSeconds?: Maybe<Scalars['Int']>;
  status: CallStatus;
  type: CallType;
};

export type CallActivityConnection = {
  __typename: 'CallActivityConnection';
  edges: Array<CallActivityEdge>;
  pageInfo: PageInfo;
};

export type CallActivityEdge = {
  __typename: 'CallActivityEdge';
  node: CallActivity;
  cursor: Scalars['String'];
};

export type CallActivityFilterInput = {
  expertId: Scalars['BusinessUserId'];
  from?: Maybe<Scalars['Date']>;
  to?: Maybe<Scalars['Date']>;
};


export type CallParticipant = BusinessUser | User;

export enum CallStatus {
  QUEUED = 'QUEUED',
  INITIATED = 'INITIATED',
  RINGING = 'RINGING',
  IN_PROGRESS = 'IN_PROGRESS',
  COMPLETED = 'COMPLETED',
  BUSY = 'BUSY',
  NO_ANSWER = 'NO_ANSWER',
  CANCELLED = 'CANCELLED',
  FAILED = 'FAILED',
  OTHER = 'OTHER'
}

export enum CallType {
  EXPERT_TO_CONSUMER = 'EXPERT_TO_CONSUMER',
  CONSUMER_TO_EXPERT = 'CONSUMER_TO_EXPERT'
}

export type Campaign = {
  __typename: 'Campaign';
  id: Scalars['CampaignId'];
  memberType: CampaignAudienceMemberType;
  name: Scalars['String'];
  description?: Maybe<Scalars['String']>;
  keywords?: Maybe<Scalars['String']>;
  conditions: Array<FilterFieldCondition>;
  state: CampaignState;
  updatedAt: Scalars['Date'];
  trigger?: Maybe<Trigger>;
  totalDelivered: Scalars['Int'];
  lastDeliveryTime?: Maybe<Scalars['Date']>;
  firstDeliveryTime?: Maybe<Scalars['Date']>;
  maximumRecipients: Scalars['Int'];
  totalTargetRecipients?: Maybe<Scalars['Int']>;
  deliveryHistory: Array<CampaignDeliveryResult>;
  pendingDelivery?: Maybe<CampaignDeliveryRequest>;
  deliveryFrequency: CampaignDeliveryFrequency;
  settings?: Maybe<CampaignSettings>;
  audience?: Maybe<CampaignAudience>;
  stopDeliveryAt?: Maybe<Scalars['Date']>;
};

export type CampaignAudience = {
  __typename: 'CampaignAudience';
  id: Scalars['CampaignAudienceId'];
  memberType: CampaignAudienceMemberType;
  name: Scalars['String'];
  description?: Maybe<Scalars['String']>;
  keywords?: Maybe<Scalars['String']>;
  conditions: Array<FilterFieldCondition>;
  integrations: Array<CampaignAudienceIntegration>;
  state: CampaignAudienceState;
  tags: Array<Scalars['String']>;
  updatedAt: Scalars['Date'];
};

export enum CampaignAudienceExternalPlatform {
  FACEBOOK = 'FACEBOOK'
}

export type CampaignAudienceFacebookIntegration = CampaignAudienceIntegration & {
  __typename: 'CampaignAudienceFacebookIntegration';
  id: Scalars['CampaignAudienceIntegrationId'];
  externalPlatform: CampaignAudienceExternalPlatform;
  valueType: CampaignAudienceFacebookValueType;
  facebookId?: Maybe<Scalars['String']>;
};

export type CampaignAudienceFacebookIntegrationInput = {
  valueType: CampaignAudienceFacebookValueType;
};

export enum CampaignAudienceFacebookValueType {
  NONE = 'NONE',
  PREDICTED_LIFETIME_VALUE = 'PREDICTED_LIFETIME_VALUE',
  REVENUE = 'REVENUE'
}

export type CampaignAudienceFilter = {
  keywords?: Maybe<Scalars['String']>;
  states?: Maybe<Array<CampaignAudienceState>>;
  externalPlatforms?: Maybe<Array<CampaignAudienceExternalPlatform>>;
};


export type CampaignAudienceIntegration = {
  id: Scalars['CampaignAudienceIntegrationId'];
  externalPlatform: CampaignAudienceExternalPlatform;
};


export enum CampaignAudienceMemberType {
  LEAD = 'LEAD',
  EXPERT = 'EXPERT',
  EXPERT_APPLICANT = 'EXPERT_APPLICANT'
}

export type CampaignAudiencePagination = {
  __typename: 'CampaignAudiencePagination';
  campaignAudiences: Array<CampaignAudience>;
  count: Scalars['Long'];
};

export enum CampaignAudienceSort {
  NAME = 'NAME',
  LAST_UPDATED = 'LAST_UPDATED'
}

export enum CampaignAudienceState {
  DRAFT = 'DRAFT',
  PUBLISHED = 'PUBLISHED',
  ARCHIVED = 'ARCHIVED'
}

export enum CampaignDeliveryFrequency {
  EMAIL = 'EMAIL',
  SMS_LONG_CODE = 'SMS_LONG_CODE',
  SMS_SHORT_CODE = 'SMS_SHORT_CODE'
}

export type CampaignDeliveryRequest = {
  __typename: 'CampaignDeliveryRequest';
  batchSize: Scalars['Int'];
  scheduledAt: Scalars['Date'];
};

export type CampaignDeliveryResult = {
  __typename: 'CampaignDeliveryResult';
  totalDelivered: Scalars['Int'];
  totalErrored: Scalars['Int'];
  totalAttempted: Scalars['Int'];
  startIndex: Scalars['Int'];
  endIndex: Scalars['Int'];
  startDeliveryTime: Scalars['Date'];
  endDeliveryTime: Scalars['Date'];
};

export type CampaignFilterInput = {
  nameKeyword?: Maybe<Scalars['String']>;
  state: CampaignState;
  memberType: CampaignAudienceMemberType;
};


export enum CampaignRecipientSortOrder {
  MOST_RECENT_ACTIVITY = 'MOST_RECENT_ACTIVITY',
  RANDOM = 'RANDOM'
}

export type CampaignSettings = {
  type: CampaignAudienceMemberType;
};

export type CampaignsPagination = {
  __typename: 'CampaignsPagination';
  campaigns: Array<Campaign>;
  count: Scalars['Int'];
};

export enum CampaignState {
  DRAFT = 'DRAFT',
  PREPARING = 'PREPARING',
  PUBLISHED = 'PUBLISHED',
  DELIVERING = 'DELIVERING',
  DEACTIVATED = 'DEACTIVATED'
}

export type CampaignUnion = LeadCampaign | Campaign;

export type CancelExpertApplicationSnoozeInput = {
  applicationId: Scalars['ExpertApplicationId'];
};

export type CancellationTicket = TicketDetail & {
  __typename: 'CancellationTicket';
  type: TicketType;
  consumer: User;
  order: Order;
  reason: OrderRefundReason;
  orderLineItemIds: Array<Scalars['OrderLineItemId']>;
  orderRefund?: Maybe<OrderRefund>;
};

export type CancelLeadSnoozeInput = {
  leadId: Scalars['LeadId'];
};

export type CancelOrderRefundInput = {
  orderRefundId: Scalars['OrderRefundId'];
};

export type CancelPaymentRequestForOrderInput = {
  orderId: Scalars['OrderId'];
  /** The unique id or token on the external platform that was used for initiating the Payment Authorization process. */
  paymentProcessorPlatformSourceId: Scalars['String'];
  paymentProcessorType: PaymentProcessorType;
};

export type CancelPaymentRequestForOrderPayload = {
  __typename: 'CancelPaymentRequestForOrderPayload';
  order: Order;
  hasError: Scalars['Boolean'];
  errorMessage?: Maybe<Scalars['String']>;
};

export type CancelShiftChangeRequestInput = {
  shiftId: Scalars['ShiftId'];
};

export type CancelSubmittedOrderInput = {
  orderId: Scalars['OrderId'];
};

export type CancelSubmittedOrderPayload = {
  __typename: 'CancelSubmittedOrderPayload';
  order: Order;
  hasError: Scalars['Boolean'];
  errorMessage?: Maybe<Scalars['String']>;
};

export enum CardFieldValidationStatus {
  PASS = 'PASS',
  FAIL = 'FAIL',
  UNAVAILABLE = 'UNAVAILABLE',
  UNCHECKED = 'UNCHECKED'
}

export enum CardFundingType {
  UNKNOWN = 'UNKNOWN',
  CREDIT = 'CREDIT',
  DEBIT = 'DEBIT',
  PREPAID = 'PREPAID'
}

export enum CartSyncUseCase {
  /** Syncing to display the cart */
  CART_VIEW = 'CART_VIEW',
  /** Syncing to display during the checkout flow */
  CHECKOUT = 'CHECKOUT'
}

export type CategoriesConnection = {
  __typename: 'CategoriesConnection';
  edges: Array<CategoriesEdge>;
  pageInfo?: Maybe<PageInfo>;
};

export type CategoriesEdge = {
  __typename: 'CategoriesEdge';
  node: Category;
  cursor: Scalars['String'];
};

export type Category = {
  __typename: 'Category';
  id: Scalars['CategoryId'];
  name: Scalars['String'];
  active: Scalars['Boolean'];
  singularDisplayName: Scalars['String'];
  pluralDisplayName: Scalars['String'];
  /**
   * A shorter version of the display name.
   * Note that this display name requires more contextual information to be used.
   * For example, ski binding's short singular name is 'binding'.
   * However, snowboard binding's short singular name is also 'binding',
   * so users must be deliberate when deciding to use the short display names.
   */
  shortSingularDisplayName: Scalars['String'];
  shortPluralDisplayName: Scalars['String'];
  titleDisplayName?: Maybe<Scalars['String']>;
  type: CategoryType;
  slug: Scalars['String'];
  /**
   * Parent categories listed in order of root to this category.
   * (e.g.: ["Product", "Winter Sports", "Skiing"] if this category is "Skis")
   * Args: last - depth of the parent hierarchy to walk up the hierarchy chain.
   * For example if the category was "Skis", last = 1 will return the parent ["Skiing'], last = 2 will return
   * the parent and grandparent, ["Winter Sports", "Skiing"]
   */
  parents: Array<Category>;
  /**
   * Builds a list of children of the requested Category.
   * 
   * If recursive it finds all children in the Category Hierarchy that are flattened into a single list
   */
  children: Array<Category>;
  /** List of all brands associated with this category */
  brands: Array<Brand>;
  /** Addresses of all Merchants's associated with this Category if its of CategoryType SERVICE */
  serviceLocations: Array<SellableServiceLocation>;
  /** The category itself or its ancestor which has a path defined */
  ancestorWithPath?: Maybe<Category>;
  /** browse url.  null if the category is not list or has no slug */
  browseUrl?: Maybe<Scalars['String']>;
  /** start path url. null if the category is not listed or has no slug */
  startPathUrl?: Maybe<Scalars['String']>;
  /** Experts assigned to this or parent categories */
  experts: Array<BusinessUser>;
  expertCategories: Array<Category>;
  contentAssets: CategoryContentAssets;
  accessory: Scalars['Boolean'];
  department?: Maybe<Department>;
  /**
   * Get sellable search facets associated with this category, by default only brands and first primary attribute
   * of the category are returned as facets. Additionally, it excludes out of stock sellables when building the facets.
   */
  sellableSearchFacets: Array<DisplayFacetSelection>;
  leadSurging: Scalars['Boolean'];
  articleNavigation?: Maybe<ArticleNavigation>;
  recommendExpertForConsumer: RecommendExpertPayload;
  sellableTopLists: Array<SellableTopList>;
};


export type CategoryParentsArgs = {
  last?: Maybe<Scalars['Int']>;
};


export type CategoryChildrenArgs = {
  recurse?: Maybe<Scalars['Boolean']>;
};


export type CategoryBrandsArgs = {
  activeOnly?: Maybe<Scalars['Boolean']>;
};


export type CategoryServiceLocationsArgs = {
  displayType?: Maybe<SellableServiceLocationDisplayType>;
};


export type CategoryExpertsArgs = {
  limit?: Maybe<Scalars['Int']>;
};


export type CategorySellableSearchFacetsArgs = {
  query: CategorySellableSearchFacetQuery;
};


export type CategorySellableTopListsArgs = {
  limit?: Maybe<Scalars['Int']>;
  featuredOnly?: Maybe<Scalars['Boolean']>;
  includeParentCategories?: Maybe<Scalars['Boolean']>;
  includeChildCategories?: Maybe<Scalars['Boolean']>;
};

export type CategoryContentAssets = {
  __typename: 'CategoryContentAssets';
  bannerImages: Array<ContentAsset>;
  posterImages: Array<ContentAsset>;
  fixedBarDesktop?: Maybe<ContentAsset>;
  fullPageTakeover?: Maybe<ContentAsset>;
  communityPoster?: Maybe<ContentAsset>;
  modalHeader?: Maybe<ContentAsset>;
  callout?: Maybe<ContentAsset>;
  openGraphImage?: Maybe<ContentAsset>;
  articleHeader?: Maybe<ContentAsset>;
  topListNavImage?: Maybe<ContentAsset>;
};

export type CategoryGroupedBrandStatsAggregateExpertReport = {
  __typename: 'CategoryGroupedBrandStatsAggregateExpertReport';
  id: Scalars['DepartmentId'];
  department: Department;
  departmentStats: Array<BrandStatsAggregateExpertReport>;
  categories: Array<SingleCategoryGroupedBrandStatsAggregateExpertReport>;
};


export type CategoryGroupedBrandStatsAggregateExpertReportDepartmentStatsArgs = {
  limit?: Maybe<Scalars['Int']>;
};


export type CategoryGroupedBrandStatsAggregateExpertReportCategoriesArgs = {
  limit?: Maybe<Scalars['Int']>;
};


export type CategorySellableSearchFacetQuery = {
  sellableSearchUseCase?: Maybe<SellableSearchUseCase>;
  facetFilters?: Maybe<Array<SellableSearchFacetsQueryFilter>>;
  maxFacets?: Maybe<Scalars['Int']>;
  maxFacetTerms?: Maybe<Scalars['Int']>;
  expandToChildCategories?: Maybe<Scalars['Boolean']>;
};

export enum CategoryType {
  PRODUCT = 'PRODUCT',
  SERVICE = 'SERVICE'
}

export enum ChallengeType {
  OTP = 'OTP',
  PASSWORD = 'PASSWORD'
}

export type ChangePasswordInput = {
  oldPassword: Scalars['String'];
  newPassword: Scalars['String'];
  refreshToken?: Maybe<Scalars['String']>;
};

export type ChangePasswordPayload = EncodedAuthenticationTokensPayload & {
  __typename: 'ChangePasswordPayload';
  result: AuthenticationResult;
  message?: Maybe<Scalars['String']>;
  encodedAuthenticationTokens?: Maybe<EncodedAuthenticationTokens>;
};

export type ChannelAddress = {
  __typename: 'ChannelAddress';
  type: MessagingChannelType;
  address: Scalars['String'];
};

export type ChannelTemplate = {
  channelType: ChannelType;
};

export enum ChannelType {
  EMAIL = 'EMAIL',
  SMS = 'SMS',
  INAPP = 'INAPP',
  FACEBOOK = 'FACEBOOK',
  PUSH_NOTIFICATION = 'PUSH_NOTIFICATION',
  SLACK = 'SLACK'
}

export type CharacterCountAttributeValidatorReference = AttributeValidatorReference & {
  __typename: 'CharacterCountAttributeValidatorReference';
  id: Scalars['AttributeValidatorReferenceId'];
  type: AttributeValidatorType;
  min?: Maybe<Scalars['Long']>;
  max?: Maybe<Scalars['Long']>;
};

export type CharacterCountAttributeValidatorReferenceInput = {
  min?: Maybe<Scalars['Long']>;
  max?: Maybe<Scalars['Long']>;
};

export type ChargeInfoInput = {
  paymentSourceChargeAmount: MonetaryAmountInput;
  paymentProcessorPlatformSourceId: Scalars['String'];
  paymentSourceType: PaymentProcessorType;
  paymentSourceUsage: PaymentSourceUsage;
  billingAddress?: Maybe<AddressInput>;
};

export type CheckedOnReturnLabelFromMerchantInput = {
  ticketId: Scalars['TicketId'];
};

export type CheckoutStartedUserActivity = UserActivity & {
  __typename: 'CheckoutStartedUserActivity';
  id: Scalars['UserActivityId'];
  userId: Scalars['UserId'];
  type: UserActivityType;
  occurredAt: Scalars['Date'];
};

export type ClaimConsumerReferralUserSourceInput = {
  requestingConsumerId: Scalars['UserId'];
  referrerEmail?: Maybe<Scalars['String']>;
  referrerPhone?: Maybe<Scalars['String']>;
  referralCode?: Maybe<Scalars['String']>;
};

export type ClaimConsumerReferralUserSourcePayload = {
  __typename: 'ClaimConsumerReferralUserSourcePayload';
  updateUserSourceResult: UpdateUserSourceToReferralResult;
  claimReferralPromotionResult?: Maybe<ClaimPromotionPayload>;
};

export type ClaimExpertReferralUserSourceInput = {
  requestingConsumerId: Scalars['UserId'];
  expertId: Scalars['BusinessUserId'];
};

export type ClaimExpertReferralUserSourcePayload = {
  __typename: 'ClaimExpertReferralUserSourcePayload';
  updateUserSourceResult: UpdateUserSourceToReferralResult;
  claimReferralPromotionResult?: Maybe<ClaimPromotionPayload>;
};

export type ClaimOrderLineItemInput = {
  orderId: Scalars['OrderId'];
  orderLineItemId: Scalars['OrderLineItemId'];
  merchantId: Scalars['MerchantId'];
  merchantQuote?: Maybe<MonetaryAmountInput>;
  merchantOrderId?: Maybe<Scalars['String']>;
  merchantEta?: Maybe<Scalars['Date']>;
  merchantMaxEta?: Maybe<Scalars['Date']>;
  merchantTax?: Maybe<MonetaryAmountInput>;
  merchantShippingCost?: Maybe<MonetaryAmountInput>;
};

export type ClaimOrderLineItemPayload = {
  __typename: 'ClaimOrderLineItemPayload';
  order: Order;
  hasError: Scalars['Boolean'];
  errorMessage?: Maybe<Scalars['String']>;
};

export enum ClaimPromotionErrorCode {
  NOT_FIRST_PURCHASE = 'NOT_FIRST_PURCHASE',
  NO_PROMOTION_FOUND = 'NO_PROMOTION_FOUND',
  LIMIT_EXCEEDED = 'LIMIT_EXCEEDED',
  ALREADY_CLAIMED = 'ALREADY_CLAIMED'
}

export type ClaimPromotionPayload = {
  __typename: 'ClaimPromotionPayload';
  promotion?: Maybe<Promotion>;
  hasError: Scalars['Boolean'];
  errorCode?: Maybe<ClaimPromotionErrorCode>;
  errorMessage?: Maybe<Scalars['String']>;
};

export type ClaimSocialShareCreditInput = {
  shareImageId?: Maybe<Scalars['MediaId']>;
};

export type ClaimSocialShareCreditPayload = {
  __typename: 'ClaimSocialShareCreditPayload';
  result: ClaimPromotionPayload;
};

export type CloseAndOpenNewTicketInput = {
  originalTicketId: Scalars['TicketId'];
  comment?: Maybe<Scalars['String']>;
  dueAt?: Maybe<Scalars['Date']>;
  ticketType: TicketType;
  description: Scalars['String'];
  workflowType: WorkflowType;
  orderId: Scalars['OrderId'];
  orderLineItemIdList: Array<Scalars['OrderLineItemId']>;
  orderRefundReason?: Maybe<OrderRefundReason>;
  userId: Scalars['UserId'];
  escalationItemInfos: Array<EscalationItemInfoInput>;
};

export type CloseApprovalRequestActivityEntryDetail = ApprovalRequestActivityEntryDetail & {
  __typename: 'CloseApprovalRequestActivityEntryDetail';
  entryType: ApprovalRequestActivityEntryType;
};

export type CloseApprovalRequestError = DefaultErrorMessage;

export type CloseApprovalRequestInput = {
  approvalRequestId: Scalars['ApprovalRequestId'];
};

export type CloseApprovalRequestPayload = {
  __typename: 'CloseApprovalRequestPayload';
  approvalRequest?: Maybe<ApprovalRequest>;
  error?: Maybe<CloseApprovalRequestError>;
};

export type CloseExpertCuratedOrderInput = {
  id: Scalars['ExpertCuratedOrderId'];
};

export type CloseExpertCuratedOrderPayload = {
  __typename: 'CloseExpertCuratedOrderPayload';
  expertCuratedOrder: ExpertCuratedOrder;
};

export type CloseTicketInput = {
  ticketId: Scalars['TicketId'];
  comment?: Maybe<Scalars['String']>;
  reason?: Maybe<CloseTicketReason>;
  escalationResolution?: Maybe<EscalationResolution>;
  workflowFailureResolution?: Maybe<WorkflowFailureResolution>;
};

export enum CloseTicketReason {
  RESOLVED = 'RESOLVED',
  NO_ACTION_NEEDED = 'NO_ACTION_NEEDED',
  REQUESTER_DID_NOT_FOLLOWUP = 'REQUESTER_DID_NOT_FOLLOWUP',
  OPENED_NEW_TICKET = 'OPENED_NEW_TICKET',
  MERGED = 'MERGED',
  UNABLE_TO_PROCESS = 'UNABLE_TO_PROCESS'
}

export type CodeExperimentUsage = ExperimentUsage & {
  __typename: 'CodeExperimentUsage';
  type: ExperimentUsageType;
  path: Scalars['String'];
  githubUrl: Scalars['String'];
};

export type CommentApprovalRequestActivityEntryDetail = ApprovalRequestActivityEntryDetail & {
  __typename: 'CommentApprovalRequestActivityEntryDetail';
  entryType: ApprovalRequestActivityEntryType;
  comment: Scalars['String'];
};

export type CommentOnApprovalRequestError = DefaultErrorMessage;

export type CommentOnApprovalRequestInput = {
  approvalRequestId: Scalars['ApprovalRequestId'];
  comment: Scalars['String'];
};

export type CommentOnApprovalRequestPayload = {
  __typename: 'CommentOnApprovalRequestPayload';
  approvalRequest?: Maybe<ApprovalRequest>;
  error?: Maybe<CommentOnApprovalRequestError>;
};

export type CommonFieldsQuestionPathNodeFlowViewModel = {
  __typename: 'CommonFieldsQuestionPathNodeFlowViewModel';
  questionText?: Maybe<PathTextViewModel>;
  questionSubText?: Maybe<PathTextViewModel>;
  inputLabel?: Maybe<PathTextViewModel>;
  required: Scalars['Boolean'];
  validationErrors: Array<QuestionPathNodeFlowViewModelValidationError>;
};

export type CommonPathEditorPayload = {
  pathEditorContext: PathEditorContext;
  errorMessage?: Maybe<Scalars['String']>;
  hasError: Scalars['Boolean'];
};

export type CommonPathSchemaRevision = PathSchemaRevision | PathSchemaFragmentRevision;

export type CommTemplateDataModelInput = {
  templateTypeId: Scalars['CommTemplateTypeId'];
  variables: Array<RenderCommTemplateVariableInput>;
};

export type CommTemplateDataModelPayload = {
  __typename: 'CommTemplateDataModelPayload';
  error?: Maybe<Scalars['String']>;
  dataJson?: Maybe<Scalars['String']>;
};

export type CommTemplateDirective = {
  __typename: 'CommTemplateDirective';
  name: Scalars['String'];
  displayName: Scalars['String'];
  parameters: Array<TemplateFragmentParameter>;
};

export type CommTemplateExperimentUsage = ExperimentUsage & {
  __typename: 'CommTemplateExperimentUsage';
  type: ExperimentUsageType;
  commTemplateId: Scalars['CommTemplateId'];
  commTemplate: MultiLocaleTemplateSet;
};

export type CommTemplateFilter = {
  state?: Maybe<RevisionState>;
};

export type CommTemplateFragment = {
  __typename: 'CommTemplateFragment';
  id: Scalars['CommTemplateFragmentId'];
  state: RevisionState;
  historyId: Scalars['CommTemplateFragmentVersionHistoryId'];
  versionNumber: Scalars['Int'];
  name: Scalars['String'];
  title: Scalars['String'];
  description: Scalars['String'];
  content: Scalars['String'];
  /** @deprecated this is optional, only used for legacy fragment */
  usage?: Maybe<Scalars['String']>;
  updatedAt: Scalars['Date'];
  pendingDraft?: Maybe<CommTemplateFragment>;
  changes: Array<RevisionChange>;
  type: TemplateFragmentType;
  nestedContentAllowed: Scalars['Boolean'];
  nestedContentExample?: Maybe<Scalars['String']>;
  parameters: Array<TemplateFragmentParameter>;
};

export type CommTemplateFragmentFilter = {
  state?: Maybe<RevisionState>;
  type?: Maybe<TemplateFragmentType>;
};




export type CommTemplateType = {
  __typename: 'CommTemplateType';
  id: Scalars['CommTemplateTypeId'];
  name: Scalars['String'];
  displayName: Scalars['String'];
  group: TemplateTypeGroup;
  groupName: Scalars['String'];
  unsubscribeTag?: Maybe<MessageUnsubscribeTag>;
  notificationType: NotificationType;
  entityName: Scalars['String'];
  description: Scalars['String'];
  templates: Array<MultiLocaleTemplateSet>;
  requiredChannels: Array<ChannelType>;
  queryVariables: Array<TriggerParameterMeta>;
  experimentSupported: Scalars['Boolean'];
  categorySupported: Scalars['Boolean'];
  categoryTypeRequired: Scalars['Boolean'];
  activeTemplateCount: Scalars['Int'];
  internal: Scalars['Boolean'];
  hardcoded: Scalars['Boolean'];
  richCardType?: Maybe<MessageRichCardType>;
  richCardDataModel?: Maybe<MessageRichCardDataModel>;
  optionalChannelSupported: Scalars['Boolean'];
  dataModel: TemplateDataModel;
  frequencyCaps: Array<TemplateMessageFrequencyCapRule>;
  publishedTriggers: Array<Trigger>;
};


export type CommTemplateTypeTemplatesArgs = {
  state?: Maybe<RevisionState>;
  categoryId?: Maybe<Scalars['CategoryId']>;
};

export type CommTemplateTypeFilter = {
  internal?: Maybe<Scalars['Boolean']>;
  hardcoded?: Maybe<Scalars['Boolean']>;
};



export type CompleteEscalationInput = {
  escalationId: Scalars['OrderEscalationId'];
  resolution?: Maybe<EscalationResolution>;
};

export type CompleteLeadSupportTaskAssignLeadActionsInput = {
  supportTaskId: Scalars['SupportTaskId'];
  actions: Array<SuggestedActionType>;
};

export type CompleteLeadSupportTaskAssignLeadActionsPayload = {
  __typename: 'CompleteLeadSupportTaskAssignLeadActionsPayload';
  supportTask: LeadSupportTask;
};

export type CompleteLeadSupportTaskCheckForSpamInput = {
  supportTaskId: Scalars['SupportTaskId'];
  spam: Scalars['Boolean'];
};

export type CompleteLeadSupportTaskCheckForSpamPayload = {
  __typename: 'CompleteLeadSupportTaskCheckForSpamPayload';
  supportTask: LeadSupportTask;
};

export type CompleteLeadSupportTaskDelegateLeadInput = {
  supportTaskId: Scalars['SupportTaskId'];
  expertId: Scalars['BusinessUserId'];
};

export type CompleteLeadSupportTaskDelegateLeadPayload = {
  __typename: 'CompleteLeadSupportTaskDelegateLeadPayload';
  supportTask: LeadSupportTask;
};

export type CompleteLeadSupportTaskEscalateForReassignmentInput = {
  supportTaskId: Scalars['SupportTaskId'];
};

export type CompleteLeadSupportTaskEscalateForReassignmentPayload = {
  __typename: 'CompleteLeadSupportTaskEscalateForReassignmentPayload';
  supportTask: LeadSupportTask;
};

export type CompleteLeadSupportTaskEscalateToTeamForDelegationInput = {
  supportTaskId: Scalars['SupportTaskId'];
};

export type CompleteLeadSupportTaskEscalateToTeamForDelegationPayload = {
  __typename: 'CompleteLeadSupportTaskEscalateToTeamForDelegationPayload';
  supportTask: LeadSupportTask;
};

export type CompleteLeadSupportTaskReassignLeadInput = {
  supportTaskId: Scalars['SupportTaskId'];
  expertId: Scalars['BusinessUserId'];
};

export type CompleteLeadSupportTaskReassignLeadPayload = {
  __typename: 'CompleteLeadSupportTaskReassignLeadPayload';
  supportTask: LeadSupportTask;
};

export type CompleteLeadSupportTaskRequestOrderSupportInput = {
  supportTaskId: Scalars['SupportTaskId'];
  note: Scalars['String'];
};

export type CompleteLeadSupportTaskRequestOrderSupportPayload = {
  __typename: 'CompleteLeadSupportTaskRequestOrderSupportPayload';
  supportTask: LeadSupportTask;
};

export type CompleteSupportTaskNoActionNeededInput = {
  supportTaskId: Scalars['SupportTaskId'];
};

export type CompleteSupportTaskNoActionNeededPayload = {
  __typename: 'CompleteSupportTaskNoActionNeededPayload';
  error?: Maybe<Scalars['String']>;
  supportTask?: Maybe<SupportTask>;
};

export type CompleteSupportTaskSnoozeInput = {
  supportTaskId: Scalars['SupportTaskId'];
  wakeAt: Scalars['Date'];
};

export type CompleteSupportTaskSnoozePayload = {
  __typename: 'CompleteSupportTaskSnoozePayload';
  supportTask: SupportTask;
};

export type ConditionDefinition = {
  type: ConditionType;
};

export type ConditionDefinitionInput = {
  type: ConditionType;
  subjectIdIn?: Maybe<SubjectIdInConditionDefinitionInput>;
  stringBinary?: Maybe<StringBinaryConditionDefinitionInput>;
  logical?: Maybe<LogicalConditionDefinitionInput>;
};

export type ConditionPathNodeEditorViewModel = PathNodeEditorViewModel & {
  __typename: 'ConditionPathNodeEditorViewModel';
  condition?: Maybe<PathEditorRichText>;
  title?: Maybe<PathEditorRichText>;
  body?: Maybe<PathEditorRichText>;
  expandedTitle?: Maybe<PathEditorRichText>;
  isRequired?: Maybe<Scalars['Boolean']>;
};

export enum ConditionType {
  ALWAYS_TRUE = 'ALWAYS_TRUE',
  SUBJECT_ID_IN = 'SUBJECT_ID_IN',
  STRING_BINARY = 'STRING_BINARY',
  LOGICAL = 'LOGICAL'
}

export type Config = {
  __typename: 'Config';
  id: Scalars['ConfigEntryId'];
  domain: Scalars['String'];
  key: Scalars['String'];
  value?: Maybe<Scalars['String']>;
};

export type ConfigDomain = {
  __typename: 'ConfigDomain';
  name: Scalars['String'];
  displayName: Scalars['String'];
};


export type ConfirmedReturnShippingLabelSentActivity = OrderActivityDetail & {
  __typename: 'ConfirmedReturnShippingLabelSentActivity';
  type: OrderActivityDetailType;
  confirmedBy: Operator;
  orderRefund: OrderRefund;
};

export type ConfirmReturnShippingLabelSentInput = {
  ticketId: Scalars['TicketId'];
};

export type ConfirmShiftProbationsInput = {
  departmentId: Scalars['SchedulingDepartmentId'];
};

export type ConfirmShiftProbationsPayload = {
  __typename: 'ConfirmShiftProbationsPayload';
  usersInProbation: Scalars['Int'];
};

export type ConflictingProductIdentifierProductCatalogPublishError = ErrorMessage & {
  __typename: 'ConflictingProductIdentifierProductCatalogPublishError';
  errorMessage: Scalars['String'];
  revisions: Array<ProductCatalogRevision>;
};

export type ConflictingSkuProductCatalogGroupPublishError = ErrorMessage & {
  __typename: 'ConflictingSkuProductCatalogGroupPublishError';
  errorMessage: Scalars['String'];
  revisions: Array<ProductCatalogGroupRevision>;
};

export type ConsumerCalledActivity = LeadActivity & {
  __typename: 'ConsumerCalledActivity';
  id: Scalars['LeadActivityId'];
  type: LeadActivityType;
  lead: Lead;
  occurredAt: Scalars['Date'];
  performedBy: Identity;
};

export type ConsumerExpertReview = {
  __typename: 'ConsumerExpertReview';
  id: Scalars['ConsumerExpertReviewId'];
  expert: BusinessUser;
  /** only admin have access to this */
  consumer: User;
  active: Scalars['Boolean'];
  rating: Scalars['Int'];
  headline?: Maybe<Scalars['String']>;
  comments?: Maybe<Scalars['String']>;
  goodQualities: Array<Scalars['String']>;
  /** @deprecated Use reviewedAt */
  createdAt: Scalars['Date'];
  reviewedAt: Scalars['Date'];
  consumerName?: Maybe<Scalars['String']>;
  consumerLocation?: Maybe<Scalars['String']>;
  source: ConsumerReviewSource;
  verifiedPurchases: Array<Sellable>;
  featured: Scalars['Boolean'];
  spotlight: Scalars['Boolean'];
};


export type ConsumerExpertReviewVerifiedPurchasesArgs = {
  limit?: Maybe<Scalars['Int']>;
};

export type ConsumerExpertReviewConnection = {
  __typename: 'ConsumerExpertReviewConnection';
  facets: Array<DisplayFacet>;
  edges: Array<ConsumerExpertReviewEdge>;
  pageInfo: PageInfo;
  count: Scalars['Long'];
};

export type ConsumerExpertReviewEdge = {
  __typename: 'ConsumerExpertReviewEdge';
  node: ConsumerExpertReview;
  cursor: Scalars['String'];
};

export type ConsumerExpertReviewFilter = {
  source?: Maybe<ConsumerReviewSource>;
  rating?: Maybe<Scalars['Int']>;
};


export type ConsumerFirstMessageSentActivity = LeadActivity & {
  __typename: 'ConsumerFirstMessageSentActivity';
  id: Scalars['LeadActivityId'];
  type: LeadActivityType;
  lead: Lead;
  occurredAt: Scalars['Date'];
  performedBy: Identity;
};

export enum ConsumerInitialLeadAction {
  BROWSE = 'BROWSE',
  CHAT = 'CHAT'
}

export type ConsumerRefundTicket = TicketDetail & {
  __typename: 'ConsumerRefundTicket';
  type: TicketType;
  consumer: User;
  order: Order;
  orderRefund: OrderRefund;
};

export type ConsumerReviewAddedActivity = LeadActivity & {
  __typename: 'ConsumerReviewAddedActivity';
  id: Scalars['LeadActivityId'];
  type: LeadActivityType;
  lead: Lead;
  occurredAt: Scalars['Date'];
  rating: Scalars['Int'];
  headline?: Maybe<Scalars['String']>;
  comments?: Maybe<Scalars['String']>;
  goodQualities: Array<Scalars['String']>;
  performedBy: Identity;
};

export type ConsumerReviewSearchQuery = {
  expertIds?: Maybe<Array<Scalars['BusinessUserId']>>;
  departmentIds?: Maybe<Array<Scalars['DepartmentId']>>;
  facetedSearch?: Maybe<Scalars['Boolean']>;
  facets?: Maybe<Array<FacetSelection>>;
};

export enum ConsumerReviewSearchSort {
  RELEVANCE = 'RELEVANCE',
  REVIEWED_AT = 'REVIEWED_AT'
}

export enum ConsumerReviewSource {
  CURATED = 'CURATED',
  SHOPPER_APPROVED = 'SHOPPER_APPROVED'
}

export type ConsumerReviewStats = {
  __typename: 'ConsumerReviewStats';
  reviewCount: Scalars['Long'];
  averageRating: Scalars['Float'];
};

export type ConsumerSellableReaction = {
  __typename: 'ConsumerSellableReaction';
  id: Scalars['ConsumerSellableReactionId'];
  ratingWithDisplayName: ConsumerSellableReactionRatingWithDisplayName;
  reasonsWithDisplayName: Array<ConsumerSellableReactionReasonWithDisplayName>;
  additionalReason?: Maybe<Scalars['String']>;
  sellable: Sellable;
  systemRecommended: Scalars['Boolean'];
  /** the BusinessUser if it was recommended by an expert */
  recommendedBy?: Maybe<BusinessUser>;
  /** Logical Component on the UI that triggered this reaction */
  reactionSource?: Maybe<ConsumerSellableReactionSource>;
};

export type ConsumerSellableReactionConnection = {
  __typename: 'ConsumerSellableReactionConnection';
  edges: Array<ConsumerSellableReactionEdge>;
  pageInfo: PageInfo;
};

export type ConsumerSellableReactionEdge = {
  __typename: 'ConsumerSellableReactionEdge';
  node: ConsumerSellableReaction;
  cursor: Scalars['String'];
};


export enum ConsumerSellableReactionRating {
  SKIP = 'SKIP',
  DISLIKE = 'DISLIKE',
  LIKE = 'LIKE',
  LOVE = 'LOVE'
}

export type ConsumerSellableReactionRatingStats = {
  __typename: 'ConsumerSellableReactionRatingStats';
  rating: SystemCuratedConsumerSellableReactionRating;
  displayName: Scalars['String'];
  count: Scalars['Int'];
};

export type ConsumerSellableReactionRatingWithDisplayName = {
  __typename: 'ConsumerSellableReactionRatingWithDisplayName';
  rating: ConsumerSellableReactionRating;
  displayName: Scalars['String'];
};

export enum ConsumerSellableReactionReason {
  PRICE = 'PRICE',
  BRAND = 'BRAND',
  STYLE = 'STYLE',
  FEATURES = 'FEATURES'
}

export type ConsumerSellableReactionReasonWithDisplayName = {
  __typename: 'ConsumerSellableReactionReasonWithDisplayName';
  reason: ConsumerSellableReactionReason;
  displayName: Scalars['String'];
};

export type ConsumerSellableReactionRecommendationSourceInput = {
  expertCuratedItemId?: Maybe<Scalars['ExpertCuratedItemId']>;
  recommendedListDefinitionId?: Maybe<Scalars['RecommendedListDefinitionId']>;
  systemCuratedItemId?: Maybe<Scalars['SystemCuratedItemId']>;
};

export enum ConsumerSellableReactionSource {
  SYSTEM_CURATED_ITEM_SURVEY = 'SYSTEM_CURATED_ITEM_SURVEY',
  FAVORITES_PAGE = 'FAVORITES_PAGE',
  SEARCH_RESULTS = 'SEARCH_RESULTS',
  PRODUCT_DETAILS = 'PRODUCT_DETAILS'
}

export type ConsumerSellableReactionsQuery = {
  /** The user whose reviews are needed */
  reviewedBy: Scalars['UserId'];
  /** Reactions for specific sellables by a user */
  sellableIds?: Maybe<Array<Scalars['SellableId']>>;
  /** Reactions for sellables recommended by the specified Expert Id */
  recommendedBy?: Maybe<Scalars['BusinessUserId']>;
  /** Reactions for specific department by user */
  departmentId?: Maybe<Scalars['DepartmentId']>;
  /** Reactions for specific categories by user */
  categoryIds?: Maybe<Array<Scalars['CategoryId']>>;
};

export type Contact = {
  __typename: 'Contact';
  id: Scalars['ContactId'];
  type: ContactType;
  value: Scalars['String'];
  /** The value as email address, if type is EMAIL */
  emailAddress?: Maybe<Scalars['String']>;
  /** The value as phone number, if type is PHONE */
  phoneNumber?: Maybe<Scalars['String']>;
  parsedPhoneNumber?: Maybe<ParsedPhoneNumber>;
  verified: Scalars['Boolean'];
};

export type ContactAvailableAttributeValidatorReference = AttributeValidatorReference & {
  __typename: 'ContactAvailableAttributeValidatorReference';
  id: Scalars['AttributeValidatorReferenceId'];
  type: AttributeValidatorType;
  contactType: ContactType;
};

export type ContactAvailableAttributeValidatorReferenceInput = {
  contactType: ContactType;
};

export type ContactCollectionRichCard = MessageRichCard & {
  __typename: 'ContactCollectionRichCard';
  type: MessageRichCardType;
  leadId: Scalars['LeadId'];
};


export type ContactPrivacyMetadata = PathFlowPageMetadata & {
  __typename: 'ContactPrivacyMetadata';
  type: PathFlowPageMetadataType;
};

export type ContactTcpaComplianceMetadata = PathFlowPageMetadata & {
  __typename: 'ContactTCPAComplianceMetadata';
  type: PathFlowPageMetadataType;
};

export enum ContactType {
  PHONE = 'PHONE',
  EMAIL = 'EMAIL',
  FACEBOOK = 'FACEBOOK',
  PUSH_NOTIFICATION = 'PUSH_NOTIFICATION'
}

export type ContentAsset = {
  __typename: 'ContentAsset';
  title: Scalars['String'];
  url: Scalars['String'];
  mimeType: Scalars['String'];
  imageUrl?: Maybe<Scalars['String']>;
};

export type ContentBooleanValue = {
  __typename: 'ContentBooleanValue';
  booleanValue: Scalars['Boolean'];
};

export type ContentFloatValue = {
  __typename: 'ContentFloatValue';
  floatValue: Scalars['Float'];
};

export type ContentIntValue = {
  __typename: 'ContentIntValue';
  intValue: Scalars['Int'];
};

export type ContentObject = {
  __typename: 'ContentObject';
  entries: Array<ContentObjectEntry>;
};

export type ContentObjectEntry = {
  __typename: 'ContentObjectEntry';
  key: Scalars['String'];
  value: ContentValue;
};

export enum ContentSelectionAdLevel {
  NONE = 'NONE',
  AD = 'AD',
  AD_GROUP = 'AD_GROUP',
  CAMPAIGN = 'CAMPAIGN',
  SOURCE = 'SOURCE'
}

export enum ContentSelectionChannelType {
  ENGAGEMENT_CHANNEL = 'ENGAGEMENT_CHANNEL',
  LANDING_PAGE = 'LANDING_PAGE',
  EXPERT_HIRING = 'EXPERT_HIRING',
  PRODUCT_DETAIL = 'PRODUCT_DETAIL'
}

export type ContentSelectionCriteriaInput = {
  pageKey?: Maybe<Scalars['String']>;
  channelType: ContentSelectionChannelType;
  deviceType: ContentSelectionDeviceType;
  keyword?: Maybe<Scalars['String']>;
  adId?: Maybe<Scalars['String']>;
  adGroupId?: Maybe<Scalars['String']>;
  campaignId?: Maybe<Scalars['String']>;
  source?: Maybe<Scalars['String']>;
  categorySlug?: Maybe<Scalars['String']>;
  guest?: Maybe<Scalars['Boolean']>;
};

export enum ContentSelectionDeviceType {
  DESKTOP = 'DESKTOP',
  MOBILE_WEB = 'MOBILE_WEB'
}

export type ContentSelectionMethod = {
  type: ContentSelectionMethodType;
};

export type ContentSelectionMethodInput = {
  experiment?: Maybe<ExperimentContentSelectionMethodInput>;
  hardcoded?: Maybe<HardcodedContentSelectionMethodInput>;
};

export enum ContentSelectionMethodType {
  EXPERIMENT = 'EXPERIMENT',
  HARDCODED = 'HARDCODED'
}

export type ContentSelectionResult = {
  __typename: 'ContentSelectionResult';
  rule: ContentSelectionRule;
  treatment?: Maybe<Scalars['String']>;
  template?: Maybe<ContentSelectionTemplate>;
};

export type ContentSelectionRule = {
  __typename: 'ContentSelectionRule';
  id: Scalars['ContentSelectionRuleId'];
  title: Scalars['String'];
  pageKey?: Maybe<Scalars['String']>;
  channelType: ContentSelectionChannelType;
  deviceTypes: Array<ContentSelectionDeviceType>;
  active: Scalars['Boolean'];
  keyword?: Maybe<Scalars['String']>;
  guestOnly: Scalars['Boolean'];
  adLevel: ContentSelectionAdLevel;
  adValues: Array<Scalars['String']>;
  categories: Array<Category>;
  selectionMethod: ContentSelectionMethod;
};

export type ContentSelectionRuleExperimentUsage = ExperimentUsage & {
  __typename: 'ContentSelectionRuleExperimentUsage';
  type: ExperimentUsageType;
  contentSelectionRuleId: Scalars['ContentSelectionRuleId'];
  contentSelectionRule: ContentSelectionRule;
};

export type ContentSelectionRuleFilterInput = {
  activeOnly: Scalars['Boolean'];
  guestOnly: Scalars['Boolean'];
  channelType: ContentSelectionChannelType;
  deviceType?: Maybe<ContentSelectionDeviceType>;
  pageKey?: Maybe<Scalars['String']>;
  categoryId?: Maybe<Scalars['CategoryId']>;
  searchKeyword?: Maybe<Scalars['String']>;
};


export type ContentSelectionRulesPagination = {
  __typename: 'ContentSelectionRulesPagination';
  rules: Array<ContentSelectionRule>;
  count: Scalars['Int'];
};

export type ContentSelectionTemplate = {
  __typename: 'ContentSelectionTemplate';
  spaceName: Scalars['String'];
  templateName: Scalars['String'];
  variation: Scalars['String'];
  content?: Maybe<ContentObject>;
};

export type ContentSpace = {
  __typename: 'ContentSpace';
  name: Scalars['String'];
  templates: Array<Scalars['String']>;
};

export type ContentStringValue = {
  __typename: 'ContentStringValue';
  stringValue: Scalars['String'];
};

export type ContentValue = ContentBooleanValue | ContentStringValue | ContentIntValue | ContentFloatValue | ContentAsset | ContentValueArray | ContentObject;

export type ContentValueArray = {
  __typename: 'ContentValueArray';
  values: Array<ContentValue>;
};

export type Conversation = {
  __typename: 'Conversation';
  id: Scalars['ConversationId'];
  externalId: Scalars['String'];
  title: Scalars['String'];
  active: Scalars['Boolean'];
  participants: Array<MessagingUser>;
  unreadCount: Scalars['Int'];
  lead?: Maybe<Lead>;
  owner?: Maybe<MessagingUser>;
  message: Message;
};


export type ConversationUnreadCountArgs = {
  participantId: Scalars['AnyId'];
};


export type ConversationMessageArgs = {
  id?: Maybe<Scalars['String']>;
};


export type ConversationMessagePart = {
  __typename: 'ConversationMessagePart';
  type: Scalars['String'];
  body: Scalars['String'];
};

export type ConversationMetrics = {
  __typename: 'ConversationMetrics';
  initialSentAt?: Maybe<Scalars['Date']>;
  firstManualMessageSentAt?: Maybe<Scalars['Date']>;
  lastSentAt?: Maybe<Scalars['Date']>;
  lastManualMessageSentAt?: Maybe<Scalars['Date']>;
  messageCount?: Maybe<Scalars['Int']>;
  manualMessageCount?: Maybe<Scalars['Int']>;
  unreadMessageCount?: Maybe<Scalars['Int']>;
  lastMessageSummary?: Maybe<MessageSummary>;
};

export type ConversationSnippet = {
  __typename: 'ConversationSnippet';
  id: Scalars['ConversationSnippetId'];
  conversation: Conversation;
  messages: Array<ConversationSnippetMessage>;
};


export type ConversationSnippetMessage = {
  __typename: 'ConversationSnippetMessage';
  id: Scalars['String'];
  text: Scalars['String'];
  sender: MessagingUser;
  sentAt: Scalars['Date'];
};

export type ConversationSnippetMessageInput = {
  id: Scalars['String'];
  text: Scalars['String'];
  senderId: Scalars['AnyId'];
  sentAt: Scalars['Date'];
};

export type ConversationStarter = {
  __typename: 'ConversationStarter';
  /** What will be displayed to the user */
  title: Scalars['String'];
  /** What will be sent to the expert when the conversation starter is clicked on. */
  message: Scalars['String'];
  /** What conversationStarterDefinitionId the conversationStarter was made from. */
  definition: ConversationStarterDefinition;
};

export enum ConversationStarterContextType {
  SELLABLE_SEARCH = 'SELLABLE_SEARCH',
  SELLABLE = 'SELLABLE'
}

export type ConversationStarterDefinition = {
  __typename: 'ConversationStarterDefinition';
  id: Scalars['ConversationStarterDefinitionId'];
  criteria: ConversationStarterDefinitionCriteria;
  titleTemplate: Scalars['String'];
  messageTemplate: Scalars['String'];
};

export type ConversationStarterDefinitionCriteria = {
  type: ConversationStarterContextType;
};


export enum ConversationStarterLocation {
  RECOMMENDED_LIST_PAGE = 'RECOMMENDED_LIST_PAGE',
  SELLABLE_PAGE_COMPARISON_MODULE = 'SELLABLE_PAGE_COMPARISON_MODULE',
  SELLABLE_PAGE_CONFIGURATION_MODULE = 'SELLABLE_PAGE_CONFIGURATION_MODULE'
}

export type ConversationStarterQueryInput = {
  sellable?: Maybe<SellableConversationStarterQueryInput>;
  sellableSearch?: Maybe<SellableSearchConversationStarterQueryInput>;
};

export type ConversationStarterRichCard = MessageRichCard & {
  __typename: 'ConversationStarterRichCard';
  type: MessageRichCardType;
  leadId: Scalars['LeadId'];
  leadConversationStarterActivityId: Scalars['LeadConversationStarterActivityId'];
};

export type CopyArticleRevisionAsDraftInput = {
  articleRevisionId: Scalars['ArticleRevisionId'];
};

export type CopyArticleRevisionAsDraftPayload = {
  __typename: 'CopyArticleRevisionAsDraftPayload';
  articleRevision?: Maybe<ArticleRevision>;
  errorMessage?: Maybe<Scalars['String']>;
  hasError: Scalars['Boolean'];
};

export type CopyAttributeSchemaRevisionAsNewVersionInput = {
  id: Scalars['AttributeSchemaRevisionId'];
};

export type CopyAttributeSchemaRevisionAsNewVersionPayload = AttributeSchemaRevisionPayload & {
  __typename: 'CopyAttributeSchemaRevisionAsNewVersionPayload';
  hasError: Scalars['Boolean'];
  errorMessage?: Maybe<Scalars['String']>;
  attributeSchemaRevision?: Maybe<AttributeSchemaRevision>;
};

export type CopyFlightPlanAsDraftInput = {
  id: Scalars['FlightPlanId'];
};

export type CopyFlightPlanAsDraftPayload = {
  __typename: 'CopyFlightPlanAsDraftPayload';
  flightPlan: FlightPlan;
};

export type CopyFromDraftNotAllowedProductCatalogCopyRevisionAsDraftError = ErrorMessage & {
  __typename: 'CopyFromDraftNotAllowedProductCatalogCopyRevisionAsDraftError';
  errorMessage: Scalars['String'];
};

export type CopyFromDraftNotAllowedProductCatalogGroupCopyRevisionAsDraftError = ErrorMessage & {
  __typename: 'CopyFromDraftNotAllowedProductCatalogGroupCopyRevisionAsDraftError';
  errorMessage: Scalars['String'];
};

export type CopyFromExpertCuratedItemsInput = {
  leadId: Scalars['LeadId'];
  /** Suggested ExpertCuratedItemId's used to copy data into the new ExpertCuratedItem */
  sourceExpertCuratedItemIds: Array<Scalars['ExpertCuratedItemId']>;
  shouldAddToCartOnActive?: Maybe<Scalars['Boolean']>;
  /** Relevance metadata passed in the SuggestedExpertCuratedItems response if this */
  suggestExpertCuratedItemRelevanceMetadata?: Maybe<Scalars['String']>;
  /**
   * If this expert curated item is being built from a Suggested alternative
   * sellable, the id of the SuggestedAlternativeSellable
   */
  suggestedAlternativeSellableId?: Maybe<Scalars['SuggestedAlternativeSellableId']>;
  /**
   * If this ExpertCuratedItem is being created from a recommendation, whether to auto fill this with the
   * most popular tag used with the underlying Sellable
   */
  fillWithMostPopularTag?: Maybe<Scalars['Boolean']>;
  /**
   * If this ExpertCuratedItem is being created from a recommendation, whether to auto fill this with the
   * most popular note used with the underlying Sellable
   */
  fillWithMostPopularNote?: Maybe<Scalars['Boolean']>;
};

export type CopyFromExpertCuratedItemsPayload = {
  __typename: 'CopyFromExpertCuratedItemsPayload';
  expertCuratedItems: Array<ExpertCuratedItem>;
  errorType?: Maybe<ExpertCuratedItemWriteErrorType>;
  expertCuratedItemsForLead?: Maybe<ExpertCuratedItemsForLeadPayload>;
  expertCuratedItemsByCategories: ExpertCuratedItemsByCategories;
};


export type CopyFromExpertCuratedItemsPayloadExpertCuratedItemsForLeadArgs = {
  onlyFetchIfError: Scalars['Boolean'];
};

export type CopyFromSavedExpertCuratedItemsInput = {
  id: Scalars['SavedExpertCuratedItemsId'];
  leadId: Scalars['LeadId'];
};

export type CopyFromSavedExpertCuratedItemsPayload = {
  __typename: 'CopyFromSavedExpertCuratedItemsPayload';
  expertCuratedItems: Array<ExpertCuratedItem>;
  errorType?: Maybe<ExpertCuratedItemWriteErrorType>;
  expertCuratedItemsForLead?: Maybe<ExpertCuratedItemsForLeadPayload>;
};


export type CopyFromSavedExpertCuratedItemsPayloadExpertCuratedItemsForLeadArgs = {
  onlyFetchIfError: Scalars['Boolean'];
};

export type CopyItemsFromExpertCuratedOrderInput = {
  sourceId: Scalars['ExpertCuratedOrderId'];
  destinationId: Scalars['ExpertCuratedOrderId'];
};

export type CopyItemsFromExpertCuratedOrderPayload = {
  __typename: 'CopyItemsFromExpertCuratedOrderPayload';
  source: ExpertCuratedOrder;
  destination: ExpertCuratedOrder;
};

export type CopyPathSchemaFragmentRevisionAsNewRevision = {
  id: Scalars['PathSchemaFragmentRevisionId'];
  /**
   * If set, this will copy the path targeted by `id` under a new slug. This will break the "historyId" link this path
   * has with its parent, and will become a completely different path referenced by this new slug. In short, a new
   * revision history will be started, instead of being tracked as an new version of an existing path.
   */
  slug?: Maybe<Scalars['String']>;
  /**
   * If set to true, will archive any existing path schema fragments in draft state that have this same slug.
   * If false and a conflicting draft exists, the `DraftExistsPathSchemaRevisionError` error will be returned.
   * Defaults to false.
   */
  archiveExistingDraft?: Maybe<Scalars['Boolean']>;
};

export type CopyPathSchemaRevisionAsNewRevision = {
  id: Scalars['PathSchemaRevisionId'];
  /**
   * If set, this will copy the path targeted by `id` under a new slug. This will break the "historyId" link this path
   * has with its parent, and will become a completely different path referenced by this new slug. In short, a new
   * revision history will be started, instead of being tracked as an new version of an existing path.
   */
  slug?: Maybe<Scalars['String']>;
  /**
   * If set to true, will archive any existing path schema in draft state that have this same slug.
   * If false and a conflicting draft exists, the `DraftExistsPathSchemaRevisionError` error will be returned.
   * Defaults to false.
   */
  archiveExistingDraft?: Maybe<Scalars['Boolean']>;
};

export type CopyProductCatalogGroupRevisionAsDraftInput = {
  revisionId: Scalars['ProductCatalogGroupRevisionId'];
  requestedById: Scalars['AnyId'];
};

export type CopyProductCatalogGroupRevisionAsDraftPayload = {
  __typename: 'CopyProductCatalogGroupRevisionAsDraftPayload';
  revision?: Maybe<ProductCatalogGroupRevision>;
  error?: Maybe<ProductCatalogGroupCopyRevisionAsDraftError>;
};

export type CopyProductCatalogRevisionAsDraftInput = {
  revisionId: Scalars['ProductCatalogRevisionId'];
  requestedById: Scalars['AnyId'];
};

export type CopyProductCatalogRevisionAsDraftPayload = {
  __typename: 'CopyProductCatalogRevisionAsDraftPayload';
  revision?: Maybe<ProductCatalogRevision>;
  error?: Maybe<ProductCatalogCopyRevisionAsDraftError>;
};

export type CopyPromotionInput = {
  id: Scalars['PromotionId'];
};

export type CopyPromotionPayload = {
  __typename: 'CopyPromotionPayload';
  promotion: Promotion;
};

export type CopySchedulingDemandForecastInput = {
  sourceRangeStart: Scalars['Date'];
  sourceRangeEnd: Scalars['Date'];
  schedulingTypeId: Scalars['SchedulingTypeId'];
};

export type CopySchedulingDemandForecastPayload = {
  __typename: 'CopySchedulingDemandForecastPayload';
  hasErrors: Scalars['Boolean'];
  totalCopied: Scalars['Int'];
  error?: Maybe<Scalars['String']>;
};

export type CopyTemplateFragmentInput = {
  id: Scalars['CommTemplateFragmentId'];
};

export type CopyTemplateFragmentPayload = {
  __typename: 'CopyTemplateFragmentPayload';
  fragment: CommTemplateFragment;
};

export type CopyTemplateInput = {
  templateId: Scalars['CommTemplateId'];
};

export type CopyTemplateTypeInput = {
  templateTypeId: Scalars['CommTemplateTypeId'];
  group: TemplateTypeGroup;
  unsubscribeTag?: Maybe<MessageUnsubscribeTag>;
  notificationType?: Maybe<NotificationType>;
  displayName: Scalars['String'];
  description: Scalars['String'];
  triggerId: Scalars['TriggerId'];
  nodeId: Scalars['TriggerNodeId'];
  parameterName: Scalars['String'];
  richCardType?: Maybe<MessageRichCardType>;
  richCardDataModel?: Maybe<MessageRichCardDataModelInput>;
  dataModel: TemplateDataModelInput;
  frequencyCaps?: Maybe<Array<TemplateMessageFrequencyCapRuleInput>>;
};

export type CopyTemplateTypePayload = {
  __typename: 'CopyTemplateTypePayload';
  trigger?: Maybe<Trigger>;
  templateType?: Maybe<CommTemplateType>;
  error?: Maybe<Scalars['String']>;
};

export type Country = {
  __typename: 'Country';
  /** country code, e.g.: "US", "AU", etc */
  countryCode: Scalars['String'];
  /** country display name, e.g.: "United States", "Australia", etc */
  displayCountry: Scalars['String'];
  /**
   * Depending on country, this will be things like "State", "Territory", "Province", etc. If null, the user shouldn't
   * be prompted for first administrative area
   */
  displayFirstAdministrativeAreaLabel?: Maybe<Scalars['String']>;
  /** Depending on country, this will be "Zip code", "Postcode", etc */
  displayPostalCodeLabel: Scalars['String'];
  /** Depending on country, this will be "City", "Suburb & City", etc */
  displayCityLabel: Scalars['String'];
  /**
   * First administrative area corresponds to things like states, territories, provinces, etc. See
   * https://en.wikipedia.org/wiki/Administrative_division for more information.
   */
  firstAdministrativeAreas: Array<AdministrativeArea>;
  /** If we support shipping to addresses in this country */
  shippingSupported: Scalars['Boolean'];
  /** If we support billing address in this country */
  billingSupported: Scalars['Boolean'];
};

export type CountryFilter = {
  shippingSupported?: Maybe<Scalars['Boolean']>;
  billingSupported?: Maybe<Scalars['Boolean']>;
};

export type CreateAccountActionPathNodeConfig = PathNodeConfig & {
  __typename: 'CreateAccountActionPathNodeConfig';
  configType: PathNodeConfigType;
};

export type CreateAccountActionPathNodeConfigUpsertEditorCommandInput = {
  _?: Maybe<Scalars['Boolean']>;
};

export type CreateAccountPathNodeFlowViewModel = PathNodeFlowViewModel & {
  __typename: 'CreateAccountPathNodeFlowViewModel';
  id: Scalars['PathNodeId'];
  createAccountError: CreateAccountPathNodeFlowViewModelError;
};

export type CreateAccountPathNodeFlowViewModelError = AccountExistsCreateAccountPathNodeFlowViewModelError;

export type CreateAdhocSellableFromEBayItemInput = {
  eBayItemId: Scalars['String'];
  categoryId: Scalars['CategoryId'];
};

export type CreateAdhocSellableFromEBayItemPayload = {
  __typename: 'CreateAdhocSellableFromEBayItemPayload';
  sellable: Sellable;
};

export type CreateAttributeSchemaRevisionInput = {
  name: Scalars['String'];
  displayName: Scalars['String'];
  attributeType: AttributeType;
};

export type CreateAttributeSchemaRevisionPayload = AttributeSchemaRevisionPayload & {
  __typename: 'CreateAttributeSchemaRevisionPayload';
  hasError: Scalars['Boolean'];
  errorMessage?: Maybe<Scalars['String']>;
  attributeSchemaRevision?: Maybe<AttributeSchemaRevision>;
};

export type CreateBlankExpertApplicationInput = {
  userId: Scalars['UserId'];
  departmentId: Scalars['DepartmentId'];
  firstName: Scalars['String'];
  lastName: Scalars['String'];
};

export type CreateBlankExpertApplicationPayload = {
  __typename: 'CreateBlankExpertApplicationPayload';
  error?: Maybe<Scalars['String']>;
  application?: Maybe<ExpertApplication>;
};

export type CreateBusinessAccountInput = {
  merchantId?: Maybe<Scalars['MerchantId']>;
  name: Scalars['String'];
};

export type CreateBusinessAccountPayload = {
  __typename: 'CreateBusinessAccountPayload';
  businessAccount: BusinessAccount;
};

export type CreateBusinessUserInput = {
  departmentId: Scalars['DepartmentId'];
  userId: Scalars['UserId'];
  roles: Array<Scalars['String']>;
  teamId?: Maybe<Scalars['BusinessUserTeamId']>;
};

export type CreateBusinessUserPayload = {
  __typename: 'CreateBusinessUserPayload';
  errors?: Maybe<Array<Scalars['String']>>;
  businessUser?: Maybe<BusinessUser>;
};

export type CreateBusinessUserTeamInput = {
  departmentId: Scalars['DepartmentId'];
  name: Scalars['String'];
  teamLeadCommissionEligible: Scalars['Boolean'];
};

export type CreateBusinessUserTeamPayload = {
  __typename: 'CreateBusinessUserTeamPayload';
  error?: Maybe<Scalars['String']>;
  businessUserTeam?: Maybe<BusinessUserTeam>;
};

export type CreateCampaignAudienceInput = {
  memberType: CampaignAudienceMemberType;
  name: Scalars['String'];
  description?: Maybe<Scalars['String']>;
  keywords?: Maybe<Scalars['String']>;
  conditions?: Maybe<Array<SearchFilterFieldInput>>;
  tags?: Maybe<Array<Scalars['String']>>;
};

export type CreateCampaignAudiencePayload = {
  __typename: 'CreateCampaignAudiencePayload';
  campaignAudience: CampaignAudience;
};

export type CreateCampaignInput = {
  name: Scalars['String'];
  description: Scalars['String'];
  memberType: CampaignAudienceMemberType;
  maximumRecipients: Scalars['Int'];
  leadCampaignSettings?: Maybe<LeadCampaignSettingsInput>;
  deliveryFrequency: CampaignDeliveryFrequency;
  stopDeliveryAt?: Maybe<Scalars['Date']>;
};

export type CreateConsumerExpertReviewActionPathNodeConfig = PathNodeConfig & {
  __typename: 'CreateConsumerExpertReviewActionPathNodeConfig';
  configType: PathNodeConfigType;
};

export type CreateConsumerExpertReviewActionPathNodeConfigUpsertEditorCommandInput = {
  _?: Maybe<Scalars['Boolean']>;
};

export type CreateConsumerReviewForExpertPathGraphFlowInput = {
  pathSelector: PathSchemaSelectorInput;
  expertId: Scalars['BusinessUserId'];
  expertStarRating?: Maybe<Scalars['Int']>;
  /** Inform the server of the client's time zone for proper time handling */
  timeZoneOffsetInMinutes?: Maybe<Scalars['Int']>;
};

export type CreateContentSelectionRuleInput = {
  title: Scalars['String'];
  pageKey?: Maybe<Scalars['String']>;
  channelType: ContentSelectionChannelType;
  deviceTypes: Array<ContentSelectionDeviceType>;
  keyword?: Maybe<Scalars['String']>;
  guestOnly: Scalars['Boolean'];
  active: Scalars['Boolean'];
  adLevel: ContentSelectionAdLevel;
  adValues: Array<Scalars['String']>;
  selectionMethod: ContentSelectionMethodInput;
  categoryIds?: Maybe<Array<Scalars['CategoryId']>>;
};

export type CreateContentSelectionRulePayload = {
  __typename: 'CreateContentSelectionRulePayload';
  errors?: Maybe<Array<Scalars['String']>>;
  rule?: Maybe<ContentSelectionRule>;
};

export type CreateCuratedGiftCardOrderInput = {
  leadId: Scalars['LeadId'];
  price: MonetaryAmountInput;
};

export type CreateCuratedGiftCardOrderPayload = {
  __typename: 'CreateCuratedGiftCardOrderPayload';
  curatedOrder: SimpleCuratedOrder;
};

export type CreateDealRequestInput = {
  /** To identify what kind of lead we want, we can also use path slug if that's easier */
  categoryId: Scalars['CategoryId'];
  /** These are all the current available params in create path flow input */
  charterLocation?: Maybe<Scalars['String']>;
  charterSpecificDates?: Maybe<Scalars['String']>;
  charterLocalDateRange?: Maybe<DateRangeInput>;
  diamondOrSetting?: Maybe<Scalars['String']>;
  durationRangeHours?: Maybe<LongRangeInput>;
  expertId?: Maybe<Scalars['BusinessUserId']>;
  numGuests?: Maybe<LongRangeInput>;
  partyOccasion?: Maybe<Scalars['String']>;
  priceRangeUSD?: Maybe<LongRangeInput>;
  timeZoneOffsetInMinutes?: Maybe<Scalars['Int']>;
};

export type CreateDealRequestPayload = {
  __typename: 'CreateDealRequestPayload';
  dealRequest?: Maybe<DealRequest>;
  lead?: Maybe<Lead>;
  hasError: Scalars['Boolean'];
  errorMessage?: Maybe<Scalars['String']>;
};

export type CreateDraftExpertProfileInput = {
  expertId: Scalars['BusinessUserId'];
};

export type CreateDraftGuestConversationSequenceInput = {
  name: Scalars['String'];
};

export type CreateDraftGuestConversationSequencePayload = {
  __typename: 'CreateDraftGuestConversationSequencePayload';
  sequence: GuestConversationSequence;
};

export type CreateDraftProductCatalogGroupRevisionForGroupInput = {
  groupId: Scalars['ProductCatalogGroupId'];
  requestedById: Scalars['AnyId'];
};

export type CreateDraftProductCatalogGroupRevisionForGroupPayload = {
  __typename: 'CreateDraftProductCatalogGroupRevisionForGroupPayload';
  revision?: Maybe<ProductCatalogGroupRevision>;
  error?: Maybe<ProductCatalogGroupCreateDraftRevisionError>;
};

export type CreateDraftProductCatalogGroupRevisionFromSellableInput = {
  sellableId: Scalars['SellableId'];
  requestedById: Scalars['AnyId'];
};

export type CreateDraftProductCatalogGroupRevisionFromSellablePayload = {
  __typename: 'CreateDraftProductCatalogGroupRevisionFromSellablePayload';
  revision?: Maybe<ProductCatalogGroupRevision>;
  error?: Maybe<ProductCatalogGroupCreateDraftFromSellableError>;
};

export type CreateDraftProductCatalogRevisionForCatalogInput = {
  catalogId: Scalars['ProductCatalogId'];
  requestedById: Scalars['AnyId'];
};

export type CreateDraftProductCatalogRevisionForCatalogPayload = {
  __typename: 'CreateDraftProductCatalogRevisionForCatalogPayload';
  revision?: Maybe<ProductCatalogRevision>;
  error?: Maybe<ProductCatalogCreateDraftRevisionError>;
};

export type CreateDraftProductCatalogRevisionFromSellableInput = {
  sellableId: Scalars['SellableId'];
  requestedById: Scalars['AnyId'];
};

export type CreateDraftProductCatalogRevisionFromSellablePayload = {
  __typename: 'CreateDraftProductCatalogRevisionFromSellablePayload';
  revision?: Maybe<ProductCatalogRevision>;
  error?: Maybe<ProductCatalogCreateDraftFromSellableError>;
};

export type CreateDraftPromotionInput = {
  code: Scalars['String'];
  description?: Maybe<Scalars['String']>;
  template?: Maybe<Scalars['Boolean']>;
  usageLimit?: Maybe<Scalars['Int']>;
  expiresAt?: Maybe<Scalars['Date']>;
};

export type CreateDraftPromotionPayload = {
  __typename: 'CreateDraftPromotionPayload';
  promotion: Promotion;
};

export type CreateExperimentInput = {
  name: Scalars['String'];
  description?: Maybe<Scalars['String']>;
  backendOnly?: Maybe<Scalars['Boolean']>;
  treatments: Array<TreatmentDefinitionInput>;
  rules: Array<RuleDefinitionInput>;
};

export type CreateExperimentPayload = {
  __typename: 'CreateExperimentPayload';
  experiment?: Maybe<ExperimentDefinition>;
  errorMessage?: Maybe<Scalars['String']>;
  hasError: Scalars['Boolean'];
};

export type CreateExpertApplicationActionPathNodeConfig = PathNodeConfig & {
  __typename: 'CreateExpertApplicationActionPathNodeConfig';
  configType: PathNodeConfigType;
  category?: Maybe<Category>;
};

export type CreateExpertApplicationActionPathNodeConfigUpsertEditorCommandInput = {
  categoryId?: Maybe<Scalars['CategoryId']>;
};

export type CreateExpertApplicationPathGraphFlowInput = {
  pathSelector: PathSchemaSelectorInput;
  initialAttributes?: Maybe<Array<AttributeInput>>;
  referredByExpertId?: Maybe<Scalars['BusinessUserId']>;
  /** Inform the server of the client's time zone for proper time handling */
  timeZoneOffsetInMinutes?: Maybe<Scalars['Int']>;
};

export type CreateExpertConsultationFeeOrderInput = {
  leadId: Scalars['LeadId'];
  price: MonetaryAmountInput;
};

export type CreateExpertConsultationFeeOrderPayload = {
  __typename: 'CreateExpertConsultationFeeOrderPayload';
  curatedOrder: SimpleCuratedOrder;
};

export type CreateExpertCuratedItemFromSavedExpertCuratedItemInput = {
  id: Scalars['SavedExpertCuratedItemsId'];
  itemId: Scalars['SellableId'];
  leadId: Scalars['LeadId'];
};

export type CreateExpertCuratedItemInput = {
  leadId: Scalars['LeadId'];
  sellableId: Scalars['SellableId'];
  priceOverride?: Maybe<MonetaryAmountInput>;
  bestOfferPrice?: Maybe<Scalars['Boolean']>;
  discount?: Maybe<MonetaryAmountInput>;
  tag?: Maybe<ExpertCuratedItemTagInput>;
  shouldAddToCartOnActive?: Maybe<Scalars['Boolean']>;
  isBuiltFromRecommendation?: Maybe<Scalars['Boolean']>;
  draftNote?: Maybe<Scalars['String']>;
  noteId?: Maybe<Scalars['ExpertCuratedItemNoteId']>;
  /** If this ExpertCuratedItem is being built from a suggested ExpertCuratedItem, the id of the original ExpertCuratedItem */
  sourceExpertCuratedItemId?: Maybe<Scalars['ExpertCuratedItemId']>;
  /** Relevance metadata passed in the SuggestedExpertCuratedItems listing */
  suggestExpertCuratedItemRelevanceMetadata?: Maybe<Scalars['String']>;
  /**
   * If this expert curated item is being built from a Suggested alternative
   * sellable, the id of the SuggestedAlternativeSellable
   */
  suggestedAlternativeSellableId?: Maybe<Scalars['SuggestedAlternativeSellableId']>;
  /**
   * If this ExpertCuratedItem is being created from a recommendation, whether to auto fill this with the
   * most popular tag used with the underlying Sellable
   */
  fillWithMostPopularTag?: Maybe<Scalars['Boolean']>;
  fulfillmentNotes?: Maybe<ExpertCuratedItemFulfillmentNotesInput>;
};

export type CreateExpertCuratedItemNoteFromSellableInput = {
  createdById: Scalars['BusinessUserId'];
  applyToAllVariants: Scalars['Boolean'];
  sellableId: Scalars['SellableId'];
};

export type CreateExpertCuratedItemNoteFromSellablePayload = {
  __typename: 'CreateExpertCuratedItemNoteFromSellablePayload';
  expertCuratedItemNote?: Maybe<ExpertCuratedItemNote>;
  errorMessage?: Maybe<Scalars['String']>;
  hasError: Scalars['Boolean'];
};

export type CreateExpertCuratedItemPayload = {
  __typename: 'CreateExpertCuratedItemPayload';
  expertCuratedItem?: Maybe<ExpertCuratedItem>;
  errorType?: Maybe<ExpertCuratedItemWriteErrorType>;
  expertCuratedItemsForLead?: Maybe<ExpertCuratedItemsForLeadPayload>;
  expertCuratedItemsByCategories?: Maybe<ExpertCuratedItemsByCategories>;
};


export type CreateExpertCuratedItemPayloadExpertCuratedItemsForLeadArgs = {
  onlyFetchIfError: Scalars['Boolean'];
};

export type CreateExpertCuratedOrderInput = {
  /** The parent sellable or child variant - this will discover the child or sibling variants automatically */
  sellableId: Scalars['SellableId'];
  leadId: Scalars['LeadId'];
  serviceStartsAt?: Maybe<Scalars['Date']>;
  availableForPurchaseDurationMinutes?: Maybe<Scalars['Int']>;
  minimumDepositPercent?: Maybe<Scalars['Int']>;
  prepaidIncidentalPercent?: Maybe<Scalars['Int']>;
  fullPaymentDueBeforeServiceStartDays?: Maybe<Scalars['Int']>;
  flightPlanId?: Maybe<Scalars['FlightPlanId']>;
  inPreview?: Maybe<Scalars['Boolean']>;
  expertNote?: Maybe<Scalars['String']>;
  custom?: Maybe<Scalars['Boolean']>;
};

export type CreateExpertCuratedOrderPayload = {
  __typename: 'CreateExpertCuratedOrderPayload';
  expertCuratedOrder: ExpertCuratedOrder;
};

export type CreateExpertFromApplicationInput = {
  applicationId: Scalars['ExpertApplicationId'];
};

export type CreateExpertFromApplicationPayload = {
  __typename: 'CreateExpertFromApplicationPayload';
  expert?: Maybe<BusinessUser>;
  errorCode?: Maybe<GetEntityErrorCode>;
  maskedUserHandles?: Maybe<Array<MaskedUserHandle>>;
};

export type CreateExpertProfileInput = {
  expertId: Scalars['BusinessUserId'];
  headline: Scalars['String'];
  state: ExpertProfileState;
  profilePhotoId?: Maybe<Scalars['MediaId']>;
  backgroundRichText?: Maybe<Scalars['String']>;
  quotes?: Maybe<Array<Scalars['String']>>;
  socialMediaUrls?: Maybe<Array<Scalars['String']>>;
  gallery?: Maybe<Array<MediaWithCaptionInput>>;
  recentArticles?: Maybe<Array<ExternalContentInput>>;
  highlights?: Maybe<Array<ProfileHighlightInput>>;
  introductionVideoUrl?: Maybe<Scalars['String']>;
  socialMediaAccessTokens?: Maybe<Array<SocialMediaAccessTokenInput>>;
  currentGearIds?: Maybe<Array<Scalars['SellableId']>>;
  favoriteBrandIds?: Maybe<Array<Scalars['BrandId']>>;
  gender?: Maybe<ExpertGender>;
  portraitVideoId?: Maybe<Scalars['MediaId']>;
  introductionVideoId?: Maybe<Scalars['MediaId']>;
  introductionVideo?: Maybe<ExternalVideoLinkInput>;
  spotlightHeadline?: Maybe<Scalars['String']>;
};

export type CreateExpertProfilePayload = {
  __typename: 'CreateExpertProfilePayload';
  expertProfile?: Maybe<ExpertProfile>;
  errors?: Maybe<Array<Scalars['String']>>;
};

export type CreateFirebaseTokenInput = {
  messagingUserId: Scalars['AnyId'];
};

export type CreateFirebaseTokenPayload = {
  __typename: 'CreateFirebaseTokenPayload';
  identityToken: Scalars['String'];
};

export type CreateFlightPlanInput = {
  consumerId?: Maybe<Scalars['UserId']>;
  state: FlightPlanState;
  legs?: Maybe<Array<FlightPlanLegUpsertRequestInput>>;
};

export type CreateFlightPlanPayload = {
  __typename: 'CreateFlightPlanPayload';
  flightPlan?: Maybe<FlightPlan>;
  errorCode?: Maybe<FlightPlanEditErrorCode>;
  hasError: Scalars['Boolean'];
  errorMessage?: Maybe<Scalars['String']>;
};

export type CreateFulfillmentChannelInput = {
  type: FulfillmentChannelType;
  instructions: Scalars['String'];
  name: Scalars['String'];
  instructionsUrl?: Maybe<Scalars['String']>;
  marginPercent?: Maybe<Scalars['Int']>;
  partnerSince?: Maybe<Scalars['Date']>;
  shipmentPricingTierType?: Maybe<ShipmentPricingTierType>;
  partnerCategoryIds?: Maybe<Array<Scalars['CategoryId']>>;
};

export type CreateFulfillmentChannelPayload = {
  __typename: 'CreateFulfillmentChannelPayload';
  fulfillmentChannel: FulfillmentChannel;
};

export type CreateGiftCardOrderInput = {
  amount: MonetaryAmountInput;
  details?: Maybe<GiftCardDetailsInput>;
};

export type CreateGiftCardOrderPayload = {
  __typename: 'CreateGiftCardOrderPayload';
  order?: Maybe<Order>;
  error?: Maybe<Scalars['String']>;
};

export type CreateGroupClaimTicketRequestInput = {
  orderId: Scalars['OrderId'];
  lineItemIds: Array<Scalars['OrderLineItemId']>;
};

export type CreateLeadNote = {
  leadId: Scalars['LeadId'];
  text: Scalars['String'];
  messageId?: Maybe<Scalars['String']>;
};

export type CreateLeadNotePayload = {
  __typename: 'CreateLeadNotePayload';
  note: SavedLeadNote;
};

export type CreateLeadSurgeInput = {
  categoryId: Scalars['CategoryId'];
  surgeFactor: Scalars['Float'];
};

export type CreateLeadSurgePayload = {
  __typename: 'CreateLeadSurgePayload';
  leadSurge?: Maybe<LeadSurge>;
  hasError: Scalars['Boolean'];
  errorMessage?: Maybe<Scalars['String']>;
};

export type CreateLeadTrainingScenarioInput = {
  leadId: Scalars['LeadId'];
  title: Scalars['String'];
  description: Scalars['String'];
};

export type CreateLeadTrainingScenarioPayload = {
  __typename: 'CreateLeadTrainingScenarioPayload';
  trainingScenario?: Maybe<LeadTrainingScenario>;
  error?: Maybe<Scalars['String']>;
};

export type CreateMediaInput = {
  url: Scalars['String'];
  persist?: Maybe<Scalars['Boolean']>;
};

export type CreateMediaPayload = {
  __typename: 'CreateMediaPayload';
  mediaFile?: Maybe<MediaFile>;
};

export type CreateMerchantInput = {
  name: Scalars['String'];
  email?: Maybe<Scalars['String']>;
  phone?: Maybe<Scalars['String']>;
  address?: Maybe<PostalAddressInput>;
  reviewRating?: Maybe<Scalars['Int']>;
  googlePlaceId?: Maybe<Scalars['String']>;
  logoUrl?: Maybe<Scalars['String']>;
  socialProfileUrls?: Maybe<Array<Scalars['String']>>;
  longitude?: Maybe<Scalars['Float']>;
  latitude?: Maybe<Scalars['Float']>;
  shippingNotificationsEmail?: Maybe<Scalars['String']>;
  internal?: Maybe<Scalars['Boolean']>;
  estimatedMarginPercent?: Maybe<Scalars['Int']>;
  defaultCurrency?: Maybe<Scalars['String']>;
  fulfillmentChannelId?: Maybe<Scalars['FulfillmentChannelId']>;
};

export type CreateMerchantPayload = {
  __typename: 'CreateMerchantPayload';
  merchant: Merchant;
  alreadyExists: Scalars['Boolean'];
};

export type CreateMerchantsPayload = {
  __typename: 'CreateMerchantsPayload';
  merchants?: Maybe<Array<CreateMerchantPayload>>;
};

export type CreateNewDraftArticleInput = {
  title: Scalars['String'];
  authorIds: Array<Scalars['AnyId']>;
};

export type CreateNewDraftArticlePayload = {
  __typename: 'CreateNewDraftArticlePayload';
  articleRevision?: Maybe<ArticleRevision>;
  errorMessage?: Maybe<Scalars['String']>;
  hasError: Scalars['Boolean'];
};

export type CreateNewDraftRevisionForArticleInput = {
  articleId: Scalars['ArticleId'];
};

export type CreateNewDraftRevisionForArticlePayload = {
  __typename: 'CreateNewDraftRevisionForArticlePayload';
  articleRevision?: Maybe<ArticleRevision>;
  errorMessage?: Maybe<Scalars['String']>;
  hasError: Scalars['Boolean'];
};

export type CreateOfferForSelfCheckoutInput = {
  sellableId: Scalars['SellableId'];
};

export type CreateOfferFromSellableInput = {
  leadId?: Maybe<Scalars['LeadId']>;
  sellableId: Scalars['SellableId'];
  expertComments?: Maybe<Scalars['String']>;
  price?: Maybe<Scalars['Float']>;
  tax?: Maybe<Scalars['Float']>;
  shippingCost?: Maybe<Scalars['Float']>;
  freeAddOns?: Maybe<Array<Maybe<OfferAddOnInput>>>;
  productOfferTerms?: Maybe<ProductOfferTermsInput>;
  serviceOfferTerms?: Maybe<ServiceOfferTermsInput>;
};

export type CreateOfferInput = {
  leadId?: Maybe<Scalars['LeadId']>;
  merchantId?: Maybe<Scalars['MerchantId']>;
  price: Scalars['Float'];
  originalPrice?: Maybe<Scalars['Float']>;
  originalPriceSource?: Maybe<Scalars['String']>;
  tax?: Maybe<Scalars['Float']>;
  shippingCost?: Maybe<Scalars['Float']>;
  title?: Maybe<Scalars['String']>;
  description?: Maybe<Scalars['String']>;
  imageUrls?: Maybe<Array<Scalars['String']>>;
  videoUrls?: Maybe<Array<Scalars['String']>>;
  expirationDate?: Maybe<Scalars['Date']>;
  comments?: Maybe<Scalars['String']>;
  offerType?: Maybe<BroadcastOfferType>;
  freeAddOns?: Maybe<Array<Maybe<OfferAddOnInput>>>;
  productOfferTerms?: Maybe<ProductOfferTermsInput>;
  serviceOfferTerms?: Maybe<ServiceOfferTermsInput>;
  merchantName?: Maybe<Scalars['String']>;
  merchantImageUrl?: Maybe<Scalars['String']>;
  publicOfferUrl?: Maybe<Scalars['String']>;
  brandId?: Maybe<Scalars['BrandId']>;
  privateOffer?: Maybe<Scalars['Boolean']>;
  dealTemplate?: Maybe<DealTemplateInput>;
  sellableId?: Maybe<Scalars['SellableId']>;
  merchantPostalAddress?: Maybe<PostalAddressInput>;
};

export type CreateOfferPayload = {
  __typename: 'CreateOfferPayload';
  error?: Maybe<Scalars['String']>;
  offer?: Maybe<BroadcastOffer>;
};

export type CreateOperatorsInput = {
  userIds: Array<Scalars['UserId']>;
  active: Scalars['Boolean'];
};

export type CreateOperatorsPayload = {
  __typename: 'CreateOperatorsPayload';
  operators?: Maybe<Array<Operator>>;
};

export type CreateOrderEscalationInput = {
  userId: Scalars['UserId'];
  orderId: Scalars['OrderId'];
  orderLineItemId?: Maybe<Scalars['OrderLineItemId']>;
  leadId?: Maybe<Scalars['LeadId']>;
  type: OrderEscalationType;
  reason?: Maybe<Scalars['String']>;
  dueDate?: Maybe<Scalars['Date']>;
  assignedToId?: Maybe<Scalars['OperatorId']>;
  priority?: Maybe<OrderEscalationPriority>;
  returnReason?: Maybe<OrderRefundReason>;
  itemCondition?: Maybe<EscalationItemCondition>;
  customized?: Maybe<Scalars['Boolean']>;
};

export type CreateOrderEscalationsPayload = {
  __typename: 'CreateOrderEscalationsPayload';
  orderEscalation: OrderEscalation;
};

export type CreateOrderFromOfferInput = {
  id: Scalars['BroadcastOfferId'];
};

export type CreateOrderFromOfferPayload = {
  __typename: 'CreateOrderFromOfferPayload';
  order: Order;
};

export type CreatePasswordInput = {
  password: Scalars['String'];
};

export type CreatePasswordPayload = EncodedAuthenticationTokensPayload & {
  __typename: 'CreatePasswordPayload';
  success: Scalars['Boolean'];
  encodedAuthenticationTokens?: Maybe<EncodedAuthenticationTokens>;
};

/**
 * pathSchemaId, pathSchemaSlug, or categorySlug must be specified to locate a path to create. The remaining input is
 * optional, and mostly provided as prefilled information into the path.
 */
export type CreatePathFlowInput = {
  /** (Primary) If specified, the path will be created from a specific schema id */
  pathSchemaId?: Maybe<Scalars['PathSchemaId']>;
  /** (Secondary) If specified, the path will be created from a specific schema that has this unique slug */
  pathSchemaSlug?: Maybe<Scalars['String']>;
  /**
   * (Tertiary) If specified, the path will be created through the following process:
   * 1) Assert the category slug is valid, and if so, locate a split experiment in the format of `{categorySlug}-path`.
   *    For example, for "skis" the experiment would be "skis-path".
   * 2) If the variation of the split experiment is not `control`, it is interpreted as a `pathSchemaSlug`, and will
   *    lookup the path by slug.
   * 3) In the case of #2 failing due to the split variation returning "control", this entire process from step 1 will
   *    be retried with the parent category (with the "skis" example, "winter-sports" will be tried next).
   * If there are any errors (including failure to discover) the category, split experiment (all fallback category
   * resolutions fail), or invalid path flow slug specified as the treatment for a split experiment, the path won't be
   * created and an error will be returned.
   */
  categorySlug?: Maybe<Scalars['String']>;
  charterDurationType?: Maybe<Scalars['String']>;
  charterLocation?: Maybe<Scalars['String']>;
  charterSpecificDates?: Maybe<Scalars['String']>;
  charterLocalDateRange?: Maybe<DateRangeInput>;
  countryCode?: Maybe<Scalars['String']>;
  diamondShape?: Maybe<Scalars['String']>;
  diamondOrSetting?: Maybe<Scalars['String']>;
  durationRangeHours?: Maybe<LongRangeInput>;
  expertCategory?: Maybe<Scalars['String']>;
  expertId?: Maybe<Scalars['BusinessUserId']>;
  expertStarRating?: Maybe<Scalars['Int']>;
  facebookMessengerChecked?: Maybe<Scalars['String']>;
  facebookUserRef?: Maybe<Scalars['String']>;
  flightPlanId?: Maybe<Scalars['FlightPlanId']>;
  flightDepartureCity?: Maybe<Scalars['String']>;
  flightDepartureDate?: Maybe<DateRangeInput>;
  flightArrivalCity?: Maybe<Scalars['String']>;
  flightReturnDate?: Maybe<DateRangeInput>;
  genericRequestCategory?: Maybe<Scalars['String']>;
  jetPassengers?: Maybe<LongRangeInput>;
  jetTripType?: Maybe<Scalars['String']>;
  aircraftType?: Maybe<Scalars['String']>;
  charterCapacity?: Maybe<Scalars['Int']>;
  numGuests?: Maybe<LongRangeInput>;
  partyOccasion?: Maybe<Scalars['String']>;
  phoneNumber?: Maybe<Scalars['String']>;
  priceRangeUSD?: Maybe<LongRangeInput>;
  /** deprecated: ignored.  referrerId is fetched from cookie */
  referrerId?: Maybe<Scalars['UserId']>;
  referredByExpertId?: Maybe<Scalars['BusinessUserId']>;
  settingRingStyle?: Maybe<Scalars['String']>;
  shoppedWithUsBefore?: Maybe<Scalars['String']>;
  timeZoneOffsetInMinutes?: Maybe<Scalars['Int']>;
  viewedSellableIds?: Maybe<Array<Scalars['SellableId']>>;
  zipCode?: Maybe<Scalars['String']>;
  uniqueDeviceId?: Maybe<Scalars['String']>;
  applicationId?: Maybe<Scalars['String']>;
  firstName?: Maybe<Scalars['String']>;
  email?: Maybe<Scalars['String']>;
  golfShoppingGoal?: Maybe<Scalars['String']>;
  giftCardId?: Maybe<Scalars['GiftCardId']>;
  conversationStarterDefinitionId?: Maybe<Scalars['ConversationStarterDefinitionId']>;
  conversationStarterSellableId?: Maybe<Scalars['SellableId']>;
};

export type CreatePathFlowPayload = EncodedAuthenticationTokensPayload & {
  __typename: 'CreatePathFlowPayload';
  /** Either flow will be provided, or a list of validation errors will be provided. */
  flow?: Maybe<PathFlow>;
  errors?: Maybe<Array<PathValidationError>>;
  /** If a new user is registered as part of this path flow page creation */
  newUserRegistered: Scalars['Boolean'];
  /** If a new deal request is created as part of this path flow page creation */
  newRequestCreated: Scalars['Boolean'];
  encodedAuthenticationTokens?: Maybe<EncodedAuthenticationTokens>;
};

export type CreatePathGraphFlowError = NoSuchPathSchemaCreatePathGraphFlowError;

export type CreatePathGraphFlowInput = {
  /** Specify exactly of the following 3 options */
  request?: Maybe<CreateRequestPathGraphFlowInput>;
  expertApplication?: Maybe<CreateExpertApplicationPathGraphFlowInput>;
  consumerReviewForExpert?: Maybe<CreateConsumerReviewForExpertPathGraphFlowInput>;
  /** Will default to "LIVE" if omitted */
  runMode?: Maybe<PathGraphFlowRunMode>;
};

export type CreatePathGraphFlowPayload = EncodedAuthenticationTokensPayload & {
  __typename: 'CreatePathGraphFlowPayload';
  pathGraphFlow?: Maybe<PathGraphFlow>;
  encodedAuthenticationTokens?: Maybe<EncodedAuthenticationTokens>;
  error?: Maybe<CreatePathGraphFlowError>;
};

export type CreatePathSchemaFragmentRevisionInput = {
  slug: Scalars['String'];
  /**
   * If set to true, will archive any existing path schema fragments in draft state that have this same slug.
   * If false and a conflicting draft exists, the `DraftExistsCreatePathSchemaRevisionError` error will be returned.
   * Defaults to false.
   */
  archiveExistingDraft?: Maybe<Scalars['Boolean']>;
};

export type CreatePathSchemaRevisionError = DraftExistsCreatePathSchemaRevisionError | RevisionExistsCreatePathSchemaRevisionError | MalformedSlugCreatePathSchemaRevisionError;

export type CreatePathSchemaRevisionInput = {
  slug: Scalars['String'];
  domainType: PathSchemaDomainType;
  categoryId?: Maybe<Scalars['CategoryId']>;
  /**
   * If set to true, will archive any existing path schemas in draft state that have this same slug.
   * If false and a conflicting draft exists, the `DraftExistsCreatePathSchemaRevisionError` error will be returned.
   * Defaults to false.
   */
  archiveExistingDraft?: Maybe<Scalars['Boolean']>;
};

export type CreatePathSchemaRevisionPayload = {
  __typename: 'CreatePathSchemaRevisionPayload';
  pathEditorContext?: Maybe<PathEditorContext>;
  error?: Maybe<CreatePathSchemaRevisionError>;
};

export type CreatePaymentSourceInput = {
  paymentProcessorPlatformSourceId: Scalars['String'];
  type: PaymentProcessorType;
  usage?: Maybe<PaymentSourceUsage>;
  billingAddress?: Maybe<AddressInput>;
  isDefault?: Maybe<Scalars['Boolean']>;
};

export type CreatePaymentSourcePayload = {
  __typename: 'CreatePaymentSourcePayload';
  paymentSource: PaymentSource;
};

export type CreatePayoutInput = {
  payeeId: Scalars['AnyId'];
  payDate: Scalars['Date'];
};

export type CreatePayStructureInput = {
  name: Scalars['String'];
  description: Scalars['String'];
  departmentId: Scalars['DepartmentId'];
  type?: Maybe<Scalars['String']>;
};

export type CreatePayStructurePayload = {
  __typename: 'CreatePayStructurePayload';
  error?: Maybe<Scalars['String']>;
  payStructure?: Maybe<PayStructure>;
};

export type CreatePayStructureRevisionInput = {
  payStructureId: Scalars['PayStructureId'];
};

export type CreatePendingAccessContactInput = {
  type: ContactType;
  value: Scalars['String'];
  interest: Scalars['String'];
};

export type CreatePendingAccessContactPayload = {
  __typename: 'CreatePendingAccessContactPayload';
  pendingAccessContact: PendingAccessContact;
};

export type CreatePracticeLeadInput = {
  trainingScenarioId: Scalars['LeadTrainingScenarioId'];
  expertId: Scalars['BusinessUserId'];
};

export type CreatePracticeLeadPayload = {
  __typename: 'CreatePracticeLeadPayload';
  lead?: Maybe<Lead>;
  error?: Maybe<Scalars['String']>;
};

export type CreateQuickReplyInput = {
  name: Scalars['String'];
  text: Scalars['String'];
  leadId?: Maybe<Scalars['LeadId']>;
};

export type CreateQuickReplyPayload = {
  __typename: 'CreateQuickReplyPayload';
  quickReply: QuickReply;
};

export type CreateQuickReplyWithLeadInput = {
  name: Scalars['String'];
  text: Scalars['String'];
  leadId: Scalars['LeadId'];
};

export type CreateQuickReplyWithoutLeadInput = {
  expertId: Scalars['BusinessUserId'];
  name: Scalars['String'];
  text: Scalars['String'];
};

export type CreateRawSellableSourceInput = {
  name: Scalars['String'];
  merchantName?: Maybe<Scalars['String']>;
  type: RawSellableSourceType;
  fulfillmentChannelId?: Maybe<Scalars['FulfillmentChannelId']>;
  filter?: Maybe<RawSellableStandardizationRuleConditionInput>;
  scraper?: Maybe<RawSellableSourceScraperInput>;
  googleShoppingFeed?: Maybe<RawSellableSourceGoogleShoppingFeedInput>;
  googleShoppingSearch?: Maybe<RawSellableSourceGoogleShoppingSearchInput>;
  levelNineFeed?: Maybe<RawSellableSourceLevelNineFeedInput>;
  shopify?: Maybe<RawSellableSourceShopifyInput>;
  walmart?: Maybe<RawSellableSourceWalmartInput>;
  impact?: Maybe<RawSellableSourceImpactInput>;
};

export type CreateRawSellableSourcePayload = {
  __typename: 'CreateRawSellableSourcePayload';
  source?: Maybe<RawSellableSource>;
  hasError: Scalars['Boolean'];
  errors?: Maybe<Array<Scalars['String']>>;
};

export type CreateRawSellableStandardizationRuleInput = {
  name: Scalars['String'];
  sourceId?: Maybe<Scalars['RawSellableSourceId']>;
  priority: Scalars['Int'];
  condition: RawSellableStandardizationRuleConditionInput;
  actions: Array<RawSellableStandardizationActionInput>;
};

export type CreateRawSellableStandardizationRulePayload = {
  __typename: 'CreateRawSellableStandardizationRulePayload';
  rule?: Maybe<RawSellableStandardizationRule>;
  hasError: Scalars['Boolean'];
  errors?: Maybe<Array<Scalars['String']>>;
};

export type CreateRecommendedListDefinitionInput = {
  /** User friendly name for this recommended list definition */
  name: Scalars['String'];
  /**
   * The title template that will be used to build the RecommendedList title shown to the consumer.
   * The template should use the freemarker style `${variable}` format for inserting any dynamic values in the resolved title.
   * For example: "Because you like ${attribute.brands}"
   * Note, the querable attributes from the title will be used as a hard filter in the RecommenedList result.
   * For example, if the title said "Because you like
   * ${attribute.brands.displayName}", then the result will only include
   * recommendations
   * that strictly match the brands
   */
  titleTemplate: Scalars['String'];
  /**
   * The subtitle template that will be used to build the RecommendedList's subtitle shown to the consumer
   * The template should use the freemarker style `${variable}` format for
   * inserting any dynamic values in the resolved subtitle.
   * This is mainly used to provide some additional context the recommended list
   * and for display purpose only with the resolved string.
   */
  subTitleTemplate?: Maybe<Scalars['String']>;
  active: Scalars['Boolean'];
  /**
   * The relative rank of the RecommendedList built using this definition compared to other RecommendedList
   * when the user sees a list of RecommendedList
   */
  rank: Scalars['Int'];
  /** The categories for which this RecommendedListDefinition is being built. */
  categoryIds: Array<Scalars['CategoryId']>;
  /** The filtering facets to refine recommended list results */
  queryFacets: Array<RecommendedListFacetSelectionInput>;
  /** defaults to relevance based sorting */
  sortOptions: Array<RecommendedListSortOrderInput>;
};

export type CreateRecommendedListDefinitionPayload = {
  __typename: 'CreateRecommendedListDefinitionPayload';
  recommendedListDefinition: RecommendedListDefinition;
};

export type CreateReportInput = {
  title: Scalars['String'];
  /** Must be globally unique if specified */
  internalName?: Maybe<Scalars['String']>;
  query: Scalars['String'];
  columns?: Maybe<Array<ReportColumnInput>>;
  scope: ReportAccessScope;
  /** If specified, the columns from the schema are automatically added to the columns */
  schemaType?: Maybe<ReportSchemaType>;
};

export type CreateRequestLeadActionPathNodeConfig = PathNodeConfig & {
  __typename: 'CreateRequestLeadActionPathNodeConfig';
  configType: PathNodeConfigType;
  category?: Maybe<Category>;
};

export type CreateRequestLeadActionPathNodeConfigUpsertEditorCommandInput = {
  categoryId?: Maybe<Scalars['CategoryId']>;
};

export type CreateRequestPathGraphFlowInput = {
  pathSelector: PathSchemaSelectorInput;
  initialAttributes?: Maybe<Array<AttributeInput>>;
  /** Inform the server of the client's time zone for proper time handling */
  timeZoneOffsetInMinutes?: Maybe<Scalars['Int']>;
};

export type CreateSavedExpertCuratedItemsInput = {
  name: Scalars['String'];
  /** Optional description for this curation */
  description?: Maybe<Scalars['String']>;
  /** Expert Curated Items being saved in this curation */
  expertCuratedItemIds?: Maybe<Array<Scalars['ExpertCuratedItemId']>>;
  taggedRequestAttributes?: Maybe<Array<AttributeInput>>;
};

export type CreateSavedExpertCuratedItemsPayload = {
  __typename: 'CreateSavedExpertCuratedItemsPayload';
  savedExpertCuratedItems: SavedExpertCuratedItems;
};

export type CreateSchedulingDemandForecastInput = {
  typeId: Scalars['SchedulingTypeId'];
  startsAt: Scalars['Date'];
  endsAt: Scalars['Date'];
  shiftsRequired: Scalars['Int'];
};

export type CreateSchedulingDemandForecastPayload = {
  __typename: 'CreateSchedulingDemandForecastPayload';
  error?: Maybe<Scalars['String']>;
  forecast?: Maybe<SchedulingDemandForecast>;
};

export type CreateSchedulingUserAvailabilityInput = {
  userId: Scalars['AnyId'];
  startsAt: Scalars['Date'];
  endsAt: Scalars['Date'];
};

export type CreateSchedulingUserAvailabilityPayload = {
  __typename: 'CreateSchedulingUserAvailabilityPayload';
  error?: Maybe<Scalars['String']>;
  availability?: Maybe<SchedulingUserAvailability>;
};

export type CreateSellableCustomOfferRuleInput = {
  departmentId: Scalars['DepartmentId'];
  type: SellableCustomOfferRuleType;
  sourceUrl: Scalars['String'];
  sourceName: Scalars['String'];
  blacklist: Scalars['Boolean'];
};

export type CreateSellableInput = {
  /** Title of the product or service */
  title: Scalars['String'];
  /** Plain text description */
  descriptionText?: Maybe<Scalars['String']>;
  /**
   * Description in GitHub-flavored Markdown format
   * See https://github.github.com/gfm/
   */
  descriptionMarkdown?: Maybe<Scalars['String']>;
  /** Categories this sellable is associated with */
  categoryIds: Array<Scalars['CategoryId']>;
  /** If this sellable is a product or service */
  type: SellableType;
  /**
   * MSRP price of this sellable; omittied if not applicable/available. Note that this is not what the consumer pays for
   * the product on Deal.com; salePrice is the actual price paid for the product.
   */
  originalPrice?: Maybe<MonetaryAmountInput>;
  /** Price we sell to the consumer for without tax */
  salePrice: MonetaryAmountInput;
  /** Standardized brand this sellable is associated with */
  brandId?: Maybe<Scalars['BrandId']>;
  /** Images for this sellable */
  imageIds?: Maybe<Array<Scalars['MediaId']>>;
  /**
   * Merchant that provides this service sellable.
   * This is required for sellables of `type` == `SERVICE`, and is prohibited for `PRODUCT`.
   */
  serviceProviderMerchantId?: Maybe<Scalars['MerchantId']>;
  /** Raw unstructured attributes; simple key value pairs. This will be displayed in the sellable specifications table. */
  rawAttributes?: Maybe<Array<RawAttributeInput>>;
  /**
   * If this sellable is created ad-hoc for single use (e.g.: created for a single customer).
   * Ad-hoc sellables are not surfaced in search, and are primarily used for experts to sell items we don't have a
   * proper standardized sellable for, but have some means to fulfill.
   */
  adHoc: Scalars['Boolean'];
};

export type CreateSellablePayload = {
  __typename: 'CreateSellablePayload';
  sellable: Sellable;
};

export type CreateSellableResearchLinkInput = {
  sellableId: Scalars['SellableId'];
  url: Scalars['String'];
};

export type CreateSellableResearchLinkPayload = {
  __typename: 'CreateSellableResearchLinkPayload';
  researchLink: SellableResearchLink;
};

export type CreateSellableTermsInput = {
  orderLineItemId: Scalars['OrderLineItemId'];
  type: SellableType;
  /** Required for Services */
  startAt?: Maybe<Scalars['Date']>;
};

export type CreateSellableTermsPayload = {
  __typename: 'CreateSellableTermsPayload';
  sellableTerms: SellableTerms;
};

export type CreateSellableTopListInput = {
  title: Scalars['String'];
  description: Scalars['String'];
  facets: Array<FacetSelection>;
  titleForSlug: Scalars['String'];
  departmentId: Scalars['DepartmentId'];
};

export type CreateShipmentPricingModelInput = {
  regularOrderProcessingDays?: Maybe<Scalars['Int']>;
  customOrderProcessingDays?: Maybe<Scalars['Int']>;
  departmentId: Scalars['DepartmentId'];
  tierType: ShipmentPricingTierType;
  pricingOptionsInputs: Array<ShipmentPricingOptionInput>;
};

export type CreateSmsRegistrationPromotionInput = {
  userId: Scalars['UserId'];
};

export type CreateSupportTaskActivity = SupportTaskActivity & {
  __typename: 'CreateSupportTaskActivity';
  id: Scalars['SupportTaskActivityId'];
  supportTask: SupportTask;
  action: SupportTaskAction;
  actor: SupportTaskActor;
  consumer: User;
  lead?: Maybe<Lead>;
  occurredAt: Scalars['Date'];
};

export type CreateTagInput = {
  type: TagType;
  name: Scalars['String'];
};

export type CreateTagPayload = {
  __typename: 'CreateTagPayload';
  errors?: Maybe<Array<Scalars['String']>>;
  tag?: Maybe<Tag>;
};

export type CreateTemplateFragmentInput = {
  name: Scalars['String'];
  title: Scalars['String'];
  description: Scalars['String'];
  type: TemplateFragmentType;
  nestedContentAllowed: Scalars['Boolean'];
};

export type CreateTemplateFragmentPayload = {
  __typename: 'CreateTemplateFragmentPayload';
  fragment?: Maybe<CommTemplateFragment>;
  errors?: Maybe<Array<Scalars['String']>>;
};

export type CreateTemplateInput = {
  title: Scalars['String'];
  typeId: Scalars['CommTemplateTypeId'];
  locale?: Maybe<Scalars['String']>;
  categoryId?: Maybe<Scalars['CategoryId']>;
  categoryType?: Maybe<CategoryType>;
  experimentKey?: Maybe<Scalars['String']>;
  treatments?: Maybe<Array<Scalars['String']>>;
  tagSyntax?: Maybe<TemplateTagSyntax>;
};

export type CreateTemplatePayload = {
  __typename: 'CreateTemplatePayload';
  multiLocaleTemplate?: Maybe<MultiLocaleTemplateSet>;
  errors?: Maybe<Array<Scalars['String']>>;
};

export type CreateTemplateTypeInput = {
  triggerId: Scalars['TriggerId'];
  nodeId: Scalars['TriggerNodeId'];
  parameterName: Scalars['String'];
  group: TemplateTypeGroup;
  unsubscribeTag?: Maybe<MessageUnsubscribeTag>;
  notificationType?: Maybe<NotificationType>;
  displayName: Scalars['String'];
  description: Scalars['String'];
  richCardType?: Maybe<MessageRichCardType>;
  richCardDataModel?: Maybe<MessageRichCardDataModelInput>;
  optionalChannelSupported?: Maybe<Scalars['Boolean']>;
  requiredChannels?: Maybe<Array<ChannelType>>;
  dataModel: TemplateDataModelInput;
  frequencyCaps: Array<TemplateMessageFrequencyCapRuleInput>;
};

export type CreateTemplateTypePayload = {
  __typename: 'CreateTemplateTypePayload';
  error?: Maybe<Scalars['String']>;
  trigger?: Maybe<Trigger>;
  templateType?: Maybe<CommTemplateType>;
};

export type CreateTicketByExpertInput = {
  ticketType: TicketType;
  leadId: Scalars['LeadId'];
  description: Scalars['String'];
  orderId: Scalars['OrderId'];
  orderLineItemIdList: Array<Scalars['OrderLineItemId']>;
  orderRefundReason?: Maybe<OrderRefundReason>;
  userId: Scalars['UserId'];
};

export type CreateTicketInput = {
  ticketType: TicketType;
  description: Scalars['String'];
  workflowType: WorkflowType;
  ticketRequestChannel: TicketRequestChannel;
  ticketQueue?: Maybe<TicketQueue>;
  orderId: Scalars['OrderId'];
  orderLineItemIdList: Array<Scalars['OrderLineItemId']>;
  orderRefundReason?: Maybe<OrderRefundReason>;
  userId: Scalars['UserId'];
  assignedToId?: Maybe<Scalars['OperatorId']>;
  escalationItemInfos: Array<EscalationItemInfoInput>;
  dueAt?: Maybe<Scalars['Date']>;
  blockingTicketId?: Maybe<Scalars['TicketId']>;
  ticketActionType?: Maybe<TicketActionType>;
  ticketActionReason?: Maybe<TicketActionReason>;
};

export type CreateTriggerInput = {
  name: Scalars['String'];
  groupName: Scalars['String'];
  description: Scalars['String'];
  eventName: Scalars['String'];
};

export type CreateTriggerJumpToInput = {
  triggerId: Scalars['TriggerId'];
  nodeId: Scalars['TriggerNodeId'];
  title: Scalars['String'];
};

export type CreateTriggerNodeInput = {
  triggerId: Scalars['TriggerId'];
  type: TriggerNodeType;
  /** if null, the node will be insert as the first element */
  insertAfter?: Maybe<Scalars['TriggerNodeId']>;
  insertAsEdgeType: TriggerNodeEdgeType;
  actionName?: Maybe<Scalars['String']>;
};

export type CreateTriggerPayload = {
  __typename: 'CreateTriggerPayload';
  trigger: Trigger;
};

export type CreateUserInput = {
  firstName?: Maybe<Scalars['String']>;
  lastName?: Maybe<Scalars['String']>;
  phone?: Maybe<Scalars['String']>;
  email?: Maybe<Scalars['String']>;
  password?: Maybe<Scalars['String']>;
  roles?: Maybe<Array<Maybe<Scalars['String']>>>;
};

export type CreateUserPayload = {
  __typename: 'CreateUserPayload';
  user?: Maybe<User>;
  errorCode?: Maybe<UserEditErrorCode>;
  hasError: Scalars['Boolean'];
  errors: Array<Scalars['String']>;
};

export type CreateVoiceTokenInput = {
  messagingUserId: Scalars['AnyId'];
};

export type CreateVoiceTokenPayload = {
  __typename: 'CreateVoiceTokenPayload';
  token: Scalars['String'];
};

export type CurationStats = {
  __typename: 'CurationStats';
  curationCount: Scalars['Long'];
  curationCountInLastSevenDays: Scalars['Long'];
};

export type CurationSummary = {
  __typename: 'CurationSummary';
  lastOfferSentAt?: Maybe<Scalars['Date']>;
  lastCuratedOrderSentAt?: Maybe<Scalars['Date']>;
  lastCuratedItemSentAt?: Maybe<Scalars['Date']>;
  lastOrderCompletedAt?: Maybe<Scalars['Date']>;
  lastCurationSentAt?: Maybe<Scalars['Date']>;
  lastSystemCuratedItemSentAt?: Maybe<Scalars['Date']>;
};


export type CustomDisplayNameTooLongExpertCuratedItemProsAndConsEditError = ErrorMessage & {
  __typename: 'CustomDisplayNameTooLongExpertCuratedItemProsAndConsEditError';
  errorMessage: Scalars['String'];
  proCon: IndividualSellableCustomProCon;
};

export type CustomDisplayNameTooShortExpertCuratedItemProsAndConsEditError = ErrorMessage & {
  __typename: 'CustomDisplayNameTooShortExpertCuratedItemProsAndConsEditError';
  errorMessage: Scalars['String'];
  proCon: IndividualSellableCustomProCon;
};

export type CustomerRequestExpertCuratedOrderInput = {
  id: Scalars['ExpertCuratedOrderId'];
};

export type CustomerRequestExpertCuratedOrderPayload = {
  __typename: 'CustomerRequestExpertCuratedOrderPayload';
  expertCuratedOrder: ExpertCuratedOrder;
};


/** ====== DatePathFlowQuestion */
export type DatePathFlowQuestion = PathFlowQuestion & {
  __typename: 'DatePathFlowQuestion';
  internalName: Scalars['String'];
  questionText?: Maybe<TextViewModel>;
  questionSubText?: Maybe<TextViewModel>;
  required: Scalars['Boolean'];
  inputIconImage?: Maybe<ImageViewModel>;
  inputLabel?: Maybe<TextViewModel>;
  attributes: Array<Attribute>;
  attribute?: Maybe<Attribute>;
  type: DatePathFlowQuestionType;
  /** If reloading a question answered by the user, this is their previous input */
  dateUserInput: SubmitDatePathFlowQuestionInputTypeCopy;
};


/** ====== DatePathFlowQuestion */
export type DatePathFlowQuestionAttributeArgs = {
  attributeName?: Maybe<Scalars['String']>;
};

export enum DatePathFlowQuestionType {
  DATE = 'DATE',
  DATE_TIME = 'DATE_TIME'
}

export type DatePathQuestionSchema = PathQuestionSchema & {
  __typename: 'DatePathQuestionSchema';
  id: Scalars['PathQuestionSchemaId'];
  schemaType: PathQuestionSchemaType;
  commonFields: PathCommonQuestionSchemaFields;
  attributeSchemaName?: Maybe<Scalars['String']>;
  attributeSchemaRevision?: Maybe<AttributeSchemaRevision>;
};

export type DatePathQuestionSchemaUpsertEditorCommandInput = {
  id?: Maybe<Scalars['PathQuestionSchemaId']>;
  attributeSchemaName?: Maybe<Scalars['String']>;
};

export type DateQuestionPathNodeFlowInputCommandInput = {
  questionId: Scalars['PathQuestionSchemaId'];
  value?: Maybe<Scalars['LocalDate']>;
};

export type DateQuestionPathNodeFlowViewModel = QuestionPathNodeFlowViewModel & {
  __typename: 'DateQuestionPathNodeFlowViewModel';
  id: Scalars['PathQuestionSchemaId'];
  schemaType: PathQuestionSchemaType;
  commonFields: CommonFieldsQuestionPathNodeFlowViewModel;
  dateValue?: Maybe<Scalars['LocalDate']>;
};

export type DateRange = {
  __typename: 'DateRange';
  from?: Maybe<Scalars['Date']>;
  includeFrom?: Maybe<Scalars['Boolean']>;
  to?: Maybe<Scalars['Date']>;
  includeTo?: Maybe<Scalars['Boolean']>;
};

export type DateRangeFilter = {
  __typename: 'DateRangeFilter';
  /** the filter will be ignored if both minDateTime and maxDateTime are null */
  field: DateRangeFilterField;
  displayName: Scalars['String'];
  negativeFilter: Scalars['Boolean'];
  minDateTime?: Maybe<Scalars['Date']>;
  maxDateTime?: Maybe<Scalars['Date']>;
};

export enum DateRangeFilterField {
  LAST_PAID_DATE = 'LAST_PAID_DATE',
  CREATED_DATE = 'CREATED_DATE',
  LAST_CURATION_DATE = 'LAST_CURATION_DATE',
  LAST_ACTIVITY_DATE = 'LAST_ACTIVITY_DATE',
  ORDER_PAID_DATE = 'ORDER_PAID_DATE',
  STARTED_DATE = 'STARTED_DATE',
  COMPLETED_DATE = 'COMPLETED_DATE',
  DUE_DATE = 'DUE_DATE',
  LAST_MARKETING_EMAIL_SENT_DATE = 'LAST_MARKETING_EMAIL_SENT_DATE',
  LAST_MARKETING_TEXT_SENT_DATE = 'LAST_MARKETING_TEXT_SENT_DATE',
  LAST_MARKETING_CHAT_SENT_DATE = 'LAST_MARKETING_CHAT_SENT_DATE',
  LAST_MARKETING_EMAIL_OPENED_DATE = 'LAST_MARKETING_EMAIL_OPENED_DATE',
  LAST_MARKETING_EMAIL_CLICKED_DATE = 'LAST_MARKETING_EMAIL_CLICKED_DATE',
  LAST_MARKETING_TEXT_CLICKED_DATE = 'LAST_MARKETING_TEXT_CLICKED_DATE',
  LAST_MARKETING_CHAT_CLICKED_DATE = 'LAST_MARKETING_CHAT_CLICKED_DATE',
  LAST_MARKETING_EMAIL_RESPONDED_DATE = 'LAST_MARKETING_EMAIL_RESPONDED_DATE',
  LAST_MARKETING_TEXT_RESPONDED_DATE = 'LAST_MARKETING_TEXT_RESPONDED_DATE',
  LAST_MARKETING_CHAT_RESPONDED_DATE = 'LAST_MARKETING_CHAT_RESPONDED_DATE',
  LAST_MARKETING_ENGAGED_DATE = 'LAST_MARKETING_ENGAGED_DATE'
}

export type DateRangeFilterInput = {
  minDateTime?: Maybe<Scalars['Date']>;
  maxDateTime?: Maybe<Scalars['Date']>;
  negativeFilter: Scalars['Boolean'];
  field: DateRangeFilterField;
};

export type DateRangeInput = {
  from?: Maybe<Scalars['Date']>;
  includeFrom?: Maybe<Scalars['Boolean']>;
  to?: Maybe<Scalars['Date']>;
  includeTo?: Maybe<Scalars['Boolean']>;
};

/** ====== DateRangePathFlowQuestion */
export type DateRangePathFlowQuestion = PathFlowQuestion & {
  __typename: 'DateRangePathFlowQuestion';
  internalName: Scalars['String'];
  questionText?: Maybe<TextViewModel>;
  questionSubText?: Maybe<TextViewModel>;
  required: Scalars['Boolean'];
  startRequired: Scalars['Boolean'];
  endRequired: Scalars['Boolean'];
  inputIconImage?: Maybe<ImageViewModel>;
  inputLabel?: Maybe<TextViewModel>;
  attributes: Array<Attribute>;
  attribute?: Maybe<Attribute>;
  type: DateRangePathFlowQuestionType;
  /** If reloading a question answered by the user, this is their previous input */
  dateRangeUserInput: SubmitDateRangePathFlowQuestionInputTypeCopy;
};


/** ====== DateRangePathFlowQuestion */
export type DateRangePathFlowQuestionAttributeArgs = {
  attributeName?: Maybe<Scalars['String']>;
};

export enum DateRangePathFlowQuestionType {
  DATE = 'DATE',
  DATE_TIME = 'DATE_TIME'
}

export enum DayOfWeek {
  MONDAY = 'MONDAY',
  TUESDAY = 'TUESDAY',
  WEDNESDAY = 'WEDNESDAY',
  THURSDAY = 'THURSDAY',
  FRIDAY = 'FRIDAY',
  SATURDAY = 'SATURDAY',
  SUNDAY = 'SUNDAY'
}

export type DeactivateExpertCuratedItemNoteInput = {
  id: Scalars['ExpertCuratedItemNoteId'];
  changedById: Scalars['BusinessUserId'];
};

export type DeactivateExpertCuratedItemNotePayload = {
  __typename: 'DeactivateExpertCuratedItemNotePayload';
  expertCuratedItemNote?: Maybe<ExpertCuratedItemNote>;
  hasError: Scalars['Boolean'];
  errorMessage?: Maybe<Scalars['String']>;
};

export type DeactivateExpertInput = {
  id: Scalars['BusinessUserId'];
};

export type DeactivateExpertPayload = {
  __typename: 'DeactivateExpertPayload';
  error?: Maybe<Scalars['String']>;
  businessUser: BusinessUser;
};

export type DeactivateGuestConversationSequenceInput = {
  id: Scalars['GuestConversationSequenceId'];
};

export type DeactivateGuestConversationSequencePayload = {
  __typename: 'DeactivateGuestConversationSequencePayload';
  sequence: GuestConversationSequence;
};

export type DeactivateSellableInput = {
  id: Scalars['SellableId'];
  /** If all of the linked variations of the sellable should also be deactivated. Defaults to false. */
  variationHierarchy?: Maybe<Scalars['Boolean']>;
};

export type DeactivateSellablePayload = {
  __typename: 'DeactivateSellablePayload';
  updatedSellableCount: Scalars['Int'];
};

export type DeactivateSellablePriceSourceInput = {
  id: Scalars['SellablePriceSourceId'];
};

export type DeactivateSellablePriceSourcePayload = {
  __typename: 'DeactivateSellablePriceSourcePayload';
  sellablePriceSource: SellablePriceSource;
};

export type DeactivateTemplateFragmentInput = {
  id: Scalars['CommTemplateFragmentId'];
  notes?: Maybe<Scalars['String']>;
};

export type DeactivateTemplateInput = {
  id: Scalars['CommTemplateId'];
  notes?: Maybe<Scalars['String']>;
};

export type DeactivateTriggerInput = {
  triggerId: Scalars['TriggerId'];
  notes?: Maybe<Scalars['String']>;
};

export type DeactivateTriggerPayload = {
  __typename: 'DeactivateTriggerPayload';
  trigger: Trigger;
};

export type Deal = {
  __typename: 'Deal';
  id: Scalars['DealId'];
  category: Category;
  title: Scalars['String'];
  description?: Maybe<Scalars['String']>;
  expiresAt?: Maybe<Scalars['Date']>;
  price: Money;
  originalPrice?: Maybe<Money>;
  originalPriceSource?: Maybe<Scalars['String']>;
  freeAddOns: Array<DealAddOn>;
  images: Array<MediaFile>;
  videos: Array<MediaFile>;
  terms: DealTerms;
  comments?: Maybe<Scalars['String']>;
  brand?: Maybe<Brand>;
  createdBy: DealCreatedByUnion;
  discount?: Maybe<Scalars['Float']>;
  interestedByViewer?: Maybe<Scalars['Boolean']>;
  state: DealState;
  sellable?: Maybe<Sellable>;
};

export type DealAddOn = {
  __typename: 'DealAddOn';
  title: Scalars['String'];
  retailPrice: Money;
};

export type DealCreatedByUnion = Operator | Merchant;


export type DealInventoryClaimedActivity = OrderActivityDetail & {
  __typename: 'DealInventoryClaimedActivity';
  type: OrderActivityDetailType;
  merchant: Merchant;
  fulfilledBy: Operator;
  fulfillmentOrder: FulfillmentOrder;
};

export type DealInventoryFulfillmentOrderCanceledActivity = OrderActivityDetail & {
  __typename: 'DealInventoryFulfillmentOrderCanceledActivity';
  type: OrderActivityDetailType;
  /** operator if known */
  canceledBy?: Maybe<Operator>;
  canceledAt: Scalars['Date'];
  fulfillmentOrder: FulfillmentOrder;
};

export type DealInventoryRawSellableSource = RawSellableSource & {
  __typename: 'DealInventoryRawSellableSource';
  id: Scalars['RawSellableSourceId'];
  name: Scalars['String'];
  merchantName: Scalars['String'];
  type: RawSellableSourceType;
  fulfillmentChannel?: Maybe<FulfillmentChannel>;
  filter?: Maybe<RawSellableStandardizationRuleCondition>;
  state: RawSellableSourceState;
};

export type DealInventoryRequestCanceledActivity = OrderActivityDetail & {
  __typename: 'DealInventoryRequestCanceledActivity';
  type: OrderActivityDetailType;
  canceledBy: Operator;
};

export type DealInventoryRequestedActivity = OrderActivityDetail & {
  __typename: 'DealInventoryRequestedActivity';
  type: OrderActivityDetailType;
  fulfillmentCenter: FulfillmentCenter;
  merchant: Merchant;
  fulfilledBy: Operator;
  quantity?: Maybe<Scalars['Int']>;
  fulfillmentShipmentMethod?: Maybe<FulfillmentShipmentMethod>;
  sourceType: FulfillmentOrderSourceType;
};

export type DealInventoryRequestFailedActivity = OrderActivityDetail & {
  __typename: 'DealInventoryRequestFailedActivity';
  type: OrderActivityDetailType;
  merchant: Merchant;
  fulfilledBy: Operator;
  fulfillmentOrder?: Maybe<FulfillmentOrder>;
  failureCode?: Maybe<Scalars['String']>;
  failureReason?: Maybe<Scalars['String']>;
};

export type DealInventorySellablePriceSource = SellablePriceSource & {
  __typename: 'DealInventorySellablePriceSource';
  id: Scalars['SellablePriceSourceId'];
  type: SellablePriceSourceType;
  sellable: Sellable;
  price?: Maybe<MonetaryAmount>;
  bestOfferPrice?: Maybe<MonetaryAmount>;
  cost?: Maybe<MonetaryAmount>;
  expiresAt?: Maybe<Scalars['Date']>;
  fulfillmentChannel?: Maybe<FulfillmentChannel>;
  canRefresh: Scalars['Boolean'];
  willRefresh: Scalars['Boolean'];
  rawSellableSource: RawSellableSource;
  sellableInventoryItem: SellableInventoryItem;
  estimatedAvailableAt?: Maybe<Scalars['Date']>;
};

export type DealPaymentAccount = PaymentProcessorAccount & {
  __typename: 'DealPaymentAccount';
  id: Scalars['PaymentProcessorAccountId'];
  createdAt: Scalars['Date'];
  updatedAt: Scalars['Date'];
  type: PaymentProcessorType;
  userId: Scalars['UserId'];
  paymentSources: Array<PaymentSource>;
};

export type DealPaymentSource = PaymentSource & {
  __typename: 'DealPaymentSource';
  id: Scalars['PaymentSourceId'];
  createdAt: Scalars['Date'];
  updatedAt: Scalars['Date'];
  externalSourceId: Scalars['String'];
  type: PaymentProcessorType;
  usage: PaymentSourceUsage;
  status: PaymentSourceStatus;
  userId: Scalars['UserId'];
  billingAddress?: Maybe<Address>;
  paymentEntity: PaymentEntity;
  isDefault: Scalars['Boolean'];
};

export type DealRequest = {
  __typename: 'DealRequest';
  id: Scalars['DealRequestId'];
  createdAt: Scalars['Date'];
  requester: User;
  createdBy: User;
  updatedAt: Scalars['Date'];
  isActive: Scalars['Boolean'];
  /** @deprecated Superseded by the `attributes` field */
  formattedAttributes: Array<FormattedAttribute>;
  attributes: Array<Attribute>;
  inlineFormattedAttributes: Scalars['String'];
  category?: Maybe<Category>;
  zipCode?: Maybe<Scalars['String']>;
  city?: Maybe<Scalars['String']>;
  state?: Maybe<Scalars['String']>;
  followUpPathFlow?: Maybe<PathFlow>;
  /** Sellables that were viewed by the user that resulted in this deal request being created */
  viewedSellables: Array<Sellable>;
};

export type DealRequestFilter = {
  requesterId: Scalars['UserId'];
};


export type DealSellablePriceSource = SellablePriceSource & {
  __typename: 'DealSellablePriceSource';
  id: Scalars['SellablePriceSourceId'];
  type: SellablePriceSourceType;
  sellable: Sellable;
  price?: Maybe<MonetaryAmount>;
  bestOfferPrice?: Maybe<MonetaryAmount>;
  cost?: Maybe<MonetaryAmount>;
  expiresAt?: Maybe<Scalars['Date']>;
  fulfillmentChannel?: Maybe<FulfillmentChannel>;
  canRefresh: Scalars['Boolean'];
  willRefresh: Scalars['Boolean'];
  estimatedAvailableAt?: Maybe<Scalars['Date']>;
};

export enum DealState {
  ACTIVE = 'ACTIVE',
  INACTIVE = 'INACTIVE'
}

export type DealTemplateInput = {
  dealId: Scalars['DealId'];
  /**
   * If this Offer is created by re-using an existing Deal Template and has
   * updates, whether to propogae them to existnig Deals.
   */
  updateExistingDeal?: Maybe<Scalars['Boolean']>;
};

export type DealTerms = ProductDealTerms | ServiceDealTerms | EmptyDealTerms;

export enum DealTermsType {
  PRODUCT = 'PRODUCT',
  SERVICE = 'SERVICE'
}

export type DealUploadTaskPayload = {
  __typename: 'DealUploadTaskPayload';
  numRowsProcessed: Scalars['Int'];
  numDealsCreated: Scalars['Int'];
  numDealsUpdated: Scalars['Int'];
  numRowsIgnored: Scalars['Int'];
  googleSpreadsheetId: Scalars['String'];
};

export type DecimalEntryGenericNumericRenderingStylePathQuestionPathNodeFlowViewModel = {
  __typename: 'DecimalEntryGenericNumericRenderingStylePathQuestionPathNodeFlowViewModel';
  /**
   * If specified, the scale the internal value is limited to. This means, for example, if set to 2, that at most 2
   * decimal points is supported (e.g.: 100.25). As such, this should be used to limit the amount of numbers after the
   * decimal point that's accepted from the user.
   */
  limitToScale?: Maybe<Scalars['Int']>;
};

export type DeclineVideoChatInput = {
  messagingUserId: Scalars['AnyId'];
  externalConversationId: Scalars['String'];
};

export type DeclineVideoChatPayload = {
  __typename: 'DeclineVideoChatPayload';
  success: Scalars['Boolean'];
};

export type DecoratedRecommendedListConnection = {
  __typename: 'DecoratedRecommendedListConnection';
  edges: Array<RecommendedListEdge>;
  facets: Array<RecommendedListDisplayFacet>;
  pageInfo: PageInfo;
};

export type DefaultErrorMessage = ErrorMessage & {
  __typename: 'DefaultErrorMessage';
  errorMessage: Scalars['String'];
};

export type DefaultPathNodeEditorViewModel = PathNodeEditorViewModel & {
  __typename: 'DefaultPathNodeEditorViewModel';
  title?: Maybe<PathEditorRichText>;
  body?: Maybe<PathEditorRichText>;
  expandedTitle?: Maybe<PathEditorRichText>;
  isRequired?: Maybe<Scalars['Boolean']>;
};

export type DefaultQuestionPathNodeFlowViewModelValidationError = ErrorMessage & {
  __typename: 'DefaultQuestionPathNodeFlowViewModelValidationError';
  errorMessage: Scalars['String'];
};

export type DelegateExpertChangedActivity = LeadActivity & {
  __typename: 'DelegateExpertChangedActivity';
  id: Scalars['LeadActivityId'];
  type: LeadActivityType;
  lead: Lead;
  occurredAt: Scalars['Date'];
  previousDelegateExpert?: Maybe<BusinessUser>;
  currentDelegateExpert?: Maybe<BusinessUser>;
  performedBy: Identity;
};

export type DelegateLeadInput = {
  leadId: Scalars['LeadId'];
  /** When the delegate expert ID is not specified, it means undelegate */
  delegateExpertId?: Maybe<Scalars['BusinessUserId']>;
};

export type DelegateLeadSupportTaskActivity = SupportTaskActivity & {
  __typename: 'DelegateLeadSupportTaskActivity';
  id: Scalars['SupportTaskActivityId'];
  supportTask: SupportTask;
  action: SupportTaskAction;
  actor: SupportTaskActor;
  consumer: User;
  lead?: Maybe<Lead>;
  occurredAt: Scalars['Date'];
  delegatedTo: BusinessUser;
};

export type DeleteAddressInput = {
  addressId: Scalars['AddressId'];
  userId: Scalars['UserId'];
};

export type DeleteAddressPayload = {
  __typename: 'DeleteAddressPayload';
  success?: Maybe<Scalars['Boolean']>;
  error?: Maybe<Scalars['String']>;
};

export type DeleteDraftAttributeSchemaRevisionInput = {
  id: Scalars['AttributeSchemaRevisionId'];
};

export type DeleteDraftAttributeSchemaRevisionPayload = AttributeSchemaRevisionPayload & {
  __typename: 'DeleteDraftAttributeSchemaRevisionPayload';
  hasError: Scalars['Boolean'];
  errorMessage?: Maybe<Scalars['String']>;
  attributeSchemaRevision?: Maybe<AttributeSchemaRevision>;
};

export type DeleteExpertCuratedLeadItineraryInput = {
  id: Scalars['LeadId'];
};

export type DeleteExpertCuratedLeadItineraryPayload = {
  __typename: 'DeleteExpertCuratedLeadItineraryPayload';
  /** If true, the item was successfully deleted. If false, it means there there was no item to delete. */
  deleted: Scalars['Boolean'];
};

export type DeletePaymentSourcePayload = {
  __typename: 'DeletePaymentSourcePayload';
  success?: Maybe<Scalars['Boolean']>;
  error?: Maybe<Scalars['String']>;
};

export type DeleteProposedShiftsInput = {
  sourceRangeStart: Scalars['Date'];
  sourceRangeEnd: Scalars['Date'];
  schedulingTypeId: Scalars['SchedulingTypeId'];
};

export type DeleteProposedShiftsPayload = {
  __typename: 'DeleteProposedShiftsPayload';
  deletedShiftSlotCount: Scalars['Int'];
};

export type DeleteRecommendedListDefinitionIdPayload = {
  __typename: 'DeleteRecommendedListDefinitionIdPayload';
  success: Scalars['Boolean'];
};

export type DeleteSavedExpertCuratedItemsPayload = {
  __typename: 'DeleteSavedExpertCuratedItemsPayload';
  data?: Maybe<SavedExpertCuratedItems>;
  error?: Maybe<Scalars['String']>;
  hasError: Scalars['Boolean'];
};

export type DeleteSellableResearchLinkInput = {
  id: Scalars['SellableResearchLinkId'];
};

export type DeleteSellableResearchLinkPayload = {
  __typename: 'DeleteSellableResearchLinkPayload';
  success: Scalars['Boolean'];
};

export type Department = {
  __typename: 'Department';
  id: Scalars['DepartmentId'];
  slug: Scalars['String'];
  type: DepartmentType;
  displayName: Scalars['String'];
  topLevelCategories: Array<Category>;
  topLevelCategory: Category;
  acceptingRequests: Scalars['Boolean'];
  launched: Scalars['Boolean'];
  test: Scalars['Boolean'];
  /**
   * Get sellable search facets associated with this department.
   * By default only brands of the all categories including children are returned as facets.
   * Additionally, it excludes out of stock sellables when building the facets.
   */
  sellableSearchFacets: Array<DisplayFacetSelection>;
  mostRecentLeadForConsumer?: Maybe<Lead>;
  /** Currently the only supported versions are 'v1' and 'v2' while we test implementations */
  navigation: DepartmentNavigation;
  navigations: Array<DepartmentNavigation>;
  flatNavigation: DepartmentFlatNavigation;
  expertTeams: Array<BusinessUserTeam>;
  expertSpecialtyCategories: Array<Category>;
  emailCuratedBannerUrl: Scalars['String'];
  emailCuratedLogoUrl: Scalars['String'];
  consumerUrl: Scalars['String'];
  placeholderExpert: BusinessUser;
  /** The URL to start a path from a given department */
  pathUrl: Scalars['String'];
  departmentStats: DepartmentStats;
  relatedArticles: Array<ArticleRevision>;
  consumerExpertReviewConnection: ConsumerExpertReviewConnection;
  reviewSummary: ReviewSummary;
  sellableTopLists: Array<SellableTopList>;
};


export type DepartmentSellableSearchFacetsArgs = {
  query: CategorySellableSearchFacetQuery;
};


export type DepartmentMostRecentLeadForConsumerArgs = {
  hasRequest?: Maybe<Scalars['Boolean']>;
};


export type DepartmentNavigationArgs = {
  version?: Maybe<Scalars['String']>;
  categorySlug?: Maybe<Scalars['String']>;
};


export type DepartmentNavigationsArgs = {
  version?: Maybe<Scalars['String']>;
};


export type DepartmentFlatNavigationArgs = {
  categorySlug?: Maybe<Scalars['String']>;
};


export type DepartmentRelatedArticlesArgs = {
  limit?: Maybe<Scalars['Int']>;
};


export type DepartmentConsumerExpertReviewConnectionArgs = {
  filter: ConsumerExpertReviewFilter;
  after?: Maybe<Scalars['String']>;
  first?: Maybe<Scalars['Int']>;
  before?: Maybe<Scalars['String']>;
  last?: Maybe<Scalars['Int']>;
};


export type DepartmentSellableTopListsArgs = {
  limit?: Maybe<Scalars['Int']>;
};

export type DepartmentFlatNavigation = {
  __typename: 'DepartmentFlatNavigation';
  items: Array<DepartmentFlatNavigationItem>;
};

export type DepartmentFlatNavigationItem = {
  __typename: 'DepartmentFlatNavigationItem';
  id: Scalars['String'];
  label: Scalars['String'];
  imagePath?: Maybe<Scalars['String']>;
  link?: Maybe<DepartmentNavigationLink>;
};


export type DepartmentNavigation = {
  __typename: 'DepartmentNavigation';
  /** Top most level items shown, usually displayed inline on the page */
  topLevelItems: Array<DepartmentNavigationTopLevelItem>;
  /**
   * category if this navigation is for a sub category of a department. for
   * example, skiing and snowboarding under winter-sports.
   */
  category?: Maybe<Category>;
};

export type DepartmentNavigationCategoryLink = {
  __typename: 'DepartmentNavigationCategoryLink';
  category: Category;
};

export type DepartmentNavigationCreatePathLink = {
  __typename: 'DepartmentNavigationCreatePathLink';
  pathSlug: Scalars['String'];
};

export type DepartmentNavigationDealsLink = {
  __typename: 'DepartmentNavigationDealsLink';
  category: Category;
};

export type DepartmentNavigationDepartmentLink = {
  __typename: 'DepartmentNavigationDepartmentLink';
  department: Department;
};

export type DepartmentNavigationExpertCommunityLink = {
  __typename: 'DepartmentNavigationExpertCommunityLink';
  departmentSlug: Scalars['String'];
};

export type DepartmentNavigationExpertSubSection = DepartmentNavigationSubSection & DepartmentNavigationResponsiveMixin & {
  __typename: 'DepartmentNavigationExpertSubSection';
  id: Scalars['String'];
  title: Scalars['String'];
  categoryId: Scalars['CategoryId'];
  titleLink?: Maybe<DepartmentNavigationLink>;
  showIfFullSize: Scalars['Boolean'];
  showIfSmallSize: Scalars['Boolean'];
  smallSizeOptions: Array<DepartmentNavigationResponsiveSmallSizeOptions>;
  fullSizeOptions: Array<DepartmentNavigationResponsiveFullSizeOptions>;
  /** Find a recommended expert for this category */
  expertCategoryId: Scalars['CategoryId'];
};

export enum DepartmentNavigationLabelStyle {
  BOLD = 'BOLD'
}

export type DepartmentNavigationLink = DepartmentNavigationDealsLink | DepartmentNavigationCategoryLink | DepartmentNavigationSearchLink | DepartmentNavigationCreatePathLink | DepartmentNavigationExpertCommunityLink | DepartmentNavigationDepartmentLink;

export type DepartmentNavigationListSubSection = DepartmentNavigationSubSection & DepartmentNavigationResponsiveMixin & {
  __typename: 'DepartmentNavigationListSubSection';
  id: Scalars['String'];
  title: Scalars['String'];
  categoryId: Scalars['CategoryId'];
  titleLink?: Maybe<DepartmentNavigationLink>;
  showIfFullSize: Scalars['Boolean'];
  showIfSmallSize: Scalars['Boolean'];
  smallSizeOptions: Array<DepartmentNavigationResponsiveSmallSizeOptions>;
  fullSizeOptions: Array<DepartmentNavigationResponsiveFullSizeOptions>;
  items: Array<DepartmentNavigationListSubSectionItem>;
};

export type DepartmentNavigationListSubSectionItem = {
  __typename: 'DepartmentNavigationListSubSectionItem';
  id: Scalars['String'];
  label: Scalars['String'];
  imagePath?: Maybe<Scalars['String']>;
  imageUrl?: Maybe<Scalars['String']>;
  link: DepartmentNavigationLink;
  labelStyles: Array<DepartmentNavigationLabelStyle>;
};

export enum DepartmentNavigationResponsiveFullSizeOptions {
  SHOW = 'SHOW'
}

export type DepartmentNavigationResponsiveMixin = {
  /** Options for showing this element for smaller screens (e.g.: mobile) */
  smallSizeOptions: Array<DepartmentNavigationResponsiveSmallSizeOptions>;
  /** Options for showing this element for full sized screens (e.g.: desktop) */
  fullSizeOptions: Array<DepartmentNavigationResponsiveFullSizeOptions>;
  /** If this element should be shown for smaller screens (e.g.: mobile) */
  showIfSmallSize: Scalars['Boolean'];
  /** If this element should be shown for full sized screens (e.g.: desktop) */
  showIfFullSize: Scalars['Boolean'];
};

export enum DepartmentNavigationResponsiveSmallSizeOptions {
  /** Show element in persistent element attached to the chrome. */
  SHOW_IN_PERSISTENT_HEADER = 'SHOW_IN_PERSISTENT_HEADER',
  /** Show element in flyout panel that expands from the side of the page */
  SHOW_IN_FLYOUT_PANEL = 'SHOW_IN_FLYOUT_PANEL'
}

export type DepartmentNavigationSearchLink = {
  __typename: 'DepartmentNavigationSearchLink';
  category: Category;
  facets: Array<FacetSelectionPayload>;
};

export type DepartmentNavigationSubSection = {
  id: Scalars['String'];
  title: Scalars['String'];
  categoryId: Scalars['CategoryId'];
  titleLink?: Maybe<DepartmentNavigationLink>;
};

export type DepartmentNavigationTopLevelItem = DepartmentNavigationResponsiveMixin & {
  __typename: 'DepartmentNavigationTopLevelItem';
  id: Scalars['String'];
  showIfFullSize: Scalars['Boolean'];
  showIfSmallSize: Scalars['Boolean'];
  smallSizeOptions: Array<DepartmentNavigationResponsiveSmallSizeOptions>;
  fullSizeOptions: Array<DepartmentNavigationResponsiveFullSizeOptions>;
  label: Scalars['String'];
  labelLink?: Maybe<DepartmentNavigationLink>;
  imagePath?: Maybe<Scalars['String']>;
  imageUrl?: Maybe<Scalars['String']>;
  subSections: Array<DepartmentNavigationSubSection>;
};

export type DepartmentStats = {
  __typename: 'DepartmentStats';
  leadStats: LeadStats;
  curationStats: CurationStats;
};

/**
 * Best effort enumeration of available departments for easy type safe comparisons.
 * There is no guarantee all departments will have a department type. The departments that are not assigned an
 * explicit type will be assigned `OTHER`.
 */
export enum DepartmentType {
  CYCLING = 'CYCLING',
  CAMPING = 'CAMPING',
  CURATED_INTERNAL = 'CURATED_INTERNAL',
  FISHING = 'FISHING',
  GOLF = 'GOLF',
  JEWELRY = 'JEWELRY',
  JET_CHARTERS = 'JET_CHARTERS',
  OTHER = 'OTHER',
  WINTER_SPORTS = 'WINTER_SPORTS',
  YACHT_CHARTERS = 'YACHT_CHARTERS'
}

export type DependencyRequiredApprovalRequestSubmitDraftEditError = ErrorMessage & {
  __typename: 'DependencyRequiredApprovalRequestSubmitDraftEditError';
  errorMessage: Scalars['String'];
  entity?: Maybe<ApprovalRequestEntity>;
};

export type DependencyResolutionFailedApprovalRequestCreationError = ErrorMessage & {
  __typename: 'DependencyResolutionFailedApprovalRequestCreationError';
  errorMessage: Scalars['String'];
  error: ApprovableEntityDependencyResolutionError;
};

export enum DependencyUpdateType {
  BLOCKED_BY = 'BLOCKED_BY',
  UNBLOCKED_BY = 'UNBLOCKED_BY'
}

export type DeprecateAttributeSchemaRevisionInput = {
  id: Scalars['AttributeSchemaRevisionId'];
  replacedBySchemaId?: Maybe<Scalars['AttributeSchemaId']>;
  reasonMessage?: Maybe<Scalars['String']>;
};

export type DeprecateAttributeSchemaRevisionPayload = AttributeSchemaRevisionPayload & {
  __typename: 'DeprecateAttributeSchemaRevisionPayload';
  hasError: Scalars['Boolean'];
  errorMessage?: Maybe<Scalars['String']>;
  attributeSchemaRevision?: Maybe<AttributeSchemaRevision>;
};

export type DevTools = {
  __typename: 'DevTools';
  idEncodeToExternal: Scalars['String'];
  idDecodeFromExternal: Scalars['String'];
  decodeId: IdCodecPayload;
  geocoding?: Maybe<GeocodingResponse>;
  frontendTask: FrontendTask;
  messageSummary: Array<Maybe<MessageSummary>>;
};


export type DevToolsIdEncodeToExternalArgs = {
  urn: Scalars['String'];
};


export type DevToolsIdDecodeFromExternalArgs = {
  externalId: Scalars['String'];
};


export type DevToolsDecodeIdArgs = {
  id: Scalars['String'];
};


export type DevToolsGeocodingArgs = {
  address: Scalars['String'];
};


export type DevToolsFrontendTaskArgs = {
  id: Scalars['FrontendTaskId'];
};


export type DevToolsMessageSummaryArgs = {
  conversationId: Scalars['ConversationId'];
};

export type DevToolsMutation = {
  __typename: 'DevToolsMutation';
  createDevData: Scalars['Boolean'];
  resetPaymentFailedOffer: BroadcastOffer;
  uploadMerchants: UploadMerchantsPayload;
  uploadSellables: UploadSellablesPayload;
  uploadSellablePrice: UploadSellablePricePayload;
  firePathStartedEvent: Scalars['Boolean'];
  uploadBrands: UploadBrandsPayload;
  createCheckoutStartedEvent: UserActivity;
  createViewSellableEvent: UserActivity;
  createVoiceCallEvent: UserActivity;
  syncFirebaseConversationParticpants: Scalars['Boolean'];
  syncLeadTeam: Lead;
};


export type DevToolsMutationResetPaymentFailedOfferArgs = {
  offerId: Scalars['BroadcastOfferId'];
};


export type DevToolsMutationUploadMerchantsArgs = {
  googleSpreadsheetId: Scalars['String'];
  categorySlug: Scalars['String'];
};


export type DevToolsMutationUploadSellablesArgs = {
  googleSpreadsheetId: Scalars['String'];
  categorySlug: Scalars['String'];
  rows?: Maybe<Scalars['Float']>;
};


export type DevToolsMutationUploadSellablePriceArgs = {
  googleSpreadsheetId: Scalars['String'];
  categorySlug: Scalars['String'];
};


export type DevToolsMutationFirePathStartedEventArgs = {
  pathFlowId: Scalars['PathFlowId'];
  userId: Scalars['UserId'];
};


export type DevToolsMutationUploadBrandsArgs = {
  input: UploadBrandsInput;
};


export type DevToolsMutationCreateCheckoutStartedEventArgs = {
  orderId: Scalars['OrderId'];
  userId: Scalars['UserId'];
};


export type DevToolsMutationCreateViewSellableEventArgs = {
  sellableId: Scalars['SellableId'];
  userId: Scalars['UserId'];
};


export type DevToolsMutationCreateVoiceCallEventArgs = {
  userId: Scalars['UserId'];
  expertId: Scalars['BusinessUserId'];
  userPhoneNumber: Scalars['String'];
  status: Scalars['String'];
  callId: Scalars['String'];
};


export type DevToolsMutationSyncFirebaseConversationParticpantsArgs = {
  leadId: Scalars['LeadId'];
};


export type DevToolsMutationSyncLeadTeamArgs = {
  leadId: Scalars['LeadId'];
};

export type DisablePromotionInput = {
  id: Scalars['PromotionId'];
};

export type DisablePromotionPayload = {
  __typename: 'DisablePromotionPayload';
  promotion: Promotion;
};

export type DismissLeadSuggestedActionInput = {
  leadId: Scalars['LeadId'];
  type: SuggestedActionType;
};

export type DismissOrderMessagesInput = {
  /** If omitted, user context will be assumed and the user's current cart will be operated on */
  id?: Maybe<Scalars['OrderId']>;
};

export type DismissOrderMessagesPayload = {
  __typename: 'DismissOrderMessagesPayload';
  order: Order;
};

export type DismissSuggestedSupportActionInput = {
  conversationId: Scalars['SupportConversationId'];
  action: SuggestedSupportAction;
};

export type DismissSupportTaskActivity = SupportTaskActivity & {
  __typename: 'DismissSupportTaskActivity';
  id: Scalars['SupportTaskActivityId'];
  supportTask: SupportTask;
  action: SupportTaskAction;
  actor: SupportTaskActor;
  consumer: User;
  lead?: Maybe<Lead>;
  occurredAt: Scalars['Date'];
};

export type DisplayFacet = {
  /** Name to display in the UI for this facet */
  displayName: Scalars['String'];
  /** Internal name that should be provided back to FacetSelection.name when selecting facet values */
  name: Scalars['String'];
  /**
   * Alias for this facet if one exist. Aliases provide a semi user friendly name that can be used
   * in the urls for example.
   */
  alias?: Maybe<Scalars['String']>;
};

/**
 * A display facet selection encodes a top level Facet with selection for individual values.
 * This could either be a flattened list of Facet selections or a combination of multiple facets
 * The individual selections encodes all information needed to unique identify a bucket value.
 * Use case: Chrome/Navigation link for Categories and departments.
 */
export type DisplayFacetSelection = {
  __typename: 'DisplayFacetSelection';
  /** internal name */
  name: Scalars['String'];
  /** Display name to use on UI */
  displayName: Scalars['String'];
  /** A list of individual selection that can be directly transformed as input RawFacetSelection for the search */
  selections: Array<FacetSelectionPayload>;
};

export type DraftExistsCreatePathSchemaRevisionError = ErrorMessage & {
  __typename: 'DraftExistsCreatePathSchemaRevisionError';
  errorMessage: Scalars['String'];
  existingDraftRevision: CommonPathSchemaRevision;
};

export type DraftExistsProductCatalogCreateDraftRevisionError = ErrorMessage & {
  __typename: 'DraftExistsProductCatalogCreateDraftRevisionError';
  errorMessage: Scalars['String'];
};

export type DraftExistsProductCatalogGroupCreateDraftRevisionError = ErrorMessage & {
  __typename: 'DraftExistsProductCatalogGroupCreateDraftRevisionError';
  errorMessage: Scalars['String'];
};

export type DryRunInfoPathNodeFlowViewModel = PathNodeFlowViewModel & {
  __typename: 'DryRunInfoPathNodeFlowViewModel';
  id: Scalars['PathNodeId'];
  sections: Array<DryRunInfoSectionPathNodeFlowViewModel>;
};

export type DryRunInfoSectionDetailRowPathNodeFlowViewModel = {
  __typename: 'DryRunInfoSectionDetailRowPathNodeFlowViewModel';
  key: Scalars['String'];
  value: Scalars['String'];
};

export type DryRunInfoSectionPathNodeFlowViewModel = {
  __typename: 'DryRunInfoSectionPathNodeFlowViewModel';
  summaryText: Scalars['String'];
  detailRows: Array<DryRunInfoSectionDetailRowPathNodeFlowViewModel>;
};

export type DryRunRawSellableStandardizationInput = {
  rawSellableIds: Array<Scalars['RawSellableId']>;
  maxPriority?: Maybe<Scalars['Int']>;
};

export type DryRunRawSellableStandardizationPayload = {
  __typename: 'DryRunRawSellableStandardizationPayload';
  results: Array<RawSellableStandardization>;
};

export type DueDateChangedActivity = TicketActivityDetail & {
  __typename: 'DueDateChangedActivity';
  type: TicketActivityType;
  oldDueDate: Scalars['Date'];
  newDueDate: Scalars['Date'];
};

export type Duration = {
  __typename: 'Duration';
  amount: Scalars['Long'];
  unit: DurationUnit;
};

export type DurationInput = {
  amount: Scalars['Long'];
  unit: DurationUnit;
};

export enum DurationUnit {
  NANOS = 'NANOS',
  MILLIS = 'MILLIS',
  SECONDS = 'SECONDS',
  MINUTES = 'MINUTES',
  HOURS = 'HOURS',
  DAYS = 'DAYS'
}

export type EBayItem = {
  __typename: 'EBayItem';
  id: Scalars['String'];
  title: Scalars['String'];
  shortDescription?: Maybe<Scalars['String']>;
  condition?: Maybe<Scalars['String']>;
  imageUrls: Array<Scalars['String']>;
  url: Scalars['String'];
  price: MonetaryAmount;
  specifications: Array<EBayItemSpecification>;
  group?: Maybe<EBayItemGroup>;
  quantity?: Maybe<Scalars['Int']>;
  isNew?: Maybe<Scalars['Boolean']>;
  outOfStock: Scalars['Boolean'];
};

export type EBayItemDimension = {
  __typename: 'EBayItemDimension';
  name: Scalars['String'];
  vectors: Array<EbayItemDimensionVector>;
};

export type EbayItemDimensionVector = {
  __typename: 'EbayItemDimensionVector';
  value: Scalars['String'];
  itemIds: Array<Scalars['String']>;
};

export type EBayItemGroup = {
  __typename: 'EBayItemGroup';
  id: Scalars['String'];
  dimensions: Array<EBayItemDimension>;
  items: Array<EBayItem>;
};

export type EBayItemSearchConnection = {
  __typename: 'EBayItemSearchConnection';
  facets: Array<DisplayFacet>;
  edges: Array<EBayItemSearchEdge>;
  pageInfo: PageInfo;
  count: Scalars['Int'];
};

export type EBayItemSearchEdge = {
  __typename: 'EBayItemSearchEdge';
  node: EBayItem;
  cursor: Scalars['String'];
};

export type EBayItemSearchQuery = {
  facets?: Maybe<Array<FacetSelection>>;
  categoryId?: Maybe<Scalars['CategoryId']>;
  keywords?: Maybe<Scalars['String']>;
  price?: Maybe<MonetaryAmountRangeInput>;
  /**
   * If categoryId and/or keywords are not specified, the sellable's category as well as its title would be
   * used as the categoryId and/or keywords
   */
  sellableId?: Maybe<Scalars['SellableId']>;
};

export type EBayItemSpecification = {
  __typename: 'EBayItemSpecification';
  /** Display name for the specification */
  name: Scalars['String'];
  /** Display text value for the specification */
  value: Scalars['String'];
};

export type EBaySellablePriceSource = SellablePriceSource & {
  __typename: 'EBaySellablePriceSource';
  id: Scalars['SellablePriceSourceId'];
  type: SellablePriceSourceType;
  sellable: Sellable;
  price?: Maybe<MonetaryAmount>;
  bestOfferPrice?: Maybe<MonetaryAmount>;
  cost?: Maybe<MonetaryAmount>;
  expiresAt?: Maybe<Scalars['Date']>;
  fulfillmentChannel?: Maybe<FulfillmentChannel>;
  canRefresh: Scalars['Boolean'];
  willRefresh: Scalars['Boolean'];
  url: Scalars['String'];
  title: Scalars['String'];
  estimatedAvailableAt?: Maybe<Scalars['Date']>;
};

export enum EditableUserSourceType {
  ORGANIC = 'ORGANIC',
  INVESTOR = 'INVESTOR'
}

export type EditorialReview = {
  __typename: 'EditorialReview';
  /** Brand associated with the editorial review site */
  brand: Brand;
  /** URL linking back to the specific review */
  url?: Maybe<Scalars['String']>;
  /** Short snippet extracted from the review to display */
  snippet?: Maybe<Scalars['String']>;
  /** Rating assigned to this review */
  rating?: Maybe<EditorialReviewRating>;
  /** The price the product was when the review was performed */
  testedAtPrice?: Maybe<MonetaryAmount>;
  /** The award the review gave this product/service */
  awardLabel?: Maybe<Scalars['String']>;
};

export type EditorialReviewRating = EditorialReviewRatingFiveStar;

export type EditorialReviewRatingFiveStar = {
  __typename: 'EditorialReviewRatingFiveStar';
  /** Between 0 and 5, inclusive */
  stars: Scalars['Int'];
};

export type EmailTemplate = ChannelTemplate & {
  __typename: 'EmailTemplate';
  channelType: ChannelType;
  subject: Scalars['String'];
  htmlBody: Scalars['String'];
  textBody: Scalars['String'];
};

export type EmailTemplateInput = {
  subject: Scalars['String'];
  htmlBody: Scalars['String'];
  textBody: Scalars['String'];
};

/** Re-usable by other questions types that embed text fields as well */
export type EmbeddedInputTextPathFlowQuestion = InputTextPathFlowQuestionMixin & {
  __typename: 'EmbeddedInputTextPathFlowQuestion';
  required: Scalars['Boolean'];
  inputTextValidations: Array<InputTextPathFlowQuestionValidation>;
  fieldType: InputTextPathFlowQuestionFieldType;
  placeholder?: Maybe<Scalars['String']>;
  questionSubText?: Maybe<TextViewModel>;
};

export type EmbedMedia = {
  __typename: 'EmbedMedia';
  id: Scalars['String'];
  type: EmbedMediaType;
  url: Scalars['String'];
};

export type EmbedMediaInput = {
  id: Scalars['String'];
  type: EmbedMediaType;
};

export enum EmbedMediaType {
  YOUTUBE = 'YOUTUBE'
}

export type EmptyDealTerms = {
  __typename: 'EmptyDealTerms';
  type: DealTermsType;
};

export type EncodedAuthenticationTokens = {
  __typename: 'EncodedAuthenticationTokens';
  refreshToken: Scalars['String'];
  accessToken: Scalars['String'];
  sessionToken: Scalars['String'];
};

export type EncodedAuthenticationTokensPayload = {
  encodedAuthenticationTokens?: Maybe<EncodedAuthenticationTokens>;
};

export type EndPathNodeConfig = PathNodeConfig & {
  __typename: 'EndPathNodeConfig';
  configType: PathNodeConfigType;
  endType: EndPathNodeConfigType;
  configs: Array<PathNodeConfig>;
};

export enum EndPathNodeConfigType {
  ACCOUNT_LEAD_REDIRECT = 'ACCOUNT_LEAD_REDIRECT',
  ACCOUNT_EXPERT_APPLICATION_REDIRECT = 'ACCOUNT_EXPERT_APPLICATION_REDIRECT',
  CONSUMER_EXPERT_REVIEW_REDIRECT = 'CONSUMER_EXPERT_REVIEW_REDIRECT',
  REDIRECT = 'REDIRECT'
}

export type EndPathNodeConfigUpsertEditorCommandInput = {
  /** If omitted, will infer the default endType from the path schema domain */
  endType?: Maybe<EndPathNodeConfigType>;
  /** will pre-fill category for nested action node, if applicable for endType */
  categoryId?: Maybe<Scalars['CategoryId']>;
};

export type EntityCreatedPathGraphFlowRequestEvent = PathGraphFlowRequestEvent & {
  __typename: 'EntityCreatedPathGraphFlowRequestEvent';
  nodeReferences: Array<PathNodeMaterializedReference>;
  entityCreatedId: Scalars['AnyId'];
  entityCreatedType: EntityCreatedTypePathGraphFlowEvent;
};

export enum EntityCreatedTypePathGraphFlowEvent {
  USER = 'USER',
  DEAL_REQUEST = 'DEAL_REQUEST',
  LEAD = 'LEAD',
  CONSUMER_EXPERT_REVIEW = 'CONSUMER_EXPERT_REVIEW',
  EXPERT_APPLICATION = 'EXPERT_APPLICATION'
}

export enum Environment {
  DEVELOPMENT = 'DEVELOPMENT',
  STAGING = 'STAGING',
  PRODUCTION = 'PRODUCTION'
}

export type ErrorMessage = {
  errorMessage: Scalars['String'];
};

/** Indicates that an unrecoverable error occurred, typically due to the path not being configured correctly. */
export type ErrorPathNodeFlowViewModel = PathNodeFlowViewModel & ErrorMessage & {
  __typename: 'ErrorPathNodeFlowViewModel';
  id: Scalars['PathNodeId'];
  errorMessage: Scalars['String'];
};

export type EscalateLeadForDelegationSupportTaskActivity = SupportTaskActivity & {
  __typename: 'EscalateLeadForDelegationSupportTaskActivity';
  id: Scalars['SupportTaskActivityId'];
  supportTask: SupportTask;
  action: SupportTaskAction;
  actor: SupportTaskActor;
  consumer: User;
  lead?: Maybe<Lead>;
  occurredAt: Scalars['Date'];
  escalation: LeadEscalation;
};

export type EscalateLeadForReassignmentSupportTaskActivity = SupportTaskActivity & {
  __typename: 'EscalateLeadForReassignmentSupportTaskActivity';
  id: Scalars['SupportTaskActivityId'];
  supportTask: SupportTask;
  action: SupportTaskAction;
  actor: SupportTaskActor;
  consumer: User;
  lead?: Maybe<Lead>;
  occurredAt: Scalars['Date'];
  escalation: LeadEscalation;
};

export type EscalationClosedActivity = OrderActivityDetail & {
  __typename: 'EscalationClosedActivity';
  type: OrderActivityDetailType;
  closedBy: Operator;
  escalation: OrderEscalation;
};

export type EscalationFacetCountsPayload = {
  __typename: 'EscalationFacetCountsPayload';
  displayFacets: Array<DisplayFacet>;
};

export enum EscalationItemCondition {
  NEW = 'NEW',
  GOOD = 'GOOD',
  OKAY = 'OKAY'
}

export type EscalationItemInfo = {
  __typename: 'EscalationItemInfo';
  condition: EscalationItemCondition;
  customized: Scalars['Boolean'];
  orderLineItemId?: Maybe<Scalars['OrderLineItemId']>;
};

export type EscalationItemInfoInput = {
  orderLineItemId: Scalars['OrderLineItemId'];
  itemCondition: EscalationItemCondition;
  customized: Scalars['Boolean'];
};

export enum EscalationResolution {
  ORDER_CANCELLED = 'ORDER_CANCELLED',
  UNAVAILABLE_INVENTORY = 'UNAVAILABLE_INVENTORY',
  REPLACEMENT_FOUND = 'REPLACEMENT_FOUND'
}

export type EscalationUser = User | Operator | BusinessUser;

export type EstimatedExpertRpalStats = {
  __typename: 'EstimatedExpertRPALStats';
  activeLeads: Scalars['Int'];
  totalOrders: Scalars['Int'];
  totalOrderAmount: MonetaryAmount;
  conversionRate: Scalars['BigDecimal'];
  revenuePerLead: MonetaryAmount;
};

/** Compute sales tax using one of these 3 location inputs. */
export type EstimatedTaxLocationInput = {
  /** Estimate sales tax using the address of the user */
  userId?: Maybe<Scalars['UserId']>;
  /** Estimate sales tax using this stored address */
  addressId?: Maybe<Scalars['AddressId']>;
  /** Estimate sales tax using the country and state. If only state is provided, the country will default to US */
  country?: Maybe<Scalars['String']>;
  /** Estimate sales tax using the country and state. If only state is provided, the country will default to US */
  state?: Maybe<Scalars['String']>;
};

export type ExchangeTicket = TicketDetail & {
  __typename: 'ExchangeTicket';
  type: TicketType;
  consumer: User;
  order: Order;
  reason: OrderRefundReason;
  itemInfos: Array<EscalationItemInfo>;
  orderLineItemIds: Array<Scalars['OrderLineItemId']>;
};

export type ExecutePathEditorMoveNodeInput = {
  id: Scalars['AnyId'];
  editorStateId?: Maybe<Scalars['PathEditorStateId']>;
  sourceNodeId: Scalars['PathNodeId'];
  destination: PathNodeMoveDestinationInput;
};

export type ExecutePathEditorMoveNodePayload = CommonPathEditorPayload & SideEffectPathEditorPayload & {
  __typename: 'ExecutePathEditorMoveNodePayload';
  pathEditorContext: PathEditorContext;
  errorMessage?: Maybe<Scalars['String']>;
  hasError: Scalars['Boolean'];
  sideEffect: PathEditorEditSideEffect;
};

export type ExecutePathEditorNodeConfigCommandInput = {
  id: Scalars['AnyId'];
  editorStateId?: Maybe<Scalars['PathEditorStateId']>;
  target: PathNodeConfigEditorNodeConfigCommandTargetInput;
  command: PathNodeConfigEditorNodeConfigCommandInput;
};

export type ExecutePathEditorNodeConfigCommandPayload = CommonPathEditorPayload & SideEffectPathEditorPayload & {
  __typename: 'ExecutePathEditorNodeConfigCommandPayload';
  pathEditorContext: PathEditorContext;
  errorMessage?: Maybe<Scalars['String']>;
  hasError: Scalars['Boolean'];
  sideEffect: PathEditorEditSideEffect;
};

export type ExecutePathEditorRedoInput = {
  id: Scalars['AnyId'];
  editorStateId?: Maybe<Scalars['PathEditorStateId']>;
  /** If null, will redo one operation */
  replayToOperationLogEntryId?: Maybe<Scalars['PathSchemaOperationLogEntryId']>;
};

export type ExecutePathEditorRedoPayload = CommonPathEditorPayload & {
  __typename: 'ExecutePathEditorRedoPayload';
  pathEditorContext: PathEditorContext;
  errorMessage?: Maybe<Scalars['String']>;
  hasError: Scalars['Boolean'];
};

export type ExecutePathEditorRemoveEdgeInput = {
  id: Scalars['AnyId'];
  editorStateId?: Maybe<Scalars['PathEditorStateId']>;
  edge: PathEdgeInput;
};

export type ExecutePathEditorRemoveEdgePayload = CommonPathEditorPayload & SideEffectPathEditorPayload & {
  __typename: 'ExecutePathEditorRemoveEdgePayload';
  pathEditorContext: PathEditorContext;
  errorMessage?: Maybe<Scalars['String']>;
  hasError: Scalars['Boolean'];
  sideEffect: PathEditorEditSideEffect;
};

export type ExecutePathEditorRemoveNodeInput = {
  id: Scalars['AnyId'];
  editorStateId?: Maybe<Scalars['PathEditorStateId']>;
  nodeId: Scalars['PathNodeId'];
};

export type ExecutePathEditorRemoveNodePayload = CommonPathEditorPayload & SideEffectPathEditorPayload & {
  __typename: 'ExecutePathEditorRemoveNodePayload';
  pathEditorContext: PathEditorContext;
  errorMessage?: Maybe<Scalars['String']>;
  hasError: Scalars['Boolean'];
  sideEffect: PathEditorEditSideEffect;
};

export type ExecutePathEditorSetEdgeInput = {
  id: Scalars['AnyId'];
  editorStateId?: Maybe<Scalars['PathEditorStateId']>;
  edge: PathEdgeInput;
};

export type ExecutePathEditorSetEdgePayload = CommonPathEditorPayload & SideEffectPathEditorPayload & {
  __typename: 'ExecutePathEditorSetEdgePayload';
  pathEditorContext: PathEditorContext;
  errorMessage?: Maybe<Scalars['String']>;
  hasError: Scalars['Boolean'];
  sideEffect: PathEditorEditSideEffect;
};

export type ExecutePathEditorUndoInput = {
  id: Scalars['AnyId'];
  editorStateId?: Maybe<Scalars['PathEditorStateId']>;
  /** If null, will undo one operation */
  rollbackToOperationLogEntryId?: Maybe<Scalars['PathSchemaOperationLogEntryId']>;
};

export type ExecutePathEditorUndoPayload = CommonPathEditorPayload & {
  __typename: 'ExecutePathEditorUndoPayload';
  pathEditorContext: PathEditorContext;
  errorMessage?: Maybe<Scalars['String']>;
  hasError: Scalars['Boolean'];
};

export type ExperimentContentSelectionMethod = ContentSelectionMethod & {
  __typename: 'ExperimentContentSelectionMethod';
  type: ContentSelectionMethodType;
  experiment: ExperimentDefinition;
};

export type ExperimentContentSelectionMethodInput = {
  experiment: Scalars['String'];
};

export type ExperimentDefinition = {
  __typename: 'ExperimentDefinition';
  id: Scalars['ExperimentId'];
  name: Scalars['String'];
  description: Scalars['String'];
  seed: Scalars['Int'];
  backendOnly: Scalars['Boolean'];
  treatments: Array<TreatmentDefinition>;
  rules: Array<RuleDefinition>;
  version: Scalars['Int'];
  createdAt: Scalars['Date'];
  updatedAt: Scalars['Date'];
  state: ExperimentState;
  updatedById: Scalars['AnyId'];
  updatedBy: Identity;
};

export type ExperimentFilter = {
  states?: Maybe<Array<ExperimentState>>;
  namePrefix?: Maybe<Scalars['String']>;
  nameKeyword?: Maybe<Scalars['String']>;
};


export enum ExperimentSortBy {
  DEFAULT = 'DEFAULT',
  NAME = 'NAME',
  CREATED_AT = 'CREATED_AT',
  UPDATED_AT = 'UPDATED_AT'
}

export type ExperimentsPagination = {
  __typename: 'ExperimentsPagination';
  experiments: Array<ExperimentDefinition>;
  count: Scalars['Int'];
};

export enum ExperimentState {
  ACTIVE = 'ACTIVE',
  ARCHIVED = 'ARCHIVED'
}

export type ExperimentSubjectAttribute = {
  __typename: 'ExperimentSubjectAttribute';
  name: Scalars['String'];
  value: Scalars['String'];
};

export type ExperimentsUpdatedAfterPayload = {
  __typename: 'ExperimentsUpdatedAfterPayload';
  experiments: Array<ExperimentDefinition>;
};

export type ExperimentUsage = {
  type: ExperimentUsageType;
};

export enum ExperimentUsageType {
  CODE = 'CODE',
  TRIGGER = 'TRIGGER',
  CONTENT_SELECTION_RULE = 'CONTENT_SELECTION_RULE',
  TEMPLATE = 'TEMPLATE'
}

export type ExpertActivatedActivity = BusinessUserActivity & {
  __typename: 'ExpertActivatedActivity';
  id: Scalars['BusinessUserActivityId'];
  type: BusinessUserActivityType;
  occurredAt: Scalars['Date'];
};

export type ExpertApplication = {
  __typename: 'ExpertApplication';
  id: Scalars['ExpertApplicationId'];
  state: ExpertApplicationState;
  /** @deprecated use currentHiringStage field */
  stateDisplayName: Scalars['String'];
  currentHiringStage?: Maybe<ExpertHiringFlowStage>;
  hiringFlow: ExpertHiringFlow;
  tags: Array<Scalars['String']>;
  user: User;
  category: Category;
  attributes: Array<Attribute>;
  rejectReason?: Maybe<Scalars['String']>;
  createdAt: Scalars['Date'];
  submittedAt: Scalars['Date'];
  approvedAt?: Maybe<Scalars['Date']>;
  rejectedAt?: Maybe<Scalars['Date']>;
  approvedBy?: Maybe<ExpertApplicationReviewer>;
  expertAccount?: Maybe<BusinessUser>;
  expertProfile?: Maybe<ExpertProfile>;
  department: Department;
  claimStatus?: Maybe<ExpertApplicationClaimStatus>;
  /** @deprecated use `feedback` field */
  reviews: Array<ExpertApplicationReview>;
  feedback: Array<ExpertHiringFeedback>;
  conversation?: Maybe<Conversation>;
  notes: Array<ExpertApplicationNote>;
  pastTasks: Array<ExpertApplicationTaskStatus>;
  currentTasks: Array<ExpertApplicationTaskStatus>;
  futureTasks: Array<ExpertApplicationTaskStatus>;
  snooze?: Maybe<ExpertApplicationSnooze>;
  archived: Scalars['Boolean'];
  lastActivityTime: Scalars['Date'];
  referredByExpertId?: Maybe<Scalars['BusinessUserId']>;
  source?: Maybe<ExpertApplicationSource>;
  contractSigned: Scalars['Boolean'];
  /** @deprecated no longer needed. will auto select stage */
  stateBeforeRejected?: Maybe<ExpertApplicationState>;
  expectedCompletionDate?: Maybe<Scalars['LocalDate']>;
  videoInterviewUrl?: Maybe<Scalars['String']>;
  onboardingUrl: Scalars['String'];
  interview?: Maybe<ExpertApplicationInterview>;
};

export type ExpertApplicationClaimStatus = {
  __typename: 'ExpertApplicationClaimStatus';
  claimedAt: Scalars['Date'];
  claimedByTeam: BusinessUserTeam;
  claimedByExpert: BusinessUser;
};

export type ExpertApplicationEdge = {
  __typename: 'ExpertApplicationEdge';
  node: ExpertApplication;
  cursor: Scalars['String'];
};

export type ExpertApplicationEvaluation = ExpertHiringFeedbackDetail & {
  __typename: 'ExpertApplicationEvaluation';
  type: ExpertHiringFeedbackType;
  technicalKnowledgeRating: Scalars['Int'];
  technicalKnowledgeSummary?: Maybe<Scalars['String']>;
  customerServiceRating: Scalars['Int'];
  customerServiceSummary?: Maybe<Scalars['String']>;
  professionalismRating?: Maybe<Scalars['Int']>;
  professionalismSummary?: Maybe<Scalars['String']>;
  overallRating: Scalars['Int'];
  overallSummary?: Maybe<Scalars['String']>;
};

export type ExpertApplicationEvaluationInput = {
  technicalKnowledgeRating: Scalars['Int'];
  technicalKnowledgeSummary?: Maybe<Scalars['String']>;
  customerServiceRating: Scalars['Int'];
  customerServiceSummary?: Maybe<Scalars['String']>;
  professionalismRating?: Maybe<Scalars['Int']>;
  professionalismSummary?: Maybe<Scalars['String']>;
  overallRating: Scalars['Int'];
  overallSummary?: Maybe<Scalars['String']>;
};

export type ExpertApplicationFolder = {
  __typename: 'ExpertApplicationFolder';
  id: Scalars['ExpertApplicationFolderId'];
  slug: Scalars['String'];
  displayName: Scalars['String'];
  totalCount?: Maybe<Scalars['Int']>;
  unreadCount?: Maybe<Scalars['Int']>;
  countSubscriptionAvailable: Scalars['Boolean'];
};

export type ExpertApplicationFolderGroup = {
  __typename: 'ExpertApplicationFolderGroup';
  type: ExpertApplicationFolderType;
  folders: Array<ExpertApplicationFolder>;
  displayName: Scalars['String'];
};


export type ExpertApplicationFolderItemChange = {
  __typename: 'ExpertApplicationFolderItemChange';
  application: ExpertApplication;
  type: ExpertApplicationFolderItemChangeType;
};

export enum ExpertApplicationFolderItemChangeType {
  ADD = 'ADD',
  REMOVE = 'REMOVE',
  UPDATE = 'UPDATE'
}

export enum ExpertApplicationFolderType {
  PIPELINE = 'PIPELINE',
  FOLDERS = 'FOLDERS'
}


export type ExpertApplicationInterview = {
  __typename: 'ExpertApplicationInterview';
  interviewId?: Maybe<Scalars['String']>;
  jobId?: Maybe<Scalars['String']>;
  createdAt: Scalars['Date'];
  state: ExpertApplicationInterviewState;
  type: ExpertApplicationInterviewType;
  beginVideoInterviewUrl: Scalars['String'];
  watchVideoInterviewUrl: Scalars['String'];
};

export enum ExpertApplicationInterviewState {
  PENDING = 'PENDING',
  COMPLETED = 'COMPLETED'
}

export enum ExpertApplicationInterviewType {
  SPARK_HIRE = 'SPARK_HIRE'
}

export type ExpertApplicationNote = {
  __typename: 'ExpertApplicationNote';
  text: Scalars['String'];
  createdAt?: Maybe<Scalars['Date']>;
  createdBy: Operator;
};

export type ExpertApplicationQuery = {
  states: Array<ExpertApplicationState>;
};

export enum ExpertApplicationRating {
  YES = 'YES',
  NO = 'NO'
}

export type ExpertApplicationRatingInput = {
  positive: Scalars['Boolean'];
};

export type ExpertApplicationReview = {
  __typename: 'ExpertApplicationReview';
  reviewedAt: Scalars['Date'];
  reviewedBy: BusinessUser;
  rating: ExpertApplicationRating;
  reason?: Maybe<Scalars['String']>;
};

export type ExpertApplicationReviewer = BusinessUser | Operator;

export type ExpertApplicationsConnection = {
  __typename: 'ExpertApplicationsConnection';
  facets: Array<DisplayFacet>;
  filters: Array<FilterFieldCondition>;
  edges: Array<ExpertApplicationEdge>;
  pageInfo: PageInfo;
  count: Scalars['Int'];
};

export type ExpertApplicationSearchQueryInput = {
  keywords?: Maybe<Scalars['String']>;
  departmentId?: Maybe<Scalars['DepartmentId']>;
  userId?: Maybe<Scalars['UserId']>;
  hasConversation?: Maybe<Scalars['Boolean']>;
  facets?: Maybe<Array<FacetSelection>>;
  facetedSearch: Scalars['Boolean'];
  filters?: Maybe<Array<SearchFilterFieldInput>>;
};

export enum ExpertApplicationSearchSort {
  DEFAULT = 'DEFAULT',
  APPLICATION_SUBMITTED_AT = 'APPLICATION_SUBMITTED_AT'
}

export type ExpertApplicationSimpleRating = ExpertHiringFeedbackDetail & {
  __typename: 'ExpertApplicationSimpleRating';
  type: ExpertHiringFeedbackType;
  positive: Scalars['Boolean'];
  reason?: Maybe<Scalars['String']>;
};

export type ExpertApplicationSnooze = {
  __typename: 'ExpertApplicationSnooze';
  wakeupTime: Scalars['Date'];
  note?: Maybe<Scalars['String']>;
  message?: Maybe<Scalars['String']>;
  cancelMessageOnReply: Scalars['Boolean'];
};

export type ExpertApplicationSource = {
  __typename: 'ExpertApplicationSource';
  initialUrl?: Maybe<Scalars['String']>;
  source?: Maybe<Scalars['String']>;
  landingPageKey?: Maybe<Scalars['String']>;
};

export type ExpertApplicationsPagination = {
  __typename: 'ExpertApplicationsPagination';
  applications: Array<ExpertApplication>;
  count: Scalars['Long'];
};

export enum ExpertApplicationState {
  REJECTED = 'REJECTED',
  ONBOARDED = 'ONBOARDED',
  SCHEDULING = 'SCHEDULING',
  FINAL_EVALUATION = 'FINAL_EVALUATION',
  ONBOARDING = 'ONBOARDING',
  APPROVED = 'APPROVED',
  PENDING = 'PENDING'
}

export type ExpertApplicationSubscriptionChange = {
  __typename: 'ExpertApplicationSubscriptionChange';
  application: ExpertApplication;
  type: ExpertApplicationSubscriptionChangeType;
};

export enum ExpertApplicationSubscriptionChangeType {
  ADD = 'ADD',
  REMOVE = 'REMOVE'
}

export type ExpertApplicationTaskConfig = {
  __typename: 'ExpertApplicationTaskConfig';
  type: ExpertApplicationTaskType;
};

export enum ExpertApplicationTaskState {
  NOT_STARTED = 'NOT_STARTED',
  IN_PROGRESS = 'IN_PROGRESS',
  ERROR = 'ERROR',
  COMPLETED = 'COMPLETED'
}

export type ExpertApplicationTaskStatus = {
  __typename: 'ExpertApplicationTaskStatus';
  type: ExpertApplicationTaskType;
  displayName: Scalars['String'];
  automated: Scalars['Boolean'];
  state: ExpertApplicationTaskState;
  externalId?: Maybe<Scalars['String']>;
  updates: Array<ExpertApplicationTaskStatusUpdate>;
};

export type ExpertApplicationTaskStatusUpdate = {
  __typename: 'ExpertApplicationTaskStatusUpdate';
  status: Scalars['String'];
  updatedAt: Scalars['Date'];
};

export enum ExpertApplicationTaskType {
  CALL_APPLICANT = 'CALL_APPLICANT',
  APPROVE_PROFILE = 'APPROVE_PROFILE',
  SIGN_CONTRACT = 'SIGN_CONTRACT',
  SETUP_PAYROLL = 'SETUP_PAYROLL',
  COMPLETE_TRAINING = 'COMPLETE_TRAINING',
  SETUP_7SHIFT = 'SETUP_7SHIFT',
  SETUP_SLACK = 'SETUP_SLACK',
  COMPLETE_HOMEWORK = 'COMPLETE_HOMEWORK',
  WAIT_FOR_SCHEDULING = 'WAIT_FOR_SCHEDULING',
  ADD_AVAILABILITY = 'ADD_AVAILABILITY',
  SCHEDULE_SHIFT = 'SCHEDULE_SHIFT',
  COMPLETE_FIRST_SHIFT = 'COMPLETE_FIRST_SHIFT',
  PASS_RESPONSIVE_EVAL = 'PASS_RESPONSIVE_EVAL',
  PASS_SKILL_EVAL = 'PASS_SKILL_EVAL',
  ACTIVATE_SCHEDULING = 'ACTIVATE_SCHEDULING',
  ACTIVATE_EXPERT_ACCOUNT = 'ACTIVATE_EXPERT_ACCOUNT',
  GET_GOOGLE_SITE_ACCESS = 'GET_GOOGLE_SITE_ACCESS',
  ASSIGN_TO_TEAM = 'ASSIGN_TO_TEAM',
  DOWNLOAD_MOBILE_APP = 'DOWNLOAD_MOBILE_APP',
  COMPLETE_ONE_WAY_INTERVIEW = 'COMPLETE_ONE_WAY_INTERVIEW',
  ATTEND_KICKOFF_METTING = 'ATTEND_KICKOFF_METTING',
  SHADOW_LIVE_SHIFT = 'SHADOW_LIVE_SHIFT'
}

export type ExpertAttributeInput = {
  specialtyCategoryId?: Maybe<Scalars['CategoryId']>;
  acceptRequestMode?: Maybe<AcceptRequestMode>;
  newMessageNotificationMode?: Maybe<ExpertNotificationMode>;
  broadcastLeadNotificationMode?: Maybe<ExpertNotificationMode>;
  assistExpert?: Maybe<Scalars['Boolean']>;
  workloadCapacity?: Maybe<Scalars['Float']>;
  broadcastLeadClaimDisabled?: Maybe<Scalars['Boolean']>;
  expertApplicationReviewEnabled?: Maybe<Scalars['Boolean']>;
  endOfShiftSurveyTakenAt?: Maybe<Scalars['Date']>;
  standbyAllowedOverride?: Maybe<Scalars['Boolean']>;
};

export type ExpertAwayAutoReplyRichCard = MessageRichCard & {
  __typename: 'ExpertAwayAutoReplyRichCard';
  type: MessageRichCardType;
  awayAutoReplyId: Scalars['AwayAutoReplyId'];
};

export type ExpertCategoryTopRecommendedSellable = {
  __typename: 'ExpertCategoryTopRecommendedSellable';
  category: Category;
  displayTitle: Scalars['String'];
  topRecommendedSellables: Array<ExpertTopRecommendedSellable>;
};

export enum ExpertCommissionRefundTreatment {
  ALL_EXEMPT = 'ALL_EXEMPT',
  TIP_EXEMPT = 'TIP_EXEMPT',
  NOT_EXEMPT = 'NOT_EXEMPT'
}

export type ExpertCuratedActivityFeedItem = {
  id: Scalars['ExpertCuratedActivityFeedItemId'];
  occurredAt: Scalars['Date'];
  expert: BusinessUser;
};

export type ExpertCuratedActivityFeedItemConnection = {
  __typename: 'ExpertCuratedActivityFeedItemConnection';
  edges: Array<ExpertCuratedActivityFeedItemEdge>;
  pageInfo: PageInfo;
};

export type ExpertCuratedActivityFeedItemEdge = {
  __typename: 'ExpertCuratedActivityFeedItemEdge';
  node: ExpertCuratedActivityFeedItem;
  cursor: Scalars['String'];
};


export type ExpertCuratedActivityFeedOrderItem = ExpertCuratedActivityFeedItem & {
  __typename: 'ExpertCuratedActivityFeedOrderItem';
  id: Scalars['ExpertCuratedActivityFeedItemId'];
  occurredAt: Scalars['Date'];
  expert: BusinessUser;
  consumerFirstName: Scalars['String'];
  review?: Maybe<ConsumerExpertReview>;
  sellables: Array<ExpertCuratedActivityFeedOrderSellableItem>;
};

export type ExpertCuratedActivityFeedOrderSellableItem = {
  __typename: 'ExpertCuratedActivityFeedOrderSellableItem';
  sellable: Sellable;
  note?: Maybe<ExpertCuratedItemNote>;
};

export type ExpertCuratedItem = {
  __typename: 'ExpertCuratedItem';
  id: Scalars['ExpertCuratedItemId'];
  /** Date at which this expert curated item was created */
  createdAt: Scalars['Date'];
  /** The lead this curated item is associated with. */
  lead: Lead;
  /** User this curated item was created for; de-normalized from the `lead`. */
  createdFor: User;
  /** Expert that created this curated item */
  createdBy: BusinessUser;
  /** The first category of the sellable that's being recommended; de-normalized from the `sellable` */
  category: Category;
  /** The sellable that's being recommended as part of this curated item. */
  sellable: Sellable;
  /**
   * If this curated item is added to the cart via the `addExpertCuratedItemToCart` mutation, this price will be used for
   * the item instead of the sellable's natural sale price.
   */
  priceOverride?: Maybe<MonetaryAmount>;
  /** Date at which the price override would be invalid. */
  priceOverrideValidUntil?: Maybe<Scalars['Date']>;
  /** If this curated item has discount from experts. */
  discount?: Maybe<MonetaryAmount>;
  /** Date at which the discount would be invalid. */
  discountValidUntil?: Maybe<Scalars['Date']>;
  /**
   * The sale price for this item; will use priceOverride if provided and valid, else fallback to the sellable
   * bestOfferPrice or salePrice depending on if best offer price is offered. This would deduct any discount if valid.
   * The sale price may be not available if it is out of stock
   */
  salePrice?: Maybe<MonetaryAmount>;
  specialOfferValidUntil?: Maybe<Scalars['Date']>;
  /** Tag for this curated item. */
  tag?: Maybe<ExpertCuratedItemTag>;
  /**
   * If this curated item is in draft state.
   * Curated items in draft state are exclusively to be used by the expert to incrementally build up multiple
   * recommendations without it being viewable by the consumer. As such, drafts are never view-able by the consumer.
   * In order to remove the draft flag from all items associated with a lead, invoke the
   * `makeExpertCuratedItemDraftsActive` mutation.
   */
  draft: Scalars['Boolean'];
  /** If this curated item is active (currently being considered, and displayed to the consumer by default). */
  active: Scalars['Boolean'];
  /** If present, represents that this item has been dismissed/removed. */
  removedState?: Maybe<ExpertCuratedItemRemovedState>;
  /**
   * If set, this curated item will be added to the user associated with the lead's cart when this item is converted
   * from a draft to non draft and active state via `makeExpertCuratedItemDraftsActive`.
   */
  shouldAddToCartOnActive: Scalars['Boolean'];
  /** The line item in the user's cart associated with this expert curated item. */
  lineItemInCart?: Maybe<OrderLineItem>;
  /**
   * Custom expert notes associated with this item for the consumer
   * @deprecated Use draftNote and note
   */
  notes?: Maybe<Scalars['String']>;
  /**
   * Custom expert notes associated with this item, that should be published when this item is activated.
   * When this note is activated, this draft note is transferred into a new `ExpertCuratedItemNote` that's set to the
   * `note` field, and this property is cleared. As such, this property is only valid for creating new notes on items
   * in draft state.
   */
  draftNote?: Maybe<Scalars['String']>;
  /** Custom expert note associated with this item for the consumer */
  note?: Maybe<ExpertCuratedItemNote>;
  /** Expert only field to view a pending draft update for this record */
  pendingDraftUpdate?: Maybe<ExpertCuratedItem>;
  /** Previous item this item is replacing (if state is draft) / replaced (if state is not draft) */
  supersededItem?: Maybe<ExpertCuratedItem>;
  /**
   * Indicates that the changes made to this item introduce no material changes to the item it's replacing
   * (referenced by `supersededItem`). If the item is activated in this state (via `makeExpertCuratedItemDraftsActive`),
   * this draft will be deleted with no modifications being made to the existing item.
   */
  noChangesFromSupersededItem: Scalars['Boolean'];
  /** Indicates whether this ExpertCuratedItem was built from a system recommendation. */
  systemRecommended?: Maybe<Scalars['Boolean']>;
  /** various notes only visible by the expert and fulfillment team */
  fulfillmentNotes: ExpertCuratedItemFulfillmentNotes;
  /**
   * Priced (including free) add-ons that are bundled together with this curated item. When added to the user's cart,
   * these customizations are also forcefully added as a grouped line item.
   */
  customizations: Array<ExpertCuratedItemCustomization>;
  /** The sale price plus prices of customizations if any. If sale price is null, this is also null. */
  salePriceWithCustomizations?: Maybe<MonetaryAmount>;
  /** Rank of item in curated list */
  rank: Scalars['Long'];
  /**
   * Note that expert has written for same sellable (all variants) that is either PENDING, APPROVED or REJECTED
   * Can be used to show expert what note they would be overriding by creating a new version for review
   */
  existingNoteForSellable?: Maybe<ExpertCuratedItemNote>;
  /** Valid note attribute schemas for this item's sellable */
  attributeSchemas: Array<AttributeSchemaRevision>;
  bestOfferPrice: Scalars['Boolean'];
};

export type ExpertCuratedItemActivation = {
  __typename: 'ExpertCuratedItemActivation';
  id: Scalars['ExpertCuratedItemActivationId'];
  activated: Array<ExpertCuratedItem>;
  removed: Array<ExpertCuratedItem>;
  items: Array<ExpertCuratedItem>;
  lead: Lead;
  activatedBy: BusinessUser;
  createdFor: User;
  previousActivation?: Maybe<ExpertCuratedItemActivation>;
  numItemsActivated: Scalars['Int'];
  numItemsRemoved: Scalars['Int'];
  specialOfferValidUntil?: Maybe<Scalars['Date']>;
  createdAt: Scalars['Date'];
  createdBySystem: Scalars['Boolean'];
  /** used for trigger entity only to avoid unnecessary look up of Business User */
  activatedById: Scalars['BusinessUserId'];
};


export type ExpertCuratedItemActivationItemsArgs = {
  first?: Maybe<Scalars['Int']>;
};


export type ExpertCuratedItemActivationPayload = {
  __typename: 'ExpertCuratedItemActivationPayload';
  activation?: Maybe<ExpertCuratedItemActivation>;
  errorCode?: Maybe<GetEntityErrorCode>;
  maskedUserHandles?: Maybe<Array<MaskedUserHandle>>;
};

export type ExpertCuratedItemActivationsConnection = {
  __typename: 'ExpertCuratedItemActivationsConnection';
  edges: Array<ExpertCuratedItemActivationsEdge>;
  pageInfo: PageInfo;
};

export type ExpertCuratedItemActivationsEdge = {
  __typename: 'ExpertCuratedItemActivationsEdge';
  node: ExpertCuratedItemActivation;
  cursor: Scalars['String'];
};

export type ExpertCuratedItemCustomization = {
  __typename: 'ExpertCuratedItemCustomization';
  sellable: Sellable;
  createdAt: Scalars['Date'];
  title: Scalars['String'];
  price: MonetaryAmount;
};

export type ExpertCuratedItemEditError = UpdateAlreadyExistsExpertCuratedItemEditError | NoteEditErrorExpertCuratedItemEditError;

export type ExpertCuratedItemFulfillmentNotes = {
  __typename: 'ExpertCuratedItemFulfillmentNotes';
  /** The reason why a custom priceOverride was set */
  priceOverrideReason?: Maybe<ExpertCuratedItemPriceOverrideReason>;
  /** If this curated item was sourced from a different site, the url of the product */
  externalProductUrl?: Maybe<Scalars['String']>;
  /** Additional notes for the fulfillment team (e.g.: special customer requests) */
  notes?: Maybe<Scalars['String']>;
  /** Additional attachments for the fulfillment team (e.g. screenshots for price match) */
  attachments: Array<MediaFile>;
};

export type ExpertCuratedItemFulfillmentNotesInput = {
  priceOverrideReasonType?: Maybe<ExpertCuratedItemPriceOverrideReasonType>;
  externalProductUrl?: Maybe<Scalars['String']>;
  notes?: Maybe<Scalars['String']>;
  attachments?: Maybe<Array<Scalars['MediaId']>>;
};

/**
 * ExpertCuratedItemGroup is a container for ExpertCuratedItem's that were part of the curation recommended to a lead
 * It also includes other decorations like the request attributes of the lead to who this curation was recommended.
 */
export type ExpertCuratedItemGroup = {
  __typename: 'ExpertCuratedItemGroup';
  expertCuratedItems: Array<ExpertCuratedItem>;
  modifiedAt: Scalars['Date'];
  /** a list of request attributes that can be used to tag this saved curation */
  suggestedTaggableRequestAttributes: Array<SuggestedExpertTaggableRequestAttribute>;
};


export type ExpertCuratedItemNote = {
  __typename: 'ExpertCuratedItemNote';
  id: Scalars['ExpertCuratedItemNoteId'];
  /** sellable variant this note is for */
  sellable: Sellable;
  /** the parent sellable of `sellable`, or `sellable` if it's already the parent */
  parentSellable: Sellable;
  /** expert that created this note */
  createdBy: BusinessUser;
  /** Note text */
  text?: Maybe<Scalars['String']>;
  /** the amount of purchased orders that contain line items added from expert curated items containing this note */
  purchaseCount: Scalars['Int'];
  /** the amount of active (non draft, non-replaced) expert curated items that expectedReference this note */
  useCount: Scalars['Int'];
  /** Between 0 and 1 */
  purchaseRate: Scalars['Float'];
  /** If the note has been flagged by operator as "featurable" review */
  featured: Scalars['Boolean'];
  /** Id of note this note was orignally copied from */
  originatedFromId?: Maybe<Scalars['ExpertCuratedItemNoteId']>;
  /** Id for grouping together differnet versions of same note */
  historyId: Scalars['ExpertCuratedItemNoteHistoryId'];
  /** Id of note this note replace. Also note with previous versionNumber */
  supersededId?: Maybe<Scalars['ExpertCuratedItemNoteId']>;
  /** Valid attribute schemas for this note */
  attributeSchemas: Array<AttributeSchemaRevision>;
  /** Bag of actual attributes */
  attributes: Array<Attribute>;
  /** version of note */
  versionNumber: Scalars['Int'];
  /** History of approval changes made to note by operator */
  approvalHistory: Array<ExpertCuratedItemNoteApprovalChange>;
  /** Changes requested by operator on note rejection */
  changesRequestedNote?: Maybe<Scalars['String']>;
  /** Current state of note */
  state: ExpertCuratedItemNoteState;
  stats: ExpertCuratedItemNoteStats;
  updatedAt: Scalars['Date'];
  createdAt: Scalars['Date'];
  pendingDraftUpdate?: Maybe<ExpertCuratedItemNote>;
  /** Previous item (if any) this item is replacing */
  supersededItem?: Maybe<ExpertCuratedItemNote>;
  /**
   * Indicates that the changes made to this item introduce no material changes to the item it's replacing
   * (referenced by `supersededItem`)
   */
  noChangesFromSupersededItem: Scalars['Boolean'];
  /**
   * The pros and cons for the expert curated item. These are the pros and cons
   * that the expert mutates, and that should be shown in consumer-app curations.
   */
  prosAndCons?: Maybe<ExpertCuratedItemProsAndCons>;
  /** The default pros and cons for the expert curated item note. Not what should be shown on the consumer end. */
  defaultProsAndCons?: Maybe<ExpertCuratedItemProsAndCons>;
};

export type ExpertCuratedItemNoteApprovalChange = {
  __typename: 'ExpertCuratedItemNoteApprovalChange';
  occurredAt: Scalars['Date'];
  changedBy: NoteApprovalChangeByUnion;
  changeType: ExpertCuratedItemNoteState;
  changeRequestedNotes?: Maybe<Scalars['String']>;
};

export type ExpertCuratedItemNoteEditError = InvalidAttributeForDepartmentExpertCuratedItemNoteEditError | InvalidNoteStateExpertCuratedItemNoteEditError | UnsupportedNoteStateExpertCuratedItemNoteEditError | ProsAndConsErrorExpertCuratedItemNoteEditError;



export enum ExpertCuratedItemNoteSort {
  USE_COUNT = 'USE_COUNT',
  CREATED_AT = 'CREATED_AT',
  UPDATED_AT = 'UPDATED_AT'
}

export type ExpertCuratedItemNotesPagination = {
  __typename: 'ExpertCuratedItemNotesPagination';
  expertCuratedItemNotes: Array<ExpertCuratedItemNote>;
  count: Scalars['Long'];
  facets: Array<DisplayFacet>;
};

export type ExpertCuratedItemNotesPaginationQueryInput = {
  states: Array<ExpertCuratedItemNoteState>;
  /** Get notes for all variations */
  parentSellableId?: Maybe<Scalars['SellableId']>;
  /** Get notes for specific variation */
  sellableId?: Maybe<Scalars['SellableId']>;
  expertId?: Maybe<Scalars['BusinessUserId']>;
  keywords?: Maybe<Scalars['String']>;
  facetedSearch?: Maybe<Scalars['Boolean']>;
};

export enum ExpertCuratedItemNoteState {
  /** Single use note */
  NONE = 'NONE',
  /** Editable note. On activation this becomes either NONE or PENDING */
  DRAFT = 'DRAFT',
  /** Waiting to be reviewed by operator */
  PENDING = 'PENDING',
  /** Approved by operator */
  APPROVED = 'APPROVED',
  /** Rejected by operator */
  REJECTED = 'REJECTED',
  /** Archived by operator or system. soft delete */
  ARCHIVED = 'ARCHIVED'
}

export type ExpertCuratedItemNoteStats = {
  __typename: 'ExpertCuratedItemNoteStats';
  purchaseCount: Scalars['Int'];
  useCount: Scalars['Int'];
  favoriteCount: Scalars['Int'];
  flagCount: Scalars['Int'];
};

export type ExpertCuratedItemPriceOverrideReason = {
  __typename: 'ExpertCuratedItemPriceOverrideReason';
  reasonType: ExpertCuratedItemPriceOverrideReasonType;
  displayLabel: Scalars['String'];
  /** If `externalProductUrl` is required for this `reasonType` */
  externalProductUrlRequired: Scalars['Boolean'];
  /** If `notesRequired` is required for this `reasonType` */
  notesRequired: Scalars['Boolean'];
  /** If at least one attachment is required for this reasonType */
  attachmentsRequired: Scalars['Boolean'];
};

export enum ExpertCuratedItemPriceOverrideReasonType {
  PRICE_MATCH = 'PRICE_MATCH',
  SPECIAL_DISCOUNT = 'SPECIAL_DISCOUNT',
  OTHER = 'OTHER',
  SECRET_DEAL = 'SECRET_DEAL'
}

export type ExpertCuratedItemProsAndCons = {
  __typename: 'ExpertCuratedItemProsAndCons';
  pros: Array<IndividualSellableProCon>;
  cons: Array<IndividualSellableProCon>;
  usingDefaultProsAndCons: Scalars['Boolean'];
};

export type ExpertCuratedItemProsAndConsEditError = CustomDisplayNameTooShortExpertCuratedItemProsAndConsEditError | CustomDisplayNameTooLongExpertCuratedItemProsAndConsEditError | AttributeEnumEntryDoesNotExistExpertCuratedItemProsAndConsEditError;

export type ExpertCuratedItemProsAndConsInput = {
  pros?: Maybe<Array<IndividualSellableProConInput>>;
  cons?: Maybe<Array<IndividualSellableProConInput>>;
  /**
   * If set to true, instead of using the pros and cons specified above, the input should be the most up-to-date
   * pros and cons from the database for the expert curated item / note / saved curated item.
   */
  shouldUseDefaultProsAndCons?: Maybe<Scalars['Boolean']>;
};

export type ExpertCuratedItemQueryByUserInput = {
  curatedForId: Scalars['UserId'];
  sellableId: Scalars['SellableId'];
};

export enum ExpertCuratedItemRankChangeType {
  INCREMENT = 'INCREMENT',
  DECREMENT = 'DECREMENT'
}

export type ExpertCuratedItemRemovedBy = User | BusinessUser;

export enum ExpertCuratedItemRemovedReason {
  /** Internal reason used when an item is replaced/updated */
  REPLACED = 'REPLACED',
  /** Should be provided by experts to indicate they removed the item (no further reason is required for them) */
  REMOVED_BY_EXPERT = 'REMOVED_BY_EXPERT',
  /** Default reason that should be used if the user isn't prompted for the remaining reasons */
  NOT_INTERESTED = 'NOT_INTERESTED',
  TOO_EXPENSIVE = 'TOO_EXPENSIVE',
  LOW_QUALITY = 'LOW_QUALITY',
  UGLY = 'UGLY',
  DONT_NEED = 'DONT_NEED',
  BOUGHT_ELSEWHERE = 'BOUGHT_ELSEWHERE',
  OTHER = 'OTHER'
}

export type ExpertCuratedItemRemovedState = {
  __typename: 'ExpertCuratedItemRemovedState';
  by?: Maybe<ExpertCuratedItemRemovedBy>;
  reason: ExpertCuratedItemRemovedReason;
  otherReason?: Maybe<Scalars['String']>;
};

export type ExpertCuratedItemsByCategories = {
  __typename: 'ExpertCuratedItemsByCategories';
  /** Note that this is primarily here to be used as a cache key, not as actual data */
  id: Scalars['LeadId'];
  /** If omitted, defaults to only including ACTIVE */
  categories: Array<ExpertCuratedItemsByCategory>;
  /** All business users that are responsible for the curations */
  experts: Array<BusinessUser>;
};


export type ExpertCuratedItemsByCategoriesCategoriesArgs = {
  filters?: Maybe<Array<ExpertCuratedItemStateFilter>>;
};

export type ExpertCuratedItemsByCategory = {
  __typename: 'ExpertCuratedItemsByCategory';
  /** This is an opaque token to be used as a cache key for this grouping of data; it has no meaning else wise */
  id: Scalars['String'];
  category: Category;
  items: Array<ExpertCuratedItem>;
};


export type ExpertCuratedItemsByCategoryItemsArgs = {
  sort?: Maybe<ExpertCuratedItemSort>;
};

export type ExpertCuratedItemsByCategoryChangedPayload = {
  __typename: 'ExpertCuratedItemsByCategoryChangedPayload';
  expertCuratedItemsByCategories: ExpertCuratedItemsByCategories;
};

export type ExpertCuratedItemsChangedPayload = {
  __typename: 'ExpertCuratedItemsChangedPayload';
  leadId: Scalars['LeadId'];
};

export type ExpertCuratedItemsForLeadPayload = {
  __typename: 'ExpertCuratedItemsForLeadPayload';
  id: Scalars['LeadId'];
  errorCode?: Maybe<GetEntityErrorCode>;
  maskedUserHandles?: Maybe<Array<MaskedUserHandle>>;
  /** If filter is omitted, defaults to only including ACTIVE */
  items: Array<ExpertCuratedItem>;
  byCategories: ExpertCuratedItemsByCategories;
  activationsConnection: ExpertCuratedItemActivationsConnection;
};


export type ExpertCuratedItemsForLeadPayloadItemsArgs = {
  filters?: Maybe<Array<ExpertCuratedItemStateFilter>>;
  first?: Maybe<Scalars['Int']>;
  sort?: Maybe<ExpertCuratedItemSort>;
};


export type ExpertCuratedItemsForLeadPayloadActivationsConnectionArgs = {
  after?: Maybe<Scalars['String']>;
  first?: Maybe<Scalars['Int']>;
  before?: Maybe<Scalars['String']>;
  last?: Maybe<Scalars['Int']>;
};

export enum ExpertCuratedItemSort {
  /** Use the default sorting; this is the default, and should always be used in the consumer use case. */
  DEFAULT = 'DEFAULT',
  /**
   * Sort only by createdAt which guarantees consistent sorting when the expert is modifying expert curated items
   * (e.g.: changing the tags, which typically changes sort order)
   */
  CREATED_AT = 'CREATED_AT'
}

/** Basic filters based on state. When multiple filters are applied, they are OR-ed together. */
export enum ExpertCuratedItemStateFilter {
  /** Include items that are in draft state (only valid for experts) */
  DRAFT = 'DRAFT',
  /** Include items that are active (not in draft state, not removed) */
  ACTIVE = 'ACTIVE',
  /** Include items that are removed */
  REMOVED = 'REMOVED',
  /** Include items that not removed */
  NOT_REMOVED = 'NOT_REMOVED'
}

export type ExpertCuratedItemTag = {
  __typename: 'ExpertCuratedItemTag';
  type: ExpertCuratedItemTagType;
  /** Display Label */
  displayLabel: Scalars['String'];
};

export type ExpertCuratedItemTagInput = {
  type: ExpertCuratedItemTagType;
  /** Required for CUSTOM; natural defaults for EXPERT_PICK and BUDGET_PICK */
  displayLabel?: Maybe<Scalars['String']>;
};

export enum ExpertCuratedItemTagType {
  SPECIAL_OFFER = 'SPECIAL_OFFER',
  THE_ALTERNATIVE = 'THE_ALTERNATIVE',
  SALE_PRICE = 'SALE_PRICE',
  EXPERT_PICK = 'EXPERT_PICK',
  BUDGET_PICK = 'BUDGET_PICK',
  CUSTOM = 'CUSTOM',
  OTHER = 'OTHER'
}

export enum ExpertCuratedItemWriteErrorType {
  UPDATE_ALREADY_EXISTS = 'UPDATE_ALREADY_EXISTS'
}

export type ExpertCuratedLeadItinerary = {
  __typename: 'ExpertCuratedLeadItinerary';
  id: Scalars['LeadId'];
  contentfulVariation: Scalars['String'];
  /**
   * Convienence resolver that's the equivalent of invoking `findContentByTemplate` with `contentfulVariation` as
   * the variation on the itinerary space, and "itineraryPage" template.
   */
  contentfulObject?: Maybe<ContentObject>;
};

/** An order curated (created by) an expert */
export type ExpertCuratedOrder = {
  __typename: 'ExpertCuratedOrder';
  id: Scalars['ExpertCuratedOrderId'];
  createdAt: Scalars['Date'];
  /** The lead between the user and expert this curation was made for */
  lead: Lead;
  /** Expert that created this curation */
  curator: BusinessUser;
  /** Only for trigger entity to avoid unnecessary look up of BusinessUser */
  curatorId: Scalars['BusinessUserId'];
  /** The user this curated order is for */
  curatedFor: User;
  /** Order that was curated */
  order: Order;
  /** The date at which this order started to be available (entered ACTIVE) state */
  availableAt?: Maybe<Scalars['Date']>;
  /** if and when this curated order will expire */
  expiresAt?: Maybe<Scalars['Date']>;
  /** if `state` == `CLOSED`, this is the date it became closed (no longer available for purchase by the consumer) */
  closedAt?: Maybe<Scalars['Date']>;
  /** Reason the order was closed */
  closedReason?: Maybe<ExpertCuratedOrderClosedReason>;
  /** If and when this curated order was last viewed */
  viewedAt?: Maybe<Scalars['Date']>;
  /** Current state of the order */
  state: ExpertCuratedOrderState;
  /** The available variations for the order. The consumer can select between available variations. */
  variationOptions: Array<ExpertCuratedOrderVariationOption>;
  /** Extra line items that are part of the order, but aren't backed by `items`. e.g.: gratuity. Only for display. */
  readOnlyLineItems: Array<ExpertCuratedOrderLineItem>;
  /** Add-on items, where optional items can be unselected (removed from the final order) by the user */
  items: Array<ExpertCuratedOrderItem>;
  /** The total amount of time this order is set to be available for purchase by the consumer */
  availableForPurchaseDurationMinutes?: Maybe<Scalars['Int']>;
  /** The date the service is scheduled for the user */
  serviceStartAt?: Maybe<Scalars['Date']>;
  /**
   * If specified, the percent (between 1 and 99) of the total order value (before taxes and promotions) that is required
   * as an initial deposit
   */
  minimumDepositPercent?: Maybe<Scalars['Int']>;
  /** If specified, the percent (greater than 0) of the base order value (excluding tax, tips, gra) prepaid incidental */
  prepaidIncidentalPercent?: Maybe<Scalars['Int']>;
  /** When deposit is used, this is the days betfore `serviceStartAt` the remaining payment is due. */
  fullPaymentDueBeforeServiceStartDays?: Maybe<Scalars['Int']>;
  /** Derived payment due date from `fullPaymentDueBeforeServiceStartDays` */
  fullPaymentDueAt?: Maybe<Scalars['Date']>;
  consumerUrl: Scalars['String'];
  /**
   * Custom service orders are unique in that the actual curated experience is not purchase-able, but rather only
   * additional `items` are. The sellable service is still used as a parent line item to identify
   * what the extra addons are for, and for taxing the new items correctly, but the actual price of the service isn't
   * added in (and similarly, gratuity and such aren't added). This allows experts to extend a curated order of
   * arbitrary content after extending an initial curated order.
   */
  custom: Scalars['Boolean'];
  /**
   * If the curated order is in preview state; in other words, view-able by the consumer, but not purchase-able.
   * Curated orders in preview state cannot be purchased, and as such have lighter data requirements (e.g.: no
   * service start time is required). This allows surfacing curated orders to the customer to discuss, without the
   * expert having to have all the inventory secured while just discussing options.
   */
  inPreview: Scalars['Boolean'];
  /** Expert only field to view a pending draft update for this record */
  pendingDraftUpdate?: Maybe<ExpertCuratedOrder>;
  /** Previous expert curated order this order is replacing (if state is draft) / replaced (if state is not draft) */
  supersededOrder?: Maybe<ExpertCuratedOrder>;
  /**
   * If this expert curated order has been replaced by an updated order, this is the latest active expert curated order.
   * for example, if curated order A was replaced by A1, and A1 was replaced by A2, and A2 is active, this property for A
   * and A1 would resolve to A2. If there is no active replacement order, this will return null.
   */
  activeReplacementOrder?: Maybe<ExpertCuratedOrder>;
  /** The address which this service will be performed */
  serviceLocation?: Maybe<PostalAddress>;
  /**
   * Based on the `serviceLocation` and service being offered, if we support automatic tax computation. If not, it's
   * expected the expert will manually enter the tax.
   */
  taxWillBeAutomaticallyComputed: Scalars['Boolean'];
  /** For services that involve flight (e.g.: jet charters), the flight plan associated with this service. */
  flightPlan?: Maybe<FlightPlan>;
  defaultManualTaxAdjustment?: Maybe<ExpertCuratedOrderManualTaxAdjustment>;
  category: Category;
  /** used for email template. */
  selectedVariationOption: ExpertCuratedOrderVariationOption;
  /** used for expert notes */
  expertNote?: Maybe<Scalars['String']>;
};

export type ExpertCuratedOrderActivationError = {
  __typename: 'ExpertCuratedOrderActivationError';
  expertCuratedOrder: ExpertCuratedOrder;
  errorMessage?: Maybe<Scalars['String']>;
};

export type ExpertCuratedOrderAddOn = {
  __typename: 'ExpertCuratedOrderAddOn';
  title: Scalars['String'];
  totalCost: MonetaryAmount;
};

export type ExpertCuratedOrderChangedPayload = {
  __typename: 'ExpertCuratedOrderChangedPayload';
  expertCuratedOrder: ExpertCuratedOrder;
};

export enum ExpertCuratedOrderClosedReason {
  MANUAL = 'MANUAL',
  REPLACED = 'REPLACED'
}


export type ExpertCuratedOrderItem = {
  __typename: 'ExpertCuratedOrderItem';
  id: Scalars['SellableId'];
  title: Scalars['String'];
  price: MonetaryAmount;
  sellable: Sellable;
  taxable: Scalars['Boolean'];
  optional: Scalars['Boolean'];
  selected: Scalars['Boolean'];
  manualTaxAdjustment?: Maybe<ExpertCuratedOrderManualTaxAdjustment>;
};

/** References existing line items from the underlying order that aren't reified by this expert curated order */
export type ExpertCuratedOrderLineItem = {
  __typename: 'ExpertCuratedOrderLineItem';
  id: Scalars['OrderLineItemId'];
  title: Scalars['String'];
  price: MonetaryAmount;
  orderLineItem: OrderLineItem;
};

export type ExpertCuratedOrderListActivation = {
  __typename: 'ExpertCuratedOrderListActivation';
  id: Scalars['ExpertCuratedOrderListActivationId'];
  createdAt: Scalars['Date'];
  /** expert that activated these curated orders */
  activatedBy: BusinessUser;
  /** user these curated orders were created for; de-normalized from the lead */
  createdFor: User;
  /** the lead associated with this curated list activation */
  lead: Lead;
  /** expert curated orders that were just activated as part of this activation */
  activated: Array<ExpertCuratedOrder>;
  /** expert curated orders that were previously activated, and still active as part of this activation */
  existingActive: Array<ExpertCuratedOrder>;
  /** get all active curated orders as part of this activation */
  active: Array<ExpertCuratedOrder>;
  /**
   * expert curated order ids that were previously activated, but closed (removed) due to being superseded by the orders
   * in `activated`.
   */
  closed: Array<ExpertCuratedOrder>;
  consumerUrl: Scalars['String'];
  previousActivation?: Maybe<ExpertCuratedOrderListActivation>;
  /** used for trigger entity only to avoid unnecessary look up of Business User */
  activatedById: Scalars['BusinessUserId'];
};

export type ExpertCuratedOrderListActivationConnection = {
  __typename: 'ExpertCuratedOrderListActivationConnection';
  edges: Array<ExpertCuratedOrderListActivationEdge>;
  pageInfo: PageInfo;
};

export type ExpertCuratedOrderListActivationEdge = {
  __typename: 'ExpertCuratedOrderListActivationEdge';
  node: ExpertCuratedOrderListActivation;
  cursor: Scalars['String'];
};


export type ExpertCuratedOrderListActivationPublicView = {
  __typename: 'ExpertCuratedOrderListActivationPublicView';
  id: Scalars['ExpertCuratedOrderListActivationId'];
  createdAt: Scalars['Date'];
  /** expert that activated these curated orders */
  activatedBy: BusinessUser;
  createdForName?: Maybe<Scalars['String']>;
  /** the user for this this curated list activation.  It is used to check if the current logged in is the curation owner */
  createdForId: Scalars['UserId'];
  /** the lead id associated with this curated list activation.  It is used to redirect logged user in to the curation page. */
  leadId: Scalars['LeadId'];
  active: Array<ExpertCuratedOrderPublicView>;
  publicViewUrl: Scalars['String'];
};

export type ExpertCuratedOrderManualTaxAdjustment = {
  __typename: 'ExpertCuratedOrderManualTaxAdjustment';
  taxRate?: Maybe<Scalars['BigDecimal']>;
  amount?: Maybe<MonetaryAmount>;
  computedFromAmount?: Maybe<MonetaryAmount>;
};

export type ExpertCuratedOrderManualTaxAdjustmentInput = {
  taxRate?: Maybe<Scalars['BigDecimal']>;
  amount?: Maybe<MonetaryAmountInput>;
  computedFromAmount?: Maybe<MonetaryAmountInput>;
};

export type ExpertCuratedOrderPublicView = {
  __typename: 'ExpertCuratedOrderPublicView';
  id: Scalars['ExpertCuratedOrderId'];
  createdAt: Scalars['Date'];
  curator: BusinessUser;
  curatedForName?: Maybe<Scalars['String']>;
  /** used for email template */
  variationOptionsWithPriceBreakdown: Array<ExpertCuratedOrderVariationOptionPriceBreakdown>;
  expertNote?: Maybe<Scalars['String']>;
};


export type ExpertCuratedOrderPublicViewVariationOptionsWithPriceBreakdownArgs = {
  maxOptions?: Maybe<Scalars['Int']>;
};

export enum ExpertCuratedOrderSelectErrorCode {
  /**
   * Expert curated order is not in an active state. This may be due to the curated order being replaced, or manually
   * closed. If being replaced, {@link #getActiveReplacement()} will have the updated curated order.
   */
  NOT_ACTIVE = 'NOT_ACTIVE'
}

export enum ExpertCuratedOrderServiceLocationErrorCode {
  /** An invalid address was supplied. */
  INVALID_ADDRESS = 'INVALID_ADDRESS'
}

export type ExpertCuratedOrdersForLeadConnection = {
  __typename: 'ExpertCuratedOrdersForLeadConnection';
  edges: Array<ExpertCuratedOrdersForLeadEdge>;
  pageInfo: PageInfo;
};

export type ExpertCuratedOrdersForLeadConnectionChangedPayload = {
  __typename: 'ExpertCuratedOrdersForLeadConnectionChangedPayload';
  connection: ExpertCuratedOrdersForLeadConnection;
};

export type ExpertCuratedOrdersForLeadEdge = {
  __typename: 'ExpertCuratedOrdersForLeadEdge';
  node: ExpertCuratedOrder;
  cursor: Scalars['String'];
};

export enum ExpertCuratedOrdersForLeadQueryCustomFilter {
  /** Show custom and not custom */
  INCLUDE = 'INCLUDE',
  /** Only show custom */
  ONLY = 'ONLY',
  /** Show no custom; only non custom */
  NONE = 'NONE'
}

export enum ExpertCuratedOrdersForLeadQueryDraftFilter {
  /** Show all drafts and non drafts */
  INCLUDE = 'INCLUDE',
  /** Show drafts that are newly created (not from replacing an existing curated order) and non drafts */
  INCLUDE_CREATED_DRAFT = 'INCLUDE_CREATED_DRAFT',
  /** Only show drafts (and no non drafts) */
  ONLY = 'ONLY',
  /** Show no drafts; only non drafts */
  NONE = 'NONE'
}

export type ExpertCuratedOrdersForLeadQueryInput = {
  leadId: Scalars['LeadId'];
  /** Defaults to `NONE` */
  draftFilter?: Maybe<ExpertCuratedOrdersForLeadQueryDraftFilter>;
  /** Defaults to `NONE` */
  customFilter?: Maybe<ExpertCuratedOrdersForLeadQueryCustomFilter>;
  /** Show curated orders that are in state EXPIRED or CLOSED, defaults to false */
  showClosed?: Maybe<Scalars['Boolean']>;
};

export enum ExpertCuratedOrderState {
  DRAFT = 'DRAFT',
  ACTIVE = 'ACTIVE',
  CLOSED = 'CLOSED',
  EXPIRED = 'EXPIRED'
}

export type ExpertCuratedOrderVariationOption = {
  __typename: 'ExpertCuratedOrderVariationOption';
  sellable: Sellable;
  price: MonetaryAmount;
  enabled: Scalars['Boolean'];
  selected: Scalars['Boolean'];
  manualTaxAdjustment?: Maybe<ExpertCuratedOrderManualTaxAdjustment>;
};

/**
 * This is only used for curated order email template and guest curation page.
 * We are being very strict on fields exposed and we want to list the order details for every variant.
 */
export type ExpertCuratedOrderVariationOptionPriceBreakdown = {
  __typename: 'ExpertCuratedOrderVariationOptionPriceBreakdown';
  option: ExpertCuratedOrderVariationOption;
  gratuity: MonetaryAmount;
  basePrice: MonetaryAmount;
  tax: MonetaryAmount;
  totalCost: MonetaryAmount;
  totalCostWithoutAddOns: MonetaryAmount;
  prepaidIncidental: MonetaryAmount;
  addOns: Array<ExpertCuratedOrderAddOn>;
};

export type ExpertDeactivatedActivity = BusinessUserActivity & {
  __typename: 'ExpertDeactivatedActivity';
  id: Scalars['BusinessUserActivityId'];
  type: BusinessUserActivityType;
  occurredAt: Scalars['Date'];
};

export type ExpertDiscountCashUploadTaskError = {
  __typename: 'ExpertDiscountCashUploadTaskError';
  row: Scalars['Int'];
  message: Scalars['String'];
};

export type ExpertDiscountCashUploadTaskPayload = {
  __typename: 'ExpertDiscountCashUploadTaskPayload';
  numRowsProcessed: Scalars['Int'];
  numRowsIgnored: Scalars['Int'];
  errors: Array<ExpertDiscountCashUploadTaskError>;
  googleSpreadsheetId: Scalars['String'];
};

export type ExpertFeedbackRequestRichCard = MessageRichCard & {
  __typename: 'ExpertFeedbackRequestRichCard';
  type: MessageRichCardType;
  expertId: Scalars['BusinessUserId'];
  leadId: Scalars['LeadId'];
};

export enum ExpertGender {
  MALE = 'MALE',
  FEMALE = 'FEMALE',
  OTHER = 'OTHER'
}

export type ExpertHiringFeedback = {
  __typename: 'ExpertHiringFeedback';
  id: Scalars['ExpertHiringFeedbackId'];
  submittedAt: Scalars['Date'];
  submittedBy: ExpertApplicationReviewer;
  application: ExpertApplication;
  detail: ExpertHiringFeedbackDetail;
  state: ExpertHiringFeedbackState;
};

export type ExpertHiringFeedbackDetail = {
  type: ExpertHiringFeedbackType;
};


export enum ExpertHiringFeedbackState {
  DRAFT = 'DRAFT',
  SUBMITTED = 'SUBMITTED'
}

export enum ExpertHiringFeedbackType {
  INTERVIEW_FEEDBACK = 'INTERVIEW_FEEDBACK',
  APPLICATION_EVALUATION = 'APPLICATION_EVALUATION',
  APPLICATION_RATING = 'APPLICATION_RATING'
}

export type ExpertHiringFlow = {
  __typename: 'ExpertHiringFlow';
  id: Scalars['ExpertHiringFlowId'];
  stages: Array<ExpertHiringFlowStage>;
  slug: Scalars['String'];
};


export type ExpertHiringFlowStage = {
  __typename: 'ExpertHiringFlowStage';
  id: Scalars['ExpertHiringFlowStageId'];
  slug: Scalars['String'];
  displayName: Scalars['String'];
  taskConfigs: Array<ExpertApplicationTaskConfig>;
};


export type ExpertInterviewFeedback = ExpertHiringFeedbackDetail & {
  __typename: 'ExpertInterviewFeedback';
  type: ExpertHiringFeedbackType;
  summary: Scalars['String'];
};

export type ExpertInterviewFeedbackInput = {
  summary: Scalars['String'];
};

export type ExpertJoinedRichCard = MessageRichCard & {
  __typename: 'ExpertJoinedRichCard';
  type: MessageRichCardType;
  expertId: Scalars['BusinessUserId'];
};

export type ExpertLeadEligibility = {
  __typename: 'ExpertLeadEligibility';
  eligible: Scalars['Boolean'];
  detailReason?: Maybe<Scalars['String']>;
};

export type ExpertLeadEligibilityChange = {
  __typename: 'ExpertLeadEligibilityChange';
  id: Scalars['BusinessUserId'];
  eligibility: ExpertLeadEligibility;
};

export type ExpertLeadFolder = {
  __typename: 'ExpertLeadFolder';
  id: Scalars['ExpertLeadFolderId'];
  totalCount?: Maybe<Scalars['Int']>;
  revenue?: Maybe<MonetaryAmount>;
  slug: Scalars['String'];
  displayName: Scalars['String'];
  description?: Maybe<Scalars['String']>;
};

export type ExpertLeadFolderGroup = {
  __typename: 'ExpertLeadFolderGroup';
  type: ExpertLeadFolderGroupType;
  displayName: Scalars['String'];
  folders: Array<ExpertLeadFolder>;
};

export enum ExpertLeadFolderGroupType {
  INBOX = 'INBOX',
  INBOX_ASSISTANT = 'INBOX_ASSISTANT',
  SALES_PIPELINE = 'SALES_PIPELINE',
  FOLDERS = 'FOLDERS'
}


export type ExpertLeadFolderItemChange = {
  __typename: 'ExpertLeadFolderItemChange';
  lead: Lead;
  count: Scalars['Int'];
  type: ExpertLeadFolderItemChangeType;
};

export enum ExpertLeadFolderItemChangeType {
  ADD = 'ADD',
  REMOVE = 'REMOVE',
  UPDATE = 'UPDATE'
}

export type ExpertLeadGate = {
  __typename: 'ExpertLeadGate';
  broadcastLeadClaimDisabled: Scalars['Boolean'];
  newLeadClaimDisabled: Scalars['Boolean'];
  type: ExpertLeadGateType;
  message?: Maybe<Scalars['String']>;
  detailedMessage?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['Date']>;
  updatedBy?: Maybe<Identity>;
};

export type ExpertLeadGateAddedActivity = BusinessUserActivity & {
  __typename: 'ExpertLeadGateAddedActivity';
  id: Scalars['BusinessUserActivityId'];
  type: BusinessUserActivityType;
  occurredAt: Scalars['Date'];
  leadGate: ExpertLeadGate;
};

export type ExpertLeadGateRemovedActivity = BusinessUserActivity & {
  __typename: 'ExpertLeadGateRemovedActivity';
  id: Scalars['BusinessUserActivityId'];
  type: BusinessUserActivityType;
  occurredAt: Scalars['Date'];
  leadGate: ExpertLeadGate;
};

export enum ExpertLeadGateType {
  NEW_EXPERT = 'NEW_EXPERT',
  ADMIN_OVERRIDE = 'ADMIN_OVERRIDE'
}

export type ExpertNoteAttributeSchemaMetadata = AttributeSchemaMetadata & {
  __typename: 'ExpertNoteAttributeSchemaMetadata';
  type: AttributeSchemaMetadataType;
  visibility: ExpertNoteVisibilityType;
  department: Department;
  requiredForReview: Scalars['Boolean'];
  rank: Scalars['Int'];
};

export type ExpertNoteAttributeSchemaMetadataInput = {
  visibility: ExpertNoteVisibilityType;
  departmentId: Scalars['DepartmentId'];
  requiredForReview: Scalars['Boolean'];
  rank: Scalars['Int'];
};

export enum ExpertNoteVisibilityType {
  PUBLIC = 'PUBLIC',
  PRIVATE = 'PRIVATE'
}

export type ExpertNotification = {
  type: ExpertNotificationType;
  occurredAt: Scalars['Date'];
};

export type ExpertNotificationLeadEscalation = ExpertNotification & {
  __typename: 'ExpertNotificationLeadEscalation';
  type: ExpertNotificationType;
  leadEscalation?: Maybe<LeadEscalation>;
  occurredAt: Scalars['Date'];
};

export type ExpertNotificationLeadSurge = ExpertNotification & {
  __typename: 'ExpertNotificationLeadSurge';
  type: ExpertNotificationType;
  leadSurge: LeadSurge;
  occurredAt: Scalars['Date'];
};

export enum ExpertNotificationMode {
  NONE = 'NONE',
  ALWAYS = 'ALWAYS',
  WHEN_NOT_ACTIVATED = 'WHEN_NOT_ACTIVATED',
  WHEN_NOT_ONLINE = 'WHEN_NOT_ONLINE'
}

export type ExpertNotificationPresenceStatusChange = ExpertNotification & {
  __typename: 'ExpertNotificationPresenceStatusChange';
  type: ExpertNotificationType;
  expert: BusinessUser;
  previousStatus?: Maybe<ExpertPresenceStatus>;
  occurredAt: Scalars['Date'];
};

export type ExpertNotificationShiftEnded = ExpertNotification & {
  __typename: 'ExpertNotificationShiftEnded';
  type: ExpertNotificationType;
  expert: BusinessUser;
  occurredAt: Scalars['Date'];
  previousStatus: ExpertPresenceStatus;
};

export enum ExpertNotificationType {
  LEAD_ESCALATION = 'LEAD_ESCALATION',
  PRESENCE_STATUS_CHANGE = 'PRESENCE_STATUS_CHANGE',
  SHIFT_ENDED = 'SHIFT_ENDED',
  LEAD_SURGE = 'LEAD_SURGE'
}

export type ExpertPerformance = {
  __typename: 'ExpertPerformance';
  rating: ExpertPerformanceRating;
  overrideExpiresAt?: Maybe<Scalars['Date']>;
};

export enum ExpertPerformanceRating {
  NEW = 'NEW',
  MASTER = 'MASTER',
  DIAMOND = 'DIAMOND',
  PLATINUM = 'PLATINUM',
  GOLD = 'GOLD',
  SILVER = 'SILVER',
  BRONZE = 'BRONZE'
}

export type ExpertPerformanceStatistics = {
  __typename: 'ExpertPerformanceStatistics';
  expert: BusinessUser;
  category?: Maybe<Category>;
  sixtyDayStats: ExpertPerformanceStatisticsForInterval;
  threeSixtyFiveDayStats: ExpertPerformanceStatisticsForInterval;
  effectiveRevenuePerLead: MonetaryAmount;
  effectiveConversionRate: Scalars['BigDecimal'];
};

export type ExpertPerformanceStatisticsFilter = {
  categoryId?: Maybe<Scalars['CategoryId']>;
  departmentId?: Maybe<Scalars['DepartmentId']>;
  teamId?: Maybe<Scalars['BusinessUserTeamId']>;
};

export type ExpertPerformanceStatisticsForInterval = {
  __typename: 'ExpertPerformanceStatisticsForInterval';
  shiftCount: Scalars['Int'];
  activeLeads: Scalars['Int'];
  directActiveLeads: Scalars['Int'];
  directQualityConversations: Scalars['Int'];
  activeLeadsWithPurchase: Scalars['Int'];
  directActiveLeadsWithPurchase: Scalars['Int'];
  totalBaseRevenueAmount: MonetaryAmount;
  totalTipAmount: MonetaryAmount;
  strictRevenuePerLead: MonetaryAmount;
  looseRevenuePerLead: MonetaryAmount;
  effectiveRevenuePerLead: MonetaryAmount;
  directLeadConversionRate: Scalars['BigDecimal'];
  directLeadQualityConversationRate: Scalars['BigDecimal'];
  activeLeadConversionRate: Scalars['BigDecimal'];
};

export type ExpertPerformanceStatisticsPayload = {
  __typename: 'ExpertPerformanceStatisticsPayload';
  rows: Array<ExpertPerformanceStatistics>;
  count: Scalars['Int'];
};

export type ExpertPresence = {
  status: ExpertPresenceStatus;
  acceptingNewLeads: Scalars['Boolean'];
};

export type ExpertPresenceAway = ExpertPresence & {
  __typename: 'ExpertPresenceAway';
  status: ExpertPresenceStatus;
  startedAt: Scalars['Date'];
  endsAt: Scalars['Date'];
  autoReply: AwayAutoReply;
  acceptingNewLeads: Scalars['Boolean'];
};

export type ExpertPresenceOffShift = ExpertPresence & {
  __typename: 'ExpertPresenceOffShift';
  status: ExpertPresenceStatus;
  acceptingNewLeads: Scalars['Boolean'];
};

export type ExpertPresenceOnCall = ExpertPresence & {
  __typename: 'ExpertPresenceOnCall';
  status: ExpertPresenceStatus;
  startedAt: Scalars['Date'];
  endsAt: Scalars['Date'];
  acceptingNewLeads: Scalars['Boolean'];
};

export type ExpertPresenceOnShift = ExpertPresence & {
  __typename: 'ExpertPresenceOnShift';
  status: ExpertPresenceStatus;
  startedAt: Scalars['Date'];
  endsAt: Scalars['Date'];
  acceptingNewLeads: Scalars['Boolean'];
};

export type ExpertPresenceOnStandby = ExpertPresence & {
  __typename: 'ExpertPresenceOnStandby';
  status: ExpertPresenceStatus;
  startedAt: Scalars['Date'];
  endsAt: Scalars['Date'];
  acceptingNewLeads: Scalars['Boolean'];
};

export enum ExpertPresenceStatus {
  OFF_SHIFT = 'OFF_SHIFT',
  ON_SHIFT = 'ON_SHIFT',
  ON_STANDBY = 'ON_STANDBY',
  ON_CALL = 'ON_CALL',
  AWAY = 'AWAY'
}

export type ExpertPresenceStatusUpdateResponse = {
  __typename: 'ExpertPresenceStatusUpdateResponse';
  businessUser?: Maybe<BusinessUser>;
  error?: Maybe<Scalars['String']>;
};

export type ExpertProfile = {
  __typename: 'ExpertProfile';
  id: Scalars['ExpertProfileId'];
  user: User;
  headline: Scalars['String'];
  background: Scalars['String'];
  backgroundRichText?: Maybe<Scalars['String']>;
  location?: Maybe<Scalars['String']>;
  profilePhoto?: Maybe<MediaFile>;
  gallery: Array<MediaFileWithCaption>;
  recentArticles: Array<ExternalContent>;
  quotes: Array<Scalars['String']>;
  isDraft: Scalars['Boolean'];
  socialMediaUrls: Array<Scalars['String']>;
  socialMediaLinks: Array<SocialMediaLink>;
  highlights: Array<ProfileHighlight>;
  editableHighlightTypes: Array<ProfileHighlightType>;
  state: ExpertProfileState;
  businessUser: BusinessUser;
  submittedAt?: Maybe<Scalars['Date']>;
  publishedAt?: Maybe<Scalars['Date']>;
  changeRequestedAt?: Maybe<Scalars['Date']>;
  changeRequestNotes?: Maybe<Scalars['String']>;
  introductionVideoUrl?: Maybe<Scalars['String']>;
  introductionVideo?: Maybe<MediaFile>;
  introductionVideoLink?: Maybe<ExternalVideoLink>;
  socialMediaAccessTokens: Array<SocialMediaAccessToken>;
  currentGears: Array<Sellable>;
  favoriteBrands: Array<Brand>;
  gender?: Maybe<ExpertGender>;
  portraitVideo?: Maybe<MediaFile>;
  spotlightHeadline?: Maybe<Scalars['String']>;
};


export type ExpertProfileQuery = {
  states: Array<ExpertProfileState>;
};

export type ExpertProfileRequestChangesInput = {
  expertProfileId: Scalars['ExpertProfileId'];
  notes?: Maybe<Scalars['String']>;
};

export type ExpertProfilesPagination = {
  __typename: 'ExpertProfilesPagination';
  profiles: Array<ExpertProfile>;
  count: Scalars['Long'];
};

export enum ExpertProfileState {
  DRAFT = 'DRAFT',
  SUBMITTED = 'SUBMITTED',
  PUBLISHED = 'PUBLISHED'
}

export type ExpertRankComputationLog = {
  __typename: 'ExpertRankComputationLog';
  id: Scalars['ExpertRankComputationLogId'];
  beforeRating: ExpertPerformanceRating;
  afterRating: ExpertPerformanceRating;
  performanceStatistics: ExpertPerformanceStatistics;
  override: Scalars['Boolean'];
  createdAt: Scalars['Date'];
};


export type ExpertRecommendationAssistantFirst = ExpertRecommendationRecord & {
  __typename: 'ExpertRecommendationAssistantFirst';
  id: Scalars['ExpertRecommendationId'];
  strategy: ExpertRecommendationStrategy;
  occurredAt: Scalars['Date'];
  consumer: User;
  assignedTo?: Maybe<BusinessUser>;
  resultingLead?: Maybe<Lead>;
  resultingLeadCreatedAt?: Maybe<Scalars['Date']>;
};

export type ExpertRecommendationByLeastWorkloadRecord = ExpertRecommendationRecord & {
  __typename: 'ExpertRecommendationByLeastWorkloadRecord';
  id: Scalars['ExpertRecommendationId'];
  strategy: ExpertRecommendationStrategy;
  occurredAt: Scalars['Date'];
  consumer: User;
  assignedTo?: Maybe<BusinessUser>;
  resultingLead?: Maybe<Lead>;
  resultingLeadCreatedAt?: Maybe<Scalars['Date']>;
  primaryExperts: Array<BusinessUser>;
  backupExperts: Array<BusinessUser>;
  expertWorkloads: Array<ExpertWorkloadForRecommendation>;
  fallbackExpertUsed: Scalars['Boolean'];
};

export type ExpertRecommendationByPerformanceWeightCandidate = {
  __typename: 'ExpertRecommendationByPerformanceWeightCandidate';
  expert: BusinessUser;
  rating: ExpertPerformanceRating;
  externalMarketingBudget: MonetaryAmount;
  workload: Scalars['Float'];
  capacity: Scalars['Float'];
  acceptingNewLead: Scalars['Boolean'];
  eligible: Scalars['Boolean'];
};

export type ExpertRecommendationByPerformanceWeightRecord = ExpertRecommendationRecord & {
  __typename: 'ExpertRecommendationByPerformanceWeightRecord';
  id: Scalars['ExpertRecommendationId'];
  strategy: ExpertRecommendationStrategy;
  occurredAt: Scalars['Date'];
  consumer: User;
  assignedTo?: Maybe<BusinessUser>;
  resultingLead?: Maybe<Lead>;
  resultingLeadCreatedAt?: Maybe<Scalars['Date']>;
  fallbackExpertUsed: Scalars['Boolean'];
  expertCandidates: Array<ExpertRecommendationByPerformanceWeightCandidate>;
  newRelationship: Scalars['Boolean'];
};


export type ExpertRecommendationRecord = {
  id: Scalars['ExpertRecommendationId'];
  strategy: ExpertRecommendationStrategy;
  occurredAt: Scalars['Date'];
  consumer: User;
  assignedTo?: Maybe<BusinessUser>;
  resultingLead?: Maybe<Lead>;
  resultingLeadCreatedAt?: Maybe<Scalars['Date']>;
};

export enum ExpertRecommendationStrategy {
  LEAST_WORKLOAD = 'LEAST_WORKLOAD',
  PERFORMANCE_WEIGHTED = 'PERFORMANCE_WEIGHTED',
  ASSISTANT_FIRST = 'ASSISTANT_FIRST'
}

export type ExpertReferral = {
  __typename: 'ExpertReferral';
  id: Scalars['ExpertReferralId'];
  expert: BusinessUser;
  referrer: User;
  note: Scalars['String'];
  referralUrl: Scalars['String'];
  fromExpert: Scalars['Boolean'];
  contactType: ContactType;
  contactValue: Scalars['String'];
};


export type ExpertReferralRequestRichCard = MessageRichCard & {
  __typename: 'ExpertReferralRequestRichCard';
  type: MessageRichCardType;
  expertId: Scalars['BusinessUserId'];
};

export type ExpertSearchConnection = {
  __typename: 'ExpertSearchConnection';
  facets: Array<DisplayFacet>;
  filters: Array<FilterFieldCondition>;
  edges: Array<ExpertSearchEdge>;
  pageInfo: PageInfo;
  count: Scalars['Int'];
};

export type ExpertSearchEdge = {
  __typename: 'ExpertSearchEdge';
  node: BusinessUser;
  cursor: Scalars['String'];
};

export type ExpertSearchQuery = {
  name?: Maybe<Scalars['String']>;
  keywords?: Maybe<Scalars['String']>;
  categoryIds?: Maybe<Array<Scalars['CategoryId']>>;
  departmentIds?: Maybe<Array<Scalars['DepartmentId']>>;
  facetedSearch: Scalars['Boolean'];
  facets?: Maybe<Array<FacetSelection>>;
  includePlaceHolderExpert?: Maybe<Scalars['Boolean']>;
  featuredOnly?: Maybe<Scalars['Boolean']>;
  filters?: Maybe<Array<SearchFilterFieldInput>>;
};

export enum ExpertSearchSort {
  DEFAULT = 'DEFAULT',
  PERFORMANCE = 'PERFORMANCE',
  FEATURED = 'FEATURED'
}

export type ExpertSellableRecommendationCount = {
  __typename: 'ExpertSellableRecommendationCount';
  expert: BusinessUser;
  timesRecommended: Scalars['Int'];
};

export type ExpertSellableRecommendationCountConnection = {
  __typename: 'ExpertSellableRecommendationCountConnection';
  pageInfo: PageInfo;
  /** The total number of experts recommending the sellable */
  total: Scalars['Int'];
  /** the number of experts in this page */
  count: Scalars['Int'];
  /** number of times this sellable was recommended by across all experts */
  timesRecommendedByAllExperts: Scalars['Int'];
  edges: Array<ExpertSellableRecommendationCountEdge>;
};

export type ExpertSellableRecommendationCountEdge = {
  __typename: 'ExpertSellableRecommendationCountEdge';
  cursor: Scalars['String'];
  node: ExpertSellableRecommendationCount;
};

export type ExpertShiftProbation = ShiftProbation & {
  __typename: 'ExpertShiftProbation';
  startsAt: Scalars['Date'];
  endsAt: Scalars['Date'];
  shiftAssignmentDisabled: Scalars['Boolean'];
  broadcastLeadClaimDisabled: Scalars['Boolean'];
  openShiftClaimDisabled: Scalars['Boolean'];
  totalEffectiveAbsences: Scalars['Int'];
};

export type ExpertStats = {
  __typename: 'ExpertStats';
  totalMessagesSent: Scalars['Int'];
  totalLeadsAsPrimaryExpert: Scalars['Int'];
  totalLeadsParticipated: Scalars['Int'];
  messageLastSentAt?: Maybe<Scalars['Date']>;
  averageRating?: Maybe<Scalars['Float']>;
  totalReviews: Scalars['Int'];
  topGoodQualities: Array<Scalars['String']>;
  firstShiftEndedAt?: Maybe<Scalars['Date']>;
  last90DaysShifts: Scalars['Int'];
};

export type ExpertTipPercentage = {
  __typename: 'ExpertTipPercentage';
  expert: BusinessUser;
  /** Value between 1 and 100 */
  percentOfTip: Scalars['Int'];
};

export type ExpertTipPercentageInput = {
  expertId: Scalars['BusinessUserId'];
  /** Value between 1 and 100 */
  percentOfTip: Scalars['Int'];
};

export type ExpertTopRecommendedBrand = {
  __typename: 'ExpertTopRecommendedBrand';
  brand: Brand;
  timesRecommended?: Maybe<Scalars['Int']>;
};

export type ExpertTopRecommendedBrandsInput = {
  expertId: Scalars['BusinessUserId'];
  departmentId: Scalars['DepartmentId'];
  topN?: Maybe<Scalars['Int']>;
};

export type ExpertTopRecommendedBrandsPayload = {
  __typename: 'ExpertTopRecommendedBrandsPayload';
  topRecommendedBrands: Array<ExpertTopRecommendedBrand>;
};

export type ExpertTopRecommendedSellable = {
  __typename: 'ExpertTopRecommendedSellable';
  sellable: Sellable;
  timesRecommended?: Maybe<Scalars['Int']>;
};

export type ExpertTopRecommendedSellablesInput = {
  expertId: Scalars['BusinessUserId'];
  departmentId: Scalars['DepartmentId'];
  maxRecommendationsPerCategory?: Maybe<Scalars['Int']>;
  recommendedAfter?: Maybe<Scalars['Date']>;
};

export type ExpertTopRecommendedSellablesPayload = {
  __typename: 'ExpertTopRecommendedSellablesPayload';
  categoryTopRecommendedSellables: Array<ExpertCategoryTopRecommendedSellable>;
};

export type ExpertTypeaheadPayload = {
  __typename: 'ExpertTypeaheadPayload';
  experts: Array<BusinessUser>;
};

export type ExpertTypeaheadQuery = {
  prefixSearch: Scalars['String'];
  departmentId?: Maybe<Scalars['DepartmentId']>;
  categoryIds?: Maybe<Array<Scalars['CategoryId']>>;
  expertTeamId?: Maybe<Scalars['BusinessUserTeamId']>;
  includeArticleAuthors?: Maybe<Scalars['Boolean']>;
  includeDeactivated?: Maybe<Scalars['Boolean']>;
};

export type ExpertWorkloadForRecommendation = {
  __typename: 'ExpertWorkloadForRecommendation';
  expert: BusinessUser;
  workload: Scalars['Float'];
  capacity: Scalars['Float'];
};

export type ExtendExpertCuratedItemExpirationInput = {
  id: Scalars['ExpertCuratedItemId'];
  /** When the top-level sellable is ad-hoc, to extend the expiration, a new sale price must be provided */
  salePrice?: Maybe<MonetaryAmountInput>;
};

export type ExtendExpertCuratedItemExpirationPayload = {
  __typename: 'ExtendExpertCuratedItemExpirationPayload';
  expertCuratedItem?: Maybe<ExpertCuratedItem>;
  error?: Maybe<Scalars['String']>;
  hasError: Scalars['Boolean'];
};

export type ExternalAdCampaign = {
  __typename: 'ExternalAdCampaign';
  id: Scalars['ExternalAdCampaignId'];
  name: Scalars['String'];
  adPlatform: ExternalAdPlatform;
  category: Category;
  externalId: Scalars['String'];
  status: ExternalAdStatus;
  /**
   * The normalized budget allocated to this campaign. The value here means assuming the total budget is 100, what would
   * be the budget allocated for this campaign. For example, if the value is 30, and the total budget is 150, the actual
   * budget for this campaign is 45.
   */
  normalizedBudget: Scalars['BigDecimal'];
  adGroups: Array<ExternalAdGroup>;
};


export type ExternalAdGroup = {
  __typename: 'ExternalAdGroup';
  id: Scalars['ExternalAdGroupId'];
  adCampaign: ExternalAdCampaign;
  name: Scalars['String'];
  adPlatform: ExternalAdPlatform;
  externalId: Scalars['String'];
  status: ExternalAdStatus;
  /**
   * The normalized budget allocated to this ad group. The value here means assuming the total budget is 100, what would
   * be the budget allocated for this ad group. For example, if the value is 30, and the total budget is 150, the actual
   * budget for this ad group is 45.
   */
  normalizedBudget?: Maybe<Scalars['BigDecimal']>;
  /**
   * The campaign normalized budget allocated to this ad group. The value here means assuming the campaign budget is
   * 100, what would be the budget allocated for this ad group. This value is used to calculate the normalized budget.
   */
  campaignNormalizedBudget?: Maybe<Scalars['BigDecimal']>;
};


export enum ExternalAdPlatform {
  FACEBOOK = 'FACEBOOK',
  GOOGLE = 'GOOGLE'
}

export enum ExternalAdStatus {
  ACTIVE = 'ACTIVE',
  PAUSED = 'PAUSED',
  DELETED = 'DELETED'
}

export type ExternalContent = {
  __typename: 'ExternalContent';
  title: Scalars['String'];
  description?: Maybe<Scalars['String']>;
  url: Scalars['String'];
  imageUrl?: Maybe<Scalars['String']>;
};

export type ExternalContentInput = {
  title: Scalars['String'];
  url: Scalars['String'];
  description?: Maybe<Scalars['String']>;
  imageUrl?: Maybe<Scalars['String']>;
};

export type ExternalInventoryItemSource = {
  type: ExternalInventoryItemSourceType;
};

export enum ExternalInventoryItemSourceType {
  SHOPIFY = 'SHOPIFY'
}

export type ExternalProfile = {
  type: ExternalProfileType;
};

export enum ExternalProfileType {
  FACEBOOK_MESSENGER = 'FACEBOOK_MESSENGER',
  PIPL = 'PIPL'
}

export type ExternalVideo = {
  __typename: 'ExternalVideo';
  /**
   * ID for the video. This can be extracted from the url, for example, url `https://www.youtube.com/watch?v=0tHH0BNH0Sc`
   * has an id of `0tHH0BNH0Sc`
   */
  id: Scalars['String'];
  /** Video type */
  idType: ExternalVideoIdType;
  /** This is the url to view the video on the website for idType */
  destinationUrl: Scalars['String'];
};

export enum ExternalVideoIdType {
  YOUTUBE = 'YOUTUBE',
  VIMEO = 'VIMEO'
}

export type ExternalVideoLink = {
  __typename: 'ExternalVideoLink';
  smallUrl: Scalars['String'];
  mediumUrl: Scalars['String'];
  largeUrl: Scalars['String'];
  xLargeUrl: Scalars['String'];
};

export type ExternalVideoLinkInput = {
  smallUrl: Scalars['String'];
  mediumUrl: Scalars['String'];
  largeUrl: Scalars['String'];
  xLargeUrl: Scalars['String'];
};

export type FacebookMessengerPathFlowPageMetadata = PathFlowPageMetadata & {
  __typename: 'FacebookMessengerPathFlowPageMetadata';
  type: PathFlowPageMetadataType;
};

export type FacebookMessengerProfile = ExternalProfile & {
  __typename: 'FacebookMessengerProfile';
  id: Scalars['String'];
  type: ExternalProfileType;
  firstName?: Maybe<Scalars['String']>;
  lastName?: Maybe<Scalars['String']>;
  avatarUrl?: Maybe<Scalars['String']>;
  locale?: Maybe<Scalars['String']>;
  timezone?: Maybe<Scalars['String']>;
  gender?: Maybe<Scalars['String']>;
};

export type FacebookTcpaComplianceMetadata = PathFlowPageMetadata & {
  __typename: 'FacebookTCPAComplianceMetadata';
  type: PathFlowPageMetadataType;
};

export type FacebookTemplate = ChannelTemplate & {
  __typename: 'FacebookTemplate';
  channelType: ChannelType;
  body: Scalars['String'];
};

export type FacebookTemplateInput = {
  body: Scalars['String'];
};

export type FacetImageMetadata = {
  type: FacetImageType;
};

export enum FacetImageType {
  /** Facets that are shown as Icons on the UI */
  ICON = 'ICON',
  /** BACKGROUND */
  BACKGROUND = 'BACKGROUND'
}

export type FacetSelection = {
  /** Internal name or alias for facet that's being selected, typically from DisplayFacet.name or DisplayFacet.alias */
  name: Scalars['String'];
  /** If this facet is a BucketedDisplayFacet, the `IndividualBucketedDisplayFacet.value`s that were selected. */
  bucketValues?: Maybe<Array<Scalars['String']>>;
  /** If this facet is a NumericRangeDisplayFacet, the unscaled lower bound that's being set. */
  lower?: Maybe<Scalars['Long']>;
  /** If this facet is a NumericRangeDisplayFacet, the unscaled upper bound that's being set. */
  upper?: Maybe<Scalars['Long']>;
  /**
   * The scale `lower` and `upper` is in; `(value x 10 ^ (-scale))` should be used to compute the actual value.
   * Defaults to 0 (which makes unscaled value == scaled value).
   */
  scale?: Maybe<Scalars['Int']>;
};

export type FacetSelectionPayload = {
  __typename: 'FacetSelectionPayload';
  name: Scalars['String'];
  displayName: Scalars['String'];
  alias?: Maybe<Scalars['String']>;
  bucketValues?: Maybe<Array<Scalars['String']>>;
  lower?: Maybe<Scalars['Long']>;
  upper?: Maybe<Scalars['Long']>;
  scale?: Maybe<Scalars['Int']>;
};

export type FacetTypeaheadMetadata = {
  __typename: 'FacetTypeaheadMetadata';
  supported: Scalars['Boolean'];
};

export type FacetTypeaheadPayload = {
  __typename: 'FacetTypeaheadPayload';
  value: Scalars['String'];
  displayName: Scalars['String'];
};

/** Featured rich content from various sites (e.g.: YouTube, Instagram, review sites, etc) */
export type FeaturedSellableContent = {
  __typename: 'FeaturedSellableContent';
  id: Scalars['SellableId'];
  /** ID portion of instagram url. */
  instagramPostIds: Array<Scalars['String']>;
  /** Relevant instagram hash tag */
  instagramHashTag?: Maybe<Scalars['String']>;
  /** Videos hosted by sites like YouTube */
  externalVideos: Array<ExternalVideo>;
  /** Brochure */
  brochureUrl?: Maybe<Scalars['String']>;
  /** Reviews */
  editorialReviews: Array<EditorialReview>;
};

export type FeaturedSellableContentUploadTaskPayload = {
  __typename: 'FeaturedSellableContentUploadTaskPayload';
  numEntriesProcessed: Scalars['Int'];
  numEntriesIgnored: Scalars['Int'];
  numEntriesCreated: Scalars['Int'];
  numEntriesUpdated: Scalars['Int'];
  errorEntries: Array<Scalars['String']>;
  mediaId: Scalars['MediaId'];
};

export type FieldUpdatedActivity = TicketActivityDetail & {
  __typename: 'FieldUpdatedActivity';
  type: TicketActivityType;
  fieldName: Scalars['String'];
  oldValue: Scalars['String'];
  newValue: Scalars['String'];
};

export type FilterAttributeFieldDefinition = FilterFieldDefinition & {
  __typename: 'FilterAttributeFieldDefinition';
  name: Scalars['String'];
  displayName: Scalars['String'];
  custom: Scalars['Boolean'];
  deprecated: Scalars['Boolean'];
  /** Allowed entity types. At least one value should exist. */
  attributeSchema: AttributeSchemaRevision;
};

export type FilterBooleanFieldDefinition = FilterFieldDefinition & {
  __typename: 'FilterBooleanFieldDefinition';
  name: Scalars['String'];
  displayName: Scalars['String'];
  custom: Scalars['Boolean'];
  deprecated: Scalars['Boolean'];
};

export type FilterCondition = {
  type: FilterConditionType;
};

export enum FilterConditionType {
  FIELD = 'FIELD',
  LOGICAL = 'LOGICAL'
}

export type FilterDateRangeFieldDefinition = FilterFieldDefinition & {
  __typename: 'FilterDateRangeFieldDefinition';
  name: Scalars['String'];
  displayName: Scalars['String'];
  custom: Scalars['Boolean'];
  deprecated: Scalars['Boolean'];
};

export type FilterEnumValueDefinition = {
  __typename: 'FilterEnumValueDefinition';
  value: Scalars['String'];
  description: Scalars['String'];
};

export type FilterFieldAttributeValue = FilterFieldValue & {
  __typename: 'FilterFieldAttributeValue';
  value: Attribute;
  custom: Scalars['Boolean'];
};

export type FilterFieldBooleanValue = FilterFieldValue & {
  __typename: 'FilterFieldBooleanValue';
  value: Scalars['Boolean'];
  custom: Scalars['Boolean'];
};

export type FilterFieldCondition = FilterCondition & {
  __typename: 'FilterFieldCondition';
  type: FilterConditionType;
  field: FilterFieldDefinition;
  values: Array<Maybe<FilterFieldValue>>;
  negative: Scalars['Boolean'];
};

export type FilterFieldDateRangeValue = FilterFieldValue & {
  __typename: 'FilterFieldDateRangeValue';
  value: DateRange;
  custom: Scalars['Boolean'];
};

export type FilterFieldDefinition = {
  name: Scalars['String'];
  displayName: Scalars['String'];
  custom: Scalars['Boolean'];
  deprecated: Scalars['Boolean'];
};

export type FilterFieldGeoSearchValue = FilterFieldValue & {
  __typename: 'FilterFieldGeoSearchValue';
  value: GeoSearchValue;
  custom: Scalars['Boolean'];
};

export type FilterFieldGroup = {
  __typename: 'FilterFieldGroup';
  name: Scalars['String'];
  displayName: Scalars['String'];
  deprecated: Scalars['Boolean'];
  fields: Array<FilterFieldDefinition>;
};

export type FilterFieldIdValue = FilterFieldValue & {
  __typename: 'FilterFieldIdValue';
  value: Scalars['AnyId'];
  displayValue: Scalars['String'];
  custom: Scalars['Boolean'];
};

export type FilterFieldIdValueTypeaheadPayload = {
  __typename: 'FilterFieldIdValueTypeaheadPayload';
  hits: Array<FilterFieldIdValue>;
};

export type FilterFieldIdValueTypeaheadQuery = {
  typeaheadTypes: Array<Scalars['String']>;
  prefix: Scalars['String'];
};

export type FilterFieldNumberRangeValue = FilterFieldValue & {
  __typename: 'FilterFieldNumberRangeValue';
  value: BigDecimalRange;
  custom: Scalars['Boolean'];
};

export enum FilterFieldNumberType {
  INTEGER = 'INTEGER',
  FLOAT = 'FLOAT',
  MONETARY_AMOUNT = 'MONETARY_AMOUNT'
}

export type FilterFieldRelativeDateRangeValue = FilterFieldValue & {
  __typename: 'FilterFieldRelativeDateRangeValue';
  value: RelativeDateRange;
  custom: Scalars['Boolean'];
};

export type FilterFieldStringValue = FilterFieldValue & {
  __typename: 'FilterFieldStringValue';
  value: Scalars['String'];
  custom: Scalars['Boolean'];
};

export type FilterFieldStringValueTypeaheadPayload = {
  __typename: 'FilterFieldStringValueTypeaheadPayload';
  hits: Array<FilterFieldStringValue>;
};

export type FilterFieldStringValueTypeaheadQuery = {
  typeaheadTypes: Array<Scalars['String']>;
  prefix: Scalars['String'];
};

export type FilterFieldValue = {
  custom: Scalars['Boolean'];
};

export type FilterGeoPointFieldDefinition = FilterFieldDefinition & {
  __typename: 'FilterGeoPointFieldDefinition';
  name: Scalars['String'];
  displayName: Scalars['String'];
  custom: Scalars['Boolean'];
  deprecated: Scalars['Boolean'];
};

export type FilterIdFieldDefinition = FilterFieldDefinition & {
  __typename: 'FilterIdFieldDefinition';
  name: Scalars['String'];
  displayName: Scalars['String'];
  custom: Scalars['Boolean'];
  deprecated: Scalars['Boolean'];
  /** Allowed entity types. At least one value should exist. */
  idEntityTypes: Array<Scalars['String']>;
  /** The typeahead for this field */
  typeaheadTypes: Array<Scalars['String']>;
};

export type FilterLogicalCondition = FilterCondition & {
  __typename: 'FilterLogicalCondition';
  type: FilterConditionType;
  operator: FilterLogicalOperator;
  operands: Array<FilterCondition>;
};

export enum FilterLogicalOperator {
  AND = 'AND',
  OR = 'OR'
}

export type FilterNumberRangeFieldDefinition = FilterFieldDefinition & {
  __typename: 'FilterNumberRangeFieldDefinition';
  name: Scalars['String'];
  displayName: Scalars['String'];
  custom: Scalars['Boolean'];
  deprecated: Scalars['Boolean'];
  numberType: FilterFieldNumberType;
};

export type FilterStringFieldDefinition = FilterFieldDefinition & {
  __typename: 'FilterStringFieldDefinition';
  name: Scalars['String'];
  displayName: Scalars['String'];
  custom: Scalars['Boolean'];
  deprecated: Scalars['Boolean'];
  /**
   * If the field is an enum, the list of possible enum values
   * If the field does not exist, any string value is allowed
   */
  enumValues?: Maybe<Array<FilterEnumValueDefinition>>;
  /** typeahead for the string field.  if null, there is no runtime typeahead support */
  typeaheadTypes?: Maybe<Array<Scalars['String']>>;
};

export type FindAndAcceptOpenLeadEscalationsInput = {
  expertId: Scalars['BusinessUserId'];
  expertRole?: Maybe<LeadExpertRole>;
  maxCount?: Maybe<Scalars['Int']>;
};

export type FindAndAcceptOpenLeadEscalationsResult = {
  __typename: 'FindAndAcceptOpenLeadEscalationsResult';
  hasError: Scalars['Boolean'];
  errorMessage?: Maybe<Scalars['String']>;
  escalations: Array<LeadEscalation>;
};

export type FindGiftCardForRedemptionPayload = {
  __typename: 'FindGiftCardForRedemptionPayload';
  error?: Maybe<Scalars['String']>;
  giftCard?: Maybe<GiftCard>;
};

export type FindOrCreateReplacementExpertCuratedOrderInput = {
  id: Scalars['ExpertCuratedOrderId'];
};

export type FindOrCreateReplacementExpertCuratedOrderPayload = {
  __typename: 'FindOrCreateReplacementExpertCuratedOrderPayload';
  /** The expert curated order that's being replaced */
  superseded: ExpertCuratedOrder;
  /** The found or newly created draft expert curated order that can be modified, and subsequently activated */
  draft: ExpertCuratedOrder;
};

export type FindShiftAbsencesInput = {
  userIds: Array<Scalars['AnyId']>;
};

export type FindShiftProbationsInput = {
  departmentId: Scalars['SchedulingDepartmentId'];
  filterType: ShiftProbationFilterType;
};

export type FlightPlan = {
  __typename: 'FlightPlan';
  id: Scalars['FlightPlanId'];
  consumer?: Maybe<User>;
  state: FlightPlanState;
  legs: Array<FlightPlanLeg>;
};

export enum FlightPlanEditErrorCode {
  EMPTY_LEGS = 'EMPTY_LEGS',
  NO_SUCH_LEG = 'NO_SUCH_LEG',
  MISSING_AIRPORT = 'MISSING_AIRPORT',
  SAME_AIRPORT = 'SAME_AIRPORT',
  OVERLAPPING_LEGS = 'OVERLAPPING_LEGS',
  NOT_DRAFT = 'NOT_DRAFT'
}


export type FlightPlanLeg = {
  __typename: 'FlightPlanLeg';
  id: Scalars['FlightPlanLegId'];
  /** One or the other will be specified */
  departAt?: Maybe<Scalars['Date']>;
  departOn?: Maybe<Scalars['LocalDate']>;
  arriveAt?: Maybe<Scalars['Date']>;
  durationInMinutes?: Maybe<Scalars['Int']>;
  flightOperator?: Maybe<Scalars['String']>;
  /** Required for ACTIVE */
  departureAirport?: Maybe<Airport>;
  /** Required for ACTIVE */
  arrivalAirport?: Maybe<Airport>;
};


export type FlightPlanLegUpsertRequestInput = {
  id?: Maybe<Scalars['FlightPlanLegId']>;
  departAt?: Maybe<Scalars['Date']>;
  departOn?: Maybe<Scalars['LocalDate']>;
  durationInMinutes?: Maybe<Scalars['Int']>;
  flightOperator?: Maybe<Scalars['String']>;
  departureAirportId?: Maybe<Scalars['AirportId']>;
  arrivalAirportId?: Maybe<Scalars['AirportId']>;
};

export enum FlightPlanState {
  DRAFT = 'DRAFT',
  ACTIVE = 'ACTIVE'
}

export type FloatRangeInput = {
  from?: Maybe<Scalars['Float']>;
  to?: Maybe<Scalars['Float']>;
};

export type FollowupActionRequestTicket = TicketDetail & {
  __typename: 'FollowupActionRequestTicket';
  type: TicketType;
  actionType: TicketActionType;
  actionReason: TicketActionReason;
  instructions?: Maybe<Scalars['String']>;
  order?: Maybe<Order>;
};

export type FormattedAttribute = {
  __typename: 'FormattedAttribute';
  name: Scalars['String'];
  internalName: Scalars['String'];
  /** @deprecated Superseded by the `displayHtml` field */
  displayValue: Scalars['String'];
  displayHtml: Scalars['String'];
  displayHtmlValues: Array<Scalars['String']>;
};

export type FrontendTask = {
  __typename: 'FrontendTask';
  id: Scalars['FrontendTaskId'];
  status: FrontendTaskStatus;
  payload?: Maybe<TaskPayload>;
  /** reason for an aborted task */
  abortReason?: Maybe<Scalars['String']>;
};


export enum FrontendTaskStatus {
  CREATED = 'CREATED',
  PROCESSING = 'PROCESSING',
  COMPLETED = 'COMPLETED',
  ABORTED = 'ABORTED'
}

/**
 * Fulfillment corresponds to the process shipment of 1 or more items. These items can be the same sku or different skus.
 * They can ship in different packages and have multiple tracking numbers, but they are all processed as
 * a single unit for purpose of order fulfillment.
 */
export type Fulfillment = {
  __typename: 'Fulfillment';
  createdAt: Scalars['Date'];
  updatedAt: Scalars['Date'];
  status: FulfillmentStatusWithDisplayName;
  /** If the fulfillment was complete, the delivery date */
  deliveredAt?: Maybe<Scalars['Date']>;
  /** Esstimate date of delivery */
  estimatedDeliveryAt?: Maybe<Scalars['Date']>;
  /** If the shipment is in transit, the date of transit */
  inTransitAt?: Maybe<Scalars['Date']>;
  deliveryStatus?: Maybe<FulfillmentOrderDeliveryStatusWithDisplayName>;
  /** Line items as part of the fulfillment. */
  lineItems: Array<FulfillmentLineItem>;
  shipmentTrackings: Array<ShipmentTracking>;
};

export type FulfillmentCenter = {
  __typename: 'FulfillmentCenter';
  id: Scalars['FulfillmentCenterId'];
  name: Scalars['String'];
  active: Scalars['Boolean'];
  /** External id of the fulfillment center if managed by third party managment tool like Shopify */
  externalLocationId?: Maybe<Scalars['String']>;
  serviceTypeWithDisplayName: FulfillmentServiceTypeWithDisplayName;
  serviceProviderWithDiplayName: FulfillmentServiceProviderWithDisplayName;
};

export type FulfillmentCenterConnection = {
  __typename: 'FulfillmentCenterConnection';
  pageInfo: PageInfo;
  edges: Array<FulfillmentCenterEdge>;
};

export type FulfillmentCenterEdge = {
  __typename: 'FulfillmentCenterEdge';
  cursor: Scalars['String'];
  node: FulfillmentCenter;
};


export type FulfillmentCentersQuery = {
  activeOnly: Scalars['Boolean'];
};

export type FulfillmentChannel = {
  __typename: 'FulfillmentChannel';
  id: Scalars['FulfillmentChannelId'];
  createdAt: Scalars['Date'];
  updatedAt: Scalars['Date'];
  createdBy: FulfillmentChannelWriter;
  updatedBy: FulfillmentChannelWriter;
  type: FulfillmentChannelType;
  name: Scalars['String'];
  instructions: Scalars['String'];
  instructionUrl?: Maybe<Scalars['String']>;
  marginPercent?: Maybe<Scalars['Int']>;
  partnerSince?: Maybe<Scalars['Date']>;
  blacklisted: Scalars['Boolean'];
  shipmentPricingTierType?: Maybe<ShipmentPricingTierType>;
  partnerCategories: Array<Category>;
};

export type FulfillmentChannelEdge = {
  __typename: 'FulfillmentChannelEdge';
  node: FulfillmentChannel;
  cursor: Scalars['String'];
};


export type FulfillmentChannelQueryInput = {
  types?: Maybe<Array<FulfillmentChannelType>>;
  namePrefix?: Maybe<Scalars['String']>;
};

export type FulfillmentChannelsConnection = {
  __typename: 'FulfillmentChannelsConnection';
  edges: Array<FulfillmentChannelEdge>;
  pageInfo: PageInfo;
  count: Scalars['Long'];
};

export type FulfillmentChannelsPagination = {
  __typename: 'FulfillmentChannelsPagination';
  fulfillmentChannels: Array<FulfillmentChannel>;
  count: Scalars['Long'];
};

export enum FulfillmentChannelType {
  WAREHOUSE = 'WAREHOUSE',
  MANUFACTURER = 'MANUFACTURER',
  RETAILER = 'RETAILER',
  GOOGLE_SHOPPING = 'GOOGLE_SHOPPING',
  AD_HOC = 'AD_HOC',
  OFFLINE_PARTNERS = 'OFFLINE_PARTNERS'
}

export type FulfillmentChannelWriter = Operator | SystemUser;

export type FulfillmentLineItem = {
  __typename: 'FulfillmentLineItem';
  createdAt: Scalars['Date'];
  updatedAt: Scalars['Date'];
  orderLineItem: OrderLineItem;
  status: FulfillmentStatusWithDisplayName;
  requestedQuantity: Scalars['Int'];
  fulfillableQuantity: Scalars['Int'];
  unfulfilledQuantity: Scalars['Int'];
};

export type FulfillmentOrder = {
  __typename: 'FulfillmentOrder';
  id: Scalars['FulfillmentOrderId'];
  createdBy: Operator;
  updatedBy: Operator;
  order: Order;
  fulfillmentCenter?: Maybe<FulfillmentCenter>;
  fulfillmentShipmentMethod?: Maybe<FulfillmentShipmentMethod>;
  fulfillmentOrderSource: FulfillmentOrderSource;
  fulfillments: Array<Fulfillment>;
  shipmentTracking?: Maybe<ShipmentTracking>;
  estimatedDeliveryAt?: Maybe<Scalars['Date']>;
  claimedByMerchant?: Maybe<Merchant>;
};

export enum FulfillmentOrderDeliveryStatus {
  ATTEMPTED_DELIVERY = 'ATTEMPTED_DELIVERY',
  CANCELED = 'CANCELED',
  CONFIRMED = 'CONFIRMED',
  DELIVERED = 'DELIVERED',
  FAILURE = 'FAILURE',
  FULFILLED = 'FULFILLED',
  IN_TRANSIT = 'IN_TRANSIT',
  LABEL_PRINTED = 'LABEL_PRINTED',
  LABEL_PURCHASED = 'LABEL_PURCHASED',
  LABEL_VOIDED = 'LABEL_VOIDED',
  MARKED_AS_FULFILLED = 'MARKED_AS_FULFILLED',
  NOT_DELIVERED = 'NOT_DELIVERED',
  OUT_FOR_DELIVERY = 'OUT_FOR_DELIVERY',
  READY_FOR_PICKUP = 'READY_FOR_PICKUP',
  SUBMITTED = 'SUBMITTED'
}

export type FulfillmentOrderDeliveryStatusWithDisplayName = {
  __typename: 'FulfillmentOrderDeliveryStatusWithDisplayName';
  status: FulfillmentOrderDeliveryStatus;
  displayName: Scalars['String'];
};


export type FulfillmentOrderPayload = {
  __typename: 'FulfillmentOrderPayload';
  fulfillmentOrder?: Maybe<FulfillmentOrder>;
  hasError: Scalars['Boolean'];
  error?: Maybe<Scalars['String']>;
};

export type FulfillmentOrderSource = {
  type: FulfillmentOrderSourceType;
};

export enum FulfillmentOrderSourceType {
  DEAL = 'DEAL',
  SHOPIFY = 'SHOPIFY',
  EXTERNAL_PARTNER = 'EXTERNAL_PARTNER'
}

export type FulfillmentProcessUpdatedActivity = OrderActivityDetail & {
  __typename: 'FulfillmentProcessUpdatedActivity';
  type: OrderActivityDetailType;
  fulfillmentChannel: FulfillmentChannel;
  performedBy: TicketUser;
  status: FulfillmentSuggestionStatus;
  note?: Maybe<Scalars['String']>;
};

export enum FulfillmentServiceProvider {
  DEAL = 'DEAL',
  UPS = 'UPS'
}

export type FulfillmentServiceProviderWithDisplayName = {
  __typename: 'FulfillmentServiceProviderWithDisplayName';
  serviceProvider: FulfillmentServiceProvider;
  displayName: Scalars['String'];
};

export enum FulfillmentServiceType {
  THIRD_PARTY_LOGISTICS = 'THIRD_PARTY_LOGISTICS',
  DEAL_WH = 'DEAL_WH'
}

export type FulfillmentServiceTypeWithDisplayName = {
  __typename: 'FulfillmentServiceTypeWithDisplayName';
  serviceType: FulfillmentServiceType;
  displayName: Scalars['String'];
};

export type FulfillmentShipmentMethod = {
  __typename: 'FulfillmentShipmentMethod';
  id: Scalars['FulfillmentShipmentMethodId'];
  name: Scalars['String'];
  active: Scalars['Boolean'];
  shippingCarrier: ShippingCarrier;
  /** Shipment cost */
  rate?: Maybe<MonetaryAmount>;
};

export type FulfillmentShipmentMethodConnection = {
  __typename: 'FulfillmentShipmentMethodConnection';
  pageInfo: PageInfo;
  edges: Array<FulfillmentShipmentMethodEdge>;
};

export type FulfillmentShipmentMethodEdge = {
  __typename: 'FulfillmentShipmentMethodEdge';
  cursor: Scalars['String'];
  node: FulfillmentShipmentMethod;
};


export type FulfillmentShipmentMethodQuery = {
  carrierId?: Maybe<Scalars['ShippingCarrierId']>;
};

export enum FulfillmentStatus {
  REQUESTED = 'REQUESTED',
  CANCELLED = 'CANCELLED',
  ERROR = 'ERROR',
  FAILED = 'FAILED',
  PROCESSING = 'PROCESSING',
  PENDING = 'PENDING',
  PARTIAL = 'PARTIAL',
  COMPLETED = 'COMPLETED'
}

export type FulfillmentStatusWithDisplayName = {
  __typename: 'FulfillmentStatusWithDisplayName';
  status: FulfillmentStatus;
  displayName: Scalars['String'];
};

export enum FulfillmentSuggestionStatus {
  PENDING = 'PENDING',
  FULFILLED = 'FULFILLED',
  SKIPPED = 'SKIPPED',
  UNAVAILABLE = 'UNAVAILABLE',
  PRICE_TOO_HIGH = 'PRICE_TOO_HIGH',
  SHIPPING_TOO_SLOW = 'SHIPPING_TOO_SLOW',
  FAILED = 'FAILED'
}

export type GeneralSupportTicket = TicketDetail & {
  __typename: 'GeneralSupportTicket';
  type: TicketType;
  consumer: User;
  order: Order;
  orderLineItemIds: Array<Scalars['OrderLineItemId']>;
};

export type GenerateCollectPhoneNumberTextInPathInput = {
  pathFlowId: Scalars['PathFlowId'];
};

export type GenerateCollectPhoneNumberTextInPathPayload = {
  __typename: 'GenerateCollectPhoneNumberTextInPathPayload';
  toNumber: Scalars['String'];
  body: Scalars['String'];
};

export type GenerateTemplateDirectiveSnippetInput = {
  directiveName: Scalars['String'];
  variableName: Scalars['String'];
  parameters: Array<TemplateFragmentParameterValueInput>;
};

export type GenerateTemplateDirectiveSnippetPayload = {
  __typename: 'GenerateTemplateDirectiveSnippetPayload';
  errors: Array<Scalars['String']>;
  content?: Maybe<Scalars['String']>;
};

export type GenerateTemplateFragmentSnippetInput = {
  id: Scalars['CommTemplateFragmentId'];
  parameters: Array<TemplateFragmentParameterValueInput>;
};

export type GenerateTemplateFragmentSnippetPayload = {
  __typename: 'GenerateTemplateFragmentSnippetPayload';
  errors: Array<Scalars['String']>;
  importStatement?: Maybe<Scalars['String']>;
  content?: Maybe<Scalars['String']>;
};

export type GenericInfoBoxPageMetadata = PathFlowPageMetadata & {
  __typename: 'GenericInfoBoxPageMetadata';
  type: PathFlowPageMetadataType;
  body?: Maybe<TextViewModel>;
};

export type GenericModalPageMetadata = PathFlowPageMetadata & {
  __typename: 'GenericModalPageMetadata';
  type: PathFlowPageMetadataType;
  body?: Maybe<TextViewModel>;
  openCtaText?: Maybe<TextViewModel>;
};

/** Configurable generic numeric entry UI */
export type GenericNumericRenderingStylePathQuestionPathNodeFlowViewModel = {
  __typename: 'GenericNumericRenderingStylePathQuestionPathNodeFlowViewModel';
  unit?: Maybe<PathTextViewModel>;
  /** What side of the input the unit should render on. For example, this would be left for dollars, but right for lbs. */
  unitPlacement: NumericPathQuestionSchemaGenericRenderingStyleUnitPlacement;
  placeholder?: Maybe<PathTextViewModel>;
  /**
   * If null, only integers should be allowed. If not null, decimal (floating point) numbers should be accepted
   * with the options specified in this object
   */
  decimalEntry?: Maybe<DecimalEntryGenericNumericRenderingStylePathQuestionPathNodeFlowViewModel>;
};

export type GenericNumericRenderingStylePathQuestionSchemaUpsertEditorCommandInput = {
  unit?: Maybe<Scalars['String']>;
  /** What side of the input the unit should render on. For example, this would be left for dollars, but right for lbs. */
  unitPlacement?: Maybe<NumericPathQuestionSchemaGenericRenderingStyleUnitPlacement>;
  placeholder?: Maybe<Scalars['String']>;
  /**
   * For integer attributes that represent decimal values (e.g.: currency in cents), this scale should be used to
   * compute the decimal value from integer. The formula `(value x 10 ^ (-scale))` is used to compute the decimal value.
   * For example, a scale of "2" will allow the user to enter "123.46", but store it internally as "12346".
   */
  integerAsDecimalScale?: Maybe<Scalars['Int']>;
};

export type GeocodingResponse = {
  __typename: 'GeocodingResponse';
  streetNumber?: Maybe<Scalars['String']>;
  street?: Maybe<Scalars['String']>;
  unit?: Maybe<Scalars['String']>;
  city?: Maybe<Scalars['String']>;
  state?: Maybe<Scalars['String']>;
  country?: Maybe<Scalars['String']>;
  postalCode?: Maybe<Scalars['String']>;
  formattedAddress?: Maybe<Scalars['String']>;
  placeId?: Maybe<Scalars['String']>;
  latitude?: Maybe<Scalars['Float']>;
  longitude?: Maybe<Scalars['Float']>;
};

export type GeoSearchValue = GeoZipCodeRadius;

export type GeoZipCodeRadius = {
  __typename: 'GeoZipCodeRadius';
  postalCode: Scalars['String'];
  countryCode: Scalars['String'];
  distanceInMiles: Scalars['Int'];
};

export type GeoZipCodeRadiusInput = {
  postalCode: Scalars['String'];
  countryCode: Scalars['String'];
  distanceInMiles: Scalars['Int'];
};

export enum GetEntityErrorCode {
  ENTITY_NOT_FOUND = 'ENTITY_NOT_FOUND',
  USER_NOT_ALLOWED = 'USER_NOT_ALLOWED'
}

export type GetOrCreateUserCartForExpertInput = {
  userId: Scalars['UserId'];
};

export type GetOrCreateUserCartForExpertPayload = {
  __typename: 'GetOrCreateUserCartForExpertPayload';
  order: Order;
};

export type GetReferralCodePayload = {
  __typename: 'GetReferralCodePayload';
  error?: Maybe<Scalars['String']>;
  referralCode?: Maybe<ReferralCode>;
};

export type GiftCard = {
  __typename: 'GiftCard';
  id: Scalars['GiftCardId'];
  state: GiftCardState;
  code: Scalars['String'];
  purchasedBy: User;
  purchasedAt: Scalars['Date'];
  amount: MonetaryAmount;
  recipientName: Scalars['String'];
  recipientEmail: Scalars['String'];
  message?: Maybe<Scalars['String']>;
  deliveryDate: Scalars['Date'];
  redeemUrl: Scalars['String'];
  redeemedBy?: Maybe<User>;
  redeemedAt?: Maybe<Scalars['Date']>;
  curator?: Maybe<BusinessUser>;
};

export type GiftCardDetailsInput = {
  recipientName: Scalars['String'];
  recipientEmail: Scalars['String'];
  deliveryDate: Scalars['Date'];
  message?: Maybe<Scalars['String']>;
};


export enum GiftCardState {
  PURCHASED = 'PURCHASED',
  REDEEMED = 'REDEEMED',
  EXPIRED = 'EXPIRED',
  TERMINATED = 'TERMINATED'
}

export type GiveUpShiftRequestInput = {
  shiftSlotId: Scalars['ShiftSlotId'];
  reason: ShiftGiveUpReason;
  note?: Maybe<Scalars['String']>;
};

export type GlobalStats = {
  __typename: 'GlobalStats';
  leadStats: LeadStats;
  curationStats: CurationStats;
  consumerReviewStats: ConsumerReviewStats;
};

export type GlobalStatsAggregateExpertReport = {
  __typename: 'GlobalStatsAggregateExpertReport';
  conversationsCountTotal: Scalars['Int'];
  conversationsCountThisWeek: Scalars['Int'];
  averageExpertRating: Scalars['Float'];
  reviewsCount: Scalars['Int'];
  curationsCountTotal: Scalars['Int'];
  curationsCountThisWeek: Scalars['Int'];
};

export type GoogleShoppingFeedAttributeSchemaMetadata = AttributeSchemaMetadata & {
  __typename: 'GoogleShoppingFeedAttributeSchemaMetadata';
  type: AttributeSchemaMetadataType;
  attributeName: Scalars['String'];
};

export type GoogleShoppingFeedAttributeSchemaMetadataInput = {
  attributeName: Scalars['String'];
};

export type GoogleShoppingSellablePriceSource = SellablePriceSource & {
  __typename: 'GoogleShoppingSellablePriceSource';
  id: Scalars['SellablePriceSourceId'];
  type: SellablePriceSourceType;
  sellable: Sellable;
  price?: Maybe<MonetaryAmount>;
  bestOfferPrice?: Maybe<MonetaryAmount>;
  cost?: Maybe<MonetaryAmount>;
  expiresAt?: Maybe<Scalars['Date']>;
  fulfillmentChannel?: Maybe<FulfillmentChannel>;
  canRefresh: Scalars['Boolean'];
  willRefresh: Scalars['Boolean'];
  googleProductId?: Maybe<Scalars['String']>;
  sellers: Array<SellablePriceSourceGoogleShoppingSeller>;
  estimatedAvailableAt?: Maybe<Scalars['Date']>;
};

export type GroupedOrderLineItems = {
  type: OrderLineItemsGroupingType;
};

export type GuestChatCreateRequestRichCard = MessageRichCard & {
  __typename: 'GuestChatCreateRequestRichCard';
  type: MessageRichCardType;
  expertId: Scalars['BusinessUserId'];
  categoryId: Scalars['CategoryId'];
};

export type GuestConversation = {
  __typename: 'GuestConversation';
  expert: BusinessUser;
  version: Scalars['Int'];
  messages: Array<GuestConversationMessage>;
  signature: Scalars['String'];
};

export type GuestConversationMessage = {
  __typename: 'GuestConversationMessage';
  id: Scalars['String'];
  parts: Array<ConversationMessagePart>;
  sendBy: MessagingUser;
  sendAt: Scalars['Date'];
  typeAt?: Maybe<Scalars['Date']>;
};

export type GuestConversationSequence = {
  __typename: 'GuestConversationSequence';
  id: Scalars['GuestConversationSequenceId'];
  name: Scalars['String'];
  state: GuestConversationSequenceState;
  messages: Array<GuestConversationSequenceMessage>;
};


export type GuestConversationSequenceMessage = {
  __typename: 'GuestConversationSequenceMessage';
  templateType: CommTemplateType;
  delay?: Maybe<Duration>;
  typingDuration?: Maybe<Duration>;
};

export type GuestConversationSequenceMessageInput = {
  templateTypeId: Scalars['CommTemplateTypeId'];
  delay?: Maybe<DurationInput>;
  typingDuration?: Maybe<DurationInput>;
};

export type GuestConversationSequenceQuery = {
  states?: Maybe<Array<GuestConversationSequenceState>>;
};

export enum GuestConversationSequenceState {
  DRAFT = 'DRAFT',
  ACTIVE = 'ACTIVE',
  INACTIVE = 'INACTIVE'
}

export enum HandleType {
  EMAIL = 'EMAIL',
  PHONE = 'PHONE'
}

export type HardcodedContentSelectionMethod = ContentSelectionMethod & {
  __typename: 'HardcodedContentSelectionMethod';
  type: ContentSelectionMethodType;
  templateName: Scalars['String'];
  variation: Scalars['String'];
};

export type HardcodedContentSelectionMethodInput = {
  templateName: Scalars['String'];
  variation: Scalars['String'];
};

export type HiddenAttributeSchemaMetadata = AttributeSchemaMetadata & {
  __typename: 'HiddenAttributeSchemaMetadata';
  type: AttributeSchemaMetadataType;
};

export type HiddenAttributeSchemaMetadataInput = {
  _?: Maybe<Scalars['Boolean']>;
};

export type HowCuratedWorksRichCard = MessageRichCard & {
  __typename: 'HowCuratedWorksRichCard';
  type: MessageRichCardType;
  leadId: Scalars['LeadId'];
};

export type IconFacetImageMetadata = FacetImageMetadata & {
  __typename: 'IconFacetImageMetadata';
  type: FacetImageType;
  imageUrl: Scalars['String'];
};

export type IdCodecPayload = {
  __typename: 'IdCodecPayload';
  error?: Maybe<Scalars['String']>;
  externalId?: Maybe<Scalars['String']>;
  internalId?: Maybe<Scalars['String']>;
  idType?: Maybe<Scalars['String']>;
};

export type IdentifyEBayItemAsSellableInput = {
  sellableId: Scalars['SellableId'];
  eBayItemId: Scalars['String'];
};

export type IdentifyEBayItemAsSellablePayload = {
  __typename: 'IdentifyEBayItemAsSellablePayload';
  sellable: Sellable;
};

export type Identity = User | BusinessUser | Operator | SystemUser | PartnerUser;

export enum IdentityType {
  GUEST = 'GUEST',
  USER = 'USER',
  BUSINESS_USER = 'BUSINESS_USER',
  OPERATOR = 'OPERATOR',
  SYSTEM_USER = 'SYSTEM_USER',
  IMPORTED_IDENTITY = 'IMPORTED_IDENTITY'
}

export type IdEntityTypeAttributeValidatorReference = AttributeValidatorReference & {
  __typename: 'IdEntityTypeAttributeValidatorReference';
  id: Scalars['AttributeValidatorReferenceId'];
  type: AttributeValidatorType;
  entityType: Scalars['String'];
};

export type IdEntityTypeAttributeValidatorReferenceInput = {
  entityType: Scalars['String'];
};

/** ====== IdPathFlowQuestion */
export type IdPathFlowQuestion = PathFlowQuestion & {
  __typename: 'IdPathFlowQuestion';
  internalName: Scalars['String'];
  questionText?: Maybe<TextViewModel>;
  questionSubText?: Maybe<TextViewModel>;
  required: Scalars['Boolean'];
  inputIconImage?: Maybe<ImageViewModel>;
  inputLabel?: Maybe<TextViewModel>;
  attributes: Array<Attribute>;
  attribute?: Maybe<Attribute>;
  type: IdPathFlowQuestionType;
  /** If reloading a question answered by the user, this is their previous input */
  idUserInput: SubmitIdPathFlowQuestionInputTypeCopy;
  /** Maximum amount of id values that are allowed for this question */
  maximumValues: Scalars['Int'];
};


/** ====== IdPathFlowQuestion */
export type IdPathFlowQuestionAttributeArgs = {
  attributeName?: Maybe<Scalars['String']>;
};

export enum IdPathFlowQuestionType {
  MEDIA_ID_IMAGE_UPLOAD = 'MEDIA_ID_IMAGE_UPLOAD',
  EXPERT_ID_SELECTION = 'EXPERT_ID_SELECTION',
  PRODUCTS_TYPEAHEAD = 'PRODUCTS_TYPEAHEAD',
  FLIGHT_PLAN = 'FLIGHT_PLAN'
}

/**
 * Notes:
 * - For lists that can be paginated, we're following the GraphQL Relay "Connection" model.
 *   This is where the "Node/Edges/Connections" convention comes from. Even though we're
 *   using Apollo, this is the most popular pagination model for GraphQL so it's beneficial
 *   for us to adopt. It's basically cursor based pagination; see the following links for
 *   more info:
 *   https://dev-blog.apollodata.com/explaining-graphql-connections-c48b7c3d6976
 *   https://facebook.github.io/relay/docs/graphql-connections.html
 *   https://facebook.github.io/relay/graphql/connections.htm
 * 
 * - Validation: All submits include an array of validation errors that can target the entire flow,
 *   a specific page, or a specific question. These are meant to be displayed to the user. The
 *   validation rules sent down by the server (e.g.: regex validation) is our best attempt at guiding
 *   the client to provide correct input, but it can't be guaranteed for all inputs (e.g.: server data
 *   is required for validation).
 * =============
 * Generic Types
 * =============
 * ====== Image View Model
 */
export type ImageViewModel = PathImageViewModel;

export type ImportedIdentity = {
  __typename: 'ImportedIdentity';
  id: Scalars['ImportedIdentityId'];
  /** Identity type that was imported */
  identityType: IdentityType;
  /** Environment the identity was imported from */
  environment: Environment;
  firstName?: Maybe<Scalars['String']>;
  lastName?: Maybe<Scalars['String']>;
  contacts: Array<Contact>;
};


export type ImportEntitiesInput = {
  file: Scalars['Upload'];
};

export type ImportEntitiesPayload = {
  __typename: 'ImportEntitiesPayload';
  templates: Array<MultiLocaleTemplateSet>;
  triggers: Array<Trigger>;
  templateTypes: Array<CommTemplateType>;
  templateFragments: Array<CommTemplateFragment>;
  leadCampaigns: Array<LeadCampaign>;
};

export type ImportRawSellableSourceInput = {
  environment: Scalars['String'];
  id: Scalars['RawSellableSourceId'];
};

export type ImportRawSellableSourcePayload = {
  __typename: 'ImportRawSellableSourcePayload';
  source?: Maybe<RawSellableSource>;
  hasError: Scalars['Boolean'];
  errorMessage?: Maybe<Scalars['String']>;
};

export type ImportRawSellableStandardizationRuleInput = {
  environment: Scalars['String'];
  id: Scalars['RawSellableStandardizationRuleId'];
};

export type ImportRawSellableStandardizationRulePayload = {
  __typename: 'ImportRawSellableStandardizationRulePayload';
  rule?: Maybe<RawSellableStandardizationRule>;
  hasError: Scalars['Boolean'];
  errorMessage?: Maybe<Scalars['String']>;
};

export type ImportRawSellableStandardizationRulesInput = {
  environment: Scalars['String'];
  query: RawSellableStandardizationRuleQuery;
};

export type ImportRawSellableStandardizationRulesPayload = {
  __typename: 'ImportRawSellableStandardizationRulesPayload';
  rules: Array<RawSellableStandardizationRule>;
  hasError: Scalars['Boolean'];
  errorMessage?: Maybe<Scalars['String']>;
};

export type InAppTemplate = ChannelTemplate & {
  __typename: 'InAppTemplate';
  channelType: ChannelType;
  body: Scalars['String'];
};

export type InAppTemplateInput = {
  body: Scalars['String'];
};

export type InboxRedirectPathNodeFlowViewModelSuccess = {
  __typename: 'InboxRedirectPathNodeFlowViewModelSuccess';
  lead?: Maybe<Lead>;
};

export type IncomingCall = {
  __typename: 'IncomingCall';
  id: Scalars['IncomingCallId'];
  externalId: Scalars['String'];
  fromContact: NormalizedContact;
  toContact: NormalizedContact;
  from?: Maybe<MessagingUser>;
  to: MessagingUser;
  rangAt?: Maybe<Scalars['Date']>;
  pickedUpAt?: Maybe<Scalars['Date']>;
  pickedUpBy?: Maybe<MessagingUser>;
  terminatedAt?: Maybe<Scalars['Date']>;
  state: IncomingCallState;
};


export enum IncomingCallState {
  RINGING = 'RINGING',
  IN_PROGRESS = 'IN_PROGRESS',
  TERMINATED = 'TERMINATED'
}

export type InconsistentVariationDimensionsProductCatalogPublishError = ErrorMessage & {
  __typename: 'InconsistentVariationDimensionsProductCatalogPublishError';
  errorMessage: Scalars['String'];
  revisions: Array<ProductCatalogRevision>;
};

export type IndividualBucketedDisplayFacet = {
  __typename: 'IndividualBucketedDisplayFacet';
  /** Name to display in the UI for this facet bucket */
  displayName: Scalars['String'];
  /** Optional name / description for use in featured facets */
  subDisplayName?: Maybe<Scalars['String']>;
  /** Internal value that should be provided back to FacetSelection.bucketValues when selecting facet values */
  value: Scalars['String'];
  /**
   * Facet count that should be displayed for this bucket. Depending on product requirements or the way facets
   * are computed, counts may not always be available
   */
  count?: Maybe<Scalars['Long']>;
  /** Optional image associated with the Facet value. This is used in navigation style SERP pages. */
  imageMetadata?: Maybe<FacetImageMetadata>;
  /** whether or not the frontend should nofollow the link to this value. True = follow, False = nofollow. */
  seoShouldFollow: Scalars['Boolean'];
};

export type IndividualBucketedRangeDisplayFacet = {
  __typename: 'IndividualBucketedRangeDisplayFacet';
  /** Name to display in the UI for this facet bucket */
  displayName: Scalars['String'];
  /**
   * Facet count that should be displayed for this bucket. Depending on product requirements or the way facets
   * are computed, counts may not always be available
   */
  count?: Maybe<Scalars['Long']>;
  /** Type of numeric facet; currently used to change rendering styles */
  type: NumericRangeDisplayFacetType;
  /** unscaled lower bound */
  lower: Scalars['Long'];
  /** unscaled upper bound */
  upper: Scalars['Long'];
  /**
   * if `upper` is capped (there are values beyond upper, but the result is truncated for ease of use, and querying for
   * the capped upper value will give all values beyond it)
   */
  upperCapped: Scalars['Boolean'];
  /** The scale `lower` and `upper` is in; `(value x 10 ^ (-scale))` should be used to compute the actual value. */
  scale: Scalars['Int'];
  /** Computed decimal value of `lower` at `scale` */
  decimalLower: Scalars['BigDecimal'];
  /** Computed decimal value of `upper` at `scale` */
  decimalUpper: Scalars['BigDecimal'];
};

export type IndividualSellableAttributeProCon = IndividualSellableProCon & {
  __typename: 'IndividualSellableAttributeProCon';
  type: IndividualSellableProConType;
  attributeName: Scalars['String'];
  attributeEnumEntryName: Scalars['String'];
  displayName: Scalars['String'];
};

export type IndividualSellableCustomProCon = IndividualSellableProCon & {
  __typename: 'IndividualSellableCustomProCon';
  type: IndividualSellableProConType;
  displayName: Scalars['String'];
};

export type IndividualSellableProCon = {
  type: IndividualSellableProConType;
};

export type IndividualSellableProConInput = {
  type: IndividualSellableProConType;
  attributeName?: Maybe<Scalars['String']>;
  attributeEnumEntryName?: Maybe<Scalars['String']>;
  displayName?: Maybe<Scalars['String']>;
};

export enum IndividualSellableProConType {
  ATTRIBUTE = 'ATTRIBUTE',
  CUSTOM = 'CUSTOM'
}

export type InitiateAffirmPaymentForOrderInput = {
  orderId: Scalars['OrderId'];
  paymentRedirectUrls: PaymentRedirectUrls;
};

export type InitiateAffirmPaymentForOrderPayload = {
  __typename: 'InitiateAffirmPaymentForOrderPayload';
  order: Order;
  /** The string representation of the JSON object to be passed to Affirm javascript SDK. */
  checkoutData: Scalars['String'];
};

export type InitiateAfterpayPaymentForOrderInput = {
  orderId: Scalars['OrderId'];
  paymentRedirectUrls: PaymentRedirectUrls;
};

export type InitiateAfterpayPaymentForOrderPayload = {
  __typename: 'InitiateAfterpayPaymentForOrderPayload';
  order: Order;
  /**
   * This is a unique token that is used for 2 purposes:
   * 1. As part of the redirect request to Afterpay (on frontend)
   * 2. For uniquely capturing the payment after approval (on backend)
   * 
   * On approval from Afterpay, this same token is appended to the redirectConfirmUrl and should be sent as the
   * paymentProcessorPlatformSourceId field in the ChargeInfoInput object. Note, the Afterpay payments are single use only
   */
  orderToken: Scalars['String'];
};

export type InitiateAuthenticationInput = {
  /** handle/handleType or handleId must be present */
  handle?: Maybe<Scalars['String']>;
  handleType?: Maybe<HandleType>;
  handleId?: Maybe<Scalars['AnyId']>;
  captcha: Scalars['String'];
};

export type InitiateAuthenticationPayload = {
  __typename: 'InitiateAuthenticationPayload';
  isValidHandle: Scalars['Boolean'];
  challengeType?: Maybe<ChallengeType>;
  session: Session;
};

export type InitiateDealInventoryFulfillmentInput = {
  orderId: Scalars['OrderId'];
  orderLineItemId: Scalars['OrderLineItemId'];
  /** The specific location to fulfill the order line item from. */
  fulfillmentCenterId: Scalars['FulfillmentCenterId'];
  /**
   * An internal merchant (Deal or Curated) for reference
   * Note, internal merchants are merchants that represent one of the Merchant accounts we use to fulfill our own inventory
   */
  merchantId: Scalars['MerchantId'];
  /**
   * If unspecified, the quantity from the OrderLineItem is used.
   * This cannot be greater than the quantity set in the OrderLineItem
   */
  quantity?: Maybe<Scalars['Int']>;
  /** Override the shipment method from Order to use for this fulfillment */
  fulfillmentShipmentMethodId?: Maybe<Scalars['FulfillmentShipmentMethodId']>;
  /** defaults to fulfilling via Shopify */
  fulfillmentSourceType?: Maybe<FulfillmentOrderSourceType>;
};

export type InitiateDealInventoryFulfillmentPayload = {
  __typename: 'InitiateDealInventoryFulfillmentPayload';
  order?: Maybe<Order>;
  error?: Maybe<Scalars['String']>;
};

export type InitiatePaypalPaymentForOfferConfirmation = {
  __typename: 'InitiatePaypalPaymentForOfferConfirmation';
  paymentId: Scalars['String'];
  authorizationUrl: Scalars['String'];
  price: MonetaryAmount;
  tax?: Maybe<MonetaryAmount>;
  shippingCost?: Maybe<MonetaryAmount>;
  tip?: Maybe<MonetaryAmount>;
};

export type InitiatePaypalPaymentForOfferInput = {
  tip?: Maybe<MonetaryAmountInput>;
  tax?: Maybe<MonetaryAmountInput>;
  shippingAddress?: Maybe<AddressInput>;
  offerId: Scalars['BroadcastOfferId'];
  paymentRedirectUrls?: Maybe<PaymentRedirectUrls>;
};

export type InitiatePaypalPaymentForOfferPayload = {
  __typename: 'InitiatePaypalPaymentForOfferPayload';
  result?: Maybe<InitiatePaypalPaymentForOfferConfirmation>;
  error?: Maybe<Scalars['String']>;
};

export type InitiatePaypalPaymentForOrderInput = {
  orderId: Scalars['OrderId'];
  paymentRedirectUrls?: Maybe<PaymentRedirectUrls>;
};

export type InitiatePaypalPaymentForOrderPayload = {
  __typename: 'InitiatePaypalPaymentForOrderPayload';
  order: Order;
  paymentId: Scalars['String'];
  authorizationUrl: Scalars['String'];
};

export type InitiateResetPasswordInput = {
  handle?: Maybe<Scalars['String']>;
  handleType?: Maybe<HandleType>;
};

export type InitiateResetPasswordPayload = {
  __typename: 'InitiateResetPasswordPayload';
  success: Scalars['Boolean'];
  errorMessage?: Maybe<Scalars['String']>;
};

export type InitiateVerifyHandleInput = {
  handle: Scalars['String'];
  handleType: HandleType;
};

export type InitiateVerifyHandlePayload = {
  __typename: 'InitiateVerifyHandlePayload';
  success: Scalars['Boolean'];
};

export type InitiateWireTransferPaymentForOrderInput = {
  orderId: Scalars['OrderId'];
};

export type InitiateWireTransferPaymentForOrderPayload = {
  __typename: 'InitiateWireTransferPaymentForOrderPayload';
  order: Order;
  /** The payment source which guarantees that it has a WireTransferPaymentEntity. */
  paymentSource: PaymentSource;
};

export type InputTextPathFlowQuestion = PathFlowQuestion & InputTextPathFlowQuestionMixin & {
  __typename: 'InputTextPathFlowQuestion';
  internalName: Scalars['String'];
  questionText?: Maybe<TextViewModel>;
  questionSubText?: Maybe<TextViewModel>;
  required: Scalars['Boolean'];
  inputIconImage?: Maybe<ImageViewModel>;
  inputLabel?: Maybe<TextViewModel>;
  attributes: Array<Attribute>;
  attribute?: Maybe<Attribute>;
  inputTextValidations: Array<InputTextPathFlowQuestionValidation>;
  fieldType: InputTextPathFlowQuestionFieldType;
  placeholder?: Maybe<Scalars['String']>;
  inputTextUserInput: SubmitInputTextPathFlowQuestionInputTypeCopy;
};


export type InputTextPathFlowQuestionAttributeArgs = {
  attributeName?: Maybe<Scalars['String']>;
};

export enum InputTextPathFlowQuestionFieldType {
  /** Typeahead for airports only */
  AIRPORT_TYPEAHEAD = 'AIRPORT_TYPEAHEAD',
  /** Single line "telephone" with SMS text context */
  SMS_TEXT = 'SMS_TEXT',
  /** Facebook user expectedReference */
  FACEBOOK_USER_REF = 'FACEBOOK_USER_REF',
  /** FCM Token */
  FCM_TOKEN = 'FCM_TOKEN',
  /** Single line text entry */
  INPUT_FIELD = 'INPUT_FIELD',
  /** Multi-line text area */
  TEXT_AREA = 'TEXT_AREA',
  /** Single line entry (numeric only) */
  NUMERIC = 'NUMERIC',
  /** Single line "telephone"-like entry (numeric only) */
  TELEPHONE = 'TELEPHONE',
  /** Single line "telephone" with its own submit action */
  TELEPHONE_SUBMIT = 'TELEPHONE_SUBMIT',
  /** Single line "email"-like entry (shows @ sign) */
  EMAIL = 'EMAIL',
  /** Text which is provided programmatically, thus should be hidden from the user */
  HIDDEN = 'HIDDEN'
}

export type InputTextPathFlowQuestionLengthValidation = InputTextPathFlowQuestionValidation & {
  __typename: 'InputTextPathFlowQuestionLengthValidation';
  type: InputTextPathFlowQuestionValidationType;
  minSize?: Maybe<Scalars['Int']>;
  maxSize?: Maybe<Scalars['Int']>;
};

/** ====== Input Text */
export type InputTextPathFlowQuestionMixin = {
  required: Scalars['Boolean'];
  inputTextValidations: Array<InputTextPathFlowQuestionValidation>;
  fieldType: InputTextPathFlowQuestionFieldType;
  placeholder?: Maybe<Scalars['String']>;
  questionSubText?: Maybe<TextViewModel>;
};

export type InputTextPathFlowQuestionNoArgValidation = InputTextPathFlowQuestionValidation & {
  __typename: 'InputTextPathFlowQuestionNoArgValidation';
  type: InputTextPathFlowQuestionValidationType;
};

export type InputTextPathFlowQuestionRegexValidation = InputTextPathFlowQuestionValidation & {
  __typename: 'InputTextPathFlowQuestionRegexValidation';
  type: InputTextPathFlowQuestionValidationType;
  regex: Scalars['String'];
  errorMessage: Scalars['String'];
};

export type InputTextPathFlowQuestionValidation = {
  type: InputTextPathFlowQuestionValidationType;
};

export enum InputTextPathFlowQuestionValidationType {
  LENGTH = 'LENGTH',
  REGEX = 'REGEX',
  PHONE_NUMBER = 'PHONE_NUMBER'
}

export type InputTextPathQuestionSchema = PathQuestionSchema & {
  __typename: 'InputTextPathQuestionSchema';
  id: Scalars['PathQuestionSchemaId'];
  schemaType: PathQuestionSchemaType;
  commonFields: PathCommonQuestionSchemaFields;
  attributeSchemaName?: Maybe<Scalars['String']>;
  attributeSchemaRevision?: Maybe<AttributeSchemaRevision>;
  placeholder?: Maybe<PathTemplateText>;
  renderingStyle?: Maybe<InputTextPathQuestionSchemaRenderingStyle>;
};

export type InputTextPathQuestionSchemaLengthValidationViewModel = {
  __typename: 'InputTextPathQuestionSchemaLengthValidationViewModel';
  minimumLength?: Maybe<Scalars['Int']>;
  maximumLength?: Maybe<Scalars['Int']>;
};

export type InputTextPathQuestionSchemaRegexValidationViewModel = {
  __typename: 'InputTextPathQuestionSchemaRegexValidationViewModel';
  regex: Scalars['String'];
  errorMessage: Scalars['String'];
};

export enum InputTextPathQuestionSchemaRenderingStyle {
  INPUT_FIELD = 'INPUT_FIELD',
  TEXT_AREA = 'TEXT_AREA',
  NUMERIC = 'NUMERIC',
  TELEPHONE = 'TELEPHONE',
  EMAIL = 'EMAIL'
}

export type InputTextPathQuestionSchemaUpsertEditorCommandInput = {
  id?: Maybe<Scalars['PathQuestionSchemaId']>;
  attributeSchemaName?: Maybe<Scalars['String']>;
  placeholder?: Maybe<Scalars['String']>;
  renderingStyle?: Maybe<InputTextPathQuestionSchemaRenderingStyle>;
};

export type InputTextPathQuestionSchemaValidationViewModel = InputTextPathQuestionSchemaLengthValidationViewModel | InputTextPathQuestionSchemaRegexValidationViewModel;

export type InputTextQuestionPathNodeFlowInputCommandInput = {
  questionId: Scalars['PathQuestionSchemaId'];
  value?: Maybe<Scalars['String']>;
};

export type InputTextQuestionPathNodeFlowViewModel = QuestionPathNodeFlowViewModel & {
  __typename: 'InputTextQuestionPathNodeFlowViewModel';
  id: Scalars['PathQuestionSchemaId'];
  schemaType: PathQuestionSchemaType;
  commonFields: CommonFieldsQuestionPathNodeFlowViewModel;
  placeholder?: Maybe<PathTextViewModel>;
  inputTextRenderingStyle: InputTextPathQuestionSchemaRenderingStyle;
  inputTextValue: Scalars['String'];
  validations: Array<InputTextPathQuestionSchemaValidationViewModel>;
};

export type InRangeDecimalAttributeValidatorReference = AttributeValidatorReference & {
  __typename: 'InRangeDecimalAttributeValidatorReference';
  id: Scalars['AttributeValidatorReferenceId'];
  type: AttributeValidatorType;
  min?: Maybe<Scalars['BigDecimal']>;
  max?: Maybe<Scalars['BigDecimal']>;
};

export type InRangeDecimalAttributeValidatorReferenceInput = {
  min?: Maybe<Scalars['BigDecimal']>;
  max?: Maybe<Scalars['BigDecimal']>;
};

export type InRangeIntegerAttributeValidatorReference = AttributeValidatorReference & {
  __typename: 'InRangeIntegerAttributeValidatorReference';
  id: Scalars['AttributeValidatorReferenceId'];
  type: AttributeValidatorType;
  min?: Maybe<Scalars['Long']>;
  max?: Maybe<Scalars['Long']>;
};

export type InRangeIntegerAttributeValidatorReferenceInput = {
  min?: Maybe<Scalars['Long']>;
  max?: Maybe<Scalars['Long']>;
};

export type InRangeNumericValidationQuestionPathNodeFlowViewModel = {
  __typename: 'InRangeNumericValidationQuestionPathNodeFlowViewModel';
  min?: Maybe<Scalars['BigDecimal']>;
  max?: Maybe<Scalars['BigDecimal']>;
};

export type InsertArticleRevisionContentBlockInput = {
  id: Scalars['ArticleRevisionId'];
  type: ArticleContentBlockType;
  /** Insert a block before this block. If this is empty, it appends as the last block */
  insertBeforeContentBlockId?: Maybe<Scalars['ArticleContentBlockId']>;
};

export type InstallmentPaymentEntity = PaymentEntity & {
  __typename: 'InstallmentPaymentEntity';
  paymentMethod: PaymentMethod;
  /** Payment token created and used during the approval process for this PaymentEntity */
  paymentToken: Scalars['String'];
};

export type InterestedInCuratedOrderRichCard = MessageRichCard & {
  __typename: 'InterestedInCuratedOrderRichCard';
  type: MessageRichCardType;
  expertCuratedOrderId: Scalars['ExpertCuratedOrderId'];
};

export type InternalMessagingUser = {
  __typename: 'InternalMessagingUser';
  id: Scalars['AnyId'];
  displayName: Scalars['String'];
};

export type InterstitialPathFlowPageMetadata = PathFlowPageMetadata & {
  __typename: 'InterstitialPathFlowPageMetadata';
  type: PathFlowPageMetadataType;
  interstitialType: InterstitialPathFlowPageMetadataType;
  title?: Maybe<TextViewModel>;
  body?: Maybe<TextViewModel>;
};

export enum InterstitialPathFlowPageMetadataType {
  ALMOST_DONE = 'ALMOST_DONE',
  BROWSE_EXPERTS = 'BROWSE_EXPERTS',
  CALCULATING = 'CALCULATING',
  CONNECTING_TO_OPERATOR = 'CONNECTING_TO_OPERATOR',
  FINDING_MERCHANTS = 'FINDING_MERCHANTS',
  /** GENERIC_WITH_BUTTON interstitial uses a button to submit */
  GENERIC_WITH_BUTTON = 'GENERIC_WITH_BUTTON',
  /** GENERIC_WITH_TITLE interstitial that uses timer to submit */
  GENERIC_WITH_TITLE = 'GENERIC_WITH_TITLE',
  HIGH_SECURITY = 'HIGH_SECURITY',
  LOADING_QUESTIONS = 'LOADING_QUESTIONS',
  SNOWBOARD_INT_LEARN = 'SNOWBOARD_INT_LEARN',
  WELCOME = 'WELCOME',
  GIVE_US_A_SEC = 'GIVE_US_A_SEC',
  REQUEST_PUSH_NOTIFICATION_PERMISSION = 'REQUEST_PUSH_NOTIFICATION_PERMISSION',
  WHAT_HAPPENS_NEXT = 'WHAT_HAPPENS_NEXT'
}

export type InterstitialPathNodeConfig = PathNodeConfig & {
  __typename: 'InterstitialPathNodeConfig';
  configType: PathNodeConfigType;
  condition?: Maybe<PathCondition>;
  interstitialType: InterstitialPathNodeConfigType;
  title?: Maybe<PathTemplateText>;
  body?: Maybe<PathTemplateText>;
  submitButtonText?: Maybe<PathTemplateText>;
  slug?: Maybe<Scalars['String']>;
};

export enum InterstitialPathNodeConfigType {
  CONTINUE_WITH_BUTTON = 'CONTINUE_WITH_BUTTON',
  TIMED_CONTINUE = 'TIMED_CONTINUE'
}

export type InterstitialPathNodeConfigUpsertEditorCommandInput = {
  interstitialType?: Maybe<InterstitialPathNodeConfigType>;
  slug?: Maybe<Scalars['String']>;
  condition?: Maybe<PathConditionEditorCommandInput>;
  title?: Maybe<Scalars['String']>;
  body?: Maybe<Scalars['String']>;
  submitButtonText?: Maybe<Scalars['String']>;
};

export type InterstitialPathNodeFlowViewModel = PathNodeFlowViewModel & SlugAwarePathNodeFlowViewModel & {
  __typename: 'InterstitialPathNodeFlowViewModel';
  id: Scalars['PathNodeId'];
  slug?: Maybe<Scalars['String']>;
  interstitialType: InterstitialPathNodeConfigType;
  title?: Maybe<PathTextViewModel>;
  body?: Maybe<PathTextViewModel>;
  submitButtonText?: Maybe<PathTextViewModel>;
};

export type InvalidAttributeForDepartmentExpertCuratedItemNoteEditError = ErrorMessage & {
  __typename: 'InvalidAttributeForDepartmentExpertCuratedItemNoteEditError';
  errorMessage: Scalars['String'];
};

export type InvalidNoteStateExpertCuratedItemNoteEditError = ErrorMessage & {
  __typename: 'InvalidNoteStateExpertCuratedItemNoteEditError';
  errorMessage: Scalars['String'];
  state: ExpertCuratedItemNoteState;
};

export type InvalidSavedExpertCuratedItemSavedExpertCuratedItemsEditExpertCuratedItemNoteError = ErrorMessage & {
  __typename: 'InvalidSavedExpertCuratedItemSavedExpertCuratedItemsEditExpertCuratedItemNoteError';
  errorMessage: Scalars['String'];
  id: Scalars['SavedExpertCuratedItemsId'];
  itemId: Scalars['SellableId'];
};

export type InvalidSearchQuerySellableSearchError = ErrorMessage & {
  __typename: 'InvalidSearchQuerySellableSearchError';
  errorMessage: Scalars['String'];
};

export type InvalidStateApprovalRequestPublishError = ApprovalRequestPublishError & ErrorMessage & {
  __typename: 'InvalidStateApprovalRequestPublishError';
  errorMessage: Scalars['String'];
  breadcrumbTrail: Array<ApprovalRequest>;
  approvalRequest: ApprovalRequest;
};

export type InvalidVariantProductCatalogPublishError = ErrorMessage & {
  __typename: 'InvalidVariantProductCatalogPublishError';
  errorMessage: Scalars['String'];
  revisions: Array<ProductCatalogRevision>;
};

export type InventoryTaskError = {
  __typename: 'InventoryTaskError';
  sheetTitle?: Maybe<Scalars['String']>;
  row: Scalars['Int'];
  message: Scalars['String'];
};

export type InvoicedShippingCostUploadTaskError = {
  __typename: 'InvoicedShippingCostUploadTaskError';
  row: Scalars['Int'];
  message: Scalars['String'];
};

export type InvoicedShippingCostUploadTaskPayload = {
  __typename: 'InvoicedShippingCostUploadTaskPayload';
  numRowsProcessed: Scalars['Int'];
  numRowsIgnored: Scalars['Int'];
  errors: Array<InvoicedShippingCostUploadTaskError>;
  googleSpreadsheetId: Scalars['String'];
  recordsUpdated: Scalars['Int'];
};

export type IpBasedUserData = {
  __typename: 'IpBasedUserData';
  companyName?: Maybe<Scalars['String']>;
  website?: Maybe<Scalars['String']>;
  countryName?: Maybe<Scalars['String']>;
  regionName?: Maybe<Scalars['String']>;
  city?: Maybe<Scalars['String']>;
};

export type ItemClaimsGroupingTicket = TicketDetail & {
  __typename: 'ItemClaimsGroupingTicket';
  type: TicketType;
  consumerId: Scalars['UserId'];
  order: Order;
  lineItemIds: Array<Scalars['OrderLineItemId']>;
  orderLineItemIds: Array<Scalars['OrderLineItemId']>;
};

export type ItemFulfillmentSuggestion = {
  __typename: 'ItemFulfillmentSuggestion';
  status: FulfillmentSuggestionStatus;
  note?: Maybe<Scalars['String']>;
  fulfillmentChannel: FulfillmentChannel;
};

export type ItemReturnReceivedActivity = OrderActivityDetail & {
  __typename: 'ItemReturnReceivedActivity';
  type: OrderActivityDetailType;
  orderRefund?: Maybe<OrderRefund>;
};

export type ItemReturnRequestedActivity = OrderActivityDetail & {
  __typename: 'ItemReturnRequestedActivity';
  type: OrderActivityDetailType;
  requestedBy: Operator;
  escalation: OrderEscalation;
  orderRefund?: Maybe<OrderRefund>;
};

export type ItemReturnShippedActivity = OrderActivityDetail & {
  __typename: 'ItemReturnShippedActivity';
  type: OrderActivityDetailType;
  orderRefund?: Maybe<OrderRefund>;
};

export type ItemUnavailableTicket = TicketDetail & {
  __typename: 'ItemUnavailableTicket';
  type: TicketType;
  consumer: User;
  order: Order;
  orderLineItemIds: Array<Scalars['OrderLineItemId']>;
};

export type JoinVideoChatInput = {
  messagingUserId: Scalars['AnyId'];
  externalConversationId: Scalars['String'];
};

export type JoinVideoChatPayload = {
  __typename: 'JoinVideoChatPayload';
  token: Scalars['String'];
};

export type Lead = {
  __typename: 'Lead';
  id: Scalars['LeadId'];
  consumer: User;
  /**
   * The expert of the lead. If the lead is assigned to an expert, this is the same as primaryExpert. Otherwise,
   * this is a placeholder expert.
   */
  expert: BusinessUser;
  /** The primary expert for the lead, if the lead is assigned to an expert */
  primaryExpert?: Maybe<BusinessUser>;
  delegateExpert?: Maybe<BusinessUser>;
  conversation: Conversation;
  qualityConversationWithCuration: Scalars['Boolean'];
  labels: Array<LeadLabel>;
  starred: Scalars['Boolean'];
  /** @deprecated Replaced by the neverReplied */
  notRepliedByConsumer: Scalars['Boolean'];
  neverReplied: Scalars['Boolean'];
  archived: Scalars['Boolean'];
  active: Scalars['Boolean'];
  snoozed: Scalars['Boolean'];
  spam: Scalars['Boolean'];
  spamRisk: Scalars['Boolean'];
  latestRequest?: Maybe<DealRequest>;
  /** The related requests are sorted according to the creation time in ascending order */
  relatedRequests: Array<DealRequest>;
  snooze?: Maybe<LeadSnooze>;
  offers: Array<BroadcastOffer>;
  consumerConversationMetrics: ConversationMetrics;
  expertConversationMetrics: ConversationMetrics;
  dealbotConversationMetrics: ConversationMetrics;
  consumerUrl: Scalars['String'];
  expertUrl: Scalars['String'];
  expertUrlForAdmin: Scalars['String'];
  adminUrl: Scalars['String'];
  recommendationsUrl: Scalars['String'];
  consumerExpertReferralUrl: Scalars['String'];
  /** Note forceCalculate flag is for admin only test */
  initialLeadScoreOnNewRequest?: Maybe<Scalars['Float']>;
  /** Note forceCalculate flag is for admin only test */
  leadScore?: Maybe<Scalars['Float']>;
  consumerReview?: Maybe<ConsumerExpertReview>;
  expertTeam?: Maybe<BusinessUserTeam>;
  /** used for graphql-based trigger entity.  expose Id directly to avoid unnecessary joins */
  labelIds: Array<Scalars['LeadLabelId']>;
  expertTeamId?: Maybe<Scalars['BusinessUserTeamId']>;
  expertId: Scalars['BusinessUserId'];
  delegateExpertId?: Maybe<Scalars['BusinessUserId']>;
  consumerId: Scalars['UserId'];
  lastMessageSentAt?: Maybe<Scalars['Date']>;
  consumerInitialAction?: Maybe<ConsumerInitialLeadAction>;
  pinnedMessages: Array<SavedLeadNote>;
  notes: Array<SavedLeadNote>;
  expertRecommendationRecord?: Maybe<ExpertRecommendationRecord>;
  lastActivityTime: Scalars['Date'];
  lastExpertMessageSentAt?: Maybe<Scalars['Date']>;
  lastExpertManualMessageSentAt?: Maybe<Scalars['Date']>;
  lastAssistantMessageSentAt?: Maybe<Scalars['Date']>;
  firstExpertManualMessageSentAt?: Maybe<Scalars['Date']>;
  lastManualMessageSenderType?: Maybe<LeadParticipantType>;
  expertMessageCount: Scalars['Int'];
  curationSummary: CurationSummary;
  surveySummary?: Maybe<SurveySummary>;
  phoneCallSummary: PhoneCallSummary;
  createdAt: Scalars['Date'];
  /** this is based on request first, if request is null, it will be the expert category id. */
  category: Category;
  /** this is based on request first, if request is null, it will be the expert category id. */
  expertCategory: Category;
  department: Department;
  suggestedActions: Array<SuggestedAction>;
  openEscalation?: Maybe<LeadEscalation>;
  curationLastViewedAt?: Maybe<Scalars['Date']>;
  otherActiveLeadsInDepartment: Array<Lead>;
  intentLabels: Array<LeadIntentLabel>;
  expertsParticipated: Array<BusinessUser>;
  /** If the lead must be an assistant first lead */
  forceAssistantFirst: Scalars['Boolean'];
  assignmentStage: LeadAssignmentStage;
  sourceFlow?: Maybe<LeadSourceFlow>;
  sourcePage?: Maybe<LeadSourcePage>;
  tickets: Array<Ticket>;
  conversationStarterActivity?: Maybe<LeadConversationStarterActivity>;
  practiceLead: Scalars['Boolean'];
  trainingScenario?: Maybe<LeadTrainingScenario>;
  needsAttentionTicketIds: Array<Scalars['TicketId']>;
  rPALExclusion?: Maybe<RpalExclusion>;
  emailDeliveryLogs: Array<TemplateMessageDeliveryLog>;
  leadActivities: Array<LeadActivity>;
  supportTaskActivities: Array<SupportTaskActivity>;
  ticketActivities: Array<TicketActivity>;
  /** @deprecated use specialCareTags */
  skiTripLead: Scalars['Boolean'];
  specialCareTags: Array<Scalars['String']>;
};


export type LeadInitialLeadScoreOnNewRequestArgs = {
  forceCalculate?: Maybe<Scalars['Boolean']>;
};


export type LeadLeadScoreArgs = {
  forceCalculate?: Maybe<Scalars['Boolean']>;
};


export type LeadOpenEscalationArgs = {
  type: LeadEscalationType;
};


export type LeadConversationStarterActivityArgs = {
  id: Scalars['LeadConversationStarterActivityId'];
};


export type LeadEmailDeliveryLogsArgs = {
  occurredSince?: Maybe<Scalars['Date']>;
  occurredBefore?: Maybe<Scalars['Date']>;
  limit?: Maybe<Scalars['Int']>;
};


export type LeadLeadActivitiesArgs = {
  occurredSince?: Maybe<Scalars['Date']>;
  occurredBefore?: Maybe<Scalars['Date']>;
  limit?: Maybe<Scalars['Int']>;
};


export type LeadSupportTaskActivitiesArgs = {
  occurredSince?: Maybe<Scalars['Date']>;
  occurredBefore?: Maybe<Scalars['Date']>;
  limit?: Maybe<Scalars['Int']>;
};


export type LeadTicketActivitiesArgs = {
  occurredSince?: Maybe<Scalars['Date']>;
  occurredBefore?: Maybe<Scalars['Date']>;
  limit?: Maybe<Scalars['Int']>;
  activityTypes?: Maybe<Array<TicketActivityType>>;
};

export type LeadActivity = {
  id: Scalars['LeadActivityId'];
  type: LeadActivityType;
  lead: Lead;
  occurredAt: Scalars['Date'];
  performedBy: Identity;
};


export enum LeadActivityType {
  DELEGATE_EXPERT_CHANGED = 'DELEGATE_EXPERT_CHANGED',
  SNOOZE_CHANGED = 'SNOOZE_CHANGED',
  WOKE_UP_FROM_SNOOZE = 'WOKE_UP_FROM_SNOOZE',
  REASSIGNED = 'REASSIGNED',
  ARCHIVED = 'ARCHIVED',
  CONSUMER_FIRST_MESSAGE_SENT = 'CONSUMER_FIRST_MESSAGE_SENT',
  CONSUMER_CALLED = 'CONSUMER_CALLED',
  CONSUMER_PAYMENT_FAILED = 'CONSUMER_PAYMENT_FAILED',
  CONSUMER_PAYMENT_SUCCEEDED = 'CONSUMER_PAYMENT_SUCCEEDED',
  CONSUMER_ORDER_PAID = 'CONSUMER_ORDER_PAID',
  CONSUMER_REVIEW_ADDED = 'CONSUMER_REVIEW_ADDED',
  ESCALATION_STARTED = 'ESCALATION_STARTED',
  ESCALATION_CHANGED = 'ESCALATION_CHANGED',
  QUALITY_CONVERSATION_ESTABLISHED = 'QUALITY_CONVERSATION_ESTABLISHED',
  QUALITY_CONVO_WITH_CURATION_ESTABLISHED = 'QUALITY_CONVO_WITH_CURATION_ESTABLISHED',
  LEAD_CREATED = 'LEAD_CREATED',
  STOP_REQUESTED = 'STOP_REQUESTED',
  GIFT_CARD_REDEEMED = 'GIFT_CARD_REDEEMED',
  REQUEST_SUBMITTED = 'REQUEST_SUBMITTED'
}

export type LeadArchivedActivity = LeadActivity & {
  __typename: 'LeadArchivedActivity';
  id: Scalars['LeadActivityId'];
  type: LeadActivityType;
  lead: Lead;
  occurredAt: Scalars['Date'];
  performedBy: Identity;
};

export enum LeadAssignmentStage {
  INITIAL = 'INITIAL',
  ESCALATING = 'ESCALATING',
  FINAL = 'FINAL'
}

export type LeadCampaign = {
  __typename: 'LeadCampaign';
  id: Scalars['LeadCampaignId'];
  name: Scalars['String'];
  minimumHoursSinceLastMessage: Scalars['Float'];
  minimumHoursSinceLastCampaign: Scalars['Float'];
  maximumRecipients: Scalars['Float'];
  facets: Array<FacetSelectionPayload>;
  decoratedFacets: Array<DisplayFacet>;
  state: LeadCampaignState;
  dateRangeFilters: Array<DateRangeFilter>;
  keywordsFilter?: Maybe<Scalars['String']>;
  firstTouchFilters: Array<LeadTouchSearchFilter>;
  filters: Array<FilterFieldCondition>;
  trigger?: Maybe<Trigger>;
  totalDelivered: Scalars['Int'];
  lastDeliveryTime?: Maybe<Scalars['Date']>;
  firstDeliveryTime?: Maybe<Scalars['Date']>;
  totalTargetRecipients?: Maybe<Scalars['Int']>;
  deliveryHistory: Array<LeadCampaignDeliveryResult>;
  pendingDelivery?: Maybe<LeadCampaignDeliveryRequest>;
  recipientSortOrder: LeadCampaignRecipientSortOrder;
  triggerExecutionInterval: LeadCampaignTriggerExecutionInterval;
};

export type LeadCampaignDeliveryRequest = {
  __typename: 'LeadCampaignDeliveryRequest';
  batchSize: Scalars['Int'];
  scheduledAt: Scalars['Date'];
};

export type LeadCampaignDeliveryResult = {
  __typename: 'LeadCampaignDeliveryResult';
  totalDelivered: Scalars['Int'];
  startDeliveryTime: Scalars['Date'];
  endDeliveryTime: Scalars['Date'];
};

export type LeadCampaignFilter = {
  name?: Maybe<Scalars['String']>;
  state?: Maybe<LeadCampaignState>;
};


export type LeadCampaignRecipient = {
  __typename: 'LeadCampaignRecipient';
  id: Scalars['LeadCampaignRecipientId'];
  lead: Lead;
  campaign: LeadCampaign;
};


export enum LeadCampaignRecipientSortOrder {
  MOST_RECENT_ACTIVITY = 'MOST_RECENT_ACTIVITY',
  RANDOM = 'RANDOM'
}

export type LeadCampaignSettings = CampaignSettings & {
  __typename: 'LeadCampaignSettings';
  type: CampaignAudienceMemberType;
  minimumTimeSinceLastCampaign: Duration;
  minimumTimeSinceLastMessage: Duration;
  recipientSortOrder: CampaignRecipientSortOrder;
};

export type LeadCampaignSettingsInput = {
  minimumTimeSinceLastMessage: DurationInput;
  minimumTimeSinceLastCampaign: DurationInput;
  recipientSortOrder: CampaignRecipientSortOrder;
};

export enum LeadCampaignState {
  DRAFT = 'DRAFT',
  PREPARING = 'PREPARING',
  PUBLISHED = 'PUBLISHED',
  DELIVERING = 'DELIVERING',
  DEACTIVATED = 'DEACTIVATED'
}

export enum LeadCampaignTriggerExecutionInterval {
  EMAIL = 'EMAIL',
  SMS_LONG_CODE = 'SMS_LONG_CODE',
  SMS_SHORT_CODE = 'SMS_SHORT_CODE'
}

export type LeadConversationStarterActivity = {
  __typename: 'LeadConversationStarterActivity';
  id: Scalars['LeadConversationStarterActivityId'];
  sourcePage?: Maybe<LeadSourcePage>;
  conversationStarterDefinitionId: Scalars['ConversationStarterDefinitionId'];
  title: Scalars['String'];
  message: Scalars['String'];
};


export type LeadCreatedActivity = LeadActivity & {
  __typename: 'LeadCreatedActivity';
  id: Scalars['LeadActivityId'];
  type: LeadActivityType;
  lead: Lead;
  occurredAt: Scalars['Date'];
  performedBy: Identity;
};

export type LeadEscalation = {
  __typename: 'LeadEscalation';
  id: Scalars['LeadEscalationId'];
  createdAt: Scalars['Date'];
  type: LeadEscalationType;
  acceptAsLeadExpertRole: LeadExpertRole;
  level: LeadEscalationLevel;
  /** only used for trigger entity so that we skip looking up the business user */
  ownerId?: Maybe<Scalars['BusinessUserId']>;
  expertsNotifiedAt?: Maybe<Scalars['Date']>;
  teamNotifiedAt?: Maybe<Scalars['Date']>;
  supportNotifiedAt?: Maybe<Scalars['Date']>;
  closedAt?: Maybe<Scalars['Date']>;
  status: LeadEscalationStatus;
  lead: Lead;
  owner?: Maybe<BusinessUser>;
  onCallExpertCount: Scalars['Int'];
  expertEscalationUrl: Scalars['String'];
};

export type LeadEscalationChangedActivity = LeadActivity & {
  __typename: 'LeadEscalationChangedActivity';
  id: Scalars['LeadActivityId'];
  type: LeadActivityType;
  lead: Lead;
  occurredAt: Scalars['Date'];
  oldEscalation: LeadEscalation;
  newEscalation: LeadEscalation;
  closing: Scalars['Boolean'];
  escalatingUp: Scalars['Boolean'];
  escalatingToTeam: Scalars['Boolean'];
  performedBy: Identity;
};


export enum LeadEscalationLevel {
  NOT_STARTED = 'NOT_STARTED',
  ONLINE_TEAM_MEMBERS = 'ONLINE_TEAM_MEMBERS',
  ALL_TEAM_MEMBERS = 'ALL_TEAM_MEMBERS',
  SUPPORT = 'SUPPORT',
  ONLINE_EXPERTS = 'ONLINE_EXPERTS',
  ALL_EXPERTS = 'ALL_EXPERTS',
  ON_CALL_EXPERTS = 'ON_CALL_EXPERTS'
}

export type LeadEscalationStartedActivity = LeadActivity & {
  __typename: 'LeadEscalationStartedActivity';
  id: Scalars['LeadActivityId'];
  type: LeadActivityType;
  lead: Lead;
  occurredAt: Scalars['Date'];
  escalation: LeadEscalation;
  performedBy: Identity;
};

export enum LeadEscalationStatus {
  OPEN = 'OPEN',
  CLOSED = 'CLOSED'
}

export enum LeadEscalationType {
  CONSUMER_WAITING_RESPONSE = 'CONSUMER_WAITING_RESPONSE'
}

export enum LeadExpertRole {
  PRIMARY = 'PRIMARY',
  DELEGATE = 'DELEGATE'
}

export type LeadGiftCardRedeemedActivity = LeadActivity & {
  __typename: 'LeadGiftCardRedeemedActivity';
  id: Scalars['LeadActivityId'];
  type: LeadActivityType;
  lead: Lead;
  occurredAt: Scalars['Date'];
  performedBy: Identity;
};


/** Triggered when the leads predicted intent changes */
export type LeadIntentChange = {
  __typename: 'LeadIntentChange';
  lead: Lead;
  /** This returns the full copy of the new intent labels not just the diff */
  changedIntentLabels: Array<LeadIntentLabel>;
  changedAt: Scalars['Date'];
};

export enum LeadIntentLabel {
  /** Lead predicted to have a high intent for conversion. */
  HIGH_INTENT_FOR_CONVERSION = 'HIGH_INTENT_FOR_CONVERSION'
}

export type LeadLabel = {
  __typename: 'LeadLabel';
  id: Scalars['LeadLabelId'];
  name: Scalars['String'];
  internalId: Scalars['String'];
};



/** @deprecated(reason: "LeadPaymentSucceededActivity") */
export type LeadOrderPaidActivity = LeadActivity & {
  __typename: 'LeadOrderPaidActivity';
  id: Scalars['LeadActivityId'];
  type: LeadActivityType;
  lead: Lead;
  occurredAt: Scalars['Date'];
  orderId: Scalars['OrderId'];
  total: MonetaryAmount;
  tip?: Maybe<MonetaryAmount>;
  performedBy: Identity;
};

export enum LeadParticipantType {
  EXPERT = 'EXPERT',
  DELEGATE_EXPERT = 'DELEGATE_EXPERT',
  CONSUMER = 'CONSUMER',
  ASSISTANT = 'ASSISTANT',
  DEAL_BOT = 'DEAL_BOT'
}

export type LeadPayload = {
  __typename: 'LeadPayload';
  lead?: Maybe<Lead>;
  errorCode?: Maybe<GetEntityErrorCode>;
  maskedUserHandles?: Maybe<Array<MaskedUserHandle>>;
};

export type LeadPaymentFailedActivity = LeadActivity & {
  __typename: 'LeadPaymentFailedActivity';
  id: Scalars['LeadActivityId'];
  type: LeadActivityType;
  paymentActivityType: PaymentActivityType;
  lead: Lead;
  occurredAt: Scalars['Date'];
  orderId: Scalars['OrderId'];
  total: MonetaryAmount;
  amountPaid: MonetaryAmount;
  transactionAmount: MonetaryAmount;
  tip?: Maybe<MonetaryAmount>;
  paymentSource: Scalars['String'];
  paymentError: Scalars['String'];
  performedBy: Identity;
};

export type LeadPaymentSucceededActivity = LeadActivity & {
  __typename: 'LeadPaymentSucceededActivity';
  id: Scalars['LeadActivityId'];
  type: LeadActivityType;
  paymentActivityType: PaymentActivityType;
  lead: Lead;
  occurredAt: Scalars['Date'];
  orderId: Scalars['OrderId'];
  total: MonetaryAmount;
  amountPaid: MonetaryAmount;
  transactionAmount: MonetaryAmount;
  fullPaymentDueAt?: Maybe<Scalars['Date']>;
  tip?: Maybe<MonetaryAmount>;
  performedBy: Identity;
};

export enum LeadPostOrderCheckinReason {
  FIRST_ITEM_SHIPPED = 'FIRST_ITEM_SHIPPED',
  ITEM_UNAVAILABLE = 'ITEM_UNAVAILABLE'
}

export type LeadReassignedActivity = LeadActivity & {
  __typename: 'LeadReassignedActivity';
  id: Scalars['LeadActivityId'];
  type: LeadActivityType;
  lead: Lead;
  occurredAt: Scalars['Date'];
  currentExpert: BusinessUser;
  previousExpert: BusinessUser;
  performedBy: Identity;
  reason?: Maybe<LeadReassignmentReason>;
  reasonNote?: Maybe<Scalars['String']>;
};

export enum LeadReassignmentReason {
  EXPERT_DEACTIVATED = 'EXPERT_DEACTIVATED',
  EXPERT_UNAVAILABLE = 'EXPERT_UNAVAILABLE',
  CATEGORY_TRANSFER = 'CATEGORY_TRANSFER',
  SPECIALITY_TRANSFER = 'SPECIALITY_TRANSFER',
  ORDER_SUPPORT_ACTION = 'ORDER_SUPPORT_ACTION',
  ESCALATION_ACCEPTED = 'ESCALATION_ACCEPTED',
  SURGE_LEAD_CLAIMED = 'SURGE_LEAD_CLAIMED',
  FINAL_ASSIGNMENT = 'FINAL_ASSIGNMENT',
  OTHER = 'OTHER'
}

export type LeadRequestSubmittedActivity = LeadActivity & {
  __typename: 'LeadRequestSubmittedActivity';
  id: Scalars['LeadActivityId'];
  type: LeadActivityType;
  lead: Lead;
  occurredAt: Scalars['Date'];
  performedBy: Identity;
};

export type LeadSavedSearchContext = {
  expertId?: Maybe<Scalars['BusinessUserId']>;
  expertTeamId?: Maybe<Scalars['BusinessUserTeamId']>;
};

export type LeadSearchConnection = {
  __typename: 'LeadSearchConnection';
  facets: Array<DisplayFacet>;
  filters: Array<FilterFieldCondition>;
  edges: Array<LeadSearchEdge>;
  pageInfo: PageInfo;
  count?: Maybe<Scalars['Int']>;
};

export type LeadSearchEdge = {
  __typename: 'LeadSearchEdge';
  node: Lead;
  cursor: Scalars['String'];
};

export type LeadSearchQuery = {
  facetedSearch: Scalars['Boolean'];
  facets?: Maybe<Array<FacetSelection>>;
  expertId?: Maybe<Scalars['BusinessUserId']>;
  expertTeamId?: Maybe<Scalars['BusinessUserTeamId']>;
  expertCategoryId?: Maybe<Scalars['CategoryId']>;
  departmentId?: Maybe<Scalars['DepartmentId']>;
  consumerId?: Maybe<Scalars['UserId']>;
  whitelistedFacets?: Maybe<Array<Scalars['String']>>;
  dateRangeFilters?: Maybe<Array<DateRangeFilterInput>>;
  keywords?: Maybe<Scalars['String']>;
  firstTouches?: Maybe<Array<LeadTouchSearchFilterInput>>;
  totalOrderAmountUSD?: Maybe<FloatRangeInput>;
  hasOpenEscalation?: Maybe<Scalars['Boolean']>;
  openEscalationCreatedAt?: Maybe<DateRangeInput>;
  openEscalationExpertRole?: Maybe<LeadExpertRole>;
  expertActionRequired?: Maybe<Scalars['Boolean']>;
  filters?: Maybe<Array<SearchFilterFieldInput>>;
  relativeDateBase?: Maybe<Scalars['Date']>;
  zipCodeRadius?: Maybe<GeoZipCodeRadiusInput>;
  excludedFromRPAL?: Maybe<Scalars['Boolean']>;
};

export type LeadSnooze = {
  __typename: 'LeadSnooze';
  wakeupTime: Scalars['Date'];
  note?: Maybe<Scalars['String']>;
  message?: Maybe<Scalars['String']>;
  messageSentAt?: Maybe<Scalars['Date']>;
  editedAt?: Maybe<Scalars['Date']>;
  cancelMessageOnConsumerReply: Scalars['Boolean'];
};

export enum LeadSortOrder {
  ACTIVITY_DATE = 'ACTIVITY_DATE',
  CREATION_DATE = 'CREATION_DATE',
  CURATION_DATE = 'CURATION_DATE',
  PRIORITY = 'PRIORITY'
}

export type LeadSourceConversationStarterFlow = LeadSourceFlow & {
  __typename: 'LeadSourceConversationStarterFlow';
  type: LeadSourceFlowType;
  conversationStarterActivity: LeadConversationStarterActivity;
};

export type LeadSourceConversationStarterFlowInput = {
  conversationStarterDefinitionId: Scalars['ConversationStarterDefinitionId'];
  title: Scalars['String'];
  message: Scalars['String'];
};

export type LeadSourceDepartmentPage = LeadSourcePage & {
  __typename: 'LeadSourceDepartmentPage';
  type: LeadSourcePageType;
  trackingKey?: Maybe<Scalars['String']>;
  departmentId: Scalars['DepartmentId'];
  department: Department;
};

export type LeadSourceDepartmentPageInput = {
  departmentId: Scalars['DepartmentId'];
  trackingKey?: Maybe<Scalars['String']>;
};

export type LeadSourceDirectExpertChatFlow = LeadSourceFlow & {
  __typename: 'LeadSourceDirectExpertChatFlow';
  type: LeadSourceFlowType;
};

export type LeadSourceDirectExpertChatFlowInput = {
  expertId: Scalars['BusinessUserId'];
};

export type LeadSourceExpertProfilePage = LeadSourcePage & {
  __typename: 'LeadSourceExpertProfilePage';
  type: LeadSourcePageType;
  trackingKey?: Maybe<Scalars['String']>;
  expertId: Scalars['BusinessUserId'];
  expert: BusinessUser;
};

export type LeadSourceExpertProfilePageInput = {
  expertId: Scalars['BusinessUserId'];
  trackingKey?: Maybe<Scalars['String']>;
};

export type LeadSourceFlow = {
  type: LeadSourceFlowType;
};

export enum LeadSourceFlowType {
  REGISTRATION = 'REGISTRATION',
  PATH = 'PATH',
  CONVERSATION_STARTER = 'CONVERSATION_STARTER',
  DIRECT_EXPERT_CHAT = 'DIRECT_EXPERT_CHAT',
  INCOMING_CALL_OR_MESSAGE = 'INCOMING_CALL_OR_MESSAGE',
  POST_ORDER_CHECKIN = 'POST_ORDER_CHECKIN'
}

export type LeadSourceGiftCardRedeemPage = LeadSourcePage & {
  __typename: 'LeadSourceGiftCardRedeemPage';
  type: LeadSourcePageType;
  trackingKey?: Maybe<Scalars['String']>;
  giftCard: GiftCard;
};

export type LeadSourceIncomingCallOrMessageFlow = LeadSourceFlow & {
  __typename: 'LeadSourceIncomingCallOrMessageFlow';
  type: LeadSourceFlowType;
};

export type LeadSourcePage = {
  type: LeadSourcePageType;
  trackingKey?: Maybe<Scalars['String']>;
};

export enum LeadSourcePageType {
  SELLABLE_DETAIL = 'SELLABLE_DETAIL',
  EXPERT_PROFILE = 'EXPERT_PROFILE',
  SELLABLE_SEARCH = 'SELLABLE_SEARCH',
  SELLABLE_TOP_LIST = 'SELLABLE_TOP_LIST',
  DEPARTMENT = 'DEPARTMENT',
  GIFT_CARD_REDEEM = 'GIFT_CARD_REDEEM'
}

export type LeadSourcePathFlow = LeadSourceFlow & {
  __typename: 'LeadSourcePathFlow';
  type: LeadSourceFlowType;
  requestId: Scalars['DealRequestId'];
};

export type LeadSourcePostOrderCheckinFlow = LeadSourceFlow & {
  __typename: 'LeadSourcePostOrderCheckinFlow';
  type: LeadSourceFlowType;
  order: Order;
  reason?: Maybe<LeadPostOrderCheckinReason>;
  ticket?: Maybe<Ticket>;
};

export type LeadSourceRegistrationFlow = LeadSourceFlow & {
  __typename: 'LeadSourceRegistrationFlow';
  type: LeadSourceFlowType;
  registrationChannel: UserRegistrationChannel;
};

export type LeadSourceSellablePage = LeadSourcePage & {
  __typename: 'LeadSourceSellablePage';
  type: LeadSourcePageType;
  trackingKey?: Maybe<Scalars['String']>;
  sellable: Sellable;
  sellableId: Scalars['SellableId'];
  conversationStarterActivity?: Maybe<LeadConversationStarterActivity>;
};

export type LeadSourceSellablePageInput = {
  sellableId: Scalars['SellableId'];
  trackingKey?: Maybe<Scalars['String']>;
};

export type LeadSourceSellableSearchPage = LeadSourcePage & {
  __typename: 'LeadSourceSellableSearchPage';
  type: LeadSourcePageType;
  trackingKey?: Maybe<Scalars['String']>;
  keywords?: Maybe<Scalars['String']>;
  facets: Array<FacetSelectionPayload>;
  decoratedFacets: Array<DisplayFacet>;
  categoryId: Scalars['CategoryId'];
  category: Category;
};

export type LeadSourceSellableSearchPageInput = {
  keywords?: Maybe<Scalars['String']>;
  facets?: Maybe<Array<FacetSelection>>;
  categorySlug: Scalars['String'];
  trackingKey?: Maybe<Scalars['String']>;
};

export type LeadSourceSellableTopListPage = LeadSourcePage & {
  __typename: 'LeadSourceSellableTopListPage';
  type: LeadSourcePageType;
  trackingKey?: Maybe<Scalars['String']>;
  sellableTopListId: Scalars['SellableTopListId'];
  sellableTopList: SellableTopList;
  sellableTopListSellableId?: Maybe<Scalars['SellableId']>;
  sellableTopListSellable?: Maybe<Sellable>;
};

export type LeadSourceSellableTopListPageInput = {
  sellableTopListId: Scalars['SellableTopListId'];
  sellableId?: Maybe<Scalars['SellableId']>;
  trackingKey?: Maybe<Scalars['String']>;
};

export type LeadSpamRiskSupportTaskActivity = SupportTaskActivity & {
  __typename: 'LeadSpamRiskSupportTaskActivity';
  id: Scalars['SupportTaskActivityId'];
  supportTask: SupportTask;
  action: SupportTaskAction;
  actor: SupportTaskActor;
  consumer: User;
  lead?: Maybe<Lead>;
  occurredAt: Scalars['Date'];
  spam: Scalars['Boolean'];
};

export type LeadStats = {
  __typename: 'LeadStats';
  conversationCount: Scalars['Long'];
  conversationCountInLastSevenDays: Scalars['Long'];
};

export type LeadStopRequestedActivity = LeadActivity & {
  __typename: 'LeadStopRequestedActivity';
  id: Scalars['LeadActivityId'];
  type: LeadActivityType;
  lead: Lead;
  occurredAt: Scalars['Date'];
  performedBy: Identity;
};

export type LeadSupportTask = SupportTask & {
  __typename: 'LeadSupportTask';
  id: Scalars['SupportTaskId'];
  type: SupportTaskType;
  state: SupportTaskState;
  url: Scalars['String'];
  dueAt: Scalars['Date'];
  assignedTo?: Maybe<Operator>;
  assignedAt?: Maybe<Scalars['Date']>;
  createdAt: Scalars['Date'];
  completedAt?: Maybe<Scalars['Date']>;
  lead: Lead;
  reason: LeadSupportTaskReason;
  reasonDescription: Scalars['String'];
};

export enum LeadSupportTaskReason {
  NEW_UNASSIGNED_LEAD = 'NEW_UNASSIGNED_LEAD',
  EXPERT_OUT_OF_SLA = 'EXPERT_OUT_OF_SLA',
  ESCALATION_FAILED = 'ESCALATION_FAILED',
  ESCALATION_FOR_DELEGATION_FAILED = 'ESCALATION_FOR_DELEGATION_FAILED',
  ESCALATION_FOR_REASSIGNMENT_FAILED = 'ESCALATION_FOR_REASSIGNMENT_FAILED',
  UNSNOOZED = 'UNSNOOZED',
  SPAM_RISK = 'SPAM_RISK',
  RESPONDED_TO_SUPPORT = 'RESPONDED_TO_SUPPORT',
  EVALUATE_CONVERSATION = 'EVALUATE_CONVERSATION',
  DEFAULT = 'DEFAULT'
}

export type LeadSurge = {
  __typename: 'LeadSurge';
  id: Scalars['LeadSurgeId'];
  category: Category;
  surgeFactor: Scalars['Float'];
  occurredAt: Scalars['Date'];
  availableSurgeShiftCount: Scalars['Int'];
};


/**
 * custom lead filters. put it here so that we can add the touch filter to the big SearchFilterFieldValueInput union
 * for easier manipulation on the frontend when building reusalbe filter field components.
 */
export type LeadTouchFilterFieldDefinition = FilterFieldDefinition & {
  __typename: 'LeadTouchFilterFieldDefinition';
  name: Scalars['String'];
  displayName: Scalars['String'];
  custom: Scalars['Boolean'];
  deprecated: Scalars['Boolean'];
};

export type LeadTouchFilterFieldValue = FilterFieldValue & {
  __typename: 'LeadTouchFilterFieldValue';
  custom: Scalars['Boolean'];
  source: Scalars['String'];
  campaignIds?: Maybe<Array<Scalars['String']>>;
  adGroupIds?: Maybe<Array<Scalars['String']>>;
  adIds?: Maybe<Array<Scalars['String']>>;
};

export type LeadTouchFilterFieldValueInput = {
  source: Scalars['String'];
  campaignIds?: Maybe<Array<Scalars['String']>>;
  adGroupIds?: Maybe<Array<Scalars['String']>>;
  adIds?: Maybe<Array<Scalars['String']>>;
};

export type LeadTouchSearchFilter = {
  __typename: 'LeadTouchSearchFilter';
  sources: Array<Scalars['String']>;
  campaignIds: Array<Scalars['String']>;
  adGroupIds: Array<Scalars['String']>;
  adIds: Array<Scalars['String']>;
};

export type LeadTouchSearchFilterInput = {
  sources?: Maybe<Array<Scalars['String']>>;
  campaignIds?: Maybe<Array<Scalars['String']>>;
  adGroupIds?: Maybe<Array<Scalars['String']>>;
  adIds?: Maybe<Array<Scalars['String']>>;
};

export type LeadTrainingScenario = {
  __typename: 'LeadTrainingScenario';
  id: Scalars['LeadTrainingScenarioId'];
  title: Scalars['String'];
  description: Scalars['String'];
  department: Department;
  consumer: User;
  sourcePage?: Maybe<LeadSourcePage>;
  sourceFlow?: Maybe<LeadSourceFlow>;
};

export type LeadTrainingScenarioFilterInput = {
  departmentId?: Maybe<Scalars['DepartmentId']>;
  activeOnly: Scalars['Boolean'];
};


export type LeadTrainingScenariosPagination = {
  __typename: 'LeadTrainingScenariosPagination';
  trainingScenarios: Array<LeadTrainingScenario>;
  count: Scalars['Int'];
};

export type LedgerAccount = {
  __typename: 'LedgerAccount';
  id: Scalars['LedgerAccountId'];
  ownerId: Scalars['AnyId'];
  type: LedgerType;
  currencyCode: Scalars['String'];
  balance: MonetaryAmount;
  usableBalance: MonetaryAmount;
  postedBalance: MonetaryAmount;
  pendingEntries: Array<LedgerEntry>;
  postedEntries: LedgerEntryPagination;
  entries: LedgerEntryPagination;
};


export type LedgerAccountPostedBalanceArgs = {
  postedBefore?: Maybe<Scalars['Date']>;
};


export type LedgerAccountPostedEntriesArgs = {
  offset?: Maybe<Scalars['Int']>;
  limit?: Maybe<Scalars['Int']>;
  postedRange?: Maybe<DateRangeInput>;
};


export type LedgerAccountEntriesArgs = {
  offset?: Maybe<Scalars['Int']>;
  limit?: Maybe<Scalars['Int']>;
};


export type LedgerEntry = {
  __typename: 'LedgerEntry';
  id: Scalars['LedgerEntryId'];
  account: LedgerAccount;
  amount: MonetaryAmount;
  credit: Scalars['Boolean'];
  descriptor: Scalars['String'];
  posted: Scalars['Boolean'];
  postedAt?: Maybe<Scalars['Date']>;
  expireAt?: Maybe<Scalars['Date']>;
  authorizedAt: Scalars['Date'];
};


export type LedgerEntryPagination = {
  __typename: 'LedgerEntryPagination';
  entries: Array<LedgerEntry>;
  count: Scalars['Int'];
};

export type LedgerTransaction = {
  __typename: 'LedgerTransaction';
  id: Scalars['LedgerTransactionId'];
  account: LedgerAccount;
  entry?: Maybe<LedgerEntry>;
  actor: Identity;
  details: LedgerTransactionDetails;
  createdAt: Scalars['Date'];
};

export type LedgerTransactionAuthorizeAndPostDetails = LedgerTransactionDetails & {
  __typename: 'LedgerTransactionAuthorizeAndPostDetails';
  type: LedgerTransactionType;
  amount: Scalars['BigDecimal'];
};

export type LedgerTransactionAuthorizeDetails = LedgerTransactionDetails & {
  __typename: 'LedgerTransactionAuthorizeDetails';
  type: LedgerTransactionType;
  amount: Scalars['BigDecimal'];
  expireAt: Scalars['Date'];
};

export type LedgerTransactionCancelAuthorizationDetails = LedgerTransactionDetails & {
  __typename: 'LedgerTransactionCancelAuthorizationDetails';
  type: LedgerTransactionType;
};

export type LedgerTransactionDetails = {
  type: LedgerTransactionType;
};

export type LedgerTransactionExtendAuthorizationDetails = LedgerTransactionDetails & {
  __typename: 'LedgerTransactionExtendAuthorizationDetails';
  type: LedgerTransactionType;
  expireAt: Scalars['Date'];
};


export type LedgerTransactionPostDetails = LedgerTransactionDetails & {
  __typename: 'LedgerTransactionPostDetails';
  type: LedgerTransactionType;
  amount?: Maybe<Scalars['BigDecimal']>;
};

export enum LedgerTransactionType {
  AUTHORIZE = 'AUTHORIZE',
  AUTHORIZE_AND_POST = 'AUTHORIZE_AND_POST',
  CANCEL_AUTHORIZATION = 'CANCEL_AUTHORIZATION',
  EXTEND_AUTHORIZATION = 'EXTEND_AUTHORIZATION',
  POST = 'POST'
}

export enum LedgerType {
  EXPERT_DISCOUNT_CASH = 'EXPERT_DISCOUNT_CASH',
  CONSUMER_STORE_CREDIT = 'CONSUMER_STORE_CREDIT'
}

/** Specifically accepting inches input, rendered as "feet" and "inches" dynamically by the UI */
export type LengthInInchesNumericRenderingStylePathQuestionPathNodeFlowViewModel = {
  __typename: 'LengthInInchesNumericRenderingStylePathQuestionPathNodeFlowViewModel';
  /** Filler property since types can't be empty */
  lengthInInches: Scalars['Boolean'];
};

export type LengthInInchesNumericRenderingStylePathQuestionSchemaUpsertEditorCommandInput = {
  _?: Maybe<Scalars['Boolean']>;
};

export type LineItemClaimTicket = TicketDetail & {
  __typename: 'LineItemClaimTicket';
  type: TicketType;
  consumerId: Scalars['UserId'];
  order: Order;
  orderLineItemId: Scalars['OrderLineItemId'];
  fulfillmentPlan?: Maybe<LineItemFulfillmentPlan>;
};

export type LineItemFulfillmentCost = {
  __typename: 'LineItemFulfillmentCost';
  orderLineItemId: Scalars['OrderLineItemId'];
  cost: MonetaryAmount;
};

export type LineItemFulfillmentCostInput = {
  orderLineItemId: Scalars['OrderLineItemId'];
  cost: MonetaryAmountInput;
  quantity?: Maybe<Scalars['Int']>;
};

export type LineItemFulfillmentPlan = {
  __typename: 'LineItemFulfillmentPlan';
  suggestions: Array<ItemFulfillmentSuggestion>;
  allSuggestionsFailed: Scalars['Boolean'];
  offlinePartners: Array<FulfillmentChannel>;
};

export type LineItemTrackingUpdateTicket = TicketDetail & {
  __typename: 'LineItemTrackingUpdateTicket';
  type: TicketType;
  consumerId: Scalars['UserId'];
  order: Order;
  orderLineItemId: Scalars['OrderLineItemId'];
};

/** ====== ListPathFlowQuestion */
export type ListPathFlowQuestion = PathFlowQuestion & {
  __typename: 'ListPathFlowQuestion';
  internalName: Scalars['String'];
  questionText?: Maybe<TextViewModel>;
  questionSubText?: Maybe<TextViewModel>;
  required: Scalars['Boolean'];
  inputIconImage?: Maybe<ImageViewModel>;
  inputLabel?: Maybe<TextViewModel>;
  attributes: Array<Attribute>;
  attribute?: Maybe<Attribute>;
  choices: Array<ListPathFlowQuestionChoice>;
  /**
   * If present, render an additional "other" selection. Only applicable
   * for MULTI_SELECT_LIST and SINGLE_SELECT_LIST question types
   */
  other?: Maybe<EmbeddedInputTextPathFlowQuestion>;
  type: ListPathFlowQuestionType;
  renderStyle: ListPathFlowQuestionRenderStyle;
  /** If present and `type` supports multiple choices, the maximum amount of choices (inclusive) that's allowed */
  maxChoices?: Maybe<Scalars['Int']>;
  /** If reloading a question answered by the user, this is their previous input */
  listUserInput: SubmitListPathFlowQuestionInputTypeCopy;
};


/** ====== ListPathFlowQuestion */
export type ListPathFlowQuestionAttributeArgs = {
  attributeName?: Maybe<Scalars['String']>;
};

export type ListPathFlowQuestionChoice = {
  __typename: 'ListPathFlowQuestionChoice';
  text?: Maybe<TextViewModel>;
  subText?: Maybe<TextViewModel>;
  /** Internal value to send back to the server if this item is selected */
  value: Scalars['String'];
  /**
   * Primary image associated with the question. Typically a large image that takes the majority of the choice card, used
   * as an alternative to text/subText
   */
  primaryImage?: Maybe<ImageViewModel>;
  /** Icon/sub-image associated with the question. Typically a small image used in conjunction with text/subText */
  iconImage?: Maybe<ImageViewModel>;
};

export enum ListPathFlowQuestionRenderStyle {
  /**
   * The default/stock rendering style that is guaranteed to fit in with the rest of the components, and will have the
   * best support in combining different options that impact rendering. Unless a path with a specific UI treatment is
   * being tested, using DEFAULT is strongly recommended.
   */
  DEFAULT = 'DEFAULT',
  /** If images should be rendered as full width (bleeds into edges of select container) */
  FULL_WIDTH_IMAGES = 'FULL_WIDTH_IMAGES',
  /** If text should be rendered as an overlay of the image in the background */
  OVERLAY_IMAGE = 'OVERLAY_IMAGE',
  /** Use a simpler radio style select that doesn't render the full cards */
  SIMPLE_RADIO = 'SIMPLE_RADIO'
}

export enum ListPathFlowQuestionType {
  SINGLE_SELECT_LIST = 'SINGLE_SELECT_LIST',
  MULTI_SELECT_LIST = 'MULTI_SELECT_LIST',
  DROP_DOWN = 'DROP_DOWN',
  MULTI_SELECT_PILLS = 'MULTI_SELECT_PILLS'
}

export type ListPathQuestionSchema = PathQuestionSchema & {
  __typename: 'ListPathQuestionSchema';
  id: Scalars['PathQuestionSchemaId'];
  schemaType: PathQuestionSchemaType;
  commonFields: PathCommonQuestionSchemaFields;
  attributeSchemaName?: Maybe<Scalars['String']>;
  attributeSchemaRevision?: Maybe<AttributeSchemaRevision>;
  choices: Array<ListPathQuestionSchemaChoice>;
  listQuestionSchemaType?: Maybe<ListPathQuestionSchemaType>;
};

export type ListPathQuestionSchemaAddChoiceEditorCommandInput = {
  id?: Maybe<Scalars['PathQuestionSchemaId']>;
};

export type ListPathQuestionSchemaChoice = {
  __typename: 'ListPathQuestionSchemaChoice';
  id: Scalars['PathListQuestionSchemaChoiceId'];
  text?: Maybe<PathTemplateText>;
  subText?: Maybe<PathTemplateText>;
  attributeValue?: Maybe<PathAttributeValue>;
  primaryImage?: Maybe<MediaFile>;
};

export type ListPathQuestionSchemaPreFillEnumerationAttributeChoicesEditorCommandInput = {
  id?: Maybe<Scalars['PathQuestionSchemaId']>;
};

export type ListPathQuestionSchemaRemoveChoicesEditorCommandInput = {
  id?: Maybe<Scalars['PathQuestionSchemaId']>;
  choiceIds: Array<Scalars['PathListQuestionSchemaChoiceId']>;
};

export type ListPathQuestionSchemaSortChoicesEditorCommandInput = {
  id?: Maybe<Scalars['PathQuestionSchemaId']>;
  choiceIds: Array<Scalars['PathListQuestionSchemaChoiceId']>;
};

export enum ListPathQuestionSchemaType {
  SINGLE_SELECT_LIST = 'SINGLE_SELECT_LIST',
  MULTI_SELECT_LIST = 'MULTI_SELECT_LIST',
  DROP_DOWN = 'DROP_DOWN',
  MULTI_SELECT_PILLS = 'MULTI_SELECT_PILLS'
}

export type ListPathQuestionSchemaUpdateChoiceEditorCommandInput = {
  id?: Maybe<Scalars['PathQuestionSchemaId']>;
  choiceId: Scalars['PathListQuestionSchemaChoiceId'];
  text?: Maybe<Scalars['String']>;
  subText?: Maybe<Scalars['String']>;
  attributeValue?: Maybe<AttributeValueCommandInput>;
  primaryImage?: Maybe<Scalars['MediaId']>;
};

export type ListPathQuestionSchemaUpsertEditorCommandInput = {
  id?: Maybe<Scalars['PathQuestionSchemaId']>;
  attributeSchemaName?: Maybe<Scalars['String']>;
  listQuestionSchemaType?: Maybe<ListPathQuestionSchemaType>;
};

export type ListQuestionChoicePathEditorValidationErrorTarget = PathEditorValidationErrorTarget & {
  __typename: 'ListQuestionChoicePathEditorValidationErrorTarget';
  id: Scalars['String'];
  targetType: PathEditorValidationErrorTargetType;
  listQuestionChoiceId: Scalars['PathListQuestionSchemaChoiceId'];
};

export type ListQuestionChoicePathNodeFlowViewModel = {
  __typename: 'ListQuestionChoicePathNodeFlowViewModel';
  id: Scalars['PathListQuestionSchemaChoiceId'];
  text?: Maybe<PathTextViewModel>;
  subText?: Maybe<PathTextViewModel>;
  primaryImage?: Maybe<MediaFile>;
  selected: Scalars['Boolean'];
};

export type ListQuestionPathNodeFlowInputCommandInput = {
  questionId: Scalars['PathQuestionSchemaId'];
  values: Array<Scalars['PathListQuestionSchemaChoiceId']>;
};

export type ListQuestionPathNodeFlowViewModel = QuestionPathNodeFlowViewModel & {
  __typename: 'ListQuestionPathNodeFlowViewModel';
  id: Scalars['PathQuestionSchemaId'];
  schemaType: PathQuestionSchemaType;
  commonFields: CommonFieldsQuestionPathNodeFlowViewModel;
  choices: Array<ListQuestionChoicePathNodeFlowViewModel>;
  listSchemaType: ListPathQuestionSchemaType;
};



export type LogicalConditionDefinition = ConditionDefinition & {
  __typename: 'LogicalConditionDefinition';
  type: ConditionType;
  conditions: Array<ConditionDefinition>;
  operator: LogicalConditionOperator;
};

export type LogicalConditionDefinitionInput = {
  conditions: Array<ConditionDefinitionInput>;
  operator: LogicalConditionOperator;
};

export enum LogicalConditionOperator {
  AND = 'AND',
  OR = 'OR'
}

export enum LogicalOperator {
  AND = 'AND',
  OR = 'OR'
}

export type LogoutAllSessionsInput = {
  /** If omitted, will log out yourself across all devices/browsers */
  userId?: Maybe<Scalars['UserId']>;
};

export type LogoutAllSessionsPayload = {
  __typename: 'LogoutAllSessionsPayload';
  sessionsLoggedOut: Scalars['Int'];
};

export type LogWorkOnTicketInput = {
  ticketId: Scalars['TicketId'];
  actionType: TicketActionType;
  contactType?: Maybe<ContactType>;
  startedAt?: Maybe<Scalars['Date']>;
  duration?: Maybe<DurationInput>;
  note?: Maybe<Scalars['String']>;
};


export type LongRange = {
  __typename: 'LongRange';
  from?: Maybe<Scalars['Long']>;
  to?: Maybe<Scalars['Long']>;
};

export type LongRangeInput = {
  from?: Maybe<Scalars['Long']>;
  to?: Maybe<Scalars['Long']>;
};

export enum LookupReferralCodeError {
  INVALID_CODE = 'INVALID_CODE'
}

export type LookupReferralCodePayload = {
  __typename: 'LookupReferralCodePayload';
  errorCode?: Maybe<LookupReferralCodeError>;
  referralCode?: Maybe<ReferralCode>;
};

export enum LtvType {
  LEAD = 'LEAD',
  REQUEST = 'REQUEST',
  RESPONSE = 'RESPONSE',
  VIEW_CURATIONS = 'VIEW_CURATIONS'
}

export type MakeExpertCuratedItemDraftsActiveInput = {
  leadId: Scalars['LeadId'];
};

export type MakeExpertCuratedItemDraftsActivePayload = {
  __typename: 'MakeExpertCuratedItemDraftsActivePayload';
  expertCuratedItemsByCategories: ExpertCuratedItemsByCategories;
  addedToCart: Array<ExpertCuratedItem>;
  activated: Array<ExpertCuratedItem>;
  removed: Array<ExpertCuratedItem>;
  errors: Array<Scalars['String']>;
};

export type MalformedSlugCreatePathSchemaRevisionError = ErrorMessage & {
  __typename: 'MalformedSlugCreatePathSchemaRevisionError';
  errorMessage: Scalars['String'];
  slug: Scalars['String'];
};

export type ManualAdjustmentPayLineItemInput = {
  adjustmentType: ManualAdjustmentPayType;
  payAmount?: Maybe<MonetaryAmountInput>;
  reason?: Maybe<Scalars['String']>;
  hours?: Maybe<Scalars['BigDecimal']>;
  hourlyAmount?: Maybe<MonetaryAmountInput>;
};

export enum ManualAdjustmentPayType {
  ONBOARDING_SPECIALIST = 'ONBOARDING_SPECIALIST',
  SHIFT_SPIFF = 'SHIFT_SPIFF',
  COMPETITION = 'COMPETITION',
  TEAM_LEAD = 'TEAM_LEAD',
  UTILITY_PLAYER = 'UTILITY_PLAYER',
  CONTENT = 'CONTENT',
  EXPERT_TASK = 'EXPERT_TASK',
  REFERRAL_BONUS = 'REFERRAL_BONUS',
  MISC = 'MISC'
}

export type MarkConversationReadInput = {
  conversationId: Scalars['ConversationId'];
};

export type MarkConversationReadPayload = {
  __typename: 'MarkConversationReadPayload';
  success: Scalars['Boolean'];
};

export type MarkLeadAsSpamInput = {
  leadId: Scalars['LeadId'];
  spam: Scalars['Boolean'];
};

export type MarkPaymentFailedForOrderInput = {
  orderId: Scalars['OrderId'];
  /** The unique id or token on the external platform that was used for initiating the Payment Authorization process. */
  paymentProcessorPlatformSourceId: Scalars['String'];
  paymentProcessorType: PaymentProcessorType;
  /** Failure reason if any. */
  failureReason?: Maybe<Scalars['String']>;
};

export type MarkPaymentFailedForOrderPayload = {
  __typename: 'MarkPaymentFailedForOrderPayload';
  order: Order;
  hasError: Scalars['Boolean'];
  errorMessage?: Maybe<Scalars['String']>;
};

export type MarkPaymentPreApprovalFailedForOrderInput = {
  orderId: Scalars['OrderId'];
  /** The unique id or token on the external platform that was used for initiating the Payment Authorization process. */
  paymentProcessorPlatformSourceId: Scalars['String'];
  paymentProcessorType: PaymentProcessorType;
  /** Failure reason if any. */
  failureReason?: Maybe<Scalars['String']>;
};

export type MarkPaymentPreApprovalFailedForOrderPayload = {
  __typename: 'MarkPaymentPreApprovalFailedForOrderPayload';
  order: Order;
  hasError: Scalars['Boolean'];
  errorMessage?: Maybe<Scalars['String']>;
};

export type MaskedUserHandle = {
  __typename: 'MaskedUserHandle';
  id: Scalars['AnyId'];
  maskedHandle: Scalars['String'];
  handleType: HandleType;
};

export type MediaFile = {
  __typename: 'MediaFile';
  id: Scalars['MediaId'];
  url: Scalars['String'];
  mimeType: Scalars['String'];
  size: Scalars['Int'];
  persisted: Scalars['Boolean'];
  originalFileName?: Maybe<Scalars['String']>;
};

export type MediaFileWithCaption = {
  __typename: 'MediaFileWithCaption';
  mediaFile: MediaFile;
  caption?: Maybe<Scalars['String']>;
  alternativeText?: Maybe<Scalars['String']>;
};


export type MediaRenderedContent = {
  __typename: 'MediaRenderedContent';
  medias: Array<MediaFile>;
};

export type MediaWithCaptionInput = {
  mediaId: Scalars['MediaId'];
  caption?: Maybe<Scalars['String']>;
  alternativeText?: Maybe<Scalars['String']>;
};

export type Merchant = {
  __typename: 'Merchant';
  id: Scalars['MerchantId'];
  contacts: Array<Contact>;
  name: Scalars['String'];
  address?: Maybe<PostalAddress>;
  latitude?: Maybe<Scalars['Float']>;
  longitude?: Maybe<Scalars['Float']>;
  reviewRating?: Maybe<Scalars['Int']>;
  googlePlaceId?: Maybe<Scalars['String']>;
  logo?: Maybe<MediaFile>;
  website?: Maybe<Scalars['String']>;
  adHoc: Scalars['Boolean'];
  brands: Array<Brand>;
  categories: Array<Category>;
  onboarded: Scalars['Boolean'];
  shippingAvailable?: Maybe<Scalars['Boolean']>;
  priceRating?: Maybe<Scalars['Int']>;
  responseTimeInMinutes?: Maybe<Scalars['Int']>;
  responseRate?: Maybe<Scalars['Float']>;
  offerAcceptRate?: Maybe<Scalars['Float']>;
  businessAccount?: Maybe<BusinessAccount>;
  fulfillmentChannel?: Maybe<FulfillmentChannel>;
  shippingNotificationsEmail?: Maybe<Scalars['String']>;
  /**
   * Indicate whether this merchant corresponds to an internal deal merchant or refers to a placeholder indicating us.
   * For example, Curated UPS for fulfillment from our UPS 3PL facility.
   */
  internal: Scalars['Boolean'];
  state: MerchantState;
  estimatedMarginPercent?: Maybe<Scalars['Int']>;
  defaultCurrency: Scalars['String'];
};

export type MerchantClaimedActivity = OrderActivityDetail & {
  __typename: 'MerchantClaimedActivity';
  type: OrderActivityDetailType;
  merchant: Merchant;
  quote?: Maybe<MonetaryAmount>;
  merchantOrderId?: Maybe<Scalars['String']>;
  claimedBy: Operator;
  tax?: Maybe<MonetaryAmount>;
  shippingCost?: Maybe<MonetaryAmount>;
};


export type MerchantQueryInput = {
  namePrefix: Scalars['String'];
  state?: Maybe<MerchantState>;
};

export type MerchantRefundTicket = TicketDetail & {
  __typename: 'MerchantRefundTicket';
  type: TicketType;
  order: Order;
  orderRefund: OrderRefund;
};

export type MerchantRefundUpdatedActivity = OrderActivityDetail & {
  __typename: 'MerchantRefundUpdatedActivity';
  type: OrderActivityDetailType;
  amountRefunded: MonetaryAmount;
  orderRefund: OrderRefund;
  updatedByOperator?: Maybe<Operator>;
};

export enum MerchantSortField {
  NAME = 'NAME'
}

export type MerchantsPagination = {
  __typename: 'MerchantsPagination';
  merchants: Array<Merchant>;
  count: Scalars['Long'];
};

export enum MerchantState {
  ACTIVE = 'ACTIVE',
  DEACTIVATED = 'DEACTIVATED'
}

export type MerchantSuggestionResult = {
  __typename: 'MerchantSuggestionResult';
  merchants: Array<Merchant>;
};

export type MerchantUploadTaskPayload = {
  __typename: 'MerchantUploadTaskPayload';
  numRowsProcessed: Scalars['Int'];
  numMerchantsCreated: Scalars['Int'];
  numMerchantsUpdated: Scalars['Int'];
  numRowsIgnored: Scalars['Int'];
  geocodingErrorCount: Scalars['Int'];
  numDuplicateRows: Scalars['Int'];
  googleSpreadsheetId: Scalars['String'];
};

export type MergeStandardizedSellableGroupInput = {
  mergeFrom: Scalars['StandardizedSellableGroupId'];
  mergeInto: Scalars['StandardizedSellableGroupId'];
};

export type MergeStandardizedSellableGroupPayload = {
  __typename: 'MergeStandardizedSellableGroupPayload';
  mergedGroup: StandardizedSellableGroup;
};

export type MergeTicketInput = {
  mergedTicketIds: Array<Scalars['TicketId']>;
  masterTicketId: Scalars['TicketId'];
  mergeReason: Scalars['String'];
};

export type MergeTriggerWaitEdgesInput = {
  triggerId: Scalars['TriggerId'];
  nodeId: Scalars['TriggerNodeId'];
  edgeTypeToKeep: TriggerNodeEdgeType;
};

export type Message = {
  __typename: 'Message';
  id: Scalars['String'];
  sentAt: Scalars['Date'];
  sender: MessagingUser;
  body: MessageBody;
};

export type MessageBody = {
  __typename: 'MessageBody';
  summary: MessageSummary;
};

export enum MessageBodyType {
  TEXT = 'TEXT',
  FILE = 'FILE',
  AUDIO = 'AUDIO',
  VIDEO = 'VIDEO',
  IMAGE = 'IMAGE',
  MULTI_MEDIA = 'MULTI_MEDIA',
  OFFER = 'OFFER',
  DEAL = 'DEAL',
  VIDEO_CHAT_REQUESTED = 'VIDEO_CHAT_REQUESTED',
  VIDEO_CHAT_DECLINED = 'VIDEO_CHAT_DECLINED',
  OTHER = 'OTHER'
}


export type MessageRichCard = {
  type: MessageRichCardType;
};

export type MessageRichCardDataModel = {
  __typename: 'MessageRichCardDataModel';
  type: MessageRichCardType;
  parameters: Array<TemplateNamedParameter>;
};

export type MessageRichCardDataModelInput = {
  type: MessageRichCardType;
  parameters: Array<TemplateNamedParameterInput>;
};

export type MessageRichCardMeta = {
  __typename: 'MessageRichCardMeta';
  type: MessageRichCardType;
  parameters: Array<TriggerParameterMeta>;
};

export enum MessageRichCardType {
  ONBOARDING_REQUEST_CONFIRMATION = 'ONBOARDING_REQUEST_CONFIRMATION',
  ONBOARDING_HOW_CURATED_WORKS = 'ONBOARDING_HOW_CURATED_WORKS',
  ONBOARDING_EXPERT_JOINED = 'ONBOARDING_EXPERT_JOINED',
  NEW_CUSTOM_CURATED_ORDER = 'NEW_CUSTOM_CURATED_ORDER',
  NEW_BOOKABLE_CURATED_ORDER = 'NEW_BOOKABLE_CURATED_ORDER',
  NEW_EXPERT_CURATED_ORDER_LIST = 'NEW_EXPERT_CURATED_ORDER_LIST',
  CONSUMER_INTERESTED_IN_CURATED_ORDER = 'CONSUMER_INTERESTED_IN_CURATED_ORDER',
  NEW_EXPERT_CURATED_ITEMS = 'NEW_EXPERT_CURATED_ITEMS',
  NEW_SYSTEM_CURATED_ITEMS = 'NEW_SYSTEM_CURATED_ITEMS',
  UPDATED_EXPERT_CURATED_ITEMS = 'UPDATED_EXPERT_CURATED_ITEMS',
  FEEDBACK_REQUEST_FROM_EXPERT = 'FEEDBACK_REQUEST_FROM_EXPERT',
  REFERRAL_REQUEST_FROM_EXPERT = 'REFERRAL_REQUEST_FROM_EXPERT',
  SYSTEM_CURATED_ITEM_SURVEY = 'SYSTEM_CURATED_ITEM_SURVEY',
  SIMPLE_CURATED_ORDER = 'SIMPLE_CURATED_ORDER',
  CONTACT_COLLECTION_REQUEST = 'CONTACT_COLLECTION_REQUEST',
  GUEST_CHAT_CREATE_REQUEST = 'GUEST_CHAT_CREATE_REQUEST',
  PAYMENT_VERIFICATION_REQUEST = 'PAYMENT_VERIFICATION_REQUEST',
  EXPERT_AWAY_AUTO_REPLY = 'EXPERT_AWAY_AUTO_REPLY',
  SELLABLE_REQUESTED = 'SELLABLE_REQUESTED',
  SELLABLE_PRICE_MATCH_REQUESTED = 'SELLABLE_PRICE_MATCH_REQUESTED',
  CONVERSATION_STARTER_SENT = 'CONVERSATION_STARTER_SENT'
}

export type MessageSummary = {
  __typename: 'MessageSummary';
  text?: Maybe<Scalars['String']>;
  type: MessageBodyType;
};

export enum MessageUnsubscribeTag {
  CURATION = 'CURATION',
  ONBOARDING = 'ONBOARDING',
  MESSAGE_NOTIFICATION = 'MESSAGE_NOTIFICATION',
  POST_PURCHASE = 'POST_PURCHASE',
  ABANDONED_ORDER = 'ABANDONED_ORDER',
  PATH_ONBOARDING = 'PATH_ONBOARDING',
  REFERRAL = 'REFERRAL',
  LEAD_CAMPAIGN = 'LEAD_CAMPAIGN'
}

export enum MessagingChannelType {
  SMS = 'SMS',
  EMAIL = 'EMAIL',
  FACEBOOK = 'FACEBOOK',
  PUSH_NOTIFICATION = 'PUSH_NOTIFICATION'
}

export type MessagingUser = {
  __typename: 'MessagingUser';
  id: Scalars['AnyId'];
  externalId?: Maybe<Scalars['String']>;
  displayName: Scalars['String'];
  /** @deprecated use `type` field */
  internalMessagingUser: Scalars['Boolean'];
  avatar?: Maybe<MediaFile>;
  profile: MessagingUserProfile;
  type: MessagingUserType;
};

export type MessagingUserProfile = User | Merchant | Operator | BusinessUser | InternalMessagingUser | OnboardingSpecialistUser | SupportMessagingUser;

export enum MessagingUserType {
  USER = 'USER',
  MERCHANT = 'MERCHANT',
  BUSINESS_USER = 'BUSINESS_USER',
  OPERATOR = 'OPERATOR',
  DEAL_BOT = 'DEAL_BOT',
  ONBOARDING_SPECIALIST = 'ONBOARDING_SPECIALIST',
  SUPPORT = 'SUPPORT'
}

export type MissingAttributeProductCatalogGroupPublishError = ErrorMessage & {
  __typename: 'MissingAttributeProductCatalogGroupPublishError';
  errorMessage: Scalars['String'];
  revisions: Array<MissingAttributeProductCatalogGroupRevision>;
};

export type MissingAttributeProductCatalogGroupRevision = {
  __typename: 'MissingAttributeProductCatalogGroupRevision';
  revision: ProductCatalogGroupRevision;
  missingAttributes: Array<AttributeSchemaRevision>;
};

export type MissingAttributeProductCatalogGroupUpdateError = ErrorMessage & {
  __typename: 'MissingAttributeProductCatalogGroupUpdateError';
  errorMessage: Scalars['String'];
  missingAttributeSchemas: Array<AttributeSchemaRevision>;
};

export type MissingAttributeProductCatalogPublishError = ErrorMessage & {
  __typename: 'MissingAttributeProductCatalogPublishError';
  errorMessage: Scalars['String'];
  revisions: Array<MissingAttributeProductCatalogRevision>;
};

export type MissingAttributeProductCatalogRevision = {
  __typename: 'MissingAttributeProductCatalogRevision';
  revision: ProductCatalogRevision;
  missingAttributes: Array<AttributeSchemaRevisionOrAttributeName>;
};

export type MissingAttributeProductCatalogUpdateError = ErrorMessage & {
  __typename: 'MissingAttributeProductCatalogUpdateError';
  errorMessage: Scalars['String'];
  missingAttributeSchemas: Array<AttributeSchemaRevision>;
};

export type MissingItemTicket = TicketDetail & {
  __typename: 'MissingItemTicket';
  type: TicketType;
  consumer: User;
  order: Order;
  orderLineItemIds: Array<Scalars['OrderLineItemId']>;
};

export type MissingRawAttributeProductCatalogGroupUpdateError = ErrorMessage & {
  __typename: 'MissingRawAttributeProductCatalogGroupUpdateError';
  errorMessage: Scalars['String'];
  missingAttributeNames: Array<Scalars['String']>;
};

export type MissingRawAttributeProductCatalogUpdateError = ErrorMessage & {
  __typename: 'MissingRawAttributeProductCatalogUpdateError';
  errorMessage: Scalars['String'];
  missingAttributeNames: Array<Scalars['String']>;
};

export type MissingSpecsTicket = TicketDetail & {
  __typename: 'MissingSpecsTicket';
  type: TicketType;
  consumer: User;
  order: Order;
  orderLineItemIds: Array<Scalars['OrderLineItemId']>;
};

export type MonetaryAmount = {
  __typename: 'MonetaryAmount';
  amount: Scalars['BigDecimal'];
  currency: Scalars['CurrencyUnit'];
};


export type MonetaryAmountAmountArgs = {
  denominationType?: Maybe<MonetaryAmountDenominationType>;
};

export enum MonetaryAmountDenominationType {
  /** Return amount in the default denomination (e.g.: dollars and cents, e.g.: "12.34" for $12.34 */
  DEFAULT = 'DEFAULT',
  /** Return amount in the smallest denomination for the given currency (e.g.: "1234" for $12.34) */
  SMALLEST = 'SMALLEST'
}

export type MonetaryAmountInput = {
  amount: Scalars['BigDecimal'];
  currency: Scalars['String'];
};

export type MonetaryAmountRangeInput = {
  lower?: Maybe<Scalars['BigDecimal']>;
  upper?: Maybe<Scalars['BigDecimal']>;
  currency: Scalars['CurrencyUnit'];
};

export type MonetaryAmountWithTax = {
  __typename: 'MonetaryAmountWithTax';
  /** The amount without tax */
  price: MonetaryAmount;
  /** The amount with tax added in */
  priceWithTax: MonetaryAmount;
  /** The amount of tax added */
  tax: MonetaryAmount;
  /** If tax is added (non-zero tax) */
  isTaxed: Scalars['Boolean'];
};

export type Money = {
  __typename: 'Money';
  amount: Scalars['Float'];
  currency: Scalars['String'];
};

export type MonitorVideoChatInput = {
  externalConversationId: Scalars['String'];
};

export type MonitorVideoChatPayload = {
  __typename: 'MonitorVideoChatPayload';
  token: Scalars['String'];
};

export type MoveArticleRevisionContentBlockInput = {
  id: Scalars['ArticleRevisionId'];
  contentBlockId: Scalars['ArticleContentBlockId'];
  /** Move the block before this block. If this is empty, it moves to be the last block */
  moveBeforeContentBlockId?: Maybe<Scalars['ArticleContentBlockId']>;
};

export type MultiChannelFulfillmentRequestInput = {
  ticketId: Scalars['TicketId'];
  merchantId: Scalars['MerchantId'];
  quantity?: Maybe<Scalars['Int']>;
  fulfillmentCenterId?: Maybe<Scalars['FulfillmentCenterId']>;
  fulfillmentShipmentMethodId?: Maybe<Scalars['FulfillmentShipmentMethodId']>;
  fulfillmentChannelId: Scalars['FulfillmentChannelId'];
  merchantQuote?: Maybe<MonetaryAmountInput>;
  merchantOrderId?: Maybe<Scalars['String']>;
  merchantEta?: Maybe<Scalars['Date']>;
  merchantMaxEta?: Maybe<Scalars['Date']>;
  merchantTax?: Maybe<MonetaryAmountInput>;
  merchantShippingCost?: Maybe<MonetaryAmountInput>;
  lineItemIds?: Maybe<Array<Scalars['OrderLineItemId']>>;
  lineItemFulfillmentCosts?: Maybe<Array<LineItemFulfillmentCostInput>>;
};

export type MultiLocaleTemplateSet = {
  __typename: 'MultiLocaleTemplateSet';
  id: Scalars['CommTemplateId'];
  title: Scalars['String'];
  active: Scalars['Boolean'];
  state: RevisionState;
  historyId: Scalars['CommTemplateVersionHistoryId'];
  versionNumber: Scalars['Int'];
  singleLocaleSets: Array<SingleLocaleTemplateSet>;
  category?: Maybe<Category>;
  createdAt: Scalars['Date'];
  updatedAt: Scalars['Date'];
  publishedAt?: Maybe<Scalars['Date']>;
  experimentKey?: Maybe<Scalars['String']>;
  categoryType?: Maybe<CategoryType>;
  treatments?: Maybe<Array<Scalars['String']>>;
  templateType: CommTemplateType;
  tagSyntax: TemplateTagSyntax;
  emailFromAddress?: Maybe<Scalars['String']>;
  allowedEmailFromAddresses: Array<Scalars['String']>;
  pendingDraft?: Maybe<MultiLocaleTemplateSet>;
  changes: Array<RevisionChange>;
  lastChangedBy?: Maybe<Operator>;
};

export type Mutation = {
  __typename: 'Mutation';
  addAddress: AddAddresssPayload;
  updateAddressPreferences: UpdateAddressPreferencesPayload;
  deleteAddress: DeleteAddressPayload;
  prepareApprovalRequestSubmitDraft: PrepareApprovalRequestSubmitDraftPayload;
  updateApprovalRequestSubmitDraft: UpdateApprovalRequestSubmitDraftPayload;
  submitForReviewInApprovalRequest: SubmitForReviewInApprovalRequestPayload;
  commentOnApprovalRequest: CommentOnApprovalRequestPayload;
  approveApprovalRequest: ApproveApprovalRequestPayload;
  rejectApprovalRequest: RejectApprovalRequestPayload;
  publishApprovalRequest: PublishApprovalRequestPayload;
  closeApprovalRequest: CloseApprovalRequestPayload;
  createAttributeSchemaRevision: CreateAttributeSchemaRevisionPayload;
  copyAttributeSchemaRevisionAsNewVersion: CopyAttributeSchemaRevisionAsNewVersionPayload;
  publishAttributeSchemaRevision: PublishAttributeSchemaRevisionPayload;
  deleteDraftAttributeSchemaRevision: DeleteDraftAttributeSchemaRevisionPayload;
  deprecateAttributeSchemaRevision: DeprecateAttributeSchemaRevisionPayload;
  updateAttributeSchemaRevision: UpdateAttributeSchemaRevisionPayload;
  upsertEnumEntriesIntoAttributeSchemaRevision: UpsertEnumEntriesIntoAttributeSchemaRevisionPayload;
  reorderEnumEntriesInAttributeSchemaRevision: ReorderEnumEntriesInAttributeSchemaRevisionPayload;
  removeDraftEnumEntriesFromAttributeSchemaRevision: RemoveDraftEnumEntriesFromAttributeSchemaRevisionPayload;
  upsertMetadataIntoAttributeSchemaRevision: UpsertMetadataIntoAttributeSchemaRevisionPayload;
  removeMetadataFromAttributeSchemaRevision: RemoveMetadataFromAttributeSchemaRevisionPayload;
  upsertValidatorIntoAttributeSchemaRevision: UpsertValidatorIntoAttributeSchemaRevisionPayload;
  removeValidatorFromAttributeSchemaRevision: RemoveValidatorFromAttributeSchemaRevisionPayload;
  initiateAuthentication: InitiateAuthenticationPayload;
  initiateResetPassword: InitiateResetPasswordPayload;
  initiateVerifyHandle: InitiateVerifyHandlePayload;
  authenticate: AuthenticationResultPayload;
  authenticateByExternalOAuthToken: AuthenticateByExternalOAuthTokenPayload;
  logout: Scalars['Boolean'];
  logoutAllSessions: LogoutAllSessionsPayload;
  createPassword: CreatePasswordPayload;
  resetPassword: ResetPasswordPayload;
  changePassword: ChangePasswordPayload;
  verifyResetPasswordChallenge: VerifyResetPasswordChallengePayload;
  verifyHandleChallenge: VerifyHandleChallengePayload;
  refreshAccessToken: RefreshAccessTokenPayload;
  createCommTemplate: CreateTemplatePayload;
  updateCommTemplate: UpdateTemplatePayload;
  copyCommTemplate: CreateTemplatePayload;
  publishCommTemplate: UpdateTemplatePayload;
  deactivateCommTemplate: UpdateTemplatePayload;
  newCommTemplateVersion: CreateTemplatePayload;
  updateChannelTemplate: UpdateTemplatePayload;
  removeChannelTemplate: UpdateTemplatePayload;
  addChannelTemplate: UpdateTemplatePayload;
  sendTemplateTestMessage: SendTemplateTestMessagePayload;
  createCommTemplateType: CreateTemplateTypePayload;
  copyCommTemplateType: CopyTemplateTypePayload;
  updateCommTemplateType: UpdateTemplateTypePayload;
  createCommTemplateFragment: CreateTemplateFragmentPayload;
  updateCommTemplateFragment: UpdateTemplateFragmentPayload;
  copyCommTemplateFragment: CopyTemplateFragmentPayload;
  publishCommTemplateFragment: UpdateTemplateFragmentPayload;
  deactivateCommTemplateFragment: UpdateTemplateFragmentPayload;
  newCommTemplateFragmentVersion: CreateTemplateFragmentPayload;
  generateTemplateFragmentSnippet: GenerateTemplateFragmentSnippetPayload;
  generateTemplateDirectiveSnippet: GenerateTemplateDirectiveSnippetPayload;
  createDealRequest: CreateDealRequestPayload;
  createUser: CreateUserPayload;
  createOperators: CreateOperatorsPayload;
  updateOperator: UpdateOperatorPayload;
  updateUserProfile: UpdateUserProfilePayload;
  createMerchant: CreateMerchantPayload;
  createMerchants: CreateMerchantsPayload;
  updateMerchant: UpdateMerchantPayload;
  registerCustomer: RegisterCustomerPayload;
  createPendingAccessContact: CreatePendingAccessContactPayload;
  verifyPendingAccessContact: VerifyPendingAccessContactPayload;
  assumeOperatorIdentity: AssumeOperatorIdentityPayload;
  releaseOperatorIdentity: ReleaseOperatorIdentityPayload;
  assumeConsumerIdentity: AssumeConsumerIdentityPayload;
  releaseConsumerIdentity: ReleaseConsumerIdentityPayload;
  generateMyLoginToken?: Maybe<Scalars['String']>;
  updateUserSource: UpdateUserSourcePayload;
  startSmsPromotionRegistration: StartSmsPromotionRegistrationPayload;
  createSmsRegistrationPromotion: ClaimPromotionPayload;
  operatorStartShift: OperatorShiftUpdatePayload;
  operatorEndShift: OperatorShiftUpdatePayload;
  createBusinessUser: CreateBusinessUserPayload;
  updateBusinessUser: UpdateBusinessUserPayload;
  updateExpertLeadGate: UpdateBusinessUserPayload;
  recomputeNewExpertLeadGate: UpdateBusinessUserPayload;
  updateBusinessUserVanityId: UpdateBusinessUserPayload;
  assumeBusinessUserIdentity: AssumeBusinessUserIdentityPayload;
  releaseBusinessUserIdentity: ReleaseBusinessUserIdentityPayload;
  setAcceptingNewRequests: ExpertPresenceStatusUpdateResponse;
  setExpertOnCall: ExpertPresenceStatusUpdateResponse;
  startOnCallShift: ExpertPresenceStatusUpdateResponse;
  startExpertShift: ExpertPresenceStatusUpdateResponse;
  startExpertStandby: ExpertPresenceStatusUpdateResponse;
  setExpertOffShift: SetExpertOffShiftPayload;
  setExpertAwayAutoReply: SetExpertAwayAutoReplyPayload;
  createBusinessAccount: CreateBusinessAccountPayload;
  createBusinessUserTeam: CreateBusinessUserTeamPayload;
  updateBusinessUserTeam: UpdateBusinessUserTeamPayload;
  deactivateExpert: DeactivateExpertPayload;
  activateExpert: ActivateExpertPayload;
  setExpertTeamLead: SetExpertTeamLeadPayload;
  overrideExpertPerformanceRating: UpdateBusinessUserPayload;
  devTools?: Maybe<DevToolsMutation>;
  createFirebaseToken: CreateFirebaseTokenPayload;
  registerFirebaseCloudMessagingToken: RegisterFirebaseCloudMessagingTokenPayload;
  registerWebPushSubscription: RegisterWebPushSubscriptionPayload;
  unregisterWebPushSubscription: UnregisterWebPushSubscriptionPayload;
  unregisterFirebaseCloudMessagingToken: UnregisterFirebaseCloudMessagingTokenPayload;
  joinVideoChat: JoinVideoChatPayload;
  declineVideoChat: DeclineVideoChatPayload;
  monitorVideoChat: MonitorVideoChatPayload;
  bridgePhoneCall: BridgePhoneCallPayload;
  bridgeLeadPhoneCall: BridgePhoneCallPayload;
  bridgeExpertApplicationPhoneCall: BridgePhoneCallPayload;
  createVoiceToken: CreateVoiceTokenPayload;
  markConversationRead: MarkConversationReadPayload;
  generateCollectPhoneNumberTextInPath: GenerateCollectPhoneNumberTextInPathPayload;
  addBlacklistChannelAddress: AddBlacklistChannelAddressPayload;
  createDraftGuestConversationSequence: CreateDraftGuestConversationSequencePayload;
  addGuestConversationSequenceMessage: AddGuestConversationSequenceMessagePayload;
  updateGuestConversationSequence: UpdateGuestConversationSequencePayload;
  activateGuestConversationSequence: ActivateGuestConversationSequencePayload;
  deactivateGuestConversationSequence: DeactivateGuestConversationSequencePayload;
  startGuestConversation: StartGuestConversationPayload;
  pickUpCall: PickUpCallPayload;
  sendTestPushNotification: Scalars['Boolean'];
  createPathFlow: CreatePathFlowPayload;
  submitPathFlowPage: SubmitPathFlowPagePayload;
  reenterPathFlowPage: ReenterPathFlowPagePayload;
  /** @deprecated Use reenterPathFlowPage(input: ReenterPathFlowPageInput!) */
  reenterPathFlowPageBySlugs: ReenterPathFlowPagePayload;
  submitListPathFlowQuestion: SubmitListPathFlowQuestionPayload;
  submitUserContactPathFlowQuestion: SubmitUserContactPathFlowQuestionPayload;
  submitNumericPathFlowQuestion: SubmitNumericPathFlowQuestionPayload;
  submitOAuthEmailPathFlowQuestion: SubmitOAuthEmailPathFlowQuestionPayload;
  submitInputTextPathFlowQuestion: SubmitInputTextPathFlowQuestionPayload;
  submitIdPathFlowQuestion: SubmitIdPathFlowQuestionPayload;
  submitDatePathFlowQuestion: SubmitDatePathFlowQuestionPayload;
  submitDateRangePathFlowQuestion: SubmitDateRangePathFlowQuestionPayload;
  createPathSchemaRevision: CreatePathSchemaRevisionPayload;
  createPathSchemaFragmentRevision: CreatePathSchemaRevisionPayload;
  copyPathSchemaRevisionAsNewRevision: CreatePathSchemaRevisionPayload;
  copyPathSchemaFragmentRevisionAsNewRevision: CreatePathSchemaRevisionPayload;
  executePathEditorNodeConfigCommand: ExecutePathEditorNodeConfigCommandPayload;
  executePathEditorUndo: ExecutePathEditorUndoPayload;
  executePathEditorRedo: ExecutePathEditorRedoPayload;
  executePathEditorSetEdge: ExecutePathEditorSetEdgePayload;
  executePathEditorRemoveEdge: ExecutePathEditorRemoveEdgePayload;
  executePathEditorMoveNode: ExecutePathEditorMoveNodePayload;
  executePathEditorRemoveNode: ExecutePathEditorRemoveNodePayload;
  togglePathEditorNodeExpansion: TogglePathEditorNodeExpansionPayload;
  /** Flow APIs */
  createPathGraphFlow: CreatePathGraphFlowPayload;
  visitPathGraphFlow: VisitPathGraphFlowPayload;
  submitPathNodeFlowInputCommands: SubmitPathNodeFlowInputCommandsPayload;
  placeOrderForOffer: PlaceOrderForOfferPayload;
  initiatePaypalPaymentForOffer: InitiatePaypalPaymentForOfferPayload;
  /** Order fulfillment related mutations */
  addOperatorNote: UpdateOrderPayload;
  addShipmentTracking: UpdateOrderPayload;
  assignFulfillmentOperator: UpdateOrderPayload;
  claimOrderLineItem: ClaimOrderLineItemPayload;
  orderLineItemUnavailable: UpdateOrderPayload;
  orderLineItemReceived: OrderLineItemReceivedPayload;
  removeShipmentTracking: UpdateOrderPayload;
  removeReturnShipmentTracking: UpdateOrderPayload;
  updateShippingMethod: UpdateShippingMethodPayload;
  updateOrderShippingAddress: UpdateOrderShippingAddressPayload;
  updatePreClaimedOrderShippingAddress: UpdateOrderShippingAddressPayload;
  createPaymentSource: CreatePaymentSourcePayload;
  setupPaymentSource: SetupPaymentSourcePayload;
  updatePaymentSource: UpdatePaymentSourcePayload;
  deletePaymentSource: DeletePaymentSourcePayload;
  payForOrder: PayForOrderPayload;
  addTipToOrder: AddTipToOrderPayload;
  updateGiftCardOrderLineItem: UpdateGiftCardOrderLineItemPayload;
  removeTipFromOrder: RemoveTipFromOrderPayload;
  submitOrder: SubmitOrderPayload;
  cancelSubmittedOrder: CancelSubmittedOrderPayload;
  initiatePaypalPaymentForOrder: InitiatePaypalPaymentForOrderPayload;
  /**
   * The Afterpay payment process starts by generating a unique order token for the Order. This is done on the backend
   * that also sets up the AfterpayPaymentProcessorAccount for the user if it
   * doesn't exist and registers the PaymentRedirectUrls
   * with Afterpay
   * On successful creation, the user is redirected to Afterpay with the orderToken
   * received in response passed as a parameter to Afterpay
   * The user goes through the loan/payment plan process on Afterpay and may be approved or declined.
   * If the user is approved, then the payment should be captured and the process is completed using the payForOrder api,
   * with the paymentProcessorPlatformSourceId set as the orderToken here.
   * If the users is declined or the process fails for any reason, then call the markPaymentDeclinedForOrder to capture
   * this state in the backend
   */
  initiateAfterpayPaymentForOrder: InitiateAfterpayPaymentForOrderPayload;
  /**
   * The Affirm payment process starts by the frontend passing a JSON checkout object to Affirm. This is done on the
   * backend which generates the checkout JSON object from the Order and the given PaymentRedirectUrls. The JSON object is
   * passed back to frontend as a JSON string. Once the frontend calls Affirm Javascript SDK to open the modal and the user
   * gets approved, a checkout_token is received. The checkout_token is used to
   * authorize and capture the payment via payForOrder api.
   * The paymentProcessorPlatformSourceId is the checkout_token.
   */
  initiateAffirmPaymentForOrder: InitiateAffirmPaymentForOrderPayload;
  /**
   * Some payment processors return the authorization response of a succes, approval, failure via means of redirection
   * to our website with additonal params. These processors may not support async webhook events so use this api to
   * notify the backend of any such changes.
   * This is a best effort approach as we run the risk of a user closing the browser before such a the request
   * was initiated. Fortunately, the order/payment doesn't go through.
   */
  markPaymentPreApprovalFailedForOrder: MarkPaymentPreApprovalFailedForOrderPayload;
  /** Deprecate */
  markPaymentFailedForOrder: MarkPaymentFailedForOrderPayload;
  /**
   * For payments that go through the multiple steps with the initiatePayment APIs, its possible that the user might
   * abandon a payment flow mid way. Most of the processors will return and redirect the consumer back to our
   * site with canceled state.
   * The frontend should use this api to inform the server of this canceled state. This is necessary to put the order
   * in the correct state to allow use of other payment methods.
   */
  cancelPaymentRequestForOrder: CancelPaymentRequestForOrderPayload;
  syncOrder: SyncOrderPayload;
  addItemsToOrder: AddItemsToOrderPayload;
  removeItemsFromOrder: RemoveItemsFromOrderPayload;
  updateQuantityForOrder: UpdateQuantityForOrderPayload;
  addPromotionToOrder: AddPromotionToOrderPayload;
  applyStoreCreditToOrder: ApplyStoreCreditToOrderPayload;
  removeStoreCreditFromOrder: RemoveStoreCreditFromOrderPayload;
  dismissOrderMessages: DismissOrderMessagesPayload;
  /**
   * Expert API to retrieve the user's cart, or create it if it doesn't exist.
   * This API should **never** be invoked when trying to fetch the current user's cart; prefer `syncOrder`.
   * This is primarily for experts to fetch a user's cart (or create if it doesn't exist). This is useful for the expert
   * to view the cart of a user, and eventually add items to the user's cart through `addExpertCuratedItemsToCart`
   */
  getOrCreateUserCartForExpert: GetOrCreateUserCartForExpertPayload;
  /**
   * Create a new promotion in draft state. After customizing the promotion, use `activatePromotion` to shift it to
   * ACTIVE state so it's available for consumers to use.
   */
  createPromotion: CreateDraftPromotionPayload;
  /**
   * Activate a promotion in `DRAFT` state. Note that if there is an existing active promotion with the
   * same promotion code, this API will automatically disable that promotion. Use the `activePromotionByCode` query
   * to discover existing active promotions and prompt the user if one exists before creating this one.
   */
  activatePromotion: ActivatePromotionPayload;
  /**
   * Disable an existing promotion. Users that just added this item to their cart before disabling will still have a
   * short grace period (1 hour) to use the promotion to minimize the chance of disrupting their checkout flow.
   */
  disablePromotion: DisablePromotionPayload;
  /**
   * Create a new promotion in `DRAFT` state which will be a copy of the promotion referenced by the input id. Some
   * state will be reset, for example, if the expiration date is in the past, it'll be removed. usageCount will be
   * reset as well.
   */
  copyPromotion: CopyPromotionPayload;
  /**
   * Conditionally update fields of a promotion in `DRAFT` state. This includes everything except for `rules` and
   * `actions`, which are taken care of by the targeted APIs like `upsertRuleIntoPromotion`, `removeRuleFromPromotion`,
   * and `reorderRulesInPromotion`
   */
  updatePromotion: UpdatePromotionPayload;
  /**
   * Add a rule to a promotion in `DRAFT` state, or if an existing `PromotionRuleReferenceId` is referenced, replace the
   * contents of that rule with the incoming payload.
   */
  upsertRuleIntoPromotion: UpsertRuleIntoPromotionPayload;
  /** Remove a rule from a promotion in `DRAFT` state. */
  removeRuleFromPromotion: RemoveRuleFromPromotionPayload;
  /**
   * Re-order the rules for a promotion in `DRAFT` state. It's assumed all rule expectedReference ids in the promotion are
   * present in this list, potentially re-ordered.
   */
  reorderRulesInPromotion: ReorderRulesInPromotionPayload;
  /**
   * Add a action to a promotion in `DRAFT` state, or if an existing `PromotionActionReferenceId` is referenced, replace
   * the contents of that action with the incoming payload.
   */
  upsertActionIntoPromotion: UpsertActionIntoPromotionPayload;
  /** Remove a action from a promotion in `DRAFT` state. */
  removeActionFromPromotion: RemoveActionFromPromotionPayload;
  /**
   * Re-order the actions for a promotion in `DRAFT` state. It's assumed all action expectedReference ids in the promotion are
   * present in this list, potentially re-ordered.
   */
  reorderActionsInPromotion: ReorderActionsInPromotionPayload;
  /**
   * The ACH/wire transfer payment process starts by assigning a unique bank account for the user. This bank account
   * is reused across multiple orders. This is done on the backend by calling Stripe API to create the ACH credit transfer
   * payment source. This source is associated with the StripeAccount for that user.
   */
  initiateWireTransferPaymentForOrder: InitiateWireTransferPaymentForOrderPayload;
  updateOrderState: UpdateOrderStatePayload;
  updateOrderExpertContributions: UpdateOrderExpertContributionsPayload;
  /** unclaim an order line item and puts it back into READY_TO_CLAIM state */
  unclaimOrderLineItem: UpdateOrderPayload;
  /**
   * Initiates the fulfillment process from our own inventory.
   * Note, this request starts the fulfillment process and remains in pending state for some amount of time to
   * allow for handling cancellations or updates on our side.
   * In addition, this request may fail due to us not having inventory during the time of order. As such, this request
   * doesn't guarantee fulfillment
   */
  initiateDealInventoryFulfillment: InitiateDealInventoryFulfillmentPayload;
  requestItemReturn: UpdateOrderPayload;
  syncItemShippingStatus: UpdateOrderPayload;
  verifyPaymentTransaction: VerifyPaymentTransactionPayload;
  updateShippingOptions: UpdateOrderPayload;
  createTag: CreateTagPayload;
  removeTag: RemoveTagPayload;
  uploadMerchants: UploadMerchantsPayload;
  uploadSellables: UploadSellablesPayload;
  uploadSellablePrice: UploadSellablePricePayload;
  uploadFeaturedSellableContent: UploadFeaturedSellableContentPayload;
  uploadBrands: UploadBrandsPayload;
  uploadSellableUpdates: UploadSellableUpdatesPayload;
  uploadSellableDeactivations: UploadSellableDeactivationsPayload;
  uploadSellableInventory: UploadSellableInventoryPayload;
  uploadExpertDiscountCash: UploadExpertDiscountCashPayload;
  uploadInvoicedShippingCost: UploadInvoicedShippingCostPayload;
  createMerchantOffer: CreateOfferPayload;
  createFreeFormOffer: CreateOfferPayload;
  createOfferFromSellable: CreateOfferPayload;
  createOfferForSelfCheckout: CreateOfferPayload;
  totalCostForOffer: TotalCostForOfferPayload;
  createOrderFromOffer: CreateOrderFromOfferPayload;
  addOfferToCart: AddOfferToCartPayload;
  /**
   * When using this mutation, either the top-level file argument or the inner UploadMediaInput.file should be set.
   * This is because of the iOS graphql client limitation.
   * If both top-level argument and file inside input are set, file inside input is used.
   */
  uploadMedia: UploadMediaPayload;
  createMedia: CreateMediaPayload;
  persistMedia: PersistMediaPayload;
  createDraftExpertProfile: CreateExpertProfilePayload;
  createExpertProfile: CreateExpertProfilePayload;
  submitExpertProfile: UpdateExpertProfilePayload;
  approveExpertProfile: UpdateExpertProfilePayload;
  requestChangesOnExpertProfile: UpdateExpertProfilePayload;
  updateExpertProfile: UpdateExpertProfilePayload;
  /** @deprecated use startExpertRatingPath */
  startExpertRating: StartExpertRatingPayload;
  startExpertRatingPath: StartExpertRatingPayload;
  updateConsumerExpertReview: UpdateConsumerExpertReviewPayload;
  deleteConsumerExpertReview: Scalars['Boolean'];
  addExpertProfileHighlight: UpdateExpertProfilePayload;
  removeExpertProfileHighlight: UpdateExpertProfilePayload;
  createBlankExpertApplication: CreateBlankExpertApplicationPayload;
  approveExpertApplication: ApproveExpertApplicationPayload;
  rejectExpertApplication: RejectExpertApplicationPayload;
  restoreExpertApplication: UpdateExpertApplicationPayload;
  setExpertApplicationArchived: UpdateExpertApplicationPayload;
  setExpertApplicationSnooze: UpdateExpertApplicationPayload;
  cancelExpertApplicationSnooze: UpdateExpertApplicationPayload;
  requestConsumerReviewByExpert: RequestConsumerExpertReviewPayload;
  requestReferralByExpert: RequestReferralByExpertPayload;
  sendExpertReferral: SendExpertReferralPayload;
  createExpertFromApplication: CreateExpertFromApplicationPayload;
  addExpertApplicationReview: AddExpertApplicationReviewPayload;
  submitExpertHiringFeedback: SubmitExpertHiringFeedbackPayload;
  updateExpertApplicationTaskStatus: UpdateExpertApplicationTaskStatusPayload;
  setExpertApplicationTaskCompleted: SetExpertApplicationTaskCompletedPayload;
  rerunExpertApplicationTask: RerunExpertApplicationTaskPayload;
  startExpertApplicationConversation: ExpertApplication;
  addExpertApplicationNote: UpdateExpertApplicationPayload;
  updateExpertApplicationTags: UpdateExpertApplicationPayload;
  updateExpertApplication: UpdateExpertApplicationPayload;
  /** @deprecated Use saveConsumerSellableReaction instead */
  saveSavedSellable: SaveSavedSellablePayload;
  /** @deprecated Use saveConsumerSellableReaction instead */
  unsaveSavedSellable: UnsaveSavedSellablePayload;
  createSellable: CreateSellablePayload;
  updateSellable: UpdateSellablePayload;
  bulkUpdateSellable: BulkUpdateSellablePayload;
  bulkSetSellableAttribute: BulkSetSellableAttributePayload;
  bulkSetSellableRawAttribute: BulkSetSellableRawAttributePayload;
  bulkRemoveSellableAttribute: BulkRemoveSellableAttributePayload;
  bulkRemoveSellableRawAttribute: BulkRemoveSellableRawAttributePayload;
  deactivateSellable: DeactivateSellablePayload;
  createSellableTerms: CreateSellableTermsPayload;
  requestSellable: RequestSellablePayload;
  updateAdHocSellablePrice: UpdateAdHocSellablePricePayload;
  deactivateSellablePriceSource: DeactivateSellablePriceSourcePayload;
  refreshSellablePriceSource: RefreshSellablePriceSourcePayload;
  saveConsumerSellableReaction: SaveConsumerSellableReactionPayload;
  createSellableResearchLink: CreateSellableResearchLinkPayload;
  deleteSellableResearchLink: DeleteSellableResearchLinkPayload;
  requestSellablePriceMatch: RequestSellablePriceMatchPayload;
  updateSellableCustomOfferRule: UpdateSellableCustomOfferRulePayload;
  createSellableCustomOfferRule: UpdateSellableCustomOfferRulePayload;
  rejectSellableQuestionCandidate: RejectSellableQuestionCandidatePayload;
  approveSellableQuestionCandidate: ApproveSellableQuestionCandidatePayload;
  updateSellableQuestion: UpdateSellableQuestionPayload;
  startExpertConsumerConversation: StartExpertConsumerConversationPayload;
  setLeadSnooze: UpdateLeadPayload;
  cancelLeadSnooze: UpdateLeadPayload;
  setLeadStar: UpdateLeadPayload;
  markLeadAsSpam: UpdateLeadPayload;
  setLeadArchived: UpdateLeadPayload;
  setLeadDoNotCall: UpdateLeadPayload;
  dismissLeadSuggestedAction: UpdateLeadPayload;
  delegateLead: UpdateLeadPayload;
  reassignLead: UpdateLeadPayload;
  replaceDeactivatedExpert: UpdateLeadPayload;
  setConsumerInitialLeadAction: SetConsumerInitialLeadActionPayload;
  /** @deprecated Replaced by the createQuickReply */
  createQuickReplyWithLead: CreateQuickReplyPayload;
  /** @deprecated Replaced by the createQuickReply */
  createQuickReplyWithoutLead: CreateQuickReplyPayload;
  createQuickReply: CreateQuickReplyPayload;
  updateQuickReply: UpdateQuickReplyPayload;
  deleteQuickReply: Scalars['Boolean'];
  createLeadNote: CreateLeadNotePayload;
  updateLeadNote: UpdateLeadNotePayload;
  deleteLeadNote: Scalars['Boolean'];
  addUserInfoForLead: AddUserInfoForLeadPayload;
  acceptLeadEscalation: AcceptEscalationResult;
  findAndAcceptOpenLeadEscalations: FindAndAcceptOpenLeadEscalationsResult;
  startLeadEscalation: StartLeadEscalationPayload;
  reportPredictedLifeTimeValueToPlatform: ReportPredictedLifeTimeValuePayload;
  createLeadSurge: CreateLeadSurgePayload;
  createLeadTrainingScenario: CreateLeadTrainingScenarioPayload;
  updateLeadTrainingScenario: UpdateLeadTrainingScenarioPayload;
  createPracticeLead: CreatePracticeLeadPayload;
  removeTicketNeedsAttention: UpdateLeadPayload;
  setLeadRPALExclusionOverride: UpdateLeadPayload;
  removeLeadRPALExclusionOverride: UpdateLeadPayload;
  createCampaignAudience: CreateCampaignAudiencePayload;
  updateCampaignAudience: UpdateCampaignAudiencePayload;
  addCampaignAudienceIntegration: AddCampaignAudienceIntegrationPayload;
  updateCampaignAudienceIntegration: UpdateCampaignAudienceIntegrationPayload;
  removeCampaignAudienceIntegration: RemoveCampaignAudienceIntegrationPayload;
  publishCampaignAudience: PublishCampaignAudiencePayload;
  archiveCampaignAudience: ArchiveCampaignAudiencePayload;
  syncCampaignAudience: SyncCampaignAudiencePayload;
  createCampaign: UpdateCampaignPayload;
  updateCampaign: UpdateCampaignPayload;
  scheduleCampaign: UpdateCampaignPayload;
  cancelScheduledCampaign: UpdateCampaignPayload;
  createCampaignTrigger: UpdateCampaignPayload;
  activateCampaign: UpdateCampaignPayload;
  deactivateCampaign: UpdateCampaignPayload;
  copyCampaign: UpdateCampaignPayload;
  trackOnlineActivity: TrackOnlineActivityPayload;
  createContentSelectionRule: CreateContentSelectionRulePayload;
  updateContentSelectionRule: UpdateContentSelectionRulePayload;
  createReport: UpdateReportPayload;
  updateReport: UpdateReportPayload;
  addReportSchedule: UpdateReportPayload;
  removeReportSchedule: UpdateReportPayload;
  /**
   * Add expert curated itemt to cart.
   * This is intended to be invoked by consumers to add the expert curated item to cart. Note that this special mutation
   * is required since it'll allow the consumer to add items with price overrides, where the consumer typically can't
   * add items to cart and override the price themselves.
   */
  addExpertCuratedItemToCart: AddExpertCuratedItemToCartPayload;
  /**
   * Create new expert curated item in draft state. `makeExpertCuratedItemDraftsActive` must be used to convert to
   * activate/submit the drafts into an active state.
   */
  createExpertCuratedItem: CreateExpertCuratedItemPayload;
  /**
   * This is intended to allow bulk duplicating data from existing ExpertCuratedItem's as new ExpertCuratedItem's
   * recommended to a new lead based on recommendations of similar ExpertCuratedItem's
   */
  copyFromExpertCuratedItems: CopyFromExpertCuratedItemsPayload;
  /** Update an existing expert curated item */
  updateExpertCuratedItem: UpdateExpertCuratedItemPayload;
  updateExpertCuratedItemFulfillmentNotes: UpdateExpertCuratedItemFulfillmentNotesPayload;
  /** Remove an existing expert curated item */
  removeExpertCuratedItem: RemoveExpertCuratedItemPayload;
  /** Make all drafts associated with the lead active, and invoke relevant actions */
  makeExpertCuratedItemDraftsActive: MakeExpertCuratedItemDraftsActivePayload;
  /**
   * Expert API to create a curated recommended order in draft mode that's backed by an actual `Order`. This expert
   * initializes it self from the provided sellable, copying over variations and prices, and starts off in a draft
   * mode where further alterations can be made. (see mutations like `updateExpertCuratedOrderVariationOptions`).
   * This is typically used for recommending services, as they typically involve more than one sellable
   */
  createExpertCuratedOrder: CreateExpertCuratedOrderPayload;
  /**
   * Expert API to change the availability or price of the variations. Note that additional variations that don't
   * exist on the sellable cannot be added!
   */
  updateExpertCuratedOrderVariationOptions: UpdateExpertCuratedOrderVariationOptionsPayload;
  /** Expert API to insert or update an add-on item */
  upsertItemsInExpertCuratedOrder: UpsertItemsInExpertCuratedOrderPayload;
  /** Expert API to remove an add-on item */
  removeItemsFromExpertCuratedOrder: RemoveItemsFromExpertCuratedOrderPayload;
  /**
   * Expert API to make a created expert curated order a bookable one. It will bringing it out of draft mode into ACTIVE state.
   * It requires the curated order to be not in the preview mode and verifies that
   * all required fields like date are all specified
   * once a curated order is active, the terms, variations, or items can't be modified by the expert. It can only be
   * closed, different options can be selected between by the consumer, or a replacement curated order can be made via
   * `findOrCreateReplacementExpertCuratedOrder`. By activating an order, a rich card will be sent to the client as well.
   */
  activateExpertCuratedOrderAsBookable: ActivateExpertCuratedOrderAsBookablePayload;
  /** Expert API to send a notification to the customer about a particular curated order */
  notifyCustomerExpertCuratedOrder: NotifyCustomerExpertCuratedOrderPayload;
  /** Consumer API to send a notification to the expert that they're interested in a curated order */
  customerRequestExpertCuratedOrder: CustomerRequestExpertCuratedOrderPayload;
  /** Close out the expert curated order, effectively expiring it making it unpurchase-able by the user */
  closeExpertCuratedOrder: CloseExpertCuratedOrderPayload;
  /** Expert API to update terms (service start date, etc) */
  updateExpertCuratedOrderTerms: UpdateExpertCuratedOrderTermsPayload;
  /**
   * Consumer API to toggle between available variations. Only applicable if the expert curated order is active,
   * and the order hasn't been purchased yet.
   */
  selectExpertCuratedOrderVariationOption: SelectExpertCuratedOrderVariationOptionPayload;
  /**
   * Consumer API to disable (remove) optional add-ons they're not interested in. Only applicable if the expert curated
   * order is active, and the order hasn't been purchased yet.
   */
  selectExpertCuratedOrderItems: SelectExpertCuratedOrderItemsPayload;
  /**
   * Expert API to override the service location that was originally derived from the sellable service merchant's address.
   * This new address will be used across the board for this expert curated order; displaying to the consumer, computing
   * tax, etc.
   */
  updateServiceLocationExpertCuratedOrder: UpdateServiceLocationExpertCuratedOrderPayload;
  /**
   * Expert API to activate all pending draft curated orders associated with a lead. This is similar to
   * `activateExpertCuratedOrder`, except that this activates multiple curated orders, resulting an a activation list
   * object summarizing the result (the curated orders that were activated, closed, etc). This also sends a custom
   * rich card to the client displaying the activation list (summary of all the curated orders).
   */
  activateExpertCuratedOrdersForLead: ActivateExpertCuratedOrdersForLeadPayload;
  /**
   * Accept ExpertCuratedOrderId, setup superseded chain and make as draft.
   * Activation of this will disable previous supersededId
   */
  findOrCreateReplacementExpertCuratedOrder: FindOrCreateReplacementExpertCuratedOrderPayload;
  /** Expert API to copy `items` from one curated order to another; convienence API to quickly copy addons. */
  copyItemsFromExpertCuratedOrder: CopyItemsFromExpertCuratedOrderPayload;
  /** Expert API to set the contentful itinerary to show on the expert curated orders list page for the lead */
  upsertExpertCuratedLeadItinerary: UpsertExpertCuratedLeadItineraryPayload;
  /** Expert API to delete the contentful itinerary to show on the expert curated orders list page for the lead */
  deleteExpertCuratedLeadItinerary: DeleteExpertCuratedLeadItineraryPayload;
  createSavedExpertCuratedItems: CreateSavedExpertCuratedItemsPayload;
  updateSavedExpertCuratedItems: UpdateSavedExpertCuratedItemsPayload;
  deleteSavedExpertCuratedItems: DeleteSavedExpertCuratedItemsPayload;
  createExpertConsultationFeeOrder: CreateExpertConsultationFeeOrderPayload;
  createCuratedGiftCardOrder: CreateCuratedGiftCardOrderPayload;
  extendExpertCuratedItemExpiration: ExtendExpertCuratedItemExpirationPayload;
  /**
   * This api is used to record the reviews for the Suggested Alternative recommendations for a sellable.
   * Note the suggestions are saved temporarily in the database and expires after 3 days. Adding a review for a
   * suggestion after the expiry period will result in an error.
   * Once a review is added, the suggestion are not expired and the review answers can be changed in future too.
   */
  saveReviewForSuggestedAlternativeSellable: SaveReviewForSuggestedAlternativeSellablePayload;
  /**
   * Update a specific item in a saved curation. If the saved curation is PUBLISHED this creates a new DRAFT that can supersed
   * published version when actiavted
   */
  updateSavedCurationCuratedItem: UpdateSavedCurationCuratedItemPayload;
  /**
   * Convenience method for updating the note assocaited with a SavedExpertCuratedItem. Allows UI to re-resolve the proper
   * note updates on a non-draft will create a new note
   */
  updateNoteForSavedExpertCuratedItem: UpdateNoteForSavedExpertCuratedItemPayload;
  /** Remove sellable from a saved curation */
  removeCuratedItemFromSavedCuration: RemoveCuratedItemFromSavedCurationPayload;
  /** Add sellable to a saved curation */
  addCuratedItemToSavedCuration: AddCuratedItemToSavedCurationPayload;
  /** Activate a DRAFT saved curation to PUBLISHED. This will deactivate and supersede any currently PUBLISHED saved curation */
  publishSavedExpertCuratedItems: PublishSavedExpertCuratedItemsPayload;
  /** Reset a DRAFT saved curation to the state of the PUBLISHED version if exists */
  resetSavedExpertCuratedItems: ResetSavedExpertCuratedItemsPayload;
  /** Expert API to create a expert curated item from a item within a saved curation */
  createExpertCuratedItemFromSavedExpertCuratedItem: CreateExpertCuratedItemPayload;
  /** Expert API to copy all items from a saved curation to an expert's curation */
  copyFromSavedExpertCuratedItems: CopyFromSavedExpertCuratedItemsPayload;
  /**
   * For operators to edit note attributes in place without sending them back through approval queue
   * Experts must use a different update API to accomodate different verisoning workflow
   */
  updateExpertCuratedItemNoteAttributes: UpdateExpertCuratedItemNoteAttributesPayload;
  /** For experts to create a new version of a note they already have a draft of */
  updateExpertCuratedItemNote: UpdateExpertCuratedItemNotePayload;
  /** For operator to approve note */
  approveExpertCuratedItemNote: ApproveExpertCuratedItemNotePayload;
  /** For operator to reject note */
  rejectExpertCuratedItemNote: RejectExpertCuratedItemNotePayload;
  /** For operator to deactivate note */
  archiveExpertCuratedItemNote: DeactivateExpertCuratedItemNotePayload;
  /** Reset expert note DRAFT to attributes of it's PENDING or APPROVED parent */
  resetExpertCuratedItemNote: ResetExpertCuratedItemNotePayload;
  /** Setting note as featured will also automatically set the state to APPROVED */
  setExpertCuratedItemNoteFeatured: SetExpertCuratedItemNoteFeaturedPayload;
  publishExpertCuratedItemNote: PublishExpertCuratedItemNotePayload;
  createExpertCuratedItemNoteFromSellable: CreateExpertCuratedItemNoteFromSellablePayload;
  /** Only allowed to create RecommndedListDefinition of RecommendedListType.CUSTOM. */
  createRecommendedListDefinition: CreateRecommendedListDefinitionPayload;
  /**
   * Update Mutation supports partial updates, most of the fields in the UpdateRecommendedListDefinitionInput are optional
   * and if they input is missing those field values it will retain the corresponding old values.
   * System default recommendedListDefinition don't allow updating their type, query facets and sorting.
   */
  updateRecommendedListDefinition: UpdateRecommendedListDefinitionPayload;
  deleteRecommendedListDefinition: DeleteRecommendedListDefinitionIdPayload;
  createTrigger: CreateTriggerPayload;
  updateTrigger: UpdateTriggerPayload;
  createTriggerNode: UpdateTriggerPayload;
  removeTriggerNode: UpdateTriggerPayload;
  updateTriggerFilter: UpdateTriggerPayload;
  updateTriggerDelay: UpdateTriggerPayload;
  updateTriggerAction: UpdateTriggerPayload;
  updateTriggerBranch: UpdateTriggerPayload;
  createTriggerJumpTo: UpdateTriggerPayload;
  swapTriggerBranchEdges: UpdateTriggerPayload;
  updateTriggerWait: UpdateTriggerPayload;
  swapTriggerWaitEdges: UpdateTriggerPayload;
  splitTriggerWaitEdges: UpdateTriggerPayload;
  mergeTriggerWaitEdges: UpdateTriggerPayload;
  updateTriggerEdge: UpdateTriggerPayload;
  removeTriggerEdge: UpdateTriggerPayload;
  publishTrigger: PublishTriggerPayload;
  deactivateTrigger: DeactivateTriggerPayload;
  archiveTrigger: ArchiveTriggerPayload;
  newTriggerVersion: NewTriggerVersionPayload;
  resetDraftTrigger: ResetDraftTriggerPayload;
  importEntities: ImportEntitiesPayload;
  testTriggerExecution: TestTriggerExecutionPayload;
  shortenUrl?: Maybe<ShortenUrlPayload>;
  createAdhocSellableFromEBayItem: CreateAdhocSellableFromEBayItemPayload;
  identifyEBayItemAsSellable: IdentifyEBayItemAsSellablePayload;
  updateConfig: UpdateConfigPayload;
  resetConfig: ResetConfigPayload;
  syncExternalAdCampaigns: SyncExternalAdCampaignsPayload;
  updateExternalAdCampaign: UpdateExternalAdCampaignPayload;
  updateExternalAdGroup: UpdateExternalAdGroupPayload;
  applyExternalAdBudget: ApplyExternalAdBudgetPayload;
  startSystemCuratedItemSurvey: StartSystemCuratedItemSurveyPayload;
  terminateSystemCuratedItemSurvey: TerminateSystemCuratedItemSurveyPayload;
  createFlightPlan: CreateFlightPlanPayload;
  activateFlightPlan: ActivateFlightPlanPayload;
  copyFlightPlanAsDraft: CopyFlightPlanAsDraftPayload;
  upsertLegsIntoFlightPlan: UpsertLegsIntoFlightPlanPayload;
  removeLegsFromFlightPlan: RemoveLegsFromFlightPlanPayload;
  assignSupportTask: AssignSupportTaskPayload;
  completeSupportTaskNoActionNeeded: CompleteSupportTaskNoActionNeededPayload;
  completeSupportTaskSnooze: CompleteSupportTaskSnoozePayload;
  completeLeadSupportTaskAssignLeadActions: CompleteLeadSupportTaskAssignLeadActionsPayload;
  completeLeadSupportTaskDelegateLead: CompleteLeadSupportTaskDelegateLeadPayload;
  completeLeadSupportTaskReassignLead: CompleteLeadSupportTaskReassignLeadPayload;
  completeLeadSupportTaskEscalateToTeamForDelegation: CompleteLeadSupportTaskEscalateToTeamForDelegationPayload;
  completeLeadSupportTaskEscalateForReassignment: CompleteLeadSupportTaskEscalateForReassignmentPayload;
  completeLeadSupportTaskRequestOrderSupport: CompleteLeadSupportTaskRequestOrderSupportPayload;
  completeLeadSupportTaskCheckForSpam: CompleteLeadSupportTaskCheckForSpamPayload;
  addSupportToLeadConversation: AddSupportToLeadConversationPayload;
  removeSupportFromLeadConversation: RemoveSupportFromLeadConversationPayload;
  createOrderEscalation: CreateOrderEscalationsPayload;
  assignOrderEscalation: UpdateOrderEscalationPayload;
  startOrderEscalation: UpdateOrderEscalationPayload;
  completeOrderEscalation: UpdateOrderEscalationPayload;
  addEscalationNote: UpdateOrderEscalationPayload;
  setEscalationPriority: UpdateOrderEscalationPayload;
  startSupportConversation: UpdateSupportConversationPayload;
  addOrderEscalationLabel: UpdateOrderEscalationPayload;
  removeOrderEscalationLabel: UpdateOrderEscalationPayload;
  dismissSuggestedSupportAction: UpdateSupportConversationPayload;
  updateSellableInventoryItem: SellableInventoryItemUpdatePayload;
  syncShopifyInventoryItem: SyncShopifyInventoryPayload;
  createPayStructure: CreatePayStructurePayload;
  createPayStructureRevision: UpdatePayStructureRevisionPayload;
  updatePayStructureRevision: UpdatePayStructureRevisionPayload;
  activatePayStructureRevision: UpdatePayStructureRevisionPayload;
  approvePayout: UpdatePayoutPayload;
  bulkResendPayouts: BulkUpdatePayoutPayload;
  bulkApprovePayouts: BulkUpdatePayoutPayload;
  resendPayout: UpdatePayoutPayload;
  recomputePayout: UpdatePayoutPayload;
  createPayout: UpdatePayoutPayload;
  addManualAdjustmentPayLineItems: UpdatePayoutPayload;
  createRawSellableSource: CreateRawSellableSourcePayload;
  updateRawSellableSource: UpdateRawSellableSourcePayload;
  createRawSellableStandardizationRule: CreateRawSellableStandardizationRulePayload;
  updateRawSellableStandardizationRule: UpdateRawSellableStandardizationRulePayload;
  mergeStandardizedSellableGroup: MergeStandardizedSellableGroupPayload;
  startStandardizedSellableGroupIngestion: StartStandardizedSellableGroupIngestionPayload;
  startRawSellableSourceIngestion: StartRawSellableSourceIngestionPayload;
  acceptStandardizedSellableGroupCandidate: AcceptStandardizedSellableGroupCandidatePayload;
  rejectStandardizedSellableGroupCandidate: RejectStandardizedSellableGroupCandidatePayload;
  startRawSellableStandardization: StartRawSellableStandardizationPayload;
  startStandardizationSellableMatching: StartStandardizationSellableMatchingPayload;
  importRawSellableSource: ImportRawSellableSourcePayload;
  importRawSellableStandardizationRule: ImportRawSellableStandardizationRulePayload;
  importRawSellableStandardizationRules: ImportRawSellableStandardizationRulesPayload;
  dryRunRawSellableStandardization: DryRunRawSellableStandardizationPayload;
  createSchedulingDemandForecast: CreateSchedulingDemandForecastPayload;
  updateSchedulingDemandForecast: UpdateSchedulingDemandForecastPayload;
  removeSchedulingDemandForecast: RemoveSchedulingDemandForecastPayload;
  createSchedulingUserAvailability: CreateSchedulingUserAvailabilityPayload;
  removeSchedulingUserAvailability: RemoveSchedulingUserAvailabilityPayload;
  claimShift: UpdateShiftPayload;
  cancelShift: UpdateShiftPayload;
  giveUpShift: UpdateShiftPayload;
  takeOverShift: UpdateShiftPayload;
  cancelShiftChangeRequest: UpdateShiftPayload;
  updateSchedulingUserProfile: UpdateSchedulingUserPayload;
  copySchedulingDemandForecastToNextPeriod: CopySchedulingDemandForecastPayload;
  overwriteShiftSlot: OverwriteShiftSlotPayload;
  runShiftAssignments: RunShiftAssignmentsPayload;
  deleteProposedShifts: DeleteProposedShiftsPayload;
  acceptProposedShifts: AcceptProposedShiftsPayload;
  notifyAssignedShifts: NotifyShiftsPayload;
  notifyAvailabilityOpen: NotifyShiftsPayload;
  openAllShiftsAndNotify: NotifyShiftsPayload;
  updateSchedulingUserRoles: UpdateSchedulingUserPayload;
  updateSchedulingType: UpdateSchedulingTypePayload;
  acceptSurgeShift: AcceptSurgeShiftPayload;
  setShiftAbsenceExcused: SetShiftAbsenceExcusedPayload;
  confirmShiftProbations: ConfirmShiftProbationsPayload;
  findOrCreateChannel: CreateFulfillmentChannelPayload;
  updateFulfillmentInstructions: UpdateFulfillmentChannelPayload;
  claimLineItemByChannel: UpdateFulfillmentTicketPayload;
  skipFulfillmentChannel: UpdateFulfillmentTicketPayload;
  setFulfillmentChannelBlacklisted: UpdateFulfillmentChannelPayload;
  updateFulfillmentChannel: UpdateFulfillmentChannelPayload;
  verifyOrder: UpdateOrderPayload;
  requestRefund: UpdateOrderRefundPayload;
  rejectRefundRequest: UpdateOrderRefundPayload;
  setRefundSucceeded: UpdateOrderRefundPayload;
  setRefundFailed: UpdateOrderRefundPayload;
  adjustRequestedRefundAmount: UpdateOrderRefundPayload;
  cancelOrderRefund: UpdateOrderRefundPayload;
  addOrderReturnShipmentTracking: UpdateOrderRefundPayload;
  removeOrderReturnShipmentTracking: UpdateOrderRefundPayload;
  syncOrderReturnShipmentTracking: UpdateOrderRefundPayload;
  updateMerchantRefund: UpdateOrderRefundPayload;
  updateProductReturnDestination: UpdateFulfillmentTicketPayload;
  confirmReturnLabelSent: UpdateFulfillmentTicketPayload;
  checkedOnReturnLabelFromMerchant: UpdateFulfillmentTicketPayload;
  startRefundProcess: TicketWithErrorPayload;
  updateLineItemClaim: FulfillmentOrderPayload;
  updateShipmentPricingModel: UpdateShipmentPricingModelPayload;
  createShipmentPricingModel: UpdateShipmentPricingModelPayload;
  createGroupClaimTicket: TicketWithErrorPayload;
  assignTicket: TicketWithErrorPayload;
  bulkAssignTickets: BulkUpdateTicketsPayload;
  unassignTicket: UpdateTicketPayload;
  setTicketDueDate: UpdateTicketPayload;
  bulkSetTicketDueDate: BulkUpdateTicketsPayload;
  updateTicketDescription: UpdateTicketPayload;
  addCommentToTicket: UpdateTicketPayload;
  addCommentToTicketByExpert: UpdateTicketPayload;
  bulkResolveTickets: BulkUpdateTicketsPayload;
  closeTicket: TicketWithErrorPayload;
  claimNextTicketInQueue?: Maybe<TicketWithErrorPayload>;
  snoozeTicket: TicketWithErrorPayload;
  transferTicketToQueue: TicketWithErrorPayload;
  mergeTickets: TicketWithErrorPayload;
  createTicket: TicketWithErrorPayload;
  createTicketByExpert: TicketWithErrorPayload;
  closeAndOpenNewTicket: TicketWithErrorPayload;
  logWorkForTicket: TicketWithErrorPayload;
  claimTicket: TicketWithErrorPayload;
  reopenTicket: TicketWithErrorPayload;
  shareReferralCodeViaEmail: ReferralCodeSharePayload;
  claimSocialShareCredit: ClaimSocialShareCreditPayload;
  claimConsumerReferral: ClaimConsumerReferralUserSourcePayload;
  claimExpertReferral: ClaimExpertReferralUserSourcePayload;
  createExperiment: CreateExperimentPayload;
  updateExperiment: UpdateExperimentPayload;
  archiveExperiment: ArchiveExperimentPayload;
  unarchiveExperiment: UnarchiveExperimentPayload;
  addLeadSpecialCareTag: UpdateLeadSpecialCareTagPayload;
  removeLeadSpecialCareTag: UpdateLeadSpecialCareTagPayload;
  addExpertSpecialCareTag: UpdateExpertSpecialCareTagPayload;
  removeExpertSpecialCareTag: UpdateExpertSpecialCareTagPayload;
  sendRichCard: SendRichCardPayload;
  createNewDraftArticle: CreateNewDraftArticlePayload;
  createNewDraftRevisionForArticle: CreateNewDraftRevisionForArticlePayload;
  copyArticleRevisionAsDraft: CopyArticleRevisionAsDraftPayload;
  publishArticleRevision: PublishArticleRevisionPayload;
  archiveArticle: ArchiveArticlePayload;
  updateArticleRevision: UpdateDraftArticleRevisionPayload;
  removeArticleRevisionAttribute: UpdateDraftArticleRevisionPayload;
  setArticleRevisionAttribute: UpdateDraftArticleRevisionPayload;
  removeArticleRevisionTag: UpdateDraftArticleRevisionPayload;
  addArticleRevisionTag: UpdateDraftArticleRevisionPayload;
  updateArticleRevisionContentBlock: UpdateDraftArticleRevisionPayload;
  removeArticleRevisionContentBlock: UpdateDraftArticleRevisionPayload;
  insertArticleRevisionContentBlock: UpdateDraftArticleRevisionPayload;
  moveArticleRevisionContentBlock: UpdateDraftArticleRevisionPayload;
  createSellableTopList: UpdateSellableTopListPayload;
  updateSellableTopList: UpdateSellableTopListPayload;
  publishSellableTopList: UpdateSellableTopListPayload;
  archiveSellableTopList: UpdateSellableTopListPayload;
  previewSellableTopList: SellableTopList;
  createGiftCardOrder: CreateGiftCardOrderPayload;
  redeemGiftCard: RedeemGiftCardPayload;
  resendGiftCard: ResendGiftCardPayload;
  publishProductCatalogRevisions: PublishProductCatalogRevisionsPayload;
  createDraftProductCatalogRevisionFromSellable: CreateDraftProductCatalogRevisionFromSellablePayload;
  createDraftProductCatalogRevisionForCatalog: CreateDraftProductCatalogRevisionForCatalogPayload;
  copyProductCatalogRevisionAsDraft: CopyProductCatalogRevisionAsDraftPayload;
  updateProductCatalogDraft: UpdateProductCatalogDraftPayload;
  archiveProductCatalogRevision: ArchiveProductCatalogRevisionPayload;
  setProductCatalogAttribute: SetProductCatalogAttributePayload;
  setProductCatalogRawAttribute: SetProductCatalogRawAttributePayload;
  removeProductCatalogAttribute: RemoveProductCatalogAttributePayload;
  reorderProductCatalogRawAttributes: ReorderProductCatalogRawAttributesPayload;
  publishProductCatalogFromSellables: PublishProductCatalogFromSellablesPayload;
  publishProductCatalogGroupRevisions: PublishProductCatalogGroupRevisionsPayload;
  createDraftProductCatalogGroupRevisionFromSellable: CreateDraftProductCatalogGroupRevisionFromSellablePayload;
  createDraftProductCatalogGroupRevisionForGroup: CreateDraftProductCatalogGroupRevisionForGroupPayload;
  copyProductCatalogGroupRevisionAsDraft: CopyProductCatalogGroupRevisionAsDraftPayload;
  updateProductCatalogGroupDraft: UpdateProductCatalogGroupDraftPayload;
  archiveProductCatalogGroupRevision: ArchiveProductCatalogGroupRevisionPayload;
  setProductCatalogGroupAttribute: SetProductCatalogGroupAttributePayload;
  setProductCatalogGroupRawAttribute: SetProductCatalogGroupRawAttributePayload;
  removeProductCatalogGroupAttribute: RemoveProductCatalogGroupAttributePayload;
  reorderProductCatalogGroupRawAttributes: ReorderProductCatalogGroupRawAttributesPayload;
  publishProductCatalogGroupFromSellables: PublishProductCatalogGroupFromSellablesPayload;
  assumePartnerUserIdentity: AssumePartnerUserIdentityPayload;
  releasePartnerUserIdentity: ReleasePartnerUserIdentityPayload;
};


export type MutationAddAddressArgs = {
  input: AddAddressInput;
};


export type MutationUpdateAddressPreferencesArgs = {
  input: UpdateAddressPreferencesInput;
};


export type MutationDeleteAddressArgs = {
  input: DeleteAddressInput;
};


export type MutationPrepareApprovalRequestSubmitDraftArgs = {
  input: PrepareApprovalRequestSubmitDraftInput;
};


export type MutationUpdateApprovalRequestSubmitDraftArgs = {
  input: UpdateApprovalRequestSubmitDraftInput;
};


export type MutationSubmitForReviewInApprovalRequestArgs = {
  input: SubmitForReviewInApprovalRequestInput;
};


export type MutationCommentOnApprovalRequestArgs = {
  input: CommentOnApprovalRequestInput;
};


export type MutationApproveApprovalRequestArgs = {
  input: ApproveApprovalRequestInput;
};


export type MutationRejectApprovalRequestArgs = {
  input: RejectApprovalRequestInput;
};


export type MutationPublishApprovalRequestArgs = {
  input: PublishApprovalRequestInput;
};


export type MutationCloseApprovalRequestArgs = {
  input: CloseApprovalRequestInput;
};


export type MutationCreateAttributeSchemaRevisionArgs = {
  input: CreateAttributeSchemaRevisionInput;
};


export type MutationCopyAttributeSchemaRevisionAsNewVersionArgs = {
  input: CopyAttributeSchemaRevisionAsNewVersionInput;
};


export type MutationPublishAttributeSchemaRevisionArgs = {
  input: PublishAttributeSchemaRevisionInput;
};


export type MutationDeleteDraftAttributeSchemaRevisionArgs = {
  input: DeleteDraftAttributeSchemaRevisionInput;
};


export type MutationDeprecateAttributeSchemaRevisionArgs = {
  input: DeprecateAttributeSchemaRevisionInput;
};


export type MutationUpdateAttributeSchemaRevisionArgs = {
  input: UpdateAttributeSchemaRevisionInput;
};


export type MutationUpsertEnumEntriesIntoAttributeSchemaRevisionArgs = {
  input: UpsertEnumEntriesIntoAttributeSchemaRevisionInput;
};


export type MutationReorderEnumEntriesInAttributeSchemaRevisionArgs = {
  input: ReorderEnumEntriesInAttributeSchemaRevisionInput;
};


export type MutationRemoveDraftEnumEntriesFromAttributeSchemaRevisionArgs = {
  input: RemoveDraftEnumEntriesFromAttributeSchemaRevisionInput;
};


export type MutationUpsertMetadataIntoAttributeSchemaRevisionArgs = {
  input: UpsertMetadataIntoAttributeSchemaRevisionInput;
};


export type MutationRemoveMetadataFromAttributeSchemaRevisionArgs = {
  input: RemoveMetadataFromAttributeSchemaRevisionInput;
};


export type MutationUpsertValidatorIntoAttributeSchemaRevisionArgs = {
  input: UpsertValidatorIntoAttributeSchemaRevisionInput;
};


export type MutationRemoveValidatorFromAttributeSchemaRevisionArgs = {
  input: RemoveValidatorFromAttributeSchemaRevisionInput;
};


export type MutationInitiateAuthenticationArgs = {
  input: InitiateAuthenticationInput;
};


export type MutationInitiateResetPasswordArgs = {
  input: InitiateResetPasswordInput;
};


export type MutationInitiateVerifyHandleArgs = {
  input: InitiateVerifyHandleInput;
};


export type MutationAuthenticateArgs = {
  input: AuthenticationInput;
};


export type MutationAuthenticateByExternalOAuthTokenArgs = {
  input: AuthenticateByExternalOAuthTokenInput;
};


export type MutationLogoutAllSessionsArgs = {
  input: LogoutAllSessionsInput;
};


export type MutationCreatePasswordArgs = {
  input: CreatePasswordInput;
};


export type MutationResetPasswordArgs = {
  input: ResetPasswordInput;
};


export type MutationChangePasswordArgs = {
  input: ChangePasswordInput;
};


export type MutationVerifyResetPasswordChallengeArgs = {
  input: VerifyResetPasswordChallengeInput;
};


export type MutationVerifyHandleChallengeArgs = {
  input: VerifyHandleChallengeInput;
};


export type MutationRefreshAccessTokenArgs = {
  input: RefreshAccessTokenInput;
};


export type MutationCreateCommTemplateArgs = {
  input: CreateTemplateInput;
};


export type MutationUpdateCommTemplateArgs = {
  input: UpdateTemplateInput;
};


export type MutationCopyCommTemplateArgs = {
  input: CopyTemplateInput;
};


export type MutationPublishCommTemplateArgs = {
  input: PublishTemplateInput;
};


export type MutationDeactivateCommTemplateArgs = {
  input: DeactivateTemplateInput;
};


export type MutationNewCommTemplateVersionArgs = {
  input: NewTemplateVersionInput;
};


export type MutationUpdateChannelTemplateArgs = {
  input: UpdateChannelTemplateInput;
};


export type MutationRemoveChannelTemplateArgs = {
  input: RemoveChannelTemplateInput;
};


export type MutationAddChannelTemplateArgs = {
  input: AddChannelTemplateInput;
};


export type MutationSendTemplateTestMessageArgs = {
  input: SendTemplateTestMessageInput;
};


export type MutationCreateCommTemplateTypeArgs = {
  input: CreateTemplateTypeInput;
};


export type MutationCopyCommTemplateTypeArgs = {
  input: CopyTemplateTypeInput;
};


export type MutationUpdateCommTemplateTypeArgs = {
  input: UpdateTemplateTypeInput;
};


export type MutationCreateCommTemplateFragmentArgs = {
  input: CreateTemplateFragmentInput;
};


export type MutationUpdateCommTemplateFragmentArgs = {
  input: UpdateTemplateFragmentInput;
};


export type MutationCopyCommTemplateFragmentArgs = {
  input: CopyTemplateFragmentInput;
};


export type MutationPublishCommTemplateFragmentArgs = {
  input: PublishTemplateFragmentInput;
};


export type MutationDeactivateCommTemplateFragmentArgs = {
  input: DeactivateTemplateFragmentInput;
};


export type MutationNewCommTemplateFragmentVersionArgs = {
  input: NewTemplateFragmentVersionInput;
};


export type MutationGenerateTemplateFragmentSnippetArgs = {
  input: GenerateTemplateFragmentSnippetInput;
};


export type MutationGenerateTemplateDirectiveSnippetArgs = {
  input: GenerateTemplateDirectiveSnippetInput;
};


export type MutationCreateDealRequestArgs = {
  input: CreateDealRequestInput;
};


export type MutationCreateUserArgs = {
  input: CreateUserInput;
};


export type MutationCreateOperatorsArgs = {
  input: CreateOperatorsInput;
};


export type MutationUpdateOperatorArgs = {
  input: UpdateOperatorInput;
};


export type MutationUpdateUserProfileArgs = {
  input: UpdateUserProfileInput;
};


export type MutationCreateMerchantArgs = {
  input: CreateMerchantInput;
};


export type MutationCreateMerchantsArgs = {
  input: Array<CreateMerchantInput>;
};


export type MutationUpdateMerchantArgs = {
  input: UpdateMerchantInput;
};


export type MutationRegisterCustomerArgs = {
  input: RegisterCustomerInput;
};


export type MutationCreatePendingAccessContactArgs = {
  input: CreatePendingAccessContactInput;
};


export type MutationVerifyPendingAccessContactArgs = {
  input: VerifyPendingAccessContactInput;
};


export type MutationAssumeOperatorIdentityArgs = {
  input: AssumeOperatorIdentityInput;
};


export type MutationAssumeConsumerIdentityArgs = {
  input: AssumeConsumerIdentityInput;
};


export type MutationUpdateUserSourceArgs = {
  input: UpdateUserSourceInput;
};


export type MutationStartSmsPromotionRegistrationArgs = {
  input: StartSmsPromotionRegistrationInput;
};


export type MutationCreateSmsRegistrationPromotionArgs = {
  input: CreateSmsRegistrationPromotionInput;
};


export type MutationOperatorStartShiftArgs = {
  input: OperatorStartShiftInput;
};


export type MutationOperatorEndShiftArgs = {
  input: OperatorEndShiftInput;
};


export type MutationCreateBusinessUserArgs = {
  input: CreateBusinessUserInput;
};


export type MutationUpdateBusinessUserArgs = {
  input: UpdateBusinessUserInput;
};


export type MutationUpdateExpertLeadGateArgs = {
  input: UpdateExpertLeadGateInput;
};


export type MutationRecomputeNewExpertLeadGateArgs = {
  input: RecomputeNewExpertLeadGateInput;
};


export type MutationUpdateBusinessUserVanityIdArgs = {
  input: UpdateBusinessUserVanityIdInput;
};


export type MutationAssumeBusinessUserIdentityArgs = {
  input: AssumeBusinessUserIdentityInput;
};


export type MutationSetAcceptingNewRequestsArgs = {
  input?: Maybe<SetAcceptingNewRequestsInput>;
};


export type MutationSetExpertOnCallArgs = {
  input: SetExpertOnCallInput;
};


export type MutationStartOnCallShiftArgs = {
  input: StartOnCallShiftInput;
};


export type MutationStartExpertShiftArgs = {
  input: StartExpertShiftInput;
};


export type MutationStartExpertStandbyArgs = {
  input: StartExpertStandbyInput;
};


export type MutationSetExpertOffShiftArgs = {
  input?: Maybe<SetExpertOffShiftInput>;
};


export type MutationSetExpertAwayAutoReplyArgs = {
  input?: Maybe<SetExpertAwayAutoReplyInput>;
};


export type MutationCreateBusinessAccountArgs = {
  input: CreateBusinessAccountInput;
};


export type MutationCreateBusinessUserTeamArgs = {
  input: CreateBusinessUserTeamInput;
};


export type MutationUpdateBusinessUserTeamArgs = {
  input: UpdateBusinessUserTeamInput;
};


export type MutationDeactivateExpertArgs = {
  input: DeactivateExpertInput;
};


export type MutationActivateExpertArgs = {
  input: ActivateExpertInput;
};


export type MutationSetExpertTeamLeadArgs = {
  input: SetExpertTeamLeadInput;
};


export type MutationOverrideExpertPerformanceRatingArgs = {
  input: OverrideExpertPerformanceRatingInput;
};


export type MutationCreateFirebaseTokenArgs = {
  input: CreateFirebaseTokenInput;
};


export type MutationRegisterFirebaseCloudMessagingTokenArgs = {
  input: RegisterFirebaseCloudMessagingTokenInput;
};


export type MutationRegisterWebPushSubscriptionArgs = {
  input: RegisterWebPushSubscriptionInput;
};


export type MutationUnregisterWebPushSubscriptionArgs = {
  input: UnregisterWebPushSubscriptionInput;
};


export type MutationUnregisterFirebaseCloudMessagingTokenArgs = {
  input: UnregisterFirebaseCloudMessagingTokenInput;
};


export type MutationJoinVideoChatArgs = {
  input: JoinVideoChatInput;
};


export type MutationDeclineVideoChatArgs = {
  input: DeclineVideoChatInput;
};


export type MutationMonitorVideoChatArgs = {
  input: MonitorVideoChatInput;
};


export type MutationBridgePhoneCallArgs = {
  input: BridgePhoneCallInput;
};


export type MutationBridgeLeadPhoneCallArgs = {
  input: BridgeLeadPhoneCallInput;
};


export type MutationBridgeExpertApplicationPhoneCallArgs = {
  input: BridgeExpertApplicantPhoneCallInput;
};


export type MutationCreateVoiceTokenArgs = {
  input: CreateVoiceTokenInput;
};


export type MutationMarkConversationReadArgs = {
  input: MarkConversationReadInput;
};


export type MutationGenerateCollectPhoneNumberTextInPathArgs = {
  input: GenerateCollectPhoneNumberTextInPathInput;
};


export type MutationAddBlacklistChannelAddressArgs = {
  input: AddBlacklistChannelAddressInput;
};


export type MutationCreateDraftGuestConversationSequenceArgs = {
  input: CreateDraftGuestConversationSequenceInput;
};


export type MutationAddGuestConversationSequenceMessageArgs = {
  input: AddGuestConversationSequenceMessageInput;
};


export type MutationUpdateGuestConversationSequenceArgs = {
  input: UpdateGuestConversationSequenceInput;
};


export type MutationActivateGuestConversationSequenceArgs = {
  input: ActivateGuestConversationSequenceInput;
};


export type MutationDeactivateGuestConversationSequenceArgs = {
  input: DeactivateGuestConversationSequenceInput;
};


export type MutationStartGuestConversationArgs = {
  input: StartGuestConversationInput;
};


export type MutationPickUpCallArgs = {
  input: PickUpCallInput;
};


export type MutationCreatePathFlowArgs = {
  input: CreatePathFlowInput;
};


export type MutationSubmitPathFlowPageArgs = {
  input: SubmitPathFlowPageInput;
};


export type MutationReenterPathFlowPageArgs = {
  input: ReenterPathFlowPageInput;
};


export type MutationReenterPathFlowPageBySlugsArgs = {
  input: ReenterPathFlowPageBySlugsInput;
};


export type MutationSubmitListPathFlowQuestionArgs = {
  input: SubmitListPathFlowQuestionInput;
};


export type MutationSubmitUserContactPathFlowQuestionArgs = {
  input: SubmitUserContactPathFlowQuestionInput;
};


export type MutationSubmitNumericPathFlowQuestionArgs = {
  input: SubmitNumericPathFlowQuestionInput;
};


export type MutationSubmitOAuthEmailPathFlowQuestionArgs = {
  input: SubmitOAuthEmailPathFlowQuestionInput;
};


export type MutationSubmitInputTextPathFlowQuestionArgs = {
  input: SubmitInputTextPathFlowQuestionInput;
};


export type MutationSubmitIdPathFlowQuestionArgs = {
  input: SubmitIdPathFlowQuestionInput;
};


export type MutationSubmitDatePathFlowQuestionArgs = {
  input: SubmitDatePathFlowQuestionInput;
};


export type MutationSubmitDateRangePathFlowQuestionArgs = {
  input: SubmitDateRangePathFlowQuestionInput;
};


export type MutationCreatePathSchemaRevisionArgs = {
  input: CreatePathSchemaRevisionInput;
};


export type MutationCreatePathSchemaFragmentRevisionArgs = {
  input: CreatePathSchemaFragmentRevisionInput;
};


export type MutationCopyPathSchemaRevisionAsNewRevisionArgs = {
  input: CopyPathSchemaRevisionAsNewRevision;
};


export type MutationCopyPathSchemaFragmentRevisionAsNewRevisionArgs = {
  input: CopyPathSchemaFragmentRevisionAsNewRevision;
};


export type MutationExecutePathEditorNodeConfigCommandArgs = {
  input: ExecutePathEditorNodeConfigCommandInput;
};


export type MutationExecutePathEditorUndoArgs = {
  input: ExecutePathEditorUndoInput;
};


export type MutationExecutePathEditorRedoArgs = {
  input: ExecutePathEditorRedoInput;
};


export type MutationExecutePathEditorSetEdgeArgs = {
  input: ExecutePathEditorSetEdgeInput;
};


export type MutationExecutePathEditorRemoveEdgeArgs = {
  input: ExecutePathEditorRemoveEdgeInput;
};


export type MutationExecutePathEditorMoveNodeArgs = {
  input: ExecutePathEditorMoveNodeInput;
};


export type MutationExecutePathEditorRemoveNodeArgs = {
  input: ExecutePathEditorRemoveNodeInput;
};


export type MutationTogglePathEditorNodeExpansionArgs = {
  input: TogglePathEditorNodeExpansionInput;
};


export type MutationCreatePathGraphFlowArgs = {
  input: CreatePathGraphFlowInput;
};


export type MutationVisitPathGraphFlowArgs = {
  input: VisitPathGraphFlowInput;
};


export type MutationSubmitPathNodeFlowInputCommandsArgs = {
  input: SubmitPathNodeFlowInputCommandsInput;
};


export type MutationPlaceOrderForOfferArgs = {
  input: PlaceOrderForOfferInput;
};


export type MutationInitiatePaypalPaymentForOfferArgs = {
  input: InitiatePaypalPaymentForOfferInput;
};


export type MutationAddOperatorNoteArgs = {
  input: AddOperatorNoteInput;
};


export type MutationAddShipmentTrackingArgs = {
  input: ShipmentTrackingInput;
};


export type MutationAssignFulfillmentOperatorArgs = {
  input: AssignFulfillmentOperatorInput;
};


export type MutationClaimOrderLineItemArgs = {
  input: ClaimOrderLineItemInput;
};


export type MutationOrderLineItemUnavailableArgs = {
  input: OrderLineItemUnavailableInput;
};


export type MutationOrderLineItemReceivedArgs = {
  input: OrderLineItemReceivedInput;
};


export type MutationRemoveShipmentTrackingArgs = {
  input: RemoveShipmentTrackingInput;
};


export type MutationRemoveReturnShipmentTrackingArgs = {
  input: RemoveShipmentTrackingInput;
};


export type MutationUpdateShippingMethodArgs = {
  input: UpdateShippingMethodInput;
};


export type MutationUpdateOrderShippingAddressArgs = {
  input: UpdateOrderShippingAddressInput;
};


export type MutationUpdatePreClaimedOrderShippingAddressArgs = {
  input: UpdateOrderShippingAddressInput;
};


export type MutationCreatePaymentSourceArgs = {
  input: CreatePaymentSourceInput;
};


export type MutationSetupPaymentSourceArgs = {
  input: SetupPaymentSourceInput;
};


export type MutationUpdatePaymentSourceArgs = {
  input: UpdatePaymentSourceInput;
};


export type MutationDeletePaymentSourceArgs = {
  id: Scalars['PaymentSourceId'];
};


export type MutationPayForOrderArgs = {
  input: PayForOrderInput;
};


export type MutationAddTipToOrderArgs = {
  input: AddTipToOrderInput;
};


export type MutationUpdateGiftCardOrderLineItemArgs = {
  input: UpdateGiftCardOrderLineItemInput;
};


export type MutationRemoveTipFromOrderArgs = {
  input: RemoveTipFromOrderInput;
};


export type MutationSubmitOrderArgs = {
  input: SubmitOrderInput;
};


export type MutationCancelSubmittedOrderArgs = {
  input: CancelSubmittedOrderInput;
};


export type MutationInitiatePaypalPaymentForOrderArgs = {
  input: InitiatePaypalPaymentForOrderInput;
};


export type MutationInitiateAfterpayPaymentForOrderArgs = {
  input: InitiateAfterpayPaymentForOrderInput;
};


export type MutationInitiateAffirmPaymentForOrderArgs = {
  input: InitiateAffirmPaymentForOrderInput;
};


export type MutationMarkPaymentPreApprovalFailedForOrderArgs = {
  input: MarkPaymentPreApprovalFailedForOrderInput;
};


export type MutationMarkPaymentFailedForOrderArgs = {
  input: MarkPaymentFailedForOrderInput;
};


export type MutationCancelPaymentRequestForOrderArgs = {
  input: CancelPaymentRequestForOrderInput;
};


export type MutationSyncOrderArgs = {
  input: SyncOrderInput;
};


export type MutationAddItemsToOrderArgs = {
  input: AddItemsToOrderInput;
};


export type MutationRemoveItemsFromOrderArgs = {
  input: RemoveItemsFromOrderInput;
};


export type MutationUpdateQuantityForOrderArgs = {
  input: UpdateQuantityForOrderInput;
};


export type MutationAddPromotionToOrderArgs = {
  input?: Maybe<AddPromotionToOrderInput>;
};


export type MutationApplyStoreCreditToOrderArgs = {
  input?: Maybe<ApplyStoreCreditToOrderInput>;
};


export type MutationRemoveStoreCreditFromOrderArgs = {
  input?: Maybe<RemoveStoreCreditFromOrderInput>;
};


export type MutationDismissOrderMessagesArgs = {
  input: DismissOrderMessagesInput;
};


export type MutationGetOrCreateUserCartForExpertArgs = {
  input: GetOrCreateUserCartForExpertInput;
};


export type MutationCreatePromotionArgs = {
  input: CreateDraftPromotionInput;
};


export type MutationActivatePromotionArgs = {
  input?: Maybe<ActivatePromotionInput>;
};


export type MutationDisablePromotionArgs = {
  input: DisablePromotionInput;
};


export type MutationCopyPromotionArgs = {
  input: CopyPromotionInput;
};


export type MutationUpdatePromotionArgs = {
  input: UpdatePromotionInput;
};


export type MutationUpsertRuleIntoPromotionArgs = {
  input: UpsertRuleIntoPromotionInput;
};


export type MutationRemoveRuleFromPromotionArgs = {
  input: RemoveRuleFromPromotionInput;
};


export type MutationReorderRulesInPromotionArgs = {
  input: ReorderRulesInPromotionInput;
};


export type MutationUpsertActionIntoPromotionArgs = {
  input: UpsertActionIntoPromotionInput;
};


export type MutationRemoveActionFromPromotionArgs = {
  input: RemoveActionFromPromotionInput;
};


export type MutationReorderActionsInPromotionArgs = {
  input: ReorderActionsInPromotionInput;
};


export type MutationInitiateWireTransferPaymentForOrderArgs = {
  input: InitiateWireTransferPaymentForOrderInput;
};


export type MutationUpdateOrderStateArgs = {
  input: UpdateOrderStateInput;
};


export type MutationUpdateOrderExpertContributionsArgs = {
  input: UpdateOrderExpertContributionsInput;
};


export type MutationUnclaimOrderLineItemArgs = {
  input: OrderLineItemUnclaimInput;
};


export type MutationInitiateDealInventoryFulfillmentArgs = {
  input: InitiateDealInventoryFulfillmentInput;
};


export type MutationRequestItemReturnArgs = {
  input: OrderLineItemReturnRequestInput;
};


export type MutationSyncItemShippingStatusArgs = {
  input: SyncItemShippingStatusInput;
};


export type MutationVerifyPaymentTransactionArgs = {
  input: VerifyPaymentTransactionInput;
};


export type MutationUpdateShippingOptionsArgs = {
  input: UpdateShippingOptionsInput;
};


export type MutationCreateTagArgs = {
  input: CreateTagInput;
};


export type MutationRemoveTagArgs = {
  input: RemoveTagInput;
};


export type MutationUploadMerchantsArgs = {
  input: UploadMerchantsInput;
};


export type MutationUploadSellablesArgs = {
  input: UploadSellablesInput;
};


export type MutationUploadSellablePriceArgs = {
  input: UploadSellablePriceInput;
};


export type MutationUploadFeaturedSellableContentArgs = {
  input: UploadFeaturedSellableContentInput;
};


export type MutationUploadBrandsArgs = {
  input: UploadBrandsInput;
};


export type MutationUploadSellableUpdatesArgs = {
  input: UploadSellableUpdatesInput;
};


export type MutationUploadSellableDeactivationsArgs = {
  input: UploadSellableDeactivationsInput;
};


export type MutationUploadSellableInventoryArgs = {
  input: UploadSellableInventoryInput;
};


export type MutationUploadExpertDiscountCashArgs = {
  input: UploadExpertDiscountCashInput;
};


export type MutationUploadInvoicedShippingCostArgs = {
  input: UploadInvoicedShippingCostInput;
};


export type MutationCreateMerchantOfferArgs = {
  input: CreateOfferInput;
};


export type MutationCreateFreeFormOfferArgs = {
  input: CreateOfferInput;
};


export type MutationCreateOfferFromSellableArgs = {
  input: CreateOfferFromSellableInput;
};


export type MutationCreateOfferForSelfCheckoutArgs = {
  input: CreateOfferForSelfCheckoutInput;
};


export type MutationTotalCostForOfferArgs = {
  input: TotalCostForOfferInput;
};


export type MutationCreateOrderFromOfferArgs = {
  input: CreateOrderFromOfferInput;
};


export type MutationAddOfferToCartArgs = {
  input: AddOfferToCartInput;
};


export type MutationUploadMediaArgs = {
  input: UploadMediaInput;
  file?: Maybe<Scalars['Upload']>;
};


export type MutationCreateMediaArgs = {
  input: CreateMediaInput;
};


export type MutationPersistMediaArgs = {
  input: PersistMediaInput;
};


export type MutationCreateDraftExpertProfileArgs = {
  input: CreateDraftExpertProfileInput;
};


export type MutationCreateExpertProfileArgs = {
  input: CreateExpertProfileInput;
};


export type MutationSubmitExpertProfileArgs = {
  id: Scalars['ExpertProfileId'];
};


export type MutationApproveExpertProfileArgs = {
  id: Scalars['ExpertProfileId'];
};


export type MutationRequestChangesOnExpertProfileArgs = {
  input: ExpertProfileRequestChangesInput;
};


export type MutationUpdateExpertProfileArgs = {
  input: UpdateExpertProfileInput;
};


export type MutationStartExpertRatingArgs = {
  expertId: Scalars['BusinessUserId'];
};


export type MutationStartExpertRatingPathArgs = {
  input: StartExpertRatingInput;
};


export type MutationUpdateConsumerExpertReviewArgs = {
  input: UpdateConsumerExpertReviewInput;
};


export type MutationDeleteConsumerExpertReviewArgs = {
  id: Scalars['ConsumerExpertReviewId'];
};


export type MutationAddExpertProfileHighlightArgs = {
  input: AddProfileHighlightInput;
};


export type MutationRemoveExpertProfileHighlightArgs = {
  input: RemoveProfileHighlightInput;
};


export type MutationCreateBlankExpertApplicationArgs = {
  input: CreateBlankExpertApplicationInput;
};


export type MutationApproveExpertApplicationArgs = {
  input: ApproveExpertApplicationInput;
};


export type MutationRejectExpertApplicationArgs = {
  input: RejectExpertApplicationInput;
};


export type MutationRestoreExpertApplicationArgs = {
  input: RestoreExpertApplicationInput;
};


export type MutationSetExpertApplicationArchivedArgs = {
  input: SetExpertApplicationArchivedInput;
};


export type MutationSetExpertApplicationSnoozeArgs = {
  input: SetExpertApplicationSnoozeInput;
};


export type MutationCancelExpertApplicationSnoozeArgs = {
  input: CancelExpertApplicationSnoozeInput;
};


export type MutationRequestConsumerReviewByExpertArgs = {
  input: RequestConsumerExpertReviewInput;
};


export type MutationRequestReferralByExpertArgs = {
  input: RequestReferralByExpertInput;
};


export type MutationSendExpertReferralArgs = {
  input: SendExpertReferralInput;
};


export type MutationCreateExpertFromApplicationArgs = {
  input: CreateExpertFromApplicationInput;
};


export type MutationAddExpertApplicationReviewArgs = {
  input: AddExpertApplicationReviewInput;
};


export type MutationSubmitExpertHiringFeedbackArgs = {
  input: SubmitExpertHiringFeedbackInput;
};


export type MutationUpdateExpertApplicationTaskStatusArgs = {
  input: UpdateExpertApplicationTaskStatusInput;
};


export type MutationSetExpertApplicationTaskCompletedArgs = {
  input: SetExpertApplicationTaskCompletedInput;
};


export type MutationRerunExpertApplicationTaskArgs = {
  input: RerunExpertApplicationTaskInput;
};


export type MutationStartExpertApplicationConversationArgs = {
  applicationId: Scalars['ExpertApplicationId'];
};


export type MutationAddExpertApplicationNoteArgs = {
  input: AddExpertApplicationNoteInput;
};


export type MutationUpdateExpertApplicationTagsArgs = {
  input: UpdateExpertApplicationTagsInput;
};


export type MutationUpdateExpertApplicationArgs = {
  input: UpdateExpertApplicationInput;
};


export type MutationSaveSavedSellableArgs = {
  input: SaveSavedSellableInput;
};


export type MutationUnsaveSavedSellableArgs = {
  input: UnsaveSavedSellableInput;
};


export type MutationCreateSellableArgs = {
  input: CreateSellableInput;
};


export type MutationUpdateSellableArgs = {
  input: UpdateSellableInput;
};


export type MutationBulkUpdateSellableArgs = {
  input: BulkUpdateSellableInput;
};


export type MutationBulkSetSellableAttributeArgs = {
  input: BulkSetSellableAttributeInput;
};


export type MutationBulkSetSellableRawAttributeArgs = {
  input: BulkSetSellableRawAttributeInput;
};


export type MutationBulkRemoveSellableAttributeArgs = {
  input: BulkRemoveSellableAttributeInput;
};


export type MutationBulkRemoveSellableRawAttributeArgs = {
  input: BulkRemoveSellableRawAttributeInput;
};


export type MutationDeactivateSellableArgs = {
  input: DeactivateSellableInput;
};


export type MutationCreateSellableTermsArgs = {
  input: CreateSellableTermsInput;
};


export type MutationRequestSellableArgs = {
  input: RequestSellableInput;
};


export type MutationUpdateAdHocSellablePriceArgs = {
  input: UpdateAdHocSellablePriceInput;
};


export type MutationDeactivateSellablePriceSourceArgs = {
  input: DeactivateSellablePriceSourceInput;
};


export type MutationRefreshSellablePriceSourceArgs = {
  input: RefreshSellablePriceSourceInput;
};


export type MutationSaveConsumerSellableReactionArgs = {
  input: SaveConsumerSellableReactionInput;
};


export type MutationCreateSellableResearchLinkArgs = {
  input: CreateSellableResearchLinkInput;
};


export type MutationDeleteSellableResearchLinkArgs = {
  input: DeleteSellableResearchLinkInput;
};


export type MutationRequestSellablePriceMatchArgs = {
  input: RequestSellablePriceMatchInput;
};


export type MutationUpdateSellableCustomOfferRuleArgs = {
  input: UpdateSellableCustomOfferRuleInput;
};


export type MutationCreateSellableCustomOfferRuleArgs = {
  input: CreateSellableCustomOfferRuleInput;
};


export type MutationRejectSellableQuestionCandidateArgs = {
  input: RejectSellableQuestionCandidateInput;
};


export type MutationApproveSellableQuestionCandidateArgs = {
  input: ApproveSellableQuestionCandidateInput;
};


export type MutationUpdateSellableQuestionArgs = {
  input: UpdateSellableQuestionInput;
};


export type MutationStartExpertConsumerConversationArgs = {
  input: StartExpertConsumerConversationInput;
};


export type MutationSetLeadSnoozeArgs = {
  input: SetLeadSnoozeInput;
};


export type MutationCancelLeadSnoozeArgs = {
  input: CancelLeadSnoozeInput;
};


export type MutationSetLeadStarArgs = {
  input: SetLeadStarInput;
};


export type MutationMarkLeadAsSpamArgs = {
  input: MarkLeadAsSpamInput;
};


export type MutationSetLeadArchivedArgs = {
  input: SetLeadArchivedInput;
};


export type MutationSetLeadDoNotCallArgs = {
  input: SetLeadDoNotCallInput;
};


export type MutationDismissLeadSuggestedActionArgs = {
  input: DismissLeadSuggestedActionInput;
};


export type MutationDelegateLeadArgs = {
  input: DelegateLeadInput;
};


export type MutationReassignLeadArgs = {
  input: ReassignLeadInput;
};


export type MutationReplaceDeactivatedExpertArgs = {
  input: ReplaceDeactivatedExpertRequestInput;
};


export type MutationSetConsumerInitialLeadActionArgs = {
  input: SetConsumerInitialLeadActionInput;
};


export type MutationCreateQuickReplyWithLeadArgs = {
  input: CreateQuickReplyWithLeadInput;
};


export type MutationCreateQuickReplyWithoutLeadArgs = {
  input: CreateQuickReplyWithoutLeadInput;
};


export type MutationCreateQuickReplyArgs = {
  input: CreateQuickReplyInput;
};


export type MutationUpdateQuickReplyArgs = {
  input: UpdateQuickReplyInput;
};


export type MutationDeleteQuickReplyArgs = {
  id: Scalars['QuickReplyId'];
};


export type MutationCreateLeadNoteArgs = {
  input: CreateLeadNote;
};


export type MutationUpdateLeadNoteArgs = {
  input: UpdateLeadNoteInput;
};


export type MutationDeleteLeadNoteArgs = {
  id: Scalars['LeadNoteId'];
};


export type MutationAddUserInfoForLeadArgs = {
  input: AddUserInfoForLeadInput;
};


export type MutationAcceptLeadEscalationArgs = {
  input: AcceptEscalationInput;
};


export type MutationFindAndAcceptOpenLeadEscalationsArgs = {
  input: FindAndAcceptOpenLeadEscalationsInput;
};


export type MutationStartLeadEscalationArgs = {
  input: StartLeadEscalationInput;
};


export type MutationReportPredictedLifeTimeValueToPlatformArgs = {
  input: ReportPredictedLifeTimeValueInput;
};


export type MutationCreateLeadSurgeArgs = {
  input: CreateLeadSurgeInput;
};


export type MutationCreateLeadTrainingScenarioArgs = {
  input: CreateLeadTrainingScenarioInput;
};


export type MutationUpdateLeadTrainingScenarioArgs = {
  input: UpdateLeadTrainingScenarioInput;
};


export type MutationCreatePracticeLeadArgs = {
  input: CreatePracticeLeadInput;
};


export type MutationRemoveTicketNeedsAttentionArgs = {
  input?: Maybe<RemoveTicketNeedsAttentionInput>;
};


export type MutationSetLeadRpalExclusionOverrideArgs = {
  input: SetLeadRpalExclusionOverrideInput;
};


export type MutationRemoveLeadRpalExclusionOverrideArgs = {
  input: RemoveLeadRpalExclusionOverrideInput;
};


export type MutationCreateCampaignAudienceArgs = {
  input: CreateCampaignAudienceInput;
};


export type MutationUpdateCampaignAudienceArgs = {
  input: UpdateCampaignAudienceInput;
};


export type MutationAddCampaignAudienceIntegrationArgs = {
  input: AddCampaignAudienceIntegrationInput;
};


export type MutationUpdateCampaignAudienceIntegrationArgs = {
  input: UpdateCampaignAudienceIntegrationInput;
};


export type MutationRemoveCampaignAudienceIntegrationArgs = {
  input: RemoveCampaignAudienceIntegrationInput;
};


export type MutationPublishCampaignAudienceArgs = {
  input: PublishCampaignAudienceInput;
};


export type MutationArchiveCampaignAudienceArgs = {
  input: ArchiveCampaignAudienceInput;
};


export type MutationSyncCampaignAudienceArgs = {
  input: SyncCampaignAudienceInput;
};


export type MutationCreateCampaignArgs = {
  input: CreateCampaignInput;
};


export type MutationUpdateCampaignArgs = {
  input: UpdateCampaignInput;
};


export type MutationScheduleCampaignArgs = {
  input: ScheduleCampaignInput;
};


export type MutationCancelScheduledCampaignArgs = {
  id: Scalars['CampaignId'];
};


export type MutationCreateCampaignTriggerArgs = {
  id: Scalars['CampaignId'];
};


export type MutationActivateCampaignArgs = {
  id: Scalars['CampaignId'];
};


export type MutationDeactivateCampaignArgs = {
  id: Scalars['CampaignId'];
};


export type MutationCopyCampaignArgs = {
  id: Scalars['CampaignId'];
};


export type MutationTrackOnlineActivityArgs = {
  input: TrackOnlineActivityInput;
};


export type MutationCreateContentSelectionRuleArgs = {
  input: CreateContentSelectionRuleInput;
};


export type MutationUpdateContentSelectionRuleArgs = {
  input: UpdateContentSelectionRuleInput;
};


export type MutationCreateReportArgs = {
  input: CreateReportInput;
};


export type MutationUpdateReportArgs = {
  input: UpdateReportInput;
};


export type MutationAddReportScheduleArgs = {
  input: AddScheduleReportInput;
};


export type MutationRemoveReportScheduleArgs = {
  input: RemoveScheduleReportInput;
};


export type MutationAddExpertCuratedItemToCartArgs = {
  input: AddExpertCuratedItemToCartInput;
};


export type MutationCreateExpertCuratedItemArgs = {
  input: CreateExpertCuratedItemInput;
};


export type MutationCopyFromExpertCuratedItemsArgs = {
  input: CopyFromExpertCuratedItemsInput;
};


export type MutationUpdateExpertCuratedItemArgs = {
  input: UpdateExpertCuratedItemInput;
};


export type MutationUpdateExpertCuratedItemFulfillmentNotesArgs = {
  input: UpdateExpertCuratedItemFulfillmentNotesInput;
};


export type MutationRemoveExpertCuratedItemArgs = {
  input: RemoveExpertCuratedItemInput;
};


export type MutationMakeExpertCuratedItemDraftsActiveArgs = {
  input: MakeExpertCuratedItemDraftsActiveInput;
};


export type MutationCreateExpertCuratedOrderArgs = {
  input: CreateExpertCuratedOrderInput;
};


export type MutationUpdateExpertCuratedOrderVariationOptionsArgs = {
  input: UpdateExpertCuratedOrderVariationOptionsInput;
};


export type MutationUpsertItemsInExpertCuratedOrderArgs = {
  input: UpsertItemsInExpertCuratedOrderInput;
};


export type MutationRemoveItemsFromExpertCuratedOrderArgs = {
  input: RemoveItemsFromExpertCuratedOrderInput;
};


export type MutationActivateExpertCuratedOrderAsBookableArgs = {
  input: ActivateExpertCuratedOrderAsBookableInput;
};


export type MutationNotifyCustomerExpertCuratedOrderArgs = {
  input: NotifyCustomerExpertCuratedOrderInput;
};


export type MutationCustomerRequestExpertCuratedOrderArgs = {
  input: CustomerRequestExpertCuratedOrderInput;
};


export type MutationCloseExpertCuratedOrderArgs = {
  input: CloseExpertCuratedOrderInput;
};


export type MutationUpdateExpertCuratedOrderTermsArgs = {
  input: UpdateExpertCuratedOrderTermsInput;
};


export type MutationSelectExpertCuratedOrderVariationOptionArgs = {
  input: SelectExpertCuratedOrderVariationOptionInput;
};


export type MutationSelectExpertCuratedOrderItemsArgs = {
  input: SelectExpertCuratedOrderItemsInput;
};


export type MutationUpdateServiceLocationExpertCuratedOrderArgs = {
  input: UpdateServiceLocationExpertCuratedOrderInput;
};


export type MutationActivateExpertCuratedOrdersForLeadArgs = {
  input: ActivateExpertCuratedOrdersForLeadInput;
};


export type MutationFindOrCreateReplacementExpertCuratedOrderArgs = {
  input: FindOrCreateReplacementExpertCuratedOrderInput;
};


export type MutationCopyItemsFromExpertCuratedOrderArgs = {
  input: CopyItemsFromExpertCuratedOrderInput;
};


export type MutationUpsertExpertCuratedLeadItineraryArgs = {
  input: UpsertExpertCuratedLeadItineraryInput;
};


export type MutationDeleteExpertCuratedLeadItineraryArgs = {
  input: DeleteExpertCuratedLeadItineraryInput;
};


export type MutationCreateSavedExpertCuratedItemsArgs = {
  input: CreateSavedExpertCuratedItemsInput;
};


export type MutationUpdateSavedExpertCuratedItemsArgs = {
  input: UpdateSavedExpertCuratedItemsInput;
};


export type MutationDeleteSavedExpertCuratedItemsArgs = {
  id: Scalars['SavedExpertCuratedItemsId'];
};


export type MutationCreateExpertConsultationFeeOrderArgs = {
  input: CreateExpertConsultationFeeOrderInput;
};


export type MutationCreateCuratedGiftCardOrderArgs = {
  input: CreateCuratedGiftCardOrderInput;
};


export type MutationExtendExpertCuratedItemExpirationArgs = {
  input: ExtendExpertCuratedItemExpirationInput;
};


export type MutationSaveReviewForSuggestedAlternativeSellableArgs = {
  input: SaveReviewForSuggestedAlternativeSellableInput;
};


export type MutationUpdateSavedCurationCuratedItemArgs = {
  input: UpdateSavedCurationCuratedItemInput;
};


export type MutationUpdateNoteForSavedExpertCuratedItemArgs = {
  input: UpdateNoteForSavedExpertCuratedItemInput;
};


export type MutationRemoveCuratedItemFromSavedCurationArgs = {
  input: RemoveCuratedItemFromSavedCurationInput;
};


export type MutationAddCuratedItemToSavedCurationArgs = {
  input: AddCuratedItemToSavedCurationInput;
};


export type MutationPublishSavedExpertCuratedItemsArgs = {
  input: PublishSavedExpertCuratedItemsInput;
};


export type MutationResetSavedExpertCuratedItemsArgs = {
  input: ResetSavedExpertCuratedItemsInput;
};


export type MutationCreateExpertCuratedItemFromSavedExpertCuratedItemArgs = {
  input: CreateExpertCuratedItemFromSavedExpertCuratedItemInput;
};


export type MutationCopyFromSavedExpertCuratedItemsArgs = {
  input: CopyFromSavedExpertCuratedItemsInput;
};


export type MutationUpdateExpertCuratedItemNoteAttributesArgs = {
  input: UpdateExpertCuratedItemNoteAttributesInput;
};


export type MutationUpdateExpertCuratedItemNoteArgs = {
  input: UpdateExpertCuratedItemNoteInput;
};


export type MutationApproveExpertCuratedItemNoteArgs = {
  input: ApproveExpertCuratedItemNoteInput;
};


export type MutationRejectExpertCuratedItemNoteArgs = {
  input: RejectExpertCuratedItemNoteInput;
};


export type MutationArchiveExpertCuratedItemNoteArgs = {
  input: DeactivateExpertCuratedItemNoteInput;
};


export type MutationResetExpertCuratedItemNoteArgs = {
  input: ResetExpertCuratedItemNoteInput;
};


export type MutationSetExpertCuratedItemNoteFeaturedArgs = {
  input: SetExpertCuratedItemNoteFeaturedInput;
};


export type MutationPublishExpertCuratedItemNoteArgs = {
  input: PublishExpertCuratedItemNoteInput;
};


export type MutationCreateExpertCuratedItemNoteFromSellableArgs = {
  input: CreateExpertCuratedItemNoteFromSellableInput;
};


export type MutationCreateRecommendedListDefinitionArgs = {
  input: CreateRecommendedListDefinitionInput;
};


export type MutationUpdateRecommendedListDefinitionArgs = {
  input: UpdateRecommendedListDefinitionInput;
};


export type MutationDeleteRecommendedListDefinitionArgs = {
  id: Scalars['RecommendedListDefinitionId'];
};


export type MutationCreateTriggerArgs = {
  input: CreateTriggerInput;
};


export type MutationUpdateTriggerArgs = {
  input: UpdateTriggerInput;
};


export type MutationCreateTriggerNodeArgs = {
  input: CreateTriggerNodeInput;
};


export type MutationRemoveTriggerNodeArgs = {
  input: RemoveTriggerNodeInput;
};


export type MutationUpdateTriggerFilterArgs = {
  input: UpdateTriggerFilterInput;
};


export type MutationUpdateTriggerDelayArgs = {
  input: UpdateTriggerDelayInput;
};


export type MutationUpdateTriggerActionArgs = {
  input: UpdateTriggerActionInput;
};


export type MutationUpdateTriggerBranchArgs = {
  input: UpdateTriggerBranchInput;
};


export type MutationCreateTriggerJumpToArgs = {
  input: CreateTriggerJumpToInput;
};


export type MutationSwapTriggerBranchEdgesArgs = {
  input: SwapTriggerBranchEdgesInput;
};


export type MutationUpdateTriggerWaitArgs = {
  input: UpdateTriggerWaitInput;
};


export type MutationSwapTriggerWaitEdgesArgs = {
  input: SwapTriggerWaitEdgesInput;
};


export type MutationSplitTriggerWaitEdgesArgs = {
  input: SplitTriggerWaitEdgesInput;
};


export type MutationMergeTriggerWaitEdgesArgs = {
  input: MergeTriggerWaitEdgesInput;
};


export type MutationUpdateTriggerEdgeArgs = {
  input: UpdateTriggerEdgeInput;
};


export type MutationRemoveTriggerEdgeArgs = {
  input: RemoveTriggerEdgeInput;
};


export type MutationPublishTriggerArgs = {
  input: PublishTriggerInput;
};


export type MutationDeactivateTriggerArgs = {
  input: DeactivateTriggerInput;
};


export type MutationArchiveTriggerArgs = {
  input: ArchiveTriggerInput;
};


export type MutationNewTriggerVersionArgs = {
  input: NewTriggerVersionInput;
};


export type MutationResetDraftTriggerArgs = {
  input: ResetDraftTriggerInput;
};


export type MutationImportEntitiesArgs = {
  input: ImportEntitiesInput;
};


export type MutationTestTriggerExecutionArgs = {
  input: TestTriggerExecutionInput;
};


export type MutationShortenUrlArgs = {
  input?: Maybe<ShortenUrlInput>;
};


export type MutationCreateAdhocSellableFromEBayItemArgs = {
  input: CreateAdhocSellableFromEBayItemInput;
};


export type MutationIdentifyEBayItemAsSellableArgs = {
  input: IdentifyEBayItemAsSellableInput;
};


export type MutationUpdateConfigArgs = {
  input: UpdateConfigInput;
};


export type MutationResetConfigArgs = {
  input: ResetConfigInput;
};


export type MutationSyncExternalAdCampaignsArgs = {
  input: SyncExternalAdCampaignsInput;
};


export type MutationUpdateExternalAdCampaignArgs = {
  input: UpdateExternalAdCampaignInput;
};


export type MutationUpdateExternalAdGroupArgs = {
  input: UpdateExternalAdGroupInput;
};


export type MutationApplyExternalAdBudgetArgs = {
  input: ApplyExternalAdBudgetInput;
};


export type MutationStartSystemCuratedItemSurveyArgs = {
  id: Scalars['SystemCuratedItemSurveyId'];
};


export type MutationTerminateSystemCuratedItemSurveyArgs = {
  input: TerminateSystemCuratedItemSurveyInput;
};


export type MutationCreateFlightPlanArgs = {
  input: CreateFlightPlanInput;
};


export type MutationActivateFlightPlanArgs = {
  input: ActivateFlightPlanInput;
};


export type MutationCopyFlightPlanAsDraftArgs = {
  input: CopyFlightPlanAsDraftInput;
};


export type MutationUpsertLegsIntoFlightPlanArgs = {
  input: UpsertLegsIntoFlightPlanInput;
};


export type MutationRemoveLegsFromFlightPlanArgs = {
  input: RemoveLegsFromFlightPlanInput;
};


export type MutationAssignSupportTaskArgs = {
  input: AssignSupportTaskInput;
};


export type MutationCompleteSupportTaskNoActionNeededArgs = {
  input: CompleteSupportTaskNoActionNeededInput;
};


export type MutationCompleteSupportTaskSnoozeArgs = {
  input: CompleteSupportTaskSnoozeInput;
};


export type MutationCompleteLeadSupportTaskAssignLeadActionsArgs = {
  input: CompleteLeadSupportTaskAssignLeadActionsInput;
};


export type MutationCompleteLeadSupportTaskDelegateLeadArgs = {
  input: CompleteLeadSupportTaskDelegateLeadInput;
};


export type MutationCompleteLeadSupportTaskReassignLeadArgs = {
  input: CompleteLeadSupportTaskReassignLeadInput;
};


export type MutationCompleteLeadSupportTaskEscalateToTeamForDelegationArgs = {
  input: CompleteLeadSupportTaskEscalateToTeamForDelegationInput;
};


export type MutationCompleteLeadSupportTaskEscalateForReassignmentArgs = {
  input: CompleteLeadSupportTaskEscalateForReassignmentInput;
};


export type MutationCompleteLeadSupportTaskRequestOrderSupportArgs = {
  input: CompleteLeadSupportTaskRequestOrderSupportInput;
};


export type MutationCompleteLeadSupportTaskCheckForSpamArgs = {
  input: CompleteLeadSupportTaskCheckForSpamInput;
};


export type MutationAddSupportToLeadConversationArgs = {
  input: AddSupportToLeadConversationInput;
};


export type MutationRemoveSupportFromLeadConversationArgs = {
  input: RemoveSupportFromLeadConversationInput;
};


export type MutationCreateOrderEscalationArgs = {
  input: CreateOrderEscalationInput;
};


export type MutationAssignOrderEscalationArgs = {
  input: AssignEscalationInput;
};


export type MutationStartOrderEscalationArgs = {
  input: StartEscalationInput;
};


export type MutationCompleteOrderEscalationArgs = {
  input: CompleteEscalationInput;
};


export type MutationAddEscalationNoteArgs = {
  input: AddEscalationOperatorNoteInput;
};


export type MutationSetEscalationPriorityArgs = {
  input: SetEscalationPriorityInput;
};


export type MutationStartSupportConversationArgs = {
  input: StartSupportConversationInput;
};


export type MutationAddOrderEscalationLabelArgs = {
  input: AddEscalationLabelInput;
};


export type MutationRemoveOrderEscalationLabelArgs = {
  input: RemoveEscalationLabelInput;
};


export type MutationDismissSuggestedSupportActionArgs = {
  input: DismissSuggestedSupportActionInput;
};


export type MutationUpdateSellableInventoryItemArgs = {
  input: SellableInventoryItemUpdateInput;
};


export type MutationSyncShopifyInventoryItemArgs = {
  input: Scalars['SellableInventoryItemId'];
};


export type MutationCreatePayStructureArgs = {
  input: CreatePayStructureInput;
};


export type MutationCreatePayStructureRevisionArgs = {
  input: CreatePayStructureRevisionInput;
};


export type MutationUpdatePayStructureRevisionArgs = {
  input: UpdatePayStructureRevisionInput;
};


export type MutationActivatePayStructureRevisionArgs = {
  input: ActivatePayStructureRevisionInput;
};


export type MutationApprovePayoutArgs = {
  id: Scalars['PayoutId'];
};


export type MutationBulkResendPayoutsArgs = {
  ids: Array<Scalars['PayoutId']>;
};


export type MutationBulkApprovePayoutsArgs = {
  ids: Array<Scalars['PayoutId']>;
};


export type MutationResendPayoutArgs = {
  id: Scalars['PayoutId'];
};


export type MutationRecomputePayoutArgs = {
  id: Scalars['PayoutId'];
};


export type MutationCreatePayoutArgs = {
  input: CreatePayoutInput;
};


export type MutationAddManualAdjustmentPayLineItemsArgs = {
  input: AddManualAdjustmentPayLineItemsInput;
};


export type MutationCreateRawSellableSourceArgs = {
  input: CreateRawSellableSourceInput;
};


export type MutationUpdateRawSellableSourceArgs = {
  input: UpdateRawSellableSourceInput;
};


export type MutationCreateRawSellableStandardizationRuleArgs = {
  input: CreateRawSellableStandardizationRuleInput;
};


export type MutationUpdateRawSellableStandardizationRuleArgs = {
  input: UpdateRawSellableStandardizationRuleInput;
};


export type MutationMergeStandardizedSellableGroupArgs = {
  input: MergeStandardizedSellableGroupInput;
};


export type MutationStartStandardizedSellableGroupIngestionArgs = {
  input: StartStandardizedSellableGroupIngestionInput;
};


export type MutationStartRawSellableSourceIngestionArgs = {
  input: StartRawSellableSourceIngestionInput;
};


export type MutationAcceptStandardizedSellableGroupCandidateArgs = {
  input: AcceptStandardizedSellableGroupCandidateInput;
};


export type MutationRejectStandardizedSellableGroupCandidateArgs = {
  input: RejectStandardizedSellableGroupCandidateInput;
};


export type MutationStartRawSellableStandardizationArgs = {
  input: StartRawSellableStandardizationInput;
};


export type MutationStartStandardizationSellableMatchingArgs = {
  input: StartStandardizationSellableMatchingInput;
};


export type MutationImportRawSellableSourceArgs = {
  input: ImportRawSellableSourceInput;
};


export type MutationImportRawSellableStandardizationRuleArgs = {
  input: ImportRawSellableStandardizationRuleInput;
};


export type MutationImportRawSellableStandardizationRulesArgs = {
  input: ImportRawSellableStandardizationRulesInput;
};


export type MutationDryRunRawSellableStandardizationArgs = {
  input: DryRunRawSellableStandardizationInput;
};


export type MutationCreateSchedulingDemandForecastArgs = {
  input: CreateSchedulingDemandForecastInput;
};


export type MutationUpdateSchedulingDemandForecastArgs = {
  input: UpdateSchedulingDemandForecastInput;
};


export type MutationRemoveSchedulingDemandForecastArgs = {
  id: Scalars['SchedulingDemandForecastId'];
};


export type MutationCreateSchedulingUserAvailabilityArgs = {
  input: CreateSchedulingUserAvailabilityInput;
};


export type MutationRemoveSchedulingUserAvailabilityArgs = {
  id: Scalars['SchedulingUserAvailabilityId'];
};


export type MutationClaimShiftArgs = {
  input: UpdateShiftInput;
};


export type MutationCancelShiftArgs = {
  input: UpdateShiftInput;
};


export type MutationGiveUpShiftArgs = {
  input: GiveUpShiftRequestInput;
};


export type MutationTakeOverShiftArgs = {
  input: TakeOverShiftRequestInput;
};


export type MutationCancelShiftChangeRequestArgs = {
  input: CancelShiftChangeRequestInput;
};


export type MutationUpdateSchedulingUserProfileArgs = {
  input: UpdateSchedulingUserProfileInput;
};


export type MutationCopySchedulingDemandForecastToNextPeriodArgs = {
  input: CopySchedulingDemandForecastInput;
};


export type MutationOverwriteShiftSlotArgs = {
  input: OverwriteShiftSlotInput;
};


export type MutationRunShiftAssignmentsArgs = {
  input: RunShiftAssignmentsInput;
};


export type MutationDeleteProposedShiftsArgs = {
  input: DeleteProposedShiftsInput;
};


export type MutationAcceptProposedShiftsArgs = {
  input: AcceptProposedShiftsInput;
};


export type MutationNotifyAssignedShiftsArgs = {
  input: NotifyShiftsInput;
};


export type MutationNotifyAvailabilityOpenArgs = {
  input: NotifyShiftsInput;
};


export type MutationOpenAllShiftsAndNotifyArgs = {
  input: NotifyShiftsInput;
};


export type MutationUpdateSchedulingUserRolesArgs = {
  input: UpdateSchedulingUserRolesInput;
};


export type MutationUpdateSchedulingTypeArgs = {
  input: UpdateSchedulingTypeInput;
};


export type MutationAcceptSurgeShiftArgs = {
  input: AcceptSurgeShiftInput;
};


export type MutationSetShiftAbsenceExcusedArgs = {
  input: SetShiftAbsenceExcusedInput;
};


export type MutationConfirmShiftProbationsArgs = {
  input: ConfirmShiftProbationsInput;
};


export type MutationFindOrCreateChannelArgs = {
  input?: Maybe<CreateFulfillmentChannelInput>;
};


export type MutationUpdateFulfillmentInstructionsArgs = {
  input: UpdateFulfillmentInstructionsInput;
};


export type MutationClaimLineItemByChannelArgs = {
  input?: Maybe<MultiChannelFulfillmentRequestInput>;
};


export type MutationSkipFulfillmentChannelArgs = {
  input?: Maybe<SkipFulfillmentChannelInput>;
};


export type MutationSetFulfillmentChannelBlacklistedArgs = {
  input?: Maybe<UpdateFulfillmentChannelBlacklistInput>;
};


export type MutationUpdateFulfillmentChannelArgs = {
  input?: Maybe<UpdateFulfillmentChannelMetadataInput>;
};


export type MutationVerifyOrderArgs = {
  input?: Maybe<VerifyOrderInput>;
};


export type MutationRequestRefundArgs = {
  input?: Maybe<RequestOrderRefundInput>;
};


export type MutationRejectRefundRequestArgs = {
  input?: Maybe<OrderRefundRejectedInput>;
};


export type MutationSetRefundSucceededArgs = {
  input?: Maybe<OrderRefundSuccessInput>;
};


export type MutationSetRefundFailedArgs = {
  input?: Maybe<OrderRefundFailedInput>;
};


export type MutationAdjustRequestedRefundAmountArgs = {
  input?: Maybe<AdjustRequestedRefundAmountInput>;
};


export type MutationCancelOrderRefundArgs = {
  input?: Maybe<CancelOrderRefundInput>;
};


export type MutationAddOrderReturnShipmentTrackingArgs = {
  input?: Maybe<AddOrderReturnShipmentTrackingInput>;
};


export type MutationRemoveOrderReturnShipmentTrackingArgs = {
  input?: Maybe<RemoveOrderReturnShipmentTrackingInput>;
};


export type MutationSyncOrderReturnShipmentTrackingArgs = {
  input?: Maybe<SyncOrderReturnShipmentTrackingInput>;
};


export type MutationUpdateMerchantRefundArgs = {
  input?: Maybe<UpdateMerchantRefundInput>;
};


export type MutationUpdateProductReturnDestinationArgs = {
  input?: Maybe<UpdateProductReturnDestinationInput>;
};


export type MutationConfirmReturnLabelSentArgs = {
  input?: Maybe<ConfirmReturnShippingLabelSentInput>;
};


export type MutationCheckedOnReturnLabelFromMerchantArgs = {
  input?: Maybe<CheckedOnReturnLabelFromMerchantInput>;
};


export type MutationStartRefundProcessArgs = {
  input?: Maybe<StartRefundProcessInput>;
};


export type MutationUpdateLineItemClaimArgs = {
  input?: Maybe<UpdateLineItemClaimInput>;
};


export type MutationUpdateShipmentPricingModelArgs = {
  input?: Maybe<UpdateShipmentPricingModelInput>;
};


export type MutationCreateShipmentPricingModelArgs = {
  input?: Maybe<CreateShipmentPricingModelInput>;
};


export type MutationCreateGroupClaimTicketArgs = {
  input?: Maybe<CreateGroupClaimTicketRequestInput>;
};


export type MutationAssignTicketArgs = {
  input: AssignTicketInput;
};


export type MutationBulkAssignTicketsArgs = {
  input: BulkAssignTicketsInput;
};


export type MutationUnassignTicketArgs = {
  input: UnassignTicketInput;
};


export type MutationSetTicketDueDateArgs = {
  input: SetTicketDueDateInput;
};


export type MutationBulkSetTicketDueDateArgs = {
  input: BulkSetTicketDueDateInput;
};


export type MutationUpdateTicketDescriptionArgs = {
  input: UpdateDescriptionInput;
};


export type MutationAddCommentToTicketArgs = {
  input: AddCommentInput;
};


export type MutationAddCommentToTicketByExpertArgs = {
  input: AddCommentByExpertInput;
};


export type MutationBulkResolveTicketsArgs = {
  input: BulkResolveTicketsInput;
};


export type MutationCloseTicketArgs = {
  input: CloseTicketInput;
};


export type MutationSnoozeTicketArgs = {
  input: SnoozeTicketInput;
};


export type MutationTransferTicketToQueueArgs = {
  input: TransferTicketInput;
};


export type MutationMergeTicketsArgs = {
  input: MergeTicketInput;
};


export type MutationCreateTicketArgs = {
  input: CreateTicketInput;
};


export type MutationCreateTicketByExpertArgs = {
  input: CreateTicketByExpertInput;
};


export type MutationCloseAndOpenNewTicketArgs = {
  input: CloseAndOpenNewTicketInput;
};


export type MutationLogWorkForTicketArgs = {
  input: LogWorkOnTicketInput;
};


export type MutationClaimTicketArgs = {
  input: PickupTicketInput;
};


export type MutationReopenTicketArgs = {
  input: ReopenTicketInput;
};


export type MutationShareReferralCodeViaEmailArgs = {
  input: ReferralCodeShareInput;
};


export type MutationClaimSocialShareCreditArgs = {
  input: ClaimSocialShareCreditInput;
};


export type MutationClaimConsumerReferralArgs = {
  input: ClaimConsumerReferralUserSourceInput;
};


export type MutationClaimExpertReferralArgs = {
  input: ClaimExpertReferralUserSourceInput;
};


export type MutationCreateExperimentArgs = {
  input: CreateExperimentInput;
};


export type MutationUpdateExperimentArgs = {
  input: UpdateExperimentInput;
};


export type MutationArchiveExperimentArgs = {
  input: ArchiveExperimentInput;
};


export type MutationUnarchiveExperimentArgs = {
  input: UnarchiveExperimentInput;
};


export type MutationAddLeadSpecialCareTagArgs = {
  input: AddLeadSpecialCareTagInput;
};


export type MutationRemoveLeadSpecialCareTagArgs = {
  input: RemoveLeadSpecialCareTagInput;
};


export type MutationAddExpertSpecialCareTagArgs = {
  input: AddExpertSpecialCareTagInput;
};


export type MutationRemoveExpertSpecialCareTagArgs = {
  input: RemoveExpertSpecialCareTagInput;
};


export type MutationSendRichCardArgs = {
  input: SendRichCardInput;
};


export type MutationCreateNewDraftArticleArgs = {
  input: CreateNewDraftArticleInput;
};


export type MutationCreateNewDraftRevisionForArticleArgs = {
  input: CreateNewDraftRevisionForArticleInput;
};


export type MutationCopyArticleRevisionAsDraftArgs = {
  input: CopyArticleRevisionAsDraftInput;
};


export type MutationPublishArticleRevisionArgs = {
  input: PublishArticleRevisionInput;
};


export type MutationArchiveArticleArgs = {
  input: ArchiveArticleInput;
};


export type MutationUpdateArticleRevisionArgs = {
  input: UpdateDraftArticleRevisionInput;
};


export type MutationRemoveArticleRevisionAttributeArgs = {
  input: RemoveArticleRevisionAttributeInput;
};


export type MutationSetArticleRevisionAttributeArgs = {
  input: SetArticleRevisionAttributeInput;
};


export type MutationRemoveArticleRevisionTagArgs = {
  input: RemoveArticleRevisionTagInput;
};


export type MutationAddArticleRevisionTagArgs = {
  input: AddArticleRevisionTagInput;
};


export type MutationUpdateArticleRevisionContentBlockArgs = {
  input: UpdateArticleRevisionContentBlockInput;
};


export type MutationRemoveArticleRevisionContentBlockArgs = {
  input: RemoveArticleRevisionContentBlockInput;
};


export type MutationInsertArticleRevisionContentBlockArgs = {
  input: InsertArticleRevisionContentBlockInput;
};


export type MutationMoveArticleRevisionContentBlockArgs = {
  input: MoveArticleRevisionContentBlockInput;
};


export type MutationCreateSellableTopListArgs = {
  input: CreateSellableTopListInput;
};


export type MutationUpdateSellableTopListArgs = {
  input: UpdateSellableTopListInput;
};


export type MutationPublishSellableTopListArgs = {
  input: PublishSellableTopListInput;
};


export type MutationArchiveSellableTopListArgs = {
  input: ArchiveSellableTopListInput;
};


export type MutationPreviewSellableTopListArgs = {
  id: Scalars['SellableTopListDefinitionId'];
};


export type MutationCreateGiftCardOrderArgs = {
  input: CreateGiftCardOrderInput;
};


export type MutationRedeemGiftCardArgs = {
  input: RedeemGiftCardInput;
};


export type MutationResendGiftCardArgs = {
  id: Scalars['GiftCardId'];
};


export type MutationPublishProductCatalogRevisionsArgs = {
  input: PublishProductCatalogRevisionsInput;
};


export type MutationCreateDraftProductCatalogRevisionFromSellableArgs = {
  input: CreateDraftProductCatalogRevisionFromSellableInput;
};


export type MutationCreateDraftProductCatalogRevisionForCatalogArgs = {
  input: CreateDraftProductCatalogRevisionForCatalogInput;
};


export type MutationCopyProductCatalogRevisionAsDraftArgs = {
  input: CopyProductCatalogRevisionAsDraftInput;
};


export type MutationUpdateProductCatalogDraftArgs = {
  input: UpdateProductCatalogDraftInput;
};


export type MutationArchiveProductCatalogRevisionArgs = {
  input: ArchiveProductCatalogRevisionInput;
};


export type MutationSetProductCatalogAttributeArgs = {
  input: SetProductCatalogAttributeInput;
};


export type MutationSetProductCatalogRawAttributeArgs = {
  input: SetProductCatalogRawAttributeInput;
};


export type MutationRemoveProductCatalogAttributeArgs = {
  input: RemoveProductCatalogAttributeInput;
};


export type MutationReorderProductCatalogRawAttributesArgs = {
  input: ReorderProductCatalogRawAttributesInput;
};


export type MutationPublishProductCatalogFromSellablesArgs = {
  input: PublishProductCatalogFromSellablesInput;
};


export type MutationPublishProductCatalogGroupRevisionsArgs = {
  input: PublishProductCatalogGroupRevisionsInput;
};


export type MutationCreateDraftProductCatalogGroupRevisionFromSellableArgs = {
  input: CreateDraftProductCatalogGroupRevisionFromSellableInput;
};


export type MutationCreateDraftProductCatalogGroupRevisionForGroupArgs = {
  input: CreateDraftProductCatalogGroupRevisionForGroupInput;
};


export type MutationCopyProductCatalogGroupRevisionAsDraftArgs = {
  input: CopyProductCatalogGroupRevisionAsDraftInput;
};


export type MutationUpdateProductCatalogGroupDraftArgs = {
  input: UpdateProductCatalogGroupDraftInput;
};


export type MutationArchiveProductCatalogGroupRevisionArgs = {
  input: ArchiveProductCatalogGroupRevisionInput;
};


export type MutationSetProductCatalogGroupAttributeArgs = {
  input: SetProductCatalogGroupAttributeInput;
};


export type MutationSetProductCatalogGroupRawAttributeArgs = {
  input: SetProductCatalogGroupRawAttributeInput;
};


export type MutationRemoveProductCatalogGroupAttributeArgs = {
  input: RemoveProductCatalogGroupAttributeInput;
};


export type MutationReorderProductCatalogGroupRawAttributesArgs = {
  input: ReorderProductCatalogGroupRawAttributesInput;
};


export type MutationPublishProductCatalogGroupFromSellablesArgs = {
  input: PublishProductCatalogGroupFromSellablesInput;
};


export type MutationAssumePartnerUserIdentityArgs = {
  input: AssumePartnerUserIdentityInput;
};

export type Myself = {
  __typename: 'Myself';
  id: Scalars['AnyId'];
  user: User;
  operator?: Maybe<Operator>;
  businessUser?: Maybe<BusinessUser>;
  partnerUser?: Maybe<PartnerUser>;
  realUser: User;
  hasPassword: Scalars['Boolean'];
  /**
   * Fetching this property will insert data into the database. It is technically a mutation, but due to
   * the restriction of Apollo SSR (no mutation executed) and our requirement to do 301 redirect, we need to make
   * this a query
   */
  loginToken: Scalars['String'];
};

export type NavigatePathGraphFlowError = AlreadyCompletedNavigatePathGraphFlowError;

export type NewBookableCuratedOrderRichCard = MessageRichCard & {
  __typename: 'NewBookableCuratedOrderRichCard';
  type: MessageRichCardType;
  expertCuratedOrderId: Scalars['ExpertCuratedOrderId'];
};

export type NewCuratedItemsRichCard = MessageRichCard & {
  __typename: 'NewCuratedItemsRichCard';
  type: MessageRichCardType;
  expertCuratedItemActivationId: Scalars['ExpertCuratedItemActivationId'];
};

export type NewCuratedOrderListRichCard = MessageRichCard & {
  __typename: 'NewCuratedOrderListRichCard';
  type: MessageRichCardType;
  expertCuratedOrderListActivationId: Scalars['ExpertCuratedOrderListActivationId'];
};

export type NewCustomCuratedOrderRichCard = MessageRichCard & {
  __typename: 'NewCustomCuratedOrderRichCard';
  type: MessageRichCardType;
  expertCuratedOrderId: Scalars['ExpertCuratedOrderId'];
};

export type NewLinePathEditorRichTextContentPart = PathEditorRichTextContentPart & {
  __typename: 'NewLinePathEditorRichTextContentPart';
  partType: PathEditorRichTextContentPartType;
};

export type NewOrderEscalationNotification = {
  __typename: 'NewOrderEscalationNotification';
  newEscalationCount: Scalars['Long'];
};

export type NewTemplateFragmentVersionInput = {
  id: Scalars['CommTemplateFragmentId'];
  notes?: Maybe<Scalars['String']>;
};

export type NewTemplateVersionInput = {
  id: Scalars['CommTemplateId'];
};

export type NewTriggerVersionInput = {
  triggerId: Scalars['TriggerId'];
};

export type NewTriggerVersionPayload = {
  __typename: 'NewTriggerVersionPayload';
  trigger?: Maybe<Trigger>;
  error?: Maybe<Scalars['String']>;
};

export type NodeNotTraversedNavigatePathGraphFlowError = ErrorMessage & {
  __typename: 'NodeNotTraversedNavigatePathGraphFlowError';
  errorMessage: Scalars['String'];
};

export type NoExpertCuratedItemNoteToUpdateSavedExpertCuratedItemsEditExpertCuratedItemNoteError = ErrorMessage & {
  __typename: 'NoExpertCuratedItemNoteToUpdateSavedExpertCuratedItemsEditExpertCuratedItemNoteError';
  errorMessage: Scalars['String'];
  id: Scalars['SavedExpertCuratedItemsId'];
  itemId: Scalars['SellableId'];
};

export type NoProductIdentifierProductCatalogDraftFromSellableError = ErrorMessage & {
  __typename: 'NoProductIdentifierProductCatalogDraftFromSellableError';
  errorMessage: Scalars['String'];
};

export type NoPublishedVariantParentProductCatalogPublishError = ErrorMessage & {
  __typename: 'NoPublishedVariantParentProductCatalogPublishError';
  errorMessage: Scalars['String'];
  revisions: Array<ProductCatalogRevision>;
};

export type NoReturnsAcceptedReturnPolicy = ReturnPolicy & {
  __typename: 'NoReturnsAcceptedReturnPolicy';
  type: ReturnPolicyType;
};

export type NormalizedContact = {
  __typename: 'NormalizedContact';
  type: ContactType;
  value: Scalars['String'];
};

export type NoSuchDependencyApprovalRequestSubmitDraftEditError = ErrorMessage & {
  __typename: 'NoSuchDependencyApprovalRequestSubmitDraftEditError';
  errorMessage: Scalars['String'];
};

export type NoSuchPathSchemaCreatePathGraphFlowError = ErrorMessage & {
  __typename: 'NoSuchPathSchemaCreatePathGraphFlowError';
  errorMessage: Scalars['String'];
};

export type NotApprovedApprovalRequestPublishError = ApprovalRequestPublishError & ErrorMessage & {
  __typename: 'NotApprovedApprovalRequestPublishError';
  errorMessage: Scalars['String'];
  breadcrumbTrail: Array<ApprovalRequest>;
  approvalRequest: ApprovalRequest;
};

export type NotDraftProductCatalogGroupUpdateError = ErrorMessage & {
  __typename: 'NotDraftProductCatalogGroupUpdateError';
  errorMessage: Scalars['String'];
};

export type NotDraftProductCatalogUpdateError = ErrorMessage & {
  __typename: 'NotDraftProductCatalogUpdateError';
  errorMessage: Scalars['String'];
};

export type NoteApprovalChangeByUnion = Operator | BusinessUser | SystemUser;

export type NoteEditErrorExpertCuratedItemEditError = ErrorMessage & {
  __typename: 'NoteEditErrorExpertCuratedItemEditError';
  errorMessage: Scalars['String'];
  noteEditError: ExpertCuratedItemNoteEditError;
};

export type NoteEditErrorSavedExpertCuratedItemsEditExpertCuratedItemNoteError = ErrorMessage & {
  __typename: 'NoteEditErrorSavedExpertCuratedItemsEditExpertCuratedItemNoteError';
  errorMessage: Scalars['String'];
  id: Scalars['SavedExpertCuratedItemsId'];
  itemId: Scalars['SellableId'];
  noteEditError: ExpertCuratedItemNoteEditError;
};

export type NotEligibleStateApprovableEntityDependencyResolutionError = ErrorMessage & {
  __typename: 'NotEligibleStateApprovableEntityDependencyResolutionError';
  errorMessage: Scalars['String'];
  state?: Maybe<ApprovableEntityState>;
};

export type NotFoundApprovableEntityDependencyResolutionError = ErrorMessage & {
  __typename: 'NotFoundApprovableEntityDependencyResolutionError';
  errorMessage: Scalars['String'];
};

export type NotFullyAppliedSellableEditError = ErrorMessage & {
  __typename: 'NotFullyAppliedSellableEditError';
  errorMessage: Scalars['String'];
};

export type NotificationSetting = {
  __typename: 'NotificationSetting';
  emailEnabled: Scalars['Boolean'];
  smsEnabled: Scalars['Boolean'];
  type: NotificationType;
};

export type NotificationSettingInput = {
  emailEnabled: Scalars['Boolean'];
  smsEnabled: Scalars['Boolean'];
  type: NotificationType;
};

export enum NotificationType {
  TRANSACTIONAL = 'TRANSACTIONAL',
  GENERAL = 'GENERAL',
  DIRECT_MESSAGE = 'DIRECT_MESSAGE',
  CURATION = 'CURATION',
  OFFERS = 'OFFERS',
  ARTICLES_AND_VIDEOS = 'ARTICLES_AND_VIDEOS',
  EXPERT_ONBOARDING = 'EXPERT_ONBOARDING',
  EXPERT_DEACTIVATION = 'EXPERT_DEACTIVATION',
  SURGE_SHIFTS = 'SURGE_SHIFTS'
}

export type NotifyCustomerExpertCuratedOrderInput = {
  id: Scalars['ExpertCuratedOrderId'];
};

export type NotifyCustomerExpertCuratedOrderPayload = {
  __typename: 'NotifyCustomerExpertCuratedOrderPayload';
  expertCuratedOrder: ExpertCuratedOrder;
};

export type NotifyShiftsInput = {
  sourceRangeStart: Scalars['Date'];
  sourceRangeEnd: Scalars['Date'];
  schedulingDepartmentId: Scalars['SchedulingDepartmentId'];
};

export type NotifyShiftsPayload = {
  __typename: 'NotifyShiftsPayload';
  success: Scalars['Boolean'];
};

export type NotLatestRevisionProductCatalogArchiveRevisionError = ErrorMessage & {
  __typename: 'NotLatestRevisionProductCatalogArchiveRevisionError';
  latestRevision: ProductCatalogRevision;
  errorMessage: Scalars['String'];
};

export type NotLatestRevisionProductCatalogGroupArchiveRevisionError = ErrorMessage & {
  __typename: 'NotLatestRevisionProductCatalogGroupArchiveRevisionError';
  latestRevision: ProductCatalogGroupRevision;
  errorMessage: Scalars['String'];
};

/** ====== NumericPathFlowQuestion */
export type NumericPathFlowQuestion = PathFlowQuestion & {
  __typename: 'NumericPathFlowQuestion';
  internalName: Scalars['String'];
  questionText?: Maybe<TextViewModel>;
  questionSubText?: Maybe<TextViewModel>;
  required: Scalars['Boolean'];
  inputIconImage?: Maybe<ImageViewModel>;
  inputLabel?: Maybe<TextViewModel>;
  attributes: Array<Attribute>;
  attribute?: Maybe<Attribute>;
  valueType: NumericPathFlowQuestionValueType;
  displayType?: Maybe<NumericPathFlowQuestionDisplayType>;
  placeholder?: Maybe<Scalars['String']>;
  /** If reloading a question answered by the user, this is their previous input */
  numericUserInput: SubmitNumericPathFlowQuestionInputTypeCopy;
  unitLabel?: Maybe<Scalars['String']>;
  unit?: Maybe<NumericPathFlowQuestionUnitType>;
};


/** ====== NumericPathFlowQuestion */
export type NumericPathFlowQuestionAttributeArgs = {
  attributeName?: Maybe<Scalars['String']>;
};

export enum NumericPathFlowQuestionDisplayType {
  HEIGHT_IN_INCHES = 'HEIGHT_IN_INCHES',
  STAR_RATING = 'STAR_RATING'
}

export enum NumericPathFlowQuestionUnitType {
  INCHES = 'INCHES',
  FEET = 'FEET',
  POUNDS = 'POUNDS',
  CENTIMETERS = 'CENTIMETERS',
  KILOGRAMS = 'KILOGRAMS',
  DOLLARS = 'DOLLARS'
}

export enum NumericPathFlowQuestionValueType {
  INTEGER = 'INTEGER',
  DECIMAL = 'DECIMAL'
}

export type NumericPathQuestionSchema = PathQuestionSchema & {
  __typename: 'NumericPathQuestionSchema';
  id: Scalars['PathQuestionSchemaId'];
  schemaType: PathQuestionSchemaType;
  commonFields: PathCommonQuestionSchemaFields;
  /** must be integer or big decimal */
  attributeSchemaName?: Maybe<Scalars['String']>;
  attributeSchemaRevision?: Maybe<AttributeSchemaRevision>;
  numericRenderingStyle: NumericPathQuestionSchemaRenderingStyle;
};

/** Configurable generic numeric entry UI */
export type NumericPathQuestionSchemaGenericRenderingStyle = {
  __typename: 'NumericPathQuestionSchemaGenericRenderingStyle';
  unit?: Maybe<PathTemplateText>;
  /** What side of the input the unit should render on. For example, this would be left for dollars, but right for lbs. */
  unitPlacement: NumericPathQuestionSchemaGenericRenderingStyleUnitPlacement;
  placeholder?: Maybe<PathTemplateText>;
  /**
   * For integer attributes that represent decimal values (e.g.: currency in cents), this scale should be used to
   * compute the decimal value from integer. The formula `(value x 10 ^ (-scale))` is used to compute the decimal value.
   * For example, a scale of "2" will allow the user to enter "123.46", but store it internally as "12346".
   */
  integerAsDecimalScale?: Maybe<Scalars['Int']>;
};

export enum NumericPathQuestionSchemaGenericRenderingStyleUnitPlacement {
  LEFT = 'LEFT',
  RIGHT = 'RIGHT'
}

/** Specifically accepting inches input, rendered as "feet" and "inches" dynamically by the UI */
export type NumericPathQuestionSchemaLengthInInchesRenderingStyle = {
  __typename: 'NumericPathQuestionSchemaLengthInInchesRenderingStyle';
  /** Filler property since types can't be empty */
  lengthInInches: Scalars['Boolean'];
};

export type NumericPathQuestionSchemaRenderingStyle = NumericPathQuestionSchemaGenericRenderingStyle | NumericPathQuestionSchemaLengthInInchesRenderingStyle | NumericPathQuestionSchemaStarRatingRenderingStyle;

/** Star rating UI */
export type NumericPathQuestionSchemaStarRatingRenderingStyle = {
  __typename: 'NumericPathQuestionSchemaStarRatingRenderingStyle';
  maxRating: Scalars['Int'];
};

export type NumericPathQuestionSchemaUpsertEditorCommandInput = {
  id?: Maybe<Scalars['PathQuestionSchemaId']>;
  attributeSchemaName?: Maybe<Scalars['String']>;
  renderingStyle?: Maybe<NumericRenderingStylePathQuestionSchemaUpsertEditorCommandInput>;
};

export type NumericQuestionPathNodeFlowInputCommandInput = {
  questionId: Scalars['PathQuestionSchemaId'];
  value?: Maybe<Scalars['BigDecimal']>;
};

export type NumericQuestionPathNodeFlowViewModel = QuestionPathNodeFlowViewModel & {
  __typename: 'NumericQuestionPathNodeFlowViewModel';
  id: Scalars['PathQuestionSchemaId'];
  schemaType: PathQuestionSchemaType;
  commonFields: CommonFieldsQuestionPathNodeFlowViewModel;
  numericValue?: Maybe<Scalars['BigDecimal']>;
  numericRenderingStyle: NumericRenderingStylePathQuestionPathNodeFlowViewModel;
  numericValidations: Array<NumericValidationQuestionPathNodeFlowViewModel>;
};

/** Display facet for a min/max range */
export type NumericRangeDisplayFacet = DisplayFacet & {
  __typename: 'NumericRangeDisplayFacet';
  /** Name to display in the UI for this facet */
  displayName: Scalars['String'];
  /** Internal name that should be provided back to FacetSelection.name when selecting facet values */
  name: Scalars['String'];
  /**
   * Alias for this facet if one exist. Aliases provide a semi user friendly name that can be used
   * in the urls for example.
   */
  alias?: Maybe<Scalars['String']>;
  /** Type of numeric facet; currently used to change rendering styles */
  type: NumericRangeDisplayFacetType;
  /** unscaled lower bound */
  lower: Scalars['Long'];
  /** unscaled upper bound */
  upper: Scalars['Long'];
  /**
   * if `upper` is capped (there are values beyond upper, but the result is truncated for ease of use, and querying for
   * the capped upper value will give all values beyond it)
   */
  upperCapped: Scalars['Boolean'];
  /** The scale `lower` and `upper` is in; `(value x 10 ^ (-scale))` should be used to compute the actual value. */
  scale: Scalars['Int'];
  /** Computed decimal value of `lower` at `scale` */
  decimalLower: Scalars['BigDecimal'];
  /** Computed decimal value of `upper` at `scale` */
  decimalUpper: Scalars['BigDecimal'];
};

export enum NumericRangeDisplayFacetType {
  /** Render the number as is */
  DEFAULT = 'DEFAULT',
  /** Render the number (represented in cents) as USD currency */
  USD_CURRENCY = 'USD_CURRENCY'
}

export type NumericRenderingStylePathQuestionPathNodeFlowViewModel = GenericNumericRenderingStylePathQuestionPathNodeFlowViewModel | LengthInInchesNumericRenderingStylePathQuestionPathNodeFlowViewModel | StarRatingNumericRenderingStylePathQuestionPathNodeFlowViewModel;

/** Specify exactly one */
export type NumericRenderingStylePathQuestionSchemaUpsertEditorCommandInput = {
  generic?: Maybe<GenericNumericRenderingStylePathQuestionSchemaUpsertEditorCommandInput>;
  lengthInInches?: Maybe<LengthInInchesNumericRenderingStylePathQuestionSchemaUpsertEditorCommandInput>;
  starRating?: Maybe<StarRatingNumericRenderingStylePathQuestionSchemaUpsertEditorCommandInput>;
};

export type NumericValidationQuestionPathNodeFlowViewModel = InRangeNumericValidationQuestionPathNodeFlowViewModel;

/** ====== OAuthEmailPathFlowQuestion */
export type OAuthEmailPathFlowQuestion = PathFlowQuestion & {
  __typename: 'OAuthEmailPathFlowQuestion';
  internalName: Scalars['String'];
  questionText?: Maybe<TextViewModel>;
  questionSubText?: Maybe<TextViewModel>;
  required: Scalars['Boolean'];
  inputIconImage?: Maybe<ImageViewModel>;
  inputLabel?: Maybe<TextViewModel>;
  attributes: Array<Attribute>;
  attribute?: Maybe<Attribute>;
  firstName?: Maybe<EmbeddedInputTextPathFlowQuestion>;
  lastName?: Maybe<EmbeddedInputTextPathFlowQuestion>;
  email?: Maybe<EmbeddedInputTextPathFlowQuestion>;
  googleIdToken?: Maybe<EmbeddedInputTextPathFlowQuestion>;
  facebookUserAccessToken?: Maybe<EmbeddedInputTextPathFlowQuestion>;
  skipFirstName?: Maybe<EmbeddedInputTextPathFlowQuestion>;
  skipLastName?: Maybe<EmbeddedInputTextPathFlowQuestion>;
  /** If reloading a question answered by the user, this is their previous input */
  oAuthEmailUserInput: SubmitOAuthEmailPathFlowQuestionInputTypeCopy;
};


/** ====== OAuthEmailPathFlowQuestion */
export type OAuthEmailPathFlowQuestionAttributeArgs = {
  attributeName?: Maybe<Scalars['String']>;
};

export type OAuthTokenNotMappedAttributeValidatorReference = AttributeValidatorReference & {
  __typename: 'OAuthTokenNotMappedAttributeValidatorReference';
  id: Scalars['AttributeValidatorReferenceId'];
  type: AttributeValidatorType;
  oauthType: OAuthType;
};

export type OAuthTokenNotMappedAttributeValidatorReferenceInput = {
  oauthType: OAuthType;
};

export enum OAuthType {
  FACEBOOK = 'FACEBOOK',
  GOOGLE = 'GOOGLE',
  APPLE = 'APPLE'
}

export type OfferAddOn = {
  __typename: 'OfferAddOn';
  title: Scalars['String'];
  retailPrice: Money;
};

export type OfferAddOnInput = {
  title: Scalars['String'];
  retailPrice: Scalars['Float'];
};

export enum OfferState {
  INITIAL = 'INITIAL',
  GENERATED = 'GENERATED',
  ACCEPTED = 'ACCEPTED',
  EXPIRED = 'EXPIRED',
  WITHDRAWN = 'WITHDRAWN'
}

export type OfferTerms = ProductOfferTerms | ServiceOfferTerms;

export type OnboardingSpecialistUser = {
  __typename: 'OnboardingSpecialistUser';
  id: Scalars['AnyId'];
  displayName: Scalars['String'];
};

export type OpenGraphData = {
  __typename: 'OpenGraphData';
  url: Scalars['String'];
  properties: Array<OpenGraphProperty>;
};

export type OpenGraphProperty = {
  __typename: 'OpenGraphProperty';
  name: Scalars['String'];
  value: Scalars['String'];
};

export type OpenLeadEscalationCountChange = {
  __typename: 'OpenLeadEscalationCountChange';
  count: Scalars['Int'];
};

export type Operator = {
  __typename: 'Operator';
  id: Scalars['AnyId'];
  user: User;
  firstName: Scalars['String'];
  lastName: Scalars['String'];
  phoneNumber?: Maybe<Scalars['String']>;
  email?: Maybe<Scalars['String']>;
  active: Scalars['Boolean'];
  isAdmin: Scalars['Boolean'];
  permissions: Array<OperatorPermission>;
  roles: Array<OperatorRole>;
  messagingUser: MessagingUser;
  onboardingSpecialistMessagingUserId: Scalars['AnyId'];
  supportMessagingUserId: Scalars['AnyId'];
  shiftPresence?: Maybe<OperatorShiftPresence>;
};

export type OperatorAssignedActivity = OrderActivityDetail & {
  __typename: 'OperatorAssignedActivity';
  type: OrderActivityDetailType;
  assigned: Operator;
};

export type OperatorEndShiftInput = {
  shiftType: OperatorShiftType;
};


/**
 * =============
 * Ops UI permission
 * =============
 */
export enum OperatorPermission {
  UI_OPS_MANAGE_CATALOG = 'UI_OPS_MANAGE_CATALOG',
  UI_OPS_MANAGE_LEADS = 'UI_OPS_MANAGE_LEADS',
  UI_OPS_MANAGE_CONSUMERS = 'UI_OPS_MANAGE_CONSUMERS',
  UI_OPS_MANAGE_MERCHANTS = 'UI_OPS_MANAGE_MERCHANTS',
  UI_OPS_MANAGE_EXPERTS = 'UI_OPS_MANAGE_EXPERTS',
  UI_OPS_DEVTOOLS = 'UI_OPS_DEVTOOLS',
  UI_OPS_MANAGE_ALL_ORDERS = 'UI_OPS_MANAGE_ALL_ORDERS',
  UI_OPS_MANAGE_PAYROLL = 'UI_OPS_MANAGE_PAYROLL',
  UI_OPS_MANAGE_ASSIGNED_ORDERS = 'UI_OPS_MANAGE_ASSIGNED_ORDERS',
  UI_OPS_RESEARCH_ORDER_FULFILLMENT = 'UI_OPS_RESEARCH_ORDER_FULFILLMENT',
  UI_OPS_FULFILL_ORDERS = 'UI_OPS_FULFILL_ORDERS',
  UI_OPS_TEST_TRIGGER = 'UI_OPS_TEST_TRIGGER',
  UI_OPS_ASSISTANT = 'UI_OPS_ASSISTANT',
  UI_OPS_MANAGE_ORDERS_ASSIGNED_TO_SELF = 'UI_OPS_MANAGE_ORDERS_ASSIGNED_TO_SELF',
  UI_OPS_ORDER_SUPPORT_EXPERIMENT = 'UI_OPS_ORDER_SUPPORT_EXPERIMENT',
  UI_OPS_FULFILLMENT_TIER1_QUEUE = 'UI_OPS_FULFILLMENT_TIER1_QUEUE',
  UI_OPS_FULFILLMENT_TIER2_QUEUE = 'UI_OPS_FULFILLMENT_TIER2_QUEUE',
  UI_OPS_SUPPORT_TIER1_QUEUE = 'UI_OPS_SUPPORT_TIER1_QUEUE',
  UI_OPS_SUPPORT_TIER2_QUEUE = 'UI_OPS_SUPPORT_TIER2_QUEUE'
}

export type OperatorQuery = {
  userIds?: Maybe<Array<Scalars['UserId']>>;
  includeInactive?: Maybe<Scalars['Boolean']>;
  name?: Maybe<Scalars['String']>;
};

export enum OperatorRole {
  CATALOG_MANAGER = 'CATALOG_MANAGER',
  ONBOARDING_SPECIALIST = 'ONBOARDING_SPECIALIST',
  LEAD_SUPPORT = 'LEAD_SUPPORT',
  ORDER_SUPPORT = 'ORDER_SUPPORT',
  SUPER_ADMIN = 'SUPER_ADMIN',
  ADMIN = 'ADMIN',
  FULFILLMENT_AGENT = 'FULFILLMENT_AGENT',
  PAYROLL_MANAGER = 'PAYROLL_MANAGER',
  CONTENT_MARKETING_MANAGER = 'CONTENT_MARKETING_MANAGER',
  ORDER_SUPPORT_LEAD = 'ORDER_SUPPORT_LEAD',
  ORDER_PAYMENT_MANAGER = 'ORDER_PAYMENT_MANAGER',
  ORDER_SUPPORT_EXPERIMENT = 'ORDER_SUPPORT_EXPERIMENT',
  FULFILLMENT_TIER_ONE = 'FULFILLMENT_TIER_ONE',
  FULFILLMENT_TIER_TWO = 'FULFILLMENT_TIER_TWO',
  SUPPORT_TIER_ONE = 'SUPPORT_TIER_ONE',
  SUPPORT_TIER_TWO = 'SUPPORT_TIER_TWO',
  ORDER_VERIFICATION = 'ORDER_VERIFICATION',
  TRACKING_UPDATE = 'TRACKING_UPDATE',
  LINE_ITEM_CLAIM = 'LINE_ITEM_CLAIM',
  SHIPMENT_PRICING_MANAGER = 'SHIPMENT_PRICING_MANAGER'
}

export type OperatorShiftPresence = {
  __typename: 'OperatorShiftPresence';
  startsAt: Scalars['Date'];
  endsAt: Scalars['Date'];
};

export enum OperatorShiftType {
  AGENT = 'AGENT'
}

export type OperatorShiftUpdatePayload = {
  __typename: 'OperatorShiftUpdatePayload';
  operator?: Maybe<Operator>;
  hasError?: Maybe<Scalars['Boolean']>;
  errorMessage?: Maybe<Scalars['String']>;
};

export type OperatorStartShiftInput = {
  shiftType: OperatorShiftType;
};

export type Order = {
  __typename: 'Order';
  id: Scalars['OrderId'];
  createdAt: Scalars['Date'];
  updatedAt: Scalars['Date'];
  paidAt?: Maybe<Scalars['Date']>;
  version: Scalars['Int'];
  /** used for trigger entity.  only need userId, not the user object */
  userId: Scalars['UserId'];
  user: User;
  state: OrderState;
  description: Scalars['String'];
  /**
   * all non tax, shipment, and tip costs
   * @deprecated Use more descriptive `totalCost*` APIs
   */
  price: MonetaryAmount;
  tax: MonetaryAmount;
  discount: MonetaryAmount;
  /** @deprecated Shipping Cost is now represented as OrderLineItem(s) */
  shippingCost: MonetaryAmount;
  /** amount of tip for the expert, if applicable */
  tip?: Maybe<MonetaryAmount>;
  /** total cost including all line items and adjustments; reflects what the customer should be charged */
  totalCost: MonetaryAmount;
  /** total cost, excluding tax */
  totalCostBeforeTax: MonetaryAmount;
  shippingAddress?: Maybe<Address>;
  shipmentTrackings?: Maybe<Array<ShipmentTracking>>;
  /** De-normalized shipping method for the order, derived from the line items */
  shippingMethod?: Maybe<ShippingMethod>;
  /**
   * Rough estimate of when the entire order will be delivered to the customer; takes `shippingMethod` and `paidAt` into
   * account
   */
  estimatedToArriveAt?: Maybe<Scalars['Date']>;
  internalNotes?: Maybe<Scalars['String']>;
  attachments: Array<MediaFile>;
  transactions?: Maybe<Array<Transaction>>;
  transaction: Transaction;
  offer?: Maybe<BroadcastOffer>;
  title: Scalars['String'];
  /**
   * topLevelOnly: if true, will only return line items where parent is null.  All line items under a parent
   * will be exluded.  default is false.
   */
  lineItems: Array<OrderLineItem>;
  /** Messages associated with this order line item */
  messages: Array<OrderMessage>;
  fulfillmentState: OrderFulfillmentState;
  /**
   * If the order can be charged. For `OrderChargeableUseCase.CHECKOUT`, it checks if it's safe to proceed to checkout.
   * For OrderChargeableUseCase.PURCHASE`, it checks if `payForOrder` is safe to invoke. Everything except for
   * `OrderChargeableStatus.CAN_CHARGE` is an error state.
   */
  chargeableStatus: OrderChargeableStatus;
  /**
   * If the order requires a shipping address
   * Note that this flag simply indicates if the order contains things which are shipped. If a shipping address is
   * required and one is provided, this will continue to be `true`.
   */
  requiresShippingAddress: Scalars['Boolean'];
  /**
   * If this order has a limited lifespan, and must be purchased before this time. If this time elapses, it will be
   * reflected in the `chargeableStatus` property as `EXPIRED`
   */
  expiresAt?: Maybe<Scalars['Date']>;
  expertCuratedOrder?: Maybe<ExpertCuratedOrder>;
  /** If this order was curated by an expert, the expert that curated it */
  curatedBy?: Maybe<BusinessUser>;
  /** If this order was curated by an expert, the lead this order was curated for */
  lead?: Maybe<Lead>;
  /** Amount of items being ordered; should be used to display badge counts for how many items the order/cart contains. */
  itemsCount: Scalars['Int'];
  /**
   * Sum of all costs that map to these cost components
   * `TAX_ADJUSTMENTS` and `DISCOUNT_ADJUSTMENTS` only include tax and discounts for other included cost components. For
   * example, if `[SHIPMENT, TAX_ADJUSTMENTS]` are provided, the total cost will be the shipment, plus the tax **ONLY**
   * for the shipment - not the `CORE` (sellables, etc). The same holds true for `CostComponent#DISCOUNT_ADJUSTMENTS`.
   * This also means that if only `TAX_ADJUSTMENTS` is provided, this will always compute a zero monetary amount.
   * To only get tax or discounts, use the `tax` or `discount` properties, respectively.
   */
  totalCostOnlyIncluding: MonetaryAmount;
  /**
   * Sum of all costs except for line items that map to these cost components
   * This contract is similar to `totalCostOnlyIncluding`, but inverted to exclude cost instead of include.
   */
  totalCostExcluding: MonetaryAmount;
  /**
   * All the leads that have contributed to curation for this order.
   * This includes ExpertCuratedItem, ExpertCuratedOrder and BroadcastOffer
   */
  associatedLeads: Array<Lead>;
  /** @deprecated Use consumerUrl */
  consumerReceiptUrl: Scalars['String'];
  consumerUrl: Scalars['String'];
  adminUrl: Scalars['String'];
  /**
   * This id can be used for order receipt.  It is more friendly then the base64 encoded order.id.  This is only available
   *  for PostCart order, ie. order state is not  CREATED or CART
   */
  consumerFriendlyId?: Maybe<Scalars['String']>;
  /** Primary image to display when previewing this order. */
  primaryImage?: Maybe<MediaFile>;
  /** Last time this order was viewed on the view cart page by the order owner (userId) */
  cartLastViewedAt?: Maybe<Scalars['Date']>;
  /** Emburse cardIds */
  emburseCardIds: Array<Scalars['String']>;
  lastCheckedOutAt?: Maybe<Scalars['Date']>;
  primaryLeadForFollowup?: Maybe<Lead>;
  categoryType: CategoryType;
  /**
   * Provides a list of Payment processor to use for the payment of this Order.
   * This list is derived from restrictions some Processors have on the amount of transaction on the Orders.
   * Note, this list may change as the OrderLineItems are added or removed.
   * @deprecated Use supportedPaymentMethods
   */
  supportedPaymentProviders: Array<PaymentProcessorType>;
  /**
   * Provides a list of payment methods and its payment processor to use for the payment of this Order.
   * This list is derived from restrictions some Processors have on the amount of transaction on the Orders.
   * Note, this list may change as the OrderLineItems are added or removed.
   */
  supportedPaymentMethods: Array<SupportedPaymentMethod>;
  /**
   * This not so great name for timestamp captures the time instant when certain activity occurs.
   * This is equal to the createdAt date when the Order is first created and then update timestamp as the user attempts
   * to place the order. The timestamp is updated for both successful and failed payment attempts, including retries.
   */
  sortTimestamp: Scalars['Date'];
  /**
   * The amount paid by payment processor transaction for this order.
   * for a paid order, it is total amount - store credit.
   */
  paidAmount: MonetaryAmount;
  /** When deposit is allowed, the remaining balance for deposit. If deposit is already paid, should be 0 */
  remainingDepositBalance?: Maybe<MonetaryAmount>;
  /**
   * The remaining balance of this order. If an order is unpaid, it should be the same as totalCost.
   * If there is a partial payment, or deposit, this would be the remaining amount in order to be fully paid.
   * This includes applied store credit , but not pending store credit. Use
   * remainingBalanceToCharge for getting amount for charge payment source
   */
  remainingBalance: MonetaryAmount;
  /**
   * The remaining balance of this order after the pending store credit. If an
   * order is unpaid and no store credit will be applied,
   * it should be the same as totalCost.
   */
  remainingBalanceToCharge: MonetaryAmount;
  /** If deposit is allowed */
  depositAllowed: Scalars['Boolean'];
  /** When deposit is allowed, this would be the minimum amount to be paid as a deposit */
  minimumDeposit?: Maybe<MonetaryAmount>;
  /** This is the due date for the full payment, regardless if deposit is allowed or not */
  fullPaymentDueAt?: Maybe<Scalars['Date']>;
  depositPaidAt?: Maybe<Scalars['Date']>;
  paidInFullAt?: Maybe<Scalars['Date']>;
  submittedAt?: Maybe<Scalars['Date']>;
  /** The payment source to be charged automatically if allow (i.e. the payment source is chargeable with sufficient funds) */
  chargingPaymentSource?: Maybe<PaymentSource>;
  /**
   * All scheduled payments that are scheduled or canceled. Executed scheduled payments are excluded, and should be
   * available as transactions
   */
  scheduledPayments: Array<ScheduledPayment>;
  scheduledPayment: ScheduledPayment;
  /**
   * All promotions added to this order, including those that may not be actively applied
   * (e.g.: promotion rule may not apply to current items in cart, or one of the promotions gives a greater discount
   * over another).
   */
  promotionEntries: Array<OrderPromotionEntry>;
  /** store credit applied to this order */
  appliedStoreCredit: MonetaryAmount;
  /**
   * store credit balance after the any pending store credit in the order.  This is only valid for orders in
   * CREATED, CART or CONSUMER_PAYMENT_FAILED state, If all other orders, it will
   * just be zero since store credit is not applicable
   * for these order states
   */
  remainingStoreCreditBalance: MonetaryAmount;
  /**
   * The currently applied promotion, if any. This is simply the `applied` entry in `promotionEntries`, which there can
   * be at most one (only one promotion active at a time)
   */
  appliedPromotionEntry?: Maybe<OrderPromotionEntry>;
  /** The operator assigned to this order for fulfillment purposes */
  fulfillmentOperator?: Maybe<Operator>;
  /** Notes from operator about the order */
  operatorNotes: Array<OrderOperatorNote>;
  /** A flag indicating if this order is urgent and should be prioritized for fulfillment */
  isUrgent: Scalars['Boolean'];
  /** If this order contains a service, the address which this service will be performed */
  serviceLocation?: Maybe<PostalAddress>;
  /** This is only used for as trigger entity. */
  activity?: Maybe<OrderActivity>;
  /** This is only used for as trigger entity so that we can filter out order events on simple curated order */
  simpleCuratedOrder?: Maybe<SimpleCuratedOrder>;
  /** Labels indicating an order's derived state, such as unclaimed orders, and orders that need to be tracked */
  labels: Array<OrderLabel>;
  /** Distinct Departments the order's sellables belong to */
  departments: Array<Department>;
  /** The experts who helped the customer with this order */
  expertContributions: Array<OrderExpertContribution>;
  /** Escalations associated with the order */
  escalations: Array<OrderEscalation>;
  /** post cart activities associated with the order */
  postCartActivities: Array<PostCartOrderActivity>;
  /** tickets associated with the order */
  tickets: Array<Ticket>;
  /** Due date for product claiming, calculated as paidAt + fulfillment SLA (24 hours) */
  productClaimDueAt?: Maybe<Scalars['Date']>;
  paymentVerificationMethod?: Maybe<PaymentVerificationMethod>;
  refunds: Array<OrderRefund>;
  tipMethod: TipMethod;
  shippingAddressEditable: Scalars['Boolean'];
  /** total cost minus refunded amount */
  effectiveCost: MonetaryAmount;
  lineItemsTrackingSummary: OrderLineItemsTrackingSummary;
  eligibleForCommission: Scalars['Boolean'];
  shippingOptions: Array<ShippingOption>;
  suggestedShippingGroups?: Maybe<SuggestedShippingGroups>;
  allItemsShipped: Scalars['Boolean'];
  allItemsReceived: Scalars['Boolean'];
  giftCardOnly: Scalars['Boolean'];
  requiredPaymentAction?: Maybe<PaymentAction>;
};


export type OrderTransactionArgs = {
  transactionId: Scalars['TransactionId'];
};


export type OrderLineItemsArgs = {
  topLevelOnly?: Maybe<Scalars['Boolean']>;
};


export type OrderChargeableStatusArgs = {
  useCase: OrderChargeableUseCase;
};


export type OrderTotalCostOnlyIncludingArgs = {
  costComponents: Array<OrderCostComponent>;
};


export type OrderTotalCostExcludingArgs = {
  costComponents: Array<OrderCostComponent>;
};


export type OrderScheduledPaymentArgs = {
  id: Scalars['ScheduledPaymentId'];
};


export type OrderEscalationsArgs = {
  sources?: Maybe<Array<OrderEscalationSource>>;
};


export type OrderPostCartActivitiesArgs = {
  limit?: Maybe<Scalars['Int']>;
};


export type OrderTicketsArgs = {
  ticketType?: Maybe<TicketType>;
};


export type OrderRefundsArgs = {
  status?: Maybe<OrderRefundStatus>;
};


export type OrderLineItemsTrackingSummaryArgs = {
  topLineItemForDisplay?: Maybe<Scalars['OrderLineItemId']>;
};

export type OrderActivity = {
  __typename: 'OrderActivity';
  lastPreSubmitAction: OrderPreSubmitAction;
  lastPreSubmitActionOccurredAt: Scalars['Date'];
};

export type OrderActivityDetail = {
  type: OrderActivityDetailType;
};

export enum OrderActivityDetailType {
  OPERATOR_ASSIGNED = 'OPERATOR_ASSIGNED',
  MERCHANT_CLAIMED = 'MERCHANT_CLAIMED',
  TRACKING_UPDATED = 'TRACKING_UPDATED',
  TRACKING_REMOVED = 'TRACKING_REMOVED',
  ORDER_ESCALATED = 'ORDER_ESCALATED',
  ITEM_SHIPPED = 'ITEM_SHIPPED',
  ESCALATION_CLOSED = 'ESCALATION_CLOSED',
  DEAL_INVENTORY_REQUESTED = 'DEAL_INVENTORY_REQUESTED',
  DEAL_INVENTORY_REQUEST_FAILED = 'DEAL_INVENTORY_REQUEST_FAILED',
  DEAL_INVENTORY_REQUEST_CANCELED = 'DEAL_INVENTORY_REQUEST_CANCELED',
  DEAL_INVENTORY_CLAIMED = 'DEAL_INVENTORY_CLAIMED',
  DEAL_INVENTORY_FULFILLMENT_ORDER_CANCELED = 'DEAL_INVENTORY_FULFILLMENT_ORDER_CANCELED',
  ITEM_RETURN_REQUESTED = 'ITEM_RETURN_REQUESTED',
  RETURN_SHIPMENT_TRACKING_UPDATED = 'RETURN_SHIPMENT_TRACKING_UPDATED',
  ITEM_RETURN_SHIPPED = 'ITEM_RETURN_SHIPPED',
  ITEM_RETURN_RECEIVED = 'ITEM_RETURN_RECEIVED',
  RETURN_SHIPMENT_TRACKING_REMOVED = 'RETURN_SHIPMENT_TRACKING_REMOVED',
  FULFILLMENT_PROCESS_UPDATED = 'FULFILLMENT_PROCESS_UPDATED',
  ITEM_RECEIVED = 'ITEM_RECEIVED',
  ITEM_ORDER_VERIFICATION = 'ITEM_ORDER_VERIFICATION',
  REFUND_REQUESTED = 'REFUND_REQUESTED',
  REFUND_STATE_UPDATED = 'REFUND_STATE_UPDATED',
  REFUND_AMOUNT_ADJUSTED = 'REFUND_AMOUNT_ADJUSTED',
  ORDER_ADDRESS_CHANGED = 'ORDER_ADDRESS_CHANGED',
  EXPERT_CONTRIBUTION_CHANGED = 'EXPERT_CONTRIBUTION_CHANGED',
  RETURN_DESTINATION_CHANGED = 'RETURN_DESTINATION_CHANGED',
  MERCHANT_REFUND_UPDATED = 'MERCHANT_REFUND_UPDATED',
  CONFIRMED_RETURN_LABEL_SENT = 'CONFIRMED_RETURN_LABEL_SENT'
}

export type OrderAddressChangedActivity = OrderActivityDetail & {
  __typename: 'OrderAddressChangedActivity';
  type: OrderActivityDetailType;
  changedBy: Operator;
  previousAddress: Address;
  currentAddress: Address;
};

export type OrderAdjustmentTicket = TicketDetail & {
  __typename: 'OrderAdjustmentTicket';
  type: TicketType;
  consumer: User;
  order: Order;
  orderLineItemIds: Array<Scalars['OrderLineItemId']>;
};

/** Compare against the total of core line items (sellables, base price, ad hoc) */
export type OrderAmountPromotionRuleReference = PromotionRuleReference & {
  __typename: 'OrderAmountPromotionRuleReference';
  id: Scalars['PromotionRuleReferenceId'];
  type: PromotionRuleType;
  operator: PromotionRuleComparisonOperator;
  /** Right hand side amount, in respect to `operator`. Left hand side is the actual aggregated cost of line items. */
  rightOperandAmount: MonetaryAmount;
};

/** See `OrderAmountPromotionRuleReference` for documentation */
export type OrderAmountPromotionRuleReferenceInput = {
  operator: PromotionRuleComparisonOperator;
  rightOperandAmount: MonetaryAmountInput;
};

export type OrderAndLineItemIdsQueryInput = {
  orderId: Scalars['OrderId'];
  orderLineItemIds: Array<Scalars['OrderLineItemId']>;
};

export type OrderChargeableStatus = {
  __typename: 'OrderChargeableStatus';
  type: OrderChargeableStatusType;
  /** Optional message for failure (non `CAN_CHARGE` types) that provides more context to the user why they can't buy */
  message?: Maybe<Scalars['String']>;
};

export enum OrderChargeableStatusType {
  /** The order can be charged */
  CAN_CHARGE = 'CAN_CHARGE',
  /** The order has already been charged. */
  ALREADY_CHARGED = 'ALREADY_CHARGED',
  /** The order is empty. */
  EMPTY = 'EMPTY',
  /** The order requires a shipping address, but none was provided. Not relevant for OrderChargeableUseCase.CHECKOUT */
  NO_SHIPPING_ADDRESS = 'NO_SHIPPING_ADDRESS',
  /**
   * The order requires a service address, but none was set by the expert. Orders should never reach the customer in
   * this state as the address should be set by the expert beforehand.
   */
  NO_SERVICE_LOCATION = 'NO_SERVICE_LOCATION',
  /** The order is expired; the user must reach out to the expert to renew the order. */
  EXPIRED = 'EXPIRED',
  /**
   * The order requires a minimum amount (e.g.: Orders shipped to Australia need to have at least $125 in the cart)
   * Use the `message` property on `OrderChargeableStatus` to display a message containing the exact amount the user
   * needs.
   */
  BELOW_MINIMUM_AMOUNT = 'BELOW_MINIMUM_AMOUNT',
  /**
   * The order is in a preview state (only available for viewing); the user must reach out to the expert to receive
   * a new purchase-able order.
   */
  IN_PREVIEW = 'IN_PREVIEW'
}

export enum OrderChargeableUseCase {
  /** Checking if the checkout process can be started */
  CHECKOUT = 'CHECKOUT',
  /** Checking if the order can be purchased (payment provided to stripe/paypal/etc, and order charged) */
  PURCHASE = 'PURCHASE'
}

export enum OrderCostComponent {
  /** Includes the price for AD_HOC, SELLABLE, and BASE_PRICE source types (the core price of what's being purchased) */
  CORE = 'CORE',
  /** Tip paid to Deal.com experts */
  EXPERT_TIP = 'EXPERT_TIP',
  /** Fixed gratuity (e.g.: mandatory crew gratuity for charters) */
  GRATUITY = 'GRATUITY',
  /** Prepaid incidental charges (e.g.: advanced provisional allowance for yacht charters) */
  PREPAID_INCIDENTAL = 'PREPAID_INCIDENTAL',
  /** Shipping */
  SHIPMENT = 'SHIPMENT',
  /** Tax */
  TAX_ADJUSTMENTS = 'TAX_ADJUSTMENTS',
  /** Discounts through promotions */
  DISCOUNT_ADJUSTMENTS = 'DISCOUNT_ADJUSTMENTS',
  /** Refunds */
  REFUNDS = 'REFUNDS',
  /** Gift Card */
  GIFT_CARD = 'GIFT_CARD'
}

export type OrderEscalatedActivity = OrderActivityDetail & {
  __typename: 'OrderEscalatedActivity';
  type: OrderActivityDetailType;
  escalation: OrderEscalation;
};

export type OrderEscalation = {
  __typename: 'OrderEscalation';
  id: Scalars['OrderEscalationId'];
  version: Scalars['Int'];
  updatedAt: Scalars['Date'];
  createdAt: Scalars['Date'];
  userId: Scalars['UserId'];
  orderId: Scalars['OrderId'];
  leadId?: Maybe<Scalars['LeadId']>;
  orderLineItemId?: Maybe<Scalars['OrderLineItemId']>;
  assignedToId?: Maybe<Scalars['OperatorId']>;
  reason?: Maybe<Scalars['String']>;
  startedAt?: Maybe<Scalars['Date']>;
  completedAt?: Maybe<Scalars['Date']>;
  dueDate?: Maybe<Scalars['Date']>;
  status: OrderEscalationStatus;
  type: OrderEscalationType;
  escalatedById: Scalars['AnyId'];
  user: User;
  assignedTo?: Maybe<Operator>;
  order: Order;
  priority: OrderEscalationPriority;
  operatorNotes: Array<OrderOperatorNote>;
  mediaAttachments: Array<OrderEscalationAttachment>;
  consumerFriendlyId?: Maybe<Scalars['String']>;
  supportConversation?: Maybe<SupportConversation>;
  escalatedBy: EscalationUser;
  labels: Array<OrderEscalationLabel>;
  source: OrderEscalationSource;
  returnReason?: Maybe<OrderRefundReason>;
  escalatedItemInfo?: Maybe<EscalationItemInfo>;
  resolution?: Maybe<EscalationResolution>;
};

export type OrderEscalationAttachment = {
  __typename: 'OrderEscalationAttachment';
  uploadedBy: Scalars['AnyId'];
  createdAt: Scalars['Date'];
  title?: Maybe<Scalars['String']>;
  attachmentMediaId: Scalars['MediaId'];
};

export type OrderEscalationConnection = {
  __typename: 'OrderEscalationConnection';
  facets: Array<DisplayFacet>;
  edges: Array<OrderEscalationEdge>;
  pageInfo: PageInfo;
  count: Scalars['Long'];
};

export type OrderEscalationEdge = {
  __typename: 'OrderEscalationEdge';
  node: OrderEscalation;
  cursor: Scalars['String'];
};


export enum OrderEscalationLabel {
  NEED_CONSUMER_INPUT = 'NEED_CONSUMER_INPUT',
  NEED_MERCHANT_INPUT = 'NEED_MERCHANT_INPUT'
}

export enum OrderEscalationPriority {
  HIGH = 'HIGH',
  NORMAL = 'NORMAL'
}

export type OrderEscalationSearchInput = {
  orderIds?: Maybe<Array<Scalars['String']>>;
  userIds?: Maybe<Array<Scalars['UserId']>>;
  operatorIds?: Maybe<Array<Scalars['OperatorId']>>;
  facets?: Maybe<Array<FacetSelection>>;
  facetedSearch?: Maybe<Scalars['Boolean']>;
  dateRangeFilters?: Maybe<Array<DateRangeFilterInput>>;
  statuses?: Maybe<Array<OrderEscalationStatus>>;
  consumerFriendlyId?: Maybe<Scalars['String']>;
  departmentIds?: Maybe<Array<Scalars['DepartmentId']>>;
  sources?: Maybe<Array<OrderEscalationSource>>;
  includeUnassigned?: Maybe<Scalars['Boolean']>;
};

export enum OrderEscalationSearchSort {
  CREATED_AT = 'CREATED_AT',
  STATUS = 'STATUS',
  ORDER_ID = 'ORDER_ID',
  USER_ID = 'USER_ID',
  PAID_AT = 'PAID_AT'
}

export enum OrderEscalationSource {
  CONSUMER = 'CONSUMER',
  EXPERT = 'EXPERT',
  OPERATIONS = 'OPERATIONS'
}

export enum OrderEscalationStatus {
  NEW = 'NEW',
  IN_PROGRESS = 'IN_PROGRESS',
  COMPLETED = 'COMPLETED'
}

export enum OrderEscalationType {
  ITEM_UNAVAILABLE = 'ITEM_UNAVAILABLE',
  MISSING_SPECS = 'MISSING_SPECS',
  ORDER_ADJUSTMENT = 'ORDER_ADJUSTMENT',
  CANCELLATION = 'CANCELLATION',
  RETURN = 'RETURN',
  EXCHANGE = 'EXCHANGE',
  MISSING_ITEM = 'MISSING_ITEM',
  TRACKING_INQUIRY = 'TRACKING_INQUIRY',
  ORDER_INFORMATION = 'ORDER_INFORMATION',
  OTHER = 'OTHER'
}

export type OrderExpertContribution = {
  __typename: 'OrderExpertContribution';
  expert: BusinessUser;
  lead: Lead;
  contributionScore: Scalars['Int'];
};

export type OrderExpertContributionChangedActivity = OrderActivityDetail & {
  __typename: 'OrderExpertContributionChangedActivity';
  type: OrderActivityDetailType;
  existingContributions: Array<OrderExpertContribution>;
  updatedContributions: Array<OrderExpertContribution>;
  existingTips: Array<Maybe<OrderLineItemExpertTipSourceExpertAmount>>;
  updatedTips: Array<Maybe<OrderLineItemExpertTipSourceExpertAmount>>;
};

export type OrderExpertContributionInput = {
  expertId: Scalars['BusinessUserId'];
  leadId: Scalars['LeadId'];
  contributionScore: Scalars['Int'];
};

export enum OrderFulfillmentState {
  NEW = 'NEW',
  CLAIMED = 'CLAIMED',
  READY = 'READY',
  FULFILLED = 'FULFILLED'
}

export type OrderGiftCardDetails = {
  __typename: 'OrderGiftCardDetails';
  recipientName: Scalars['String'];
  recipientEmail: Scalars['String'];
  deliveryDate: Scalars['Date'];
  message?: Maybe<Scalars['Date']>;
};


export type OrderInformationTicket = TicketDetail & {
  __typename: 'OrderInformationTicket';
  type: TicketType;
  consumer: User;
  order: Order;
  orderLineItemIds: Array<Scalars['OrderLineItemId']>;
};

export type OrderItemReceivedActivity = OrderActivityDetail & {
  __typename: 'OrderItemReceivedActivity';
  type: OrderActivityDetailType;
};

export type OrderItemShippedActivity = OrderActivityDetail & {
  __typename: 'OrderItemShippedActivity';
  type: OrderActivityDetailType;
};

export enum OrderLabel {
  UNCLAIMED = 'UNCLAIMED',
  TRACKING_NEEDED = 'TRACKING_NEEDED',
  TRACKING_OVERDUE = 'TRACKING_OVERDUE'
}

export type OrderLineItem = {
  __typename: 'OrderLineItem';
  id: Scalars['OrderLineItemId'];
  title: Scalars['String'];
  /**
   * The entity which this line item is derived/synced with. Note that changes in a line item's source price
   * (e.g.: changing a sellable's price) will be bubbled down to to the order line's unitPrice each time the
   * order is modified, or the `syncOrder` mutation is called.
   */
  source: OrderLineItemSource;
  /** the base price of one unit; does not include adjustments (tax, promotions, etc) */
  unitPrice: MonetaryAmount;
  /** quantity of items; can only be greater than one for sellable sources. */
  quantity: Scalars['Int'];
  /** the base price for `quantity` items; does not include adjustments (tax, promotions, etc) */
  price: MonetaryAmount;
  /** the final price of this item, excluding tax adjustments, but including other adjustments such as promotions. */
  totalBeforeTax: MonetaryAmount;
  /** the total price of the item including tax adjustments */
  total: MonetaryAmount;
  /** Messages associated with this order line item */
  messages: Array<OrderMessage>;
  /**
   * If this order line item is a child line item, this will be the parent line item this line item is a child of.
   * If null, this line item is a parent (top level) line item.
   */
  parentId?: Maybe<Scalars['OrderLineItemId']>;
  /** This is the child -> parent relationship of the `parentId` relationship, provided for convenience. */
  childIds: Array<Scalars['OrderLineItemId']>;
  children: Array<OrderLineItem>;
  /**
   * If this order line item is a grouping order line item. This flag should be used to determine if child line items
   * can expectedReference this line item as a parent. Note that all line items can't have children blindly added - parents
   * need to be explicitly made into groups (groups dictate pricing policies of children, along with taxation), so
   * prefer using this over inferring if this is a group from non-empty `childIds`.
   */
  isGroup: Scalars['Boolean'];
  /** Metadata about this grouping, if isGroup == true */
  groupDefinition?: Maybe<OrderLineItemGroupDefinition>;
  /**
   * If this order line item is required. Note that this will only be true for child line items that are required within
   * their parent line item. Forcefully removing this line item will remove the parent line item, and any other
   * sibling/child line items of that parent.
   */
  required: Scalars['Boolean'];
  /** Terms specific to the user's purchase of the sellable (e.g.: start time for a charter) */
  terms?: Maybe<SellableTerms>;
  /** The state of the order line item */
  state: OrderLineItemState;
  /** Shipment tracking associated with this order */
  shipmentTracking?: Maybe<ShipmentTracking>;
  /** Return shipment tracking associated with this order */
  returnShipmentTracking?: Maybe<ShipmentTracking>;
  /** Shipping method used for this line item, if applicable */
  shippingMethod?: Maybe<ShippingMethod>;
  /** The parent order that contains this line item */
  order: Order;
  /** The expert curated item this line item was added from, if any */
  expertCuratedItem?: Maybe<ExpertCuratedItem>;
  /** Email alias for the line item used to place order with merchants */
  emailForFulfillment: Scalars['String'];
  /** Item specific notes */
  notes: Array<OrderOperatorNote>;
  fulfillmentOrderSourceType?: Maybe<FulfillmentOrderSourceType>;
  /** If fulfilled by Deal inventory, the corresponding fulfillment order */
  fulfillmentOrder?: Maybe<FulfillmentOrder>;
  eligibleForReturn: Scalars['Boolean'];
  eligibleForCancellation: Scalars['Boolean'];
  requestedReturn?: Maybe<OrderRefund>;
  /**
   * list of categories derived from the sellable, including parent categories. For sellables belonging to multiple
   * categories, the first category path is picked
   */
  categoryPath: Array<Category>;
  /** tickets associated with the line item */
  tickets: Array<Ticket>;
  /** package the item belongs to */
  shippingOption?: Maybe<ShippingOption>;
  /** postcart order activities relevant to the line item */
  postCartActivities: Array<PostCartOrderActivity>;
};


export type OrderLineItemTicketsArgs = {
  ticketType?: Maybe<TicketType>;
};

export type OrderLineItemAdHocSource = OrderLineItemSource & {
  __typename: 'OrderLineItemAdHocSource';
  type: OrderLineItemSourceType;
};

export type OrderLineItemBasePriceSource = OrderLineItemSource & {
  __typename: 'OrderLineItemBasePriceSource';
  type: OrderLineItemSourceType;
  preOrder: Scalars['Boolean'];
};

export type OrderLineItemExpertTipSource = OrderLineItemSource & {
  __typename: 'OrderLineItemExpertTipSource';
  type: OrderLineItemSourceType;
  amount: MonetaryAmount;
  expertAmounts: Array<OrderLineItemExpertTipSourceExpertAmount>;
};

export type OrderLineItemExpertTipSourceExpertAmount = {
  __typename: 'OrderLineItemExpertTipSourceExpertAmount';
  expert: BusinessUser;
  amount: MonetaryAmount;
};

export type OrderLineItemGiftCardSource = OrderLineItemSource & {
  __typename: 'OrderLineItemGiftCardSource';
  type: OrderLineItemSourceType;
  amount: MonetaryAmount;
  details?: Maybe<OrderGiftCardDetails>;
  curator?: Maybe<BusinessUser>;
  giftCard?: Maybe<GiftCard>;
  imageUrl: Scalars['String'];
};

export type OrderLineItemGratuitySource = OrderLineItemSource & {
  __typename: 'OrderLineItemGratuitySource';
  type: OrderLineItemSourceType;
  percentage: Scalars['Int'];
};

export type OrderLineItemGroupDefinition = {
  __typename: 'OrderLineItemGroupDefinition';
  /** Defines how price is computed for this grouped line item and its children */
  priceStrategy: OrderLineItemGroupPriceStrategy;
  /** Defines how tax is computed for this grouped line item and its children */
  taxStrategy: OrderLineItemGroupTaxStrategy;
};

export enum OrderLineItemGroupPriceStrategy {
  /** This line item has no price, and is strictly added as a grouping line item with the children having prices. */
  IGNORE_SELF_DEFAULT_CHILDREN = 'IGNORE_SELF_DEFAULT_CHILDREN',
  /** This line item has a price, with the child line item prices being ignored / not respected. */
  ONLY_SELF_IGNORE_CHILDREN = 'ONLY_SELF_IGNORE_CHILDREN'
}

export enum OrderLineItemGroupTaxStrategy {
  /** All line items will retain their default tax calculation. */
  DEFAULT = 'DEFAULT',
  /**
   * All line items that are children of the current line item will use the current line item's tax calculation.
   * This is useful when the grouping parent line item is a service (e.g.: charters) that are taxed using the service
   * location - not the shipping address. This strategy will use that same calculation (service location) for all child
   * line items (e.g.: ensure that add-on food line item is taxed like the charter).
   */
  PROPAGATE_SELF_TO_CHILDREN = 'PROPAGATE_SELF_TO_CHILDREN'
}


export type OrderLineItemPrepaidIncidentalSource = OrderLineItemSource & {
  __typename: 'OrderLineItemPrepaidIncidentalSource';
  type: OrderLineItemSourceType;
  percentage: Scalars['Int'];
};

export type OrderLineItemReceivedInput = {
  orderId: Scalars['OrderId'];
  orderLineItemId: Scalars['OrderLineItemId'];
};

export type OrderLineItemReceivedPayload = {
  __typename: 'OrderLineItemReceivedPayload';
  order: Order;
  hasError: Scalars['Boolean'];
  errorMessage?: Maybe<Scalars['String']>;
};

export type OrderLineItemRefundInput = {
  orderLineItemId: Scalars['OrderLineItemId'];
  refundAmount?: Maybe<MonetaryAmountInput>;
  merchantRefundAmount?: Maybe<MonetaryAmountInput>;
};

export type OrderLineItemRefundSource = OrderLineItemSource & {
  __typename: 'OrderLineItemRefundSource';
  type: OrderLineItemSourceType;
  orderRefund: OrderRefund;
};

export type OrderLineItemRefundSummary = {
  __typename: 'OrderLineItemRefundSummary';
  lineItemId: Scalars['OrderLineItemId'];
  refundAmount?: Maybe<MonetaryAmount>;
  merchantRefundAmount?: Maybe<MonetaryAmount>;
};

export type OrderLineItemReturnRequestInput = {
  orderId: Scalars['OrderId'];
  orderLineItemId: Scalars['OrderLineItemId'];
  orderEscalationId: Scalars['OrderEscalationId'];
};

export type OrderLineItemSellableSource = OrderLineItemSource & {
  __typename: 'OrderLineItemSellableSource';
  type: OrderLineItemSourceType;
  sellable: Sellable;
  overridePrice?: Maybe<MonetaryAmount>;
  preOrder: Scalars['Boolean'];
  discount?: Maybe<MonetaryAmount>;
};

export enum OrderLineItemsGroupingType {
  TRACKING = 'TRACKING'
}

export type OrderLineItemShipmentSource = OrderLineItemSource & {
  __typename: 'OrderLineItemShipmentSource';
  type: OrderLineItemSourceType;
  amount: MonetaryAmount;
};

export type OrderLineItemSource = {
  type: OrderLineItemSourceType;
};

export enum OrderLineItemSourceType {
  /** No additional metadata; ad-hoc line item */
  AD_HOC = 'AD_HOC',
  /** Line item is linked to a sellable */
  SELLABLE = 'SELLABLE',
  /** Line item is a child line item, indicating the base price of the parent (primarily used for services) */
  BASE_PRICE = 'BASE_PRICE',
  /** Line item represents a tip to Deal.com experts */
  EXPERT_TIP = 'EXPERT_TIP',
  /** Fixed gratuity */
  GRATUITY = 'GRATUITY',
  /** Prepaid incidental charges */
  PREPAID_INCIDENTAL = 'PREPAID_INCIDENTAL',
  /** Shipment cost line item */
  SHIPMENT = 'SHIPMENT',
  /** Refund for one or more items in the order */
  REFUND = 'REFUND',
  /** Gift card purchase */
  GIFT_CARD = 'GIFT_CARD'
}

export enum OrderLineItemState {
  PENDING_CLAIM = 'PENDING_CLAIM',
  CLAIMED = 'CLAIMED',
  NEW = 'NEW',
  PAID = 'PAID',
  READY_TO_CLAIM = 'READY_TO_CLAIM',
  PENDING_SHIPPING = 'PENDING_SHIPPING',
  READY = 'READY',
  RECEIVED = 'RECEIVED',
  RETURN_PENDING_SHIPPING = 'RETURN_PENDING_SHIPPING',
  RETURN_REQUESTED = 'RETURN_REQUESTED',
  RETURN_RECEIVED = 'RETURN_RECEIVED',
  RETURN_SHIPPED = 'RETURN_SHIPPED',
  SHIPPED = 'SHIPPED',
  UNAVAILABLE = 'UNAVAILABLE',
  CUSTOMIZING = 'CUSTOMIZING'
}

export type OrderLineItemsTrackingSummary = {
  __typename: 'OrderLineItemsTrackingSummary';
  shipped: Array<TrackingGroupedOrderLineItems>;
  delivered: Array<TrackingGroupedOrderLineItems>;
  pending: Array<TrackingGroupedOrderLineItems>;
  inFulfillment: Array<TrackingGroupedOrderLineItems>;
};

export type OrderLineItemUnavailableInput = {
  orderId: Scalars['OrderId'];
  orderLineItemId: Scalars['OrderLineItemId'];
};

export type OrderLineItemUnclaimInput = {
  orderId: Scalars['OrderId'];
  orderLineItemId: Scalars['OrderLineItemId'];
};

export type OrderMessage = {
  __typename: 'OrderMessage';
  dismissible: Scalars['Boolean'];
  message: Scalars['String'];
};

export type OrderOperatorNote = {
  __typename: 'OrderOperatorNote';
  operator: Operator;
  createdAt: Scalars['Date'];
  title?: Maybe<Scalars['String']>;
  note: Scalars['String'];
};

export type OrderPayload = {
  __typename: 'OrderPayload';
  order?: Maybe<Order>;
  errorCode?: Maybe<GetEntityErrorCode>;
  maskedUserHandles?: Maybe<Array<MaskedUserHandle>>;
};

export enum OrderPreSubmitAction {
  CHECKOUT_STARTED = 'CHECKOUT_STARTED',
  ADD_TO_CART = 'ADD_TO_CART',
  PAYMENT_INFO_ENTERED = 'PAYMENT_INFO_ENTERED'
}

export type OrderPromotionEntry = {
  __typename: 'OrderPromotionEntry';
  promotion: Promotion;
  addedAt: Scalars['Date'];
  /**
   * If this promotion is applied to the order. Note that there will be at most one promotion entry for a given order
   * that has this set to `true`.
   */
  applied: Scalars['Boolean'];
  /** The total discount this promotion provides to the order */
  discount: MonetaryAmount;
};

export type OrderQuery = {
  userId?: Maybe<Scalars['UserId']>;
  /** If omitted, this will default to all states except for CREATED and CART */
  states?: Maybe<Array<OrderState>>;
  fulfillmentStates?: Maybe<Array<OrderFulfillmentState>>;
  orderLineItemStates?: Maybe<Array<OrderLineItemState>>;
  /** this can be either consumerFriendlyId or order external id */
  orderId?: Maybe<Scalars['String']>;
  fulfillmentOperatorIds?: Maybe<Array<Scalars['OperatorId']>>;
  ordersWithNoFulfillmentOperatorOnly?: Maybe<Scalars['Boolean']>;
  userQuery?: Maybe<Scalars['String']>;
  facetedSearch?: Maybe<Scalars['Boolean']>;
  facets?: Maybe<Array<FacetSelection>>;
  dateRangeFilters?: Maybe<Array<DateRangeFilterInput>>;
  shippingAddresseeName?: Maybe<Scalars['String']>;
  keywords?: Maybe<Scalars['String']>;
  departmentIds?: Maybe<Array<Scalars['DepartmentId']>>;
  includeUnassignedOrders?: Maybe<Scalars['Boolean']>;
  categoryType?: Maybe<CategoryType>;
};

export type OrderRefund = {
  __typename: 'OrderRefund';
  id: Scalars['OrderRefundId'];
  createdAt: Scalars['Date'];
  updatedAt: Scalars['Date'];
  order: Order;
  consumer: User;
  lineItemIds: Array<Scalars['OrderLineItemId']>;
  escalation?: Maybe<OrderEscalation>;
  requestedByOperator?: Maybe<Operator>;
  processedBy?: Maybe<Operator>;
  reason: OrderRefundReason;
  status: OrderRefundStatus;
  amountRequested: MonetaryAmount;
  originalTransactionId: Scalars['TransactionId'];
  comment?: Maybe<Scalars['String']>;
  merchantRefundNeeded: Scalars['Boolean'];
  merchantRefundedAmount?: Maybe<MonetaryAmount>;
  merchantRefundedAt?: Maybe<Scalars['Date']>;
  merchantRefundTax?: Maybe<MonetaryAmount>;
  merchantRefundShipping?: Maybe<MonetaryAmount>;
  merchantRefundNote?: Maybe<Scalars['String']>;
  returnShipmentTracking?: Maybe<ShipmentTracking>;
  type: OrderRefundType;
  lineItemRefundSummaries: Array<OrderLineItemRefundSummary>;
  commissionTreatment: ExpertCommissionRefundTreatment;
};

export type OrderRefundEdge = {
  __typename: 'OrderRefundEdge';
  node: OrderRefund;
  cursor: Scalars['String'];
};

export type OrderRefundFailedInput = {
  orderRefundId: Scalars['OrderRefundId'];
};


export type OrderRefundQueryInput = {
  statuses?: Maybe<Array<OrderRefundStatus>>;
  originalTransactionIds?: Maybe<Array<Scalars['TransactionId']>>;
  orderIds?: Maybe<Array<Scalars['OrderId']>>;
  requestDateRange?: Maybe<DateRangeInput>;
  orderAndLineItemIdsQuery?: Maybe<OrderAndLineItemIdsQueryInput>;
};

export enum OrderRefundReason {
  DIDNT_LIKE = 'DIDNT_LIKE',
  NOT_EXPECTED = 'NOT_EXPECTED',
  WRONG_ITEM = 'WRONG_ITEM',
  BAD_DESCRIPTION = 'BAD_DESCRIPTION',
  DEFECTIVE = 'DEFECTIVE',
  DAMAGED_IN_SHIPPING = 'DAMAGED_IN_SHIPPING',
  NEVER_ARRIVED = 'NEVER_ARRIVED',
  ARRIVED_LATE = 'ARRIVED_LATE',
  UNAPPROVED = 'UNAPPROVED',
  BAD_WEATHER = 'BAD_WEATHER',
  EQUIPMENT_MALFUNCTION = 'EQUIPMENT_MALFUNCTION',
  WRONG_AMOUNT = 'WRONG_AMOUNT',
  WRONG_SIZE = 'WRONG_SIZE',
  WRONG_COLOR = 'WRONG_COLOR',
  DAMAGED_SHIPPING_BOX_OK = 'DAMAGED_SHIPPING_BOX_OK',
  DAMAGED_SHIPPING_BOX_DAMAGED = 'DAMAGED_SHIPPING_BOX_DAMAGED',
  UNAVAILABLE_INVENTORY = 'UNAVAILABLE_INVENTORY',
  REPLACED_INVENTORY = 'REPLACED_INVENTORY',
  LOST_DURING_SHIPPING = 'LOST_DURING_SHIPPING',
  UNABLE_TO_EXPEDITE_SHIPPING = 'UNABLE_TO_EXPEDITE_SHIPPING',
  PRICE_MATCH = 'PRICE_MATCH',
  CUSTOMER_REQUEST = 'CUSTOMER_REQUEST'
}

export type OrderRefundRejectedInput = {
  orderRefundId: Scalars['OrderRefundId'];
};

export type OrderRefundsConnection = {
  __typename: 'OrderRefundsConnection';
  edges: Array<OrderRefundEdge>;
  pageInfo: PageInfo;
  count: Scalars['Long'];
};

export type OrderRefundsPagination = {
  __typename: 'OrderRefundsPagination';
  orderRefunds: Array<OrderRefund>;
  count: Scalars['Long'];
};

export enum OrderRefundStatus {
  SUCCESS = 'SUCCESS',
  PENDING = 'PENDING',
  FAILED = 'FAILED',
  REJECTED = 'REJECTED',
  CANCELLED = 'CANCELLED'
}

export type OrderRefundSuccessInput = {
  orderRefundId: Scalars['OrderRefundId'];
};

export enum OrderRefundType {
  REFUND = 'REFUND',
  RETURN = 'RETURN',
  CANCELLATION = 'CANCELLATION'
}

export type OrderRefundWithError = {
  __typename: 'OrderRefundWithError';
  orderRefund?: Maybe<OrderRefund>;
  hasError: Scalars['Boolean'];
  errorMessage?: Maybe<Scalars['String']>;
};

export type OrdersConnection = {
  __typename: 'OrdersConnection';
  facets: Array<DisplayFacet>;
  edges: Array<OrdersEdge>;
  pageInfo: PageInfo;
  count: Scalars['Long'];
};

export enum OrderSearchSort {
  PAID_AT = 'PAID_AT',
  CREATED_AT = 'CREATED_AT',
  EFFECTIVE_ORDER_DATE = 'EFFECTIVE_ORDER_DATE',
  EFFECTIVE_ORDER_DATE_ASC = 'EFFECTIVE_ORDER_DATE_ASC'
}

export type OrdersEdge = {
  __typename: 'OrdersEdge';
  node: Order;
  cursor: Scalars['String'];
};

export type OrderShippingCost = {
  __typename: 'OrderShippingCost';
  shippingMethodCosts: Array<ShippingMethodCost>;
  suggestedShippingGroups?: Maybe<SuggestedShippingGroups>;
};

/** Can specify either addressId, country/state, or none */
export type OrderShippingCostAddressInput = {
  addressId?: Maybe<Scalars['AddressId']>;
  country?: Maybe<Scalars['String']>;
  state?: Maybe<Scalars['String']>;
};

export enum OrderState {
  CART = 'CART',
  CREATED = 'CREATED',
  SUBMITTED = 'SUBMITTED',
  CONSUMER_PAYMENT_PENDING = 'CONSUMER_PAYMENT_PENDING',
  CONSUMER_PAYMENT_IN_REVIEW = 'CONSUMER_PAYMENT_IN_REVIEW',
  CONSUMER_PAYMENT_COMPLETED = 'CONSUMER_PAYMENT_COMPLETED',
  CONSUMER_PAYMENT_FAILED = 'CONSUMER_PAYMENT_FAILED',
  CONSUMER_PAYMENT_PARTIAL = 'CONSUMER_PAYMENT_PARTIAL',
  CONSUMER_OVERPAID = 'CONSUMER_OVERPAID',
  CONSUMER_PAYMENT_REFUNDED = 'CONSUMER_PAYMENT_REFUNDED',
  CONSUMER_PAYMENT_CANCELED = 'CONSUMER_PAYMENT_CANCELED'
}

export type OrderSupportTask = SupportTask & {
  __typename: 'OrderSupportTask';
  id: Scalars['SupportTaskId'];
  type: SupportTaskType;
  state: SupportTaskState;
  url: Scalars['String'];
  dueAt: Scalars['Date'];
  assignedTo?: Maybe<Operator>;
  assignedAt?: Maybe<Scalars['Date']>;
  completedAt?: Maybe<Scalars['Date']>;
  consumer: User;
  note: Scalars['String'];
  order?: Maybe<Order>;
  lead?: Maybe<Lead>;
};

export type OrderVerificationActivity = OrderActivityDetail & {
  __typename: 'OrderVerificationActivity';
  type: OrderActivityDetailType;
  verifiedBy: Operator;
  successful: Scalars['Boolean'];
};

export type OrderVerificationTicket = TicketDetail & {
  __typename: 'OrderVerificationTicket';
  type: TicketType;
  consumerId: Scalars['UserId'];
  order: Order;
  orderLineItemId: Scalars['OrderLineItemId'];
};

export type OverrideExpertPerformanceRatingInput = {
  expertId: Scalars['BusinessUserId'];
  overrideExpiresAt: Scalars['Date'];
  overrideRating: ExpertPerformanceRating;
};

export type OverwriteShiftSlotInput = {
  shiftSlotId: Scalars['ShiftSlotId'];
  shiftsRequired?: Maybe<Scalars['Int']>;
  userIdToAdd?: Maybe<Scalars['AnyId']>;
  userIdToRemove?: Maybe<Scalars['AnyId']>;
};

export type OverwriteShiftSlotPayload = {
  __typename: 'OverwriteShiftSlotPayload';
  shiftSlot?: Maybe<ShiftSlot>;
  error?: Maybe<Scalars['String']>;
};

/** Generic pagination information. We can put things like count/total in here as well */
export type PageInfo = {
  __typename: 'PageInfo';
  hasNextPage: Scalars['Boolean'];
  hasPreviousPage: Scalars['Boolean'];
  startCursor?: Maybe<Scalars['String']>;
  endCursor?: Maybe<Scalars['String']>;
};

export type ParentNotExistProductCatalogDraftFromSellableError = ErrorMessage & {
  __typename: 'ParentNotExistProductCatalogDraftFromSellableError';
  errorMessage: Scalars['String'];
};

export type ParsedPhoneNumber = {
  __typename: 'ParsedPhoneNumber';
  /** e.g. +1 for US/Canada, +44 for UK */
  countryCode: Scalars['String'];
  /** e.g. US, CA, UK */
  regionCode: Scalars['String'];
  /** e.g. 4151234567 for a US number +14151234567 */
  nationalNumber: Scalars['String'];
};

export type PartitionDefinition = {
  __typename: 'PartitionDefinition';
  treatmentValue: Scalars['String'];
  /** The percentage allocated to this partition. 60 means 60% */
  percentage: Scalars['Int'];
};

export type PartitionDefinitionInput = {
  treatmentValue: Scalars['String'];
  percentage: Scalars['Int'];
};

export type PartnerFulfillmentOrderSource = FulfillmentOrderSource & {
  __typename: 'PartnerFulfillmentOrderSource';
  type: FulfillmentOrderSourceType;
  /** order id from partner merchant */
  merchantOrderId?: Maybe<Scalars['String']>;
  estimatedDeliveryAt?: Maybe<Scalars['Date']>;
  maxEstimatedDeliveryAt?: Maybe<Scalars['Date']>;
  tax?: Maybe<MonetaryAmount>;
  shippingCost?: Maybe<MonetaryAmount>;
  quote?: Maybe<MonetaryAmount>;
  lineItemCosts: Array<LineItemFulfillmentCost>;
};

export type PartnerUser = {
  __typename: 'PartnerUser';
  /**
   * This needs to AnyId instead of PartnerUserId since it is used with other identity objects such as User
   * in a few union type.  Graphql will complain if the same field return different types
   */
  id: Scalars['AnyId'];
  user: User;
  roles: Array<Scalars['String']>;
};


export type PathAttributeValue = {
  attributeValueType: PathAttributeValueType;
};

export enum PathAttributeValueType {
  STATIC = 'STATIC'
}


export type PathCommonQuestionSchemaFields = {
  __typename: 'PathCommonQuestionSchemaFields';
  questionText?: Maybe<PathTemplateText>;
  questionSubText?: Maybe<PathTemplateText>;
  inputLabel?: Maybe<PathTemplateText>;
  required: Scalars['Boolean'];
};

export type PathCommonQuestionSchemaFieldsUpdateEditorCommandInput = {
  id?: Maybe<Scalars['PathQuestionSchemaId']>;
  questionText?: Maybe<Scalars['String']>;
  questionSubText?: Maybe<Scalars['String']>;
  inputLabel?: Maybe<Scalars['String']>;
  required?: Maybe<Scalars['Boolean']>;
};

export type PathCompletedPathGraphFlowRequestEvent = PathGraphFlowRequestEvent & {
  __typename: 'PathCompletedPathGraphFlowRequestEvent';
  nodeReferences: Array<PathNodeMaterializedReference>;
};

export type PathCondition = {
  id?: Maybe<Scalars['String']>;
  conditionType: PathConditionType;
};

export type PathConditionAttributeEnumDeclaration = PathConditionEnumDeclaration & {
  __typename: 'PathConditionAttributeEnumDeclaration';
  declarationType: PathConditionEnumDeclarationType;
  attributeSchemaRevision: AttributeSchemaRevision;
};

export type PathConditionAttributeEnumDeclarationCommandInput = {
  attributeSchemaId: Scalars['AttributeSchemaId'];
};

export type PathConditionAttributeOperand = PathConditionOperand & {
  __typename: 'PathConditionAttributeOperand';
  valueType: PathConditionOperandValueType;
  enumDefinition?: Maybe<PathConditionEnumDefinition>;
  attributeSchemaRevision: AttributeSchemaRevision;
};

export type PathConditionAttributeOperandEditorCommandInput = {
  attributeSchemaId?: Maybe<Scalars['AttributeSchemaId']>;
};

export type PathConditionComparison = PathCondition & {
  __typename: 'PathConditionComparison';
  id?: Maybe<Scalars['String']>;
  conditionType: PathConditionType;
  operatorTypeDescription?: Maybe<PathConditionOperatorTypeDescription>;
  operands: Array<PathConditionOperand>;
  /** Given the currently entered data, show the available operator and operand type combinations */
  availableOperators: Array<PathConditionOperator>;
};

export type PathConditionComparisonEditorCommandInput = {
  id?: Maybe<Scalars['String']>;
  operatorType?: Maybe<PathConditionOperatorType>;
  operands: Array<PathConditionOperandEditorCommandInput>;
};

export type PathConditionEditorCommandInput = {
  logical?: Maybe<PathConditionLogicalEditorCommandInput>;
  comparison?: Maybe<PathConditionComparisonEditorCommandInput>;
};

export type PathConditionEnumDeclaration = {
  declarationType: PathConditionEnumDeclarationType;
};

export type PathConditionEnumDeclarationCommandInput = {
  attribute?: Maybe<PathConditionAttributeEnumDeclarationCommandInput>;
  static?: Maybe<PathConditionStaticEnumDeclarationCommandInput>;
};

export enum PathConditionEnumDeclarationType {
  ATTRIBUTE = 'ATTRIBUTE',
  STATIC = 'STATIC'
}

export type PathConditionEnumDefinition = {
  __typename: 'PathConditionEnumDefinition';
  declaration: PathConditionEnumDeclaration;
  items: Array<PathConditionEnumDefinitionItem>;
};

export type PathConditionEnumDefinitionItem = {
  __typename: 'PathConditionEnumDefinitionItem';
  value: Scalars['String'];
  displayName: Scalars['String'];
};

export type PathConditionExperimentOperand = PathConditionOperand & {
  __typename: 'PathConditionExperimentOperand';
  valueType: PathConditionOperandValueType;
  experimentName: Scalars['String'];
  experiment?: Maybe<ExperimentDefinition>;
};

export type PathConditionExperimentOperandEditorCommandInput = {
  experimentName: Scalars['String'];
};

export type PathConditionLiteralBigDecimalEditorCommandInput = {
  bigDecimalValues: Array<Scalars['BigDecimal']>;
  multiValued: Scalars['Boolean'];
};

export type PathConditionLiteralBigDecimalOperand = PathConditionOperand & {
  __typename: 'PathConditionLiteralBigDecimalOperand';
  valueType: PathConditionOperandValueType;
  bigDecimalValues: Array<Scalars['BigDecimal']>;
  multiValued: Scalars['Boolean'];
};

export type PathConditionLiteralBigDecimalRangeEditorCommandInput = {
  bigDecimalRangeValues: Array<BigDecimalRangeInput>;
  multiValued: Scalars['Boolean'];
};

export type PathConditionLiteralBigDecimalRangeOperand = PathConditionOperand & {
  __typename: 'PathConditionLiteralBigDecimalRangeOperand';
  valueType: PathConditionOperandValueType;
  bigDecimalRangeValues: Array<BigDecimalRange>;
  multiValued: Scalars['Boolean'];
};

export type PathConditionLiteralEnumEditorCommandInput = {
  enumValues: Array<Scalars['String']>;
  multiValued: Scalars['Boolean'];
  enumDeclaration: PathConditionEnumDeclarationCommandInput;
};

export type PathConditionLiteralEnumOperand = PathConditionOperand & {
  __typename: 'PathConditionLiteralEnumOperand';
  valueType: PathConditionOperandValueType;
  enumDefinition?: Maybe<PathConditionEnumDefinition>;
  enumValues: Array<Scalars['String']>;
  multiValued: Scalars['Boolean'];
};

export type PathConditionLiteralLongEditorCommandInput = {
  longValues: Array<Scalars['Long']>;
  multiValued: Scalars['Boolean'];
};

export type PathConditionLiteralLongOperand = PathConditionOperand & {
  __typename: 'PathConditionLiteralLongOperand';
  valueType: PathConditionOperandValueType;
  longValues: Array<Scalars['Long']>;
  multiValued: Scalars['Boolean'];
};

export type PathConditionLiteralLongRangeEditorCommandInput = {
  longRangeValues: Array<LongRangeInput>;
  multiValued: Scalars['Boolean'];
};

export type PathConditionLiteralLongRangeOperand = PathConditionOperand & {
  __typename: 'PathConditionLiteralLongRangeOperand';
  valueType: PathConditionOperandValueType;
  longRangeValues: Array<LongRange>;
  multiValued: Scalars['Boolean'];
};

export type PathConditionLiteralStringEditorCommandInput = {
  stringValues: Array<Scalars['String']>;
  multiValued: Scalars['Boolean'];
};

export type PathConditionLiteralStringOperand = PathConditionOperand & {
  __typename: 'PathConditionLiteralStringOperand';
  valueType: PathConditionOperandValueType;
  stringValues: Array<Scalars['String']>;
  multiValued: Scalars['Boolean'];
};

export type PathConditionLogical = PathCondition & {
  __typename: 'PathConditionLogical';
  id?: Maybe<Scalars['String']>;
  logicalType: PathConditionLogicalType;
  conditionType: PathConditionType;
  conditions: Array<PathCondition>;
};

export type PathConditionLogicalEditorCommandInput = {
  id?: Maybe<Scalars['String']>;
  logicalType: PathConditionLogicalType;
  conditions: Array<PathConditionEditorCommandInput>;
};

export enum PathConditionLogicalType {
  AND = 'AND',
  OR = 'OR'
}

export type PathConditionOperand = {
  valueType: PathConditionOperandValueType;
};

export type PathConditionOperandEditorCommandInput = {
  attribute?: Maybe<PathConditionAttributeOperandEditorCommandInput>;
  experiment?: Maybe<PathConditionExperimentOperandEditorCommandInput>;
  repositoryEntry?: Maybe<PathConditionRepositoryEntryOperandEditorCommandInput>;
  literalLong?: Maybe<PathConditionLiteralLongEditorCommandInput>;
  literalLongRange?: Maybe<PathConditionLiteralLongRangeEditorCommandInput>;
  literalBigDecimal?: Maybe<PathConditionLiteralBigDecimalEditorCommandInput>;
  literalBigDecimalRange?: Maybe<PathConditionLiteralBigDecimalRangeEditorCommandInput>;
  literalString?: Maybe<PathConditionLiteralStringEditorCommandInput>;
  literalEnum?: Maybe<PathConditionLiteralEnumEditorCommandInput>;
};

export type PathConditionOperandRepository = {
  __typename: 'PathConditionOperandRepository';
  id: Scalars['PathConditionOperandRepositoryId'];
  displayName?: Maybe<Scalars['String']>;
  entries: Array<PathConditionOperandRepositoryEntry>;
};

export type PathConditionOperandRepositoryEntry = PathConditionOperand & {
  __typename: 'PathConditionOperandRepositoryEntry';
  id: Scalars['PathConditionOperandRepositoryEntryId'];
  valueType: PathConditionOperandValueType;
  displayName: Scalars['String'];
  repository: PathConditionOperandRepository;
  enumDefinition?: Maybe<PathConditionEnumDefinition>;
};



export type PathConditionOperandValueType = {
  __typename: 'PathConditionOperandValueType';
  name: PathConditionOperandValueTypeName;
  multiValued: Scalars['Boolean'];
};

export enum PathConditionOperandValueTypeName {
  LONG = 'LONG',
  LONG_RANGE = 'LONG_RANGE',
  BIG_DECIMAL = 'BIG_DECIMAL',
  BIG_DECIMAL_RANGE = 'BIG_DECIMAL_RANGE',
  STRING = 'STRING',
  ENUM = 'ENUM',
  LOCAL_DATE = 'LOCAL_DATE',
  LOCAL_DATE_RANGE = 'LOCAL_DATE_RANGE',
  LOCAL_TIME = 'LOCAL_TIME',
  LOCAL_TIME_RANGE = 'LOCAL_TIME_RANGE',
  LOCAL_DATE_TIME = 'LOCAL_DATE_TIME',
  LOCAL_DATE_TIME_RANGE = 'LOCAL_DATE_TIME_RANGE',
  ZONE_ID = 'ZONE_ID',
  DURATION = 'DURATION',
  ID = 'ID',
  BOOLEAN = 'BOOLEAN'
}

export type PathConditionOperator = {
  __typename: 'PathConditionOperator';
  operatorTypeDescription?: Maybe<PathConditionOperatorTypeDescription>;
  operandTypes: Array<PathConditionOperandValueType>;
};

export enum PathConditionOperatorType {
  TRUE = 'TRUE',
  FALSE = 'FALSE',
  EQUAL = 'EQUAL',
  NOT_EQUAL = 'NOT_EQUAL',
  LESSER_THAN = 'LESSER_THAN',
  LESSER_THAN_OR_EQUAL = 'LESSER_THAN_OR_EQUAL',
  GREATER_THAN = 'GREATER_THAN',
  GREATER_THAN_OR_EQUAL = 'GREATER_THAN_OR_EQUAL',
  ONE_OF = 'ONE_OF',
  NOT_ONE_OF = 'NOT_ONE_OF',
  EXISTS = 'EXISTS',
  DOES_NOT_EXIST = 'DOES_NOT_EXIST',
  ENCLOSED_BY = 'ENCLOSED_BY',
  CONNECTED = 'CONNECTED',
  IN_RANGE = 'IN_RANGE',
  CONTAINS = 'CONTAINS',
  DOES_NOT_CONTAIN = 'DOES_NOT_CONTAIN'
}

export type PathConditionOperatorTypeDescription = {
  __typename: 'PathConditionOperatorTypeDescription';
  enumType: PathConditionOperatorType;
  displayName: Scalars['String'];
};

export type PathConditionRepositoryEntryOperandEditorCommandInput = {
  repositoryEntryId: Scalars['PathConditionOperandRepositoryEntryId'];
};

export type PathConditionStaticEnumDeclaration = PathConditionEnumDeclaration & {
  __typename: 'PathConditionStaticEnumDeclaration';
  declarationType: PathConditionEnumDeclarationType;
  staticReference: Scalars['String'];
};

export type PathConditionStaticEnumDeclarationCommandInput = {
  staticReference: Scalars['String'];
};

export enum PathConditionType {
  COMPARISON = 'COMPARISON',
  LOGICAL = 'LOGICAL'
}

export type PathEdge = {
  __typename: 'PathEdge';
  fromPort: PathPort;
  toPort: PathPort;
  editable: Scalars['Boolean'];
};

export type PathEdgeInput = {
  fromPort: PathPortInput;
  toPort: PathPortInput;
};

export type PathEditorContext = {
  __typename: 'PathEditorContext';
  schemaRevision: CommonPathSchemaRevision;
  editorStateId: Scalars['PathEditorStateId'];
  graph: RichPathGraph;
  undoOperationLog: Array<PathSchemaOperationLogEntry>;
  redoOperationLog: Array<PathSchemaOperationLogEntry>;
  eligibleDestinationPorts: Array<PathPort>;
  eligibleNodesToMove: Array<Scalars['PathNodeId']>;
  conditionOperandRepositories: Array<PathConditionOperandRepository>;
};


export type PathEditorContextUndoOperationLogArgs = {
  first?: Maybe<Scalars['Int']>;
};


export type PathEditorContextRedoOperationLogArgs = {
  first?: Maybe<Scalars['Int']>;
};


export type PathEditorContextEligibleDestinationPortsArgs = {
  fromPort: PathPortInput;
};


export type PathEditorContextEligibleNodesToMoveArgs = {
  moveDestination: PathNodeMoveDestinationInput;
};

export type PathEditorEditSideEffect = {
  __typename: 'PathEditorEditSideEffect';
  removedNodes: Array<PathEditorRemovedNodeSummary>;
  /** Specific operation log entry to undo this exact operation */
  undoOperationLogEntry?: Maybe<PathSchemaOperationLogEntry>;
};

export type PathEditorRemovedNodeSummary = {
  __typename: 'PathEditorRemovedNodeSummary';
  id: Scalars['PathNodeId'];
  configType: PathNodeConfigType;
  editorViewModel: PathNodeEditorViewModel;
};

export type PathEditorRichText = {
  __typename: 'PathEditorRichText';
  contentParts: Array<PathEditorRichTextContentPart>;
};

export type PathEditorRichTextContentPart = {
  partType: PathEditorRichTextContentPartType;
};

export enum PathEditorRichTextContentPartType {
  TEXT = 'TEXT',
  NEW_LINE = 'NEW_LINE'
}


export type PathEditorValidationError = {
  __typename: 'PathEditorValidationError';
  id: Scalars['String'];
  nodeId?: Maybe<Scalars['PathNodeId']>;
  errorType: PathEditorValidationErrorType;
  errorTier: PathEditorValidationErrorTier;
  errorMessage?: Maybe<Scalars['String']>;
  targetPath: Array<PathEditorValidationErrorTarget>;
};

export type PathEditorValidationErrorContainer = {
  /** Simple and clearly separates owned vs aggregated errors. Can do this at the top level as well. */
  errors: Array<PathEditorValidationError>;
  childErrors: Array<PathEditorValidationError>;
};

export type PathEditorValidationErrorTarget = {
  id: Scalars['String'];
  targetType: PathEditorValidationErrorTargetType;
};

export enum PathEditorValidationErrorTargetType {
  QUESTION = 'QUESTION',
  LIST_QUESTION_CHOICE = 'LIST_QUESTION_CHOICE',
  BRANCH_RULE = 'BRANCH_RULE',
  PORT = 'PORT'
}

export enum PathEditorValidationErrorTier {
  MISSING_DATA = 'MISSING_DATA',
  INVALID_DATA = 'INVALID_DATA'
}

export enum PathEditorValidationErrorType {
  MISSING_SLUG = 'MISSING_SLUG',
  MALFORMED_SLUG = 'MALFORMED_SLUG',
  DUPLICATE_SLUG = 'DUPLICATE_SLUG',
  BRANCH_CONTAINER_RULES_EMPTY = 'BRANCH_CONTAINER_RULES_EMPTY',
  CREATE_REQUEST_LEAD_MISSING_CATEGORY = 'CREATE_REQUEST_LEAD_MISSING_CATEGORY',
  CREATE_EXPERT_APPLICATION_MISSING_CATEGORY = 'CREATE_EXPERT_APPLICATION_MISSING_CATEGORY',
  QUESTIONS_MISSING_ATTRIBUTE = 'QUESTIONS_MISSING_ATTRIBUTE',
  QUESTIONS_INVALID_ATTRIBUTE = 'QUESTIONS_INVALID_ATTRIBUTE',
  QUESTIONS_CHOICES_EMPTY = 'QUESTIONS_CHOICES_EMPTY',
  QUESTIONS_CHOICES_MISSING_TEXT_AND_IMAGE = 'QUESTIONS_CHOICES_MISSING_TEXT_AND_IMAGE',
  QUESTIONS_CHOICES_MISSING_ATTRIBUTE_VALUE = 'QUESTIONS_CHOICES_MISSING_ATTRIBUTE_VALUE',
  QUESTIONS_CHOICES_INVALID_ATTRIBUTE_VALUE = 'QUESTIONS_CHOICES_INVALID_ATTRIBUTE_VALUE',
  QUESTIONS_EMPTY = 'QUESTIONS_EMPTY',
  CONDITION_MISSING_OPERAND = 'CONDITION_MISSING_OPERAND',
  CONDITION_MISSING_OPERATOR = 'CONDITION_MISSING_OPERATOR',
  CONDITION_INVALID_OPERAND_OPERATOR_COMBINATION = 'CONDITION_INVALID_OPERAND_OPERATOR_COMBINATION',
  PATH_SCHEMA_REFERENCE_INVALID = 'PATH_SCHEMA_REFERENCE_INVALID',
  PATH_SCHEMA_FRAGMENT_REFERENCE_INVALID = 'PATH_SCHEMA_FRAGMENT_REFERENCE_INVALID',
  MISSING_EDGE = 'MISSING_EDGE'
}

/**
 * =============================
 * Path Schema, Flow, & Question
 * =============================
 */
export type PathFlow = {
  __typename: 'PathFlow';
  id: Scalars['PathFlowId'];
  /** Displayable title for the path flow; will be used to eventually derive the request name as well */
  title?: Maybe<TextViewModel>;
  /** Once the user completes the flow, this will be true and no further modifications to the flow are possible */
  completed: Scalars['Boolean'];
  /** When completed=true, this will signify the action that should be performed. */
  onComplete?: Maybe<PathFlowOnComplete>;
  /**
   * When completed=true, there will be a generated Request from this path as well.
   * NOTE: Request schema included in this file; included separately
   * Unique slug for this path flow variant to add to the URL. .e.g.: "watches", "watches-sf", "massages", ...
   */
  slug: Scalars['String'];
  /** Styling that should be applied when rendering the path flow */
  theme: PathFlowTheme;
  /** The category this path is associated with */
  category?: Maybe<Category>;
  /**
   * Server understands client (e.g.: react native with shipped code) - client will only recieve question types they understand
   * You'll get the sequence of static pages until you hit the first dynamic branching step. You can either
   * 1) Go through each step you have cached and as you select, submit the mutation to save and optimistically
   *    show the next screen (if you have it)
   * 2) Each mutation you do returns the updated PathFlow. You'll need to depend on this if there is a branching step
   *    (PathFlowPage.requiresServerSyncAfterSubmit=true), or you don't have the next step cached.
   * Pagination follows GraphQL Relay Connections standard; first = 1 will get you one page. after accepts the "cursor" field
   * from Edge types and will give results after that cursor.
   */
  pagesConnection: PathFlowPagesConnection;
  /** The user who created this path flow */
  createdBy?: Maybe<User>;
};


/**
 * =============================
 * Path Schema, Flow, & Question
 * =============================
 */
export type PathFlowPagesConnectionArgs = {
  first?: Maybe<Scalars['Int']>;
  after?: Maybe<Scalars['String']>;
};

export type PathFlowBySlugPayload = {
  __typename: 'PathFlowBySlugPayload';
  flow?: Maybe<PathFlow>;
};


export type PathFlowOnComplete = PathFlowOnCompleteBroadcast | PathFlowOnCompleteLead | PathFlowOnCompleteNewPath | PathFlowOnCompleteDealRequest | PathFlowOnCompleteExpertReview | PathFlowOnCompleteRedirectOnly | PathFlowOnCompleteRedirectWithUpsert | PathFlowOnCompleteExpertApplication;

/**
 * On complete of a path flow, a conversation is generated
 * DEPRECATED: Use PathFlowOnCompleteLead
 */
export type PathFlowOnCompleteBroadcast = {
  __typename: 'PathFlowOnCompleteBroadcast';
  /** Location the client should navigate */
  location: PathFlowOnCompleteRedirectLocation;
  /** Actual conversation that was created */
  conversation: Conversation;
};

export type PathFlowOnCompleteDealRequest = {
  __typename: 'PathFlowOnCompleteDealRequest';
  dealRequest: DealRequest;
  location: PathFlowOnCompleteRedirectLocation;
};

export type PathFlowOnCompleteExpertApplication = {
  __typename: 'PathFlowOnCompleteExpertApplication';
  application: ExpertApplication;
  location: PathFlowOnCompleteRedirectLocation;
};

export type PathFlowOnCompleteExpertReview = {
  __typename: 'PathFlowOnCompleteExpertReview';
  review: ConsumerExpertReview;
  location: PathFlowOnCompleteRedirectLocation;
};

export type PathFlowOnCompleteLead = {
  __typename: 'PathFlowOnCompleteLead';
  /** Location the client should navigate */
  location: PathFlowOnCompleteRedirectLocation;
  /** The new lead that was created, or existing lead that was re-used */
  lead: Lead;
  /** Conversation for the lead */
  conversation: Conversation;
};

/** On complete of a path flow, a new path is generated that should be navigated to */
export type PathFlowOnCompleteNewPath = {
  __typename: 'PathFlowOnCompleteNewPath';
  /** New path flow that was generated that the client should navigate to and start */
  flow: PathFlow;
};

export enum PathFlowOnCompleteRedirectLocation {
  /** Reload the current page, this is used for paths that happen in-place */
  RELOAD_CURRENT_PAGE = 'RELOAD_CURRENT_PAGE',
  /** Expert profile page with selection screen. Only valid for paths completed with a lead. */
  EXPERT_PROFILE = 'EXPERT_PROFILE',
  /** Default inbox page */
  INBOX = 'INBOX',
  /** Redirect to login page */
  LOGIN = 'LOGIN',
  /** Redirect to the completion page after an application is submitted */
  APPLY_FINISH = 'APPLY_FINISH',
  /** Redirect to selected department page */
  DEPARTMENT_PAGE = 'DEPARTMENT_PAGE',
  /** Redirect to selected category page */
  CATEGORY = 'CATEGORY',
  /**
   * For golf experiment only, a redirect that will take the user back into
   * the path system to add their phone number
   */
  PHONE_COLLECTION_PATH = 'PHONE_COLLECTION_PATH'
}

/**
 * On complete of a path flow, the user should be navigated to the specified location.
 * This on complete type is typically used when the path flow isn't relevant, and we
 * want to direct the user to do something else (e.g.: already has an account - login).
 */
export type PathFlowOnCompleteRedirectOnly = {
  __typename: 'PathFlowOnCompleteRedirectOnly';
  /** Location the client should navigate */
  location: PathFlowOnCompleteRedirectLocation;
};

/**
 * This is the same as the PathFlowOnCompleteRedirectOnly, but the client needs to be able to
 * discern when a lead is coming from an upsert or just a vanilla redirect
 */
export type PathFlowOnCompleteRedirectWithUpsert = {
  __typename: 'PathFlowOnCompleteRedirectWithUpsert';
  /** Location the client should navigate */
  location: PathFlowOnCompleteRedirectLocation;
};

export type PathFlowPage = {
  __typename: 'PathFlowPage';
  id: Scalars['PathFlowPageId'];
  /** Parent PathFlow this page is a part of */
  flow: PathFlow;
  /** Additional metadata that can be used to customize behavior or rendering of this page */
  metadata: Array<PathFlowPageMetadata>;
  /**
   * Unique identifier for this flow "type". you can pick this up from the client and do any customizations as required.
   * String may be something like: "dial_size". Not to be exposed in the ui/url, only for internal use
   */
  internalName: Scalars['String'];
  /** Display text for page */
  title?: Maybe<TextViewModel>;
  /** Top level image for page */
  titleImage?: Maybe<ImageViewModel>;
  /** Interstitial text for the page. If present, there will be no quesetions on the page. */
  interstitialText?: Maybe<TextViewModel>;
  /** Questions to display on this page. If non-empty, there will be no interstitial text */
  questions: Array<PathFlowQuestion>;
  /**
   * Notifications to display at the top of the page (e.g.: contextual tool tip)
   * Crappy name since we'll probably deprecate this for a richer model which can use the proper "notification" name
   */
  notificationTexts: Array<TextViewModel>;
  /**
   * Unique slug for this page within the parent path flow which should be added to the URL. .e.g.: "flexibility", "distance"
   * Note that when assembling the url, the parent path flow page slug should be used as the preceeding path component. So:
   * http://www.deal.com/request/{pathFlow.slug}/{pathFlowPage.slug}
   */
  slug: Scalars['String'];
  /**
   * Questions from this and previous pages must be submitted before proceeding
   * This may be true due to enforced input validation. e.g.: question doesn't
   * introduce branching, but does special server side validation.
   * This also may be true due to conditional skip targets. e.g..: question does
   * introduce branching, and dynamically selects next page.
   */
  requiresServerSyncAfterSubmit: Scalars['Boolean'];
  /**
   * How close are we to completing this flow. Will be a value from 0 to 100, inclusive
   * Note: Since flows can branch, this number is not guaranteed to progress in a linear fashion
   */
  completionPercentage: Scalars['Int'];
  /** If the user completed this page by submitting it and/or all associated questions on the page */
  completed: Scalars['Boolean'];
  /** submit button text to use when submitting a non-empty response. If empty, should fallback to client default */
  submitButtonText?: Maybe<TextViewModel>;
  /**
   * submit button text to use when all questions are optional, and none of them are filled out. If empty, should
   * fallback to client default.
   */
  skipButtonText?: Maybe<TextViewModel>;
};


export type PathFlowPageMetadata = {
  type: PathFlowPageMetadataType;
};

export enum PathFlowPageMetadataType {
  INTERSTITIAL = 'INTERSTITIAL',
  CUSTOM = 'CUSTOM',
  /** Below are deprecated */
  LOADING_QUESTIONS = 'LOADING_QUESTIONS',
  CONNECTING_TO_OPERATOR = 'CONNECTING_TO_OPERATOR',
  FINDING_MERCHANTS = 'FINDING_MERCHANTS',
  HIGH_SECURITY = 'HIGH_SECURITY',
  WELCOME = 'WELCOME'
}

export type PathFlowPagePayload = {
  __typename: 'PathFlowPagePayload';
  page?: Maybe<PathFlowPage>;
};

export type PathFlowPagesConnection = {
  __typename: 'PathFlowPagesConnection';
  edges: Array<PathFlowPagesEdge>;
  pageInfo?: Maybe<PageInfo>;
};

export type PathFlowPagesEdge = {
  __typename: 'PathFlowPagesEdge';
  node: PathFlowPage;
  cursor: Scalars['String'];
};

export type PathFlowPayload = {
  __typename: 'PathFlowPayload';
  errorCode?: Maybe<GetEntityErrorCode>;
  maskedUserHandles?: Maybe<Array<MaskedUserHandle>>;
  flow?: Maybe<PathFlow>;
};

export type PathFlowQuestion = {
  /**
   * Similar to parent's PathFlowPage.internalName, unique identifier for a question within a page.
   * String may be something like: "products.watches.dial_size.diameter"
   * Not to be exposed in the ui/url, only for internal use like customizing UI widget
   */
  internalName: Scalars['String'];
  questionText?: Maybe<TextViewModel>;
  questionSubText?: Maybe<TextViewModel>;
  required: Scalars['Boolean'];
  /** An icon that's placed immediately above the question input */
  inputIconImage?: Maybe<ImageViewModel>;
  /** A label that's placed immediately above the question input; should be placed after the icon if inputIconImage is present */
  inputLabel?: Maybe<TextViewModel>;
  /** All of the attributes that have been entered in the path so far */
  attributes: Array<Attribute>;
  /** Pull out a particular attribute value by name */
  attribute?: Maybe<Attribute>;
};


export type PathFlowQuestionAttributeArgs = {
  attributeName?: Maybe<Scalars['String']>;
};

export type PathFlowTheme = {
  __typename: 'PathFlowTheme';
  type: PathFlowThemeType;
};

export enum PathFlowThemeType {
  DEFAULT = 'DEFAULT',
  SNOWBOARD = 'SNOWBOARD',
  CHAT_LIKE = 'CHAT_LIKE'
}

export type PathGraphAuthor = Operator | SystemUser | ImportedIdentity;

export type PathGraphContainer = {
  slug: Scalars['String'];
  /** @deprecated Superseded by the `created` field */
  createdAt: Scalars['Date'];
  updatedAt: Scalars['Date'];
  created: PathGraphContainerAuditStamp;
  published?: Maybe<PathGraphContainerAuditStamp>;
  archived?: Maybe<PathGraphContainerAuditStamp>;
  revisionNumber: Scalars['Int'];
  revisionHistory: Array<PathGraphContainer>;
  state: PathGraphContainerState;
  /** @deprecated Superseded by the `created` field */
  createdBy: PathGraphAuthor;
  approvalRequest?: Maybe<ApprovalRequest>;
  importedFromEnvironment?: Maybe<Environment>;
};

export type PathGraphContainerAuditStamp = {
  __typename: 'PathGraphContainerAuditStamp';
  by: PathGraphAuthor;
  at: Scalars['Date'];
};

export type PathGraphContainerQueryInput = {
  keywords?: Maybe<Scalars['String']>;
  /** Defaults to ALL */
  stateFilter?: Maybe<PathGraphContainerStateFilter>;
};

export enum PathGraphContainerSort {
  NAME = 'NAME',
  UPDATED_AT = 'UPDATED_AT',
  KEYWORD_RELEVANCE = 'KEYWORD_RELEVANCE'
}

export enum PathGraphContainerState {
  DRAFT = 'DRAFT',
  IN_REVIEW = 'IN_REVIEW',
  PUBLISHED = 'PUBLISHED',
  ARCHIVED = 'ARCHIVED'
}

export enum PathGraphContainerStateFilter {
  ALL = 'ALL',
  ALL_INCLUDE_ARCHIVED = 'ALL_INCLUDE_ARCHIVED',
  IN_REVIEW = 'IN_REVIEW',
  DRAFT = 'DRAFT',
  PUBLISHED = 'PUBLISHED'
}

export type PathGraphFlow = {
  __typename: 'PathGraphFlow';
  id: Scalars['PathGraphFlowId'];
  /** Nodes in traversal order */
  nodes: Array<PathNodeFlow>;
  /** Automatically completed once a terminal node is reached */
  completed: Scalars['Boolean'];
  /** Events that happened as part of this request. Should typically be emitted as client side tracking events */
  requestEvents: Array<PathGraphFlowRequestEvent>;
  /**
   * If this path is executing with side effects, or a dry run for testing that
   * remotes all external side effects like account creation
   */
  runMode: PathGraphFlowRunMode;
};


export type PathGraphFlowRequestEvent = {
  /** The node which the event occurred */
  nodeReferences: Array<PathNodeMaterializedReference>;
};

export enum PathGraphFlowRunMode {
  /** Path is executing all actions with real side effects (e.g.: creating accounts, etc) */
  LIVE = 'LIVE',
  /**
   * Path is not executing any operation that produces external side effects (like creating accounts), and instead will
   * attempt to display DryRunInfoPathNodeFlowViewModel in place of action executions to detail what would happen in
   * a real execution.
   */
  DRY_RUN = 'DRY_RUN'
}

/** Denotes an image or icon that's dynamically resolved within the client app */
export type PathImageViewModel = {
  __typename: 'PathImageViewModel';
  imagePath: Scalars['String'];
  imageUrl: Scalars['String'];
};


export type PathNodeConfig = {
  configType: PathNodeConfigType;
};

export type PathNodeConfigEditorNodeConfigCommandInput = {
  createAccountActionUpsert?: Maybe<CreateAccountActionPathNodeConfigUpsertEditorCommandInput>;
  createRequestLeadActionUpsert?: Maybe<CreateRequestLeadActionPathNodeConfigUpsertEditorCommandInput>;
  createExpertApplicationActionUpsert?: Maybe<CreateExpertApplicationActionPathNodeConfigUpsertEditorCommandInput>;
  createConsumerExpertReviewActionUpsert?: Maybe<CreateConsumerExpertReviewActionPathNodeConfigUpsertEditorCommandInput>;
  endPathUpsert?: Maybe<EndPathNodeConfigUpsertEditorCommandInput>;
  pathSchemaFragmentEndPathCreate?: Maybe<PathSchemaFragmentEndPathNodeConfigCreateEditorCommandInput>;
  pathSchemaReferenceUpsert?: Maybe<PathSchemaReferencePathNodeConfigUpsertEditorCommandInput>;
  pathSchemaFragmentReferenceUpsert?: Maybe<PathSchemaFragmentReferencePathNodeConfigUpsertEditorCommandInput>;
  interstitialUpsert?: Maybe<InterstitialPathNodeConfigUpsertEditorCommandInput>;
  questionsUpsert?: Maybe<QuestionsPathNodeConfigUpsertEditorCommandInput>;
  questionsSort?: Maybe<QuestionsPathNodeConfigSortEditorCommandInput>;
  questionsRemove?: Maybe<QuestionsPathNodeConfigRemoveEditorCommandInput>;
  switchQuestionTypeUpdate?: Maybe<SwitchPathQuestionSchemaTypeUpdateEditorCommandInput>;
  questionsDisplayComponentsRemove?: Maybe<QuestionsPathNodeConfigDisplayComponentsRemoveEditorCommandInput>;
  termsAndConditionsQuestionsDisplayComponentUpdate?: Maybe<TermsAndConditionsQuestionsDisplayComponentSchemaFieldsUpdateEditorCommandInput>;
  tcpaComplianceQuestionsDisplayComponentUpdate?: Maybe<TcpaComplianceQuestionsDisplayComponentSchemaFieldsUpdateEditorCommandInput>;
  commonQuestionUpdate?: Maybe<PathCommonQuestionSchemaFieldsUpdateEditorCommandInput>;
  inputTextQuestionUpsert?: Maybe<InputTextPathQuestionSchemaUpsertEditorCommandInput>;
  numericQuestionUpsert?: Maybe<NumericPathQuestionSchemaUpsertEditorCommandInput>;
  listQuestionUpsert?: Maybe<ListPathQuestionSchemaUpsertEditorCommandInput>;
  listQuestionPreFillEnumerationAttributeChoices?: Maybe<ListPathQuestionSchemaPreFillEnumerationAttributeChoicesEditorCommandInput>;
  listQuestionAddChoice?: Maybe<ListPathQuestionSchemaAddChoiceEditorCommandInput>;
  listQuestionUpdateChoice?: Maybe<ListPathQuestionSchemaUpdateChoiceEditorCommandInput>;
  listQuestionSortChoices?: Maybe<ListPathQuestionSchemaSortChoicesEditorCommandInput>;
  listQuestionRemoveChoices?: Maybe<ListPathQuestionSchemaRemoveChoicesEditorCommandInput>;
  dateQuestionUpsert?: Maybe<DatePathQuestionSchemaUpsertEditorCommandInput>;
  branchContainerCreate?: Maybe<BranchContainerPathNodeConfigCreateEditorCommandInput>;
  branchContainerAddRule?: Maybe<BranchContainerPathNodeConfigAddRuleEditorCommandInput>;
  branchContainerUpdateRule?: Maybe<BranchContainerPathNodeConfigUpdateRuleEditorCommandInput>;
  branchContainerSortRules?: Maybe<BranchContainerPathNodeConfigSortRulesEditorCommandInput>;
  branchContainerRemoveRules?: Maybe<BranchContainerPathNodeConfigRemoveRulesEditorCommandInput>;
  branchRuleUpdate?: Maybe<BranchRulePathNodeConfigUpdateEditorCommandInput>;
};

export type PathNodeConfigEditorNodeConfigCommandTargetInput = {
  editNodeId?: Maybe<Scalars['PathNodeId']>;
  nestedRefs?: Maybe<Array<Scalars['String']>>;
  insertEdge?: Maybe<PathEdgeInput>;
  insertFromPort?: Maybe<PathPortInput>;
};

export enum PathNodeConfigType {
  START = 'START',
  PATH_SCHEMA = 'PATH_SCHEMA',
  PATH_SCHEMA_END = 'PATH_SCHEMA_END',
  PATH_SCHEMA_FRAGMENT = 'PATH_SCHEMA_FRAGMENT',
  PATH_SCHEMA_FRAGMENT_END = 'PATH_SCHEMA_FRAGMENT_END',
  PATH_SCHEMA_REFERENCE = 'PATH_SCHEMA_REFERENCE',
  PATH_SCHEMA_FRAGMENT_REFERENCE = 'PATH_SCHEMA_FRAGMENT_REFERENCE',
  QUESTION = 'QUESTION',
  INTERSTITIAL = 'INTERSTITIAL',
  REDIRECT = 'REDIRECT',
  BRANCH_CONTAINER = 'BRANCH_CONTAINER',
  BRANCH_RULE = 'BRANCH_RULE',
  BRANCH_FALLBACK_RULE = 'BRANCH_FALLBACK_RULE',
  CREATE_ACCOUNT_ACTION = 'CREATE_ACCOUNT_ACTION',
  CREATE_REQUEST_LEAD_ACTION = 'CREATE_REQUEST_LEAD_ACTION',
  CREATE_EXPERT_APPLICATION_ACTION = 'CREATE_EXPERT_APPLICATION_ACTION'
}

export type PathNodeDynamicExpanderState = {
  stateType: PathNodeDynamicExpanderStateType;
};

export enum PathNodeDynamicExpanderStateType {
  PATH_SCHEMA_REFERENCE = 'PATH_SCHEMA_REFERENCE'
}

export type PathNodeEditorViewModel = {
  /** Title to display on node when collapsed */
  title?: Maybe<PathEditorRichText>;
  /** Body to display on node when collapsed */
  body?: Maybe<PathEditorRichText>;
  /** Title to display (without showing body) when the node is expanded */
  expandedTitle?: Maybe<PathEditorRichText>;
  /**
   * If this node is "required" where it requires input from the user. There are three states:
   * `null`: Not applicable; this node doesn't have a notion of being required or optional.
   * `false`: This node can be required, but is configured to be optional.
   * `true`: This node is configured to be required.
   */
  isRequired?: Maybe<Scalars['Boolean']>;
};

export enum PathNodeExpanderSetting {
  EXPANDED = 'EXPANDED',
  COLLAPSED = 'COLLAPSED'
}

export type PathNodeFlow = {
  __typename: 'PathNodeFlow';
  id: Scalars['PathNodeId'];
  references: Array<PathNodeMaterializedReference>;
  /** golf-v4b or golf-v4b-contact-collection (path schema + nested fragment chain, connected by dashes) */
  pathGraphSlug: Scalars['String'];
  viewModel: PathNodeFlowViewModel;
};

export type PathNodeFlowInputCommandInput = {
  id: Scalars['PathNodeId'];
  submitInterstitial?: Maybe<SubmitInterstitialPathNodeFlowInputCommandInput>;
  submitQuestions?: Maybe<SubmitQuestionsPathNodeFlowInputCommandInput>;
  inputTextQuestion?: Maybe<InputTextQuestionPathNodeFlowInputCommandInput>;
  numericQuestion?: Maybe<NumericQuestionPathNodeFlowInputCommandInput>;
  listQuestion?: Maybe<ListQuestionPathNodeFlowInputCommandInput>;
  dateQuestion?: Maybe<DateQuestionPathNodeFlowInputCommandInput>;
};

export type PathNodeFlowViewModel = {
  id: Scalars['PathNodeId'];
};


export type PathNodeMaterializedReference = {
  __typename: 'PathNodeMaterializedReference';
  /**
   * The native `PathNodeId` from `owningEntityId`. Specifically when a fragment or path is embedded in another path,
   * the `PathNodeId` becomes a new concatenated result that can't be joined directly to the `PathNodeId` in the
   * schema referenced by `owningEntityId`. This removes the concatenation, and surfaces the exact `PathNodeId` that
   * exists in the schema referenced by `owningEntityId`.
   */
  id: Scalars['PathNodeId'];
  /** Entity, typically a path schema (fragment) revision, that owns the path node */
  owningEntityId: Scalars['AnyId'];
  /** Entity type of `owningEntityId` */
  owningEntityType: RichPathNodeOwningEntityType;
  /**
   * If the path identified by `owningEntityId` is the highest level parent. When an array of these reference objects
   * are created, there will be exactly one reference that has this set to true. For example, for a path flow node,
   * a node that has the nested hierarchy (winter-sports -> snowboard-v5 -> contact-collection -> first-name) will
   * report rootOwner=true only when creating a reference where owningEntityId is the winter-sports path, and will be
   * false for (snowboard-v5 -> contact-collection -> first-name) and (contact-collection -> first-name) references.
   */
  rootOwner: Scalars['Boolean'];
};

export type PathNodeMoveDestinationInput = {
  insertEdge?: Maybe<PathEdgeInput>;
  insertFromPort?: Maybe<PathPortInput>;
};

export type PathPort = {
  __typename: 'PathPort';
  name: Scalars['String'];
  nodeId: Scalars['PathNodeId'];
  portType: PathPortType;
};

export type PathPortInput = {
  name: Scalars['String'];
  nodeId: Scalars['PathNodeId'];
  portType: PathPortType;
};

export enum PathPortType {
  INCOMING = 'INCOMING',
  OUTGOING = 'OUTGOING'
}

export enum PathQuestionDisplayComponentSchemaType {
  /** Show terms and conditions */
  TERMS_AND_CONDITIONS = 'TERMS_AND_CONDITIONS',
  /** Telephone Consumer Protection Act Compliance disclaimer */
  TCPA_COMPLIANCE = 'TCPA_COMPLIANCE'
}

export type PathQuestionSchema = {
  id: Scalars['PathQuestionSchemaId'];
  schemaType: PathQuestionSchemaType;
  commonFields: PathCommonQuestionSchemaFields;
};


export enum PathQuestionSchemaType {
  LIST = 'LIST',
  INPUT_TEXT = 'INPUT_TEXT',
  NUMERIC = 'NUMERIC',
  DATE = 'DATE'
}

/**
 * Directives to modify how the questions are displayed, typically adding new elements to the page like
 * legal disclaimers.
 */
export type PathQuestionsDisplayComponentSchema = {
  displayComponentType: PathQuestionDisplayComponentSchemaType;
};

export type PathSchemaApprovalRequestEntity = ApprovalRequestEntity & {
  __typename: 'PathSchemaApprovalRequestEntity';
  id: Scalars['AnyId'];
  entityType: ApprovalRequestEntityType;
  entityTypeDisplayName: Scalars['String'];
  displayName: Scalars['String'];
  pathSchemaRevision: PathSchemaRevision;
};

export enum PathSchemaDomainType {
  /** "r" is the short form used in slugs */
  REQUEST = 'REQUEST',
  /** "ea" is the short form used in slugs */
  EXPERT_APPLICATION = 'EXPERT_APPLICATION',
  /** "cre" is the short form used in slugs */
  CONSUMER_REVIEW_FOR_EXPERT = 'CONSUMER_REVIEW_FOR_EXPERT'
}

export type PathSchemaFragmentApprovalRequestEntity = ApprovalRequestEntity & {
  __typename: 'PathSchemaFragmentApprovalRequestEntity';
  id: Scalars['AnyId'];
  entityType: ApprovalRequestEntityType;
  entityTypeDisplayName: Scalars['String'];
  displayName: Scalars['String'];
  pathSchemaFragmentRevision: PathSchemaFragmentRevision;
};

export type PathSchemaFragmentEndPathNodeConfig = PathNodeConfig & {
  __typename: 'PathSchemaFragmentEndPathNodeConfig';
  configType: PathNodeConfigType;
};

export type PathSchemaFragmentEndPathNodeConfigCreateEditorCommandInput = {
  _?: Maybe<Scalars['Boolean']>;
};


export type PathSchemaFragmentPathNodeConfig = PathNodeConfig & {
  __typename: 'PathSchemaFragmentPathNodeConfig';
  configType: PathNodeConfigType;
};

export type PathSchemaFragmentReferencePathNodeConfig = PathNodeConfig & {
  __typename: 'PathSchemaFragmentReferencePathNodeConfig';
  configType: PathNodeConfigType;
  /** Will be null if path schema fragment was archived, and is no longer available */
  pathSchemaFragment?: Maybe<PathSchemaFragmentRevision>;
  slug?: Maybe<Scalars['String']>;
};

export type PathSchemaFragmentReferencePathNodeConfigUpsertEditorCommandInput = {
  pathSchemaFragmentId?: Maybe<Scalars['PathSchemaFragmentId']>;
  slug?: Maybe<Scalars['String']>;
};

export type PathSchemaFragmentReferencePathNodeDynamicExpanderState = PathNodeDynamicExpanderState & {
  __typename: 'PathSchemaFragmentReferencePathNodeDynamicExpanderState';
  stateType: PathNodeDynamicExpanderStateType;
  pathSchemaFragment: PathSchemaFragmentRevision;
};

export type PathSchemaFragmentRevision = PathGraphContainer & {
  __typename: 'PathSchemaFragmentRevision';
  id: Scalars['PathSchemaFragmentRevisionId'];
  pathSchemaFragmentId: Scalars['PathSchemaFragmentId'];
  slug: Scalars['String'];
  /** @deprecated Superseded by the `created` field */
  createdAt: Scalars['Date'];
  /** @deprecated Superseded by the `created` field */
  createdBy: PathGraphAuthor;
  created: PathGraphContainerAuditStamp;
  updatedAt: Scalars['Date'];
  published?: Maybe<PathGraphContainerAuditStamp>;
  archived?: Maybe<PathGraphContainerAuditStamp>;
  revisionNumber: Scalars['Int'];
  revisionHistory: Array<PathGraphContainer>;
  state: PathGraphContainerState;
  approvalRequest?: Maybe<ApprovalRequest>;
  importedFromEnvironment?: Maybe<Environment>;
};


export type PathSchemaFragmentRevisionsPagination = {
  __typename: 'PathSchemaFragmentRevisionsPagination';
  pathSchemaFragmentRevisions: Array<PathSchemaFragmentRevision>;
  count: Scalars['Long'];
};


export type PathSchemaOperationLogEntry = {
  __typename: 'PathSchemaOperationLogEntry';
  id: Scalars['PathSchemaOperationLogEntryId'];
  operationNumber: Scalars['Int'];
  summaryText: Scalars['String'];
  author: PathGraphAuthor;
};


export type PathSchemaPathNodeConfig = PathNodeConfig & {
  __typename: 'PathSchemaPathNodeConfig';
  configType: PathNodeConfigType;
  domainType: PathSchemaDomainType;
};

export type PathSchemaReferencePathNodeConfig = PathNodeConfig & {
  __typename: 'PathSchemaReferencePathNodeConfig';
  configType: PathNodeConfigType;
  /** Will be null if path schema was archived, and is no longer available */
  pathSchema?: Maybe<PathSchemaRevision>;
  slug?: Maybe<Scalars['String']>;
};

export type PathSchemaReferencePathNodeConfigUpsertEditorCommandInput = {
  pathSchemaId?: Maybe<Scalars['PathSchemaId']>;
  slug?: Maybe<Scalars['String']>;
};

export type PathSchemaReferencePathNodeDynamicExpanderState = PathNodeDynamicExpanderState & {
  __typename: 'PathSchemaReferencePathNodeDynamicExpanderState';
  stateType: PathNodeDynamicExpanderStateType;
  pathSchema: PathSchemaRevision;
};

export type PathSchemaRevision = PathGraphContainer & {
  __typename: 'PathSchemaRevision';
  id: Scalars['PathSchemaRevisionId'];
  pathSchemaId: Scalars['PathSchemaId'];
  slug: Scalars['String'];
  /** @deprecated Superseded by the `created` field */
  createdAt: Scalars['Date'];
  /** @deprecated Superseded by the `created` field */
  createdBy: PathGraphAuthor;
  created: PathGraphContainerAuditStamp;
  updatedAt: Scalars['Date'];
  published?: Maybe<PathGraphContainerAuditStamp>;
  archived?: Maybe<PathGraphContainerAuditStamp>;
  revisionNumber: Scalars['Int'];
  revisionHistory: Array<PathGraphContainer>;
  domainType: PathSchemaDomainType;
  state: PathGraphContainerState;
  approvalRequest?: Maybe<ApprovalRequest>;
  importedFromEnvironment?: Maybe<Environment>;
};


export type PathSchemaRevisionsPagination = {
  __typename: 'PathSchemaRevisionsPagination';
  pathSchemaRevisions: Array<PathSchemaRevision>;
  count: Scalars['Long'];
};

/** Specify exactly one option */
export type PathSchemaSelectorInput = {
  /** The path will be created by locating the published path schema revision for this history id */
  pathSchemaId?: Maybe<Scalars['PathSchemaId']>;
  /** The path will be created using this exact revision. This is generally useful for administrators testing draft paths. */
  pathSchemaRevisionId?: Maybe<Scalars['PathSchemaRevisionId']>;
  /** The path will be created by locating the published path schema revision for this slug */
  pathSchemaSlug?: Maybe<Scalars['String']>;
  /**
   * This will start by looking up a path schema with the slug
   * "{short form of PathSchemaDomainType}-{categorySlugHierarchyLookup}", for example, given `PathSchemaDomainType.REQUEST`
   * and the "snowboards" category, "r-snowboards" path will be looked up. If this path doesn't exist, this
   * will perform a recursive walk up the category hierarchy until a path schema is located, trying
   * "r-snowboarding", then "r-winter-sports", then finally "r-product".
   * If this is done for `PathSchemaDomainType.EXPERT_APPLICATION`, the lookup will start with
   * "ea-snowboards", and walk up the hierarchy in the same way.
   */
  categorySlugHierarchyLookup?: Maybe<Scalars['String']>;
};

export type PathStaticAttributeValue = PathAttributeValue & {
  __typename: 'PathStaticAttributeValue';
  attributeValueType: PathAttributeValueType;
  attribute: Attribute;
};

export type PathTemplateText = {
  __typename: 'PathTemplateText';
  template?: Maybe<Scalars['String']>;
};

export type PathTextViewModel = {
  __typename: 'PathTextViewModel';
  plainText: Scalars['String'];
};

/** ====== Path validation errors */
export type PathValidationError = {
  __typename: 'PathValidationError';
  /** Which page the error is the associated with */
  pageName?: Maybe<Scalars['String']>;
  /** Which question on the above page the error is associated with. If this is not null, pageId will also be not null. */
  questionName?: Maybe<Scalars['String']>;
  /** Additional "tags" that act something like an error-code, except that a single message may have many tags */
  tags?: Maybe<Array<PathValidationErrorTag>>;
  /** Text describing the validation error which should be displayed to the user */
  message?: Maybe<TextViewModel>;
};

export enum PathValidationErrorTag {
  /** If this error is produced, the client must have the user login, or change the contact information being used to proceed */
  REQUIRES_LOGIN_TO_PROCEED = 'REQUIRES_LOGIN_TO_PROCEED',
  /** Indicates an internal error, typically surfaced if the API is misused, or some type of developer/administrative error. */
  INTERNAL = 'INTERNAL'
}

export type PayComponentCommissionRule = PayComponentRule & {
  __typename: 'PayComponentCommissionRule';
  type: PayComponentType;
  rate: Scalars['BigDecimal'];
};

export type PayComponentCommissionRuleInput = {
  rate: Scalars['BigDecimal'];
};

export type PayComponentCommissionSummary = PayComponentSummary & {
  __typename: 'PayComponentCommissionSummary';
  type: PayComponentType;
  payAmount: MonetaryAmount;
  lineCount: Scalars['Int'];
  basisAmount: MonetaryAmount;
};

export type PayComponentFirstShiftsGuaranteedRule = PayComponentRule & {
  __typename: 'PayComponentFirstShiftsGuaranteedRule';
  type: PayComponentType;
  amount: MonetaryAmount;
  shifts: Scalars['Int'];
};

export type PayComponentFirstShiftsGuaranteedRuleInput = {
  amount: MonetaryAmountInput;
  shifts: Scalars['Int'];
};

export type PayComponentFirstShiftsGuaranteedSummary = PayComponentSummary & {
  __typename: 'PayComponentFirstShiftsGuaranteedSummary';
  type: PayComponentType;
  payAmount: MonetaryAmount;
  lineCount: Scalars['Int'];
};

export type PayComponentHourlyOnCallRule = PayComponentRule & {
  __typename: 'PayComponentHourlyOnCallRule';
  type: PayComponentType;
  hourlyPayAmount: MonetaryAmount;
};

export type PayComponentHourlyOnCallRuleInput = {
  hourlyPayAmount: MonetaryAmountInput;
};

export type PayComponentHourlyOnCallSummary = PayComponentSummary & {
  __typename: 'PayComponentHourlyOnCallSummary';
  type: PayComponentType;
  payAmount: MonetaryAmount;
  lineCount: Scalars['Int'];
  minutes: Scalars['Int'];
};

export type PayComponentManualAdjustmentSummary = PayComponentSummary & {
  __typename: 'PayComponentManualAdjustmentSummary';
  type: PayComponentType;
  payAmount: MonetaryAmount;
  lineCount: Scalars['Int'];
};

export type PayComponentQualityConversationRule = PayComponentRule & {
  __typename: 'PayComponentQualityConversationRule';
  type: PayComponentType;
  amountPerConversation: MonetaryAmount;
  amountPerSurgeShiftLead?: Maybe<MonetaryAmount>;
};

export type PayComponentQualityConversationRuleInput = {
  amountPerConversation: MonetaryAmountInput;
  amountPerSurgeShiftLead?: Maybe<MonetaryAmountInput>;
};

export type PayComponentQualityConversationSummary = PayComponentSummary & {
  __typename: 'PayComponentQualityConversationSummary';
  type: PayComponentType;
  payAmount: MonetaryAmount;
  lineCount: Scalars['Int'];
};

export type PayComponentReferralFirstOrderRule = PayComponentRule & {
  __typename: 'PayComponentReferralFirstOrderRule';
  type: PayComponentType;
  feeToExpert: MonetaryAmount;
  minimumOrderAmount: MonetaryAmount;
};

export type PayComponentReferralFirstOrderRuleInput = {
  feeToExpert: MonetaryAmountInput;
  minimumOrderAmount: MonetaryAmountInput;
};

export type PayComponentReferralFirstOrderSummary = PayComponentSummary & {
  __typename: 'PayComponentReferralFirstOrderSummary';
  type: PayComponentType;
  payAmount: MonetaryAmount;
  lineCount: Scalars['Int'];
};

export type PayComponentRule = {
  type: PayComponentType;
};

export type PayComponentRuleInput = {
  commission?: Maybe<PayComponentCommissionRuleInput>;
  tip?: Maybe<PayComponentTipRuleInput>;
  hourlyOnCall?: Maybe<PayComponentHourlyOnCallRuleInput>;
  shiftsGuaranteed?: Maybe<PayComponentFirstShiftsGuaranteedRuleInput>;
  qualityConversation?: Maybe<PayComponentQualityConversationRuleInput>;
  referralFirstOrder?: Maybe<PayComponentReferralFirstOrderRuleInput>;
  teamLeadCommission?: Maybe<PayComponentTeamLeadCommissionRuleInput>;
  type: PayComponentType;
};

export type PayComponentSummary = {
  type: PayComponentType;
  payAmount: MonetaryAmount;
  lineCount: Scalars['Int'];
};

export type PayComponentTeamLeadCommissionRule = PayComponentRule & {
  __typename: 'PayComponentTeamLeadCommissionRule';
  type: PayComponentType;
  defaultRate: Scalars['BigDecimal'];
  rates: Array<PayLineItemTeamLeadCommissionRate>;
};

export type PayComponentTeamLeadCommissionRuleInput = {
  defaultRate: Scalars['BigDecimal'];
  rates: Array<PayLineItemTeamLeadCommissionRateInput>;
};

export type PayComponentTeamLeadCommissionSummary = PayComponentSummary & {
  __typename: 'PayComponentTeamLeadCommissionSummary';
  type: PayComponentType;
  payAmount: MonetaryAmount;
  lineCount: Scalars['Int'];
  basisAmount: MonetaryAmount;
};

export type PayComponentTipRule = PayComponentRule & {
  __typename: 'PayComponentTipRule';
  type: PayComponentType;
};

export type PayComponentTipRuleInput = {
  enabled: Scalars['Boolean'];
};

export type PayComponentTipSummary = PayComponentSummary & {
  __typename: 'PayComponentTipSummary';
  type: PayComponentType;
  payAmount: MonetaryAmount;
  lineCount: Scalars['Int'];
};

export enum PayComponentType {
  COMMISSION = 'COMMISSION',
  QUALITY_CONVERSATION = 'QUALITY_CONVERSATION',
  TIP = 'TIP',
  FIRST_SHIFTS_GUARANTEED_PAY = 'FIRST_SHIFTS_GUARANTEED_PAY',
  HOURLY_ON_CALL = 'HOURLY_ON_CALL',
  MANUAL_ADJUSTMENT = 'MANUAL_ADJUSTMENT',
  REFERRAL_FIRST_ORDER = 'REFERRAL_FIRST_ORDER',
  TEAM_LEAD_COMMISSION = 'TEAM_LEAD_COMMISSION'
}

export type PayForOrderInput = {
  orderId: Scalars['OrderId'];
  chargeInfos: Array<ChargeInfoInput>;
};

export type PayForOrderPayload = {
  __typename: 'PayForOrderPayload';
  order?: Maybe<Order>;
  /** string explaining reason for failure if any */
  error?: Maybe<Scalars['String']>;
};

export type PayLineItem = {
  __typename: 'PayLineItem';
  id: Scalars['PayLineItemId'];
  postedAt: Scalars['Date'];
  payStructureRevision?: Maybe<PayStructureRevision>;
  payee: BusinessUser;
  payout: Payout;
  source: PayLineItemSource;
  notes?: Maybe<Scalars['String']>;
};

export type PayLineItemCommissionSource = PayLineItemSource & {
  __typename: 'PayLineItemCommissionSource';
  type: PayComponentType;
  payAmount: MonetaryAmount;
  orderId: Scalars['OrderId'];
  basisAmount: MonetaryAmount;
  contributionPercent: Scalars['Int'];
  rule: PayComponentCommissionRule;
  order: Order;
  orderDetails: PayLineItemOrderDetails;
};

export type PayLineItemFirstShiftsGuaranteedSource = PayLineItemSource & {
  __typename: 'PayLineItemFirstShiftsGuaranteedSource';
  type: PayComponentType;
  payAmount: MonetaryAmount;
  rule: PayComponentFirstShiftsGuaranteedRule;
};

export type PayLineItemHourlyOnCallSource = PayLineItemSource & {
  __typename: 'PayLineItemHourlyOnCallSource';
  type: PayComponentType;
  payAmount: MonetaryAmount;
  durationInMinutes: Scalars['Int'];
  rule: PayComponentHourlyOnCallRule;
};


export type PayLineItemLeadDetails = {
  __typename: 'PayLineItemLeadDetails';
  consumer: User;
  leadId: Scalars['LeadId'];
};

export type PayLineItemManualAdjustmentSource = PayLineItemSource & {
  __typename: 'PayLineItemManualAdjustmentSource';
  type: PayComponentType;
  payAmount: MonetaryAmount;
  adjustmentType: ManualAdjustmentPayType;
  hours?: Maybe<Scalars['BigDecimal']>;
  hourlyAmount?: Maybe<MonetaryAmount>;
};

export type PayLineItemOrderDetails = {
  __typename: 'PayLineItemOrderDetails';
  consumer: User;
  totalAmount: MonetaryAmount;
  orderTitle: Scalars['String'];
  orderNumber?: Maybe<Scalars['String']>;
};

export type PayLineItemQualityConversationSource = PayLineItemSource & {
  __typename: 'PayLineItemQualityConversationSource';
  type: PayComponentType;
  payAmount: MonetaryAmount;
  rule: PayComponentQualityConversationRule;
  leadId: Scalars['LeadId'];
  surgeShiftLead: Scalars['Boolean'];
  lead: Lead;
  leadDetails: PayLineItemLeadDetails;
};

export type PayLineItemReferralFirstOrderSource = PayLineItemSource & {
  __typename: 'PayLineItemReferralFirstOrderSource';
  type: PayComponentType;
  payAmount: MonetaryAmount;
  rule: PayComponentReferralFirstOrderRule;
  orderId: Scalars['OrderId'];
  order: Order;
  orderDetails: PayLineItemOrderDetails;
};

export enum PayLineItemSortField {
  PAY_COMPONENT_TYPE = 'PAY_COMPONENT_TYPE',
  POSTED_AT = 'POSTED_AT',
  AMOUNT = 'AMOUNT'
}

export type PayLineItemSortInput = {
  field: PayLineItemSortField;
  ascending: Scalars['Boolean'];
};

export type PayLineItemSource = {
  type: PayComponentType;
  payAmount: MonetaryAmount;
};

export type PayLineItemsPagination = {
  __typename: 'PayLineItemsPagination';
  count: Scalars['Long'];
  lineItems: Array<PayLineItem>;
};

export type PayLineItemTeamLeadCommissionRate = {
  __typename: 'PayLineItemTeamLeadCommissionRate';
  rate: Scalars['BigDecimal'];
  teamMemberStatus: Scalars['String'];
};

export type PayLineItemTeamLeadCommissionRateInput = {
  rate: Scalars['BigDecimal'];
  teamMemberStatus: Scalars['String'];
};

export type PayLineItemTeamLeadCommissionSource = PayLineItemSource & {
  __typename: 'PayLineItemTeamLeadCommissionSource';
  type: PayComponentType;
  payAmount: MonetaryAmount;
  rule: PayComponentTeamLeadCommissionRule;
  rate: Scalars['BigDecimal'];
  basisAmount: MonetaryAmount;
  teamMember: Identity;
  teamMemberStatus: Scalars['String'];
};

export type PayLineItemTipSource = PayLineItemSource & {
  __typename: 'PayLineItemTipSource';
  type: PayComponentType;
  payAmount: MonetaryAmount;
  rule: PayComponentTipRule;
  orderId: Scalars['OrderId'];
  order: Order;
  orderDetails: PayLineItemOrderDetails;
};

export type Payment3DSecure = PaymentEntity & {
  __typename: 'Payment3DSecure';
  paymentMethod: PaymentMethod;
  threeDSecureSourceId: Scalars['String'];
  authenticated: Scalars['Boolean'];
};

export type PaymentAction = {
  type: PaymentActionType;
};

export enum PaymentActionType {
  STRIPE_REQUIRED_PAYMENT_ACTION = 'STRIPE_REQUIRED_PAYMENT_ACTION',
  STRIPE_REQUIRED_SETUP_ACTION = 'STRIPE_REQUIRED_SETUP_ACTION'
}

export enum PaymentActivityType {
  FULL_PAYMENT = 'FULL_PAYMENT',
  DEPOSIT = 'DEPOSIT',
  REMAINING_BALANCE = 'REMAINING_BALANCE'
}

/**
 * Only saving minimal non PII information to avoid PCI compliance
 * https://www.pcisecuritystandards.org/pdfs/pci_fs_data_storage.pdf
 */
export type PaymentCard = PaymentEntity & {
  __typename: 'PaymentCard';
  paymentMethod: PaymentMethod;
  last4: Scalars['String'];
  /** Ex: Visa, Mastercard etc */
  brand?: Maybe<Scalars['String']>;
  /** 2 digit number representing the card’s expiration month. */
  expiryMonth?: Maybe<Scalars['Int']>;
  /** 4 digit number representing the card’s expiration year. */
  expiryYear?: Maybe<Scalars['Int']>;
  addressZipCheckStatus?: Maybe<CardFieldValidationStatus>;
  cvcCheckStatus?: Maybe<CardFieldValidationStatus>;
  cardFundingType?: Maybe<CardFundingType>;
  country?: Maybe<Scalars['String']>;
  threeDSecureVerificationRequired?: Maybe<Scalars['Boolean']>;
  threeDSecureVerification?: Maybe<ThreeDSecureVerification>;
};

/** The payment entity represents the asset associated the payment method used for the transaction */
export type PaymentEntity = {
  paymentMethod: PaymentMethod;
};

export enum PaymentMethod {
  CARD = 'CARD',
  PAYPAL = 'PAYPAL',
  THREE_D_SECURE = 'THREE_D_SECURE',
  APPLE_PAY = 'APPLE_PAY',
  ANDROID_PAY = 'ANDROID_PAY',
  GOOGLE_PAY = 'GOOGLE_PAY',
  PAY_BY_INSTALLMENT = 'PAY_BY_INSTALLMENT',
  WIRE_TRANSFER = 'WIRE_TRANSFER',
  BANK_CHECK = 'BANK_CHECK'
}

export type PaymentProcessorAccount = {
  id: Scalars['PaymentProcessorAccountId'];
  createdAt: Scalars['Date'];
  updatedAt: Scalars['Date'];
  type: PaymentProcessorType;
  userId: Scalars['UserId'];
  paymentSources?: Maybe<Array<PaymentSource>>;
};


export enum PaymentProcessorType {
  STRIPE = 'STRIPE',
  PAYPAL = 'PAYPAL',
  AFTERPAY = 'AFTERPAY',
  AFFIRM = 'AFFIRM',
  DEAL = 'DEAL'
}

export type PaymentRedirectUrls = {
  /** Url Path without the scheme and domain where the payer will be redirected to after approving the payment */
  paymentApprovedReturnUrlPath: Scalars['String'];
  /** Url Path without the scheme and domain where the payer will be redirected to after canceling the payment */
  paymentCanceledReturnUrlPath: Scalars['String'];
};

/** Abstraction for payment sources like Stripe, Paypal, ACH etc. */
export type PaymentSource = {
  id: Scalars['PaymentSourceId'];
  createdAt: Scalars['Date'];
  updatedAt: Scalars['Date'];
  externalSourceId: Scalars['String'];
  type: PaymentProcessorType;
  usage: PaymentSourceUsage;
  status: PaymentSourceStatus;
  userId: Scalars['UserId'];
  billingAddress?: Maybe<Address>;
  paymentEntity: PaymentEntity;
  isDefault: Scalars['Boolean'];
};


export enum PaymentSourceStatus {
  /** indicates the source is archived, for ex: on expiry, account closure, deleting previously saved card */
  ARCHIVED = 'ARCHIVED',
  CANCELED = 'CANCELED',
  /** Only chargeable Source can be used to create a charge */
  CHARGEABLE = 'CHARGEABLE',
  /** This indicates an older Source that is now detached from the user. */
  CONSUMED = 'CONSUMED',
  FAILED = 'FAILED',
  PENDING = 'PENDING',
  PENDING_INTENT = 'PENDING_INTENT'
}

/**
 * Whether this source should be reusable or not. Some source types may or may not be reusable by construction,
 * while other may leave the option at creation. If an incompatible value is passed, an error will be returned.
 */
export enum PaymentSourceUsage {
  REUSABLE = 'REUSABLE',
  SINGLE_USE = 'SINGLE_USE'
}

export enum PaymentVerificationMethod {
  CODE = 'CODE',
  AMOUNT = 'AMOUNT'
}

export type PaymentVerificationRequestRichCard = MessageRichCard & {
  __typename: 'PaymentVerificationRequestRichCard';
  type: MessageRichCardType;
  orderId: Scalars['OrderId'];
  transactionId: Scalars['TransactionId'];
};

export type Payout = {
  __typename: 'Payout';
  id: Scalars['PayoutId'];
  state: PayoutState;
  period: PayPeriod;
  payee: BusinessUser;
  department: Department;
  totalAmount: MonetaryAmount;
  lineCount: Scalars['Int'];
  components: Array<PayComponentSummary>;
  lastComputedAt?: Maybe<Scalars['Date']>;
};

export type PayoutFilters = {
  state?: Maybe<PayoutState>;
  expertId?: Maybe<Scalars['BusinessUserId']>;
  departmentId?: Maybe<Scalars['DepartmentId']>;
  payDate?: Maybe<Scalars['Date']>;
};


export type PayoutRollupSummary = {
  __typename: 'PayoutRollupSummary';
  payoutCount: Scalars['Int'];
  totalAmount: MonetaryAmount;
  lineCount: Scalars['Int'];
  components: Array<PayComponentSummary>;
};

export enum PayoutSortField {
  POSTED_AT = 'POSTED_AT',
  TOTAL_AMOUNT = 'TOTAL_AMOUNT',
  COMMISSION_AMOUNT = 'COMMISSION_AMOUNT',
  QUALITY_CONVERSATION_AMOUNT = 'QUALITY_CONVERSATION_AMOUNT',
  TIP_AMOUNT = 'TIP_AMOUNT',
  FIRST_SHIFTS_GUARANTEED_PAY_AMOUNT = 'FIRST_SHIFTS_GUARANTEED_PAY_AMOUNT',
  HOURLY_ON_CALL_AMOUNT = 'HOURLY_ON_CALL_AMOUNT',
  MANUAL_ADJUSTMENT_AMOUNT = 'MANUAL_ADJUSTMENT_AMOUNT'
}

export type PayoutSortInput = {
  field: PayoutSortField;
  ascending: Scalars['Boolean'];
};

export type PayoutsPagination = {
  __typename: 'PayoutsPagination';
  payouts: Array<Payout>;
  rollupSummary: PayoutRollupSummary;
};

export enum PayoutState {
  CREATED = 'CREATED',
  PENDING_APPROVAL = 'PENDING_APPROVAL',
  APPROVED = 'APPROVED',
  ERROR = 'ERROR',
  PAID = 'PAID',
  ARCHIVED = 'ARCHIVED'
}

export type PaypalAccount = PaymentProcessorAccount & {
  __typename: 'PaypalAccount';
  id: Scalars['PaymentProcessorAccountId'];
  createdAt: Scalars['Date'];
  updatedAt: Scalars['Date'];
  type: PaymentProcessorType;
  userId: Scalars['UserId'];
  paymentSources?: Maybe<Array<PaymentSource>>;
  externalAccountId?: Maybe<Scalars['String']>;
  name?: Maybe<Scalars['String']>;
  description?: Maybe<Scalars['String']>;
  email?: Maybe<Scalars['String']>;
};

export type PaypalPaymentEntity = PaymentEntity & {
  __typename: 'PaypalPaymentEntity';
  paymentMethod: PaymentMethod;
  payerId: Scalars['String'];
};

export type PaypalPaymentSource = PaymentSource & {
  __typename: 'PaypalPaymentSource';
  id: Scalars['PaymentSourceId'];
  createdAt: Scalars['Date'];
  updatedAt: Scalars['Date'];
  externalSourceId: Scalars['String'];
  type: PaymentProcessorType;
  usage: PaymentSourceUsage;
  status: PaymentSourceStatus;
  userId: Scalars['UserId'];
  billingAddress?: Maybe<Address>;
  paymentEntity: PaymentEntity;
  isDefault: Scalars['Boolean'];
  /** PayPal specific attributes */
  paymentId: Scalars['String'];
};

export type PayPeriod = {
  __typename: 'PayPeriod';
  startInclusive: Scalars['Date'];
  endInclusive: Scalars['Date'];
};

export type PayStructure = {
  __typename: 'PayStructure';
  id: Scalars['PayStructureId'];
  department: Department;
  name: Scalars['String'];
  description: Scalars['String'];
  type?: Maybe<Scalars['String']>;
  revisions: Array<PayStructureRevision>;
};

export type PayStructureFilters = {
  name?: Maybe<Scalars['String']>;
  departmentId?: Maybe<Scalars['DepartmentId']>;
  defaultOnly?: Maybe<Scalars['Boolean']>;
};


export type PayStructureRevision = {
  __typename: 'PayStructureRevision';
  id: Scalars['PayStructureRevisionId'];
  payStructure: PayStructure;
  createdAt: Scalars['Date'];
  effectiveAt?: Maybe<Scalars['Date']>;
  state: PayStructureRevisionState;
  components: Array<PayComponentRule>;
};


export enum PayStructureRevisionState {
  DRAFT = 'DRAFT',
  ACTIVE = 'ACTIVE',
  PENDING = 'PENDING',
  DEACTIVATED = 'DEACTIVATED'
}

export type PayStructuresPagination = {
  __typename: 'PayStructuresPagination';
  payStructures: Array<PayStructure>;
  count: Scalars['Long'];
};

export type PendingAccessContact = {
  __typename: 'PendingAccessContact';
  id: Scalars['PendingAccessContactId'];
  contact: Contact;
  interest: Scalars['String'];
  verificationUrl: Scalars['String'];
  user?: Maybe<User>;
};


/** Percent off individual line items that meet the `Promotion.rules` criteria */
export type PercentOffLineItemsPromotionActionReference = PromotionActionReference & {
  __typename: 'PercentOffLineItemsPromotionActionReference';
  id: Scalars['PromotionActionReferenceId'];
  type: PromotionActionType;
  /** Between 1 and 100 */
  percentOff: Scalars['Int'];
  /**
   * If present and percent off provides a discount greater than this maximum, this fixed amount is instead applied
   * proportionally to the line items that meet the `Promotion.rules` criteria (the same semantics as AmountOff).
   */
  maximumAmountOff?: Maybe<MonetaryAmount>;
};

/** See `PercentOffLineItemsPromotionActionReference` for documentation */
export type PercentOffLineItemsPromotionActionReferenceInput = {
  percentOff: Scalars['Int'];
  maximumAmountOff?: Maybe<MonetaryAmountInput>;
};

/**
 * =============
 * this is used in biz-app, we should migrate to BusinessUserPermission
 * =============
 */
export enum Permission {
  UI_OVERWRITE_SELLABLE_PRICE = 'UI_OVERWRITE_SELLABLE_PRICE',
  UI_ON_CALL_EXPERT = 'UI_ON_CALL_EXPERT',
  UI_ACCEPT_NEW_LEAD = 'UI_ACCEPT_NEW_LEAD'
}

export type PersistMediaInput = {
  id: Scalars['MediaId'];
};

export type PersistMediaPayload = {
  __typename: 'PersistMediaPayload';
  mediaFile?: Maybe<MediaFile>;
};

export type PhoneCallSummary = {
  __typename: 'PhoneCallSummary';
  consumerLastCalledAt?: Maybe<Scalars['Date']>;
  consumerCallCount: Scalars['Int'];
};

export type PhoneExplanationModalMetadata = PathFlowPageMetadata & {
  __typename: 'PhoneExplanationModalMetadata';
  type: PathFlowPageMetadataType;
};

export type PickUpCallInput = {
  callingFor: Array<Scalars['AnyId']>;
  pickUpBy: Scalars['AnyId'];
};

export type PickUpCallPayload = {
  __typename: 'PickUpCallPayload';
  call?: Maybe<IncomingCall>;
  hasError: Scalars['Boolean'];
  errorMessage?: Maybe<Scalars['String']>;
};

export type PickupTicketInput = {
  ticketId: Scalars['TicketId'];
  comment?: Maybe<Scalars['String']>;
};

export type PiplAddress = {
  __typename: 'PiplAddress';
  streetNumber?: Maybe<Scalars['String']>;
  apartment?: Maybe<Scalars['String']>;
  street?: Maybe<Scalars['String']>;
  city?: Maybe<Scalars['String']>;
  state?: Maybe<Scalars['String']>;
  countryCode?: Maybe<Scalars['String']>;
  zipCode?: Maybe<Scalars['String']>;
  postOfficeBox?: Maybe<Scalars['String']>;
};

export type PiplEducation = {
  __typename: 'PiplEducation';
  degree?: Maybe<Scalars['String']>;
  school?: Maybe<Scalars['String']>;
  duration?: Maybe<DateRange>;
};

export type PiplName = {
  __typename: 'PiplName';
  firstName?: Maybe<Scalars['String']>;
  middleName?: Maybe<Scalars['String']>;
  lastName?: Maybe<Scalars['String']>;
  suffix?: Maybe<Scalars['String']>;
  prefix?: Maybe<Scalars['String']>;
  fullName?: Maybe<Scalars['String']>;
};

export type PiplPosition = {
  __typename: 'PiplPosition';
  title?: Maybe<Scalars['String']>;
  company?: Maybe<Scalars['String']>;
  industry?: Maybe<Scalars['String']>;
  duration?: Maybe<DateRange>;
};

export type PiplProfile = ExternalProfile & {
  __typename: 'PiplProfile';
  id: Scalars['String'];
  type: ExternalProfileType;
  names: Array<PiplName>;
  emails: Array<Scalars['String']>;
  phoneNumbers: Array<Scalars['String']>;
  gender?: Maybe<Scalars['String']>;
  addresses: Array<PiplAddress>;
  links: Array<Scalars['String']>;
  imageUrls: Array<Scalars['String']>;
  dateOfBirth?: Maybe<DateRange>;
  positions: Array<PiplPosition>;
  educations: Array<PiplEducation>;
};

export type PixelFiredEvent = {
  __typename: 'PixelFiredEvent';
  adPlatform: Scalars['String'];
  firedAt: Scalars['Date'];
};

export type PlaceOrderForOfferInput = {
  offerId: Scalars['BroadcastOfferId'];
  chargeInfos: Array<ChargeInfoInput>;
  tip?: Maybe<MonetaryAmountInput>;
  shippingAddress?: Maybe<AddressInput>;
  /** @deprecated moved to ChargeInfoInput */
  billingAddress?: Maybe<AddressInput>;
  serviceConfirmedTime?: Maybe<Scalars['Date']>;
};

export type PlaceOrderForOfferPayload = {
  __typename: 'PlaceOrderForOfferPayload';
  offer?: Maybe<BroadcastOffer>;
  /** string explaining reason for failure if any */
  error?: Maybe<Scalars['String']>;
};

export type PopularExpertCuratedItem = {
  __typename: 'PopularExpertCuratedItem';
  sellable: Sellable;
  recommendedForSellable: Sellable;
  category: Category;
  timesRecommended?: Maybe<Scalars['Int']>;
  popularTag?: Maybe<ExpertCuratedItemTag>;
};

export type PopularExpertCuratedItemConnection = {
  __typename: 'PopularExpertCuratedItemConnection';
  edges: Array<PopularExpertCuratedItemEdge>;
  pageInfo: PageInfo;
};

export type PopularExpertCuratedItemEdge = {
  __typename: 'PopularExpertCuratedItemEdge';
  node: PopularExpertCuratedItem;
  cursor: Scalars['String'];
};

export type PopularExpertCuratedItemFromSimilarUserSystemCuratedItemSource = SystemCuratedItemSource & {
  __typename: 'PopularExpertCuratedItemFromSimilarUserSystemCuratedItemSource';
  type?: Maybe<SystemCuratedItemType>;
  expertCuratedItem: ExpertCuratedItem;
  dealRequest: DealRequest;
};

export type PopularExpertCuratedItemQueryInput = {
  /** @deprecated use sellableIds */
  sellableId?: Maybe<Scalars['SellableId']>;
  /** TODO: Make sellableIds required after deprecating sellableId */
  sellableIds?: Maybe<Array<Scalars['SellableId']>>;
  categoryIds?: Maybe<Array<Scalars['CategoryId']>>;
  includeCuratedItemTag?: Maybe<Scalars['Boolean']>;
  filters?: Maybe<Array<SuggestedSellableFilter>>;
};

export type PortPathEditorValidationErrorTarget = PathEditorValidationErrorTarget & {
  __typename: 'PortPathEditorValidationErrorTarget';
  id: Scalars['String'];
  targetType: PathEditorValidationErrorTargetType;
  /** The port that should be surfaced to the user which has an error */
  port: PathPort;
  /**
   * The actual port commands should be executed against. For basic nodes like `QuestionsPathNodeConfig`, `port` and
   * this will be the same, but for containerized nodes like a `BranchRulePathNodeConfig` inside of a
   * `BranchContainerPathNodeConfig`, they will be different.
   * For example, for a `PathEditorValidationErrorType.MISSING_EDGE` error reported against a branch rule means
   * there is no node linked to the true condition of the branch rule. This isn't actually true though - there is
   * an edge going from the branch rule to the branch container, with the branch container not being linked to a
   * subsequent node. Since we don't expose this detail in the UI, but internally need to understand it, this editable
   * port will surface the container port we need to execute actions against, while `port` is what the user should see.
   */
  editablePort: PathPort;
};

/**
 * PostalAddress was used for embedding address data in the User and Merchant objects but unless absolutely needed
 * prefer the Address object, which allows reusability
 */
export type PostalAddress = AddressFields & {
  __typename: 'PostalAddress';
  addresseeName?: Maybe<Scalars['String']>;
  businessName?: Maybe<Scalars['String']>;
  line1?: Maybe<Scalars['String']>;
  line2?: Maybe<Scalars['String']>;
  city?: Maybe<Scalars['String']>;
  state?: Maybe<Scalars['String']>;
  country?: Maybe<Scalars['String']>;
  countryDetails?: Maybe<Country>;
  postalCode: Scalars['String'];
  phoneNumber?: Maybe<Scalars['String']>;
  parsedPhoneNumber?: Maybe<ParsedPhoneNumber>;
  displayTitle?: Maybe<Scalars['String']>;
};


/**
 * PostalAddress was used for embedding address data in the User and Merchant objects but unless absolutely needed
 * prefer the Address object, which allows reusability
 */
export type PostalAddressDisplayTitleArgs = {
  displayType?: Maybe<PostalAddressLocationDisplayType>;
};

export type PostalAddressInput = {
  addresseeName?: Maybe<Scalars['String']>;
  businessName?: Maybe<Scalars['String']>;
  line1?: Maybe<Scalars['String']>;
  line2?: Maybe<Scalars['String']>;
  city?: Maybe<Scalars['String']>;
  state?: Maybe<Scalars['String']>;
  country: Scalars['String'];
  postalCode: Scalars['String'];
  phoneNumber?: Maybe<Scalars['String']>;
};

export enum PostalAddressLocationDisplayType {
  CITY_STATE = 'CITY_STATE'
}

export type PostCartOrderActivity = {
  __typename: 'PostCartOrderActivity';
  id: Scalars['PostCartOrderActivityId'];
  updatedAt: Scalars['Date'];
  createdAt: Scalars['Date'];
  orderId: Scalars['OrderId'];
  orderLineItemId?: Maybe<Scalars['OrderLineItemId']>;
  occurredAt: Scalars['Date'];
  detail: OrderActivityDetail;
};


export type PredictedLifeTimeValue = {
  __typename: 'PredictedLifeTimeValue';
  id: Scalars['PredictedLifeTimeValueId'];
  userId: Scalars['UserId'];
  ltvType: LtvType;
  pLTV: MonetaryAmount;
  pixelFiredEvents: Array<PixelFiredEvent>;
};


export type PrepareApprovalRequestSubmitDraftInput = {
  revisionId: Scalars['AnyId'];
};

export type PrepareApprovalRequestSubmitDraftPayload = {
  __typename: 'PrepareApprovalRequestSubmitDraftPayload';
  approvalRequestSubmitDraft?: Maybe<ApprovalRequestSubmitDraft>;
  error?: Maybe<ApprovableEntityDependencyResolutionError>;
};

export enum PresenceStatus {
  ONLINE = 'ONLINE',
  ONLINE_INACTIVE = 'ONLINE_INACTIVE',
  OFFLINE = 'OFFLINE',
  PUSH_NOTIFICATION = 'PUSH_NOTIFICATION',
  SMS = 'SMS'
}

export type PriceMatchRequestRetailPrice = {
  __typename: 'PriceMatchRequestRetailPrice';
  retailer: Scalars['String'];
  price: Scalars['String'];
};

export type PriceMatchRequestRichCard = MessageRichCard & {
  __typename: 'PriceMatchRequestRichCard';
  type: MessageRichCardType;
  sellableId: Scalars['SellableId'];
  price: Scalars['String'];
  otherRetailPrices: Array<PriceMatchRequestRetailPrice>;
};

export type ProConAttributeSchemaMetadata = AttributeSchemaMetadata & {
  __typename: 'ProConAttributeSchemaMetadata';
  type: AttributeSchemaMetadataType;
};

export type ProConAttributeSchemaMetadataInput = {
  _?: Maybe<Scalars['Boolean']>;
};

export type ProductCatalogArchiveRevisionError = NotLatestRevisionProductCatalogArchiveRevisionError | PublishedNotLatestRevisionProductCatalogArchiveRevisionError;

export type ProductCatalogCopyRevisionAsDraftError = CopyFromDraftNotAllowedProductCatalogCopyRevisionAsDraftError;

export type ProductCatalogCreateDraftFromSellableError = AlreadyCreatedProductCatalogDraftFromSellableError | NoProductIdentifierProductCatalogDraftFromSellableError | ParentNotExistProductCatalogDraftFromSellableError;

export type ProductCatalogCreateDraftRevisionError = DraftExistsProductCatalogCreateDraftRevisionError;

export type ProductCatalogGroupArchiveRevisionError = NotLatestRevisionProductCatalogGroupArchiveRevisionError | PublishedNotLatestRevisionProductCatalogGroupArchiveRevisionError | PublishedVariantsProductCatalogGroupArchiveRevisionError;

export type ProductCatalogGroupCopyRevisionAsDraftError = CopyFromDraftNotAllowedProductCatalogGroupCopyRevisionAsDraftError;

export type ProductCatalogGroupCreateDraftFromSellableError = AlreadyCreatedProductCatalogGroupDraftFromSellableError;

export type ProductCatalogGroupCreateDraftRevisionError = DraftExistsProductCatalogGroupCreateDraftRevisionError;


export type ProductCatalogGroupPublishError = ArchivedProductCatalogGroupPublishError | ConflictingSkuProductCatalogGroupPublishError | MissingAttributeProductCatalogGroupPublishError;

export type ProductCatalogGroupPublishFromSellablesError = SellableNotFromCatalogGroupProductCatalogGroupPublishFromSellablesError;

export type ProductCatalogGroupRemoveAttributeError = NotDraftProductCatalogGroupUpdateError | MissingAttributeProductCatalogGroupUpdateError;

export type ProductCatalogGroupReorderRawAttributesError = NotDraftProductCatalogGroupUpdateError | MissingRawAttributeProductCatalogGroupUpdateError;

export type ProductCatalogGroupRevision = {
  __typename: 'ProductCatalogGroupRevision';
  id: Scalars['ProductCatalogGroupRevisionId'];
  revisionNumber: Scalars['Int'];
  superseded?: Maybe<ProductCatalogGroupRevision>;
  groupId: Scalars['ProductCatalogGroupId'];
  title: Scalars['String'];
  slug: Scalars['String'];
  images: Array<MediaFile>;
  description?: Maybe<Scalars['String']>;
  brand?: Maybe<Brand>;
  categories: Array<Category>;
  attributes: Array<Attribute>;
  rawAttributes: Array<RawAttribute>;
  groupSku: Scalars['String'];
  variants: Array<ProductCatalogRevision>;
  allRevisions: Array<ProductCatalogGroupRevision>;
  state: ProductCatalogGroupRevisionState;
  publishedAt?: Maybe<Scalars['Date']>;
  updatedBy: Identity;
  updatedAt: Scalars['Date'];
};


export type ProductCatalogGroupRevisionVariantsArgs = {
  includeDraft?: Maybe<Scalars['Boolean']>;
};


export enum ProductCatalogGroupRevisionState {
  PUBLISHED = 'PUBLISHED',
  DRAFT = 'DRAFT',
  ARCHIVED = 'ARCHIVED'
}

export type ProductCatalogGroupSetAttributeError = NotDraftProductCatalogGroupUpdateError;

export type ProductCatalogGroupSetRawAttributeError = NotDraftProductCatalogGroupUpdateError;

export type ProductCatalogGroupUpdateDraftError = NotDraftProductCatalogGroupUpdateError;


export type ProductCatalogPublishError = NoPublishedVariantParentProductCatalogPublishError | InconsistentVariationDimensionsProductCatalogPublishError | ArchivedProductCatalogPublishError | ConflictingProductIdentifierProductCatalogPublishError | MissingAttributeProductCatalogPublishError | InvalidVariantProductCatalogPublishError;

export type ProductCatalogPublishFromSellablesError = SellableNotFromCatalogProductCatalogPublishFromSellablesError;

export type ProductCatalogRemoveAttributeError = NotDraftProductCatalogUpdateError | MissingAttributeProductCatalogUpdateError;

export type ProductCatalogReorderRawAttributesError = NotDraftProductCatalogUpdateError | MissingRawAttributeProductCatalogUpdateError;

export type ProductCatalogRevision = {
  __typename: 'ProductCatalogRevision';
  id: Scalars['ProductCatalogRevisionId'];
  revisionNumber: Scalars['Int'];
  superseded?: Maybe<ProductCatalogRevision>;
  catalogId: Scalars['ProductCatalogId'];
  group?: Maybe<ProductCatalogGroupRevision>;
  title: Scalars['String'];
  slug: Scalars['String'];
  images: Array<MediaFile>;
  description?: Maybe<Scalars['String']>;
  brand?: Maybe<Brand>;
  categories: Array<Category>;
  attributes: Array<Attribute>;
  rawAttributes: Array<RawAttribute>;
  attributeVariationDimensions: Array<Scalars['String']>;
  gtin?: Maybe<Scalars['String']>;
  mpn?: Maybe<Scalars['String']>;
  listPrice?: Maybe<MonetaryAmount>;
  minimumAdvertisedPrice?: Maybe<MonetaryAmount>;
  salePriceOverride?: Maybe<MonetaryAmount>;
  allRevisions: Array<ProductCatalogRevision>;
  state: ProductCatalogRevisionState;
  publishedAt?: Maybe<Scalars['Date']>;
  updatedBy: Identity;
  updatedAt: Scalars['Date'];
};


export type ProductCatalogRevisionGroupArgs = {
  includeDraft?: Maybe<Scalars['Boolean']>;
};


export enum ProductCatalogRevisionState {
  PUBLISHED = 'PUBLISHED',
  DRAFT = 'DRAFT',
  ARCHIVED = 'ARCHIVED'
}

export type ProductCatalogSearchConnection = {
  __typename: 'ProductCatalogSearchConnection';
  facets: Array<DisplayFacet>;
  edges: Array<ProductCatalogSearchEdge>;
  pageInfo: PageInfo;
  count: Scalars['Int'];
};

export type ProductCatalogSearchEdge = {
  __typename: 'ProductCatalogSearchEdge';
  node: ProductCatalogRevision;
  cursor: Scalars['String'];
};

export type ProductCatalogSearchRequest = {
  facets?: Maybe<Array<FacetSelection>>;
  title?: Maybe<Scalars['String']>;
  keywords?: Maybe<Scalars['String']>;
  categoryIds?: Maybe<Array<Scalars['CategoryId']>>;
  brandIds?: Maybe<Array<Scalars['BrandId']>>;
  state?: Maybe<ProductCatalogRevisionState>;
  maxFacetTerms?: Maybe<Scalars['Int']>;
};

export type ProductCatalogSetAttributeError = NotDraftProductCatalogUpdateError;

export type ProductCatalogSetRawAttributeError = NotDraftProductCatalogUpdateError;

export enum ProductCatalogSort {
  /** The date when it is first published */
  FIRST_PUBLISHED = 'FIRST_PUBLISHED',
  /** The date when it is last updated */
  LAST_UPDATED = 'LAST_UPDATED'
}

export type ProductCatalogUpdateDraftError = NotDraftProductCatalogUpdateError;

export enum ProductCondition {
  NEW = 'NEW',
  EXCELLENT = 'EXCELLENT',
  GOOD = 'GOOD',
  FAIR = 'FAIR'
}

export type ProductDealTerms = {
  __typename: 'ProductDealTerms';
  type: DealTermsType;
  condition: ProductCondition;
  returnPolicy: ReturnPolicy;
  shippingPolicy: ShippingPolicy;
  pickupAvailable: Scalars['Boolean'];
};

export type ProductOfferTerms = {
  __typename: 'ProductOfferTerms';
  condition: ProductCondition;
  shippingCost?: Maybe<Money>;
  returnPolicy?: Maybe<ReturnPolicy>;
  shippingAvailable: Scalars['Boolean'];
  pickupAvailable: Scalars['Boolean'];
};

export type ProductOfferTermsInput = {
  condition: ProductCondition;
  shippingCost?: Maybe<Scalars['Float']>;
  shippingAvailable: Scalars['Boolean'];
  pickupAvailable: Scalars['Boolean'];
  returnPolicyType?: Maybe<ReturnPolicyType>;
  refundMethod?: Maybe<ReturnRefundMethod>;
  returnWithinDays?: Maybe<Scalars['Int']>;
  returnShippingPaidBy?: Maybe<ReturnShippingPaidBy>;
};

export enum ProductReturnDestination {
  WAREHOUSE = 'WAREHOUSE',
  MERCHANT = 'MERCHANT',
  OFFICE = 'OFFICE',
  UNKNOWN = 'UNKNOWN'
}

export type ProductReturnTicket = TicketDetail & {
  __typename: 'ProductReturnTicket';
  type: TicketType;
  order: Order;
  orderRefund: OrderRefund;
  merchant?: Maybe<Merchant>;
  returnDestination: ProductReturnDestination;
  shippingLabelSentToConsumerAt?: Maybe<Scalars['Date']>;
  lastCheckedLabelFromMerchantAt?: Maybe<Scalars['Date']>;
};

export type ProfileHighlight = {
  __typename: 'ProfileHighlight';
  type: ProfileHighlightType;
  value: Scalars['String'];
  secondaryValue: Scalars['String'];
};

export enum ProfileHighlightIconType {
  BEER = 'BEER',
  CAKE = 'CAKE',
  CALENDAR = 'CALENDAR',
  CHAT = 'CHAT',
  CHECK = 'CHECK',
  COCKTAIL = 'COCKTAIL',
  DRINK = 'DRINK',
  GOLF_CLUB = 'GOLF_CLUB',
  GOLF_CLUB_SET = 'GOLF_CLUB_SET',
  GOLF_COURSE = 'GOLF_COURSE',
  HEART = 'HEART',
  LOCATION = 'LOCATION',
  DIPLOMA = 'DIPLOMA',
  SKIER = 'SKIER',
  SNOWBOARDER = 'SNOWBOARDER',
  MOUNTAIN = 'MOUNTAIN',
  SNOWFLAKE = 'SNOWFLAKE',
  SMILE = 'SMILE',
  STAR = 'STAR'
}

export type ProfileHighlightInput = {
  typeId: Scalars['ProfileHighlightTypeId'];
  value: Scalars['String'];
  secondaryValue?: Maybe<Scalars['String']>;
};

export enum ProfileHighlightSource {
  SYSTEM = 'SYSTEM',
  USER = 'USER'
}

export type ProfileHighlightType = {
  __typename: 'ProfileHighlightType';
  id: Scalars['ProfileHighlightTypeId'];
  displayName: Scalars['String'];
  icon: ProfileHighlightIconType;
  source: ProfileHighlightSource;
  valueType: ProfileHighlightValueType;
  enumerationValues?: Maybe<Array<Scalars['String']>>;
  placeHolderForValue?: Maybe<Scalars['String']>;
  placeHolderForSecondaryValue?: Maybe<Scalars['String']>;
  secondaryValueRequired: Scalars['Boolean'];
};


export enum ProfileHighlightValueType {
  TEXT = 'TEXT',
  ENUMERATION = 'ENUMERATION',
  DATE = 'DATE'
}

export type Promotion = {
  __typename: 'Promotion';
  id: Scalars['PromotionId'];
  createdAt: Scalars['Date'];
  createdBy: PromotionCreator;
  /** The time at which the promotion entered `ACTIVE` state */
  activatedAt?: Maybe<Scalars['Date']>;
  /** Promotion the operator copied to create this promotion, if any */
  copiedFrom?: Maybe<Promotion>;
  /** If `state==DISABLED`, information about why/when/who. */
  disabled?: Maybe<PromotionDisabled>;
  /** De-normalized flag, the same as `state==ACTIVE` */
  active: Scalars['Boolean'];
  state: PromotionState;
  /**
   * Promotion code used by consumers to expectedReference the promotion.
   * There is a unique constraint where there can only be one active promotion that uses this code. Many disabled
   * promotions can expectedReference this code (can be viewed as a log of promotion history).
   * While this code is stored and displayed as case sensitive, searching for this code, as well as the unique index
   * for active promotion codes, are both **case insensitive**. So while this can store and display case sensitive
   * values like "BigGolfSale", searching for "biggolfsale" or "BIGGOLFSALE" will locate the same document, and
   * similarly, multiple active codes that only vary by case are not allowed.
   */
  code: Scalars['String'];
  /** Description of this promotion */
  description: Scalars['String'];
  /**
   * Rules run in sequence, filtering down line items in the order that are eligible for the promotion. For example,
   * the 3 rules:
   * - Line item amount over $500
   * - Sellables in Golf category
   * - Line item amount over $100
   * Means, apply the promotion if the order has over $500 of value, and has sellables in the golf category, and those
   * sellables in the golf category are worth at least $100.
   * If all rules are evaluated and all line items are filtered out, the promotion will not be applied to the order.
   */
  rules: Array<PromotionRuleReference>;
  /**
   * Actions to the remaining line items that aren't filtered. These are processed in order, using the result of the
   * previous promotion. For example, if there's a 5% off action, and then a 10% off action, the 5% will be taken off,
   * and then the 10% will be computed from the 5% off amount - not the original total.
   */
  actions: Array<PromotionActionReference>;
  /**
   * Description of promotions action, for example, 5% off order max $500, $20 off order
   * This is used on the consumer side to display the promotion prizes
   */
  actionsDisplayValue: Scalars['String'];
  /** If set, this promotion will be automatically disabled when usages meet or exceeds this limit. */
  usageLimit?: Maybe<Scalars['Int']>;
  /** The amount of paid orders that had this promotion code applied */
  usages: Scalars['Int'];
  /** If set, the date this promotion will disable its self */
  expiresAt?: Maybe<Scalars['Date']>;
  /** Indicates this is a template promotion that is used to create other promotions. */
  template: Scalars['Boolean'];
  /** Indicates this promotion is automatically generated, typically from a template, and not manually created. */
  autoGenerated: Scalars['Boolean'];
  source?: Maybe<PromotionSource>;
  createdFor?: Maybe<User>;
};

export type PromotionActionReference = {
  id: Scalars['PromotionActionReferenceId'];
  type: PromotionActionType;
};


/** Exploded union of `PromotionActionReference` types; exactly one must be non null */
export type PromotionActionReferenceInput = {
  percentOffLineItems?: Maybe<PercentOffLineItemsPromotionActionReferenceInput>;
  amountOffOrder?: Maybe<AmountOffOrderPromotionActionReferenceInput>;
};

export enum PromotionActionType {
  PERCENT_OFF_LINE_ITEMS = 'PERCENT_OFF_LINE_ITEMS',
  AMOUNT_OFF_ORDER = 'AMOUNT_OFF_ORDER'
}

export type PromotionCreator = Operator | User;

export type PromotionDisabled = {
  __typename: 'PromotionDisabled';
  /** If null, disabled by the system (will be the case for expired and reached usage limit) */
  by?: Maybe<Operator>;
  at: Scalars['Date'];
  reason: PromotionDisabledReason;
};

export enum PromotionDisabledReason {
  MANUAL = 'MANUAL',
  REPLACED = 'REPLACED',
  EXPIRED = 'EXPIRED',
  REACHED_USAGE_LIMIT = 'REACHED_USAGE_LIMIT'
}

export type PromotionEdge = {
  __typename: 'PromotionEdge';
  node: Promotion;
  cursor: Scalars['String'];
};


export enum PromotionQueryFlagType {
  /** Surface items including items with this flag set */
  INCLUDE = 'INCLUDE',
  /** Only surface items with this flag set */
  ONLY = 'ONLY',
  /** Exclude items with this flag set */
  NONE = 'NONE'
}

export type PromotionQueryInput = {
  createdById?: Maybe<Scalars['AnyId']>;
  /** Defaults to `[ACTIVE]` */
  states?: Maybe<Array<PromotionState>>;
  /**
   * Case insensitive search for a specific promotion code.
   * If `states=[ACTIVE]` (the default), this will return exactly 0 or 1 entries since there can be at most 1 active
   * promotion for a given code. If searching disabled or draft, you'll also retrieve the previous promotions that used
   * this same code.
   */
  promotionCode?: Maybe<Scalars['String']>;
  /** Defaults to `INCLUDE` */
  template?: Maybe<PromotionQueryFlagType>;
  /** Defaults to `NONE` */
  autoGenerated?: Maybe<PromotionQueryFlagType>;
  source?: Maybe<PromotionSourceQueryInput>;
  createdForId?: Maybe<Scalars['UserId']>;
};

export enum PromotionRuleComparisonOperator {
  GREATER_THAN = 'GREATER_THAN',
  GREATER_THAN_OR_EQUAL = 'GREATER_THAN_OR_EQUAL',
  EQUAL = 'EQUAL',
  LESS_THAN = 'LESS_THAN',
  LESS_THAN_OR_EQUAL = 'LESS_THAN_OR_EQUAL'
}

export enum PromotionRuleFilterStrategy {
  /**
   * Filtering reduces the scope of the promotion actions. For example, if the rule is to `FILTER` for sellables in
   * the snowboard category, a subsequent promotion action to take 10% off will only take 10% off of the sellables
   * in the snowboard category - not other items in the cart. If no line items fall into the filter criteria, the
   * promotion will not be applied to the order.
   */
  FILTER = 'FILTER',
  /**
   * Excluding forces the promotion to not be the order if any of its criteria are met. For example, if the rule is
   * to `EXCLUDE` sellable X, any order with sellable X will not be eligible for the promotion.
   */
  EXCLUDE = 'EXCLUDE'
}

export type PromotionRuleReference = {
  id: Scalars['PromotionRuleReferenceId'];
  type: PromotionRuleType;
};


/**
 * Exploded union of `PromotionRuleReference` types; exactly one must be non null
 * See `PromotionRuleReference` sub-types for documentation
 */
export type PromotionRuleReferenceInput = {
  orderAmount?: Maybe<OrderAmountPromotionRuleReferenceInput>;
  sellableFilter?: Maybe<SellableFilterPromotionRuleReferenceInput>;
  sellableCategoryFilter?: Maybe<SellableCategoryFilterPromotionRuleReferenceInput>;
  sellableBrandFilter?: Maybe<SellableBrandFilterPromotionRuleReferenceInput>;
  sellableAttributeFilter?: Maybe<SellableAttributeFilterPromotionRuleReferenceInput>;
  purchaseOrderCount?: Maybe<PurchasedOrderCountPromotionRuleReferenceInput>;
  userUsageLimit?: Maybe<UserUsageLimitPromotionRuleReferenceInput>;
};

export enum PromotionRuleType {
  ORDER_AMOUNT = 'ORDER_AMOUNT',
  SELLABLE_FILTER = 'SELLABLE_FILTER',
  SELLABLE_CATEGORY_FILTER = 'SELLABLE_CATEGORY_FILTER',
  SELLABLE_BRAND_FILTER = 'SELLABLE_BRAND_FILTER',
  SELLABLE_ATTRIBUTE_FILTER = 'SELLABLE_ATTRIBUTE_FILTER',
  PURCHASED_ORDER_COUNT = 'PURCHASED_ORDER_COUNT',
  USER_USAGE_LIMIT = 'USER_USAGE_LIMIT'
}

export type PromotionsConnection = {
  __typename: 'PromotionsConnection';
  edges: Array<PromotionEdge>;
  pageInfo: PageInfo;
  count: Scalars['Long'];
};

export type PromotionSource = {
  type: PromotionSourceType;
};

export type PromotionSourceQueryInput = {
  type: PromotionSourceType;
};

export type PromotionSourceReferee = PromotionSource & {
  __typename: 'PromotionSourceReferee';
  type: PromotionSourceType;
};

export type PromotionSourceReferrer = PromotionSource & {
  __typename: 'PromotionSourceReferrer';
  type: PromotionSourceType;
  refereeName: Scalars['String'];
};

export type PromotionSourceRegistration = PromotionSource & {
  __typename: 'PromotionSourceRegistration';
  type: PromotionSourceType;
};

export type PromotionSourceSocialSharing = PromotionSource & {
  __typename: 'PromotionSourceSocialSharing';
  type: PromotionSourceType;
};

export enum PromotionSourceType {
  REFERRER = 'REFERRER',
  REFEREE = 'REFEREE',
  REGISTRATION = 'REGISTRATION',
  SOCIAL_SHARING = 'SOCIAL_SHARING'
}

export type PromotionsPagination = {
  __typename: 'PromotionsPagination';
  promotions: Array<Promotion>;
  count: Scalars['Long'];
};

export enum PromotionState {
  DRAFT = 'DRAFT',
  ACTIVE = 'ACTIVE',
  DISABLED = 'DISABLED'
}

export type ProsAndConsErrorExpertCuratedItemNoteEditError = ErrorMessage & {
  __typename: 'ProsAndConsErrorExpertCuratedItemNoteEditError';
  errorMessage: Scalars['String'];
  prosAndConsError: ExpertCuratedItemProsAndConsEditError;
};

export type PublishApprovalRequestActivityEntryDetail = ApprovalRequestActivityEntryDetail & {
  __typename: 'PublishApprovalRequestActivityEntryDetail';
  entryType: ApprovalRequestActivityEntryType;
};

export type PublishApprovalRequestInput = {
  approvalRequestId: Scalars['ApprovalRequestId'];
};

export type PublishApprovalRequestPayload = {
  __typename: 'PublishApprovalRequestPayload';
  approvalRequest?: Maybe<ApprovalRequest>;
  error?: Maybe<ApprovalRequestPublishError>;
};

export type PublishArticleRevisionInput = {
  articleRevisionId: Scalars['ArticleRevisionId'];
};

export type PublishArticleRevisionPayload = {
  __typename: 'PublishArticleRevisionPayload';
  articleRevision: ArticleRevision;
  errorMessage?: Maybe<Scalars['String']>;
  hasError: Scalars['Boolean'];
};

export type PublishAttributeSchemaRevisionInput = {
  id: Scalars['AttributeSchemaRevisionId'];
};

export type PublishAttributeSchemaRevisionPayload = AttributeSchemaRevisionPayload & {
  __typename: 'PublishAttributeSchemaRevisionPayload';
  hasError: Scalars['Boolean'];
  errorMessage?: Maybe<Scalars['String']>;
  attributeSchemaRevision?: Maybe<AttributeSchemaRevision>;
};

export type PublishCampaignAudienceInput = {
  id: Scalars['CampaignAudienceId'];
};

export type PublishCampaignAudiencePayload = {
  __typename: 'PublishCampaignAudiencePayload';
  campaignAudience: CampaignAudience;
  hasError: Scalars['Boolean'];
  errorMessage?: Maybe<Scalars['String']>;
};

export type PublishedNotLatestRevisionProductCatalogArchiveRevisionError = ErrorMessage & {
  __typename: 'PublishedNotLatestRevisionProductCatalogArchiveRevisionError';
  publishedRevision: ProductCatalogRevision;
  errorMessage: Scalars['String'];
};

export type PublishedNotLatestRevisionProductCatalogGroupArchiveRevisionError = ErrorMessage & {
  __typename: 'PublishedNotLatestRevisionProductCatalogGroupArchiveRevisionError';
  publishedRevision: ProductCatalogGroupRevision;
  errorMessage: Scalars['String'];
};

export type PublishedVariantsProductCatalogGroupArchiveRevisionError = ErrorMessage & {
  __typename: 'PublishedVariantsProductCatalogGroupArchiveRevisionError';
  errorMessage: Scalars['String'];
  publishedVariants: Array<ProductCatalogRevision>;
};

export type PublishExpertCuratedItemNoteInput = {
  id: Scalars['ExpertCuratedItemNoteId'];
};

export type PublishExpertCuratedItemNotePayload = {
  __typename: 'PublishExpertCuratedItemNotePayload';
  expertCuratedItemNote?: Maybe<ExpertCuratedItemNote>;
  errorMessage?: Maybe<Scalars['String']>;
  hasError: Scalars['Boolean'];
};

export type PublishProductCatalogFromSellablesInput = {
  sellableIds: Array<Scalars['SellableId']>;
  requestedById: Scalars['AnyId'];
};

export type PublishProductCatalogFromSellablesPayload = {
  __typename: 'PublishProductCatalogFromSellablesPayload';
  revisions?: Maybe<Array<ProductCatalogRevision>>;
  error?: Maybe<ProductCatalogPublishFromSellablesError>;
};

export type PublishProductCatalogGroupFromSellablesInput = {
  sellableIds: Array<Scalars['SellableId']>;
  requestedById: Scalars['AnyId'];
};

export type PublishProductCatalogGroupFromSellablesPayload = {
  __typename: 'PublishProductCatalogGroupFromSellablesPayload';
  revisions?: Maybe<Array<ProductCatalogGroupRevision>>;
  error?: Maybe<ProductCatalogGroupPublishFromSellablesError>;
};

export type PublishProductCatalogGroupRevisionsInput = {
  revisionIds: Array<Scalars['ProductCatalogGroupRevisionId']>;
  requestedById: Scalars['AnyId'];
};

export type PublishProductCatalogGroupRevisionsPayload = {
  __typename: 'PublishProductCatalogGroupRevisionsPayload';
  revisions: Array<ProductCatalogGroupRevision>;
  error?: Maybe<ProductCatalogGroupPublishError>;
};

export type PublishProductCatalogRevisionsInput = {
  revisionIds: Array<Scalars['ProductCatalogRevisionId']>;
  requestedById: Scalars['AnyId'];
};

export type PublishProductCatalogRevisionsPayload = {
  __typename: 'PublishProductCatalogRevisionsPayload';
  revisions: Array<ProductCatalogRevision>;
  error?: Maybe<ProductCatalogPublishError>;
};

export type PublishSavedExpertCuratedItemsInput = {
  id: Scalars['SavedExpertCuratedItemsId'];
};

export type PublishSavedExpertCuratedItemsPayload = {
  __typename: 'PublishSavedExpertCuratedItemsPayload';
  savedExpertCuratedItems?: Maybe<SavedExpertCuratedItems>;
  error?: Maybe<Scalars['String']>;
  hasError: Scalars['Boolean'];
};

export type PublishSellableTopListInput = {
  id: Scalars['SellableTopListDefinitionId'];
};

export type PublishTemplateFragmentInput = {
  id: Scalars['CommTemplateFragmentId'];
  notes?: Maybe<Scalars['String']>;
};

export type PublishTemplateInput = {
  id: Scalars['CommTemplateId'];
  notes?: Maybe<Scalars['String']>;
};

export type PublishTriggerInput = {
  triggerId: Scalars['TriggerId'];
  notes?: Maybe<Scalars['String']>;
};

export type PublishTriggerPayload = {
  __typename: 'PublishTriggerPayload';
  errors: Array<TriggerValidationErrors>;
  trigger: Trigger;
};

/** Compare against the total amount of purchased orders made by the user */
export type PurchasedOrderCountPromotionRuleReference = PromotionRuleReference & {
  __typename: 'PurchasedOrderCountPromotionRuleReference';
  id: Scalars['PromotionRuleReferenceId'];
  type: PromotionRuleType;
  operator: PromotionRuleComparisonOperator;
  /** Right hand side amount, in respect to `operator`. Left hand side is the purchase count. */
  rightOperandCount: Scalars['Int'];
};

/** See `PurchasedOrderCountPromotionRuleReference` for documentation */
export type PurchasedOrderCountPromotionRuleReferenceInput = {
  operator: PromotionRuleComparisonOperator;
  rightOperandCount: Scalars['Int'];
};

export type PushNotificationTemplate = ChannelTemplate & {
  __typename: 'PushNotificationTemplate';
  channelType: ChannelType;
  title: Scalars['String'];
  body: Scalars['String'];
};

export type PushNotificationTemplateInput = {
  title: Scalars['String'];
  body: Scalars['String'];
};

export type QualityConversationEstablishedActivity = LeadActivity & {
  __typename: 'QualityConversationEstablishedActivity';
  id: Scalars['LeadActivityId'];
  type: LeadActivityType;
  lead: Lead;
  occurredAt: Scalars['Date'];
  performedBy: Identity;
};

export type QualityConvoWithCurationEstablishedActivity = LeadActivity & {
  __typename: 'QualityConvoWithCurationEstablishedActivity';
  id: Scalars['LeadActivityId'];
  type: LeadActivityType;
  lead: Lead;
  occurredAt: Scalars['Date'];
  performedBy: Identity;
};

export type Query = {
  __typename: 'Query';
  health: Scalars['String'];
  savedAddresses: Array<Address>;
  approvalRequest: ApprovalRequest;
  findApprovalRequestForRevision?: Maybe<ApprovalRequest>;
  approvalRequestSubmitDraft: ApprovalRequestSubmitDraft;
  attributeSchemaRevision: AttributeSchemaRevision;
  attributeSchemaRevisionPagination: AttributeSchemaRevisionsPagination;
  exportAttributeSchemaRevisions: Array<BsonObject>;
  attributeSchemaValidators: Array<AttributeSchemaValidator>;
  session: Session;
  maskedHandle: MaskedUserHandle;
  maskedHandlesByLoginToken: Array<MaskedUserHandle>;
  /**
   * categoryTypes: Retrieve categories only under these master category types
   * first: Retrieve the first N categories in the filter criteria. See Relay Connection spec for more information.
   * after: Retrieve categories after a AttributeSchemasByCategoryEdge.cursor value. Used for pagination.
   *   See Relay Connection spec for more information.
   */
  categories: CategoriesConnection;
  topLevelCategories: Array<Category>;
  category: Category;
  categoryBySlug?: Maybe<Category>;
  allPathCategories: Array<Category>;
  /**
   * Finds the first category in the hierarchy tree of the Category identified by specified slug, if present.
   * The category tree is traversed parents first and then children
   */
  departments: Array<Department>;
  /** Currently the only supported versions are 'v1' and 'v2' while we test implementations */
  departmentsForNavigation: Array<Department>;
  departmentsForFlatNavigation: Array<Department>;
  department: Department;
  departmentBySlug?: Maybe<Department>;
  commTemplate: MultiLocaleTemplateSet;
  commTemplates: Array<MultiLocaleTemplateSet>;
  commTemplateVersionHistory: Array<MultiLocaleTemplateSet>;
  commTemplateTypes?: Maybe<Array<CommTemplateType>>;
  commTemplateType: CommTemplateType;
  renderCommTemplate: RenderCommTemplatePayload;
  commTemplateDataModel: CommTemplateDataModelPayload;
  commTemplateFragment: CommTemplateFragment;
  commTemplateFragments: Array<CommTemplateFragment>;
  commTemplateFragmentVersionHistory: Array<CommTemplateFragment>;
  commTemplateDirectives: Array<CommTemplateDirective>;
  messageRichCardMetas: Array<MessageRichCardMeta>;
  templateMessageDeliveryLogs: TemplateMessageDeliveryLogPagination;
  commTemplatesConnection: TemplatesConnection;
  commTemplateFacetTypeahead: Array<FacetTypeaheadPayload>;
  templateMessageDeliveryLog: TemplateMessageDeliveryLog;
  dealRequest?: Maybe<DealRequest>;
  findDealRequests: Array<DealRequest>;
  me?: Maybe<Myself>;
  findContact?: Maybe<Contact>;
  user: User;
  userRegistration?: Maybe<UserRegistration>;
  userByContact?: Maybe<User>;
  usersByContact: Array<User>;
  merchant: Merchant;
  merchantsPagination: MerchantsPagination;
  suggestMerchants: MerchantSuggestionResult;
  searchUsers: UsersPagination;
  operators: Array<Operator>;
  pendingAccessContact: PendingAccessContact;
  awayAutoReply: AwayAutoReply;
  exportIdentities: Array<BsonObject>;
  validateSmsPromotionRegistration: ValidateSmsPromotionRegistrationPayload;
  businessUser: BusinessUser;
  businessUsers: Array<Maybe<BusinessUser>>;
  experts: Array<BusinessUser>;
  businessAccount: BusinessAccount;
  businessAccounts: Array<BusinessAccount>;
  businessUserTeam: BusinessUserTeam;
  findBusinessUserTeams: BusinessUserTeamsPagination;
  devTools?: Maybe<DevTools>;
  conversation: Conversation;
  conversationByExternalId?: Maybe<Conversation>;
  activeVideoChatConversations: Array<Conversation>;
  messagingUsers: Array<MessagingUser>;
  callActivityConnection: CallActivityConnection;
  guestConversationSequence: GuestConversationSequence;
  findGuestConversationSequences: Array<GuestConversationSequence>;
  countRingingCalls: Scalars['Long'];
  pathFlow: PathFlowPayload;
  pathFlowPage: PathFlowPagePayload;
  /** @deprecated Use pathFlow(id: PathFlowId!) */
  pathFlowBySlug: PathFlowBySlugPayload;
  /** @deprecated Use pathFlowPage(id: PathFlowId!, pageSlug: String!) */
  pathFlowPageBySlugs: PathFlowPagePayload;
  pathSchemaRevision: PathSchemaRevision;
  pathSchemaFragmentRevision: PathSchemaFragmentRevision;
  pathEditorContext: PathEditorContext;
  pathSchemaRevisionsPagination: PathSchemaRevisionsPagination;
  pathSchemaFragmentRevisionsPagination: PathSchemaFragmentRevisionsPagination;
  exportPathGraphContainers: Array<BsonObject>;
  exportAllPathGraphContainers: Array<BsonObject>;
  shippingCarriers: Array<ShippingCarrier>;
  paymentSources: Array<Maybe<PaymentSource>>;
  order: Order;
  safeGetOrder: OrderPayload;
  orderLineItem: OrderLineItem;
  transaction: Transaction;
  /** @deprecated Use paginated `ordersConnection` API */
  findOrders: Array<Order>;
  ordersConnection: OrdersConnection;
  paymentSource: PaymentSource;
  reusablePaymentSources: Array<PaymentSource>;
  /**
   * If this returns an empty array, it means the recommendation is to not prompt the user to tip since we weren't able
   * to locate a relevant expert that aided the owner of the order. If more than one `ExpertTipPercentage` is returned,
   * it's guaranteed that all `ExpertTipPercentage.percentOfTip` add up to 100. The user can be shown all of the experts
   * returned by this API.
   * Ultimately, the result of this is intended to be used as an input to the `addTipToOrder` mutation. Users of this API
   * are free to modify the percent distribution, or even select different experts for tip distribution.
   */
  recommendTipPercentagesForOrder: Array<ExpertTipPercentage>;
  promotion: Promotion;
  promotionsConnection: PromotionsConnection;
  promotionsPagination: PromotionsPagination;
  /**
   * Case insensitive search for a active promotion with promotion code `code`.
   * Convienence API that's equivalent to querying `promotionsConnection` for `state=[ACTIVE]` and this `code`
   */
  activePromotionByCode?: Maybe<Promotion>;
  /**
   * Get all shipping costs for a given order. A custom address can be specified to compute shipping cost via
   * `orderShippingCostAddress`, or it can be omitted to compute all shipping cost options for the current order shipping
   * address. A `null` return value means the order doesn't require any shipping.
   */
  orderShippingCost?: Maybe<OrderShippingCost>;
  tags: Array<Tag>;
  frontendTask: FrontendTask;
  broadcastOffer: BroadcastOffer;
  mediaFile: MediaFile;
  mediaFiles: Array<MediaFile>;
  openGraphData?: Maybe<OpenGraphData>;
  embedMedia?: Maybe<EmbedMedia>;
  exportMediaFiles: Array<BsonObject>;
  findExpert?: Maybe<BusinessUser>;
  expertProfile: ExpertProfile;
  /** @deprecated use recommendExpert2 */
  recommendExpert?: Maybe<BusinessUser>;
  recommendExpert2: RecommendExpertPayload;
  recommendExpertForRequest: RecommendExpertPayload;
  recommendExpertsForPathFlow: Array<RecommendedExpert>;
  recommendExpertsForDepartment: Array<RecommendedExpert>;
  consumerExpertReview: ConsumerExpertReview;
  consumerExpertReviewConnection: ConsumerExpertReviewConnection;
  consumerExpertReviewFacetTypeahead: Array<FacetTypeaheadPayload>;
  expertApplication: ExpertApplication;
  expertApplications: Array<ExpertApplication>;
  expertApplicationsPagination: ExpertApplicationsPagination;
  expertApplicationsConnection: ExpertApplicationsConnection;
  expertApplicationsPendingReview: ExpertApplicationsConnection;
  expertApplicationFacetTypeahead: Array<FacetTypeaheadPayload>;
  expertProfilesPagination: ExpertProfilesPagination;
  expertSearchConnection: ExpertSearchConnection;
  expertApplicationFolderGroups: Array<ExpertApplicationFolderGroup>;
  expertApplicationFolderItems: ExpertApplicationsConnection;
  expertTypeahead: ExpertTypeaheadPayload;
  aggregateExpertReport: AggregateExpertReport;
  expertReferral: ExpertReferral;
  expertPerformanceStatistics: ExpertPerformanceStatisticsPayload;
  expertSearchFieldGroups: Array<FilterFieldGroup>;
  expertApplicationSearchFieldGroups: Array<FilterFieldGroup>;
  expertRankComputationLogs: Array<ExpertRankComputationLog>;
  estimatedExpertRPALStats: EstimatedExpertRpalStats;
  expertNewLeadEligibility: ExpertLeadEligibility;
  expertBroadcastLeadEligibility: ExpertLeadEligibility;
  expertHiringFlows: Array<ExpertHiringFlow>;
  deal: Deal;
  brands: BrandConnection;
  brandTypeahead: BrandTypeaheadPayload;
  /** @deprecated Use consumerSellableReactions instead */
  savedSellable: SavedSellable;
  /** @deprecated Use consumerSellableReactions instead */
  savedSellablesConnection: SavedSellablesConnection;
  sellable: Sellable;
  findSellable?: Maybe<Sellable>;
  sellables: Array<Sellable>;
  searchSellables: SellableSearchConnection;
  searchSellablesPagination: SellablesPagination;
  sellableTypeahead: SellableTypeaheadPayload;
  similarSellables: SimilarSellablePayload;
  /**
   * Use this API to identify find mapping of the supplied SellableSearchFacetsQuery to corresponding facets shown in the
   * sellable search results.
   * This useful for cases where the facets internal representation is unknown to the caller but wants to create
   * a preselected facet input to the sellable search api.
   * Note this only provides a transformation, currently no facets are discovered.
   */
  sellableSearchFacets: SellableSearchFacetsPayload;
  consumerSellableReactions: ConsumerSellableReactionConnection;
  sellableResearchLink: SellableResearchLink;
  sellableResearchLinks: Array<SellableResearchLink>;
  findSellableResearchLinks: Array<SellableResearchLink>;
  sellableCustomOfferRulesPagination: SellableCustomOfferRulesPagination;
  findSellableQuestionCandidatesForSellables: Array<SellableQuestionCandidateReview>;
  findSellableQuestionsForSellables: Array<SellableQuestion>;
  sellableSearchPageRelatedLinks: SellableSearchPageRelatedLinks;
  lead?: Maybe<Lead>;
  safeGetLead: LeadPayload;
  batchGetLeads: Array<Lead>;
  leadLabels: Array<LeadLabel>;
  leads: LeadSearchConnection;
  leadSearchFieldGroups: Array<FilterFieldGroup>;
  findExistingLead?: Maybe<Lead>;
  quickReply: QuickReply;
  quickReplies: Array<QuickReply>;
  expertLeadFolderGroups: Array<ExpertLeadFolderGroup>;
  expertLeadFolderItems: LeadSearchConnection;
  leadEscalation: LeadEscalation;
  predictedLifeTimeValues: Array<PredictedLifeTimeValue>;
  leadSurge: LeadSurge;
  countAttentionNeededLeads: Scalars['Int'];
  countOpenLeadEscalations: Scalars['Int'];
  leadFacetTypeahead: Array<FacetTypeaheadPayload>;
  leadTrainingScenario: LeadTrainingScenario;
  leadTrainingScenariosPagination: LeadTrainingScenariosPagination;
  findPracticeLeads: Array<Lead>;
  leadCampaign: LeadCampaign;
  leadCampaignRecipient: LeadCampaignRecipient;
  leadCampaigns: Array<LeadCampaign>;
  campaignAudience: CampaignAudience;
  campaignAudiences: CampaignAudiencePagination;
  /** this is new campaign that supports multiple member types (lead, expert).  will replace lead campaign eventually */
  campaign: Campaign;
  campaignsPagination: CampaignsPagination;
  savedSearch: SavedSearch;
  savedSearches: Array<SavedSearch>;
  runSavedSearch: SavedSearchResultConnection;
  runLeadSavedSearch: LeadSearchConnection;
  /**
   * Find the content object by the template and variation. When preview parameter
   * is null, by default it is for published content
   */
  findContentByTemplate?: Maybe<ContentObject>;
  findContentForCriteria?: Maybe<ContentSelectionResult>;
  contentSelectionRulesPagination: ContentSelectionRulesPagination;
  allContentSpaces: Array<ContentSpace>;
  /**
   * For backwards compatibility, if filter is entirely omitted, will default to
   * shippingSupported == true, billingSupported == true
   */
  countries: Array<Country>;
  country: Country;
  airport: Airport;
  airportTypeahead: AirportTypeaheadPayload;
  report: Report;
  allReports: Array<Report>;
  reportResult: ReportResultPayload;
  expertCuratedItem: ExpertCuratedItem;
  expertCuratedItems: Array<ExpertCuratedItem>;
  expertCuratedItemsForLead: ExpertCuratedItemsForLeadPayload;
  expertCuratedItemActivation: ExpertCuratedItemActivation;
  safeGetExpertCuratedItemActivation: ExpertCuratedItemActivationPayload;
  expertCuratedOrder: ExpertCuratedOrder;
  expertCuratedOrders: Array<ExpertCuratedOrder>;
  expertCuratedOrdersForLeadConnection: ExpertCuratedOrdersForLeadConnection;
  expertCuratedOrderListActivation: ExpertCuratedOrderListActivation;
  expertCuratedOrderListActivations: Array<ExpertCuratedOrderListActivation>;
  expertCuratedOrderListActivationsForLead: ExpertCuratedOrderListActivationConnection;
  expertCuratedLeadItinerary?: Maybe<ExpertCuratedLeadItinerary>;
  /** Get all available curated item tags that can be used, with their display labels */
  defaultExpertCuratedItemTags: Array<ExpertCuratedItemTag>;
  /** Get all available curated item price override reasons that can be used */
  expertCuratedItemPriceOverrideReasons: Array<ExpertCuratedItemPriceOverrideReason>;
  /** @deprecated Use suggestedAlternativesForSellable api instead */
  popularExpertCuratedItemsForSellable: PopularExpertCuratedItemConnection;
  /** Get suggested notes for a sellable */
  suggestExpertCuratedItemNotes: SuggestExpertCuratedItemNotesConnection;
  /** Recommendation and search style API to get ExpertCuratedItems recommended by other experts for similar lead */
  suggestExpertCuratedItemsForLead: SuggestExpertCuratedItemsForLeadConnection;
  /**
   * Recommendation api that suggest similar sellables for the specified query.
   * The recommendations can be a mix of items that were sent as curations to other users or recommendations of sellables
   * based on similarity with other Sellables in our system.
   * This api also deprecates the popularExpertCuratedItemsForSellable api and
   * provides a single unified view for similar sellables
   */
  suggestedAlternativeSellables: SuggestedAlternativeSellableConnection;
  /** Admin api to search for all SuggestedAlternativeSellable */
  searchSuggestedAlternativeSellables: SuggestedAlternativeSellableConnection;
  departmentExpertCuratedActivityFeed: ExpertCuratedActivityFeedItemConnection;
  expertExpertCuratedActivityFeed: ExpertCuratedActivityFeedItemConnection;
  expertTopRecommendedSellables: ExpertTopRecommendedSellablesPayload;
  expertTopRecommendedBrands: ExpertTopRecommendedBrandsPayload;
  searchRecentExpertCuratedItemGroups: RecentExpertCuratedItemGroupConnection;
  searchSavedExpertCuratedItems: SavedExpertCuratedItemsConnection;
  savedCurationsPagination: SavedCurationsPagination;
  savedExpertCuratedItems: SavedExpertCuratedItems;
  simpleCuratedOrder: SimpleCuratedOrder;
  expertCuratedItemsForUser: Array<ExpertCuratedItem>;
  expertCuratedItemNotesPagination: ExpertCuratedItemNotesPagination;
  /** specific endpoint for getting public view */
  expertCuratedOrderListActivationPublicView: ExpertCuratedOrderListActivationPublicView;
  expertCuratedOrderPublicView: ExpertCuratedOrderPublicView;
  expertCuratedItemNote: ExpertCuratedItemNote;
  sellableExpertCuratedItemNoteStatsConnection: SellableExpertCuratedItemNoteStatsConnection;
  sellableExpertCuratedItemNoteStatsPagination: SellableExpertCuratedItemNoteStatsPagination;
  /** Endpoint for getting the suggested pros and cons to use for an expert curated item in a typeahead. */
  suggestedProConTypeahead: SuggestedIndividualExpertCuratedItemProConTypeaheadPayload;
  /** @deprecated Use recommendedLists api */
  recommendedListsForCategory: RecommendedListConnection;
  recommendedLists: RecommendedListConnection;
  recommendedListDefinition: RecommendedListDefinition;
  recommendedListDefinitions: RecommendedListDefinitionConnection;
  triggerEntities: Array<TriggerEntityMeta>;
  triggerActions: Array<TriggerActionMeta>;
  triggerEvents: Array<TriggerEventMeta>;
  trigger: Trigger;
  triggers: Array<Trigger>;
  triggerVersionHistory: Array<Trigger>;
  validateTrigger: ValidateTriggerPayload;
  triggersConnection: TriggersConnection;
  triggerFacetTypeahead: Array<FacetTypeaheadPayload>;
  findShortenedUrl?: Maybe<Scalars['String']>;
  eBayItem: EBayItem;
  searchEBayItems: EBayItemSearchConnection;
  matchSellableForEBayItem?: Maybe<Sellable>;
  config: Config;
  configs: Array<Config>;
  configDomains: Array<ConfigDomain>;
  externalAdCampaign: ExternalAdCampaign;
  externalAdCampaignsByCategory: Array<ExternalAdCampaign>;
  externalAdGroup: ExternalAdGroup;
  systemCuratedItemSurvey: SystemCuratedItemSurvey;
  flightPlan: FlightPlan;
  supportTask?: Maybe<SupportTask>;
  supportTasks: Array<SupportTask>;
  findSupportTasks: SupportTasksConnection;
  findSupportTasksForOperatorFolder: SupportTasksConnection;
  supportTaskFoldersForOperator: Array<SupportTaskFolder>;
  orderEscalation: OrderEscalation;
  orderEscalations: OrderEscalationConnection;
  supportConversation?: Maybe<SupportConversation>;
  supportConversationById: SupportConversation;
  supportConversationsConnection: SupportConversationsConnection;
  sellableInventory: SellableInventoryItem;
  payStructure: PayStructure;
  payStructuresPagination: PayStructuresPagination;
  payStructureRevision: PayStructureRevision;
  payoutsPagination: PayoutsPagination;
  payLineItemsPagination: PayLineItemsPagination;
  payout: Payout;
  payPeriods: Array<PayPeriod>;
  rawSellableSource: RawSellableSource;
  exportRawSellableSource: BsonObject;
  rawSellable: RawSellable;
  standardizedSellable: StandardizedSellable;
  standardizedSellableGroup: StandardizedSellableGroup;
  rawSellableStandardizationRule: RawSellableStandardizationRule;
  exportRawSellableStandardizationRule: BsonObject;
  findRawSellables: Array<RawSellable>;
  findRawSellableSources: Array<RawSellableSource>;
  findRawSellableStandardizationRules: Array<RawSellableStandardizationRule>;
  exportRawSellableStandardizationRules: Array<BsonObject>;
  findStandardizedSellables: Array<StandardizedSellable>;
  findStandardizedSellableGroups: Array<StandardizedSellableGroup>;
  rawSellableStandardizationMeta: RawSellableStandardizationMeta;
  findStandardizedSellableGroupCandidates: Array<StandardizedSellableGroupCandidate>;
  discoverStandardizedSellableGroupVariationGroups: Array<StandardizedSellableGroup>;
  findRawSellableBrandNames: Array<Scalars['String']>;
  findRawSellableAttributeNames: Array<Scalars['String']>;
  findRawSellableAttributeValues: Array<RawSellableAttributeValues>;
  rawSellableSearchConnection: RawSellableSearchConnection;
  fulfillmentCenters: FulfillmentCenterConnection;
  fulfillmentShipmentMethods: FulfillmentShipmentMethodConnection;
  schedulingTypes: Array<SchedulingType>;
  schedulingDepartments: Array<SchedulingDepartment>;
  schedulingType: SchedulingType;
  schedulingUser: SchedulingUser;
  schedulingDemandForecast: SchedulingDemandForecast;
  schedulingDemandForecastDailyView: Array<SchedulingDemandForecastDailyView>;
  schedulingUserAvailability: SchedulingUserAvailability;
  schedulingUserAvailabilityDailyView: Array<SchedulingUserAvailabilityDailyView>;
  shift: Shift;
  shiftDailyView: Array<ShiftDailyView>;
  shiftTeamDailyView: Array<ShiftTeamDailyView>;
  shiftTimeIntervalDailyView: Array<ShiftTimeIntervalDailyView>;
  shiftSlotUserDailyView: Array<ShiftSlotUserDailyView>;
  shiftSlotDailyView: Array<ShiftSlotDailyView>;
  findShiftProbations: Array<SchedulingUser>;
  findShiftAbsences: Array<Shift>;
  getFulfillmentChannel: FulfillmentChannel;
  findFulfillmentChannels: FulfillmentChannelsConnection;
  fulfillmentChannelsPagination: FulfillmentChannelsPagination;
  getOrderRefund: OrderRefund;
  orderRefundsConnection: OrderRefundsConnection;
  orderRefundsPagination: OrderRefundsPagination;
  getShipmentPricingModel: ShipmentPricingModel;
  shipmentPricingModelsPagination: ShipmentPricingModelPagination;
  ticket: Ticket;
  ticketsConnection: TicketsConnection;
  searchTickets: TicketSearchConnection;
  searchTicketsPagination: TicketsPagination;
  ticketTimeline: TicketTimeline;
  lookupReferralCode: LookupReferralCodePayload;
  consumerGenericReferralCode: ReferralCode;
  potentialConsumerReferralSources: Array<ReferralCode>;
  expertDirectReferralCode: GetReferralCodePayload;
  referralCodeShare: ReferralCodeShare;
  experimentsUpdatedAfter: ExperimentsUpdatedAfterPayload;
  experiment: ExperimentDefinition;
  experimentByName?: Maybe<ExperimentDefinition>;
  experiments: Array<ExperimentDefinition>;
  findExperiments: ExperimentsPagination;
  findExperimentUsages: Array<ExperimentUsage>;
  leadSpecialCareAttribute: AttributeSchemaRevision;
  bookingsConnection: BookingsConnection;
  articleRevision: ArticleRevision;
  articleRevisions: Array<ArticleRevision>;
  findPublishedArticleRevisionByArticleIdOrFriendlyId?: Maybe<ArticleRevision>;
  findPublishedArticleRevisionByArticleId?: Maybe<ArticleRevision>;
  findPublishedArticleRevisionByArticleIds: Array<ArticleRevision>;
  findDraftArticleRevisionByArticleId?: Maybe<ArticleRevision>;
  findDraftArticleRevisionByArticleIds: Array<ArticleRevision>;
  findArticleRevisionsByArticleId: Array<ArticleRevision>;
  searchArticles: ArticleSearchConnection;
  relatedArticles: Array<ArticleRevision>;
  articleTopLevelNavigation: ArticleNavigation;
  articleCategories: Array<Category>;
  sellableTopListDefinition: SellableTopListDefinition;
  sellableTopListDefinitionPagination: SellableTopListDefinitionsPagination;
  findSellableTopListByExternalIdOrFriendlyId?: Maybe<SellableTopList>;
  filterFieldIdValueTypeahead: FilterFieldIdValueTypeaheadPayload;
  filterFieldStringValueTypeahead: FilterFieldStringValueTypeaheadPayload;
  ledgerTransactionsForAccount: Array<LedgerTransaction>;
  ledgerTransactionsForEntry: Array<LedgerTransaction>;
  conversationStarters: Array<ConversationStarter>;
  giftCard: GiftCard;
  purchasedGiftCards: Array<GiftCard>;
  findGiftCardForRedemption: FindGiftCardForRedemptionPayload;
  productCatalogRevision: ProductCatalogRevision;
  productCatalogRevisions: Array<ProductCatalogRevision>;
  productCatalogGroupRevision: ProductCatalogGroupRevision;
  productCatalogGroupRevisions: Array<ProductCatalogGroupRevision>;
  publishedProductCatalog?: Maybe<ProductCatalogRevision>;
  publishedProductCatalogs: Array<ProductCatalogRevision>;
  publishedProductCatalogGroup?: Maybe<ProductCatalogGroupRevision>;
  publishedProductCatalogGroups: Array<ProductCatalogGroupRevision>;
  searchProductCatalogs: ProductCatalogSearchConnection;
  partnerUser: PartnerUser;
};


export type QueryApprovalRequestArgs = {
  id: Scalars['ApprovalRequestId'];
};


export type QueryFindApprovalRequestForRevisionArgs = {
  revisionId: Scalars['AnyId'];
};


export type QueryApprovalRequestSubmitDraftArgs = {
  id: Scalars['ApprovalRequestSubmitDraftId'];
};


export type QueryAttributeSchemaRevisionArgs = {
  id: Scalars['AttributeSchemaRevisionId'];
};


export type QueryAttributeSchemaRevisionPaginationArgs = {
  query?: Maybe<AttributeSchemaRevisionQueryInput>;
  offset?: Maybe<Scalars['Int']>;
  limit?: Maybe<Scalars['Int']>;
  sort?: Maybe<AttributeSchemaRevisionSort>;
  order?: Maybe<SortOrder>;
};


export type QueryExportAttributeSchemaRevisionsArgs = {
  ids?: Maybe<Array<Scalars['AttributeSchemaRevisionId']>>;
};


export type QueryMaskedHandleArgs = {
  id: Scalars['AnyId'];
};


export type QueryMaskedHandlesByLoginTokenArgs = {
  loginToken: Scalars['String'];
};


export type QueryCategoriesArgs = {
  categoryTypes?: Maybe<Array<Maybe<CategoryType>>>;
  first?: Maybe<Scalars['Int']>;
  after?: Maybe<Scalars['String']>;
};


export type QueryCategoryArgs = {
  categoryId: Scalars['CategoryId'];
};


export type QueryCategoryBySlugArgs = {
  slug: Scalars['String'];
};


export type QueryDepartmentsForNavigationArgs = {
  version?: Maybe<Scalars['String']>;
};


export type QueryDepartmentArgs = {
  id: Scalars['DepartmentId'];
};


export type QueryDepartmentBySlugArgs = {
  slug: Scalars['String'];
};


export type QueryCommTemplateArgs = {
  id: Scalars['CommTemplateId'];
};


export type QueryCommTemplatesArgs = {
  filter: CommTemplateFilter;
};


export type QueryCommTemplateVersionHistoryArgs = {
  historyId: Scalars['CommTemplateVersionHistoryId'];
};


export type QueryCommTemplateTypesArgs = {
  filter?: Maybe<CommTemplateTypeFilter>;
};


export type QueryCommTemplateTypeArgs = {
  id: Scalars['CommTemplateTypeId'];
};


export type QueryRenderCommTemplateArgs = {
  input: RenderCommTemplateInput;
};


export type QueryCommTemplateDataModelArgs = {
  input: CommTemplateDataModelInput;
};


export type QueryCommTemplateFragmentArgs = {
  id: Scalars['CommTemplateFragmentId'];
};


export type QueryCommTemplateFragmentsArgs = {
  filter: CommTemplateFragmentFilter;
};


export type QueryCommTemplateFragmentVersionHistoryArgs = {
  historyId: Scalars['CommTemplateFragmentVersionHistoryId'];
};


export type QueryTemplateMessageDeliveryLogsArgs = {
  filter: TemplateMessageDeliveryLogFilterInput;
  offset?: Maybe<Scalars['Int']>;
  limit?: Maybe<Scalars['Int']>;
};


export type QueryCommTemplatesConnectionArgs = {
  query: TemplateSearchRequestInput;
  after?: Maybe<Scalars['String']>;
  first?: Maybe<Scalars['Int']>;
  before?: Maybe<Scalars['String']>;
  last?: Maybe<Scalars['Int']>;
  sortBy?: Maybe<TemplateSearchSort>;
  sortOrder?: Maybe<SortOrder>;
};


export type QueryCommTemplateFacetTypeaheadArgs = {
  facetName: Scalars['String'];
  keyword: Scalars['String'];
  first?: Maybe<Scalars['Int']>;
};


export type QueryTemplateMessageDeliveryLogArgs = {
  id?: Maybe<Scalars['MessageDeliveryLogId']>;
};


export type QueryDealRequestArgs = {
  id: Scalars['DealRequestId'];
};


export type QueryFindDealRequestsArgs = {
  filters: DealRequestFilter;
};


export type QueryFindContactArgs = {
  contactId: Scalars['ContactId'];
};


export type QueryUserArgs = {
  userId: Scalars['UserId'];
};


export type QueryUserRegistrationArgs = {
  id: Scalars['UserRegistrationId'];
};


export type QueryUserByContactArgs = {
  type: ContactType;
  value: Scalars['String'];
};


export type QueryUsersByContactArgs = {
  contacts?: Maybe<Array<Scalars['String']>>;
};


export type QueryMerchantArgs = {
  id: Scalars['MerchantId'];
};


export type QueryMerchantsPaginationArgs = {
  input?: Maybe<MerchantQueryInput>;
  offset?: Maybe<Scalars['Int']>;
  limit?: Maybe<Scalars['Int']>;
  sortBy?: Maybe<MerchantSortField>;
  sortOrder?: Maybe<SortOrder>;
};


export type QuerySuggestMerchantsArgs = {
  name: Scalars['String'];
  categoryId?: Maybe<Scalars['CategoryId']>;
};


export type QuerySearchUsersArgs = {
  query: UserSearchQuery;
  offset?: Maybe<Scalars['Int']>;
  limit?: Maybe<Scalars['Int']>;
};


export type QueryOperatorsArgs = {
  query: OperatorQuery;
};


export type QueryPendingAccessContactArgs = {
  id: Scalars['PendingAccessContactId'];
};


export type QueryAwayAutoReplyArgs = {
  id: Scalars['AwayAutoReplyId'];
};


export type QueryExportIdentitiesArgs = {
  ids: Array<Scalars['AnyId']>;
};


export type QueryValidateSmsPromotionRegistrationArgs = {
  input: ValidateSmsPromotionRegistrationInput;
};


export type QueryBusinessUserArgs = {
  id: Scalars['BusinessUserId'];
};


export type QueryBusinessUsersArgs = {
  ids: Array<Scalars['BusinessUserId']>;
};


export type QueryExpertsArgs = {
  includeInactive: Scalars['Boolean'];
};


export type QueryBusinessAccountArgs = {
  id: Scalars['BusinessAccountId'];
};


export type QueryBusinessUserTeamArgs = {
  id: Scalars['BusinessUserTeamId'];
};


export type QueryFindBusinessUserTeamsArgs = {
  filter: BusinessUserTeamFilterInput;
  offset?: Maybe<Scalars['Int']>;
  limit?: Maybe<Scalars['Int']>;
};


export type QueryConversationArgs = {
  id: Scalars['ConversationId'];
};


export type QueryConversationByExternalIdArgs = {
  externalId: Scalars['String'];
};


export type QueryMessagingUsersArgs = {
  ids: Array<Scalars['AnyId']>;
};


export type QueryCallActivityConnectionArgs = {
  input?: Maybe<CallActivityFilterInput>;
  after?: Maybe<Scalars['String']>;
  first?: Maybe<Scalars['Int']>;
  before?: Maybe<Scalars['String']>;
  last?: Maybe<Scalars['Int']>;
};


export type QueryGuestConversationSequenceArgs = {
  id: Scalars['GuestConversationSequenceId'];
};


export type QueryFindGuestConversationSequencesArgs = {
  query: GuestConversationSequenceQuery;
};


export type QueryCountRingingCallsArgs = {
  callingFor: Array<Scalars['AnyId']>;
};


export type QueryPathFlowArgs = {
  id: Scalars['PathFlowId'];
};


export type QueryPathFlowPageArgs = {
  id: Scalars['PathFlowId'];
  pageSlug: Scalars['String'];
};


export type QueryPathFlowBySlugArgs = {
  pathFlowSlug: Scalars['String'];
};


export type QueryPathFlowPageBySlugsArgs = {
  pathFlowSlug: Scalars['String'];
  pathFlowPageSlug: Scalars['String'];
};


export type QueryPathSchemaRevisionArgs = {
  id: Scalars['PathSchemaRevisionId'];
};


export type QueryPathSchemaFragmentRevisionArgs = {
  id: Scalars['PathSchemaFragmentRevisionId'];
};


export type QueryPathEditorContextArgs = {
  schemaRevisionId: Scalars['AnyId'];
  editorStateId?: Maybe<Scalars['PathEditorStateId']>;
};


export type QueryPathSchemaRevisionsPaginationArgs = {
  query?: Maybe<PathGraphContainerQueryInput>;
  offset?: Maybe<Scalars['Int']>;
  limit?: Maybe<Scalars['Int']>;
  sort?: Maybe<PathGraphContainerSort>;
};


export type QueryPathSchemaFragmentRevisionsPaginationArgs = {
  query?: Maybe<PathGraphContainerQueryInput>;
  offset?: Maybe<Scalars['Int']>;
  limit?: Maybe<Scalars['Int']>;
  sort?: Maybe<PathGraphContainerSort>;
};


export type QueryExportPathGraphContainersArgs = {
  ids: Array<Scalars['AnyId']>;
};


export type QueryShippingCarriersArgs = {
  includeInternal?: Maybe<Scalars['Boolean']>;
};


export type QueryOrderArgs = {
  id: Scalars['OrderId'];
};


export type QuerySafeGetOrderArgs = {
  id: Scalars['OrderId'];
};


export type QueryOrderLineItemArgs = {
  id: Scalars['OrderLineItemId'];
};


export type QueryTransactionArgs = {
  id: Scalars['TransactionId'];
};


export type QueryFindOrdersArgs = {
  state?: Maybe<OrderState>;
  fulfillmentState?: Maybe<OrderFulfillmentState>;
  orderLineItemState?: Maybe<OrderLineItemState>;
  userId?: Maybe<Scalars['UserId']>;
};


export type QueryOrdersConnectionArgs = {
  query?: Maybe<OrderQuery>;
  sort?: Maybe<OrderSearchSort>;
  after?: Maybe<Scalars['String']>;
  first?: Maybe<Scalars['Int']>;
  before?: Maybe<Scalars['String']>;
  last?: Maybe<Scalars['Int']>;
};


export type QueryPaymentSourceArgs = {
  id: Scalars['PaymentSourceId'];
};


export type QueryReusablePaymentSourcesArgs = {
  paymentMethod?: Maybe<PaymentMethod>;
};


export type QueryRecommendTipPercentagesForOrderArgs = {
  id: Scalars['OrderId'];
};


export type QueryPromotionArgs = {
  id: Scalars['PromotionId'];
};


export type QueryPromotionsConnectionArgs = {
  query?: Maybe<PromotionQueryInput>;
  after?: Maybe<Scalars['String']>;
  first?: Maybe<Scalars['Int']>;
};


export type QueryPromotionsPaginationArgs = {
  query?: Maybe<PromotionQueryInput>;
  offset?: Maybe<Scalars['Int']>;
  limit?: Maybe<Scalars['Int']>;
};


export type QueryActivePromotionByCodeArgs = {
  code?: Maybe<Scalars['String']>;
};


export type QueryOrderShippingCostArgs = {
  id: Scalars['OrderId'];
  orderShippingCostAddress?: Maybe<OrderShippingCostAddressInput>;
};


export type QueryTagsArgs = {
  type: TagType;
};


export type QueryFrontendTaskArgs = {
  id: Scalars['FrontendTaskId'];
};


export type QueryBroadcastOfferArgs = {
  id: Scalars['BroadcastOfferId'];
};


export type QueryMediaFileArgs = {
  id: Scalars['MediaId'];
};


export type QueryMediaFilesArgs = {
  ids: Array<Scalars['MediaId']>;
};


export type QueryOpenGraphDataArgs = {
  url: Scalars['String'];
};


export type QueryEmbedMediaArgs = {
  id: Scalars['String'];
};


export type QueryExportMediaFilesArgs = {
  ids: Array<Scalars['MediaId']>;
};


export type QueryFindExpertArgs = {
  vanityIdOrId: Scalars['String'];
};


export type QueryExpertProfileArgs = {
  id: Scalars['ExpertProfileId'];
};


export type QueryRecommendExpertArgs = {
  consumerId: Scalars['UserId'];
  categoryId: Scalars['CategoryId'];
};


export type QueryRecommendExpert2Args = {
  consumerId: Scalars['UserId'];
  categoryId: Scalars['CategoryId'];
};


export type QueryRecommendExpertForRequestArgs = {
  requestId: Scalars['DealRequestId'];
};


export type QueryRecommendExpertsForPathFlowArgs = {
  pathFlowId: Scalars['PathFlowId'];
  limit?: Maybe<Scalars['Int']>;
};


export type QueryRecommendExpertsForDepartmentArgs = {
  departmentId: Scalars['DepartmentId'];
  limit?: Maybe<Scalars['Int']>;
};


export type QueryConsumerExpertReviewArgs = {
  id: Scalars['ConsumerExpertReviewId'];
};


export type QueryConsumerExpertReviewConnectionArgs = {
  query: ConsumerReviewSearchQuery;
  after?: Maybe<Scalars['String']>;
  first?: Maybe<Scalars['Int']>;
  before?: Maybe<Scalars['String']>;
  last?: Maybe<Scalars['Int']>;
  sortBy?: ConsumerReviewSearchSort;
};


export type QueryConsumerExpertReviewFacetTypeaheadArgs = {
  facetName: Scalars['String'];
  keyword: Scalars['String'];
  first?: Maybe<Scalars['Int']>;
};


export type QueryExpertApplicationArgs = {
  id: Scalars['ExpertApplicationId'];
};


export type QueryExpertApplicationsArgs = {
  ids: Array<Scalars['ExpertApplicationId']>;
};


export type QueryExpertApplicationsPaginationArgs = {
  query?: Maybe<ExpertApplicationQuery>;
  offset?: Maybe<Scalars['Int']>;
  limit?: Maybe<Scalars['Int']>;
};


export type QueryExpertApplicationsConnectionArgs = {
  query?: Maybe<ExpertApplicationSearchQueryInput>;
  after?: Maybe<Scalars['String']>;
  first?: Maybe<Scalars['Int']>;
  before?: Maybe<Scalars['String']>;
  last?: Maybe<Scalars['Int']>;
  sortBy?: Maybe<ExpertApplicationSearchSort>;
  sortDescending?: Maybe<Scalars['Boolean']>;
};


export type QueryExpertApplicationsPendingReviewArgs = {
  after?: Maybe<Scalars['String']>;
  first?: Maybe<Scalars['Int']>;
  before?: Maybe<Scalars['String']>;
  last?: Maybe<Scalars['Int']>;
};


export type QueryExpertApplicationFacetTypeaheadArgs = {
  facetName: Scalars['String'];
  keyword: Scalars['String'];
  first?: Maybe<Scalars['Int']>;
};


export type QueryExpertProfilesPaginationArgs = {
  query?: Maybe<ExpertProfileQuery>;
  offset?: Maybe<Scalars['Int']>;
  limit?: Maybe<Scalars['Int']>;
};


export type QueryExpertSearchConnectionArgs = {
  query?: Maybe<ExpertSearchQuery>;
  after?: Maybe<Scalars['String']>;
  first?: Maybe<Scalars['Int']>;
  before?: Maybe<Scalars['String']>;
  last?: Maybe<Scalars['Int']>;
  sortBy?: Maybe<ExpertSearchSort>;
};


export type QueryExpertApplicationFolderGroupsArgs = {
  hiringFlowId?: Maybe<Scalars['ExpertHiringFlowId']>;
};


export type QueryExpertApplicationFolderItemsArgs = {
  hiringFlowId?: Maybe<Scalars['ExpertHiringFlowId']>;
  departmentId?: Maybe<Scalars['DepartmentId']>;
  approvedById?: Maybe<Scalars['OperatorId']>;
  folderSlug: Scalars['String'];
  after?: Maybe<Scalars['String']>;
  first?: Maybe<Scalars['Int']>;
  before?: Maybe<Scalars['String']>;
  last?: Maybe<Scalars['Int']>;
};


export type QueryExpertTypeaheadArgs = {
  query?: Maybe<ExpertTypeaheadQuery>;
  first?: Maybe<Scalars['Int']>;
};


export type QueryExpertReferralArgs = {
  id: Scalars['ExpertReferralId'];
};


export type QueryExpertPerformanceStatisticsArgs = {
  filter: ExpertPerformanceStatisticsFilter;
  offset?: Maybe<Scalars['Int']>;
  limit?: Maybe<Scalars['Int']>;
};


export type QueryExpertRankComputationLogsArgs = {
  expertId: Scalars['BusinessUserId'];
};


export type QueryEstimatedExpertRpalStatsArgs = {
  expertId: Scalars['BusinessUserId'];
  days: Scalars['Int'];
};


export type QueryExpertNewLeadEligibilityArgs = {
  expertId: Scalars['BusinessUserId'];
};


export type QueryExpertBroadcastLeadEligibilityArgs = {
  expertId: Scalars['BusinessUserId'];
};


export type QueryDealArgs = {
  id: Scalars['DealId'];
};


export type QueryBrandsArgs = {
  activeOnly?: Maybe<Scalars['Boolean']>;
  first?: Maybe<Scalars['Int']>;
  after?: Maybe<Scalars['String']>;
  last?: Maybe<Scalars['Int']>;
  before?: Maybe<Scalars['String']>;
};


export type QueryBrandTypeaheadArgs = {
  query: BrandTypeaheadQuery;
  first?: Maybe<Scalars['Int']>;
};


export type QuerySavedSellableArgs = {
  id: Scalars['SavedSellableId'];
};


export type QuerySavedSellablesConnectionArgs = {
  query: SavedSellableQueryInput;
  after?: Maybe<Scalars['String']>;
  first?: Maybe<Scalars['Int']>;
};


export type QuerySellableArgs = {
  id: Scalars['SellableId'];
};


export type QueryFindSellableArgs = {
  friendlyIdOrId: Scalars['String'];
};


export type QuerySellablesArgs = {
  ids: Array<Scalars['SellableId']>;
};


export type QuerySearchSellablesArgs = {
  query?: Maybe<SellableSearchQuery>;
  after?: Maybe<Scalars['String']>;
  first?: Maybe<Scalars['Int']>;
  before?: Maybe<Scalars['String']>;
  last?: Maybe<Scalars['Int']>;
  sortBy?: Maybe<SellableSort>;
  order?: Maybe<SortOrder>;
};


export type QuerySearchSellablesPaginationArgs = {
  query?: Maybe<SellableSearchQuery>;
  offset?: Maybe<Scalars['Int']>;
  limit?: Maybe<Scalars['Int']>;
  sortBy?: Maybe<SellableSort>;
  order?: Maybe<SortOrder>;
};


export type QuerySellableTypeaheadArgs = {
  query?: Maybe<SellableTypeaheadQuery>;
  first?: Maybe<Scalars['Int']>;
};


export type QuerySimilarSellablesArgs = {
  id: Scalars['SellableId'];
  topN?: Maybe<Scalars['Int']>;
  leadId?: Maybe<Scalars['LeadId']>;
  filters?: Maybe<Array<SuggestedSellableFilter>>;
};


export type QuerySellableSearchFacetsArgs = {
  query: SellableSearchFacetsQuery;
};


export type QueryConsumerSellableReactionsArgs = {
  query?: Maybe<ConsumerSellableReactionsQuery>;
  after?: Maybe<Scalars['String']>;
  first?: Maybe<Scalars['Int']>;
  before?: Maybe<Scalars['String']>;
  last?: Maybe<Scalars['Int']>;
};


export type QuerySellableResearchLinkArgs = {
  id: Scalars['SellableResearchLinkId'];
};


export type QuerySellableResearchLinksArgs = {
  ids: Array<Scalars['SellableResearchLinkId']>;
};


export type QueryFindSellableResearchLinksArgs = {
  input: SellableResearchLinkFilter;
};


export type QuerySellableCustomOfferRulesPaginationArgs = {
  input: SellableCustomOfferRuleFilterInput;
  offset?: Maybe<Scalars['Int']>;
  limit?: Maybe<Scalars['Int']>;
};


export type QueryFindSellableQuestionCandidatesForSellablesArgs = {
  sellableIds: Array<Scalars['SellableId']>;
  state: SellableQuestionCandidateState;
  offset?: Maybe<Scalars['Int']>;
  limit?: Maybe<Scalars['Int']>;
};


export type QueryFindSellableQuestionsForSellablesArgs = {
  sellableIds: Array<Scalars['SellableId']>;
  state: SellableQuestionState;
  offset?: Maybe<Scalars['Int']>;
  limit?: Maybe<Scalars['Int']>;
};


export type QuerySellableSearchPageRelatedLinksArgs = {
  input: SellableSearchPageRelatedLinksInput;
  limit?: Maybe<Scalars['Int']>;
};


export type QueryLeadArgs = {
  id: Scalars['LeadId'];
};


export type QuerySafeGetLeadArgs = {
  id: Scalars['LeadId'];
};


export type QueryBatchGetLeadsArgs = {
  ids: Array<Scalars['LeadId']>;
};


export type QueryLeadsArgs = {
  query: LeadSearchQuery;
  after?: Maybe<Scalars['String']>;
  first?: Maybe<Scalars['Int']>;
  before?: Maybe<Scalars['String']>;
  last?: Maybe<Scalars['Int']>;
  sort?: Maybe<LeadSortOrder>;
};


export type QueryFindExistingLeadArgs = {
  consumerId: Scalars['UserId'];
  expertId: Scalars['BusinessUserId'];
};


export type QueryQuickReplyArgs = {
  id: Scalars['QuickReplyId'];
};


export type QueryQuickRepliesArgs = {
  query: QuickReplyQuery;
};


export type QueryExpertLeadFolderGroupsArgs = {
  expertId?: Maybe<Scalars['BusinessUserId']>;
  expertTeamId?: Maybe<Scalars['BusinessUserTeamId']>;
};


export type QueryExpertLeadFolderItemsArgs = {
  expertId?: Maybe<Scalars['BusinessUserId']>;
  expertTeamId?: Maybe<Scalars['BusinessUserTeamId']>;
  folderName: Scalars['String'];
  after?: Maybe<Scalars['String']>;
  first?: Maybe<Scalars['Int']>;
  before?: Maybe<Scalars['String']>;
  last?: Maybe<Scalars['Int']>;
};


export type QueryLeadEscalationArgs = {
  id: Scalars['LeadEscalationId'];
};


export type QueryPredictedLifeTimeValuesArgs = {
  id: Scalars['UserId'];
  ltvType?: Maybe<LtvType>;
  adPlatform?: Maybe<Scalars['String']>;
};


export type QueryLeadSurgeArgs = {
  id: Scalars['LeadSurgeId'];
};


export type QueryCountAttentionNeededLeadsArgs = {
  expertId: Scalars['BusinessUserId'];
};


export type QueryCountOpenLeadEscalationsArgs = {
  expertId: Scalars['BusinessUserId'];
  expertRole?: Maybe<LeadExpertRole>;
};


export type QueryLeadFacetTypeaheadArgs = {
  facetName: Scalars['String'];
  keyword: Scalars['String'];
  first?: Maybe<Scalars['Int']>;
};


export type QueryLeadTrainingScenarioArgs = {
  id: Scalars['LeadTrainingScenarioId'];
};


export type QueryLeadTrainingScenariosPaginationArgs = {
  input: LeadTrainingScenarioFilterInput;
  offset?: Maybe<Scalars['Int']>;
  limit?: Maybe<Scalars['Int']>;
};


export type QueryFindPracticeLeadsArgs = {
  expertId: Scalars['BusinessUserId'];
};


export type QueryLeadCampaignArgs = {
  id: Scalars['LeadCampaignId'];
};


export type QueryLeadCampaignRecipientArgs = {
  id: Scalars['LeadCampaignRecipientId'];
};


export type QueryLeadCampaignsArgs = {
  input: LeadCampaignFilter;
};


export type QueryCampaignAudienceArgs = {
  id: Scalars['CampaignAudienceId'];
};


export type QueryCampaignAudiencesArgs = {
  filter: CampaignAudienceFilter;
  offset?: Maybe<Scalars['Int']>;
  limit?: Maybe<Scalars['Int']>;
  sortBy?: Maybe<CampaignAudienceSort>;
  sortOrder?: Maybe<SortOrder>;
};


export type QueryCampaignArgs = {
  id: Scalars['CampaignId'];
};


export type QueryCampaignsPaginationArgs = {
  filter: CampaignFilterInput;
  offset?: Maybe<Scalars['Int']>;
  limit?: Maybe<Scalars['Int']>;
};


export type QuerySavedSearchArgs = {
  id: Scalars['SavedSearchId'];
};


export type QuerySavedSearchesArgs = {
  groupName: Scalars['String'];
  entityName: Scalars['String'];
};


export type QueryRunSavedSearchArgs = {
  id: Scalars['SavedSearchId'];
  after?: Maybe<Scalars['String']>;
  first?: Maybe<Scalars['Int']>;
  before?: Maybe<Scalars['String']>;
  last?: Maybe<Scalars['Int']>;
};


export type QueryRunLeadSavedSearchArgs = {
  id: Scalars['SavedSearchId'];
  after?: Maybe<Scalars['String']>;
  first?: Maybe<Scalars['Int']>;
  before?: Maybe<Scalars['String']>;
  last?: Maybe<Scalars['Int']>;
  context: LeadSavedSearchContext;
};


export type QueryFindContentByTemplateArgs = {
  space?: Maybe<Scalars['String']>;
  template: Scalars['String'];
  variation: Scalars['String'];
  preview?: Maybe<Scalars['Boolean']>;
};


export type QueryFindContentForCriteriaArgs = {
  input: ContentSelectionCriteriaInput;
};


export type QueryContentSelectionRulesPaginationArgs = {
  input: ContentSelectionRuleFilterInput;
  offset?: Maybe<Scalars['Int']>;
  limit?: Maybe<Scalars['Int']>;
};


export type QueryCountriesArgs = {
  filter?: Maybe<CountryFilter>;
};


export type QueryCountryArgs = {
  countryCode: Scalars['String'];
};


export type QueryAirportArgs = {
  airport: Scalars['AirportId'];
};


export type QueryAirportTypeaheadArgs = {
  query?: Maybe<AirportTypeaheadQuery>;
  first?: Maybe<Scalars['Int']>;
};


export type QueryReportArgs = {
  id: Scalars['ReportId'];
};


export type QueryReportResultArgs = {
  query: ReportResultQuery;
};


export type QueryExpertCuratedItemArgs = {
  id: Scalars['ExpertCuratedItemId'];
};


export type QueryExpertCuratedItemsArgs = {
  ids: Array<Scalars['ExpertCuratedItemId']>;
};


export type QueryExpertCuratedItemsForLeadArgs = {
  leadId: Scalars['LeadId'];
};


export type QueryExpertCuratedItemActivationArgs = {
  id: Scalars['ExpertCuratedItemActivationId'];
};


export type QuerySafeGetExpertCuratedItemActivationArgs = {
  id: Scalars['ExpertCuratedItemActivationId'];
};


export type QueryExpertCuratedOrderArgs = {
  id: Scalars['ExpertCuratedOrderId'];
};


export type QueryExpertCuratedOrdersArgs = {
  ids: Array<Scalars['ExpertCuratedOrderId']>;
};


export type QueryExpertCuratedOrdersForLeadConnectionArgs = {
  query: ExpertCuratedOrdersForLeadQueryInput;
  after?: Maybe<Scalars['String']>;
  first?: Maybe<Scalars['Int']>;
  before?: Maybe<Scalars['String']>;
  last?: Maybe<Scalars['Int']>;
};


export type QueryExpertCuratedOrderListActivationArgs = {
  id: Scalars['ExpertCuratedOrderListActivationId'];
};


export type QueryExpertCuratedOrderListActivationsArgs = {
  ids: Array<Scalars['ExpertCuratedOrderListActivationId']>;
};


export type QueryExpertCuratedOrderListActivationsForLeadArgs = {
  leadId: Scalars['LeadId'];
  after?: Maybe<Scalars['String']>;
  first?: Maybe<Scalars['Int']>;
  before?: Maybe<Scalars['String']>;
  last?: Maybe<Scalars['Int']>;
};


export type QueryExpertCuratedLeadItineraryArgs = {
  leadId: Scalars['LeadId'];
};


export type QueryPopularExpertCuratedItemsForSellableArgs = {
  query: PopularExpertCuratedItemQueryInput;
  after?: Maybe<Scalars['String']>;
  first?: Maybe<Scalars['Int']>;
  before?: Maybe<Scalars['String']>;
  last?: Maybe<Scalars['Int']>;
};


export type QuerySuggestExpertCuratedItemNotesArgs = {
  query: SuggestExpertCuratedItemNotesQueryInput;
  after?: Maybe<Scalars['String']>;
  first?: Maybe<Scalars['Int']>;
  sort?: Maybe<SuggestExpertCuratedItemNotesSort>;
};


export type QuerySuggestExpertCuratedItemsForLeadArgs = {
  query: SuggestExpertCuratedItemsForLeadQueryInput;
  after?: Maybe<Scalars['String']>;
  first?: Maybe<Scalars['Int']>;
  before?: Maybe<Scalars['String']>;
  last?: Maybe<Scalars['Int']>;
};


export type QuerySuggestedAlternativeSellablesArgs = {
  input: SuggestedAlternativeSellableInput;
  after?: Maybe<Scalars['String']>;
  first?: Maybe<Scalars['Int']>;
  before?: Maybe<Scalars['String']>;
  last?: Maybe<Scalars['Int']>;
};


export type QuerySearchSuggestedAlternativeSellablesArgs = {
  input: SuggestedAlternativeSellableSearchInput;
  after?: Maybe<Scalars['String']>;
  first?: Maybe<Scalars['Int']>;
  before?: Maybe<Scalars['String']>;
  last?: Maybe<Scalars['Int']>;
};


export type QueryDepartmentExpertCuratedActivityFeedArgs = {
  id: Scalars['DepartmentId'];
  after?: Maybe<Scalars['String']>;
  first?: Maybe<Scalars['Int']>;
};


export type QueryExpertExpertCuratedActivityFeedArgs = {
  id: Scalars['BusinessUserId'];
  after?: Maybe<Scalars['String']>;
  first?: Maybe<Scalars['Int']>;
};


export type QueryExpertTopRecommendedSellablesArgs = {
  query: ExpertTopRecommendedSellablesInput;
};


export type QueryExpertTopRecommendedBrandsArgs = {
  query: ExpertTopRecommendedBrandsInput;
};


export type QuerySearchRecentExpertCuratedItemGroupsArgs = {
  filter: RecentExpertCuratedItemGroupSearchFilter;
  after?: Maybe<Scalars['String']>;
  first?: Maybe<Scalars['Int']>;
  before?: Maybe<Scalars['String']>;
  last?: Maybe<Scalars['Int']>;
};


export type QuerySearchSavedExpertCuratedItemsArgs = {
  filter: SavedExpertCuratedItemsSearchFilter;
  after?: Maybe<Scalars['String']>;
  first?: Maybe<Scalars['Int']>;
  before?: Maybe<Scalars['String']>;
  last?: Maybe<Scalars['Int']>;
};


export type QuerySavedCurationsPaginationArgs = {
  query: SavedCurationsQuery;
  offset?: Maybe<Scalars['Int']>;
  limit?: Maybe<Scalars['Int']>;
};


export type QuerySavedExpertCuratedItemsArgs = {
  id: Scalars['SavedExpertCuratedItemsId'];
};


export type QuerySimpleCuratedOrderArgs = {
  id: Scalars['SimpleCuratedOrderId'];
};


export type QueryExpertCuratedItemsForUserArgs = {
  input: ExpertCuratedItemQueryByUserInput;
  size?: Maybe<Scalars['Int']>;
};


export type QueryExpertCuratedItemNotesPaginationArgs = {
  query: ExpertCuratedItemNotesPaginationQueryInput;
  sort?: Maybe<ExpertCuratedItemNoteSort>;
  sortOrder?: Maybe<SortOrder>;
  offset?: Maybe<Scalars['Int']>;
  limit?: Maybe<Scalars['Int']>;
};


export type QueryExpertCuratedOrderListActivationPublicViewArgs = {
  id: Scalars['ExpertCuratedOrderListActivationId'];
};


export type QueryExpertCuratedOrderPublicViewArgs = {
  id: Scalars['ExpertCuratedOrderId'];
};


export type QueryExpertCuratedItemNoteArgs = {
  id: Scalars['ExpertCuratedItemNoteId'];
};


export type QuerySellableExpertCuratedItemNoteStatsConnectionArgs = {
  query: SellableExpertCuratedItemNoteStatsSearchRequest;
  sortBy?: Maybe<SellableExpertCuratedItemNoteStatsSort>;
  sortOrder?: Maybe<SortOrder>;
  after?: Maybe<Scalars['String']>;
  first?: Maybe<Scalars['Int']>;
  before?: Maybe<Scalars['String']>;
  last?: Maybe<Scalars['Int']>;
};


export type QuerySellableExpertCuratedItemNoteStatsPaginationArgs = {
  query: SellableExpertCuratedItemNoteStatsSearchRequest;
  sortBy?: Maybe<SellableExpertCuratedItemNoteStatsSort>;
  sortOrder?: Maybe<SortOrder>;
  offset?: Maybe<Scalars['Int']>;
  limit?: Maybe<Scalars['Int']>;
};


export type QuerySuggestedProConTypeaheadArgs = {
  input: SuggestedIndividualExpertCuratedItemProConTypeaheadQueryInput;
  sortBy?: Maybe<SuggestedIndividualExpertCuratedItemProConTypeaheadSort>;
  limit?: Maybe<Scalars['Int']>;
};


export type QueryRecommendedListsForCategoryArgs = {
  categorySlug: Scalars['String'];
  types?: Maybe<Array<RecommendedListType>>;
  after?: Maybe<Scalars['String']>;
  first?: Maybe<Scalars['Int']>;
  before?: Maybe<Scalars['String']>;
  last?: Maybe<Scalars['Int']>;
};


export type QueryRecommendedListsArgs = {
  query: RecommendedListsQuery;
  after?: Maybe<Scalars['String']>;
  first?: Maybe<Scalars['Int']>;
  before?: Maybe<Scalars['String']>;
  last?: Maybe<Scalars['Int']>;
};


export type QueryRecommendedListDefinitionArgs = {
  id: Scalars['RecommendedListDefinitionId'];
};


export type QueryRecommendedListDefinitionsArgs = {
  query?: Maybe<RecommendedListDefintionQuery>;
  after?: Maybe<Scalars['String']>;
  first?: Maybe<Scalars['Int']>;
  before?: Maybe<Scalars['String']>;
  last?: Maybe<Scalars['Int']>;
};


export type QueryTriggerArgs = {
  id: Scalars['TriggerId'];
};


export type QueryTriggersArgs = {
  input: TriggerQuery;
};


export type QueryTriggerVersionHistoryArgs = {
  historyId: Scalars['TriggerVersionHistoryId'];
};


export type QueryValidateTriggerArgs = {
  input: ValidateTriggerInput;
};


export type QueryTriggersConnectionArgs = {
  query: TriggerSearchRequestInput;
  after?: Maybe<Scalars['String']>;
  first?: Maybe<Scalars['Int']>;
  before?: Maybe<Scalars['String']>;
  last?: Maybe<Scalars['Int']>;
  sortBy?: Maybe<TriggerSearchSort>;
  sortOrder?: Maybe<SortOrder>;
};


export type QueryTriggerFacetTypeaheadArgs = {
  facetName: Scalars['String'];
  keyword: Scalars['String'];
  first?: Maybe<Scalars['Int']>;
};


export type QueryFindShortenedUrlArgs = {
  handle: Scalars['String'];
};


export type QueryEBayItemArgs = {
  itemId: Scalars['String'];
};


export type QuerySearchEBayItemsArgs = {
  query?: Maybe<EBayItemSearchQuery>;
  after?: Maybe<Scalars['String']>;
  first?: Maybe<Scalars['Int']>;
};


export type QueryMatchSellableForEBayItemArgs = {
  itemId: Scalars['String'];
};


export type QueryConfigArgs = {
  domain: Scalars['String'];
  key: Scalars['String'];
};


export type QueryConfigsArgs = {
  domain: Scalars['String'];
};


export type QueryExternalAdCampaignArgs = {
  id: Scalars['ExternalAdCampaignId'];
};


export type QueryExternalAdCampaignsByCategoryArgs = {
  categoryId: Scalars['CategoryId'];
};


export type QueryExternalAdGroupArgs = {
  id: Scalars['ExternalAdGroupId'];
};


export type QuerySystemCuratedItemSurveyArgs = {
  id: Scalars['SystemCuratedItemSurveyId'];
};


export type QueryFlightPlanArgs = {
  id: Scalars['FlightPlanId'];
};


export type QuerySupportTaskArgs = {
  id: Scalars['SupportTaskId'];
};


export type QuerySupportTasksArgs = {
  ids: Array<Scalars['SupportTaskId']>;
};


export type QueryFindSupportTasksArgs = {
  query: SupportTaskQuery;
  sortOrder?: Maybe<SortOrder>;
  after?: Maybe<Scalars['String']>;
  first?: Maybe<Scalars['Int']>;
  before?: Maybe<Scalars['String']>;
  last?: Maybe<Scalars['Int']>;
};


export type QueryFindSupportTasksForOperatorFolderArgs = {
  operatorId: Scalars['OperatorId'];
  supportTaskType: SupportTaskType;
  folderSlug: Scalars['String'];
  after?: Maybe<Scalars['String']>;
  first?: Maybe<Scalars['Int']>;
  before?: Maybe<Scalars['String']>;
  last?: Maybe<Scalars['Int']>;
};


export type QuerySupportTaskFoldersForOperatorArgs = {
  operatorId: Scalars['OperatorId'];
  supportTaskType: SupportTaskType;
};


export type QueryOrderEscalationArgs = {
  input: Scalars['OrderEscalationId'];
};


export type QueryOrderEscalationsArgs = {
  query: OrderEscalationSearchInput;
  sort?: Maybe<OrderEscalationSearchSort>;
  sortOrder?: Maybe<SortOrder>;
  after?: Maybe<Scalars['String']>;
  first?: Maybe<Scalars['Int']>;
  before?: Maybe<Scalars['String']>;
  last?: Maybe<Scalars['Int']>;
};


export type QuerySupportConversationArgs = {
  consumerId: Scalars['UserId'];
};


export type QuerySupportConversationByIdArgs = {
  id: Scalars['SupportConversationId'];
};


export type QuerySupportConversationsConnectionArgs = {
  query: SupportConversationQueryInput;
  after?: Maybe<Scalars['String']>;
  first?: Maybe<Scalars['Int']>;
  before?: Maybe<Scalars['String']>;
  last?: Maybe<Scalars['Int']>;
};


export type QuerySellableInventoryArgs = {
  id: Scalars['SellableInventoryItemId'];
};


export type QueryPayStructureArgs = {
  id: Scalars['PayStructureId'];
};


export type QueryPayStructuresPaginationArgs = {
  filters: PayStructureFilters;
  offset?: Maybe<Scalars['Int']>;
  limit?: Maybe<Scalars['Int']>;
};


export type QueryPayStructureRevisionArgs = {
  id: Scalars['PayStructureRevisionId'];
};


export type QueryPayoutsPaginationArgs = {
  filters: PayoutFilters;
  sort?: Maybe<PayoutSortInput>;
  fetchRollupSummary?: Maybe<Scalars['Boolean']>;
  offset?: Maybe<Scalars['Int']>;
  limit?: Maybe<Scalars['Int']>;
};


export type QueryPayLineItemsPaginationArgs = {
  payoutId: Scalars['PayoutId'];
  sort?: Maybe<PayLineItemSortInput>;
  offset?: Maybe<Scalars['Int']>;
  limit?: Maybe<Scalars['Int']>;
};


export type QueryPayoutArgs = {
  id: Scalars['PayoutId'];
};


export type QueryRawSellableSourceArgs = {
  id: Scalars['RawSellableSourceId'];
};


export type QueryExportRawSellableSourceArgs = {
  id: Scalars['RawSellableSourceId'];
};


export type QueryRawSellableArgs = {
  id: Scalars['RawSellableId'];
};


export type QueryStandardizedSellableArgs = {
  id: Scalars['StandardizedSellableId'];
};


export type QueryStandardizedSellableGroupArgs = {
  id: Scalars['StandardizedSellableGroupId'];
};


export type QueryRawSellableStandardizationRuleArgs = {
  id: Scalars['RawSellableStandardizationRuleId'];
};


export type QueryExportRawSellableStandardizationRuleArgs = {
  id: Scalars['RawSellableStandardizationRuleId'];
};


export type QueryFindRawSellablesArgs = {
  query: RawSellableQuery;
  offset?: Maybe<Scalars['Int']>;
  limit?: Maybe<Scalars['Int']>;
};


export type QueryFindRawSellableSourcesArgs = {
  query: RawSellableSourceQuery;
};


export type QueryFindRawSellableStandardizationRulesArgs = {
  query: RawSellableStandardizationRuleQuery;
};


export type QueryExportRawSellableStandardizationRulesArgs = {
  query: RawSellableStandardizationRuleQuery;
};


export type QueryFindStandardizedSellablesArgs = {
  query: StandardizedSellableQuery;
};


export type QueryFindStandardizedSellableGroupsArgs = {
  query: StandardizedSellableGroupQuery;
  offset?: Maybe<Scalars['Int']>;
  limit?: Maybe<Scalars['Int']>;
};


export type QueryFindStandardizedSellableGroupCandidatesArgs = {
  query: StandardizedSellableGroupCandidateQuery;
  offset?: Maybe<Scalars['Int']>;
  limit?: Maybe<Scalars['Int']>;
};


export type QueryDiscoverStandardizedSellableGroupVariationGroupsArgs = {
  id: Scalars['StandardizedSellableGroupId'];
};


export type QueryFindRawSellableBrandNamesArgs = {
  query: RawSellableSearchQuery;
};


export type QueryFindRawSellableAttributeNamesArgs = {
  query: RawSellableSearchQuery;
};


export type QueryFindRawSellableAttributeValuesArgs = {
  query: RawSellableSearchQuery;
  attributeNames: Array<Scalars['String']>;
};


export type QueryRawSellableSearchConnectionArgs = {
  query: RawSellableSearchQuery;
  after?: Maybe<Scalars['String']>;
  first?: Maybe<Scalars['Int']>;
  before?: Maybe<Scalars['String']>;
  last?: Maybe<Scalars['Int']>;
};


export type QueryFulfillmentCentersArgs = {
  query: FulfillmentCentersQuery;
  after?: Maybe<Scalars['String']>;
  first?: Maybe<Scalars['Int']>;
  before?: Maybe<Scalars['String']>;
  last?: Maybe<Scalars['Int']>;
};


export type QueryFulfillmentShipmentMethodsArgs = {
  query: FulfillmentShipmentMethodQuery;
  after?: Maybe<Scalars['String']>;
  first?: Maybe<Scalars['Int']>;
  before?: Maybe<Scalars['String']>;
  last?: Maybe<Scalars['Int']>;
};


export type QuerySchedulingTypesArgs = {
  activeOnly: Scalars['Boolean'];
};


export type QuerySchedulingDepartmentsArgs = {
  activeOnly: Scalars['Boolean'];
};


export type QuerySchedulingTypeArgs = {
  id: Scalars['SchedulingTypeId'];
};


export type QuerySchedulingUserArgs = {
  id: Scalars['AnyId'];
};


export type QuerySchedulingDemandForecastArgs = {
  id: Scalars['SchedulingDemandForecastId'];
};


export type QuerySchedulingDemandForecastDailyViewArgs = {
  input: SchedulingDemandForecastDailyViewFilter;
};


export type QuerySchedulingUserAvailabilityArgs = {
  id: Scalars['SchedulingUserAvailabilityId'];
};


export type QuerySchedulingUserAvailabilityDailyViewArgs = {
  input: SchedulingUserAvailabilityDailyViewFilter;
};


export type QueryShiftArgs = {
  id: Scalars['ShiftId'];
};


export type QueryShiftDailyViewArgs = {
  input: ShiftDailyViewFilter;
};


export type QueryShiftTeamDailyViewArgs = {
  input: ShiftTeamDailyViewFilter;
};


export type QueryShiftTimeIntervalDailyViewArgs = {
  input: ShiftTimeIntervalDailyViewFilter;
};


export type QueryShiftSlotUserDailyViewArgs = {
  input: ShiftSlotUserDailyViewFilter;
};


export type QueryShiftSlotDailyViewArgs = {
  input: ShiftSlotDailyViewFilter;
};


export type QueryFindShiftProbationsArgs = {
  input: FindShiftProbationsInput;
};


export type QueryFindShiftAbsencesArgs = {
  input: FindShiftAbsencesInput;
};


export type QueryGetFulfillmentChannelArgs = {
  channelId: Scalars['FulfillmentChannelId'];
};


export type QueryFindFulfillmentChannelsArgs = {
  query: FulfillmentChannelQueryInput;
  after?: Maybe<Scalars['String']>;
  first?: Maybe<Scalars['Int']>;
  before?: Maybe<Scalars['String']>;
  last?: Maybe<Scalars['Int']>;
};


export type QueryFulfillmentChannelsPaginationArgs = {
  query: FulfillmentChannelQueryInput;
  offset?: Maybe<Scalars['Int']>;
  limit?: Maybe<Scalars['Int']>;
};


export type QueryGetOrderRefundArgs = {
  id: Scalars['OrderRefundId'];
};


export type QueryOrderRefundsConnectionArgs = {
  input: OrderRefundQueryInput;
  after?: Maybe<Scalars['String']>;
  first?: Maybe<Scalars['Int']>;
  before?: Maybe<Scalars['String']>;
  last?: Maybe<Scalars['Int']>;
};


export type QueryOrderRefundsPaginationArgs = {
  input: OrderRefundQueryInput;
  offset?: Maybe<Scalars['Int']>;
  limit?: Maybe<Scalars['Int']>;
};


export type QueryGetShipmentPricingModelArgs = {
  shipmentPricingModelId: Scalars['ShipmentPricingModelId'];
};


export type QueryShipmentPricingModelsPaginationArgs = {
  input: ShipmentPricingModelQueryInput;
  offset?: Maybe<Scalars['Int']>;
  limit?: Maybe<Scalars['Int']>;
};


export type QueryTicketArgs = {
  input: Scalars['TicketId'];
};


export type QueryTicketsConnectionArgs = {
  input: TicketQueryInput;
  after?: Maybe<Scalars['String']>;
  first?: Maybe<Scalars['Int']>;
  before?: Maybe<Scalars['String']>;
  last?: Maybe<Scalars['Int']>;
};


export type QuerySearchTicketsArgs = {
  input: TicketSearchQueryInput;
  sort?: Maybe<TicketSearchSort>;
  after?: Maybe<Scalars['String']>;
  first?: Maybe<Scalars['Int']>;
  before?: Maybe<Scalars['String']>;
  last?: Maybe<Scalars['Int']>;
};


export type QuerySearchTicketsPaginationArgs = {
  input: TicketSearchQueryInput;
  sort?: Maybe<TicketSearchSort>;
  offset?: Maybe<Scalars['Int']>;
  limit?: Maybe<Scalars['Int']>;
};


export type QueryTicketTimelineArgs = {
  input?: Maybe<TicketTimelineRequestInput>;
};


export type QueryLookupReferralCodeArgs = {
  code: Scalars['String'];
};


export type QueryConsumerGenericReferralCodeArgs = {
  referrerIncentiveType: ReferrerIncentiveType;
};


export type QueryPotentialConsumerReferralSourcesArgs = {
  referrerIncentiveType?: Maybe<ReferrerIncentiveType>;
  expertId?: Maybe<Scalars['BusinessUserId']>;
};


export type QueryExpertDirectReferralCodeArgs = {
  expertId: Scalars['BusinessUserId'];
};


export type QueryReferralCodeShareArgs = {
  id: Scalars['ReferralCodeShareId'];
};


export type QueryExperimentsUpdatedAfterArgs = {
  updatedAfter?: Maybe<Scalars['Date']>;
  excludeBackendOnly?: Maybe<Scalars['Boolean']>;
};


export type QueryExperimentArgs = {
  id: Scalars['ExperimentId'];
};


export type QueryExperimentByNameArgs = {
  name: Scalars['String'];
};


export type QueryExperimentsArgs = {
  ids: Array<Scalars['ExperimentId']>;
};


export type QueryFindExperimentsArgs = {
  filter: ExperimentFilter;
  offset?: Maybe<Scalars['Int']>;
  limit?: Maybe<Scalars['Int']>;
  sortBy?: Maybe<ExperimentSortBy>;
};


export type QueryFindExperimentUsagesArgs = {
  id: Scalars['ExperimentId'];
};


export type QueryBookingsConnectionArgs = {
  query?: Maybe<BookingSearchQueryInput>;
  after?: Maybe<Scalars['String']>;
  first?: Maybe<Scalars['Int']>;
  before?: Maybe<Scalars['String']>;
  last?: Maybe<Scalars['Int']>;
  sortBy?: Maybe<BookingSearchSort>;
  sortDescending?: Maybe<Scalars['Boolean']>;
};


export type QueryArticleRevisionArgs = {
  id: Scalars['ArticleRevisionId'];
};


export type QueryArticleRevisionsArgs = {
  ids: Array<Scalars['ArticleRevisionId']>;
};


export type QueryFindPublishedArticleRevisionByArticleIdOrFriendlyIdArgs = {
  articleIdOrFriendlyId: Scalars['String'];
};


export type QueryFindPublishedArticleRevisionByArticleIdArgs = {
  articleId: Scalars['ArticleId'];
};


export type QueryFindPublishedArticleRevisionByArticleIdsArgs = {
  articleIds: Array<Scalars['ArticleId']>;
};


export type QueryFindDraftArticleRevisionByArticleIdArgs = {
  articleId: Scalars['ArticleId'];
};


export type QueryFindDraftArticleRevisionByArticleIdsArgs = {
  articleIds: Array<Scalars['ArticleId']>;
};


export type QueryFindArticleRevisionsByArticleIdArgs = {
  articleId: Scalars['ArticleId'];
};


export type QuerySearchArticlesArgs = {
  query: ArticleSearchRequest;
  after?: Maybe<Scalars['String']>;
  first?: Maybe<Scalars['Int']>;
  before?: Maybe<Scalars['String']>;
  last?: Maybe<Scalars['Int']>;
  sortBy?: Maybe<ArticleSort>;
  order?: Maybe<SortOrder>;
};


export type QueryRelatedArticlesArgs = {
  id?: Maybe<Scalars['ArticleRevisionId']>;
  limit?: Maybe<Scalars['Int']>;
};


export type QuerySellableTopListDefinitionArgs = {
  id: Scalars['SellableTopListDefinitionId'];
};


export type QuerySellableTopListDefinitionPaginationArgs = {
  query?: Maybe<SellableTopListDefinitionQueryInput>;
  offset?: Maybe<Scalars['Int']>;
  limit?: Maybe<Scalars['Int']>;
  sort?: Maybe<SellableTopListDefinitionSort>;
  order?: Maybe<SortOrder>;
};


export type QueryFindSellableTopListByExternalIdOrFriendlyIdArgs = {
  externalIdOrFriendlyId: Scalars['String'];
};


export type QueryFilterFieldIdValueTypeaheadArgs = {
  query: FilterFieldIdValueTypeaheadQuery;
  first?: Maybe<Scalars['Int']>;
};


export type QueryFilterFieldStringValueTypeaheadArgs = {
  query: FilterFieldStringValueTypeaheadQuery;
  first?: Maybe<Scalars['Int']>;
};


export type QueryLedgerTransactionsForAccountArgs = {
  accountId: Scalars['LedgerAccountId'];
  offset?: Maybe<Scalars['Int']>;
  limit?: Maybe<Scalars['Int']>;
};


export type QueryLedgerTransactionsForEntryArgs = {
  entryId: Scalars['LedgerEntryId'];
};


export type QueryConversationStartersArgs = {
  input: ConversationStarterQueryInput;
};


export type QueryGiftCardArgs = {
  id: Scalars['GiftCardId'];
};


export type QueryFindGiftCardForRedemptionArgs = {
  code: Scalars['String'];
};


export type QueryProductCatalogRevisionArgs = {
  id: Scalars['ProductCatalogRevisionId'];
};


export type QueryProductCatalogRevisionsArgs = {
  ids: Array<Scalars['ProductCatalogRevisionId']>;
};


export type QueryProductCatalogGroupRevisionArgs = {
  id: Scalars['ProductCatalogGroupRevisionId'];
};


export type QueryProductCatalogGroupRevisionsArgs = {
  ids: Array<Scalars['ProductCatalogGroupRevisionId']>;
};


export type QueryPublishedProductCatalogArgs = {
  id: Scalars['ProductCatalogId'];
};


export type QueryPublishedProductCatalogsArgs = {
  ids: Array<Scalars['ProductCatalogId']>;
};


export type QueryPublishedProductCatalogGroupArgs = {
  id: Scalars['ProductCatalogGroupId'];
};


export type QueryPublishedProductCatalogGroupsArgs = {
  ids: Array<Scalars['ProductCatalogGroupId']>;
};


export type QuerySearchProductCatalogsArgs = {
  query: ProductCatalogSearchRequest;
  sortBy?: Maybe<ProductCatalogSort>;
  order?: Maybe<SortOrder>;
  after?: Maybe<Scalars['String']>;
  first?: Maybe<Scalars['Int']>;
  before?: Maybe<Scalars['String']>;
  last?: Maybe<Scalars['Int']>;
};


export type QueryPartnerUserArgs = {
  id: Scalars['PartnerUserId'];
};

export type QuestionPathEditorValidationErrorTarget = PathEditorValidationErrorTarget & {
  __typename: 'QuestionPathEditorValidationErrorTarget';
  id: Scalars['String'];
  targetType: PathEditorValidationErrorTargetType;
  questionId: Scalars['PathQuestionSchemaId'];
};

export type QuestionPathNodeFlowViewModel = {
  id: Scalars['PathQuestionSchemaId'];
  schemaType: PathQuestionSchemaType;
  commonFields: CommonFieldsQuestionPathNodeFlowViewModel;
};

export type QuestionPathNodeFlowViewModelValidationError = DefaultQuestionPathNodeFlowViewModelValidationError | RequireLoginQuestionPathNodeFlowViewModelValidationError;

export type QuestionsDisplayComponentPathNodeFlowViewModel = {
  displayComponentType: PathQuestionDisplayComponentSchemaType;
};

export type QuestionsPathNodeConfig = PathNodeConfig & {
  __typename: 'QuestionsPathNodeConfig';
  configType: PathNodeConfigType;
  slug?: Maybe<Scalars['String']>;
  condition?: Maybe<PathCondition>;
  questions: Array<PathQuestionSchema>;
  questionsDisplayComponents: Array<PathQuestionsDisplayComponentSchema>;
  submitButtonText?: Maybe<PathTemplateText>;
  skipButtonText?: Maybe<PathTemplateText>;
};

export type QuestionsPathNodeConfigDisplayComponentsRemoveEditorCommandInput = {
  displayComponentTypes: Array<PathQuestionDisplayComponentSchemaType>;
};

export type QuestionsPathNodeConfigRemoveEditorCommandInput = {
  questionIds: Array<Scalars['PathQuestionSchemaId']>;
};

export type QuestionsPathNodeConfigSortEditorCommandInput = {
  questionIds: Array<Scalars['PathQuestionSchemaId']>;
};

export type QuestionsPathNodeConfigUpsertEditorCommandInput = {
  slug?: Maybe<Scalars['String']>;
  condition?: Maybe<PathConditionEditorCommandInput>;
  submitButtonText?: Maybe<Scalars['String']>;
  skipButtonText?: Maybe<Scalars['String']>;
};

export type QuestionsPathNodeFlowViewModel = PathNodeFlowViewModel & SlugAwarePathNodeFlowViewModel & {
  __typename: 'QuestionsPathNodeFlowViewModel';
  id: Scalars['PathNodeId'];
  slug?: Maybe<Scalars['String']>;
  questions: Array<QuestionPathNodeFlowViewModel>;
  questionsDisplayComponents: Array<QuestionsDisplayComponentPathNodeFlowViewModel>;
  submitButtonText?: Maybe<PathTextViewModel>;
  skipButtonText?: Maybe<PathTextViewModel>;
};

export type QuickReply = {
  __typename: 'QuickReply';
  id: Scalars['QuickReplyId'];
  name: Scalars['String'];
  text: Scalars['String'];
  expert: BusinessUser;
  lead?: Maybe<Lead>;
};


export type QuickReplyQuery = {
  expertId?: Maybe<Scalars['BusinessUserId']>;
};

export type RatingContactPageMetadata = PathFlowPageMetadata & {
  __typename: 'RatingContactPageMetadata';
  type: PathFlowPageMetadataType;
};

export type RawAttribute = {
  __typename: 'RawAttribute';
  name: Scalars['String'];
  value: Scalars['String'];
  attributeSchema?: Maybe<AttributeSchemaRevision>;
};

export type RawAttributeInput = {
  name: Scalars['String'];
  value: Scalars['String'];
  attributeSchemaId?: Maybe<Scalars['AttributeSchemaId']>;
};

export type RawSellable = {
  __typename: 'RawSellable';
  id: Scalars['RawSellableId'];
  title: Scalars['String'];
  description?: Maybe<Scalars['String']>;
  category?: Maybe<Category>;
  imageUrls: Array<Scalars['String']>;
  attributes: Array<RawSellableAttribute>;
  titleVariationDimension: Scalars['Boolean'];
  gtin?: Maybe<Scalars['String']>;
  mpn?: Maybe<Scalars['String']>;
  brand?: Maybe<Scalars['String']>;
  originalPrice?: Maybe<MonetaryAmount>;
  salePrice?: Maybe<MonetaryAmount>;
  source: RawSellableSource;
  sourceUniqueKey: Scalars['String'];
  sourceReference: Scalars['String'];
  variationGroupReference?: Maybe<Scalars['String']>;
  state: RawSellableState;
  preOrderPermitted: Scalars['Boolean'];
  estimatedAvailableAt?: Maybe<Scalars['Date']>;
  standardizationResult?: Maybe<RawSellableStandardizationResult>;
};

export type RawSellableAttribute = {
  __typename: 'RawSellableAttribute';
  name: Scalars['String'];
  value: Scalars['String'];
  variationDimension: Scalars['Boolean'];
};

export type RawSellableAttributeReference = {
  __typename: 'RawSellableAttributeReference';
  attributeName: Scalars['String'];
  referencedAttributeName: Scalars['String'];
};

export enum RawSellableAttributeValuePatternFlag {
  UNIX_LINES = 'UNIX_LINES',
  CASE_INSENSITIVE = 'CASE_INSENSITIVE',
  COMMENTS = 'COMMENTS',
  MULTILINE = 'MULTILINE',
  LITERAL = 'LITERAL',
  DOTALL = 'DOTALL',
  UNICODE_CASE = 'UNICODE_CASE',
  CANON_EQ = 'CANON_EQ',
  UNICODE_CHARACTER_CLASS = 'UNICODE_CHARACTER_CLASS'
}

export type RawSellableAttributeValues = {
  __typename: 'RawSellableAttributeValues';
  name: Scalars['String'];
  values: Array<Scalars['String']>;
};

export type RawSellableFeedSellablePriceSource = SellablePriceSource & {
  __typename: 'RawSellableFeedSellablePriceSource';
  id: Scalars['SellablePriceSourceId'];
  type: SellablePriceSourceType;
  sellable: Sellable;
  price?: Maybe<MonetaryAmount>;
  bestOfferPrice?: Maybe<MonetaryAmount>;
  cost?: Maybe<MonetaryAmount>;
  expiresAt?: Maybe<Scalars['Date']>;
  fulfillmentChannel?: Maybe<FulfillmentChannel>;
  canRefresh: Scalars['Boolean'];
  willRefresh: Scalars['Boolean'];
  url: Scalars['String'];
  name: Scalars['String'];
  rawSellableSource: RawSellableFeedSource;
  estimatedAvailableAt?: Maybe<Scalars['Date']>;
};

export type RawSellableFeedSource = RawSellableGoogleShoppingFeedSource | RawSellableLevelNineFeedSource;

export type RawSellableGoogleProductSellablePriceSource = SellablePriceSource & {
  __typename: 'RawSellableGoogleProductSellablePriceSource';
  id: Scalars['SellablePriceSourceId'];
  type: SellablePriceSourceType;
  sellable: Sellable;
  price?: Maybe<MonetaryAmount>;
  bestOfferPrice?: Maybe<MonetaryAmount>;
  cost?: Maybe<MonetaryAmount>;
  expiresAt?: Maybe<Scalars['Date']>;
  fulfillmentChannel?: Maybe<FulfillmentChannel>;
  canRefresh: Scalars['Boolean'];
  willRefresh: Scalars['Boolean'];
  googleProductId: Scalars['String'];
  name: Scalars['String'];
  rawSellableSource: RawSellableGoogleShoppingSearchSource;
  estimatedAvailableAt?: Maybe<Scalars['Date']>;
};

export type RawSellableGoogleShoppingFeedSource = RawSellableSource & {
  __typename: 'RawSellableGoogleShoppingFeedSource';
  id: Scalars['RawSellableSourceId'];
  name: Scalars['String'];
  merchantName: Scalars['String'];
  type: RawSellableSourceType;
  fulfillmentChannel?: Maybe<FulfillmentChannel>;
  filter?: Maybe<RawSellableStandardizationRuleCondition>;
  state: RawSellableSourceState;
  feedUrls: Array<Scalars['String']>;
  username?: Maybe<Scalars['String']>;
  password?: Maybe<Scalars['String']>;
  supplementalSpider?: Maybe<RawSellableSourceSpider>;
  priceRefreshInterval: Duration;
};

export type RawSellableGoogleShoppingSearchSource = RawSellableSource & {
  __typename: 'RawSellableGoogleShoppingSearchSource';
  id: Scalars['RawSellableSourceId'];
  name: Scalars['String'];
  merchantName: Scalars['String'];
  type: RawSellableSourceType;
  fulfillmentChannel?: Maybe<FulfillmentChannel>;
  filter?: Maybe<RawSellableStandardizationRuleCondition>;
  state: RawSellableSourceState;
  merchantId: Scalars['String'];
  categoryIds: Array<Scalars['String']>;
  priceRefreshInterval: Duration;
};


export type RawSellableImpactSellablePriceSource = SellablePriceSource & {
  __typename: 'RawSellableImpactSellablePriceSource';
  id: Scalars['SellablePriceSourceId'];
  type: SellablePriceSourceType;
  sellable: Sellable;
  price?: Maybe<MonetaryAmount>;
  bestOfferPrice?: Maybe<MonetaryAmount>;
  cost?: Maybe<MonetaryAmount>;
  expiresAt?: Maybe<Scalars['Date']>;
  fulfillmentChannel?: Maybe<FulfillmentChannel>;
  canRefresh: Scalars['Boolean'];
  willRefresh: Scalars['Boolean'];
  itemId: Scalars['String'];
  catalogId: Scalars['String'];
  url: Scalars['String'];
  name: Scalars['String'];
  rawSellableSource: RawSellableImpactSource;
  estimatedAvailableAt?: Maybe<Scalars['Date']>;
};

export type RawSellableImpactSource = RawSellableSource & {
  __typename: 'RawSellableImpactSource';
  id: Scalars['RawSellableSourceId'];
  name: Scalars['String'];
  merchantName: Scalars['String'];
  type: RawSellableSourceType;
  fulfillmentChannel?: Maybe<FulfillmentChannel>;
  filter?: Maybe<RawSellableStandardizationRuleCondition>;
  state: RawSellableSourceState;
  accountSid: Scalars['String'];
  authToken: Scalars['String'];
  catalogIds: Array<Scalars['String']>;
  query?: Maybe<Scalars['String']>;
  priceRefreshInterval: Duration;
};

export type RawSellableLevelNineFeedSource = RawSellableSource & {
  __typename: 'RawSellableLevelNineFeedSource';
  id: Scalars['RawSellableSourceId'];
  name: Scalars['String'];
  merchantName: Scalars['String'];
  type: RawSellableSourceType;
  fulfillmentChannel?: Maybe<FulfillmentChannel>;
  filter?: Maybe<RawSellableStandardizationRuleCondition>;
  state: RawSellableSourceState;
  feedUrl: Scalars['String'];
  priceRefreshInterval: Duration;
};

export type RawSellableQuery = {
  sourceIds?: Maybe<Array<Scalars['RawSellableSourceId']>>;
  sourceReferences?: Maybe<Array<RawSellableSourceReferenceInput>>;
  sourceKeys?: Maybe<Array<RawSellableSourceLookupKeyInput>>;
  states?: Maybe<Array<RawSellableState>>;
};

export type RawSellableScraperSellablePriceSource = SellablePriceSource & {
  __typename: 'RawSellableScraperSellablePriceSource';
  id: Scalars['SellablePriceSourceId'];
  type: SellablePriceSourceType;
  sellable: Sellable;
  price?: Maybe<MonetaryAmount>;
  bestOfferPrice?: Maybe<MonetaryAmount>;
  cost?: Maybe<MonetaryAmount>;
  expiresAt?: Maybe<Scalars['Date']>;
  fulfillmentChannel?: Maybe<FulfillmentChannel>;
  canRefresh: Scalars['Boolean'];
  willRefresh: Scalars['Boolean'];
  url: Scalars['String'];
  name: Scalars['String'];
  rawSellableSource: RawSellableScraperSource;
  estimatedAvailableAt?: Maybe<Scalars['Date']>;
};

export type RawSellableScraperSource = RawSellableSource & {
  __typename: 'RawSellableScraperSource';
  id: Scalars['RawSellableSourceId'];
  name: Scalars['String'];
  merchantName: Scalars['String'];
  type: RawSellableSourceType;
  fulfillmentChannel?: Maybe<FulfillmentChannel>;
  filter?: Maybe<RawSellableStandardizationRuleCondition>;
  state: RawSellableSourceState;
  spider: RawSellableSourceSpider;
  priceRefreshInterval: Duration;
};

export type RawSellableSearchConnection = {
  __typename: 'RawSellableSearchConnection';
  facets: Array<DisplayFacet>;
  edges: Array<RawSellableSearchEdge>;
  pageInfo: PageInfo;
  count: Scalars['Int'];
};

export type RawSellableSearchEdge = {
  __typename: 'RawSellableSearchEdge';
  node: RawSellable;
  cursor: Scalars['String'];
};

export type RawSellableSearchQuery = {
  sourceIds?: Maybe<Array<Scalars['RawSellableSourceId']>>;
  sourceReferences?: Maybe<Array<RawSellableSourceReferenceInput>>;
  sourceKeys?: Maybe<Array<RawSellableSourceLookupKeyInput>>;
  sourceTypes?: Maybe<Array<RawSellableSourceType>>;
  title?: Maybe<Scalars['String']>;
  facets?: Maybe<Array<FacetSelection>>;
};

export type RawSellableShopifySellablePriceSource = SellablePriceSource & {
  __typename: 'RawSellableShopifySellablePriceSource';
  id: Scalars['SellablePriceSourceId'];
  type: SellablePriceSourceType;
  sellable: Sellable;
  price?: Maybe<MonetaryAmount>;
  bestOfferPrice?: Maybe<MonetaryAmount>;
  cost?: Maybe<MonetaryAmount>;
  expiresAt?: Maybe<Scalars['Date']>;
  fulfillmentChannel?: Maybe<FulfillmentChannel>;
  canRefresh: Scalars['Boolean'];
  willRefresh: Scalars['Boolean'];
  productId: Scalars['String'];
  productVariantId: Scalars['String'];
  name: Scalars['String'];
  rawSellableSource: RawSellableShopifySource;
  estimatedAvailableAt?: Maybe<Scalars['Date']>;
};

export type RawSellableShopifySource = RawSellableSource & {
  __typename: 'RawSellableShopifySource';
  id: Scalars['RawSellableSourceId'];
  name: Scalars['String'];
  merchantName: Scalars['String'];
  type: RawSellableSourceType;
  fulfillmentChannel?: Maybe<FulfillmentChannel>;
  filter?: Maybe<RawSellableStandardizationRuleCondition>;
  state: RawSellableSourceState;
  shopName: Scalars['String'];
  apiKey: Scalars['String'];
  collectionId?: Maybe<Scalars['String']>;
  priceRefreshInterval: Duration;
};

export type RawSellableSource = {
  id: Scalars['RawSellableSourceId'];
  name: Scalars['String'];
  merchantName: Scalars['String'];
  type: RawSellableSourceType;
  state: RawSellableSourceState;
  fulfillmentChannel?: Maybe<FulfillmentChannel>;
  filter?: Maybe<RawSellableStandardizationRuleCondition>;
};

export type RawSellableSourceGoogleShoppingFeedInput = {
  feedUrls: Array<Scalars['String']>;
  username?: Maybe<Scalars['String']>;
  password?: Maybe<Scalars['String']>;
  supplementalSpider?: Maybe<RawSellableSourceSpiderInput>;
  priceRefreshInterval: DurationInput;
};

export type RawSellableSourceGoogleShoppingSearchInput = {
  merchantId: Scalars['String'];
  categoryIds: Array<Scalars['String']>;
  priceRefreshInterval: DurationInput;
};


export type RawSellableSourceImpactInput = {
  accountSid: Scalars['String'];
  authToken: Scalars['String'];
  catalogIds: Array<Scalars['String']>;
  priceRefreshInterval: DurationInput;
};

export type RawSellableSourceLevelNineFeedInput = {
  feedUrl: Scalars['String'];
  priceRefreshInterval: DurationInput;
};

export type RawSellableSourceLookupKeyInput = {
  sourceId: Scalars['RawSellableSourceId'];
  uniqueKey: Scalars['String'];
};

export type RawSellableSourceQuery = {
  states?: Maybe<Array<RawSellableSourceState>>;
  types?: Maybe<Array<RawSellableSourceType>>;
};

export type RawSellableSourceReferenceInput = {
  sourceId: Scalars['RawSellableSourceId'];
  reference: Scalars['String'];
};

export type RawSellableSourceScraperInput = {
  priceRefreshInterval: DurationInput;
  spider: RawSellableSourceSpiderInput;
};

export type RawSellableSourceScrapinghubSpider = RawSellableSourceSpider & {
  __typename: 'RawSellableSourceScrapinghubSpider';
  spider: Scalars['String'];
  priceSpider: Scalars['String'];
  projectId: Scalars['String'];
  arguments: Array<RawSellableSourceScrapinghubSpiderArgument>;
  type: ScrapingJobType;
};

export type RawSellableSourceScrapinghubSpiderArgument = {
  __typename: 'RawSellableSourceScrapinghubSpiderArgument';
  key: Scalars['String'];
  value: Scalars['String'];
};

export type RawSellableSourceScrapinghubSpiderArgumentInput = {
  key: Scalars['String'];
  value: Scalars['String'];
};

export type RawSellableSourceScrapinghubSpiderInput = {
  spider: Scalars['String'];
  priceSpider: Scalars['String'];
  projectId: Scalars['String'];
  arguments: Array<RawSellableSourceScrapinghubSpiderArgumentInput>;
};

export type RawSellableSourceShopifyInput = {
  shopName: Scalars['String'];
  apiKey: Scalars['String'];
  collectionId?: Maybe<Scalars['String']>;
  priceRefreshInterval: DurationInput;
};

export type RawSellableSourceSpider = {
  type: ScrapingJobType;
};

export type RawSellableSourceSpiderInput = {
  scrapinghubSpider: RawSellableSourceScrapinghubSpiderInput;
};

export enum RawSellableSourceState {
  ACTIVE = 'ACTIVE',
  INACTIVE = 'INACTIVE'
}

export enum RawSellableSourceType {
  SCRAPER = 'SCRAPER',
  DEAL_INVENTORY = 'DEAL_INVENTORY',
  GOOGLE_SHOPPING_FEED = 'GOOGLE_SHOPPING_FEED',
  GOOGLE_SHOPPING_SEARCH = 'GOOGLE_SHOPPING_SEARCH',
  LEVEL9_FEED = 'LEVEL9_FEED',
  SHOPIFY = 'SHOPIFY',
  WALMART = 'WALMART',
  IMPACT = 'IMPACT'
}

export type RawSellableSourceWalmartInput = {
  categoryIds: Array<Scalars['String']>;
  priceRefreshInterval: DurationInput;
};

export type RawSellableStandardization = {
  __typename: 'RawSellableStandardization';
  id: Scalars['RawSellableId'];
  rawSellable: RawSellable;
  variationGroupTitle?: Maybe<Scalars['String']>;
  attributeReferences: Array<RawSellableAttributeReference>;
  hideFromConsumerSearch: Scalars['Boolean'];
  forceOutOfStock: Scalars['Boolean'];
  errors: Array<Scalars['String']>;
  appliedRules: Array<RawSellableStandardizationRule>;
  hasErrors: Scalars['Boolean'];
};

export type RawSellableStandardizationAction = {
  type: RawSellableStandardizationActionType;
};

export type RawSellableStandardizationActionInput = {
  type: RawSellableStandardizationActionType;
  copyAttributeValue?: Maybe<RawSellableStandardizationCopyAttributeValueActionInput>;
  removeAttribute?: Maybe<RawSellableStandardizationRemoveAttributeActionInput>;
  renameAttribute?: Maybe<RawSellableStandardizationRenameAttributeActionInput>;
  replaceAttributeValue?: Maybe<RawSellableStandardizationReplaceAttributeValueActionInput>;
  setAttributeValue?: Maybe<RawSellableStandardizationSetAttributeValueActionInput>;
  setCategory?: Maybe<RawSellableStandardizationSetCategoryActionInput>;
  setTitle?: Maybe<RawSellableStandardizationSetTitleActionInput>;
  setVariationGroupTitle?: Maybe<RawSellableStandardizationSetVariationGroupTitleActionInput>;
  setVariationGroupReference?: Maybe<RawSellableStandardizationSetVariationGroupReferenceActionInput>;
  setBrand?: Maybe<RawSellableStandardizationSetBrandActionInput>;
  setMpn?: Maybe<RawSellableStandardizationSetMpnActionInput>;
  setAttributeVariationDimension?: Maybe<RawSellableStandardizationSetAttributeVariationDimensionActionInput>;
  setDescription?: Maybe<RawSellableStandardizationSetDescriptionActionInput>;
};

export enum RawSellableStandardizationActionType {
  SET_CATEGORY = 'SET_CATEGORY',
  SET_ATTRIBUTE_VALUE = 'SET_ATTRIBUTE_VALUE',
  COPY_ATTRIBUTE_VALUE = 'COPY_ATTRIBUTE_VALUE',
  REMOVE_ATTRIBUTE = 'REMOVE_ATTRIBUTE',
  REPLACE_ATTRIBUTE_VALUE = 'REPLACE_ATTRIBUTE_VALUE',
  MARK_OUT_OF_STOCK = 'MARK_OUT_OF_STOCK',
  DEACTIVATE = 'DEACTIVATE',
  HIDE_FROM_CONSUMER_SEARCH = 'HIDE_FROM_CONSUMER_SEARCH',
  SET_TITLE = 'SET_TITLE',
  SET_VARIATION_GROUP_TITLE = 'SET_VARIATION_GROUP_TITLE',
  SET_VARIATION_GROUP_REFERENCE = 'SET_VARIATION_GROUP_REFERENCE',
  SET_BRAND = 'SET_BRAND',
  SET_MPN = 'SET_MPN',
  SET_ATTRIBUTE_VARIATION_DIMENSION = 'SET_ATTRIBUTE_VARIATION_DIMENSION',
  SET_DESCRIPTION = 'SET_DESCRIPTION',
  RENAME_ATTRIBUTE = 'RENAME_ATTRIBUTE',
  MARK_NONE_VARIANT = 'MARK_NONE_VARIANT'
}

export type RawSellableStandardizationAttributeValueFieldMeta = RawSellableStandardizationFieldMeta & {
  __typename: 'RawSellableStandardizationAttributeValueFieldMeta';
  name: Scalars['String'];
  displayName: Scalars['String'];
  attributeName: Scalars['String'];
  type: RawSellableStandardizationRuleFieldType;
  idType?: Maybe<Scalars['String']>;
  supportedOperators: Array<RawSellableStandardizationRuleFieldOperator>;
};

export type RawSellableStandardizationAttributeVariationDimensionFieldMeta = RawSellableStandardizationFieldMeta & {
  __typename: 'RawSellableStandardizationAttributeVariationDimensionFieldMeta';
  name: Scalars['String'];
  displayName: Scalars['String'];
  attributeName: Scalars['String'];
  type: RawSellableStandardizationRuleFieldType;
  idType?: Maybe<Scalars['String']>;
  supportedOperators: Array<RawSellableStandardizationRuleFieldOperator>;
};

export type RawSellableStandardizationCopyAttributeValueAction = RawSellableStandardizationAction & {
  __typename: 'RawSellableStandardizationCopyAttributeValueAction';
  type: RawSellableStandardizationActionType;
  sourceAttributeName: Scalars['String'];
  targetAttributeName: Scalars['String'];
  reference: Scalars['Boolean'];
};

export type RawSellableStandardizationCopyAttributeValueActionInput = {
  sourceAttributeName: Scalars['String'];
  targetAttributeName: Scalars['String'];
  reference: Scalars['Boolean'];
};

export type RawSellableStandardizationDeactivateAction = RawSellableStandardizationAction & {
  __typename: 'RawSellableStandardizationDeactivateAction';
  type: RawSellableStandardizationActionType;
};

export type RawSellableStandardizationFieldMeta = {
  name: Scalars['String'];
  displayName: Scalars['String'];
  type: RawSellableStandardizationRuleFieldType;
  idType?: Maybe<Scalars['String']>;
  supportedOperators: Array<RawSellableStandardizationRuleFieldOperator>;
};

export type RawSellableStandardizationHideFromConsumerSearchAction = RawSellableStandardizationAction & {
  __typename: 'RawSellableStandardizationHideFromConsumerSearchAction';
  type: RawSellableStandardizationActionType;
};

export type RawSellableStandardizationMarkNoneVariantAction = RawSellableStandardizationAction & {
  __typename: 'RawSellableStandardizationMarkNoneVariantAction';
  type: RawSellableStandardizationActionType;
};

export type RawSellableStandardizationMarkOutOfStockAction = RawSellableStandardizationAction & {
  __typename: 'RawSellableStandardizationMarkOutOfStockAction';
  type: RawSellableStandardizationActionType;
};

export type RawSellableStandardizationMeta = {
  __typename: 'RawSellableStandardizationMeta';
  name: Scalars['String'];
  displayName: Scalars['String'];
  fields: Array<RawSellableStandardizationFieldMeta>;
  attributeValueField?: Maybe<RawSellableStandardizationFieldMeta>;
  attributeVariationDimensionField?: Maybe<RawSellableStandardizationFieldMeta>;
};


export type RawSellableStandardizationMetaFieldsArgs = {
  names?: Maybe<Array<Scalars['String']>>;
};


export type RawSellableStandardizationMetaAttributeValueFieldArgs = {
  attributeName: Scalars['String'];
};


export type RawSellableStandardizationMetaAttributeVariationDimensionFieldArgs = {
  attributeName: Scalars['String'];
};

export type RawSellableStandardizationPredefinedFieldMeta = RawSellableStandardizationFieldMeta & {
  __typename: 'RawSellableStandardizationPredefinedFieldMeta';
  name: Scalars['String'];
  displayName: Scalars['String'];
  type: RawSellableStandardizationRuleFieldType;
  idType?: Maybe<Scalars['String']>;
  supportedOperators: Array<RawSellableStandardizationRuleFieldOperator>;
};

export type RawSellableStandardizationRemoveAttributeAction = RawSellableStandardizationAction & {
  __typename: 'RawSellableStandardizationRemoveAttributeAction';
  type: RawSellableStandardizationActionType;
  attributeName: Scalars['String'];
};

export type RawSellableStandardizationRemoveAttributeActionInput = {
  attributeName: Scalars['String'];
};

export type RawSellableStandardizationRenameAttributeAction = RawSellableStandardizationAction & {
  __typename: 'RawSellableStandardizationRenameAttributeAction';
  type: RawSellableStandardizationActionType;
  sourceAttributeName: Scalars['String'];
  targetAttributeName: Scalars['String'];
};

export type RawSellableStandardizationRenameAttributeActionInput = {
  sourceAttributeName: Scalars['String'];
  targetAttributeName: Scalars['String'];
};

export type RawSellableStandardizationReplaceAttributeValueAction = RawSellableStandardizationAction & {
  __typename: 'RawSellableStandardizationReplaceAttributeValueAction';
  type: RawSellableStandardizationActionType;
  attributeName: Scalars['String'];
  attributeValuePattern: Scalars['String'];
  attributeValuePatternFlags: Array<RawSellableAttributeValuePatternFlag>;
  attributeValueReplacement: Scalars['String'];
};

export type RawSellableStandardizationReplaceAttributeValueActionInput = {
  attributeName: Scalars['String'];
  attributeValuePattern: Scalars['String'];
  attributeValuePatternFlags: Array<RawSellableAttributeValuePatternFlag>;
  attributeValueReplacement: Scalars['String'];
};

export type RawSellableStandardizationResult = {
  __typename: 'RawSellableStandardizationResult';
  id: Scalars['RawSellableId'];
  state: RawSellableStandardizationResultState;
  deactivated: Scalars['Boolean'];
  errors: Array<Scalars['String']>;
  standardizedSellable?: Maybe<StandardizedSellable>;
  catalog?: Maybe<ProductCatalogRevision>;
};

export enum RawSellableStandardizationResultState {
  PENDING = 'PENDING',
  COMPLETED = 'COMPLETED'
}

export type RawSellableStandardizationRule = {
  __typename: 'RawSellableStandardizationRule';
  id: Scalars['RawSellableStandardizationRuleId'];
  name: Scalars['String'];
  source?: Maybe<RawSellableSource>;
  priority: Scalars['Int'];
  condition: RawSellableStandardizationRuleCondition;
  actions: Array<RawSellableStandardizationAction>;
  state: RawSellableStandardizationRuleState;
  meta: RawSellableStandardizationMeta;
};

export type RawSellableStandardizationRuleBinaryCondition = RawSellableStandardizationRuleCondition & {
  __typename: 'RawSellableStandardizationRuleBinaryCondition';
  type: RawSellableStandardizationRuleConditionType;
  leftOperand: RawSellableStandardizationRuleParameter;
  rightOperand: RawSellableStandardizationRuleParameter;
  binaryOperator: RawSellableStandardizationRuleFieldOperator;
};

export type RawSellableStandardizationRuleBinaryConditionInput = {
  leftOperand: RawSellableStandardizationRuleParameterInput;
  rightOperand: RawSellableStandardizationRuleParameterInput;
  binaryOperator: Scalars['String'];
};

export type RawSellableStandardizationRuleCondition = {
  type: RawSellableStandardizationRuleConditionType;
};

export type RawSellableStandardizationRuleConditionInput = {
  binaryCondition?: Maybe<RawSellableStandardizationRuleBinaryConditionInput>;
  logicalCondition?: Maybe<RawSellableStandardizationRuleLogicalConditionInput>;
  constantCondition?: Maybe<RawSellableStandardizationRuleConstantConditionInput>;
};

export enum RawSellableStandardizationRuleConditionType {
  LOGICAL = 'LOGICAL',
  BINARY = 'BINARY',
  CONSTANT = 'CONSTANT'
}

export type RawSellableStandardizationRuleConstantCondition = RawSellableStandardizationRuleCondition & {
  __typename: 'RawSellableStandardizationRuleConstantCondition';
  type: RawSellableStandardizationRuleConditionType;
  result: Scalars['Boolean'];
};

export type RawSellableStandardizationRuleConstantConditionInput = {
  result: Scalars['Boolean'];
};

export type RawSellableStandardizationRuleEntityFieldReference = RawSellableStandardizationRuleParameter & {
  __typename: 'RawSellableStandardizationRuleEntityFieldReference';
  type: RawSellableStandardizationRuleParameterType;
  field: Scalars['String'];
};

export type RawSellableStandardizationRuleFieldOperator = {
  __typename: 'RawSellableStandardizationRuleFieldOperator';
  name: Scalars['String'];
  displayName: Scalars['String'];
  leftOperandType: RawSellableStandardizationRuleFieldType;
  rightOperandType: RawSellableStandardizationRuleFieldType;
};

export enum RawSellableStandardizationRuleFieldType {
  BOOLEAN = 'BOOLEAN',
  STRING = 'STRING',
  STRING_LIST = 'STRING_LIST',
  ID = 'ID',
  ID_LIST = 'ID_LIST',
  INTEGER = 'INTEGER',
  DECIMAL = 'DECIMAL'
}


export type RawSellableStandardizationRuleLiteralBooleanValue = RawSellableStandardizationRuleParameter & {
  __typename: 'RawSellableStandardizationRuleLiteralBooleanValue';
  type: RawSellableStandardizationRuleParameterType;
  booleanValue: Scalars['Boolean'];
};

export type RawSellableStandardizationRuleLiteralDecimalValue = RawSellableStandardizationRuleParameter & {
  __typename: 'RawSellableStandardizationRuleLiteralDecimalValue';
  type: RawSellableStandardizationRuleParameterType;
  decimalValue: Scalars['BigDecimal'];
};

export type RawSellableStandardizationRuleLiteralIdListValue = RawSellableStandardizationRuleParameter & {
  __typename: 'RawSellableStandardizationRuleLiteralIdListValue';
  type: RawSellableStandardizationRuleParameterType;
  idListValue: Array<Scalars['AnyId']>;
};

export type RawSellableStandardizationRuleLiteralIdValue = RawSellableStandardizationRuleParameter & {
  __typename: 'RawSellableStandardizationRuleLiteralIdValue';
  type: RawSellableStandardizationRuleParameterType;
  idValue: Scalars['AnyId'];
};

export type RawSellableStandardizationRuleLiteralIntegerValue = RawSellableStandardizationRuleParameter & {
  __typename: 'RawSellableStandardizationRuleLiteralIntegerValue';
  type: RawSellableStandardizationRuleParameterType;
  integerValue: Scalars['Int'];
};

export type RawSellableStandardizationRuleLiteralStringListValue = RawSellableStandardizationRuleParameter & {
  __typename: 'RawSellableStandardizationRuleLiteralStringListValue';
  type: RawSellableStandardizationRuleParameterType;
  stringListValue: Array<Scalars['String']>;
};

export type RawSellableStandardizationRuleLiteralStringValue = RawSellableStandardizationRuleParameter & {
  __typename: 'RawSellableStandardizationRuleLiteralStringValue';
  type: RawSellableStandardizationRuleParameterType;
  stringValue: Scalars['String'];
};

export type RawSellableStandardizationRuleLogicalCondition = RawSellableStandardizationRuleCondition & {
  __typename: 'RawSellableStandardizationRuleLogicalCondition';
  type: RawSellableStandardizationRuleConditionType;
  conditions: Array<RawSellableStandardizationRuleCondition>;
  logicalOperator: LogicalOperator;
};

export type RawSellableStandardizationRuleLogicalConditionInput = {
  logicalOperator: LogicalOperator;
  conditions: Array<RawSellableStandardizationRuleConditionInput>;
};

export type RawSellableStandardizationRuleParameter = {
  type: RawSellableStandardizationRuleParameterType;
};

export type RawSellableStandardizationRuleParameterInput = {
  fieldName?: Maybe<Scalars['String']>;
  stringValue?: Maybe<Scalars['String']>;
  stringListValue?: Maybe<Array<Scalars['String']>>;
  booleanValue?: Maybe<Scalars['Boolean']>;
  idValue?: Maybe<Scalars['AnyId']>;
  idListValue?: Maybe<Array<Scalars['AnyId']>>;
  integerValue?: Maybe<Scalars['Int']>;
  decimalValue?: Maybe<Scalars['BigDecimal']>;
};

export enum RawSellableStandardizationRuleParameterType {
  ENTITY_FIELD = 'ENTITY_FIELD',
  LITERAL_VALUE = 'LITERAL_VALUE'
}

export type RawSellableStandardizationRuleQuery = {
  states?: Maybe<Array<RawSellableStandardizationRuleState>>;
  sourceIds?: Maybe<Array<Scalars['RawSellableSourceId']>>;
  modifiedSince?: Maybe<Scalars['Date']>;
};

export enum RawSellableStandardizationRuleState {
  ACTIVE = 'ACTIVE',
  INACTIVE = 'INACTIVE'
}

export type RawSellableStandardizationSetAttributeValueAction = RawSellableStandardizationAction & {
  __typename: 'RawSellableStandardizationSetAttributeValueAction';
  type: RawSellableStandardizationActionType;
  attributeName: Scalars['String'];
  attributeValueTemplate: Scalars['String'];
};

export type RawSellableStandardizationSetAttributeValueActionInput = {
  attributeName: Scalars['String'];
  attributeValueTemplate: Scalars['String'];
};

export type RawSellableStandardizationSetAttributeVariationDimensionAction = RawSellableStandardizationAction & {
  __typename: 'RawSellableStandardizationSetAttributeVariationDimensionAction';
  type: RawSellableStandardizationActionType;
  attributeName: Scalars['String'];
  variationDimension: Scalars['Boolean'];
};

export type RawSellableStandardizationSetAttributeVariationDimensionActionInput = {
  attributeName: Scalars['String'];
  variationDimension: Scalars['Boolean'];
};

export type RawSellableStandardizationSetBrandAction = RawSellableStandardizationAction & {
  __typename: 'RawSellableStandardizationSetBrandAction';
  type: RawSellableStandardizationActionType;
  valueTemplate: Scalars['String'];
};

export type RawSellableStandardizationSetBrandActionInput = {
  valueTemplate: Scalars['String'];
};

export type RawSellableStandardizationSetCategoryAction = RawSellableStandardizationAction & {
  __typename: 'RawSellableStandardizationSetCategoryAction';
  type: RawSellableStandardizationActionType;
  category: Category;
};

export type RawSellableStandardizationSetCategoryActionInput = {
  categoryId: Scalars['CategoryId'];
};

export type RawSellableStandardizationSetDescriptionAction = RawSellableStandardizationAction & {
  __typename: 'RawSellableStandardizationSetDescriptionAction';
  type: RawSellableStandardizationActionType;
  valueTemplate: Scalars['String'];
};

export type RawSellableStandardizationSetDescriptionActionInput = {
  valueTemplate: Scalars['String'];
};

export type RawSellableStandardizationSetMpnAction = RawSellableStandardizationAction & {
  __typename: 'RawSellableStandardizationSetMpnAction';
  type: RawSellableStandardizationActionType;
  valueTemplate: Scalars['String'];
};

export type RawSellableStandardizationSetMpnActionInput = {
  valueTemplate: Scalars['String'];
};

export type RawSellableStandardizationSetTitleAction = RawSellableStandardizationAction & {
  __typename: 'RawSellableStandardizationSetTitleAction';
  type: RawSellableStandardizationActionType;
  valueTemplate: Scalars['String'];
};

export type RawSellableStandardizationSetTitleActionInput = {
  valueTemplate: Scalars['String'];
};

export type RawSellableStandardizationSetVariationGroupReferenceAction = RawSellableStandardizationAction & {
  __typename: 'RawSellableStandardizationSetVariationGroupReferenceAction';
  type: RawSellableStandardizationActionType;
  valueTemplate: Scalars['String'];
};

export type RawSellableStandardizationSetVariationGroupReferenceActionInput = {
  valueTemplate: Scalars['String'];
};

export type RawSellableStandardizationSetVariationGroupTitleAction = RawSellableStandardizationAction & {
  __typename: 'RawSellableStandardizationSetVariationGroupTitleAction';
  type: RawSellableStandardizationActionType;
  valueTemplate: Scalars['String'];
};

export type RawSellableStandardizationSetVariationGroupTitleActionInput = {
  valueTemplate: Scalars['String'];
};

export enum RawSellableState {
  ACTIVE = 'ACTIVE',
  INACTIVE = 'INACTIVE'
}

export type RawSellableVariationGroupInput = {
  sourceId: Scalars['RawSellableSourceId'];
  variationGroupReference: Scalars['String'];
};

export type RawSellableWalmartSellablePriceSource = SellablePriceSource & {
  __typename: 'RawSellableWalmartSellablePriceSource';
  id: Scalars['SellablePriceSourceId'];
  type: SellablePriceSourceType;
  sellable: Sellable;
  price?: Maybe<MonetaryAmount>;
  bestOfferPrice?: Maybe<MonetaryAmount>;
  cost?: Maybe<MonetaryAmount>;
  expiresAt?: Maybe<Scalars['Date']>;
  fulfillmentChannel?: Maybe<FulfillmentChannel>;
  canRefresh: Scalars['Boolean'];
  willRefresh: Scalars['Boolean'];
  itemId: Scalars['String'];
  url: Scalars['String'];
  name: Scalars['String'];
  rawSellableSource: RawSellableWalmartSource;
  estimatedAvailableAt?: Maybe<Scalars['Date']>;
};

export type RawSellableWalmartSource = RawSellableSource & {
  __typename: 'RawSellableWalmartSource';
  id: Scalars['RawSellableSourceId'];
  name: Scalars['String'];
  merchantName: Scalars['String'];
  type: RawSellableSourceType;
  fulfillmentChannel?: Maybe<FulfillmentChannel>;
  filter?: Maybe<RawSellableStandardizationRuleCondition>;
  state: RawSellableSourceState;
  categoryIds: Array<Scalars['String']>;
  priceRefreshInterval: Duration;
};

export type ReassignLeadInput = {
  leadId: Scalars['LeadId'];
  reassignedToExpertId: Scalars['BusinessUserId'];
  reason: LeadReassignmentReason;
  note?: Maybe<Scalars['String']>;
};

export type ReassignLeadSupportTaskActivity = SupportTaskActivity & {
  __typename: 'ReassignLeadSupportTaskActivity';
  id: Scalars['SupportTaskActivityId'];
  supportTask: SupportTask;
  action: SupportTaskAction;
  actor: SupportTaskActor;
  consumer: User;
  lead?: Maybe<Lead>;
  occurredAt: Scalars['Date'];
  reassignedTo: BusinessUser;
};

export type RecentExpertCuratedItemFromSimilarUserSystemCuratedItemSource = SystemCuratedItemSource & {
  __typename: 'RecentExpertCuratedItemFromSimilarUserSystemCuratedItemSource';
  type?: Maybe<SystemCuratedItemType>;
  expertCuratedItem: ExpertCuratedItem;
  dealRequest: DealRequest;
};

export type RecentExpertCuratedItemGroupConnection = {
  __typename: 'RecentExpertCuratedItemGroupConnection';
  edges: Array<RecentExpertCuratedItemGroupEdge>;
  pageInfo: PageInfo;
  facets: Array<DisplayFacet>;
  count: Scalars['Int'];
};

export type RecentExpertCuratedItemGroupEdge = {
  __typename: 'RecentExpertCuratedItemGroupEdge';
  node: ExpertCuratedItemGroup;
  cursor: Scalars['String'];
};

export type RecentExpertCuratedItemGroupSearchFilter = {
  facets?: Maybe<Array<FacetSelection>>;
};

export type RecommendedExpert = {
  __typename: 'RecommendedExpert';
  expert: BusinessUser;
  existingLead?: Maybe<Lead>;
};

/**
 * A RecommendedList corresponds to a list of Sellables that are grouped together based on a combination of
 * Attributes and properties from a Sellable that match the Users intent.
 * For example, Carbon fiber Bike under $2000
 */
export type RecommendedList = {
  __typename: 'RecommendedList';
  /**
   * The RecommendedListDefinition used to build this RecommendedList
   * All recommendation lists should have a corresponding RecommendedListDefinition but this may be filtered based
   * on requesters Permission levels.
   */
  recommendedListDefinition?: Maybe<RecommendedListDefinition>;
  /**
   * the display name is dynamically generated using the matched Attributes of Sellables in the list and the users intent
   * If this is RecommendedList is built using a corresponding RecommendedListDefinition then this is the resolved title
   */
  displayName: Scalars['String'];
  subTitle?: Maybe<Scalars['String']>;
  /**
   * A list of Sellables belonging to this RecommendedList
   * @deprecated Use paginatedSellables
   */
  sellables: Array<Sellable>;
  sellableConnection: RecommendedListSellableConnection;
  /** The top level RecommendedListType for this RecommendedList */
  type?: Maybe<RecommendedListType>;
};


/**
 * A RecommendedList corresponds to a list of Sellables that are grouped together based on a combination of
 * Attributes and properties from a Sellable that match the Users intent.
 * For example, Carbon fiber Bike under $2000
 */
export type RecommendedListSellableConnectionArgs = {
  after?: Maybe<Scalars['String']>;
  first?: Maybe<Scalars['Int']>;
  before?: Maybe<Scalars['String']>;
  last?: Maybe<Scalars['Int']>;
};

/**
 * The RecommendedLists are a list of Sellable items categorized into different RecommendedList, each with its corresponding
 * RecommendedListDefinition.
 * 
 * The RecommendedList is identified from the users intent for a Category specified in the request. Each individual
 * list edge is generated dynamically using a combination of attributes in the user's request in a path.
 * There is a default ordering for the edges returned in the response, listed as follows:
 * 1. Top recommendation based on a combination of user attributes
 * 2. Top level category Attribute Function type + Price combination. For ex: Road bikes under $2000.
 * 3. Top level category Function type + Brand combination. For ex: Specialized bikes
 * 4. The next section will contain lists of itmes belonging to Sub-categories or Accessories. For ex: Bike Helmets, Bike Shoes
 * 5. Any custom RecommendedListDefinition based Recommended List.
 * 
 * The above default order can be changed by updating the rank property of the corresponding RecommendedListDefinition.
 * 
 * Note, that based on the user's intent we may have 0 or more lists of a specific type. For example, if the user didn't
 * specify the brand preference, then we will skip the recommended list for brand type.
 * Also, note that a Sellable may belong to one or more RecommendedList's based on the list generation Criteria.
 * 
 * The total items in each RecommendedList are restricted to 10 items if present and minimum of 3
 */
export type RecommendedListConnection = {
  __typename: 'RecommendedListConnection';
  edges: Array<RecommendedListEdge>;
  pageInfo: PageInfo;
};

export type RecommendedListDefinition = {
  __typename: 'RecommendedListDefinition';
  id: Scalars['RecommendedListDefinitionId'];
  /** User friendly name for this recommended list definition */
  name?: Maybe<Scalars['String']>;
  /**
   * The title template that will be used to build the RecommendedList title shown to the consumer.
   * The template should use the freemarker style `${variable}` format for inserting any dynamic values in the resolved title.
   * For example: "Because you like ${attribute.brands}"
   * Note, the querable attributes from the title will be used as a hard filter in the RecommenedList result.
   * For example, if the title said "Because you like
   * ${attribute.brands.displayName}", then the result will only include
   * recommendations
   * that strictly match the brands
   */
  titleTemplate: Scalars['String'];
  /**
   * The subtitle template that will be used to build the RecommendedList's subtitle shown to the consumer
   * The template should use the freemarker style `${variable}` format for
   * inserting any dynamic values in the resolved subtitle.
   * This is mainly used to provide some additional context the recommended list
   * and for display purpose only with the resolved string.
   */
  subTitleTemplate?: Maybe<Scalars['String']>;
  active: Scalars['Boolean'];
  /**
   * The category for which this RecommendedListDefinition is being built.
   * @deprecated use Categories
   */
  categoryIds: Array<Scalars['CategoryId']>;
  /** The categories for which this RecommendedListDefinition is being built. */
  categories: Array<Category>;
  /**
   * The relative rank of the RecommendedList built using this definition compared to other RecommendedList
   * when the user sees a list of RecommendedList
   */
  rank: Scalars['Int'];
  recommendedListType: RecommendedListType;
  /** The filtering facets to refine recommended list results */
  queryFacets?: Maybe<Array<RecommendedListDisplayFacet>>;
  /** defaults to relevance based sorting */
  sortOptions?: Maybe<Array<RecommendedListSortOrder>>;
  /** The system auto generated RecommendedLists can't be edited, only their ranking can be changed. */
  queryFiltersAndSortingEditable: Scalars['Boolean'];
  /** A expectedReference User whose request Attributes to use for building the preview results */
  previewResults: DecoratedRecommendedListConnection;
};


export type RecommendedListDefinitionPreviewResultsArgs = {
  asViewedByUser: Scalars['UserId'];
  forParentCategoryId: Scalars['CategoryId'];
  maxFacetTerms?: Maybe<Scalars['Int']>;
  after?: Maybe<Scalars['String']>;
  first?: Maybe<Scalars['Int']>;
  before?: Maybe<Scalars['String']>;
  last?: Maybe<Scalars['Int']>;
  topNSellablesPerRecommendedList?: Maybe<Scalars['Int']>;
};

export type RecommendedListDefinitionConnection = {
  __typename: 'RecommendedListDefinitionConnection';
  edges: Array<RecommendedListDefinitionEdge>;
  pageInfo: PageInfo;
};

export type RecommendedListDefinitionEdge = {
  __typename: 'RecommendedListDefinitionEdge';
  node: RecommendedListDefinition;
  cursor: Scalars['String'];
};


export type RecommendedListDefintionQuery = {
  categoryIds?: Maybe<Array<Scalars['CategoryId']>>;
  recurseToChildCategories?: Maybe<Scalars['Boolean']>;
};

export type RecommendedListDisplayFacet = {
  __typename: 'RecommendedListDisplayFacet';
  facet?: Maybe<DisplayFacet>;
  useUserPreference: Scalars['Boolean'];
};

export type RecommendedListEdge = {
  __typename: 'RecommendedListEdge';
  node: RecommendedList;
  cursor: Scalars['String'];
};

export type RecommendedListFacetSelectionInput = {
  facetSelection: FacetSelection;
  useUserPreference: Scalars['Boolean'];
};

export type RecommendedListSellableConnection = {
  __typename: 'RecommendedListSellableConnection';
  edges: Array<RecommendedListSellableEdge>;
  pageInfo: PageInfo;
};

export type RecommendedListSellableEdge = {
  __typename: 'RecommendedListSellableEdge';
  cursor: Scalars['String'];
  node: Sellable;
};

export type RecommendedListSortOrder = {
  __typename: 'RecommendedListSortOrder';
  sellableSortBy: SellableSort;
  order: SortOrder;
};

export type RecommendedListSortOrderInput = {
  sellableSortBy: SellableSort;
  order: SortOrder;
};

export type RecommendedListsQuery = {
  /** Fetch recommended list for a specific category only */
  categorySlug?: Maybe<Scalars['String']>;
  /** Recommendations include sellables from all categories within the department */
  departmentSlug?: Maybe<Scalars['String']>;
  /**
   * Recommendation types to be used for building the RecommendedList. This includes some pre defined types and a custom
   * type. Use RecommendedListType.CUSTOM to get all RecommendedList built using definitions in the Recommendation list builder
   * To filter further to specific RecommendedListDefinition specify the RecommendedListDefinitionId
   */
  types?: Maybe<Array<RecommendedListType>>;
  /** To restrict recommended list to a specific RecommendedListDefinition only. This overrides types specified above. */
  recommendedListDefinitionId?: Maybe<Scalars['RecommendedListDefinitionId']>;
  /** The max number of sellables to fetch per recommend list */
  topNSellablesPerRecommendedList?: Maybe<Scalars['Int']>;
};

export enum RecommendedListType {
  /**
   * Recommendation list built using  a combination of multiple user Attributes learnt from
   * the Path Deal request. More specifically, it uses Gender, Price, Brand, Primary Attributes and other secondary
   * attributes to build this request.
   * The list built only if brand and primary attributes are present in the users request
   * Accessories are explicitly excluded
   */
  MY_TOP_LIST = 'MY_TOP_LIST',
  /** This is similar to TOP LIST but enforces a strict matching of user request attributes. */
  STRICT_MY_TOP_LIST = 'STRICT_MY_TOP_LIST',
  /**
   * Recommendation list built using price and primary attributes from users path request attributes
   * Each primary attribute has a separate list
   * The list built only if primary attributes are present in the users request
   * Accessories are explicitly excluded
   */
  PRICE_AND_PRIMARY_ATTRIBUTES = 'PRICE_AND_PRIMARY_ATTRIBUTES',
  /**
   * Recommendation list built using brands and primary attributes from users path request attributes
   * Each brand has a separate list
   * The list built only if brand attributes are present in the users request
   * Accessories are explicitly excluded
   */
  BRAND_AND_PRIMARY_ATTRIBUTES = 'BRAND_AND_PRIMARY_ATTRIBUTES',
  /**
   * Recommendation list built using accessories selected by the user in the path request
   * Each Accessory has a separate list
   */
  ACCESSORIES = 'ACCESSORIES',
  /** Recommended list built using curated lists that were recommended to similar users */
  CURATED_LIST_TO_SIMILAR_USERS = 'CURATED_LIST_TO_SIMILAR_USERS',
  /**
   * This recommendation list is used to build a digest of recommendations based on user intent from the deal request
   * The relevancy favors most recent sellables and also favors sellables with price within users budget
   * that has changed recently.
   */
  PRICE_SENSITIVE_INTENT_BASED_DIGEST = 'PRICE_SENSITIVE_INTENT_BASED_DIGEST',
  /** the recommended list built from a custom list defined by the operator or expert */
  CUSTOM = 'CUSTOM'
}

export type RecommendExpertPayload = {
  __typename: 'RecommendExpertPayload';
  expert?: Maybe<BusinessUser>;
  existingLead?: Maybe<Lead>;
};

export type RecomputeNewExpertLeadGateInput = {
  expertId: Scalars['BusinessUserId'];
};

export type RecursiveUsageApprovableEntityDependencyResolutionError = ErrorMessage & {
  __typename: 'RecursiveUsageApprovableEntityDependencyResolutionError';
  errorMessage: Scalars['String'];
  recursionChain: Array<ApprovalRequestEntity>;
};

export type RedeemGiftCardInput = {
  code: Scalars['String'];
};

export type RedeemGiftCardPayload = {
  __typename: 'RedeemGiftCardPayload';
  giftCard?: Maybe<GiftCard>;
  error?: Maybe<Scalars['String']>;
  existingLeadWithCurator?: Maybe<Lead>;
};

export type RedirectPathNodeConfig = PathNodeConfig & {
  __typename: 'RedirectPathNodeConfig';
  configType: PathNodeConfigType;
  redirectType: RedirectPathNodeConfigType;
};

export enum RedirectPathNodeConfigType {
  RETURN_TO_PREVIOUS_CONTEXT = 'RETURN_TO_PREVIOUS_CONTEXT',
  /** EXPERT_PROFILE, */
  INBOX = 'INBOX',
  APPLY_FINISH = 'APPLY_FINISH'
}

export type RedirectPathNodeFlowViewModel = PathNodeFlowViewModel & {
  __typename: 'RedirectPathNodeFlowViewModel';
  id: Scalars['PathNodeId'];
  redirectResult: RedirectPathNodeFlowViewModelResult;
};

export type RedirectPathNodeFlowViewModelResult = ApplyFinishRedirectPathNodeFlowViewModelSuccess | InboxRedirectPathNodeFlowViewModelSuccess | ReturnToPreviousContextRedirectPathNodeFlowViewModelSuccess;

export type ReenterPathFlowPageBySlugsInput = {
  pathFlowSlug: Scalars['String'];
  pathFlowPageSlug: Scalars['String'];
};

export type ReenterPathFlowPageInput = {
  pathFlowId: Scalars['PathFlowId'];
  pathFlowPageSlug: Scalars['String'];
};

export type ReenterPathFlowPagePayload = {
  __typename: 'ReenterPathFlowPagePayload';
  flow?: Maybe<PathFlow>;
  errors?: Maybe<Array<PathValidationError>>;
};

export type ReferralCode = {
  __typename: 'ReferralCode';
  id: Scalars['ReferralCodeId'];
  code: Scalars['String'];
  source: ReferralSource;
  shortenedUrl: Scalars['String'];
  urlWithoutTracking: Scalars['String'];
};


export type ReferralCodeShortenedUrlArgs = {
  medium: ReferralMedium;
  sourceKey: Scalars['String'];
};


export type ReferralCodeShare = {
  __typename: 'ReferralCodeShare';
  id: Scalars['ReferralCodeShareId'];
  referralCode: ReferralCode;
  note?: Maybe<Scalars['String']>;
  contact: Scalars['String'];
  contactType: ContactType;
  shareCount: Scalars['Int'];
  lastSharedAt: Scalars['Date'];
};


export type ReferralCodeShareInput = {
  referralCodeId: Scalars['ReferralCodeId'];
  emails: Array<Scalars['String']>;
  note?: Maybe<Scalars['String']>;
};

export type ReferralCodeSharePayload = {
  __typename: 'ReferralCodeSharePayload';
  shareCount: Scalars['Int'];
  errors: Array<Scalars['String']>;
};

export enum ReferralMedium {
  EMAIL = 'EMAIL',
  FACEBOOK = 'FACEBOOK',
  LINK = 'LINK'
}

export type ReferralSource = {
  type: ReferralType;
};

export type ReferralSourceConsumerGeneric = ReferralSource & {
  __typename: 'ReferralSourceConsumerGeneric';
  type: ReferralType;
  user: User;
  expertsToRefer: Array<BusinessUser>;
  referrerIncentiveType: ReferrerIncentiveType;
};

export type ReferralSourceConsumerToExpert = ReferralSource & {
  __typename: 'ReferralSourceConsumerToExpert';
  type: ReferralType;
  user: User;
  referredToExpert: BusinessUser;
};

export type ReferralSourceExpertDirect = ReferralSource & {
  __typename: 'ReferralSourceExpertDirect';
  type: ReferralType;
  referredByExpert: BusinessUser;
};

export enum ReferralType {
  CONSUMER_GENERIC = 'CONSUMER_GENERIC',
  CONSUMER_TO_EXPERT = 'CONSUMER_TO_EXPERT',
  EXPERT_DIRECT = 'EXPERT_DIRECT'
}

export enum ReferrerIncentiveType {
  CREDIT_FOR_SOCIAL_SHARE = 'CREDIT_FOR_SOCIAL_SHARE',
  PERCENT_OFF_ON_FIRST_REFEREE_ORDER = 'PERCENT_OFF_ON_FIRST_REFEREE_ORDER'
}

export type RefreshAccessTokenInput = {
  refreshToken?: Maybe<Scalars['String']>;
};

export type RefreshAccessTokenPayload = EncodedAuthenticationTokensPayload & {
  __typename: 'RefreshAccessTokenPayload';
  result: AuthenticationResult;
  message?: Maybe<Scalars['String']>;
  encodedAuthenticationTokens?: Maybe<EncodedAuthenticationTokens>;
};

export type RefreshSellablePriceSourceInput = {
  id: Scalars['SellablePriceSourceId'];
};

export type RefreshSellablePriceSourcePayload = {
  __typename: 'RefreshSellablePriceSourcePayload';
  sellablePriceSource: SellablePriceSource;
  hasError: Scalars['Boolean'];
  errorMessage?: Maybe<Scalars['String']>;
};

export type RefundAmountAdjustedActivity = OrderActivityDetail & {
  __typename: 'RefundAmountAdjustedActivity';
  type: OrderActivityDetailType;
  previousAmount: MonetaryAmount;
  newAmount: MonetaryAmount;
  orderRefund: OrderRefund;
  adjustedBy: Operator;
};

export type RefundRequestedActivity = OrderActivityDetail & {
  __typename: 'RefundRequestedActivity';
  type: OrderActivityDetailType;
  requestedByOperator?: Maybe<Operator>;
  orderRefund: OrderRefund;
  requestedAmount: MonetaryAmount;
};

export type RefundStatusUpdateActivity = OrderActivityDetail & {
  __typename: 'RefundStatusUpdateActivity';
  type: OrderActivityDetailType;
  previousState: Scalars['String'];
  newState: Scalars['String'];
  orderRefund: OrderRefund;
  updatedByOperator?: Maybe<Operator>;
};

export type RegexAttributeValidatorReference = AttributeValidatorReference & {
  __typename: 'RegexAttributeValidatorReference';
  id: Scalars['AttributeValidatorReferenceId'];
  type: AttributeValidatorType;
  regex: Scalars['String'];
  errorMessage: Scalars['String'];
};

export type RegexAttributeValidatorReferenceInput = {
  regex: Scalars['String'];
  errorMessage: Scalars['String'];
};

export enum RegisterCustomerErrorCode {
  ALREADY_REGISTERED = 'ALREADY_REGISTERED',
  INVALID_PHONE_NUMBER = 'INVALID_PHONE_NUMBER',
  INVALID_EMAIL_ADDRESS = 'INVALID_EMAIL_ADDRESS',
  INVALID_SMS_SIGN_IN = 'INVALID_SMS_SIGN_IN',
  FAILED_OAUTH = 'FAILED_OAUTH'
}

export type RegisterCustomerInput = {
  firstName?: Maybe<Scalars['String']>;
  lastName?: Maybe<Scalars['String']>;
  phone?: Maybe<Scalars['String']>;
  email?: Maybe<Scalars['String']>;
  password?: Maybe<Scalars['String']>;
  externalOAuthType?: Maybe<OAuthType>;
  externalOAuthToken?: Maybe<Scalars['String']>;
  referralCodeId?: Maybe<Scalars['ReferralCodeId']>;
  registrationId?: Maybe<Scalars['UserRegistrationId']>;
};

export type RegisterCustomerPayload = {
  __typename: 'RegisterCustomerPayload';
  user?: Maybe<User>;
  errors?: Maybe<Array<Scalars['String']>>;
  errorCodes: Array<RegisterCustomerErrorCode>;
  encodedAuthenticationTokens?: Maybe<EncodedAuthenticationTokens>;
  claimPromotionResult?: Maybe<ClaimPromotionPayload>;
};

export type RegisterFirebaseCloudMessagingTokenInput = {
  messagingUserId: Scalars['AnyId'];
  fcmToken: Scalars['String'];
  deviceUniqueId?: Maybe<Scalars['String']>;
  applicationId?: Maybe<Scalars['String']>;
};

export type RegisterFirebaseCloudMessagingTokenPayload = {
  __typename: 'RegisterFirebaseCloudMessagingTokenPayload';
  registered?: Maybe<Scalars['Boolean']>;
};

export type RegisterWebPushSubscriptionInput = {
  messagingUserId: Scalars['AnyId'];
  subscription: Scalars['String'];
};

export type RegisterWebPushSubscriptionPayload = {
  __typename: 'RegisterWebPushSubscriptionPayload';
  registered: Scalars['Boolean'];
};

export type RejectApprovalRequestActivityEntryDetail = ApprovalRequestActivityEntryDetail & {
  __typename: 'RejectApprovalRequestActivityEntryDetail';
  entryType: ApprovalRequestActivityEntryType;
};

export type RejectApprovalRequestError = DefaultErrorMessage;

export type RejectApprovalRequestInput = {
  approvalRequestId: Scalars['ApprovalRequestId'];
  /** If provided, will create a comment entry before the reject entry */
  comment?: Maybe<Scalars['String']>;
};

export type RejectApprovalRequestPayload = {
  __typename: 'RejectApprovalRequestPayload';
  approvalRequest?: Maybe<ApprovalRequest>;
  error?: Maybe<RejectApprovalRequestError>;
};

export type RejectExpertApplicationInput = {
  applicationId: Scalars['ExpertApplicationId'];
  reason: Scalars['String'];
};

export type RejectExpertApplicationPayload = {
  __typename: 'RejectExpertApplicationPayload';
  application: ExpertApplication;
};

export type RejectExpertCuratedItemNoteInput = {
  id: Scalars['ExpertCuratedItemNoteId'];
  changesRequestedNote?: Maybe<Scalars['String']>;
  changedById: Scalars['OperatorId'];
};

export type RejectExpertCuratedItemNotePayload = {
  __typename: 'RejectExpertCuratedItemNotePayload';
  expertCuratedItemNote?: Maybe<ExpertCuratedItemNote>;
  hasError: Scalars['Boolean'];
  errorMessage?: Maybe<Scalars['String']>;
};

export type RejectSellableQuestionCandidateInput = {
  sellableIds: Array<Scalars['SellableId']>;
  messageId: Scalars['String'];
  conversationId: Scalars['ConversationId'];
};

export type RejectSellableQuestionCandidatePayload = {
  __typename: 'RejectSellableQuestionCandidatePayload';
  candidates: Array<SellableQuestionCandidate>;
  errorMessage?: Maybe<Scalars['String']>;
};

export type RejectStandardizedSellableGroupCandidateInput = {
  id: Scalars['StandardizedSellableGroupCandidateId'];
};

export type RejectStandardizedSellableGroupCandidatePayload = {
  __typename: 'RejectStandardizedSellableGroupCandidatePayload';
  candidate: StandardizedSellableGroupCandidate;
};

/** All relative date calculation is in timezone 'America/Los_Angeles' */
export type RelativeDate = {
  __typename: 'RelativeDate';
  /** When the amount is negative, it means the amount before the relativeTo date. Otherwise, it means after. */
  amount: Scalars['Long'];
  unit: RelativeDateUnit;
  truncateTo?: Maybe<RelativeDateUnit>;
  /** Calculate the absolute date of this relative date relative to the given date. If not given, relative to now. */
  date: Scalars['Date'];
};


/** All relative date calculation is in timezone 'America/Los_Angeles' */
export type RelativeDateDateArgs = {
  relativeTo?: Maybe<Scalars['Date']>;
};

export type RelativeDateInput = {
  amount: Scalars['Long'];
  unit: RelativeDateUnit;
  truncateTo?: Maybe<RelativeDateUnit>;
};

export type RelativeDateRange = {
  __typename: 'RelativeDateRange';
  from?: Maybe<RelativeDate>;
  to?: Maybe<RelativeDate>;
  /** Calculate the absolute date range of this relative date range relative to the given date. If not given, relative to now. */
  dateRange: DateRange;
};


export type RelativeDateRangeDateRangeArgs = {
  relativeTo?: Maybe<Scalars['Date']>;
};

export type RelativeDateRangeInput = {
  from?: Maybe<RelativeDateInput>;
  to?: Maybe<RelativeDateInput>;
};

export enum RelativeDateUnit {
  NANOS = 'NANOS',
  MILLIS = 'MILLIS',
  SECONDS = 'SECONDS',
  MINUTES = 'MINUTES',
  HOURS = 'HOURS',
  DAYS = 'DAYS',
  MONTHS = 'MONTHS',
  YEARS = 'YEARS'
}

export type ReleaseBusinessUserIdentityPayload = EncodedAuthenticationTokensPayload & {
  __typename: 'ReleaseBusinessUserIdentityPayload';
  myself?: Maybe<Myself>;
  encodedAuthenticationTokens?: Maybe<EncodedAuthenticationTokens>;
};

export type ReleaseConsumerIdentityPayload = EncodedAuthenticationTokensPayload & {
  __typename: 'ReleaseConsumerIdentityPayload';
  user?: Maybe<User>;
  myself?: Maybe<Myself>;
  encodedAuthenticationTokens?: Maybe<EncodedAuthenticationTokens>;
};

export type ReleaseOperatorIdentityPayload = EncodedAuthenticationTokensPayload & {
  __typename: 'ReleaseOperatorIdentityPayload';
  operator?: Maybe<Operator>;
  encodedAuthenticationTokens?: Maybe<EncodedAuthenticationTokens>;
};

export type ReleasePartnerUserIdentityPayload = EncodedAuthenticationTokensPayload & {
  __typename: 'ReleasePartnerUserIdentityPayload';
  myself?: Maybe<Myself>;
  encodedAuthenticationTokens?: Maybe<EncodedAuthenticationTokens>;
};

export type RemoveActionFromPromotionInput = {
  id: Scalars['PromotionId'];
  referenceId: Scalars['PromotionActionReferenceId'];
};

export type RemoveActionFromPromotionPayload = {
  __typename: 'RemoveActionFromPromotionPayload';
  promotion: Promotion;
};

export type RemoveArticleRevisionAttributeInput = {
  id: Scalars['ArticleRevisionId'];
  attributeName: Scalars['String'];
};

export type RemoveArticleRevisionContentBlockInput = {
  id: Scalars['ArticleRevisionId'];
  contentBlockId: Scalars['ArticleContentBlockId'];
};

export type RemoveArticleRevisionTagInput = {
  id: Scalars['ArticleRevisionId'];
  tag: Scalars['String'];
};

export type RemoveCampaignAudienceIntegrationInput = {
  campaignAudienceId: Scalars['CampaignAudienceId'];
  integrationId: Scalars['CampaignAudienceIntegrationId'];
};

export type RemoveCampaignAudienceIntegrationPayload = {
  __typename: 'RemoveCampaignAudienceIntegrationPayload';
  campaignAudience: CampaignAudience;
  hasError: Scalars['Boolean'];
  errorMessage?: Maybe<Scalars['String']>;
};

export type RemoveChannelTemplateInput = {
  templateId: Scalars['CommTemplateId'];
  channelType: ChannelType;
};

export type RemoveCuratedItemFromSavedCurationInput = {
  id: Scalars['SavedExpertCuratedItemsId'];
  sellableId: Scalars['SellableId'];
};

export type RemoveCuratedItemFromSavedCurationPayload = {
  __typename: 'RemoveCuratedItemFromSavedCurationPayload';
  savedExpertCuratedItems?: Maybe<SavedExpertCuratedItems>;
  error?: Maybe<Scalars['String']>;
  hasError: Scalars['Boolean'];
};

export type RemoveDraftEnumEntriesFromAttributeSchemaRevisionInput = {
  id: Scalars['AttributeSchemaRevisionId'];
  enumEntryNames: Array<Scalars['String']>;
};

export type RemoveDraftEnumEntriesFromAttributeSchemaRevisionPayload = AttributeSchemaRevisionPayload & {
  __typename: 'RemoveDraftEnumEntriesFromAttributeSchemaRevisionPayload';
  hasError: Scalars['Boolean'];
  errorMessage?: Maybe<Scalars['String']>;
  attributeSchemaRevision?: Maybe<AttributeSchemaRevision>;
};

export type RemoveEscalationLabelInput = {
  escalationId: Scalars['OrderEscalationId'];
  escalationLabel: OrderEscalationLabel;
};

export type RemoveExpertCuratedItemInput = {
  id: Scalars['ExpertCuratedItemId'];
  reason: ExpertCuratedItemRemovedReason;
  otherReason?: Maybe<Scalars['String']>;
  /** Defaults to false; only experts can set this to true. Note that if a draft is being removed, it gets hard deleted. */
  shouldCopyUpdateIntoNewDraft?: Maybe<Scalars['Boolean']>;
};

export type RemoveExpertCuratedItemPayload = {
  __typename: 'RemoveExpertCuratedItemPayload';
  /**
   * The entity that as ultimately modified; may be a new/existing draft that's staged to replace the targeted curated
   * item
   */
  updated?: Maybe<ExpertCuratedItem>;
  /**
   * The entity that was targeted for update being staged to be removed once `updated` is activated (converted to non
   * draft status)
   */
  superseded?: Maybe<ExpertCuratedItem>;
  errorType?: Maybe<ExpertCuratedItemWriteErrorType>;
  expertCuratedItemsForLead?: Maybe<ExpertCuratedItemsForLeadPayload>;
  expertCuratedItemsByCategories: ExpertCuratedItemsByCategories;
};


export type RemoveExpertCuratedItemPayloadExpertCuratedItemsForLeadArgs = {
  onlyFetchIfError: Scalars['Boolean'];
};

export type RemoveExpertSpecialCareTagInput = {
  expertId: Scalars['BusinessUserId'];
  careType: Scalars['String'];
};

export type RemoveItemsFromExpertCuratedOrderInput = {
  id: Scalars['ExpertCuratedOrderId'];
  sellableIds: Array<Scalars['SellableId']>;
};

export type RemoveItemsFromExpertCuratedOrderPayload = {
  __typename: 'RemoveItemsFromExpertCuratedOrderPayload';
  expertCuratedOrder: ExpertCuratedOrder;
};

export type RemoveItemsFromOrderInput = {
  /** If omitted, user context will be assumed and the user's current cart will be operated on */
  id?: Maybe<Scalars['OrderId']>;
  lineItemIds: Array<Scalars['OrderLineItemId']>;
};

export type RemoveItemsFromOrderPayload = {
  __typename: 'RemoveItemsFromOrderPayload';
  order: Order;
};

export type RemoveLeadRpalExclusionOverrideInput = {
  leadId: Scalars['LeadId'];
};

export type RemoveLeadSpecialCareTagInput = {
  leadId: Scalars['LeadId'];
  careType: Scalars['String'];
};

export type RemoveLegsFromFlightPlanInput = {
  id: Scalars['FlightPlanId'];
  legIdsToRemove: Array<Scalars['FlightPlanLegId']>;
};

export type RemoveLegsFromFlightPlanPayload = {
  __typename: 'RemoveLegsFromFlightPlanPayload';
  flightPlan: FlightPlan;
  errorCode?: Maybe<FlightPlanEditErrorCode>;
  hasError: Scalars['Boolean'];
  errorMessage?: Maybe<Scalars['String']>;
};

export type RemoveMetadataFromAttributeSchemaRevisionInput = {
  id: Scalars['AttributeSchemaRevisionId'];
  metadatasToRemove: Array<AttributeSchemaMetadataType>;
};

export type RemoveMetadataFromAttributeSchemaRevisionPayload = AttributeSchemaRevisionPayload & {
  __typename: 'RemoveMetadataFromAttributeSchemaRevisionPayload';
  hasError: Scalars['Boolean'];
  errorMessage?: Maybe<Scalars['String']>;
  attributeSchemaRevision?: Maybe<AttributeSchemaRevision>;
};

export type RemoveOrderReturnShipmentTrackingInput = {
  orderRefundId: Scalars['OrderRefundId'];
};

export type RemoveProductCatalogAttributeInput = {
  revisionId: Scalars['ProductCatalogRevisionId'];
  requestedById: Scalars['AnyId'];
  attributeSchemaId: Scalars['AttributeSchemaId'];
};

export type RemoveProductCatalogAttributePayload = {
  __typename: 'RemoveProductCatalogAttributePayload';
  revision: ProductCatalogRevision;
  error?: Maybe<ProductCatalogRemoveAttributeError>;
};

export type RemoveProductCatalogGroupAttributeInput = {
  revisionId: Scalars['ProductCatalogGroupRevisionId'];
  requestedById: Scalars['AnyId'];
  attributeSchemaId: Scalars['AttributeSchemaId'];
};

export type RemoveProductCatalogGroupAttributePayload = {
  __typename: 'RemoveProductCatalogGroupAttributePayload';
  revision: ProductCatalogGroupRevision;
  error?: Maybe<ProductCatalogGroupRemoveAttributeError>;
};

export type RemoveProfileHighlightInput = {
  expertProfileId: Scalars['ExpertProfileId'];
  typeId: Scalars['ProfileHighlightTypeId'];
};

export type RemoveRuleFromPromotionInput = {
  id: Scalars['PromotionId'];
  referenceId: Scalars['PromotionRuleReferenceId'];
};

export type RemoveRuleFromPromotionPayload = {
  __typename: 'RemoveRuleFromPromotionPayload';
  promotion: Promotion;
};

export type RemoveScheduleReportInput = {
  reportId: Scalars['ReportId'];
};

export type RemoveSchedulingDemandForecastPayload = {
  __typename: 'RemoveSchedulingDemandForecastPayload';
  /** If true, the item was successfully deleted. If false, it means there there was no item to delete. */
  deleted: Scalars['Boolean'];
};

export type RemoveSchedulingUserAvailabilityPayload = {
  __typename: 'RemoveSchedulingUserAvailabilityPayload';
  /** If true, the item was successfully deleted. If false, it means there there was no item to delete. */
  deleted: Scalars['Boolean'];
};

export type RemoveSellableAttributeInput = {
  ids: Array<Scalars['SellableId']>;
  attributeSchemaId: Scalars['AttributeSchemaId'];
  allVariants?: Maybe<Scalars['Boolean']>;
};

export type RemoveSellableRawAttributeInput = {
  ids: Array<Scalars['SellableId']>;
  attributeName: Scalars['String'];
  allVariants?: Maybe<Scalars['Boolean']>;
};

export type RemoveShipmentTrackingInput = {
  orderId: Scalars['OrderId'];
  orderLineItemId: Scalars['OrderLineItemId'];
};

export type RemoveStoreCreditFromOrderInput = {
  id: Scalars['OrderId'];
};

export type RemoveStoreCreditFromOrderPayload = {
  __typename: 'RemoveStoreCreditFromOrderPayload';
  order: Order;
  error?: Maybe<Scalars['String']>;
};

export type RemoveSupportFromLeadConversationInput = {
  leadId: Scalars['LeadId'];
};

export type RemoveSupportFromLeadConversationPayload = {
  __typename: 'RemoveSupportFromLeadConversationPayload';
  success: Scalars['Boolean'];
  lead?: Maybe<Lead>;
};

export type RemoveTagInput = {
  id: Scalars['TagId'];
};

export type RemoveTagPayload = {
  __typename: 'RemoveTagPayload';
  success?: Maybe<Scalars['Boolean']>;
  errors?: Maybe<Array<Scalars['String']>>;
};

export type RemoveTicketNeedsAttentionInput = {
  leadId: Scalars['LeadId'];
  ticketId: Scalars['TicketId'];
};

export type RemoveTipFromOrderInput = {
  id: Scalars['OrderId'];
};

export type RemoveTipFromOrderPayload = {
  __typename: 'RemoveTipFromOrderPayload';
  order: Order;
};

export type RemoveTriggerEdgeInput = {
  triggerId: Scalars['TriggerId'];
  nodeId: Scalars['TriggerNodeId'];
  edgeType: TriggerNodeEdgeType;
};

export type RemoveTriggerNodeInput = {
  triggerId: Scalars['TriggerId'];
  nodeId: Scalars['TriggerNodeId'];
  edgeTypeToKeep: TriggerNodeEdgeType;
};

export type RemoveValidatorFromAttributeSchemaRevisionInput = {
  id: Scalars['AttributeSchemaRevisionId'];
  referenceIds: Array<Scalars['AttributeValidatorReferenceId']>;
};

export type RemoveValidatorFromAttributeSchemaRevisionPayload = AttributeSchemaRevisionPayload & {
  __typename: 'RemoveValidatorFromAttributeSchemaRevisionPayload';
  hasError: Scalars['Boolean'];
  errorMessage?: Maybe<Scalars['String']>;
  attributeSchemaRevision?: Maybe<AttributeSchemaRevision>;
};

export type RenderCommTemplateInput = {
  templateId: Scalars['CommTemplateId'];
  variables: Array<RenderCommTemplateVariableInput>;
};

export type RenderCommTemplatePayload = {
  __typename: 'RenderCommTemplatePayload';
  contents?: Maybe<Array<RenderedChannelContent>>;
  errors?: Maybe<Array<Scalars['String']>>;
};

export type RenderCommTemplateVariableInput = {
  name: Scalars['String'];
  idValue?: Maybe<Scalars['String']>;
  stringValue?: Maybe<Scalars['String']>;
  idListValue?: Maybe<Array<Scalars['String']>>;
};

export type RenderedChannelContent = {
  channelType: ChannelType;
};

export type RenderedContent = MediaRenderedContent | TextRenderedContent;

export type RenderedEmailContent = RenderedChannelContent & {
  __typename: 'RenderedEmailContent';
  channelType: ChannelType;
  subject: Scalars['String'];
  htmlBody: Scalars['String'];
  textBody: Scalars['String'];
  medias: Array<MediaFile>;
};

export type RenderedFacebookContent = RenderedChannelContent & {
  __typename: 'RenderedFacebookContent';
  channelType: ChannelType;
  content: Scalars['String'];
  medias: Array<MediaFile>;
};

export type RenderedInAppContent = RenderedChannelContent & {
  __typename: 'RenderedInAppContent';
  channelType: ChannelType;
  /** @deprecated Use contents */
  content: Scalars['String'];
  contents: Array<RenderedContent>;
};

export type RenderedPushNotificationContent = RenderedChannelContent & {
  __typename: 'RenderedPushNotificationContent';
  channelType: ChannelType;
  title: Scalars['String'];
  body: Scalars['String'];
  threadId?: Maybe<Scalars['String']>;
  medias: Array<MediaFile>;
};

export type RenderedSlackContent = RenderedChannelContent & {
  __typename: 'RenderedSlackContent';
  channelType: ChannelType;
  content: Scalars['String'];
};

export type RenderedSmsContent = RenderedChannelContent & {
  __typename: 'RenderedSmsContent';
  channelType: ChannelType;
  content: Scalars['String'];
  medias: Array<MediaFile>;
};

export type ReopenTicketInput = {
  ticketId: Scalars['TicketId'];
  reason: ReopenTicketReason;
};

export enum ReopenTicketReason {
  NOT_RESOLVED = 'NOT_RESOLVED',
  EXPERT_COMMENT = 'EXPERT_COMMENT'
}

export type ReorderActionsInPromotionInput = {
  id: Scalars['PromotionId'];
  newReferenceIdOrder: Array<Scalars['PromotionActionReferenceId']>;
};

export type ReorderActionsInPromotionPayload = {
  __typename: 'ReorderActionsInPromotionPayload';
  promotion: Promotion;
};

export type ReorderEnumEntriesInAttributeSchemaRevisionInput = {
  id: Scalars['AttributeSchemaRevisionId'];
  enumEntryNames: Array<Scalars['String']>;
};

export type ReorderEnumEntriesInAttributeSchemaRevisionPayload = AttributeSchemaRevisionPayload & {
  __typename: 'ReorderEnumEntriesInAttributeSchemaRevisionPayload';
  hasError: Scalars['Boolean'];
  errorMessage?: Maybe<Scalars['String']>;
  attributeSchemaRevision?: Maybe<AttributeSchemaRevision>;
};

export type ReorderProductCatalogGroupRawAttributesInput = {
  revisionId: Scalars['ProductCatalogGroupRevisionId'];
  requestedById: Scalars['AnyId'];
  /** If an existing attribute name is no longer listed here, it will be removed. */
  attributeNames: Array<Scalars['String']>;
};

export type ReorderProductCatalogGroupRawAttributesPayload = {
  __typename: 'ReorderProductCatalogGroupRawAttributesPayload';
  revision: ProductCatalogGroupRevision;
  error?: Maybe<ProductCatalogGroupReorderRawAttributesError>;
};

export type ReorderProductCatalogRawAttributesInput = {
  revisionId: Scalars['ProductCatalogRevisionId'];
  requestedById: Scalars['AnyId'];
  /** If an existing attribute name is no longer listed here, it will be removed. */
  attributeNames: Array<Scalars['String']>;
};

export type ReorderProductCatalogRawAttributesPayload = {
  __typename: 'ReorderProductCatalogRawAttributesPayload';
  revision: ProductCatalogRevision;
  error?: Maybe<ProductCatalogReorderRawAttributesError>;
};

export type ReorderRulesInPromotionInput = {
  id: Scalars['PromotionId'];
  newReferenceIdOrder: Array<Scalars['PromotionRuleReferenceId']>;
};

export type ReorderRulesInPromotionPayload = {
  __typename: 'ReorderRulesInPromotionPayload';
  promotion: Promotion;
};

export type ReplaceDeactivatedExpertRequestInput = {
  conversationId: Scalars['ConversationId'];
};

export type Report = {
  __typename: 'Report';
  id: Scalars['ReportId'];
  title: Scalars['String'];
  /** Must be globally unique if specified */
  internalName?: Maybe<Scalars['String']>;
  columns: Array<ReportColumn>;
  refreshIntervalInMinutes?: Maybe<Scalars['Int']>;
  lastGeneratedAt?: Maybe<Scalars['Date']>;
  scope: ReportAccessScope;
  schemaType?: Maybe<ReportSchemaType>;
};

export enum ReportAccessScope {
  BUSINESS_USER = 'BUSINESS_USER',
  TEAM = 'TEAM',
  DEPARTMENT = 'DEPARTMENT',
  GLOBAL = 'GLOBAL'
}

export type ReportColumn = {
  __typename: 'ReportColumn';
  title: Scalars['String'];
  description: Scalars['String'];
  name: Scalars['String'];
  type: ReportColumnValueType;
  format: ReportColumnFormat;
  filterOnly: Scalars['Boolean'];
};

export enum ReportColumnFormat {
  NONE = 'NONE',
  PERCENTAGE = 'PERCENTAGE',
  CURRENCY = 'CURRENCY'
}

export type ReportColumnInput = {
  name: Scalars['String'];
  title: Scalars['String'];
  type: ReportColumnValueType;
};

export type ReportColumnValue = {
  __typename: 'ReportColumnValue';
  stringValue?: Maybe<Scalars['String']>;
  integerValue?: Maybe<Scalars['Int']>;
  doubleValue?: Maybe<Scalars['Float']>;
  type: ReportColumnValueType;
};

export enum ReportColumnValueType {
  STRING = 'STRING',
  INTEGER = 'INTEGER',
  DOUBLE = 'DOUBLE'
}


export type ReportPredictedLifeTimeValueInput = {
  userId: Scalars['UserId'];
  ltvType: LtvType;
  adPlatform: Scalars['String'];
};

export type ReportPredictedLifeTimeValuePayload = {
  __typename: 'ReportPredictedLifeTimeValuePayload';
  predictedLifeTimeValues: Array<PredictedLifeTimeValue>;
};

export type ReportResultPayload = {
  __typename: 'ReportResultPayload';
  error?: Maybe<Scalars['String']>;
  report?: Maybe<Report>;
  rows: Array<ReportResultRow>;
};

export type ReportResultQuery = {
  reportName?: Maybe<Scalars['String']>;
  reportId?: Maybe<Scalars['ReportId']>;
};

export type ReportResultRow = {
  __typename: 'ReportResultRow';
  values: Array<ReportColumnValue>;
};

export enum ReportSchemaType {
  /** The total amount of conversations, and the amount of new conversations in the last week. */
  CONVERSATIONS_COUNT = 'CONVERSATIONS_COUNT',
  /** Stats about expert ratings; total rating count, and average rating score. */
  EXPERT_RATING_STATS = 'EXPERT_RATING_STATS',
  /** The total amount of curations, and the amount of new curations in the last week. */
  CURATIONS_COUNT = 'CURATIONS_COUNT',
  /** Most popular brands recommended by experts, grouped by category */
  RECOMMENDED_BY_EXPERTS_CAT_BRAND_STATS = 'RECOMMENDED_BY_EXPERTS_CAT_BRAND_STATS',
  /**
   * Most popular brands recommended by experts, grouped and rolled up by category
   * linked to department (e.g.: winter sports, golf, etc)
   */
  RECOMMENDED_BY_EXPERTS_DEPT_CAT_BRAND_STATS = 'RECOMMENDED_BY_EXPERTS_DEPT_CAT_BRAND_STATS'
}

export type RequestConfirmationRichCard = MessageRichCard & {
  __typename: 'RequestConfirmationRichCard';
  type: MessageRichCardType;
  leadId: Scalars['LeadId'];
  expertId: Scalars['BusinessUserId'];
  requestId: Scalars['DealRequestId'];
};

export type RequestConsumerExpertReviewInput = {
  leadId: Scalars['LeadId'];
};

export type RequestConsumerExpertReviewPayload = {
  __typename: 'RequestConsumerExpertReviewPayload';
  success: Scalars['Boolean'];
};

export type RequestOrderRefundInput = {
  orderId: Scalars['OrderId'];
  consumerId: Scalars['UserId'];
  lineItemIds?: Maybe<Array<Scalars['OrderLineItemId']>>;
  orderEscalationId?: Maybe<Scalars['OrderEscalationId']>;
  refundReason: OrderRefundReason;
  amountRequested: MonetaryAmountInput;
  originalTransactionId: Scalars['TransactionId'];
  comment?: Maybe<Scalars['String']>;
  merchantRefundNeeded?: Maybe<Scalars['Boolean']>;
  refundType?: Maybe<OrderRefundType>;
  lineItemRefunds?: Maybe<Array<OrderLineItemRefundInput>>;
};

export type RequestOrderSupportForLeadSupportTaskActivity = SupportTaskActivity & {
  __typename: 'RequestOrderSupportForLeadSupportTaskActivity';
  id: Scalars['SupportTaskActivityId'];
  supportTask: SupportTask;
  action: SupportTaskAction;
  actor: SupportTaskActor;
  consumer: User;
  lead?: Maybe<Lead>;
  occurredAt: Scalars['Date'];
};

export type RequestReferralByExpertInput = {
  leadId: Scalars['LeadId'];
  expertId: Scalars['BusinessUserId'];
};

export type RequestReferralByExpertPayload = {
  __typename: 'RequestReferralByExpertPayload';
  success: Scalars['Boolean'];
};

export type RequestSellableInput = {
  expertId: Scalars['BusinessUserId'];
  sellableId: Scalars['SellableId'];
};

export type RequestSellablePayload = {
  __typename: 'RequestSellablePayload';
  error?: Maybe<Scalars['String']>;
  lead?: Maybe<Lead>;
};

export type RequestSellablePriceMatchInput = {
  expertId: Scalars['BusinessUserId'];
  sellableId: Scalars['SellableId'];
};

export type RequestSellablePriceMatchPayload = {
  __typename: 'RequestSellablePriceMatchPayload';
  error?: Maybe<Scalars['String']>;
  lead?: Maybe<Lead>;
};

export type RequireLoginQuestionPathNodeFlowViewModelValidationError = ErrorMessage & {
  __typename: 'RequireLoginQuestionPathNodeFlowViewModelValidationError';
  errorMessage: Scalars['String'];
};

export type RerunExpertApplicationTaskInput = {
  applicationId: Scalars['ExpertApplicationId'];
  task: ExpertApplicationTaskType;
};

export type RerunExpertApplicationTaskPayload = {
  __typename: 'RerunExpertApplicationTaskPayload';
  success: Scalars['Boolean'];
};

export type ResendGiftCardPayload = {
  __typename: 'ResendGiftCardPayload';
  success: Scalars['Boolean'];
  error?: Maybe<Scalars['String']>;
};

export type ResetConfigInput = {
  domain: Scalars['String'];
  key: Scalars['String'];
};

export type ResetConfigPayload = {
  __typename: 'ResetConfigPayload';
  config: Config;
};

export type ResetDraftTriggerInput = {
  triggerId: Scalars['TriggerId'];
};

export type ResetDraftTriggerPayload = {
  __typename: 'ResetDraftTriggerPayload';
  trigger?: Maybe<Trigger>;
  error?: Maybe<Scalars['String']>;
};

export type ResetExpertCuratedItemNoteInput = {
  id: Scalars['ExpertCuratedItemNoteId'];
};

export type ResetExpertCuratedItemNotePayload = {
  __typename: 'ResetExpertCuratedItemNotePayload';
  expertCuratedItemNote?: Maybe<ExpertCuratedItemNote>;
  errorMessage?: Maybe<Scalars['String']>;
  hasError: Scalars['Boolean'];
};

export type ResetPasswordInput = {
  handle?: Maybe<Scalars['String']>;
  handleType?: Maybe<HandleType>;
  challenge?: Maybe<Scalars['String']>;
  newPassword: Scalars['String'];
};

export type ResetPasswordPayload = EncodedAuthenticationTokensPayload & {
  __typename: 'ResetPasswordPayload';
  result: AuthenticationResult;
  user?: Maybe<User>;
  message?: Maybe<Scalars['String']>;
  encodedAuthenticationTokens?: Maybe<EncodedAuthenticationTokens>;
};

export type ResetSavedExpertCuratedItemsInput = {
  id: Scalars['SavedExpertCuratedItemsId'];
};

export type ResetSavedExpertCuratedItemsPayload = {
  __typename: 'ResetSavedExpertCuratedItemsPayload';
  savedExpertCuratedItems?: Maybe<SavedExpertCuratedItems>;
  error?: Maybe<Scalars['String']>;
  hasError: Scalars['Boolean'];
};

export type RestoreExpertApplicationInput = {
  applicationId: Scalars['ExpertApplicationId'];
  reason?: Maybe<Scalars['String']>;
  restoredToState?: Maybe<ExpertApplicationState>;
};

export type ReturnDestinationChangedActivity = OrderActivityDetail & {
  __typename: 'ReturnDestinationChangedActivity';
  type: OrderActivityDetailType;
  previousDestination: Scalars['String'];
  newDestination: Scalars['String'];
  orderRefund: OrderRefund;
  changedByOperator?: Maybe<Operator>;
};

export type ReturnPolicy = {
  type: ReturnPolicyType;
};

export enum ReturnPolicyType {
  NO_RETURNS_ACCEPTED = 'NO_RETURNS_ACCEPTED',
  STANDARD = 'STANDARD'
}

export enum ReturnRefundMethod {
  ORIGINAL_PAYMENT = 'ORIGINAL_PAYMENT',
  STORE_CREDIT = 'STORE_CREDIT'
}

export type ReturnShipmentTrackingRemovedActivity = OrderActivityDetail & {
  __typename: 'ReturnShipmentTrackingRemovedActivity';
  type: OrderActivityDetailType;
  removedBy?: Maybe<Operator>;
  orderRefund?: Maybe<OrderRefund>;
};

export type ReturnShipmentTrackingUpdatedActivity = OrderActivityDetail & {
  __typename: 'ReturnShipmentTrackingUpdatedActivity';
  type: OrderActivityDetailType;
  shippingCarrier: ShippingCarrier;
  trackingNumber: Scalars['String'];
  updatedBy?: Maybe<Operator>;
  orderRefund?: Maybe<OrderRefund>;
};

export enum ReturnShippingPaidBy {
  NOT_APPLICABLE = 'NOT_APPLICABLE',
  MERCHANT = 'MERCHANT',
  CUSTOMER = 'CUSTOMER'
}

export type ReturnTicket = TicketDetail & {
  __typename: 'ReturnTicket';
  type: TicketType;
  consumer: User;
  order: Order;
  reason: OrderRefundReason;
  itemInfos: Array<EscalationItemInfo>;
  orderLineItemIds: Array<Scalars['OrderLineItemId']>;
  orderRefund?: Maybe<OrderRefund>;
  merchant?: Maybe<Merchant>;
  returnDestination: ProductReturnDestination;
  shippingLabelSentToConsumerAt?: Maybe<Scalars['Date']>;
  lastCheckedLabelFromMerchantAt?: Maybe<Scalars['Date']>;
};

export type ReturnToPreviousContextRedirectPathNodeFlowViewModelSuccess = {
  __typename: 'ReturnToPreviousContextRedirectPathNodeFlowViewModelSuccess';
  /**
   * This type generally represents success; this field is only added since empty types are not allowed in GraphQL.
   * As such, there is no need to resolve or check this
   */
  success?: Maybe<Scalars['Boolean']>;
};

export type ReviewFooterPageMetadata = PathFlowPageMetadata & {
  __typename: 'ReviewFooterPageMetadata';
  type: PathFlowPageMetadataType;
};

export type ReviewSummary = {
  __typename: 'ReviewSummary';
  averageRating?: Maybe<Scalars['Float']>;
  totalReviews: Scalars['Int'];
  summaryByRating: Array<ReviewSummaryByRating>;
};

export type ReviewSummaryByRating = {
  __typename: 'ReviewSummaryByRating';
  rating: Scalars['Int'];
  count: Scalars['Int'];
};

export type RevisionChange = {
  __typename: 'RevisionChange';
  occurredAt: Scalars['Date'];
  notes?: Maybe<Scalars['String']>;
  type: RevisionChangeType;
  changedBy?: Maybe<Operator>;
};

export enum RevisionChangeType {
  CREATED = 'CREATED',
  PUBLISHED = 'PUBLISHED',
  DEACTIVATED = 'DEACTIVATED',
  IMPORTED = 'IMPORTED'
}

export type RevisionExistsCreatePathSchemaRevisionError = ErrorMessage & {
  __typename: 'RevisionExistsCreatePathSchemaRevisionError';
  errorMessage: Scalars['String'];
};

export enum RevisionState {
  DRAFT = 'DRAFT',
  PUBLISHED = 'PUBLISHED',
  DEACTIVATED = 'DEACTIVATED'
}

export type RichPathGraph = PathEditorValidationErrorContainer & {
  __typename: 'RichPathGraph';
  incomingPort: PathPort;
  outgoingPorts: Array<PathPort>;
  nodes: Array<RichPathNode>;
  edges: Array<PathEdge>;
  errors: Array<PathEditorValidationError>;
  childErrors: Array<PathEditorValidationError>;
};

export type RichPathNode = PathEditorValidationErrorContainer & {
  __typename: 'RichPathNode';
  id: Scalars['PathNodeId'];
  references: Array<PathNodeMaterializedReference>;
  /**
   * Entity, typically a path schema (fragment) revision, that owns this path node
   * @deprecated Superseded by the `reference` field
   */
  owningEntityId: Scalars['AnyId'];
  /** @deprecated Superseded by the `reference` field */
  owningEntityType: RichPathNodeOwningEntityType;
  /** @deprecated Superseded by the `reference` field */
  nodeIdFromOwningEntity: Scalars['PathNodeId'];
  /** If it's safe to remove or  move this node directly since it's not owned by a parent container node */
  directManipulationAllowed: Scalars['Boolean'];
  parentId?: Maybe<Scalars['PathNodeId']>;
  config: PathNodeConfig;
  incomingPort: PathPort;
  outgoingPorts: Array<PathPort>;
  expandable: Scalars['Boolean'];
  expanderSetting?: Maybe<PathNodeExpanderSetting>;
  dynamicExpanderState?: Maybe<PathNodeDynamicExpanderState>;
  editorViewModel: PathNodeEditorViewModel;
  /** flowViewModel: PathNodeFlowViewModel */
  errors: Array<PathEditorValidationError>;
  childErrors: Array<PathEditorValidationError>;
};

export enum RichPathNodeOwningEntityType {
  PATH_SCHEMA_REVISION = 'PATH_SCHEMA_REVISION',
  PATH_SCHEMA_FRAGMENT_REVISION = 'PATH_SCHEMA_FRAGMENT_REVISION'
}

export type RingingCallCountChange = {
  __typename: 'RingingCallCountChange';
  count: Scalars['Long'];
};

export type RpalExclusion = {
  __typename: 'RPALExclusion';
  reason: RpalExclusionReason;
  updatedBy: Identity;
  updatedAt: Scalars['Date'];
  override: Scalars['Boolean'];
  note?: Maybe<Scalars['String']>;
};

export enum RpalExclusionReason {
  SPAM = 'SPAM',
  TRAINING = 'TRAINING',
  SELF_CHECKOUT = 'SELF_CHECKOUT',
  NON_RESPONSIVE = 'NON_RESPONSIVE',
  STOPPED = 'STOPPED',
  BUSINESS_DEVELOPMENT = 'BUSINESS_DEVELOPMENT',
  RECRUITING = 'RECRUITING',
  OTHER = 'OTHER'
}

export type RuleDefinition = {
  __typename: 'RuleDefinition';
  condition: ConditionDefinition;
  partitions: Array<PartitionDefinition>;
};

export type RuleDefinitionInput = {
  condition: ConditionDefinitionInput;
  partitions: Array<PartitionDefinitionInput>;
};

export type RunShiftAssignmentsInput = {
  sourceRangeStart: Scalars['Date'];
  sourceRangeEnd: Scalars['Date'];
  schedulingTypeId: Scalars['SchedulingTypeId'];
  assignmentMode: ShiftAssignmentMode;
};

export type RunShiftAssignmentsPayload = {
  __typename: 'RunShiftAssignmentsPayload';
  updateShiftSlotCount: Scalars['Int'];
};

export type SaveConsumerSellableReactionInput = {
  rating: ConsumerSellableReactionRating;
  reasons?: Maybe<Array<ConsumerSellableReactionReason>>;
  additionalReason?: Maybe<Scalars['String']>;
  /** The sellable being reviewed */
  sellableId: Scalars['SellableId'];
  /**
   * Since the sellable can be shown in multiple context like different types of recommended list, search results or
   * in auto curations. This field provides the source of the recommendation if one exists
   * If this is review for an ExpertCuratedItem the id of the corresponding item
   * If this is a review for sellable seen in a recommended list the id of the corresponding RecommendedListDefinition
   */
  recommendationSource?: Maybe<ConsumerSellableReactionRecommendationSourceInput>;
  /** Logical Component on the UI that triggered this reaction */
  reactionSource?: Maybe<ConsumerSellableReactionSource>;
};

export type SaveConsumerSellableReactionPayload = {
  __typename: 'SaveConsumerSellableReactionPayload';
  consumerSellableReaction?: Maybe<ConsumerSellableReaction>;
  error?: Maybe<Scalars['String']>;
};

export type SavedCurationsPagination = {
  __typename: 'SavedCurationsPagination';
  savedCurations: Array<SavedExpertCuratedItems>;
  count: Scalars['Long'];
};

export type SavedCurationsQuery = {
  createdBy: Scalars['BusinessUserId'];
};

export type SavedExpertCuratedItem = {
  __typename: 'SavedExpertCuratedItem';
  id: Scalars['SellableId'];
  createdAt: Scalars['Date'];
  updatedAt: Scalars['Date'];
  tag?: Maybe<ExpertCuratedItemTag>;
  note?: Maybe<ExpertCuratedItemNote>;
  sellable: Sellable;
  fulfillmentNotes?: Maybe<ExpertCuratedItemFulfillmentNotes>;
  /** Valid note attribute schemas for this item's sellable department */
  attributeSchemas: Array<AttributeSchemaRevision>;
};

/**
 * SavedExpertCuratedItems is a container for ExpertCuratedItem's that were saved for future reference by an expert.
 * Although, this may have been originally created for a lead, it is not tied to a lead and such this information
 * is not persisted.
 * There is however some metadata about request attributes of the original lead to who this curation was sent, which
 * is mainly used for tagging and searching theis curation.
 */
export type SavedExpertCuratedItems = {
  __typename: 'SavedExpertCuratedItems';
  id: Scalars['SavedExpertCuratedItemsId'];
  name: Scalars['String'];
  description?: Maybe<Scalars['String']>;
  active: Scalars['Boolean'];
  state: SavedExpertCuratedItemState;
  createdAt: Scalars['Date'];
  updatedAt: Scalars['Date'];
  supersededId?: Maybe<Scalars['SavedExpertCuratedItemsId']>;
  expertCuratedItems: Array<ExpertCuratedItem>;
  /** A list of request attributes tagged and associated with this curation */
  taggedRequestAttributes: Array<Attribute>;
  /** A list of request attributes that can be used to tag this saved curation */
  suggestedTaggableRequestAttributes: Array<SuggestedExpertTaggableRequestAttribute>;
  savedExpertCuratedItems: Array<SavedExpertCuratedItem>;
  pendingDraftUpdate?: Maybe<SavedExpertCuratedItems>;
  /** Previous item (if any) this item is replacing */
  supersededItem?: Maybe<SavedExpertCuratedItems>;
  /**
   * Indicates that the changes made to this item introduce no material changes to the item it's replacing
   * (referenced by `supersededItem`). If the item is activated in this state (via `publishSavedExpertCuratedItems`),
   * it will be a no-op
   */
  noChangesFromSupersededItem: Scalars['Boolean'];
};

export type SavedExpertCuratedItemsConnection = {
  __typename: 'SavedExpertCuratedItemsConnection';
  edges: Array<SavedExpertCuratedItemsEdge>;
  pageInfo: PageInfo;
  facets: Array<DisplayFacet>;
  count: Scalars['Int'];
};

export type SavedExpertCuratedItemsEdge = {
  __typename: 'SavedExpertCuratedItemsEdge';
  node: SavedExpertCuratedItems;
  cursor: Scalars['String'];
};

export type SavedExpertCuratedItemsEditExpertCuratedItemNoteError = InvalidSavedExpertCuratedItemSavedExpertCuratedItemsEditExpertCuratedItemNoteError | NoExpertCuratedItemNoteToUpdateSavedExpertCuratedItemsEditExpertCuratedItemNoteError | NoteEditErrorSavedExpertCuratedItemsEditExpertCuratedItemNoteError;


export type SavedExpertCuratedItemsSearchFilter = {
  /**
   * keywords for search
   * currently only supports the name of the saved curation and sellable title
   */
  keywords?: Maybe<Scalars['String']>;
  facets?: Maybe<Array<FacetSelection>>;
  expertIds?: Maybe<Array<Scalars['BusinessUserId']>>;
  departmentId?: Maybe<Scalars['DepartmentId']>;
};

export enum SavedExpertCuratedItemState {
  DRAFT = 'DRAFT',
  PUBLISHED = 'PUBLISHED',
  ARCHIVED = 'ARCHIVED'
}

export type SavedLeadNote = {
  __typename: 'SavedLeadNote';
  id: Scalars['LeadNoteId'];
  lead: Lead;
  text: Scalars['String'];
  createdAt: Scalars['Date'];
  messageId?: Maybe<Scalars['String']>;
};

export type SavedSearch = {
  __typename: 'SavedSearch';
  id: Scalars['SavedSearchId'];
  title: Scalars['String'];
  entityName: Scalars['String'];
  count: Scalars['Int'];
};


export type SavedSearchResultConnection = LeadSearchConnection;

export type SavedSellable = {
  __typename: 'SavedSellable';
  id: Scalars['SavedSellableId'];
  sellable: Sellable;
  saved: Scalars['Boolean'];
  savedAt: Scalars['Date'];
  savedReason?: Maybe<SavedSellableReason>;
  savedReasonDisplay?: Maybe<Scalars['String']>;
  unsavedAt?: Maybe<Scalars['Date']>;
  unsavedReason?: Maybe<UnsavedSellableReason>;
  unsavedReasonDisplay?: Maybe<Scalars['String']>;
};

export type SavedSellableEdge = {
  __typename: 'SavedSellableEdge';
  node: SavedSellable;
  cursor: Scalars['String'];
};


export type SavedSellableQueryInput = {
  /** Defaults to the logged in user */
  userId?: Maybe<Scalars['UserId']>;
};

export enum SavedSellableReason {
  PRICE = 'PRICE',
  STYLE = 'STYLE',
  HIGH_QUALITY = 'HIGH_QUALITY',
  BRAND = 'BRAND',
  FEATURES = 'FEATURES'
}

export type SavedSellablesConnection = {
  __typename: 'SavedSellablesConnection';
  edges: Array<SavedSellableEdge>;
  pageInfo: PageInfo;
  count: Scalars['Long'];
};

export type SaveReviewForSuggestedAlternativeSellableInput = {
  suggestedAlternativeSellableId: Scalars['SuggestedAlternativeSellableId'];
  isSuggestionGood: SuggestedSellableReviewAnswer;
};

export type SaveReviewForSuggestedAlternativeSellablePayload = {
  __typename: 'SaveReviewForSuggestedAlternativeSellablePayload';
  data?: Maybe<SuggestedAlternativeSellable>;
  error?: Maybe<Scalars['String']>;
  hasError: Scalars['Boolean'];
};

export type SaveSavedSellableInput = {
  sellableId: Scalars['SellableId'];
  reason?: Maybe<SavedSellableReason>;
};

export type SaveSavedSellablePayload = {
  __typename: 'SaveSavedSellablePayload';
  savedSellable: SavedSellable;
};

export type ScheduleCampaignInput = {
  id: Scalars['CampaignId'];
  batchSize: Scalars['Int'];
  scheduledAt: Scalars['Date'];
};

export type ScheduledPayment = {
  __typename: 'ScheduledPayment';
  id: Scalars['ScheduledPaymentId'];
  amount: MonetaryAmount;
  payAt: Scalars['Date'];
  state: ScheduledPaymentState;
  order: Order;
  paymentSource: PaymentSource;
  remindedAt?: Maybe<Scalars['Date']>;
};


export enum ScheduledPaymentState {
  SCHEDULED = 'SCHEDULED',
  EXECUTED = 'EXECUTED',
  CANCELED = 'CANCELED'
}

export type SchedulingDemandForecast = {
  __typename: 'SchedulingDemandForecast';
  id: Scalars['SchedulingDemandForecastId'];
  startsAt: Scalars['Date'];
  endsAt: Scalars['Date'];
  shiftsRequired: Scalars['Int'];
  type: SchedulingType;
  locked: Scalars['Boolean'];
};

export type SchedulingDemandForecastDailyView = {
  __typename: 'SchedulingDemandForecastDailyView';
  date: Scalars['LocalDate'];
  orderedList: Array<SchedulingDemandForecast>;
  zoneId: Scalars['String'];
};

export type SchedulingDemandForecastDailyViewFilter = {
  zoneId: Scalars['String'];
  startDateInclusive: Scalars['LocalDate'];
  endDateExclusive: Scalars['LocalDate'];
  typeId: Scalars['SchedulingTypeId'];
};


export type SchedulingDepartment = {
  __typename: 'SchedulingDepartment';
  id: Scalars['SchedulingDepartmentId'];
  displayName: Scalars['String'];
  autoAssignmentEnabled: Scalars['Boolean'];
  autoAdjustUserSettingsEnabled: Scalars['Boolean'];
  schedulingTypes: Array<SchedulingType>;
  active: Scalars['Boolean'];
};


export type SchedulingPeriod = {
  __typename: 'SchedulingPeriod';
  startsAt: Scalars['Date'];
  endsAt: Scalars['Date'];
  availabilityOpensAt: Scalars['Date'];
  availabilityFreezesAt: Scalars['Date'];
  reservedShiftsClaimStartsAt: Scalars['Date'];
  openShiftsClaimStartsAt: Scalars['Date'];
  expertShiftCalendarUrl: Scalars['String'];
};

export type SchedulingType = {
  __typename: 'SchedulingType';
  id: Scalars['SchedulingTypeId'];
  name: Scalars['String'];
  role: SchedulingUserRole;
  workHourStartsAt: Scalars['LocalTime'];
  workHourEndsAt: Scalars['LocalTime'];
  shiftDuration: Duration;
  active: Scalars['Boolean'];
  allSettings: Array<SchedulingUserSettings>;
};


export type SchedulingUser = {
  __typename: 'SchedulingUser';
  id: Scalars['AnyId'];
  active: Scalars['Boolean'];
  profiles: Array<SchedulingUserProfile>;
  identity: SchedulingUserIdentity;
  nextSchedulingPeriod: SchedulingPeriod;
  currentSchedulingPeriod: SchedulingPeriod;
  shiftAttendanceSummary?: Maybe<ShiftAttendanceSummary>;
  pendingShiftProbation?: Maybe<ShiftProbation>;
  latestShiftProbation?: Maybe<ShiftProbation>;
  effectiveShiftProbation?: Maybe<ShiftProbation>;
  shiftProbationHistory: Array<ShiftProbation>;
  shiftProbationForThisSchedulingPeriod?: Maybe<ShiftProbation>;
  shiftProbationForNextSchedulingPeriod?: Maybe<ShiftProbation>;
  newlyAccruedAbsences: Scalars['Int'];
  missedShifts: Array<Shift>;
  daysDisabledForShifts: Array<DayOfWeek>;
};


export type SchedulingUserMissedShiftsArgs = {
  maxDays?: Scalars['Int'];
};

export type SchedulingUserAvailability = {
  __typename: 'SchedulingUserAvailability';
  id: Scalars['SchedulingUserAvailabilityId'];
  startsAt: Scalars['Date'];
  endsAt: Scalars['Date'];
  user: SchedulingUser;
  locked: Scalars['Boolean'];
};

export type SchedulingUserAvailabilityDailyView = {
  __typename: 'SchedulingUserAvailabilityDailyView';
  date: Scalars['LocalDate'];
  orderedList: Array<SchedulingUserAvailability>;
  zoneId: Scalars['String'];
};

export type SchedulingUserAvailabilityDailyViewFilter = {
  zoneId: Scalars['String'];
  startDateInclusive: Scalars['LocalDate'];
  endDateExclusive: Scalars['LocalDate'];
  userId: Scalars['AnyId'];
};


export type SchedulingUserIdentity = Operator | BusinessUser;

export type SchedulingUserProfile = {
  __typename: 'SchedulingUserProfile';
  type: SchedulingType;
  weeklyMaximumShifts: Scalars['Int'];
  weeklyMaximumShiftsDefault: Scalars['Int'];
  weeklyMaximumShiftsOverride?: Maybe<Scalars['Int']>;
  dailyMaximumShifts: Scalars['Int'];
  dailyMaximumShiftsDefault: Scalars['Int'];
  dailyMaximumShiftsOverride?: Maybe<Scalars['Int']>;
  priority: Scalars['Int'];
  priorityDefault: Scalars['Int'];
  priorityOverride?: Maybe<Scalars['Int']>;
};

export enum SchedulingUserRole {
  EXPERT = 'EXPERT',
  ON_CALL_EXPERT = 'ON_CALL_EXPERT',
  CHARTER_EXPERT = 'CHARTER_EXPERT',
  ENTRY_EXPERT = 'ENTRY_EXPERT'
}

export type SchedulingUserSettings = {
  __typename: 'SchedulingUserSettings';
  name: Scalars['String'];
  priority: Scalars['Int'];
  weeklyMaximumShifts: Scalars['Int'];
  dailyMaximumShifts: Scalars['Int'];
};

export type SchedulingUserSettingsInput = {
  name: Scalars['String'];
  priority: Scalars['Int'];
  weeklyMaximumShifts: Scalars['Int'];
  dailyMaximumShifts: Scalars['Int'];
};

export enum ScrapingJobType {
  SCRAPINGHUB = 'SCRAPINGHUB'
}

export type ScrapingSellablePriceSource = SellablePriceSource & {
  __typename: 'ScrapingSellablePriceSource';
  id: Scalars['SellablePriceSourceId'];
  type: SellablePriceSourceType;
  sellable: Sellable;
  price?: Maybe<MonetaryAmount>;
  bestOfferPrice?: Maybe<MonetaryAmount>;
  cost?: Maybe<MonetaryAmount>;
  expiresAt?: Maybe<Scalars['Date']>;
  fulfillmentChannel?: Maybe<FulfillmentChannel>;
  canRefresh: Scalars['Boolean'];
  willRefresh: Scalars['Boolean'];
  url: Scalars['String'];
  spider: ScrapingSellablePriceSourceSpider;
  estimatedAvailableAt?: Maybe<Scalars['Date']>;
};

export enum ScrapingSellablePriceSourceSpider {
  EVO = 'EVO',
  PROGOLFYAKIMA = 'PROGOLFYAKIMA',
  JENSONUSA = 'JENSONUSA',
  BIKEBLING = 'BIKEBLING',
  CHAINREACTIONCYCLES = 'CHAINREACTIONCYCLES',
  CAMBRIABIKE = 'CAMBRIABIKE'
}

export type SearchFacetCappedNumericAttributeSchemaMetadata = AttributeSchemaMetadata & {
  __typename: 'SearchFacetCappedNumericAttributeSchemaMetadata';
  type: AttributeSchemaMetadataType;
  upperCap: Scalars['BigDecimal'];
};

export type SearchFacetCappedNumericAttributeSchemaMetadataInput = {
  upperCap: Scalars['BigDecimal'];
};

export type SearchFacetDecimalScaleAttributeSchemaMetadata = AttributeSchemaMetadata & {
  __typename: 'SearchFacetDecimalScaleAttributeSchemaMetadata';
  type: AttributeSchemaMetadataType;
  scale: Scalars['Int'];
};

export type SearchFacetDecimalScaleAttributeSchemaMetadataInput = {
  scale: Scalars['Int'];
};

export type SearchFacetFixedIntegerBucketAttributeSchemaMetadata = AttributeSchemaMetadata & {
  __typename: 'SearchFacetFixedIntegerBucketAttributeSchemaMetadata';
  type: AttributeSchemaMetadataType;
  longBuckets: Array<LongRange>;
};

export type SearchFacetFixedIntegerBucketAttributeSchemaMetadataInput = {
  longBuckets: Array<LongRangeInput>;
};

export type SearchFacetHistogramBucketAttributeSchemaMetadata = AttributeSchemaMetadata & {
  __typename: 'SearchFacetHistogramBucketAttributeSchemaMetadata';
  type: AttributeSchemaMetadataType;
  bucketWidth: Scalars['Int'];
};

export type SearchFacetHistogramBucketAttributeSchemaMetadataInput = {
  bucketWidth: Scalars['Int'];
};

export type SearchFacetNameAliasAttributeSchemaMetadata = AttributeSchemaMetadata & {
  __typename: 'SearchFacetNameAliasAttributeSchemaMetadata';
  type: AttributeSchemaMetadataType;
  alias: Scalars['String'];
};

export type SearchFacetNameAliasAttributeSchemaMetadataInput = {
  alias: Scalars['String'];
};

export type SearchFilterFieldAttributeSchemaMetadata = AttributeSchemaMetadata & {
  __typename: 'SearchFilterFieldAttributeSchemaMetadata';
  type: AttributeSchemaMetadataType;
  filters: Array<SearchFilterFieldAttributeSchemaMetadataSearchFilter>;
};

export type SearchFilterFieldAttributeSchemaMetadataInput = {
  filters: Array<SearchFilterFieldAttributeSchemaMetadataSearchFilterInput>;
};

export type SearchFilterFieldAttributeSchemaMetadataSearchFilter = {
  __typename: 'SearchFilterFieldAttributeSchemaMetadataSearchFilter';
  entity: SearchFilterFieldAttributeSchemaMetadataSearchFilterEntity;
  deprecated: Scalars['Boolean'];
};

export enum SearchFilterFieldAttributeSchemaMetadataSearchFilterEntity {
  LEAD = 'LEAD'
}

export type SearchFilterFieldAttributeSchemaMetadataSearchFilterInput = {
  entity: SearchFilterFieldAttributeSchemaMetadataSearchFilterEntity;
  deprecated: Scalars['Boolean'];
};

export type SearchFilterFieldInput = {
  name: Scalars['String'];
  values: Array<SearchFilterFieldValueInput>;
  negative: Scalars['Boolean'];
};

export type SearchFilterFieldValueInput = {
  attributeValue?: Maybe<AttributeInput>;
  stringValue?: Maybe<Scalars['String']>;
  idValue?: Maybe<Scalars['AnyId']>;
  booleanValue?: Maybe<Scalars['Boolean']>;
  dateRange?: Maybe<DateRangeInput>;
  relativeDateRange?: Maybe<RelativeDateRangeInput>;
  numberRange?: Maybe<BigDecimalRangeInput>;
  leadTouchValue?: Maybe<LeadTouchFilterFieldValueInput>;
  zipCodeRadius?: Maybe<GeoZipCodeRadiusInput>;
};

export type SelectExpertCuratedOrderItemInput = {
  id: Scalars['SellableId'];
  selected: Scalars['Boolean'];
};

export type SelectExpertCuratedOrderItemsInput = {
  id: Scalars['ExpertCuratedOrderId'];
  items: Array<SelectExpertCuratedOrderItemInput>;
};

export type SelectExpertCuratedOrderItemsPayload = {
  __typename: 'SelectExpertCuratedOrderItemsPayload';
  expertCuratedOrder: ExpertCuratedOrder;
  errorCode?: Maybe<ExpertCuratedOrderSelectErrorCode>;
  hasError: Scalars['Boolean'];
  errorMessage?: Maybe<Scalars['String']>;
  /**
   * If errorCode is NOT_ACTIVE and this is present, it means this is the latest active update which replaces
   * `expertCuratedOrder`.
   */
  activeReplacement?: Maybe<ExpertCuratedOrder>;
};

export type SelectExpertCuratedOrderVariationOptionInput = {
  id: Scalars['ExpertCuratedOrderId'];
  sellableId: Scalars['SellableId'];
};

export type SelectExpertCuratedOrderVariationOptionPayload = {
  __typename: 'SelectExpertCuratedOrderVariationOptionPayload';
  expertCuratedOrder: ExpertCuratedOrder;
  errorCode?: Maybe<ExpertCuratedOrderSelectErrorCode>;
  hasError: Scalars['Boolean'];
  errorMessage?: Maybe<Scalars['String']>;
  /**
   * If errorCode is NOT_ACTIVE and this is present, it means this is the latest active update which replaces
   * `expertCuratedOrder`.
   */
  activeReplacement?: Maybe<ExpertCuratedOrder>;
};

export type Sellable = {
  __typename: 'Sellable';
  id: Scalars['SellableId'];
  /** Case-insensitive ID */
  googleId: Scalars['String'];
  /**
   * The ID in the google shopping feed for this sellable
   * If the sellable has GTIN or MPN, this is the same as googleId. Otherwise, it is the parent sellable's googleId
   */
  feedId: Scalars['String'];
  /** Title of the product or service */
  title: Scalars['String'];
  /** Plain text description */
  descriptionText?: Maybe<Scalars['String']>;
  /**
   * Description in GitHub-flavored Markdown format
   * See https://github.github.com/gfm/
   */
  descriptionMarkdown?: Maybe<Scalars['String']>;
  /** categories this sellable is associated with */
  categories: Array<Category>;
  /** if this sellable is a product or service */
  type: SellableType;
  /**
   * MSRP price of this sellable; omittied if not applicable/available. Note that this is not what the consumer pays for
   * the product on Deal.com; salePrice is the actual price paid for the product.
   */
  originalPrice?: Maybe<MonetaryAmount>;
  /** @deprecated Aliased to 'originalPrice' for better readability */
  price?: Maybe<MonetaryAmount>;
  /** default price we advertise to consumer without tax; omitted if not applicable/available (usually for parent sellable) */
  salePrice?: Maybe<MonetaryAmount>;
  /** the overridden price if set. */
  salePriceOverride?: Maybe<MonetaryAmount>;
  /**
   * the minimum sale price if set. the actual salePrice must equal or be higher than this price. note that
   * bestOfferPrice may be less than this price.
   */
  minimumSalePrice?: Maybe<MonetaryAmount>;
  /** the best price we sell to consumer which is not publically shown; omitted if not applicable/available */
  bestOfferPrice?: Maybe<MonetaryAmount>;
  /** the overridden best offer price */
  bestOfferPriceOverride?: Maybe<MonetaryAmount>;
  /** the price source of the sale price. for legacy sale price, this source may not exist, even though salePrice exists */
  salePriceSource?: Maybe<SellablePriceSource>;
  /**
   * The amount of savings `salePrice` offers over `originalPrice`; null if there are no savings, or there is no
   * `originalPrice`
   * @deprecated Use savingsAmountFromOriginalPrice
   */
  savingsAmountFromOriginaPrice?: Maybe<MonetaryAmount>;
  savingsAmountFromOriginalPrice?: Maybe<MonetaryAmount>;
  /** Percent savings for `savingsAmountFromOriginaPrice` */
  savingsPercentFromOriginalPrice?: Maybe<Scalars['Float']>;
  /**
   * Default price we sell to the consumer for with estimated tax. If no input is provided, the user's address associated
   * with their account will be used. If no address is found/provided, or there is no sale price, this field will be null.
   */
  salePriceWithEstimatedTax?: Maybe<MonetaryAmountWithTax>;
  brand?: Maybe<Brand>;
  images: Array<MediaFile>;
  /**
   * Subset of ids in `images` that are sample/backfill images, and not indicative of the exact product or service the
   * customer is receiving.
   */
  sampleImageIds: Array<Scalars['MediaId']>;
  active: Scalars['Boolean'];
  /** The parent sellable if this is a child variant */
  parent?: Maybe<Sellable>;
  /** If this sellable is a variant */
  variant: Scalars['Boolean'];
  /** Computed n-dimension matrix of all of the child variants of this product (e.g.: color, size, etc variations) */
  variationMatrix?: Maybe<VariationMatrix>;
  /** Get formatted components that make up this sellable's unique variant (e.g.: red color, Medium size, etc) */
  variants: Array<SellableFormattedVariant>;
  /** Specifications table */
  specifications: Array<SellableSpecification>;
  /** Get all standardized attributes for this sellable. Note that this will be a subset of specifications. */
  attributes: Array<Attribute>;
  /** Get all raw attributes for this sellable. Note that this will be a subset of specifications. */
  rawAttributes: Array<RawAttribute>;
  /** Get a specific standardized attribute. */
  attribute?: Maybe<Attribute>;
  /** If this sellable is in the user's cart */
  inCart: Scalars['Boolean'];
  /** Unique sources this sellable is associated with. */
  sources: Array<SellableSource>;
  /** If this sellable type is a service, the location at which this service is provided */
  serviceLocation?: Maybe<SellableServiceLocation>;
  /**
   * If this sellable is created ad-hoc for single use (e.g.: created for a single customer).
   * Ad-hoc sellables are not surfaced in search, and are primarily used for experts to sell items we don't have a
   * proper standardized sellable for, but have some means to fulfill.
   */
  adHoc: Scalars['Boolean'];
  consumerUrl: Scalars['String'];
  /**
   * Retrieve expert curated items associated with the specified lead and this sellable, or any of it's variations.
   * If leadId is null, this property will return an empty list. This is to simplify client side queries so the same
   * query can be used for UIs that require and don't require this property
   */
  expertCuratedItemsForLead: Array<ExpertCuratedItem>;
  /** List of features this product/service has */
  features: Array<Scalars['String']>;
  /** Featured rich content from various sites (e.g.: YouTube, Instagram, review sites, etc) */
  featuredContent?: Maybe<FeaturedSellableContent>;
  /** Metrics about this sellable, like page views, purchase count etc. */
  metrics?: Maybe<SellableMetrics>;
  /** If the current user has saved (or subsequently unsaved) this sellable */
  savedSellable?: Maybe<SavedSellable>;
  /**
   * If this particular sellable is out of stock. If this is the parent sellable that is not sellable, it will always
   * be out of stock since it is not sellable in its self.
   */
  outOfStock: Scalars['Boolean'];
  /** The date and time when the sellable will not be purchasable. */
  expireAt?: Maybe<Scalars['Date']>;
  /**
   * If part of a variation, checks if all child/sibling variants are out of stock. If not in a variation, this is
   * identical to `outOfStock`
   */
  areAllVariantsOutOfStock: Scalars['Boolean'];
  department?: Maybe<Department>;
  /** All price sources */
  priceSources: Array<SellablePriceSource>;
  /**
   * Note that this slug is for SEO purposes to put in the url, and is NOT globally unique. The friendlyId should be
   * added to the URL as a unique identifier
   */
  slug: Scalars['String'];
  /**
   * Alternative unique identifier that's shorter than `id`, and more SEO friendly. If not present, it means this
   * sellable is not intended to be discovered via search (e.g.: ad hoc sellables).
   */
  friendlyId?: Maybe<Scalars['String']>;
  /** A flag indicating if this sellable is in short supply */
  inShortSupply: Scalars['Boolean'];
  /**
   * Best-effort search on recent active expert curated items an expert extended to the current user that match this
   * exact sellable, or a variant of this sellable
   */
  recentExpertCuratedItem?: Maybe<ExpertCuratedItem>;
  /**
   * Returns Sellable reactions in context of the viewer. For Consumer, it returns the reactions given by the user to
   * this specific sellable, while in context of Expert, this returns the
   * ConsumerSellableReaction's given by all users to this expert
   */
  consumerSellableReactions: ConsumerSellableReactionConnection;
  /** url to html page providing 360 view of the product, currently used for diamonds */
  dynamic360ViewUrl?: Maybe<Scalars['String']>;
  /** GIA cert url for diamonds */
  certificateUrl?: Maybe<Scalars['String']>;
  /**
   * List of experts who have recommended this sellable
   * Order by expert who has given the most recommendations, total arbitarily limited to 100.
   * @deprecated Use recommendingExperts
   */
  recommendedByExperts: Array<ExpertSellableRecommendationCount>;
  recommendingExperts: ExpertSellableRecommendationCountConnection;
  /**
   * badges associated with a specific sellable
   * If the sellable is a parent sellable, the badges of all variants rollup to the parent
   */
  badges: Array<SellableBadgeWithDisplayName>;
  /** used in email template so that we don't need to fetch the first from images list in freemarker templates. */
  primaryImage?: Maybe<MediaFile>;
  /** other online sellers price for price comparison */
  otherOnlineRetailers: Array<SellableOnlineRetailer>;
  /** stats for expert curated item notes associated with this sellable */
  sellableExpertNoteStats?: Maybe<SellableExpertNoteStats>;
  /** when the sellable is no longer active, which sellable replaces this sellable if known */
  replacedBy?: Maybe<Sellable>;
  relatedArticles: Array<ArticleRevision>;
  /** The single active note written for this sellable by the viewing expert */
  expertCuratedItemNoteForCurrentExpert?: Maybe<ExpertCuratedItemNote>;
  /** GTIN, a.k.a UPC, barcode of the sellable */
  gtin?: Maybe<Scalars['String']>;
  /** Manufacturer Part Number of the sellable */
  mpn?: Maybe<Scalars['String']>;
  /** for parent sellables, this will return true if any of the variant sellables are pre-order */
  availableForPreOrder: Scalars['Boolean'];
  availableAt?: Maybe<Scalars['Date']>;
  questions: Array<SellableQuestion>;
  /**
   * Conversation Starters, i.e. "Is this right for me?" that the user can click on to start a conversation with their expert.
   * Use Case should either be TOP_LIST_PAGE or SELLABLE_PAGE.
   */
  conversationStarters: Array<ConversationStarter>;
  topLists: Array<SellableTopListItemPosition>;
};


export type SellableSalePriceWithEstimatedTaxArgs = {
  input?: Maybe<EstimatedTaxLocationInput>;
};


export type SellableAttributeArgs = {
  attributeName?: Maybe<Scalars['String']>;
};


export type SellableExpertCuratedItemsForLeadArgs = {
  leadId?: Maybe<Scalars['LeadId']>;
  filters?: Maybe<Array<ExpertCuratedItemStateFilter>>;
  sort?: Maybe<ExpertCuratedItemSort>;
};


export type SellableConsumerSellableReactionsArgs = {
  after?: Maybe<Scalars['String']>;
  first?: Maybe<Scalars['Int']>;
  before?: Maybe<Scalars['String']>;
  last?: Maybe<Scalars['Int']>;
};


export type SellableRecommendingExpertsArgs = {
  first?: Maybe<Scalars['Int']>;
};


export type SellableRelatedArticlesArgs = {
  limit?: Maybe<Scalars['Int']>;
};


export type SellableQuestionsArgs = {
  offset?: Maybe<Scalars['Int']>;
  limit?: Maybe<Scalars['Int']>;
};


export type SellableConversationStartersArgs = {
  location?: Maybe<ConversationStarterLocation>;
  limit?: Maybe<Scalars['Int']>;
};

export type SellableAttributeFilterPromotionRuleReference = PromotionRuleReference & {
  __typename: 'SellableAttributeFilterPromotionRuleReference';
  id: Scalars['PromotionRuleReferenceId'];
  type: PromotionRuleType;
  attributes: Array<Attribute>;
  rawAttributes: Array<RawAttribute>;
  comparison: SellableAttributePromotionRuleReferenceComparison;
  strategy: PromotionRuleFilterStrategy;
};

/** See `SellableAttributeFilterPromotionRuleReference` for documentation */
export type SellableAttributeFilterPromotionRuleReferenceInput = {
  attributes?: Maybe<Array<AttributeInput>>;
  rawAttributes?: Maybe<Array<RawAttributeInput>>;
  comparison: SellableAttributePromotionRuleReferenceComparison;
  strategy: PromotionRuleFilterStrategy;
};

export enum SellableAttributePromotionRuleReferenceComparison {
  EQUAL = 'EQUAL',
  NOT_EQUAL = 'NOT_EQUAL'
}

export enum SellableBadge {
  /** Used for items in our warehouse to indicate gurantees on delivery estimates. */
  SHIPPED_BY_CURATED = 'SHIPPED_BY_CURATED',
  /** Used for items drop-shipped by manufacturer */
  SHIPPED_BY_MANUFACTURER = 'SHIPPED_BY_MANUFACTURER',
  /** Used for items shipped by a retail partner */
  SHIPPED_BY_PARTNER = 'SHIPPED_BY_PARTNER',
  /** Used for items whose Sale price is manually overridden and is lower than any of the known price sources */
  SECRET_DEAL = 'SECRET_DEAL'
}

export type SellableBadgeWithDisplayName = {
  __typename: 'SellableBadgeWithDisplayName';
  badge: SellableBadge;
  displayName: Scalars['String'];
};

export type SellableBrandFilterPromotionRuleReference = PromotionRuleReference & {
  __typename: 'SellableBrandFilterPromotionRuleReference';
  id: Scalars['PromotionRuleReferenceId'];
  type: PromotionRuleType;
  brands: Array<Brand>;
  strategy: PromotionRuleFilterStrategy;
};

/** See `SellableBrandFilterPromotionRuleReference` for documentation */
export type SellableBrandFilterPromotionRuleReferenceInput = {
  brandIds: Array<Scalars['BrandId']>;
  strategy: PromotionRuleFilterStrategy;
};

/** Filter or exclude (depending on `strategy`) line item sellables that match `categories` */
export type SellableCategoryFilterPromotionRuleReference = PromotionRuleReference & {
  __typename: 'SellableCategoryFilterPromotionRuleReference';
  id: Scalars['PromotionRuleReferenceId'];
  type: PromotionRuleType;
  categories: Array<Category>;
  strategy: PromotionRuleFilterStrategy;
  /** If children, parents, or both of `categories` should also be included during the filtering/excluding evaluation */
  traversalOptions: Array<SellableCategoryFilterPromotionRuleReferenceTraversalOption>;
};

/** See `SellableCategoryFilterPromotionRuleReference` for documentation */
export type SellableCategoryFilterPromotionRuleReferenceInput = {
  categoryIds: Array<Scalars['CategoryId']>;
  strategy: PromotionRuleFilterStrategy;
  traversalOptions: Array<SellableCategoryFilterPromotionRuleReferenceTraversalOption>;
};

export enum SellableCategoryFilterPromotionRuleReferenceTraversalOption {
  INCLUDE_PARENTS = 'INCLUDE_PARENTS',
  INCLUDE_CHILDREN = 'INCLUDE_CHILDREN'
}

export type SellableConversationStarterDefinitionCriteria = ConversationStarterDefinitionCriteria & {
  __typename: 'SellableConversationStarterDefinitionCriteria';
  type: ConversationStarterContextType;
  categoryIds?: Maybe<Array<Scalars['CategoryId']>>;
  locations: Array<ConversationStarterLocation>;
};

export type SellableConversationStarterQueryInput = {
  sellableId: Scalars['SellableId'];
  location?: Maybe<ConversationStarterLocation>;
  limit?: Maybe<Scalars['Int']>;
};

export type SellableCustomOfferRule = {
  __typename: 'SellableCustomOfferRule';
  id: Scalars['SellableCustomOfferRuleId'];
  department: Department;
  blacklist: Scalars['Boolean'];
  type: SellableCustomOfferRuleType;
  sourceUrl: Scalars['String'];
  sourceName: Scalars['String'];
  active: Scalars['Boolean'];
};

export type SellableCustomOfferRuleFilterInput = {
  departmentId?: Maybe<Scalars['DepartmentId']>;
  sourceKeyword?: Maybe<Scalars['String']>;
  type?: Maybe<SellableCustomOfferRuleType>;
};


export type SellableCustomOfferRulesPagination = {
  __typename: 'SellableCustomOfferRulesPagination';
  rules: Array<SellableCustomOfferRule>;
  count: Scalars['Int'];
};

export enum SellableCustomOfferRuleType {
  PRICE_MATCH = 'PRICE_MATCH',
  CUSTOM_ITEM = 'CUSTOM_ITEM'
}

export type SellableDeactivationTaskPayload = {
  __typename: 'SellableDeactivationTaskPayload';
  numRowsProcessed: Scalars['Int'];
  numRowsIgnored: Scalars['Int'];
  numSellableDisabled: Scalars['Int'];
  errors: Array<SellableTaskError>;
  googleSpreadsheetId: Scalars['String'];
  deactivateVariations: Scalars['Boolean'];
};

export type SellableExpertCuratedItemNoteStatsConnection = {
  __typename: 'SellableExpertCuratedItemNoteStatsConnection';
  facets: Array<DisplayFacet>;
  edges: Array<SellableExpertCuratedItemNoteStatsEdge>;
  pageInfo: PageInfo;
  count: Scalars['Int'];
};

export type SellableExpertCuratedItemNoteStatsEdge = {
  __typename: 'SellableExpertCuratedItemNoteStatsEdge';
  node: SellableExpertNoteStats;
  cursor: Scalars['String'];
};


export type SellableExpertCuratedItemNoteStatsPagination = {
  __typename: 'SellableExpertCuratedItemNoteStatsPagination';
  facets: Array<DisplayFacet>;
  sellableExpertCuratedItemNoteStats: Array<SellableExpertNoteStats>;
  count: Scalars['Int'];
};

export type SellableExpertCuratedItemNoteStatsSearchRequest = {
  keywords?: Maybe<Scalars['String']>;
  categoryIds?: Maybe<Array<Scalars['CategoryId']>>;
  /** The department Id or slug is internally expanded to include all children categories within the department */
  departmentId?: Maybe<Scalars['DepartmentId']>;
  facets?: Maybe<Array<FacetSelection>>;
  /** Top N facet terms to be returned per facet. */
  maxFacetTerms?: Maybe<Scalars['Int']>;
};

export enum SellableExpertCuratedItemNoteStatsSort {
  /** Number of approved review */
  APPROVED_COUNT = 'APPROVED_COUNT',
  /** Number of pending review */
  PENDING_COUNT = 'PENDING_COUNT',
  /** Number of rejected review */
  REJECTED_COUNT = 'REJECTED_COUNT',
  /** Of PDP page views in last week */
  PRODUCT_VIEWS = 'PRODUCT_VIEWS',
  /** of times parent sellable has been recommended */
  TIMES_RECOMMENDED = 'TIMES_RECOMMENDED'
}

export type SellableExpertNoteStats = {
  __typename: 'SellableExpertNoteStats';
  id: Scalars['SellableExpertCuratedItemNoteStatsId'];
  pendingCount: Scalars['Int'];
  approvedCount: Scalars['Int'];
  rejectedCount: Scalars['Int'];
  deactivatedCount: Scalars['Int'];
  sellable: Sellable;
};

/** Filter or exclude (depending on `strategy`) line items that match `sellables`, or their parents match `sellables` */
export type SellableFilterPromotionRuleReference = PromotionRuleReference & {
  __typename: 'SellableFilterPromotionRuleReference';
  id: Scalars['PromotionRuleReferenceId'];
  type: PromotionRuleType;
  sellables: Array<Sellable>;
  strategy: PromotionRuleFilterStrategy;
};

/** See `SellableFilterPromotionRuleReference` for documentation */
export type SellableFilterPromotionRuleReferenceInput = {
  sellableIds: Array<Scalars['SellableId']>;
  strategy: PromotionRuleFilterStrategy;
};

export type SellableFormattedVariant = {
  __typename: 'SellableFormattedVariant';
  /** Internal name for this variant; not intended to be displayed in the UI */
  name: Scalars['String'];
  /**
   * Display name for this variant.
   * This may be something like "Color", "Length", where it effectively serves as a title. Note that this display name is
   * not required. For example, if there is only one dimension, and that's a title dimension, the grouping may not be
   * titled. For title dimensions, the display name may be the shortened product title, e.g.: "Red Special Edition",
   * "Anniversary Edition", "Game of the year bundle".
   */
  displayName?: Maybe<Scalars['String']>;
  /** Internal value; not to be displayed in the UI. Expect this to be things like "RED", "123", "WOMAN", etc. */
  value: Scalars['String'];
  /**
   * Display value formatted as sanitized HTML. To match with the value property examples, expect this to be things like
   * "Red", "123cm", "Woman", etc.
   */
  displayValueHtml: Scalars['String'];
};


export type SellableInventoryItem = {
  __typename: 'SellableInventoryItem';
  id: Scalars['SellableInventoryItemId'];
  category: Category;
  dealSku: Scalars['String'];
  /** External inventory source if managed by a third party management tool */
  externalInventoryItemSource?: Maybe<ExternalInventoryItemSource>;
  gtin?: Maybe<Scalars['String']>;
  mpn?: Maybe<Scalars['String']>;
  attributes: Array<Attribute>;
  rawAttributes: Array<RawAttribute>;
  variationAttributes: Array<Scalars['String']>;
  /**
   * The total available quantity to sell across all fulfillment centers
   * This will take into account any orders that are yet to be fulfilled but are scheduled to be fulfilled
   */
  totalAvailableToOrder: Scalars['Int'];
  /** Availability to order by fulfillment center */
  orderAvailabilityByFulfillmentCenter: Array<AvailabilityByFulfillmentCenter>;
  inventoryItemLevels: Array<SellableInventoryItemLevel>;
  cost?: Maybe<MonetaryAmount>;
  msrp?: Maybe<MonetaryAmount>;
  salePrice?: Maybe<MonetaryAmount>;
  map?: Maybe<MonetaryAmount>;
  title?: Maybe<Scalars['String']>;
  descriptionText?: Maybe<Scalars['String']>;
  descriptionHtml?: Maybe<Scalars['String']>;
  /** A list of purchase order information associated with the inventory item */
  purchaseOrders: Array<SellableInventoryItemPurchaseOrder>;
  /** flag to incidicate explicitly marked available for pre-order inventory item */
  preOrderPermitted: Scalars['Boolean'];
  /**
   * Indicates whether this item is available for pre-order
   * this field is derived from the estimated availability date and whether this was previously marked as pre-order
   */
  availableForPreOrder: Scalars['Boolean'];
  /** Estimate is the value configured by the admin */
  estimatedAvailableAt?: Maybe<Scalars['Date']>;
  /** Actual value is derived based on real availability of inventory count */
  actualAvailableAt?: Maybe<Scalars['Date']>;
};


export type SellableInventoryItemLevel = {
  __typename: 'SellableInventoryItemLevel';
  /** Details of fulfillment center where this inventory is located */
  fulfillmentCenter: FulfillmentCenter;
  /** time when the inventory level was updated */
  updatedAt: Scalars['Date'];
  /** current quantity of items available at this Fulfillment Center */
  availableAtFulfillmentCenter: Scalars['Int'];
  /** current number of items in transit to this Fulfillment Center */
  inTransitShippedToFulfillmentCenter: Scalars['Int'];
};

export type SellableInventoryItemLevelUpdateInput = {
  fulfillmentCenterId: Scalars['FulfillmentCenterId'];
  totalShippedToFulfillmentCenter?: Maybe<Scalars['Int']>;
  availableAtFulfillmentCenter?: Maybe<Scalars['Int']>;
};

export type SellableInventoryItemPurchaseOrder = {
  __typename: 'SellableInventoryItemPurchaseOrder';
  purchasedAt: Scalars['Date'];
  estimatedAvailableAt: Scalars['Date'];
  fulfillmentCenter: FulfillmentCenter;
  quantity: Scalars['Int'];
  availableForPreOrder: Scalars['Boolean'];
};

export type SellableInventoryItemUpdateInput = {
  id: Scalars['SellableInventoryItemId'];
  gtin?: Maybe<Scalars['String']>;
  /** manufacture part number */
  mpn?: Maybe<Scalars['String']>;
  /**
   * Updates to inventory level are allowed as a backup in case of synchronization or data integrity issues
   * The values act as overrides so use them carefully
   */
  inventoryLevels?: Maybe<Array<SellableInventoryItemLevelUpdateInput>>;
  /** The purchase price of the sellable per unit */
  cost?: Maybe<MonetaryAmountInput>;
  /** The msp of the sellable */
  msrp?: Maybe<MonetaryAmountInput>;
};

export type SellableInventoryItemUpdatePayload = {
  __typename: 'SellableInventoryItemUpdatePayload';
  data?: Maybe<SellableInventoryItem>;
  error?: Maybe<Scalars['String']>;
  hasError: Scalars['Boolean'];
};

export type SellableInventoryUploadTaskPayload = {
  __typename: 'SellableInventoryUploadTaskPayload';
  numRowsProcessed: Scalars['Int'];
  numRowsIgnored: Scalars['Int'];
  numInventoryItemsCreated: Scalars['Int'];
  numInventoryItemsUpdated: Scalars['Int'];
  errors: Array<InventoryTaskError>;
  googleSpreadsheetId: Scalars['String'];
  /** Whether the upload process allowed multiple tabs. */
  multiTabUpload: Scalars['Boolean'];
  /** This flag indicates it was used to process data for partner inventory data. */
  partnerInventory: Scalars['Boolean'];
  /**
   * If the uploaded sheet is for items were previously ordered.
   * This has implications on how the PurchaseOrder details are saved. In case of re-orders a new entry is created
   * otherwise, any existing purchase order information is overwritten with the new details in the sheet.
   */
  reOrderedInventory: Scalars['Boolean'];
  /** The file to be uploaded on UPS when this new inventory ships */
  upsShipmentUploadFile?: Maybe<MediaFile>;
};

export type SellableMetrics = {
  __typename: 'SellableMetrics';
  /**
   * Uniqueness here means all PVs by the same user on the same parent Sellable in
   * the hourly window is considered a single event
   * @deprecated use totalUniquePVsInPastHour
   */
  totalUniqueInPastHour?: Maybe<Scalars['Long']>;
  totalUniquePVsInPastHour?: Maybe<Scalars['Int']>;
  /**
   * Uniqueness here means all PVs by the same user on the same parent Sellable in
   * the day long window is considered a single event
   * @deprecated use totalUniquePVsInPastDay
   */
  totalUniqueInPastDay?: Maybe<Scalars['Long']>;
  totalUniquePVsInPastDay?: Maybe<Scalars['Int']>;
  /**
   * Uniqueness here means all PVs by the same user on the same parent Sellable in
   * the week long window is considered a single event
   * @deprecated use totalUniquePVsInPastWeek
   */
  totalUniqueInPastWeek?: Maybe<Scalars['Long']>;
  totalUniquePVsInPastWeek?: Maybe<Scalars['Int']>;
  /**
   * total number of purchases in the past day across all users
   * @deprecated use totalPurchasesInLast24Hours
   */
  totalPurchasesInPast24Hours?: Maybe<Scalars['Long']>;
  totalPurchasesInLast24Hours?: Maybe<Scalars['Int']>;
  /**
   * total number of purchases in the past 30 days across all users
   * @deprecated use totalPurchasesInLast30Days
   */
  totalPurchasesInPast30Days?: Maybe<Scalars['Long']>;
  totalPurchasesInLast30Days?: Maybe<Scalars['Int']>;
  timesRecommendedByExpert?: Maybe<Scalars['Int']>;
};

export type SellableNotFromCatalogGroupProductCatalogGroupPublishFromSellablesError = ErrorMessage & {
  __typename: 'SellableNotFromCatalogGroupProductCatalogGroupPublishFromSellablesError';
  sellables: Array<Sellable>;
  errorMessage: Scalars['String'];
};

export type SellableNotFromCatalogProductCatalogPublishFromSellablesError = ErrorMessage & {
  __typename: 'SellableNotFromCatalogProductCatalogPublishFromSellablesError';
  sellables: Array<Sellable>;
  errorMessage: Scalars['String'];
};

export type SellableOnlineRetailer = {
  __typename: 'SellableOnlineRetailer';
  name: Scalars['String'];
  salePrice: MonetaryAmount;
  freeShipping: Scalars['Boolean'];
};

export type SellablePriceSource = {
  id: Scalars['SellablePriceSourceId'];
  type: SellablePriceSourceType;
  sellable: Sellable;
  price?: Maybe<MonetaryAmount>;
  bestOfferPrice?: Maybe<MonetaryAmount>;
  cost?: Maybe<MonetaryAmount>;
  expiresAt?: Maybe<Scalars['Date']>;
  fulfillmentChannel?: Maybe<FulfillmentChannel>;
  canRefresh: Scalars['Boolean'];
  willRefresh: Scalars['Boolean'];
  estimatedAvailableAt?: Maybe<Scalars['Date']>;
};

export type SellablePriceSourceGoogleShoppingSeller = {
  __typename: 'SellablePriceSourceGoogleShoppingSeller';
  name: Scalars['String'];
  salePrice: MonetaryAmount;
  freeShipping: Scalars['Boolean'];
};


export enum SellablePriceSourceType {
  DEAL = 'DEAL',
  AMAZON = 'AMAZON',
  EBAY = 'EBAY',
  SCRAPING = 'SCRAPING',
  YADAV = 'YADAV',
  RAW_SELLABLE_SCRAPER = 'RAW_SELLABLE_SCRAPER',
  RAW_SELLABLE_FEED = 'RAW_SELLABLE_FEED',
  RAW_SELLABLE_GOOGLE_PRODUCT = 'RAW_SELLABLE_GOOGLE_PRODUCT',
  RAW_SELLABLE_SHOPIFY = 'RAW_SELLABLE_SHOPIFY',
  RAW_SELLABLE_WALMART = 'RAW_SELLABLE_WALMART',
  RAW_SELLABLE_IMPACT = 'RAW_SELLABLE_IMPACT',
  DEAL_INVENTORY = 'DEAL_INVENTORY',
  GOOGLE_SHOPPING = 'GOOGLE_SHOPPING'
}

export type SellablePriceUploadTaskPayload = {
  __typename: 'SellablePriceUploadTaskPayload';
  numRowsProcessed: Scalars['Int'];
  numRowsIgnored: Scalars['Int'];
  numSellableUpdated: Scalars['Int'];
  numSellableCreated: Scalars['Int'];
  numSellableDisabled: Scalars['Int'];
  /** @deprecated use errors */
  errorRows: Array<Scalars['Int']>;
  errors: Array<SellableTaskError>;
  googleSpreadsheetId: Scalars['String'];
};

export type SellableQuestion = {
  __typename: 'SellableQuestion';
  id: Scalars['SellableQuestionId'];
  title: Scalars['String'];
  sellable: Sellable;
  questionedBy: MessagingUser;
  answeredBy: MessagingUser;
  askedAt: Scalars['Date'];
  conversationSnippet: ConversationSnippet;
  state: SellableQuestionState;
};

export type SellableQuestionCandidate = {
  __typename: 'SellableQuestionCandidate';
  id: Scalars['SellableQuestionCandidateId'];
  messageId: Scalars['String'];
  sellable: Sellable;
  lead: Lead;
  sentBy: MessagingUser;
  text: Scalars['String'];
  score: Scalars['Float'];
  state: SellableQuestionCandidateState;
  question?: Maybe<SellableQuestion>;
};


export type SellableQuestionCandidateReview = {
  __typename: 'SellableQuestionCandidateReview';
  id: Scalars['String'];
  messageId: Scalars['String'];
  sellables: Array<Sellable>;
  lead: Lead;
  sentBy: MessagingUser;
  text: Scalars['String'];
  score: Scalars['Float'];
  state: SellableQuestionCandidateState;
  question?: Maybe<SellableQuestion>;
};

export enum SellableQuestionCandidateState {
  PENDING = 'PENDING',
  REJECTED = 'REJECTED',
  APPROVED = 'APPROVED'
}


export enum SellableQuestionState {
  ACTIVE = 'ACTIVE',
  INACTIVE = 'INACTIVE'
}

export type SellableRequestRichCard = MessageRichCard & {
  __typename: 'SellableRequestRichCard';
  type: MessageRichCardType;
  sellableId: Scalars['SellableId'];
};

export type SellableResearchLink = {
  __typename: 'SellableResearchLink';
  id: Scalars['SellableResearchLinkId'];
  createdAt: Scalars['Date'];
  active: Scalars['Boolean'];
  createdBy: BusinessUser;
  sellable: Sellable;
  url: Scalars['String'];
};

export type SellableResearchLinkFilter = {
  sellableId?: Maybe<Scalars['SellableId']>;
  parentSellableId?: Maybe<Scalars['SellableId']>;
  createdById?: Maybe<Scalars['BusinessUserId']>;
};


export type SellableSearchConnection = {
  __typename: 'SellableSearchConnection';
  error?: Maybe<SellableSearchError>;
  facets: Array<DisplayFacet>;
  edges: Array<SellableSearchEdge>;
  pageInfo: PageInfo;
  count: Scalars['Int'];
  modules: Array<SellableSearchPageModule>;
  relatedLinks: Array<SellableSearchPageRelatedLinks>;
  /** Additional metadata that could describe the associated results */
  pageMetadata?: Maybe<SellableSearchPageMetadata>;
  canonicalUrl?: Maybe<Scalars['String']>;
};


export type SellableSearchConnectionModulesArgs = {
  shouldShowModules?: Maybe<Scalars['Boolean']>;
};

export type SellableSearchConversationStarterDefinitionCriteria = ConversationStarterDefinitionCriteria & {
  __typename: 'SellableSearchConversationStarterDefinitionCriteria';
  type: ConversationStarterContextType;
  categoryIds: Array<Scalars['CategoryId']>;
  appliesToChildCategories: Scalars['Boolean'];
};

export type SellableSearchConversationStarterQueryInput = {
  categoryId: Scalars['CategoryId'];
  keywords?: Maybe<Scalars['String']>;
  facets?: Maybe<Array<FacetSelection>>;
  filters?: Maybe<Array<SellableSearchFilter>>;
  limit?: Maybe<Scalars['Int']>;
};

export type SellableSearchEdge = {
  __typename: 'SellableSearchEdge';
  node: Sellable;
  cursor: Scalars['String'];
};

export type SellableSearchError = InvalidSearchQuerySellableSearchError;

export type SellableSearchFacetsPayload = {
  __typename: 'SellableSearchFacetsPayload';
  facets: Array<FacetSelectionPayload>;
};

export type SellableSearchFacetsQuery = {
  /** hack - this is mainly used to provide a facet selection mapping from the external brand ids to internal brand ids */
  brandIds?: Maybe<Array<Scalars['BrandId']>>;
};

export enum SellableSearchFacetsQueryFilter {
  /**
   * Returns facets that have attributes that are marked as PRIMARY in the specific category.
   * In case there are multiple PRIMARY attributes in a Category, it returns the first one after category specific
   * custom sorting, to provide deterministic behavior.
   */
  FIRST_PRIMARY_ATTRIBUTE_ONLY = 'FIRST_PRIMARY_ATTRIBUTE_ONLY',
  /** All facets with PRIMARY attributes are returned, ordered by category specific sorting. */
  ALL_PRIMARY_ATTRIBUTES = 'ALL_PRIMARY_ATTRIBUTES',
  /**
   * Returns facets that have attributes that are marked as SECONDARY in the specific category.
   * In case there are multiple SECONDARY attributes in a Category, it returns the first one after category specific
   * custom sorting, to provide deterministic behavior.
   */
  FIRST_SECONDARY_ATTRIBUTE_ONLY = 'FIRST_SECONDARY_ATTRIBUTE_ONLY',
  /** All facets with SECONDARY attributes are returned, ordered by category specific sorting. */
  ALL_SECONDARY_ATTRIBUTES = 'ALL_SECONDARY_ATTRIBUTES',
  /** Returns brand facets for the specific category */
  INCLUDE_BRANDS = 'INCLUDE_BRANDS',
  /** Excludes out of stock sellables while building the facets */
  EXCLUDE_OUT_OF_STOCK = 'EXCLUDE_OUT_OF_STOCK',
  /** Include gender facet */
  INCLUDE_GENDER = 'INCLUDE_GENDER',
  /** Include Sale price facet as a range */
  INCLUDE_SALE_PRICE_RANGE = 'INCLUDE_SALE_PRICE_RANGE',
  /** Only includes sellables that have discounts */
  INCLUDE_DISCOUNTED_ONLY = 'INCLUDE_DISCOUNTED_ONLY'
}

export enum SellableSearchFilter {
  /**
   * Returns sellables that have discounts only
   * In addition if the sorting is by relevancy, it boosts the sellables that have their price updated recently
   * higher in the result set.
   */
  DISCOUNTED = 'DISCOUNTED',
  /** Exclude out of stock sellables */
  EXCLUDE_OUT_OF_STOCK = 'EXCLUDE_OUT_OF_STOCK',
  /** Include only pre-orders in the search result. */
  PRE_ORDER_ONLY = 'PRE_ORDER_ONLY',
  /** Dual state to include both in stock items and pre-orders */
  INCLUDE_IN_STOCK_OR_PRE_ORDER = 'INCLUDE_IN_STOCK_OR_PRE_ORDER',
  /** Only show sellables that are in stock in Deal warehouse */
  SHIPPED_BY_CURATED = 'SHIPPED_BY_CURATED',
  /** Only show sellables that are drop-shipped by manufacturer */
  SHIPPED_BY_MANUFACTURER = 'SHIPPED_BY_MANUFACTURER',
  /**
   * Only show sellables with a deal.
   * A sellable is considered to have a Secret deal if its salePriceOverride is lower than the salePrice of all known sources
   */
  SECRET_DEAL = 'SECRET_DEAL'
}

export type SellableSearchPageArticleModule = SellableSearchPageModule & {
  __typename: 'SellableSearchPageArticleModule';
  type: SellableSearchPageModuleType;
  /** After this many sellables, the module should be placed. */
  after: Scalars['Int'];
  articles: Array<ArticleRevision>;
};

export type SellableSearchPageConversationStarterModule = SellableSearchPageModule & {
  __typename: 'SellableSearchPageConversationStarterModule';
  type: SellableSearchPageModuleType;
  /** After this many sellables, the module should be placed. */
  after: Scalars['Int'];
  conversationStarters: Array<ConversationStarter>;
};

export type SellableSearchPageMetadata = {
  __typename: 'SellableSearchPageMetadata';
  /** Will not be present if the category's freemarker template is invalid. */
  pageTitle?: Maybe<Scalars['String']>;
  featuredFacets: Array<DisplayFacet>;
  subcategoryTiles: Array<SellableSearchPageSubcategoryTile>;
};

export type SellableSearchPageModule = {
  type: SellableSearchPageModuleType;
  /** After this many sellables, the module should be placed. */
  after: Scalars['Int'];
};

/** Sellable Search Page Module Types */
export enum SellableSearchPageModuleType {
  TOP_LIST = 'TOP_LIST',
  ARTICLE = 'ARTICLE',
  CONVERSATION_STARTER = 'CONVERSATION_STARTER'
}

export type SellableSearchPageRelatedLinks = {
  __typename: 'SellableSearchPageRelatedLinks';
  type: SellableSearchPageRelatedLinksType;
  title: Scalars['String'];
  items: Array<SellableSearchPageRelatedSearchItem>;
};

export type SellableSearchPageRelatedLinksInput = {
  sellableSearchQuery: SellableSearchQuery;
  type: SellableSearchPageRelatedLinksType;
};

export enum SellableSearchPageRelatedLinksType {
  DOWNWARDS_SEARCH = 'DOWNWARDS_SEARCH',
  SIDEWAYS_SEARCH = 'SIDEWAYS_SEARCH',
  BRAND_SEARCH = 'BRAND_SEARCH',
  ARTICLE = 'ARTICLE',
  TOP_LIST = 'TOP_LIST'
}

export type SellableSearchPageRelatedSearch = {
  __typename: 'SellableSearchPageRelatedSearch';
  category: Category;
  facets: Array<FacetSelectionPayload>;
  title?: Maybe<Scalars['String']>;
};

export type SellableSearchPageRelatedSearchItem = ArticleRevision | SellableTopList | SellableSearchPageRelatedSearch;

export type SellableSearchPageSubcategoryTile = {
  __typename: 'SellableSearchPageSubcategoryTile';
  category: Category;
  imagePath?: Maybe<Scalars['String']>;
};

export type SellableSearchPageTopListModule = SellableSearchPageModule & {
  __typename: 'SellableSearchPageTopListModule';
  type: SellableSearchPageModuleType;
  /** After this many sellables, the module should be placed. */
  after: Scalars['Int'];
  topLists: Array<SellableTopList>;
};

export type SellableSearchQuery = {
  facets?: Maybe<Array<FacetSelection>>;
  title?: Maybe<Scalars['String']>;
  keywords?: Maybe<Scalars['String']>;
  categoryIds?: Maybe<Array<Scalars['CategoryId']>>;
  categorySlugs?: Maybe<Array<Scalars['String']>>;
  /** The department Id or slug is internally expanded to include all children categories within the department */
  departmentId?: Maybe<Scalars['DepartmentId']>;
  departmentSlug?: Maybe<Scalars['String']>;
  brandIds?: Maybe<Array<Scalars['BrandId']>>;
  /** If omitted, defaults to CONSUMER_SEARCH */
  sellableSearchUseCase?: Maybe<SellableSearchUseCase>;
  /** Admin/Expert search queries can pass the UserId to see the results that the specified consumer will see. */
  impersonatingUserId?: Maybe<Scalars['UserId']>;
  /** To restrict the search results to a specific SellableType */
  type?: Maybe<SellableType>;
  /** Top N facet terms to be returned per facet. */
  maxFacetTerms?: Maybe<Scalars['Int']>;
  /**
   * Explicit query filters that are applied to the search results. These provide special query conditions
   * that are different than facets or categories for example.
   * In case of multiple SellableSearchFilters, all input SellableSearchFilters are ANDed
   */
  filters?: Maybe<Array<SellableSearchFilter>>;
};

export enum SellableSearchUseCase {
  CONSUMER_SEARCH = 'CONSUMER_SEARCH',
  EXPERT_SEARCH = 'EXPERT_SEARCH',
  IMPERSONATE_CONSUMER = 'IMPERSONATE_CONSUMER',
  OPS_SEARCH = 'OPS_SEARCH',
  /** This use case for consumer does not take the user intent into account and is basically a simple brand search query */
  CONSUMER_HOME_PAGE_BY_BRANDS = 'CONSUMER_HOME_PAGE_BY_BRANDS'
}

export type SellableServiceLocation = {
  __typename: 'SellableServiceLocation';
  displayTitle?: Maybe<Scalars['String']>;
};


export type SellableServiceLocationDisplayTitleArgs = {
  displayType?: Maybe<SellableServiceLocationDisplayType>;
};

export enum SellableServiceLocationDisplayType {
  CITY_STATE = 'CITY_STATE'
}

export enum SellableSort {
  /** Average sale price is calculated as (min + max)/2 for all variations */
  AVG_SALE_PRICE = 'AVG_SALE_PRICE',
  /** Best offer price is our secret deal price and should only be shown to the experts. */
  BEST_OFFER_PRICE = 'BEST_OFFER_PRICE',
  /** Savings = actual price - sale price */
  MAX_PRICE_SAVINGS = 'MAX_PRICE_SAVINGS',
  /** Percent savings = (actual price - sale price)/actual price */
  MAX_PRICE_PERCENT_SAVINGS = 'MAX_PRICE_PERCENT_SAVINGS',
  /** Defined as the unique page views in the last 7 days */
  POPULARITY = 'POPULARITY',
  /** Defined as the number of purchases in the last 30 days */
  BEST_SELLER = 'BEST_SELLER',
  /** Relevance score computed from sellables that match users intent */
  RELEVANCE = 'RELEVANCE',
  /** sort by times recommended by expert */
  MOST_RECOMMENDED_BY_EXPERTS = 'MOST_RECOMMENDED_BY_EXPERTS',
  /** This is the fastest way to get results if ordering is not important */
  INDEX_ORDER = 'INDEX_ORDER',
  /** An stable way to paginate across all indexed documents */
  DOC_ID_ORDER = 'DOC_ID_ORDER'
}

export type SellableSource = {
  type: SellableSourceType;
};

export type SellableSourceExternalId = SellableSource & {
  __typename: 'SellableSourceExternalId';
  type: SellableSourceType;
  externalId: Scalars['String'];
  externalIdType: SellableSourceExternalIdType;
};

export enum SellableSourceExternalIdType {
  YADAV_DIAMOND = 'YADAV_DIAMOND',
  YADAV_SETTING = 'YADAV_SETTING'
}

export type SellableSourceProductCatalog = SellableSource & {
  __typename: 'SellableSourceProductCatalog';
  type: SellableSourceType;
  catalog: ProductCatalogRevision;
};

export type SellableSourceProductCatalogGroup = SellableSource & {
  __typename: 'SellableSourceProductCatalogGroup';
  type: SellableSourceType;
  group: ProductCatalogGroupRevision;
};

export type SellableSourceStandardizedSellableGroup = SellableSource & {
  __typename: 'SellableSourceStandardizedSellableGroup';
  type: SellableSourceType;
  standardizedSellableGroup: StandardizedSellableGroup;
};

export enum SellableSourceType {
  URL = 'URL',
  EXTERNAL_ID = 'EXTERNAL_ID',
  STANDARDIZED_SELLABLE_GROUP = 'STANDARDIZED_SELLABLE_GROUP',
  PRODUCT_CATALOG = 'PRODUCT_CATALOG',
  PRODUCT_CATALOG_GROUP = 'PRODUCT_CATALOG_GROUP'
}

export type SellableSourceUrl = SellableSource & {
  __typename: 'SellableSourceUrl';
  type: SellableSourceType;
  url: Scalars['String'];
};

export type SellablesPagination = {
  __typename: 'SellablesPagination';
  error?: Maybe<SellableSearchError>;
  facets: Array<DisplayFacet>;
  sellables: Array<Sellable>;
  count: Scalars['Int'];
  maximumExceeded: Scalars['Boolean'];
  modules: Array<SellableSearchPageModule>;
  relatedLinks: Array<SellableSearchPageRelatedLinks>;
  /** Additional metadata that could describe the associated results */
  pageMetadata?: Maybe<SellableSearchPageMetadata>;
  canonicalUrl?: Maybe<Scalars['String']>;
};


export type SellablesPaginationModulesArgs = {
  shouldShowModules?: Maybe<Scalars['Boolean']>;
};

export type SellableSpecification = {
  __typename: 'SellableSpecification';
  /**
   * Internal unique name that can be used as a unique key for referencing this specification entry.
   * This name is human readable and consistent to match the underlying data source (e.g.: attribute:fooBar), so UI
   * treatments can be created if these keys are hard coded and checked against.
   */
  key?: Maybe<Scalars['String']>;
  /** Display name for the specification */
  name: Scalars['String'];
  /** Display HTML value for the specification */
  valueHtml: Scalars['String'];
};

export type SellableTaskError = {
  __typename: 'SellableTaskError';
  row: Scalars['Int'];
  message: Scalars['String'];
};

export type SellableTerms = {
  id: Scalars['SellableTermsId'];
  createdFor: User;
  createdByExpert?: Maybe<BusinessUser>;
  orderLineItemId: Scalars['OrderLineItemId'];
  order: Order;
  type: SellableType;
};


export type SellableTopList = {
  __typename: 'SellableTopList';
  id: Scalars['SellableTopListId'];
  state: SellableTopListState;
  title: Scalars['String'];
  description: Scalars['String'];
  friendlyId: Scalars['Long'];
  slug: Scalars['String'];
  generatedAt: Scalars['Date'];
  createdAt: Scalars['Date'];
  items: Array<SellableTopListItem>;
  relatedTopLists: Array<SellableTopList>;
  featuredImage?: Maybe<MediaFileWithCaption>;
  department: Department;
  featured: Scalars['Boolean'];
  /** The url to the sellable top list, e.g. https://www.curated.com/most-recommended/18001/arbor-snowboards */
  consumerUrl: Scalars['String'];
};


export type SellableTopListRelatedTopListsArgs = {
  limit?: Maybe<Scalars['Int']>;
};

export type SellableTopListDefinition = {
  __typename: 'SellableTopListDefinition';
  id: Scalars['SellableTopListDefinitionId'];
  slug: Scalars['String'];
  state: SellableTopListState;
  friendlyId: Scalars['Long'];
  createdAt?: Maybe<Scalars['Date']>;
  publishedAt?: Maybe<Scalars['Date']>;
  archivedAt?: Maybe<Scalars['Date']>;
  createdBy: Operator;
  updatedBy: Operator;
  title: Scalars['String'];
  description: Scalars['String'];
  facets: Array<FacetSelectionPayload>;
  decoratedFacets: Array<DisplayFacet>;
  categories: Array<Category>;
  featuredImage?: Maybe<MediaFileWithCaption>;
  department: Department;
  featured: Scalars['Boolean'];
  /** The url to the sellable top list, e.g. https://www.curated.com/most-recommended/18001/arbor-snowboards */
  consumerUrl: Scalars['String'];
};


export type SellableTopListDefinitionQueryInput = {
  categoryIds?: Maybe<Array<Scalars['CategoryId']>>;
  departmentId?: Maybe<Scalars['DepartmentId']>;
  keywords?: Maybe<Scalars['String']>;
  includeChildCategories?: Maybe<Scalars['Boolean']>;
  includeParentCategories?: Maybe<Scalars['Boolean']>;
  state?: Maybe<SellableTopListState>;
};

export enum SellableTopListDefinitionSort {
  TITLE = 'TITLE',
  CREATED_AT = 'CREATED_AT',
  UPDATED_AT = 'UPDATED_AT',
  PUBLISHED_AT = 'PUBLISHED_AT'
}

export type SellableTopListDefinitionsPagination = {
  __typename: 'SellableTopListDefinitionsPagination';
  definitions: Array<SellableTopListDefinition>;
  count: Scalars['Long'];
};


export type SellableTopListItem = {
  __typename: 'SellableTopListItem';
  expertNote: ExpertCuratedItemNote;
  parentSellable: Sellable;
  timesRecommended: Scalars['Int'];
};

export type SellableTopListItemPosition = {
  __typename: 'SellableTopListItemPosition';
  topList: SellableTopList;
  position: Scalars['Int'];
};

export enum SellableTopListState {
  DRAFT = 'DRAFT',
  PUBLISHED = 'PUBLISHED',
  ARCHIVED = 'ARCHIVED'
}

export enum SellableType {
  PRODUCT = 'PRODUCT',
  SERVICE = 'SERVICE'
}

export type SellableTypeaheadHit = {
  __typename: 'SellableTypeaheadHit';
  id: Scalars['SellableId'];
  /** The matched text string in the indexed keywords */
  text: Scalars['String'];
  /** The sellable title */
  title: Scalars['String'];
  /** The Brand name associated with this Sellable if present */
  brandName?: Maybe<Scalars['String']>;
  /**
   * Image url if present for this Sellable. Typically, Sellables will have multiple images but this returns only one
   * since its usage is restricted to the typeahead
   */
  imageUrl?: Maybe<Scalars['String']>;
  /** For maximum typeahead performance, don't resolve this sellable property */
  sellable: Sellable;
};

export type SellableTypeaheadPayload = {
  __typename: 'SellableTypeaheadPayload';
  hits: Array<SellableTypeaheadHit>;
};

export type SellableTypeaheadQuery = {
  prefixSearch?: Maybe<Scalars['String']>;
  categoryIds?: Maybe<Array<Scalars['CategoryId']>>;
  categorySlugs?: Maybe<Array<Scalars['String']>>;
  /** The department Id or slug is internally expanded to include all children categories within the department */
  departmentId?: Maybe<Scalars['DepartmentId']>;
  departmentSlug?: Maybe<Scalars['String']>;
  /** If omitted, defaults to CONSUMER_SEARCH */
  sellableSearchUseCase?: Maybe<SellableSearchUseCase>;
};

export type SellableUpdateTaskPayload = {
  __typename: 'SellableUpdateTaskPayload';
  numRowsProcessed: Scalars['Int'];
  numRowsIgnored: Scalars['Int'];
  numSellableUpdated: Scalars['Int'];
  numSellableSkipped: Scalars['Int'];
  errors: Array<SellableTaskError>;
  googleSpreadsheetId: Scalars['String'];
};

export type SellableUploadTaskPayload = {
  __typename: 'SellableUploadTaskPayload';
  numRowsProcessed: Scalars['Int'];
  numRowsIgnored: Scalars['Int'];
  numSellableUpdated: Scalars['Int'];
  numSellableCreated: Scalars['Int'];
  numSellableDisabled: Scalars['Int'];
  numSellableVariationFilteredOut: Scalars['Int'];
  /** @deprecated use errors */
  errorRows: Array<Scalars['Int']>;
  errors: Array<SellableTaskError>;
  googleSpreadsheetId: Scalars['String'];
};

export type SendExpertReferralInput = {
  expertId: Scalars['BusinessUserId'];
  referrerId: Scalars['UserId'];
  emails: Array<Scalars['String']>;
  note: Scalars['String'];
};

export type SendExpertReferralPayload = {
  __typename: 'SendExpertReferralPayload';
  expertReferral?: Maybe<ExpertReferral>;
  errors: Array<Scalars['String']>;
};

export type SendRichCardInput = {
  type: MessageRichCardType;
};

export type SendRichCardPayload = {
  __typename: 'SendRichCardPayload';
  richCard?: Maybe<MessageRichCard>;
};

export type SendTemplateTestMessageInput = {
  templateId: Scalars['CommTemplateId'];
  variables: Array<RenderCommTemplateVariableInput>;
  channelType: ChannelType;
  contact: Scalars['String'];
};

export type SendTemplateTestMessagePayload = {
  __typename: 'SendTemplateTestMessagePayload';
  success: Scalars['Boolean'];
  error?: Maybe<Scalars['String']>;
};

export type ServiceDealTerms = {
  __typename: 'ServiceDealTerms';
  type: DealTermsType;
  additionalDetails?: Maybe<Scalars['String']>;
};

export type ServiceOfferTerms = {
  __typename: 'ServiceOfferTerms';
  dateTimes?: Maybe<Array<Scalars['Date']>>;
  confirmedTime?: Maybe<Scalars['Date']>;
  additionalDetails?: Maybe<Scalars['String']>;
  termDocuments: Array<MediaFile>;
};

export type ServiceOfferTermsInput = {
  dateTimes?: Maybe<Array<Scalars['Date']>>;
  additionalDetails?: Maybe<Scalars['String']>;
  termDocuments?: Maybe<Array<Scalars['MediaId']>>;
};

export type ServiceSellableTerms = SellableTerms & {
  __typename: 'ServiceSellableTerms';
  id: Scalars['SellableTermsId'];
  createdFor: User;
  createdByExpert?: Maybe<BusinessUser>;
  orderLineItemId: Scalars['OrderLineItemId'];
  order: Order;
  type: SellableType;
  startAt: Scalars['Date'];
};

export type Session = {
  __typename: 'Session';
  id: Scalars['SessionId'];
  token: Scalars['String'];
  experimentUserId: Scalars['AnyId'];
  authenticationMethod?: Maybe<AuthenticationMethod>;
  authenticationState: AuthenticationSessionState;
};


export type SetAcceptingNewRequestsInput = {
  id: Scalars['BusinessUserId'];
  accept: Scalars['Boolean'];
};

export type SetArticleRevisionAttributeInput = {
  id: Scalars['ArticleRevisionId'];
  attribute: AttributeInput;
};

export type SetConsumerInitialLeadActionInput = {
  leadId: Scalars['LeadId'];
  action: ConsumerInitialLeadAction;
};

export type SetConsumerInitialLeadActionPayload = {
  __typename: 'SetConsumerInitialLeadActionPayload';
  lead?: Maybe<Lead>;
};

export type SetEscalationPriorityInput = {
  escalationId: Scalars['OrderEscalationId'];
  priority: OrderEscalationPriority;
};

export type SetExpertApplicationArchivedInput = {
  applicationId: Scalars['ExpertApplicationId'];
  archived: Scalars['Boolean'];
};

export type SetExpertApplicationSnoozeInput = {
  applicationId: Scalars['ExpertApplicationId'];
  wakeupTime: Scalars['Date'];
  note?: Maybe<Scalars['String']>;
  message?: Maybe<Scalars['String']>;
  cancelMessageOnReply?: Maybe<Scalars['Boolean']>;
};

export type SetExpertApplicationTaskCompletedInput = {
  applicationId: Scalars['ExpertApplicationId'];
  task: ExpertApplicationTaskType;
};

export type SetExpertApplicationTaskCompletedPayload = {
  __typename: 'SetExpertApplicationTaskCompletedPayload';
  error?: Maybe<Scalars['String']>;
  application: ExpertApplication;
};

export type SetExpertAwayAutoReplyInput = {
  expertId: Scalars['BusinessUserId'];
  effectiveFrom?: Maybe<Scalars['Date']>;
  effectiveUntil: Scalars['Date'];
  message: Scalars['String'];
};

export type SetExpertAwayAutoReplyPayload = {
  __typename: 'SetExpertAwayAutoReplyPayload';
  businessUser?: Maybe<BusinessUser>;
  error?: Maybe<Scalars['String']>;
};

export type SetExpertCuratedItemNoteFeaturedInput = {
  id: Scalars['ExpertCuratedItemNoteId'];
  featured: Scalars['Boolean'];
  changedById: Scalars['OperatorId'];
};

export type SetExpertCuratedItemNoteFeaturedPayload = {
  __typename: 'SetExpertCuratedItemNoteFeaturedPayload';
  expertCuratedItemNote?: Maybe<ExpertCuratedItemNote>;
  hasError: Scalars['Boolean'];
  errorMessage?: Maybe<Scalars['String']>;
};

export type SetExpertOffShiftInput = {
  id: Scalars['BusinessUserId'];
};

export type SetExpertOffShiftPayload = {
  __typename: 'SetExpertOffShiftPayload';
  businessUser?: Maybe<BusinessUser>;
  error?: Maybe<Scalars['String']>;
  shouldShowEndOfShiftSurvey: Scalars['Boolean'];
};

export type SetExpertOnCallInput = {
  id: Scalars['BusinessUserId'];
  onCall: Scalars['Boolean'];
};

export type SetExpertTeamLeadInput = {
  id: Scalars['BusinessUserId'];
  teamLead: Scalars['Boolean'];
};

export type SetExpertTeamLeadPayload = {
  __typename: 'SetExpertTeamLeadPayload';
  businessUser?: Maybe<BusinessUser>;
  error?: Maybe<Scalars['String']>;
};

export type SetLeadArchivedInput = {
  leadId: Scalars['LeadId'];
  archived: Scalars['Boolean'];
};

export type SetLeadDoNotCallInput = {
  leadId: Scalars['LeadId'];
  doNotCall: Scalars['Boolean'];
};

export type SetLeadRpalExclusionOverrideInput = {
  leadId: Scalars['LeadId'];
  reason: RpalExclusionReason;
  note?: Maybe<Scalars['String']>;
};

export type SetLeadSnoozeInput = {
  leadId: Scalars['LeadId'];
  wakeupTime: Scalars['Date'];
  note?: Maybe<Scalars['String']>;
  message?: Maybe<Scalars['String']>;
  cancelMessageOnConsumerReply?: Maybe<Scalars['Boolean']>;
};

export type SetLeadStarInput = {
  leadId: Scalars['LeadId'];
  starred: Scalars['Boolean'];
};

export type SetProductCatalogAttributeInput = {
  revisionId: Scalars['ProductCatalogRevisionId'];
  requestedById: Scalars['AnyId'];
  attribute: AttributeInput;
};

export type SetProductCatalogAttributePayload = {
  __typename: 'SetProductCatalogAttributePayload';
  revision: ProductCatalogRevision;
  error?: Maybe<ProductCatalogSetAttributeError>;
};

export type SetProductCatalogGroupAttributeInput = {
  revisionId: Scalars['ProductCatalogGroupRevisionId'];
  requestedById: Scalars['AnyId'];
  attribute: AttributeInput;
};

export type SetProductCatalogGroupAttributePayload = {
  __typename: 'SetProductCatalogGroupAttributePayload';
  revision: ProductCatalogGroupRevision;
  error?: Maybe<ProductCatalogGroupSetAttributeError>;
};

export type SetProductCatalogGroupRawAttributeInput = {
  revisionId: Scalars['ProductCatalogGroupRevisionId'];
  requestedById: Scalars['AnyId'];
  rawAttribute: RawAttributeInput;
};

export type SetProductCatalogGroupRawAttributePayload = {
  __typename: 'SetProductCatalogGroupRawAttributePayload';
  revision: ProductCatalogGroupRevision;
  error?: Maybe<ProductCatalogGroupSetRawAttributeError>;
};

export type SetProductCatalogRawAttributeInput = {
  revisionId: Scalars['ProductCatalogRevisionId'];
  requestedById: Scalars['AnyId'];
  rawAttribute: RawAttributeInput;
};

export type SetProductCatalogRawAttributePayload = {
  __typename: 'SetProductCatalogRawAttributePayload';
  revision: ProductCatalogRevision;
  error?: Maybe<ProductCatalogSetRawAttributeError>;
};

export type SetSellableAttributeInput = {
  ids: Array<Scalars['SellableId']>;
  attribute: AttributeInput;
  allVariants?: Maybe<Scalars['Boolean']>;
};

export type SetSellableRawAttributeInput = {
  ids: Array<Scalars['SellableId']>;
  rawAttribute: RawAttributeInput;
  allVariants?: Maybe<Scalars['Boolean']>;
};

export type SetShiftAbsenceExcusedInput = {
  shiftIds: Array<Scalars['ShiftId']>;
};

export type SetShiftAbsenceExcusedPayload = {
  __typename: 'SetShiftAbsenceExcusedPayload';
  schedulingUsers: Array<SchedulingUser>;
  shifts: Array<Shift>;
  errorMessages: Array<Scalars['String']>;
};

export type SetTicketDueDateInput = {
  ticketId: Scalars['TicketId'];
  dueDate: Scalars['Date'];
};

export type SetupPaymentSourceInput = {
  paymentProcessorPlatformSourceId: Scalars['String'];
  type: PaymentProcessorType;
  billingAddress?: Maybe<AddressInput>;
  isDefault?: Maybe<Scalars['Boolean']>;
};

export type SetupPaymentSourcePayload = {
  __typename: 'SetupPaymentSourcePayload';
  paymentSource: PaymentSource;
  paymentAction?: Maybe<PaymentAction>;
  error?: Maybe<SetupPaymentSourcePayloadError>;
};

export type SetupPaymentSourcePayloadError = DefaultErrorMessage;

export type Shift = {
  __typename: 'Shift';
  id: Scalars['ShiftId'];
  shiftSlot?: Maybe<ShiftSlot>;
  leadSurge?: Maybe<LeadSurge>;
  type: SchedulingType;
  startsAt: Scalars['Date'];
  endsAt: Scalars['Date'];
  user: SchedulingUser;
  active: Scalars['Boolean'];
  changeRequest?: Maybe<ShiftChangeRequest>;
  attendance?: Maybe<ShiftAttendance>;
};

export enum ShiftAssignmentMode {
  CLAIM = 'CLAIM',
  RESERVE = 'RESERVE',
  DRY_RUN = 'DRY_RUN',
  NONE = 'NONE'
}

export type ShiftAttendance = {
  __typename: 'ShiftAttendance';
  status: ShiftAttendanceStatus;
  updatedAt: Scalars['Date'];
  overriddenBy?: Maybe<Operator>;
};

export enum ShiftAttendanceStatus {
  NOT_APPLICABLE = 'NOT_APPLICABLE',
  PRESENT = 'PRESENT',
  STARTED_LATE = 'STARTED_LATE',
  ENDED_EARLY = 'ENDED_EARLY',
  ABSENT = 'ABSENT',
  EXCUSED = 'EXCUSED'
}

export type ShiftAttendanceSummary = {
  __typename: 'ShiftAttendanceSummary';
  shiftsMissed: Scalars['Int'];
  shiftsStartedLate: Scalars['Int'];
  shiftsEndedEarly: Scalars['Int'];
  effectiveAbsences: Scalars['Int'];
  updatedAt: Scalars['Date'];
};

export type ShiftChangeRequest = {
  type: ShiftChangeRequestType;
  requestedAt: Scalars['Date'];
};

export enum ShiftChangeRequestType {
  GIVE_UP = 'GIVE_UP',
  SWAP = 'SWAP'
}

export type ShiftDailyView = {
  __typename: 'ShiftDailyView';
  date: Scalars['LocalDate'];
  orderedList: Array<Shift>;
  zoneId: Scalars['String'];
};

export type ShiftDailyViewFilter = {
  zoneId: Scalars['String'];
  startDateInclusive: Scalars['LocalDate'];
  endDateExclusive: Scalars['LocalDate'];
  userId: Scalars['AnyId'];
};

export enum ShiftGiveUpReason {
  PICK_ANOTHER_SHIFT = 'PICK_ANOTHER_SHIFT',
  SICK = 'SICK',
  EMERGENCY = 'EMERGENCY',
  OTHER = 'OTHER'
}

export type ShiftGiveUpRequest = ShiftChangeRequest & {
  __typename: 'ShiftGiveUpRequest';
  type: ShiftChangeRequestType;
  requestedAt: Scalars['Date'];
  reason: ShiftGiveUpReason;
  note?: Maybe<Scalars['String']>;
};


export type ShiftProbation = {
  startsAt: Scalars['Date'];
  endsAt: Scalars['Date'];
  shiftAssignmentDisabled: Scalars['Boolean'];
  openShiftClaimDisabled: Scalars['Boolean'];
  totalEffectiveAbsences: Scalars['Int'];
};

export enum ShiftProbationFilterType {
  CURRENT = 'CURRENT',
  PENDING = 'PENDING'
}

export type ShiftSlot = {
  __typename: 'ShiftSlot';
  id?: Maybe<Scalars['ShiftSlotId']>;
  startsAt: Scalars['Date'];
  endsAt: Scalars['Date'];
  cancellationPenaltyStartsAt: Scalars['Date'];
  shiftsRequired: Scalars['Int'];
  availableUserCount: Scalars['Int'];
  eligibleUserCount: Scalars['Int'];
  claimedUserCount: Scalars['Int'];
  assignedUserCount: Scalars['Int'];
  state: ShiftSlotState;
  type: SchedulingType;
  availableUsers: Array<SchedulingUser>;
  eligibleUsers: Array<SchedulingUser>;
  assignedUsers: Array<SchedulingUser>;
  claimedByUsers: Array<SchedulingUser>;
  availableUsersIdentity: Array<SchedulingUserIdentity>;
  assignedUsersIdentity: Array<SchedulingUserIdentity>;
  claimedByUsersIdentity: Array<SchedulingUserIdentity>;
  eligibleUsersIdentity: Array<SchedulingUserIdentity>;
  shiftClaimedByCurrentUser?: Maybe<Shift>;
  shiftsWaitingTakeOver: Array<Shift>;
};

export type ShiftSlotDailyView = {
  __typename: 'ShiftSlotDailyView';
  date: Scalars['LocalDate'];
  orderedList: Array<ShiftSlot>;
  zoneId: Scalars['String'];
};

export type ShiftSlotDailyViewFilter = {
  zoneId: Scalars['String'];
  startDateInclusive: Scalars['LocalDate'];
  endDateExclusive: Scalars['LocalDate'];
  typeId: Scalars['SchedulingTypeId'];
};


export enum ShiftSlotState {
  SHIFTS_PROPOSED = 'SHIFTS_PROPOSED',
  SHIFTS_RESERVED = 'SHIFTS_RESERVED',
  SHIFTS_OPEN = 'SHIFTS_OPEN'
}

export type ShiftSlotUserDailyView = {
  __typename: 'ShiftSlotUserDailyView';
  date: Scalars['LocalDate'];
  orderedList: Array<ShiftSlotUserView>;
  zoneId: Scalars['String'];
};

export type ShiftSlotUserDailyViewFilter = {
  zoneId: Scalars['String'];
  startDateInclusive: Scalars['LocalDate'];
  endDateExclusive: Scalars['LocalDate'];
  userId: Scalars['AnyId'];
};

export type ShiftSlotUserView = {
  __typename: 'ShiftSlotUserView';
  id: Scalars['ShiftSlotUserViewId'];
  startsAt: Scalars['Date'];
  endsAt: Scalars['Date'];
  availability?: Maybe<SchedulingUserAvailability>;
  claimedSlots: Array<ShiftSlot>;
  claimableSlots: Array<ShiftSlot>;
};


export type ShiftSwapRequest = ShiftChangeRequest & {
  __typename: 'ShiftSwapRequest';
  type: ShiftChangeRequestType;
  requestedAt: Scalars['Date'];
  swapWith: Shift;
};

export type ShiftTeamDailyView = {
  __typename: 'ShiftTeamDailyView';
  date: Scalars['LocalDate'];
  orderedList: Array<ShiftTeamView>;
  zoneId: Scalars['String'];
};

export type ShiftTeamDailyViewFilter = {
  zoneId: Scalars['String'];
  startDateInclusive: Scalars['LocalDate'];
  endDateExclusive: Scalars['LocalDate'];
  teamId: Scalars['BusinessUserTeamId'];
  teamMemberId?: Maybe<Scalars['BusinessUserId']>;
  teamMemberIds?: Maybe<Array<Scalars['BusinessUserId']>>;
};

export type ShiftTeamView = {
  __typename: 'ShiftTeamView';
  /** This is an opaque token to be used as a cache key for this grouping of data; it has no meaning else wise */
  id: Scalars['String'];
  startsAt: Scalars['Date'];
  endsAt: Scalars['Date'];
  shifts: Array<Shift>;
};

export type ShiftTimeInterval = {
  __typename: 'ShiftTimeInterval';
  startsAt: Scalars['Date'];
  endsAt: Scalars['Date'];
};

export type ShiftTimeIntervalDailyView = {
  __typename: 'ShiftTimeIntervalDailyView';
  date: Scalars['LocalDate'];
  orderedList: Array<ShiftTimeInterval>;
  zoneId: Scalars['String'];
};

export type ShiftTimeIntervalDailyViewFilter = {
  zoneId: Scalars['String'];
  startDateInclusive: Scalars['LocalDate'];
  endDateExclusive: Scalars['LocalDate'];
  userId: Scalars['AnyId'];
};

export type ShipmentPricingModel = {
  __typename: 'ShipmentPricingModel';
  id: Scalars['ShipmentPricingModelId'];
  createdAt: Scalars['Date'];
  updatedAt: Scalars['Date'];
  createdBy: FulfillmentChannelWriter;
  updatedBy: FulfillmentChannelWriter;
  department: Department;
  tierType: ShipmentPricingTierType;
  regularOrderProcessingDays?: Maybe<Scalars['Int']>;
  customOrderProcessingDays?: Maybe<Scalars['Int']>;
  pricingOptions: Array<ShipmentPricingOption>;
};


export type ShipmentPricingModelPagination = {
  __typename: 'ShipmentPricingModelPagination';
  pricingModels: Array<ShipmentPricingModel>;
  count: Scalars['Long'];
};

export type ShipmentPricingModelQueryInput = {
  departmentIds?: Maybe<Array<Scalars['DepartmentId']>>;
  tierTypes?: Maybe<Array<ShipmentPricingTierType>>;
};

export type ShipmentPricingOption = {
  __typename: 'ShipmentPricingOption';
  minDeliveryDays: Scalars['Int'];
  maxDeliveryDays: Scalars['Int'];
  name: Scalars['String'];
  minOrderTotal?: Maybe<MonetaryAmount>;
  cost: MonetaryAmount;
};

export type ShipmentPricingOptionInput = {
  minDays: Scalars['Int'];
  maxDays: Scalars['Int'];
  name: Scalars['String'];
  minOrderTotal?: Maybe<MonetaryAmountInput>;
  cost: MonetaryAmountInput;
};

export enum ShipmentPricingTierType {
  WAREHOUSE = 'WAREHOUSE',
  TIER_ONE_PARTNER = 'TIER_ONE_PARTNER',
  TIER_TWO_PARTNER = 'TIER_TWO_PARTNER'
}

export type ShipmentTracking = {
  __typename: 'ShipmentTracking';
  trackingNumber: Scalars['String'];
  shippingCarrier: ShippingCarrier;
  status: ShippingStatus;
  estimatedDeliveryTime?: Maybe<Scalars['Date']>;
  trackingUrl?: Maybe<Scalars['String']>;
  deliveredAt?: Maybe<Scalars['Date']>;
  returnBefore?: Maybe<Scalars['Date']>;
};

export type ShipmentTrackingInput = {
  orderId: Scalars['OrderId'];
  orderLineItemId: Scalars['OrderLineItemId'];
  shippingCarrierId: Scalars['ShippingCarrierId'];
  trackingNumber: Scalars['String'];
  shippingStatus?: Maybe<ShippingStatus>;
  estimatedDeliveryTime?: Maybe<Scalars['Date']>;
};

export type ShipmentTrackingRemovedActivity = OrderActivityDetail & {
  __typename: 'ShipmentTrackingRemovedActivity';
  type: OrderActivityDetailType;
  removedBy?: Maybe<Operator>;
};

export type ShipmentTrackingUpdatedActivity = OrderActivityDetail & {
  __typename: 'ShipmentTrackingUpdatedActivity';
  type: OrderActivityDetailType;
  shippingCarrier: ShippingCarrier;
  trackingNumber: Scalars['String'];
  updatedBy?: Maybe<Operator>;
};

export type ShippingCarrier = {
  __typename: 'ShippingCarrier';
  id: Scalars['ShippingCarrierId'];
  code: Scalars['String'];
  displayName: Scalars['String'];
  trackingUpdateEnabled: Scalars['Boolean'];
};


export type ShippingGroup = {
  __typename: 'ShippingGroup';
  id: Scalars['ShippingGroupId'];
  orderLineItemIds: Array<Scalars['OrderLineItemId']>;
  shippingMethodAndCosts: Array<ShippingMethodCost>;
  tierType?: Maybe<ShipmentPricingTierType>;
};


export enum ShippingGroupStrategy {
  FEWEST_PACKAGES = 'FEWEST_PACKAGES',
  LEGACY = 'LEGACY'
}

export enum ShippingMethod {
  /** Standard ground (default) */
  STANDARD = 'STANDARD',
  /** Expedited shipping */
  EXPEDITED = 'EXPEDITED'
}

export type ShippingMethodCost = {
  __typename: 'ShippingMethodCost';
  shippingMethod: ShippingMethod;
  cost: MonetaryAmount;
  /**
   * Rough estimate of when the entire order will be delivered to the customer using this shipping method. If the order
   * isn't purchased yet, this will use the current time to compute the estimation.
   */
  estimatedToArriveAt: Scalars['Date'];
  deliveryTimeRange: DateRange;
  shippingOptionName: Scalars['String'];
};

export type ShippingOption = {
  __typename: 'ShippingOption';
  orderLineItemIds: Array<Scalars['OrderLineItemId']>;
  cost: MonetaryAmount;
  estimatedToArriveAt: Scalars['Date'];
  shippingOptionName: Scalars['String'];
  tierType?: Maybe<ShipmentPricingTierType>;
  shippingMethod: ShippingMethod;
  deliveryTimeRange: DateRange;
};

export type ShippingOptionInput = {
  shippingGroupId: Scalars['ShippingGroupId'];
  shippingOptionName: Scalars['String'];
};

export enum ShippingPolicy {
  NO_SHIPPING = 'NO_SHIPPING',
  FREE_SHIPPING = 'FREE_SHIPPING',
  PAID_BY_CUSTOMER = 'PAID_BY_CUSTOMER'
}

export enum ShippingStatus {
  UNKNOWN = 'UNKNOWN',
  IN_TRANSIT = 'IN_TRANSIT',
  DELIVERED = 'DELIVERED',
  FAILURE = 'FAILURE',
  RETURNED = 'RETURNED'
}

export type ShopifyExternalInventoryItemSource = ExternalInventoryItemSource & {
  __typename: 'ShopifyExternalInventoryItemSource';
  type: ExternalInventoryItemSourceType;
  productId: Scalars['String'];
  productVariantId: Scalars['String'];
  inventoryItemId: Scalars['String'];
};

export type ShopifyFulfillmentOrderSource = FulfillmentOrderSource & {
  __typename: 'ShopifyFulfillmentOrderSource';
  type: FulfillmentOrderSourceType;
  /** draft order id on Shopify */
  draftOrderId: Scalars['String'];
  /**
   * Shopify Order id, if the order was completed successfully.
   * when this value is present it indicates the start of the fulfillment process.
   */
  orderId?: Maybe<Scalars['String']>;
};

export type ShortenUrlInput = {
  url: Scalars['String'];
  preferredDomain?: Maybe<Scalars['String']>;
};

export type ShortenUrlPayload = {
  __typename: 'ShortenUrlPayload';
  url: Scalars['String'];
};

export type SideEffectPathEditorPayload = {
  pathEditorContext: PathEditorContext;
  errorMessage?: Maybe<Scalars['String']>;
  hasError: Scalars['Boolean'];
  sideEffect: PathEditorEditSideEffect;
};

export type SimilarSellablePayload = {
  __typename: 'SimilarSellablePayload';
  sellables?: Maybe<Array<Sellable>>;
};

export type SimpleCuratedOrder = {
  __typename: 'SimpleCuratedOrder';
  id: Scalars['SimpleCuratedOrderId'];
  curator: BusinessUser;
  curatedFor: User;
  order: Order;
  lead: Lead;
  type: SimpleCuratedOrderType;
  /** Expose id fields for trigger entity */
  curatorId: Scalars['BusinessUserId'];
  curatedForId: Scalars['UserId'];
  leadId: Scalars['LeadId'];
  orderId: Scalars['OrderId'];
  giftCardImageUrl: Scalars['String'];
};


export type SimpleCuratedOrderRichCard = MessageRichCard & {
  __typename: 'SimpleCuratedOrderRichCard';
  type: MessageRichCardType;
  simpleCuratedOrderId: Scalars['SimpleCuratedOrderId'];
};

export enum SimpleCuratedOrderType {
  EXPERT_CONSULTATION_FEE = 'EXPERT_CONSULTATION_FEE',
  GIFT_CARD = 'GIFT_CARD'
}

export type SingleCategoryGroupedBrandStatsAggregateExpertReport = {
  __typename: 'SingleCategoryGroupedBrandStatsAggregateExpertReport';
  id: Scalars['CategoryId'];
  category: Category;
  categoryStats: Array<BrandStatsAggregateExpertReport>;
};


export type SingleCategoryGroupedBrandStatsAggregateExpertReportCategoryStatsArgs = {
  limit?: Maybe<Scalars['Int']>;
};

export type SingleLocaleTemplateSet = {
  __typename: 'SingleLocaleTemplateSet';
  locale: Scalars['String'];
  templates: Array<ChannelTemplate>;
};

export type SkipFulfillmentChannelInput = {
  ticketId: Scalars['TicketId'];
  fulfillmentChannelId: Scalars['FulfillmentChannelId'];
  status: FulfillmentSuggestionStatus;
  note?: Maybe<Scalars['String']>;
};

export type SlackTemplate = ChannelTemplate & {
  __typename: 'SlackTemplate';
  channelType: ChannelType;
  body: Scalars['String'];
};

export type SlackTemplateInput = {
  body: Scalars['String'];
};

export type SlugAwarePathNodeFlowViewModel = {
  slug?: Maybe<Scalars['String']>;
};

export type SmsCapablePhoneNumberAttributeValidatorReference = AttributeValidatorReference & {
  __typename: 'SmsCapablePhoneNumberAttributeValidatorReference';
  id: Scalars['AttributeValidatorReferenceId'];
  type: AttributeValidatorType;
};

export type SmsCapablePhoneNumberAttributeValidatorReferenceInput = {
  _?: Maybe<Scalars['Boolean']>;
};

export type SmsTemplate = ChannelTemplate & {
  __typename: 'SmsTemplate';
  channelType: ChannelType;
  body: Scalars['String'];
};

export type SmsTemplateInput = {
  body: Scalars['String'];
};

export type SnoozeChangedActivity = LeadActivity & {
  __typename: 'SnoozeChangedActivity';
  id: Scalars['LeadActivityId'];
  type: LeadActivityType;
  lead: Lead;
  occurredAt: Scalars['Date'];
  oldSnooze?: Maybe<LeadSnooze>;
  newSnooze?: Maybe<LeadSnooze>;
  performedBy: Identity;
};

export type SnoozeSupportTaskActivity = SupportTaskActivity & {
  __typename: 'SnoozeSupportTaskActivity';
  id: Scalars['SupportTaskActivityId'];
  supportTask: SupportTask;
  action: SupportTaskAction;
  actor: SupportTaskActor;
  consumer: User;
  lead?: Maybe<Lead>;
  occurredAt: Scalars['Date'];
  wakeAt: Scalars['Date'];
};

export type SnoozeTicketInput = {
  ticketId: Scalars['TicketId'];
  snoozeDurationInHours: Scalars['Long'];
  comment?: Maybe<Scalars['String']>;
  reason?: Maybe<TicketSnoozeChangeReason>;
};

export type SocialMediaAccessToken = {
  __typename: 'SocialMediaAccessToken';
  socialMediaType: SocialMediaType;
  accessToken: Scalars['String'];
};

export type SocialMediaAccessTokenInput = {
  socialMediaType: SocialMediaType;
  accessToken: Scalars['String'];
};

export type SocialMediaLink = {
  __typename: 'SocialMediaLink';
  socialMediaType: SocialMediaType;
  url: Scalars['String'];
};

export enum SocialMediaType {
  FACEBOOK = 'FACEBOOK',
  TWITTER = 'TWITTER',
  LINKEDIN = 'LINKEDIN',
  INSTAGRAM = 'INSTAGRAM',
  PINTEREST = 'PINTEREST',
  YOUTUBE = 'YOUTUBE',
  STRAVA = 'STRAVA'
}

/** Common ordering context, each query should define its specific sortable fields as enums. */
export enum SortOrder {
  ASC = 'ASC',
  DESC = 'DESC'
}

export type SplitTriggerWaitEdgesInput = {
  triggerId: Scalars['TriggerId'];
  nodeId: Scalars['TriggerNodeId'];
};

export type StandardizedSellable = {
  __typename: 'StandardizedSellable';
  id: Scalars['StandardizedSellableId'];
  rawSellable: RawSellable;
  title?: Maybe<Scalars['String']>;
  description?: Maybe<Scalars['String']>;
  imageUrls: Array<Scalars['String']>;
  attributes: Array<Attribute>;
  rawAttributes: Array<RawAttribute>;
  attributeVariationDimensions: Array<Scalars['String']>;
  brand?: Maybe<Brand>;
  category: Category;
  titleVariationDimension: Scalars['Boolean'];
  gtin?: Maybe<Scalars['String']>;
  mpn?: Maybe<Scalars['String']>;
  originalPrice?: Maybe<MonetaryAmount>;
  salePrice?: Maybe<MonetaryAmount>;
  state: StandardizedSellableState;
  preOrderPermitted: Scalars['Boolean'];
  estimatedAvailableAt?: Maybe<Scalars['Date']>;
};

export type StandardizedSellableGroup = {
  __typename: 'StandardizedSellableGroup';
  id: Scalars['StandardizedSellableGroupId'];
  standardizedSellableScores: Array<StandardizedSellableScore>;
  state: StandardizedSellableGroupState;
  mergedInto?: Maybe<StandardizedSellableGroup>;
};

export type StandardizedSellableGroupCandidate = {
  __typename: 'StandardizedSellableGroupCandidate';
  id: Scalars['StandardizedSellableGroupCandidateId'];
  candidateStandardizedSellable: StandardizedSellable;
  group: StandardizedSellableGroup;
  state: StandardizedSellableGroupCandidateState;
  category: Category;
  brand?: Maybe<Brand>;
  reviewedBy?: Maybe<Identity>;
};


export type StandardizedSellableGroupCandidateQuery = {
  candidateIds?: Maybe<Array<Scalars['StandardizedSellableId']>>;
  groupIds?: Maybe<Array<Scalars['StandardizedSellableGroupId']>>;
  categoryIds?: Maybe<Array<Scalars['CategoryId']>>;
  brandIds?: Maybe<Array<Scalars['BrandId']>>;
  states?: Maybe<Array<StandardizedSellableGroupCandidateState>>;
};

export enum StandardizedSellableGroupCandidateState {
  PENDING = 'PENDING',
  ACCEPTED = 'ACCEPTED',
  REJECTED = 'REJECTED'
}


export type StandardizedSellableGroupQuery = {
  states?: Maybe<Array<StandardizedSellableGroupState>>;
  standardizedSellableIds?: Maybe<Array<Scalars['StandardizedSellableId']>>;
  dirty?: Maybe<Scalars['Boolean']>;
};

export enum StandardizedSellableGroupState {
  ACTIVE = 'ACTIVE',
  INACTIVE = 'INACTIVE'
}


export type StandardizedSellableQuery = {
  rawSellableIds?: Maybe<Array<Scalars['RawSellableId']>>;
  sourceIds?: Maybe<Array<Scalars['RawSellableSourceId']>>;
  variationGroups?: Maybe<Array<RawSellableVariationGroupInput>>;
  states?: Maybe<Array<StandardizedSellableState>>;
};

export type StandardizedSellableScore = {
  __typename: 'StandardizedSellableScore';
  standardizedSellable: StandardizedSellable;
  score: Scalars['Float'];
};

export enum StandardizedSellableState {
  ACTIVE = 'ACTIVE',
  INACTIVE = 'INACTIVE'
}

export type StandardReturnPolicy = ReturnPolicy & {
  __typename: 'StandardReturnPolicy';
  type: ReturnPolicyType;
  returnWithinDays: Scalars['Int'];
  returnShippingPaidBy: ReturnShippingPaidBy;
  refundMethod: ReturnRefundMethod;
};

/** Star rating UI */
export type StarRatingNumericRenderingStylePathQuestionPathNodeFlowViewModel = {
  __typename: 'StarRatingNumericRenderingStylePathQuestionPathNodeFlowViewModel';
  maxRating: Scalars['Int'];
};

export type StarRatingNumericRenderingStylePathQuestionSchemaUpsertEditorCommandInput = {
  maxRating?: Maybe<Scalars['Int']>;
};

export type StartEscalationInput = {
  escalationId: Scalars['OrderEscalationId'];
  assignedToId?: Maybe<Scalars['OperatorId']>;
};

export type StartExpertConsumerConversationInput = {
  consumerId: Scalars['UserId'];
  expertId: Scalars['BusinessUserId'];
  sourceFlow?: Maybe<StartExpertConsumerConversationSourceFlowInput>;
  sourcePage?: Maybe<StartExpertConsumerConversationSourcePageInput>;
  setActive?: Maybe<Scalars['Boolean']>;
};

export type StartExpertConsumerConversationPayload = {
  __typename: 'StartExpertConsumerConversationPayload';
  lead?: Maybe<Lead>;
  conversation?: Maybe<Conversation>;
  error?: Maybe<Scalars['String']>;
};

export type StartExpertConsumerConversationSourceFlowInput = {
  conversationStarterFlow?: Maybe<LeadSourceConversationStarterFlowInput>;
  directExpertChatFlow?: Maybe<LeadSourceDirectExpertChatFlowInput>;
};

export type StartExpertConsumerConversationSourcePageInput = {
  expertProfilePage?: Maybe<LeadSourceExpertProfilePageInput>;
  sellablePage?: Maybe<LeadSourceSellablePageInput>;
  departmentPage?: Maybe<LeadSourceDepartmentPageInput>;
  sellableSearchPage?: Maybe<LeadSourceSellableSearchPageInput>;
  sellableTopListPage?: Maybe<LeadSourceSellableTopListPageInput>;
};

export type StartExpertRatingInput = {
  expertId: Scalars['BusinessUserId'];
  expertStartRating?: Maybe<Scalars['Int']>;
};

export type StartExpertRatingPayload = {
  __typename: 'StartExpertRatingPayload';
  expert: BusinessUser;
  flow?: Maybe<PathFlow>;
  errors?: Maybe<Array<PathValidationError>>;
};

export type StartExpertShiftInput = {
  id: Scalars['BusinessUserId'];
};

export type StartExpertStandbyInput = {
  id: Scalars['BusinessUserId'];
  duration: DurationInput;
};

export type StartGuestConversationInput = {
  expertId: Scalars['BusinessUserId'];
};

export type StartGuestConversationPayload = {
  __typename: 'StartGuestConversationPayload';
  conversation: GuestConversation;
};

export type StartLeadEscalationInput = {
  type: LeadEscalationType;
  acceptAsLeadExpertRole: LeadExpertRole;
  leadId: Scalars['LeadId'];
};

export type StartLeadEscalationPayload = {
  __typename: 'StartLeadEscalationPayload';
  escalation: LeadEscalation;
};

export type StartOnCallActivity = BusinessUserActivity & {
  __typename: 'StartOnCallActivity';
  id: Scalars['BusinessUserActivityId'];
  type: BusinessUserActivityType;
  occurredAt: Scalars['Date'];
};

export type StartOnCallShiftInput = {
  id: Scalars['BusinessUserId'];
};

export type StartPathNodeConfig = PathNodeConfig & {
  __typename: 'StartPathNodeConfig';
  configType: PathNodeConfigType;
};

export type StartRawSellableSourceIngestionInput = {
  sourceId: Scalars['RawSellableSourceId'];
};

export type StartRawSellableSourceIngestionPayload = {
  __typename: 'StartRawSellableSourceIngestionPayload';
  hasError: Scalars['Boolean'];
  errors?: Maybe<Array<Scalars['String']>>;
};

export type StartRawSellableStandardizationInput = {
  query: RawSellableQuery;
};

export type StartRawSellableStandardizationPayload = {
  __typename: 'StartRawSellableStandardizationPayload';
  count: Scalars['Long'];
};

export type StartReceivingLeadsActivity = BusinessUserActivity & {
  __typename: 'StartReceivingLeadsActivity';
  id: Scalars['BusinessUserActivityId'];
  type: BusinessUserActivityType;
  occurredAt: Scalars['Date'];
};

export type StartRefundProcessInput = {
  ticketId: Scalars['TicketId'];
  requestOrderRefundInput: RequestOrderRefundInput;
};

export type StartSmsPromotionRegistrationInput = {
  startPage: Scalars['String'];
  categoryId: Scalars['CategoryId'];
};

export type StartSmsPromotionRegistrationPayload = {
  __typename: 'StartSmsPromotionRegistrationPayload';
  registrationId: Scalars['String'];
  smsText: Scalars['String'];
  smsNumber: Scalars['String'];
};

export type StartStandardizationSellableMatchingInput = {
  query: StandardizedSellableQuery;
};

export type StartStandardizationSellableMatchingPayload = {
  __typename: 'StartStandardizationSellableMatchingPayload';
  count: Scalars['Long'];
};

export type StartStandardizedSellableGroupIngestionInput = {
  query: StandardizedSellableGroupQuery;
};

export type StartStandardizedSellableGroupIngestionPayload = {
  __typename: 'StartStandardizedSellableGroupIngestionPayload';
  hasError: Scalars['Boolean'];
  errors?: Maybe<Array<Scalars['String']>>;
};

export type StartSupportConversationInput = {
  consumerId: Scalars['UserId'];
};

export type StartSystemCuratedItemSurveyPayload = {
  __typename: 'StartSystemCuratedItemSurveyPayload';
  data?: Maybe<SystemCuratedItemSurvey>;
  error?: Maybe<Scalars['String']>;
};

export type StopOnCallActivity = BusinessUserActivity & {
  __typename: 'StopOnCallActivity';
  id: Scalars['BusinessUserActivityId'];
  type: BusinessUserActivityType;
  occurredAt: Scalars['Date'];
};

export type StopReceivingLeadsActivity = BusinessUserActivity & {
  __typename: 'StopReceivingLeadsActivity';
  id: Scalars['BusinessUserActivityId'];
  type: BusinessUserActivityType;
  occurredAt: Scalars['Date'];
};

export type StringBinaryConditionDefinition = ConditionDefinition & {
  __typename: 'StringBinaryConditionDefinition';
  type: ConditionType;
  attributeName: Scalars['String'];
  operator: StringBinaryConditionDefinitionOperator;
  attributeValues: Array<Scalars['String']>;
};

export type StringBinaryConditionDefinitionInput = {
  attributeName: Scalars['String'];
  operator: StringBinaryConditionDefinitionOperator;
  attributeValues: Array<Scalars['String']>;
};

export enum StringBinaryConditionDefinitionOperator {
  IN = 'IN',
  NOT_IN = 'NOT_IN',
  EXISTS = 'EXISTS',
  NOT_EXISTS = 'NOT_EXISTS'
}

export enum StringFieldType {
  EMAIL_ADDRESS = 'EMAIL_ADDRESS',
  SMS_NUMBER = 'SMS_NUMBER',
  DURATION = 'DURATION',
  JSON = 'JSON'
}

export type StripeAccount = PaymentProcessorAccount & {
  __typename: 'StripeAccount';
  id: Scalars['PaymentProcessorAccountId'];
  createdAt: Scalars['Date'];
  updatedAt: Scalars['Date'];
  type: PaymentProcessorType;
  userId: Scalars['UserId'];
  paymentSources?: Maybe<Array<PaymentSource>>;
  externalAccountId?: Maybe<Scalars['String']>;
  name?: Maybe<Scalars['String']>;
  description?: Maybe<Scalars['String']>;
  email?: Maybe<Scalars['String']>;
};

export type StripeAddress = {
  __typename: 'StripeAddress';
  line1?: Maybe<Scalars['String']>;
  line2?: Maybe<Scalars['String']>;
  city?: Maybe<Scalars['String']>;
  state?: Maybe<Scalars['String']>;
  country?: Maybe<Scalars['String']>;
  postalCode: Scalars['String'];
};

export enum StripeAuthenticationFlow {
  REDIRECT = 'redirect',
  RECEIVER = 'receiver',
  CODE_VERIFICATION = 'code_verification',
  NONE = 'none'
}

export type StripeCodeVerification = {
  __typename: 'StripeCodeVerification';
  /** The number of attempts remaining to authenticate the source object with a verification code. */
  attemptsRemaining?: Maybe<Scalars['Int']>;
  status?: Maybe<StripeCodeVerificationStatus>;
};

export enum StripeCodeVerificationStatus {
  PENDING = 'pending',
  AWAITING_VERIFICATION = 'awaiting_verification',
  SUCCEEDED = 'succeeded',
  FAILED = 'failed'
}

export type StripeOwner = {
  __typename: 'StripeOwner';
  address?: Maybe<StripeAddress>;
  email?: Maybe<Scalars['String']>;
  name?: Maybe<Scalars['String']>;
  phone?: Maybe<Scalars['String']>;
  verifiedAddress?: Maybe<StripeAddress>;
  verifiedEmail?: Maybe<Scalars['String']>;
  verifiedName?: Maybe<Scalars['String']>;
  verifiedPhone?: Maybe<Scalars['String']>;
};

export type StripePaymentSource = PaymentSource & {
  __typename: 'StripePaymentSource';
  id: Scalars['PaymentSourceId'];
  createdAt: Scalars['Date'];
  updatedAt: Scalars['Date'];
  externalSourceId: Scalars['String'];
  type: PaymentProcessorType;
  usage: PaymentSourceUsage;
  status: PaymentSourceStatus;
  userId: Scalars['UserId'];
  billingAddress?: Maybe<Address>;
  paymentEntity: PaymentEntity;
  isDefault: Scalars['Boolean'];
  /**
   * Stripe specific attributes
   * The client secret of the source. Used for client-side retrieval using a publishable key.
   */
  clientSecret?: Maybe<Scalars['String']>;
  authenticationFlow?: Maybe<StripeAuthenticationFlow>;
  codeVerification?: Maybe<StripeCodeVerification>;
  /** Flag indicating whether the object exists in live mode or test mode. */
  liveMode?: Maybe<Scalars['Boolean']>;
  owner?: Maybe<StripeOwner>;
};

export type StripeRequiredPaymentAction = PaymentAction & {
  __typename: 'StripeRequiredPaymentAction';
  type: PaymentActionType;
  /**
   * client secret for the payment intent, used by client side API to call stripe.confirmCardPayment or stripe.handleCardAction
   * to handle any required action, such as 3d secure authentication.
   */
  clientSecret: Scalars['String'];
};

export type StripeRequiredSetupAction = PaymentAction & {
  __typename: 'StripeRequiredSetupAction';
  type: PaymentActionType;
  /**
   * client secret for the payment intent, used by client side API to call stripe.confirmCardPayment or stripe.handleCardAction
   * to handle any required action, such as 3d secure authentication.
   */
  clientSecret: Scalars['String'];
};

export type SubjectIdInConditionDefinition = ConditionDefinition & {
  __typename: 'SubjectIdInConditionDefinition';
  type: ConditionType;
  subjectIds: Array<Scalars['String']>;
};

export type SubjectIdInConditionDefinitionInput = {
  subjectIds: Array<Scalars['String']>;
};

export type SubmitDatePathFlowQuestionInput = {
  pathFlowId: Scalars['PathFlowId'];
  questionName: Scalars['String'];
  value?: Maybe<Scalars['Date']>;
};

export type SubmitDatePathFlowQuestionInputTypeCopy = {
  __typename: 'SubmitDatePathFlowQuestionInputTypeCopy';
  value?: Maybe<Scalars['Date']>;
};

export type SubmitDatePathFlowQuestionPayload = {
  __typename: 'SubmitDatePathFlowQuestionPayload';
  flow?: Maybe<PathFlow>;
  errors?: Maybe<Array<PathValidationError>>;
};

export type SubmitDateRangePathFlowQuestionInput = {
  pathFlowId: Scalars['PathFlowId'];
  questionName: Scalars['String'];
  startValue?: Maybe<Scalars['Date']>;
  endValue?: Maybe<Scalars['Date']>;
};

export type SubmitDateRangePathFlowQuestionInputTypeCopy = {
  __typename: 'SubmitDateRangePathFlowQuestionInputTypeCopy';
  startValue?: Maybe<Scalars['Date']>;
  endValue?: Maybe<Scalars['Date']>;
};

export type SubmitDateRangePathFlowQuestionPayload = {
  __typename: 'SubmitDateRangePathFlowQuestionPayload';
  flow?: Maybe<PathFlow>;
  errors?: Maybe<Array<PathValidationError>>;
};

export type SubmitExpertHiringFeedbackInput = {
  applicationId: Scalars['ExpertApplicationId'];
  applicationEvaluation?: Maybe<ExpertApplicationEvaluationInput>;
  interviewFeedback?: Maybe<ExpertInterviewFeedbackInput>;
  applicationRating?: Maybe<ExpertApplicationRatingInput>;
};

export type SubmitExpertHiringFeedbackPayload = {
  __typename: 'SubmitExpertHiringFeedbackPayload';
  error?: Maybe<Scalars['String']>;
  application?: Maybe<ExpertApplication>;
};

export type SubmitForReviewApprovalRequestActivityEntryDetail = ApprovalRequestActivityEntryDetail & {
  __typename: 'SubmitForReviewApprovalRequestActivityEntryDetail';
  entryType: ApprovalRequestActivityEntryType;
  description?: Maybe<Scalars['String']>;
  entity?: Maybe<ApprovalRequestEntity>;
  dependencies: Array<ApprovalRequest>;
};

export type SubmitForReviewInApprovalRequestInput = {
  submitDraftId: Scalars['ApprovalRequestSubmitDraftId'];
};

export type SubmitForReviewInApprovalRequestPayload = {
  __typename: 'SubmitForReviewInApprovalRequestPayload';
  approvalRequest?: Maybe<ApprovalRequest>;
  error?: Maybe<ApprovalRequestCreationError>;
};

export type SubmitIdPathFlowQuestionInput = {
  pathFlowId: Scalars['PathFlowId'];
  questionName: Scalars['String'];
  value?: Maybe<Array<Scalars['AnyId']>>;
};

export type SubmitIdPathFlowQuestionInputTypeCopy = {
  __typename: 'SubmitIdPathFlowQuestionInputTypeCopy';
  value: Array<Scalars['AnyId']>;
};

export type SubmitIdPathFlowQuestionPayload = {
  __typename: 'SubmitIdPathFlowQuestionPayload';
  flow?: Maybe<PathFlow>;
  errors?: Maybe<Array<PathValidationError>>;
};

export type SubmitInputTextPathFlowQuestionInput = {
  pathFlowId: Scalars['PathFlowId'];
  questionName: Scalars['String'];
  value?: Maybe<Scalars['String']>;
};

/** Identical to SubmitInputTextPathFlowQuestionInput used to include in output schemas */
export type SubmitInputTextPathFlowQuestionInputTypeCopy = {
  __typename: 'SubmitInputTextPathFlowQuestionInputTypeCopy';
  /** Same fields as SubmitInputTextPathFlowQuestionInput */
  value?: Maybe<Scalars['String']>;
};

export type SubmitInputTextPathFlowQuestionPayload = {
  __typename: 'SubmitInputTextPathFlowQuestionPayload';
  flow?: Maybe<PathFlow>;
  errors?: Maybe<Array<PathValidationError>>;
};

export type SubmitInterstitialPathNodeFlowInputCommandInput = {
  _?: Maybe<Scalars['Boolean']>;
};

export type SubmitListPathFlowQuestionInput = {
  pathFlowId: Scalars['PathFlowId'];
  questionName: Scalars['String'];
  /**
   * If values were selected, specify them here.
   * Note that this is called value and not values to be consistent with other question inputs
   */
  value?: Maybe<Array<Scalars['String']>>;
  /**
   * If other was filled out, specify the input here.
   * Note that values and other are mutually exclusive - only one should be filled out.
   */
  other?: Maybe<Scalars['String']>;
};

/** Identical to SubmitListPathFlowQuestionInput used to include in output schemas */
export type SubmitListPathFlowQuestionInputTypeCopy = {
  __typename: 'SubmitListPathFlowQuestionInputTypeCopy';
  /**
   * If values were selected, specify them here.
   * Note that this is called value and not values to be consistent with other question inputs
   */
  value?: Maybe<Array<Scalars['String']>>;
  /**
   * If other was filled out, specify the input here.
   * Note that values and other are mutually exclusive - only one should be filled out.
   */
  other?: Maybe<Scalars['String']>;
};

export type SubmitListPathFlowQuestionPayload = {
  __typename: 'SubmitListPathFlowQuestionPayload';
  flow?: Maybe<PathFlow>;
  errors?: Maybe<Array<PathValidationError>>;
};

export type SubmitNumericPathFlowQuestionInput = {
  pathFlowId: Scalars['PathFlowId'];
  questionName: Scalars['String'];
  value?: Maybe<Scalars['Int']>;
};

export type SubmitNumericPathFlowQuestionInputTypeCopy = {
  __typename: 'SubmitNumericPathFlowQuestionInputTypeCopy';
  value?: Maybe<Scalars['Int']>;
  decimalValue?: Maybe<Scalars['BigDecimal']>;
};

export type SubmitNumericPathFlowQuestionPayload = {
  __typename: 'SubmitNumericPathFlowQuestionPayload';
  flow?: Maybe<PathFlow>;
  errors?: Maybe<Array<PathValidationError>>;
};

export type SubmitOAuthEmailPathFlowQuestionInput = {
  pathFlowId: Scalars['PathFlowId'];
  questionName: Scalars['String'];
  firstName?: Maybe<Scalars['String']>;
  lastName?: Maybe<Scalars['String']>;
  email: Scalars['String'];
  googleIdToken?: Maybe<Scalars['String']>;
  facebookUserAccessToken?: Maybe<Scalars['String']>;
  skipFirstName?: Maybe<Scalars['String']>;
  skipLastName?: Maybe<Scalars['String']>;
};

export type SubmitOAuthEmailPathFlowQuestionInputTypeCopy = {
  __typename: 'SubmitOAuthEmailPathFlowQuestionInputTypeCopy';
  firstName?: Maybe<Scalars['String']>;
  lastName?: Maybe<Scalars['String']>;
  email?: Maybe<Scalars['String']>;
  googleIdToken?: Maybe<Scalars['String']>;
  facebookUserAccessToken?: Maybe<Scalars['String']>;
  skipFirstName?: Maybe<Scalars['String']>;
  skipLastName?: Maybe<Scalars['String']>;
};

export type SubmitOAuthEmailPathFlowQuestionPayload = {
  __typename: 'SubmitOAuthEmailPathFlowQuestionPayload';
  flow?: Maybe<PathFlow>;
  errors?: Maybe<Array<PathValidationError>>;
};

export type SubmitOrderInput = {
  orderId: Scalars['OrderId'];
  paymentSourceId: Scalars['PaymentSourceId'];
};

export type SubmitOrderPayload = {
  __typename: 'SubmitOrderPayload';
  order: Order;
  hasError: Scalars['Boolean'];
  errorMessage?: Maybe<Scalars['String']>;
};

export type SubmitPathFlowPageInput = {
  pathFlowId: Scalars['PathFlowId'];
  pageName: Scalars['String'];
};

export type SubmitPathFlowPagePayload = EncodedAuthenticationTokensPayload & {
  __typename: 'SubmitPathFlowPagePayload';
  flow?: Maybe<PathFlow>;
  errors?: Maybe<Array<PathValidationError>>;
  /** If a new user is registered as part of this path flow page submit */
  newUserRegistered: Scalars['Boolean'];
  /** If a new deal request is created as part of this path flow page submit */
  newRequestCreated: Scalars['Boolean'];
  encodedAuthenticationTokens?: Maybe<EncodedAuthenticationTokens>;
};

export type SubmitPathNodeFlowInputCommandsInput = {
  id: Scalars['PathGraphFlowId'];
  commands: Array<PathNodeFlowInputCommandInput>;
};

export type SubmitPathNodeFlowInputCommandsPayload = EncodedAuthenticationTokensPayload & {
  __typename: 'SubmitPathNodeFlowInputCommandsPayload';
  pathGraphFlow?: Maybe<PathGraphFlow>;
  encodedAuthenticationTokens?: Maybe<EncodedAuthenticationTokens>;
  error?: Maybe<NavigatePathGraphFlowError>;
};

export type SubmitQuestionsPathNodeFlowInputCommandInput = {
  _?: Maybe<Scalars['Boolean']>;
};

export type SubmitUserContactPathFlowQuestionInput = {
  pathFlowId: Scalars['PathFlowId'];
  questionName: Scalars['String'];
  firstName: Scalars['String'];
  lastName: Scalars['String'];
  phoneNumber: Scalars['String'];
};

export type SubmitUserContactPathFlowQuestionInputTypeCopy = {
  __typename: 'SubmitUserContactPathFlowQuestionInputTypeCopy';
  firstName?: Maybe<Scalars['String']>;
  lastName?: Maybe<Scalars['String']>;
  phoneNumber?: Maybe<Scalars['String']>;
};

export type SubmitUserContactPathFlowQuestionPayload = {
  __typename: 'SubmitUserContactPathFlowQuestionPayload';
  flow?: Maybe<PathFlow>;
  errors?: Maybe<Array<PathValidationError>>;
};

export type Subscription = {
  __typename: 'Subscription';
  ringingCallCountChanged: RingingCallCountChange;
  /**
   * Updates when the user's order in CART status has line items that change (item added, removed, or quantity changes),
   * or the cart is replaced (user purchases previous cart and a new cart is generated). Intended for use cases like
   * keeping the items in cart badge updated.
   * If `userId` is omitted, it will use the current viewer (assumed to be a user)
   */
  userCartLineItemsChanged: Order;
  expertApplicationsPendingReviewChanged: ExpertApplicationSubscriptionChange;
  expertApplicationsPendingReviewCountChanged: Scalars['Int'];
  expertApplicationFolderChanged: ExpertApplicationFolder;
  expertApplicationFolderItemChanged: ExpertApplicationFolderItemChange;
  expertNotification: ExpertNotification;
  expertCapacityLimitReached: Scalars['Boolean'];
  expertNewLeadEligibilityChanged: ExpertLeadEligibilityChange;
  expertLeadFolderChanged: ExpertLeadFolder;
  expertLeadFolderItemChanged: ExpertLeadFolderItemChange;
  leadEscalationChanged: LeadEscalation;
  openLeadEscalationCountChanged: OpenLeadEscalationCountChange;
  expertLeadIntentChanged: LeadIntentChange;
  leadChanged: Lead;
  attentionNeededLeadChanged: AttentionNeededLeadChanged;
  attentionNeededLeadCountChanged: AttentionNeededLeadCountChanged;
  heartbeat: Scalars['Boolean'];
  /**
   * Consumer API; subscription version of the read query `expertCuratedOrder` that broadcasts changes to the curated
   * order, except for changes while the curated order is in draft state.
   */
  expertCuratedOrderChanged: ExpertCuratedOrderChangedPayload;
  /**
   * Consumer API; subscription version of the read query `expertCuratedOrdersForLeadConnection` that broadcasts changes
   * when any curated order associated with the queried lead changes state, except for curated orders in draft state.
   */
  expertCuratedOrdersForLeadConnectionChanged: ExpertCuratedOrdersForLeadConnectionChangedPayload;
  /**
   * Subscription that emits changes when a expert curated item is modified (excluding draft modifications/creations),
   * and when the consumer's active cart is modified. This makes it possible to get an up to date view on both the
   * active curated items (e.g.: pick up changes if the consumer dismisses an item), as well as cart updates the user
   * makes (allows experts to dynamically refresh the `lineItemInCart` property).
   */
  expertCuratedItemsByCategoryChanged: ExpertCuratedItemsByCategoryChangedPayload;
  expertCuratedItemsChanged: ExpertCuratedItemsChangedPayload;
  leadActivityOccurred: LeadActivity;
  supportTaskOperatorFolderChanged: SupportTaskFolderEvent;
  supportTaskOperatorFolderListChanged: SupportTaskListEvent;
  newEscalationCount: NewOrderEscalationNotification;
  escalationFacetCounts: EscalationFacetCountsPayload;
  orderEscalationCreated: OrderEscalation;
  supportConversationsCount: SupportConversationCountNotification;
};


export type SubscriptionRingingCallCountChangedArgs = {
  callingFor: Array<Scalars['AnyId']>;
};


export type SubscriptionUserCartLineItemsChangedArgs = {
  userId?: Maybe<Scalars['UserId']>;
};


export type SubscriptionExpertApplicationFolderChangedArgs = {
  expertHiringFlowId?: Maybe<Scalars['ExpertHiringFlowId']>;
  departmentId?: Maybe<Scalars['DepartmentId']>;
  approvedById?: Maybe<Scalars['OperatorId']>;
};


export type SubscriptionExpertApplicationFolderItemChangedArgs = {
  expertHiringFlowId?: Maybe<Scalars['ExpertHiringFlowId']>;
  departmentId?: Maybe<Scalars['DepartmentId']>;
  approvedById?: Maybe<Scalars['OperatorId']>;
  folderSlug: Scalars['String'];
};


export type SubscriptionExpertNotificationArgs = {
  expertId: Scalars['BusinessUserId'];
};


export type SubscriptionExpertCapacityLimitReachedArgs = {
  expertId: Scalars['BusinessUserId'];
};


export type SubscriptionExpertNewLeadEligibilityChangedArgs = {
  expertId: Scalars['BusinessUserId'];
};


export type SubscriptionExpertLeadFolderChangedArgs = {
  expertId?: Maybe<Scalars['BusinessUserId']>;
  expertTeamId?: Maybe<Scalars['BusinessUserTeamId']>;
};


export type SubscriptionExpertLeadFolderItemChangedArgs = {
  expertId?: Maybe<Scalars['BusinessUserId']>;
  expertTeamId?: Maybe<Scalars['BusinessUserTeamId']>;
  folderSlug: Scalars['String'];
};


export type SubscriptionLeadEscalationChangedArgs = {
  id: Scalars['LeadEscalationId'];
};


export type SubscriptionOpenLeadEscalationCountChangedArgs = {
  expertId: Scalars['BusinessUserId'];
  expertRole?: Maybe<LeadExpertRole>;
};


export type SubscriptionExpertLeadIntentChangedArgs = {
  expertId: Scalars['BusinessUserId'];
};


export type SubscriptionLeadChangedArgs = {
  leadId: Scalars['LeadId'];
};


export type SubscriptionAttentionNeededLeadChangedArgs = {
  expertId: Scalars['BusinessUserId'];
};


export type SubscriptionAttentionNeededLeadCountChangedArgs = {
  expertId: Scalars['BusinessUserId'];
};


export type SubscriptionExpertCuratedOrderChangedArgs = {
  id: Scalars['ExpertCuratedOrderId'];
};


export type SubscriptionExpertCuratedOrdersForLeadConnectionChangedArgs = {
  query: ExpertCuratedOrdersForLeadQueryInput;
  first?: Maybe<Scalars['Int']>;
};


export type SubscriptionExpertCuratedItemsByCategoryChangedArgs = {
  leadId: Scalars['LeadId'];
};


export type SubscriptionExpertCuratedItemsChangedArgs = {
  leadId: Scalars['LeadId'];
};


export type SubscriptionLeadActivityOccurredArgs = {
  expertId: Scalars['BusinessUserId'];
  types: Array<LeadActivityType>;
  teamActivityTypes?: Maybe<Array<LeadActivityType>>;
};


export type SubscriptionSupportTaskOperatorFolderChangedArgs = {
  operatorId: Scalars['OperatorId'];
  supportTaskType: SupportTaskType;
};


export type SubscriptionSupportTaskOperatorFolderListChangedArgs = {
  operatorId: Scalars['OperatorId'];
  supportTaskType: SupportTaskType;
  folderSlug: Scalars['String'];
};


export type SubscriptionEscalationFacetCountsArgs = {
  searchQuery: OrderEscalationSearchInput;
  facetNames: Array<Maybe<Scalars['String']>>;
};


export type SubscriptionSupportConversationsCountArgs = {
  query?: Maybe<SupportConversationQueryInput>;
};

export type SuggestedAction = {
  __typename: 'SuggestedAction';
  type: SuggestedActionType;
  headline: Scalars['String'];
  reason: Scalars['String'];
  suggestedMessage?: Maybe<Scalars['String']>;
  urgent: Scalars['Boolean'];
};

export enum SuggestedActionType {
  SEND_INITIAL_RESPONSE = 'SEND_INITIAL_RESPONSE',
  RESPOND_TO_NEW_MESSAGE = 'RESPOND_TO_NEW_MESSAGE',
  FOLLOW_UP = 'FOLLOW_UP',
  SNOOZE = 'SNOOZE',
  STAR = 'STAR',
  ARCHIVE = 'ARCHIVE',
  REQUEST_EXPERT_REVIEW = 'REQUEST_EXPERT_REVIEW',
  REQUEST_EXPERT_REFERRAL = 'REQUEST_EXPERT_REFERRAL',
  SEND_CURATION = 'SEND_CURATION',
  CLASSIFY_ARCHIVED_LEAD = 'CLASSIFY_ARCHIVED_LEAD',
  REVIEW_SURVEY = 'REVIEW_SURVEY',
  FULFILL_PROMISE = 'FULFILL_PROMISE',
  CURATION_VIEWED_FOLLOW_UP = 'CURATION_VIEWED_FOLLOW_UP',
  SELLABLE_VIEWED_FOLLOW_UP = 'SELLABLE_VIEWED_FOLLOW_UP',
  PRODUCT_ADDED_TO_CART_FOLLOW_UP = 'PRODUCT_ADDED_TO_CART_FOLLOW_UP',
  ORDER_CANCELLATION = 'ORDER_CANCELLATION',
  ORDER_RETURN = 'ORDER_RETURN',
  ORDER_EXCHANGE = 'ORDER_EXCHANGE',
  ORDER_ITEM_UNAVAILABLE = 'ORDER_ITEM_UNAVAILABLE',
  VIEW_TICKET_UPDATE = 'VIEW_TICKET_UPDATE'
}

export type SuggestedAlternativeSellable = {
  __typename: 'SuggestedAlternativeSellable';
  id: Scalars['SuggestedAlternativeSellableId'];
  originalSellable: Sellable;
  suggestedSellable: Sellable;
  /** Lead for whom this suggestion was made */
  lead: Lead;
  mostPopularTag?: Maybe<ExpertCuratedItemTag>;
  /** review details if this item has been reviewed by an expert */
  expertReview?: Maybe<SuggestedSellableExpertReview>;
};

export type SuggestedAlternativeSellableConnection = {
  __typename: 'SuggestedAlternativeSellableConnection';
  pageInfo: PageInfo;
  edges: Array<SuggestedAlternativeSellableEdge>;
};

export type SuggestedAlternativeSellableEdge = {
  __typename: 'SuggestedAlternativeSellableEdge';
  cursor: Scalars['String'];
  node: SuggestedAlternativeSellable;
};


export type SuggestedAlternativeSellableInput = {
  /** Sellables for which suggestions are being requested. */
  sellableIds: Array<Scalars['SellableId']>;
  /** if set and there are curations for the sellable with tags, return the most popular tag */
  includeCuratedItemTag?: Maybe<Scalars['Boolean']>;
  /** Explicit filters for the results. */
  filters: Array<SuggestedSellableFilter>;
  /** lead for whom the recommendations will be created */
  leadId: Scalars['LeadId'];
};

export type SuggestedAlternativeSellableSearchInput = {
  /** Sellables for which suggestions are being requested. */
  sellableIds: Array<Scalars['SellableId']>;
  /** Any Explicit filters for the results. */
  filters: Array<SuggestedSellableFilter>;
};

export type SuggestedExpertCuratedItems = {
  __typename: 'SuggestedExpertCuratedItems';
  /** The suggested ExpertCuratedItem */
  expertCuratedItems: Array<ExpertCuratedItem>;
  /** Attributes that were common between the requested user and the user to whom these ExpertCuratedItem's were recommended. */
  commonUserRequestAttributes: Array<FormattedAttribute>;
  /** Relevance Metadata for reconciling when a new ExpertCuratedItem is created from the suggested expertCuratedItems above. */
  relevanceMetadata?: Maybe<Scalars['String']>;
  /** The lead to who these ExpertCuratedItem's were recommended. */
  sourceLead?: Maybe<Lead>;
  /** a list of request attributes that can be used to tag this saved curation */
  suggestedTaggableRequestAttributes: Array<SuggestedExpertTaggableRequestAttribute>;
  /** Rank of this Lead in the group of other similar leads */
  rank?: Maybe<Scalars['Int']>;
  /** How closely this lead matches the query lead */
  matchPercent?: Maybe<Scalars['Float']>;
};

/**
 * SuggestedExpertTaggableRequestAttribute consist of all values of the Attribute that are marked AttributeFunction,TAGGABLE
 * during the schema definition.
 * The values are further flagged if they were selected by the lead in the request, which can be used on the UI
 * to auto tag the curation.
 */
export type SuggestedExpertTaggableRequestAttribute = {
  __typename: 'SuggestedExpertTaggableRequestAttribute';
  attributeSchema: AttributeSchemaRevision;
  values: Array<SuggestedExpertTaggableRequestAttributeValue>;
};

export type SuggestedExpertTaggableRequestAttributeValue = {
  __typename: 'SuggestedExpertTaggableRequestAttributeValue';
  attributeValue: AttributeValue;
  displayValue: Scalars['String'];
  selectedByLead: Scalars['Boolean'];
};

export type SuggestedIndividualExpertCuratedItemProConTypeaheadPayload = {
  __typename: 'SuggestedIndividualExpertCuratedItemProConTypeaheadPayload';
  /** pros and cons that the expert should use for the expert curated item. */
  hits: Array<IndividualSellableProCon>;
};

export type SuggestedIndividualExpertCuratedItemProConTypeaheadQueryInput = {
  sellableId: Scalars['SellableId'];
  prefixSearch: Scalars['String'];
};

export enum SuggestedIndividualExpertCuratedItemProConTypeaheadSort {
  PROS_FIRST = 'PROS_FIRST',
  CONS_FIRST = 'CONS_FIRST'
}

export type SuggestedSellableExpertReview = {
  __typename: 'SuggestedSellableExpertReview';
  isSuggestionGood: SuggestedSellableReviewAnswerWithDisplayName;
  expert: BusinessUser;
};

export enum SuggestedSellableFilter {
  /** Whether to exclude out of stock sellables */
  EXCLUDE_OUT_OF_STOCK = 'EXCLUDE_OUT_OF_STOCK',
  /** Dual state to include both in stock items and pre-orders */
  INCLUDE_IN_STOCK_OR_PRE_ORDER = 'INCLUDE_IN_STOCK_OR_PRE_ORDER',
  /** Include only pre-orders in the search result. */
  PRE_ORDER_ONLY = 'PRE_ORDER_ONLY',
  /** Only show sellables that are in stock in Deal warehouse */
  SHIPPED_BY_CURATED = 'SHIPPED_BY_CURATED',
  /** Only show sellables that are drop-shipped by manufacturer */
  SHIPPED_BY_MANUFACTURER = 'SHIPPED_BY_MANUFACTURER',
  /**
   * Only show sellables with a deal, a sellable is considered to have a Secret deal if its salePriceOverride is
   * lower than the salePrice of all known sources
   */
  SECRET_DEAL = 'SECRET_DEAL'
}

export enum SuggestedSellableReviewAnswer {
  YES = 'YES',
  NOT_SURE = 'NOT_SURE',
  NO = 'NO'
}

export type SuggestedSellableReviewAnswerWithDisplayName = {
  __typename: 'SuggestedSellableReviewAnswerWithDisplayName';
  answer: SuggestedSellableReviewAnswer;
  displayName: Scalars['String'];
};

export type SuggestedShippingGroups = {
  __typename: 'SuggestedShippingGroups';
  shippingGroups: Array<ShippingGroup>;
  strategy: ShippingGroupStrategy;
  computedAt: Scalars['Date'];
};

export enum SuggestedSupportAction {
  SUPPORT_RESPONSE_NEEDED = 'SUPPORT_RESPONSE_NEEDED'
}

export type SuggestExpertCuratedItemNotesConnection = {
  __typename: 'SuggestExpertCuratedItemNotesConnection';
  edges: Array<SuggestExpertCuratedItemNotesEdge>;
  pageInfo: PageInfo;
};

export type SuggestExpertCuratedItemNotesEdge = {
  __typename: 'SuggestExpertCuratedItemNotesEdge';
  node: ExpertCuratedItemNote;
  cursor: Scalars['String'];
};

export type SuggestExpertCuratedItemNotesQueryInput = {
  /** Suggested notes will be given for the parent of this sellable (or this sellable directly if it's already the parent) */
  sellableId: Scalars['SellableId'];
  /** If we should exclude old notes in the suggested search. Added for backward compatibility. */
  excludeDeprecatedNotes?: Maybe<Scalars['Boolean']>;
  /** Will include notes that are PENDING or REJECTED in suggested notes for this expert */
  expertId?: Maybe<Scalars['BusinessUserId']>;
};

export enum SuggestExpertCuratedItemNotesSort {
  /** Sort by purchase rate, usage count, note length */
  DEFAULT = 'DEFAULT',
  /** Sort by usage count, note length */
  USAGES = 'USAGES',
  /** Sort by featured, usage count */
  FEATURED = 'FEATURED'
}

export type SuggestExpertCuratedItemsForLeadConnection = {
  __typename: 'SuggestExpertCuratedItemsForLeadConnection';
  facets: Array<DisplayFacet>;
  edges: Array<SuggestExpertCuratedItemsForLeadEdge>;
  pageInfo: PageInfo;
  count: Scalars['Int'];
};

export type SuggestExpertCuratedItemsForLeadEdge = {
  __typename: 'SuggestExpertCuratedItemsForLeadEdge';
  node: SuggestedExpertCuratedItems;
  cursor: Scalars['String'];
};

export type SuggestExpertCuratedItemsForLeadQueryInput = {
  /** Facets to filter search result */
  facets?: Maybe<Array<FacetSelection>>;
  /** The category for which the expert curated item is being searched. */
  categoryId: Scalars['CategoryId'];
  /** The lead for whom the ExpertCuratedItems are being searched for. */
  searchingForLead: Scalars['LeadId'];
  /** Top N facet terms to be returned per facet. */
  maxFacetTerms?: Maybe<Scalars['Int']>;
  /**
   * Explicit query filters that are applied to the results. These provide special query conditions
   * that are different than facets or categories for example.
   * In case of multiple SuggestedExpertCuratedItemFilter, all input SellableSearchFilters are ANDed
   * Note, this currently explicitly excludes out of stock sellables from recommendations
   */
  filters?: Maybe<Array<SuggestedSellableFilter>>;
};

export type SuggestLeadActionsSupportTaskActivity = SupportTaskActivity & {
  __typename: 'SuggestLeadActionsSupportTaskActivity';
  id: Scalars['SupportTaskActivityId'];
  supportTask: SupportTask;
  action: SupportTaskAction;
  actor: SupportTaskActor;
  consumer: User;
  lead?: Maybe<Lead>;
  occurredAt: Scalars['Date'];
  suggestedActions: Array<SuggestedActionType>;
};

export type SummarizedAddSellableUserActivity = SummarizedUserActivity & {
  __typename: 'SummarizedAddSellableUserActivity';
  sellable: Sellable;
  type: UserActivityType;
  lastOccurredAt: Scalars['Date'];
};

export type SummarizedCheckoutStartedUserActivity = SummarizedUserActivity & {
  __typename: 'SummarizedCheckoutStartedUserActivity';
  type: UserActivityType;
  lastOccurredAt: Scalars['Date'];
};

export type SummarizedPaymentInfoEnteredUserActivity = SummarizedUserActivity & {
  __typename: 'SummarizedPaymentInfoEnteredUserActivity';
  type: UserActivityType;
  lastOccurredAt: Scalars['Date'];
};

export type SummarizedRemoveSellableUserActivity = SummarizedUserActivity & {
  __typename: 'SummarizedRemoveSellableUserActivity';
  sellable: Sellable;
  type: UserActivityType;
  lastOccurredAt: Scalars['Date'];
};

export type SummarizedSavedSellableUserActivity = SummarizedUserActivity & {
  __typename: 'SummarizedSavedSellableUserActivity';
  sellable: Sellable;
  type: UserActivityType;
  lastOccurredAt: Scalars['Date'];
  saved: Scalars['Boolean'];
  reason?: Maybe<Scalars['String']>;
};

export type SummarizedUnSavedSellableUserActivity = SummarizedUserActivity & {
  __typename: 'SummarizedUnSavedSellableUserActivity';
  sellable: Sellable;
  type: UserActivityType;
  lastOccurredAt: Scalars['Date'];
  reason?: Maybe<Scalars['String']>;
};

export type SummarizedUserActivity = {
  type: UserActivityType;
  lastOccurredAt: Scalars['Date'];
};

export type SummarizedViewCartUserActivity = SummarizedUserActivity & {
  __typename: 'SummarizedViewCartUserActivity';
  type: UserActivityType;
  lastOccurredAt: Scalars['Date'];
};

export type SummarizedViewCuratedListUserActivity = SummarizedUserActivity & {
  __typename: 'SummarizedViewCuratedListUserActivity';
  type: UserActivityType;
  lastOccurredAt: Scalars['Date'];
  lead: Lead;
};

export type SummarizedViewSellableUserActivity = SummarizedUserActivity & {
  __typename: 'SummarizedViewSellableUserActivity';
  sellable: Sellable;
  count: Scalars['Int'];
  /** @deprecated Use lastOccurredAt */
  lastViewedAt: Scalars['Date'];
  lastViewEndedAt?: Maybe<Scalars['Date']>;
  type: UserActivityType;
  lastOccurredAt: Scalars['Date'];
};

export type SupportConversation = {
  __typename: 'SupportConversation';
  id: Scalars['SupportConversationId'];
  version: Scalars['Int'];
  updatedAt: Scalars['Date'];
  createdAt: Scalars['Date'];
  conversationId: Scalars['ConversationId'];
  consumerId: Scalars['UserId'];
  conversation: Conversation;
  supportLastMessagedAt?: Maybe<Scalars['Date']>;
  consumerLastMessagedAt?: Maybe<Scalars['Date']>;
  suggestedActions: Array<SuggestedSupportAction>;
  consumerUnreadCount: Scalars['Int'];
  consumer: User;
  escalations: Array<OrderEscalation>;
};

export type SupportConversationCountNotification = {
  __typename: 'SupportConversationCountNotification';
  conversationsCount: Scalars['Long'];
};

export type SupportConversationEdge = {
  __typename: 'SupportConversationEdge';
  node: SupportConversation;
  cursor: Scalars['String'];
};


export type SupportConversationQueryInput = {
  consumerLastMessagedAfter?: Maybe<Scalars['Date']>;
  needResponse?: Maybe<Scalars['Boolean']>;
  mustHaveConsumerActivity?: Maybe<Scalars['Boolean']>;
};

export type SupportConversationsConnection = {
  __typename: 'SupportConversationsConnection';
  edges: Array<SupportConversationEdge>;
  pageInfo: PageInfo;
  count: Scalars['Long'];
};

export type SupportedPaymentMethod = {
  __typename: 'SupportedPaymentMethod';
  paymentMethod: PaymentMethod;
  paymentProvider: PaymentProcessorType;
};

export type SupportMessagingUser = {
  __typename: 'SupportMessagingUser';
  id: Scalars['AnyId'];
  displayName: Scalars['String'];
};

export type SupportTask = {
  id: Scalars['SupportTaskId'];
  type: SupportTaskType;
  state: SupportTaskState;
  url: Scalars['String'];
  dueAt: Scalars['Date'];
  assignedTo?: Maybe<Operator>;
  assignedAt?: Maybe<Scalars['Date']>;
  completedAt?: Maybe<Scalars['Date']>;
};

export enum SupportTaskAction {
  CREATE_TASK = 'CREATE_TASK',
  ASSIGN = 'ASSIGN',
  UNASSIGN = 'UNASSIGN',
  DISMISS = 'DISMISS',
  DELEGATE_LEAD = 'DELEGATE_LEAD',
  REASSIGN_LEAD = 'REASSIGN_LEAD',
  SUGGEST_LEAD_ACTIONS = 'SUGGEST_LEAD_ACTIONS',
  ESCALATE_LEAD_FOR_DELEGATION = 'ESCALATE_LEAD_FOR_DELEGATION',
  ESCALATE_LEAD_FOR_REASSIGNMENT = 'ESCALATE_LEAD_FOR_REASSIGNMENT',
  REQUEST_ORDER_SUPPORT_FOR_LEAD = 'REQUEST_ORDER_SUPPORT_FOR_LEAD',
  SNOOZE = 'SNOOZE',
  UNSNOOZE = 'UNSNOOZE',
  SPAM_RISK = 'SPAM_RISK'
}

export type SupportTaskActivity = {
  id: Scalars['SupportTaskActivityId'];
  supportTask: SupportTask;
  action: SupportTaskAction;
  actor: SupportTaskActor;
  consumer: User;
  lead?: Maybe<Lead>;
  occurredAt: Scalars['Date'];
};


export type SupportTaskActor = Operator | SystemUser;

export type SupportTaskAssignedToQuery = {
  assigneeIds: Array<Scalars['OperatorId']>;
  includeUnassigned?: Maybe<Scalars['Boolean']>;
};

export type SupportTaskFolder = {
  __typename: 'SupportTaskFolder';
  id: Scalars['SupportTaskFolderId'];
  slug: Scalars['String'];
  displayName: Scalars['String'];
  badgeCount?: Maybe<Scalars['Int']>;
};

export type SupportTaskFolderEvent = {
  __typename: 'SupportTaskFolderEvent';
  folder: SupportTaskFolder;
};



export type SupportTaskListEvent = {
  __typename: 'SupportTaskListEvent';
  supportTask: SupportTask;
  type: SupportTaskListEventType;
};

export enum SupportTaskListEventType {
  ADD = 'ADD',
  REMOVE = 'REMOVE'
}

export type SupportTaskQuery = {
  types?: Maybe<Array<SupportTaskType>>;
  states?: Maybe<Array<SupportTaskState>>;
  dueAtRange?: Maybe<DateRangeInput>;
  assignedTo?: Maybe<SupportTaskAssignedToQuery>;
};

export type SupportTasksConnection = {
  __typename: 'SupportTasksConnection';
  edges: Array<SupportTasksEdge>;
  pageInfo: PageInfo;
  count: Scalars['Long'];
};

export type SupportTasksEdge = {
  __typename: 'SupportTasksEdge';
  node: SupportTask;
  cursor: Scalars['String'];
};

export enum SupportTaskState {
  PENDING = 'PENDING',
  ASSIGNED = 'ASSIGNED',
  COMPLETED = 'COMPLETED'
}

export enum SupportTaskType {
  LEAD = 'LEAD',
  ORDER = 'ORDER'
}

export type SurveySummary = {
  __typename: 'SurveySummary';
  lastSystemCuratedItemSurvey: SystemCuratedItemSurvey;
  lastSystemCuratedItemSurveySentAt: Scalars['Date'];
};

export type SwapTriggerBranchEdgesInput = {
  triggerId: Scalars['TriggerId'];
  nodeId: Scalars['TriggerNodeId'];
};

export type SwapTriggerWaitEdgesInput = {
  triggerId: Scalars['TriggerId'];
  nodeId: Scalars['TriggerNodeId'];
};

export type SwitchPathQuestionSchemaTypeUpdateEditorCommandInput = {
  id?: Maybe<Scalars['PathQuestionSchemaId']>;
  schemaType: PathQuestionSchemaType;
};

export type SyncCampaignAudienceInput = {
  campaignAudienceId: Scalars['CampaignAudienceId'];
};

export type SyncCampaignAudiencePayload = {
  __typename: 'SyncCampaignAudiencePayload';
  campaignAudience: CampaignAudience;
  hasError: Scalars['Boolean'];
  errorMessage?: Maybe<Scalars['String']>;
};

export type SyncExternalAdCampaignsInput = {
  categoryId: Scalars['CategoryId'];
};

export type SyncExternalAdCampaignsPayload = {
  __typename: 'SyncExternalAdCampaignsPayload';
  adCampaigns: Array<ExternalAdCampaign>;
};

export type SyncItemShippingStatusInput = {
  orderId: Scalars['OrderId'];
  orderLineItemId: Scalars['OrderLineItemId'];
  isReturn?: Maybe<Scalars['Boolean']>;
  fulfillmentOrderId?: Maybe<Scalars['FulfillmentOrderId']>;
};

export type SyncOrderInput = {
  /** If omitted, user context will be assumed and the user's current cart will be operated on */
  id?: Maybe<Scalars['OrderId']>;
  useCase: CartSyncUseCase;
};

export type SyncOrderPayload = {
  __typename: 'SyncOrderPayload';
  order: Order;
};

export type SyncOrderReturnShipmentTrackingInput = {
  orderRefundId: Scalars['OrderRefundId'];
};

export type SyncShopifyInventoryPayload = {
  __typename: 'SyncShopifyInventoryPayload';
  data?: Maybe<SellableInventoryItem>;
  error?: Maybe<Scalars['String']>;
  hasError: Scalars['Boolean'];
};

export enum SystemCuratedConsumerSellableReactionRating {
  SKIP = 'SKIP',
  DISLIKE = 'DISLIKE',
  LIKE = 'LIKE',
  LOVE = 'LOVE'
}

export type SystemCuratedItem = {
  __typename: 'SystemCuratedItem';
  id: Scalars['SystemCuratedItemId'];
  type: SystemCuratedItemType;
  sellable: Sellable;
  category: Category;
  systemCuratedItemSource: SystemCuratedItemSource;
};


export type SystemCuratedItemSource = {
  type?: Maybe<SystemCuratedItemType>;
};

export type SystemCuratedItemsRichCard = MessageRichCard & {
  __typename: 'SystemCuratedItemsRichCard';
  type: MessageRichCardType;
  expertCuratedItemActivationId: Scalars['ExpertCuratedItemActivationId'];
};

export type SystemCuratedItemSurvey = {
  __typename: 'SystemCuratedItemSurvey';
  id: Scalars['SystemCuratedItemSurveyId'];
  systemCuratedItems: Array<SystemCuratedItem>;
  ended: Scalars['Boolean'];
  startedAt?: Maybe<Scalars['Date']>;
  endedAt?: Maybe<Scalars['Date']>;
  terminationReason?: Maybe<SystemCuratedItemSurveyTerminationReason>;
  stats?: Maybe<SystemCuratedItemSurveyStats>;
  /** skipped all questions */
  skippedAll?: Maybe<Scalars['Boolean']>;
  /** answered some question before early termination */
  answeredSome?: Maybe<Scalars['Boolean']>;
  /** all questions answered, inclusive of skips */
  answeredAll?: Maybe<Scalars['Boolean']>;
};


export type SystemCuratedItemSurveyRichCard = MessageRichCard & {
  __typename: 'SystemCuratedItemSurveyRichCard';
  type: MessageRichCardType;
  leadId: Scalars['LeadId'];
};

export type SystemCuratedItemSurveyStats = {
  __typename: 'SystemCuratedItemSurveyStats';
  ratingStats: Array<ConsumerSellableReactionRatingStats>;
};

export enum SystemCuratedItemSurveyTerminationReason {
  SKIPPED = 'SKIPPED',
  TERMINATED_EARLY = 'TERMINATED_EARLY',
  REVIEWED_ALL = 'REVIEWED_ALL'
}

export enum SystemCuratedItemType {
  EXPERT_CURATED_ITEMS_FROM_SIMILAR_USER = 'EXPERT_CURATED_ITEMS_FROM_SIMILAR_USER',
  EXPERT_CURATED_ITEMS_FROM_SIMILAR_USER_RANKED_BY_TIMES_RECOMMENDED = 'EXPERT_CURATED_ITEMS_FROM_SIMILAR_USER_RANKED_BY_TIMES_RECOMMENDED',
  TOP_RECOMMENDATIONS_BASED_ON_DEAL_REQUEST = 'TOP_RECOMMENDATIONS_BASED_ON_DEAL_REQUEST',
  SIMILAR_USER_AND_TOP_RECOMMENDATIONS_GLOBALLY_RANKED = 'SIMILAR_USER_AND_TOP_RECOMMENDATIONS_GLOBALLY_RANKED'
}

export type SystemUser = {
  __typename: 'SystemUser';
  id: Scalars['AnyId'];
};

export type Tag = {
  __typename: 'Tag';
  id: Scalars['TagId'];
  type: TagType;
  name: Scalars['String'];
};


export enum TagType {
  BROADCAST_LEAD_QUALITY = 'BROADCAST_LEAD_QUALITY',
  BROADCAST_CONVERSION_STRATEGY = 'BROADCAST_CONVERSION_STRATEGY',
  BROADCAST_TRUST_STRATEGY = 'BROADCAST_TRUST_STRATEGY',
  REMINDER_TASK_TYPE = 'REMINDER_TASK_TYPE'
}

export type TakeOverShiftRequestInput = {
  shiftId: Scalars['ShiftId'];
};

export type TaskPayload = MerchantUploadTaskPayload | DealUploadTaskPayload | SellableUploadTaskPayload | SellablePriceUploadTaskPayload | BrandUploadTaskPayload | FeaturedSellableContentUploadTaskPayload | SellableUpdateTaskPayload | SellableDeactivationTaskPayload | SellableInventoryUploadTaskPayload | ExpertDiscountCashUploadTaskPayload | InvoicedShippingCostUploadTaskPayload;

export type TcpaCompliancePathQuestionsDisplayComponentSchema = PathQuestionsDisplayComponentSchema & {
  __typename: 'TcpaCompliancePathQuestionsDisplayComponentSchema';
  displayComponentType: PathQuestionDisplayComponentSchemaType;
};

export type TcpaComplianceQuestionsDisplayComponentPathNodeFlowViewModel = QuestionsDisplayComponentPathNodeFlowViewModel & {
  __typename: 'TcpaComplianceQuestionsDisplayComponentPathNodeFlowViewModel';
  displayComponentType: PathQuestionDisplayComponentSchemaType;
};

export type TcpaComplianceQuestionsDisplayComponentSchemaFieldsUpdateEditorCommandInput = {
  _?: Maybe<Scalars['Boolean']>;
};

export type TemplateCustomQueryDataModel = TemplateDataModel & {
  __typename: 'TemplateCustomQueryDataModel';
  type: TemplateDataModelType;
};

export type TemplateDataModel = {
  type: TemplateDataModelType;
};

export type TemplateDataModelInput = {
  queries: Array<TemplateNamedQueryInput>;
  categoryType?: Maybe<TriggerParameterInput>;
  category?: Maybe<TriggerParameterInput>;
};

export enum TemplateDataModelType {
  DATA_OBJECT = 'DATA_OBJECT',
  CUSTOM_QUERY = 'CUSTOM_QUERY',
  NAMED_QUERIES = 'NAMED_QUERIES'
}

export type TemplateEdge = {
  __typename: 'TemplateEdge';
  node: MultiLocaleTemplateSet;
  cursor: Scalars['String'];
};

export type TemplateFragmentParameter = {
  __typename: 'TemplateFragmentParameter';
  name: Scalars['String'];
  displayName: Scalars['String'];
  type: TemplateFragmentParameterType;
  enumValues: Array<Scalars['String']>;
  required: Scalars['Boolean'];
};

export type TemplateFragmentParameterInput = {
  name: Scalars['String'];
  type: TemplateFragmentParameterType;
  displayName: Scalars['String'];
  enumValues: Array<Scalars['String']>;
  required: Scalars['Boolean'];
};

export enum TemplateFragmentParameterType {
  TEXT = 'TEXT',
  BOOLEAN = 'BOOLEAN',
  OBJECT = 'OBJECT',
  IMAGE_URL = 'IMAGE_URL',
  ACTION_URL = 'ACTION_URL',
  ENUMERATION = 'ENUMERATION'
}

export type TemplateFragmentParameterValueInput = {
  name: Scalars['String'];
  stringValue?: Maybe<Scalars['String']>;
  booleanValue?: Maybe<Scalars['Boolean']>;
  reference?: Maybe<Scalars['String']>;
};

export enum TemplateFragmentType {
  BLOCK = 'BLOCK',
  HEADER = 'HEADER',
  FOOTER = 'FOOTER',
  BANNER = 'BANNER',
  MODULE = 'MODULE',
  PAGE_WRAPPER = 'PAGE_WRAPPER',
  NONE = 'NONE'
}

export type TemplateMessageContentQuickView = {
  __typename: 'TemplateMessageContentQuickView';
  subject?: Maybe<Scalars['String']>;
  body?: Maybe<Scalars['String']>;
};

export type TemplateMessageDeliveryLog = {
  __typename: 'TemplateMessageDeliveryLog';
  id: Scalars['MessageDeliveryLogId'];
  recipient: TemplateMessageDeliveryRecipient;
  sentAt: Scalars['Date'];
  trigger: Trigger;
  templateType: CommTemplateType;
  template: MultiLocaleTemplateSet;
  channelType: ChannelType;
  variableMapJson: Scalars['String'];
  content?: Maybe<TemplateMessageContentQuickView>;
};

export type TemplateMessageDeliveryLogFilterInput = {
  triggerId?: Maybe<Scalars['TriggerId']>;
  templateId?: Maybe<Scalars['CommTemplateId']>;
  templateTypeId?: Maybe<Scalars['CommTemplateTypeId']>;
  channelType?: Maybe<ChannelType>;
  recipientId?: Maybe<Scalars['AnyId']>;
};

export type TemplateMessageDeliveryLogPagination = {
  __typename: 'TemplateMessageDeliveryLogPagination';
  deliveryLogs: Array<TemplateMessageDeliveryLog>;
  count: Scalars['Int'];
};

export type TemplateMessageDeliveryRecipient = User | BusinessUser;

export type TemplateMessageFrequencyCapRule = {
  __typename: 'TemplateMessageFrequencyCapRule';
  duration: TriggerDuration;
  entityId?: Maybe<TriggerParameter>;
};

export type TemplateMessageFrequencyCapRuleInput = {
  duration: TriggerDurationInput;
  entityId?: Maybe<TriggerParameterInput>;
};

export type TemplateNamedParameter = {
  __typename: 'TemplateNamedParameter';
  name: Scalars['String'];
  value: TriggerParameter;
};

export type TemplateNamedParameterInput = {
  name: Scalars['String'];
  value: TriggerParameterInput;
};

export type TemplateNamedQuery = {
  __typename: 'TemplateNamedQuery';
  queryName: Scalars['String'];
  alias?: Maybe<Scalars['String']>;
  variables: Array<TemplateNamedParameter>;
};

export type TemplateNamedQueryDataModel = TemplateDataModel & {
  __typename: 'TemplateNamedQueryDataModel';
  type: TemplateDataModelType;
  categoryType?: Maybe<TriggerParameter>;
  categoryId?: Maybe<TriggerParameter>;
  queries: Array<TemplateNamedQuery>;
};

export type TemplateNamedQueryInput = {
  queryName: Scalars['String'];
  alias?: Maybe<Scalars['String']>;
  variables: Array<TemplateNamedParameterInput>;
};

export type TemplateNamedQueryMeta = {
  __typename: 'TemplateNamedQueryMeta';
  name: Scalars['String'];
  displayName: Scalars['String'];
  query: Scalars['String'];
  variables: Array<TriggerParameterMeta>;
};

export type TemplateObjectTemplateDataModel = TemplateDataModel & {
  __typename: 'TemplateObjectTemplateDataModel';
  type: TemplateDataModelType;
};

export type TemplatesConnection = {
  __typename: 'TemplatesConnection';
  facets: Array<DisplayFacet>;
  edges: Array<TemplateEdge>;
  pageInfo: PageInfo;
  count: Scalars['Int'];
};

export type TemplateSearchRequestInput = {
  keywords?: Maybe<Scalars['String']>;
  facets: Array<FacetSelection>;
  content?: Maybe<Scalars['String']>;
};

export enum TemplateSearchSort {
  PUBLISHED_AT = 'PUBLISHED_AT',
  CREATED_AT = 'CREATED_AT',
  TITLE = 'TITLE'
}

export enum TemplateTagSyntax {
  DEFAULT = 'DEFAULT',
  ALTERNATIVE = 'ALTERNATIVE'
}

export enum TemplateTypeGroup {
  ONBOARDING = 'ONBOARDING',
  NURTURING = 'NURTURING',
  FEEDBACK = 'FEEDBACK',
  CURATION = 'CURATION',
  EXPERT_ONBOARDING = 'EXPERT_ONBOARDING',
  MESSAGE_ROUTING = 'MESSAGE_ROUTING',
  EXPERT_NOTIFICATION = 'EXPERT_NOTIFICATION',
  POST_PURCHASE = 'POST_PURCHASE',
  CONSUMER_REQUEST = 'CONSUMER_REQUEST',
  CAMPAIGN = 'CAMPAIGN',
  ABANDONED_CART = 'ABANDONED_CART',
  ABANDONED_CHECKOUT = 'ABANDONED_CHECKOUT',
  PATH_DROPOFF = 'PATH_DROPOFF',
  FULFILLMENT = 'FULFILLMENT',
  REFERRAL = 'REFERRAL'
}

export type TerminateSystemCuratedItemSurveyInput = {
  id: Scalars['SystemCuratedItemSurveyId'];
  reason: SystemCuratedItemSurveyTerminationReason;
};

export type TerminateSystemCuratedItemSurveyPayload = {
  __typename: 'TerminateSystemCuratedItemSurveyPayload';
  data?: Maybe<SystemCuratedItemSurvey>;
  error?: Maybe<Scalars['String']>;
};

export type TermsAndConditionsPathFlowPageMetadata = PathFlowPageMetadata & {
  __typename: 'TermsAndConditionsPathFlowPageMetadata';
  type: PathFlowPageMetadataType;
};

export type TermsAndConditionsPathQuestionsDisplayComponentSchema = PathQuestionsDisplayComponentSchema & {
  __typename: 'TermsAndConditionsPathQuestionsDisplayComponentSchema';
  displayComponentType: PathQuestionDisplayComponentSchemaType;
};

export type TermsAndConditionsQuestionsDisplayComponentPathNodeFlowViewModel = QuestionsDisplayComponentPathNodeFlowViewModel & {
  __typename: 'TermsAndConditionsQuestionsDisplayComponentPathNodeFlowViewModel';
  displayComponentType: PathQuestionDisplayComponentSchemaType;
};

export type TermsAndConditionsQuestionsDisplayComponentSchemaFieldsUpdateEditorCommandInput = {
  _?: Maybe<Scalars['Boolean']>;
};

export type TermsPrivacyMedicalPathFlowPageMetadata = PathFlowPageMetadata & {
  __typename: 'TermsPrivacyMedicalPathFlowPageMetadata';
  type: PathFlowPageMetadataType;
};

export type TestTriggerEventParameterInput = {
  name: Scalars['String'];
  idValue?: Maybe<Scalars['AnyId']>;
  stringValue?: Maybe<Scalars['String']>;
};

export type TestTriggerExecutionInput = {
  triggerId: Scalars['TriggerId'];
  eventParameters: Array<TestTriggerEventParameterInput>;
};

export type TestTriggerExecutionPayload = {
  __typename: 'TestTriggerExecutionPayload';
  success: Scalars['Boolean'];
  error?: Maybe<Scalars['String']>;
};

export type TextPathEditorRichTextContentPart = PathEditorRichTextContentPart & {
  __typename: 'TextPathEditorRichTextContentPart';
  partType: PathEditorRichTextContentPartType;
  text: Scalars['String'];
  style?: Maybe<TextPathEditorRichTextContentPartStyle>;
};

export enum TextPathEditorRichTextContentPartStyle {
  IDENTIFIER = 'IDENTIFIER'
}

export type TextRenderedContent = {
  __typename: 'TextRenderedContent';
  text: Scalars['String'];
  link?: Maybe<Scalars['String']>;
};

/** ====== Text View Model */
export type TextViewModel = AttributedHtmlTextViewModel;

export enum ThreeDSecureVerification {
  /** 3D Secure is required, and the process must be completed for a charge to be successful. */
  REQUIRED = 'REQUIRED',
  /**
   * 3D Secure is recommended. The process is not required, but it is highly recommended and
   * has minimal impact to your conversion rate.
   */
  RECOMMENDED = 'RECOMMENDED',
  /**
   * 3D Secure is optional. The process is neither required nor recommended, but it can be performed to
   * help reduce the likelihood of fraud.
   */
  OPTIONAL = 'OPTIONAL',
  /** 3D Secure is not supported on this card. Proceed with a regular card payment instead. */
  NOT_SUPPORTED = 'NOT_SUPPORTED'
}

export type Ticket = {
  __typename: 'Ticket';
  id: Scalars['TicketId'];
  createdAt: Scalars['Date'];
  updatedAt: Scalars['Date'];
  assignedTo?: Maybe<TicketUser>;
  description?: Maybe<Scalars['String']>;
  dueAt: Scalars['Date'];
  comments: Array<TicketComment>;
  priority: TicketPriority;
  detail: TicketDetail;
  consumerFriendlyId?: Maybe<Scalars['String']>;
  activities: Array<TicketActivity>;
  workflowType: WorkflowType;
  requester: TicketRequester;
  requestChannel: TicketRequestChannel;
  subTickets: Array<Ticket>;
  mergedTickets: Array<Ticket>;
  assignedQueue?: Maybe<TicketQueue>;
  parentTicket?: Maybe<Ticket>;
  snooze?: Maybe<TicketSnooze>;
  consumer?: Maybe<User>;
  supersededTicket?: Maybe<Ticket>;
  dependedOnTickets: Array<Ticket>;
  state: TicketState;
  workLogs: Array<TicketWorkLog>;
  blockingTickets: Array<Ticket>;
  supportConversation?: Maybe<SupportConversation>;
};


export type TicketCommentsArgs = {
  ticketCommentTypes?: Maybe<Array<TicketCommentType>>;
};


export type TicketActivitiesArgs = {
  limit?: Maybe<Scalars['Int']>;
  ticketActivityTypes?: Maybe<Array<TicketActivityType>>;
};

export enum TicketActionReason {
  CUSTOMER_PREFERENCE = 'CUSTOMER_PREFERENCE',
  EXPERT_RECOMMENDATION = 'EXPERT_RECOMMENDATION',
  MISSING_EXPERT_INFO = 'MISSING_EXPERT_INFO',
  MERCHANT_UPDATE = 'MERCHANT_UPDATE',
  NEED_MERCHANT_TRACKING = 'NEED_MERCHANT_TRACKING',
  UPDATE_TRACKING = 'UPDATE_TRACKING',
  CONFIRM_INVENTORY = 'CONFIRM_INVENTORY',
  CLAIM_ITEM = 'CLAIM_ITEM'
}

export enum TicketActionType {
  CONTACT_CUSTOMER = 'CONTACT_CUSTOMER',
  CONTACT_MERCHANT = 'CONTACT_MERCHANT',
  CONTACT_EXPERT = 'CONTACT_EXPERT',
  CONTACT_CARRIER = 'CONTACT_CARRIER',
  GENERATE_SHIPPING_LABEL = 'GENERATE_SHIPPING_LABEL',
  VERIFY_ORDER = 'VERIFY_ORDER',
  UPDATE_TRACKING = 'UPDATE_TRACKING',
  REQUEST_CANCELLATION = 'REQUEST_CANCELLATION',
  REQUEST_REFUND = 'REQUEST_REFUND',
  UPDATE_ORDER = 'UPDATE_ORDER',
  MERGE_TICKETS = 'MERGE_TICKETS',
  TRANSFER_TICKET = 'TRANSFER_TICKET'
}

export type TicketActivity = {
  __typename: 'TicketActivity';
  id: Scalars['TicketActivityId'];
  occurredAt: Scalars['Date'];
  author: TicketRequester;
  detail: TicketActivityDetail;
  ticket: Ticket;
};

export type TicketActivityDetail = {
  type: TicketActivityType;
};


export type TicketActivityTimelineItem = TicketTimelineItem & {
  __typename: 'TicketActivityTimelineItem';
  type: TicketTimelineItemType;
  occurredAt: Scalars['Date'];
  activity: TicketActivity;
};

export enum TicketActivityType {
  TICKET_ASSIGNED = 'TICKET_ASSIGNED',
  TICKET_UNASSIGNED = 'TICKET_UNASSIGNED',
  DUE_DATE_CHANGED = 'DUE_DATE_CHANGED',
  FIELD_UPDATED = 'FIELD_UPDATED',
  SNOOZE_CHANGED = 'SNOOZE_CHANGED',
  TICKET_MERGED = 'TICKET_MERGED',
  QUEUE_TRANSFER = 'QUEUE_TRANSFER',
  TICKET_PICKED_UP = 'TICKET_PICKED_UP',
  TICKET_CLOSED = 'TICKET_CLOSED',
  TICKET_REOPENED = 'TICKET_REOPENED',
  TICKET_CREATED = 'TICKET_CREATED',
  DEPENDENCY_UPDATED = 'DEPENDENCY_UPDATED',
  TICKET_COMMENT_ADDED = 'TICKET_COMMENT_ADDED'
}

export type TicketAssignedActivity = TicketActivityDetail & {
  __typename: 'TicketAssignedActivity';
  type: TicketActivityType;
  previousAssignee?: Maybe<TicketUser>;
  newAssignee: TicketUser;
};

export type TicketAuthor = SystemUser | Operator;

export type TicketClosedActivity = TicketActivityDetail & {
  __typename: 'TicketClosedActivity';
  type: TicketActivityType;
  comment?: Maybe<Scalars['String']>;
  reasonForClosing: CloseTicketReason;
};

export type TicketComment = {
  __typename: 'TicketComment';
  author: TicketRequester;
  createdAt: Scalars['Date'];
  note: Scalars['String'];
  type: TicketCommentType;
};

export type TicketCommentAddedActivity = TicketActivityDetail & {
  __typename: 'TicketCommentAddedActivity';
  type: TicketActivityType;
  comment: TicketComment;
};

export type TicketCommentTimelineItem = TicketTimelineItem & {
  __typename: 'TicketCommentTimelineItem';
  type: TicketTimelineItemType;
  occurredAt: Scalars['Date'];
  comment: TicketComment;
};

export enum TicketCommentType {
  AGENT_NOTES = 'AGENT_NOTES',
  REPLY_TO_EXPERT = 'REPLY_TO_EXPERT',
  EXPERT_RESPONSE = 'EXPERT_RESPONSE'
}

export type TicketCreatedActivity = TicketActivityDetail & {
  __typename: 'TicketCreatedActivity';
  type: TicketActivityType;
  parentTicket?: Maybe<Ticket>;
  supersededTicket?: Maybe<Ticket>;
};

export type TicketDependencyUpdatedActivity = TicketActivityDetail & {
  __typename: 'TicketDependencyUpdatedActivity';
  type: TicketActivityType;
  dependencyUpdateType: DependencyUpdateType;
  dependedOnTicket: Ticket;
};

export type TicketDetail = {
  type: TicketType;
};

export type TicketEdge = {
  __typename: 'TicketEdge';
  node: Ticket;
  cursor: Scalars['String'];
};


export type TicketOrderActivityTimelineItem = TicketTimelineItem & {
  __typename: 'TicketOrderActivityTimelineItem';
  type: TicketTimelineItemType;
  occurredAt: Scalars['Date'];
  orderActivity: PostCartOrderActivity;
};

export type TicketPickedUpActivity = TicketActivityDetail & {
  __typename: 'TicketPickedUpActivity';
  type: TicketActivityType;
  comment?: Maybe<Scalars['String']>;
};

export enum TicketPriority {
  NORMAL = 'NORMAL',
  HIGH = 'HIGH'
}

export type TicketQueryInput = {
  orderIds?: Maybe<Array<Scalars['String']>>;
  orderLineItemIds?: Maybe<Array<Scalars['String']>>;
  ticketTypes?: Maybe<Array<TicketType>>;
  assignedToIds?: Maybe<Array<Scalars['AnyId']>>;
  includeUnassigned?: Maybe<Scalars['Boolean']>;
  dueDateRange?: Maybe<DateRangeInput>;
  consumerIds?: Maybe<Array<Scalars['UserId']>>;
  ticketStates?: Maybe<Array<TicketState>>;
};

export enum TicketQueue {
  FULFILLMENT_TIER_ONE = 'FULFILLMENT_TIER_ONE',
  FULFILLMENT_TIER_TWO = 'FULFILLMENT_TIER_TWO',
  SUPPORT_TIER_ONE = 'SUPPORT_TIER_ONE',
  SUPPORT_TIER_TWO = 'SUPPORT_TIER_TWO'
}

export type TicketQueueTransferActivity = TicketActivityDetail & {
  __typename: 'TicketQueueTransferActivity';
  type: TicketActivityType;
  fromQueue?: Maybe<TicketQueue>;
  toQueue: TicketQueue;
  comment?: Maybe<Scalars['String']>;
  reasonForTransfer: TransferTicketReason;
};

export type TicketReopenedActivity = TicketActivityDetail & {
  __typename: 'TicketReopenedActivity';
  type: TicketActivityType;
  reasonForReopen: ReopenTicketReason;
};

export enum TicketRequestChannel {
  CUSTOMER_ESCALATION = 'CUSTOMER_ESCALATION',
  EXPERT_CHAT = 'EXPERT_CHAT',
  AGENT_ESCALATION = 'AGENT_ESCALATION',
  EMAIL = 'EMAIL',
  CALL = 'CALL',
  WORKFLOW = 'WORKFLOW'
}

export type TicketRequester = Operator | SystemUser | BusinessUser | User;

export type TicketsConnection = {
  __typename: 'TicketsConnection';
  edges: Array<TicketEdge>;
  pageInfo: PageInfo;
  count: Scalars['Long'];
};

export type TicketSearchConnection = {
  __typename: 'TicketSearchConnection';
  edges: Array<TicketEdge>;
  pageInfo: PageInfo;
  facets: Array<DisplayFacet>;
  count: Scalars['Long'];
};

export type TicketSearchQueryInput = {
  keywords?: Maybe<Scalars['String']>;
  ticketTypes?: Maybe<Array<TicketType>>;
  assignedToOperatorIds?: Maybe<Array<Scalars['OperatorId']>>;
  includeUnassigned?: Maybe<Scalars['Boolean']>;
  dateRangeFilters?: Maybe<Array<DateRangeFilterInput>>;
  facets?: Maybe<Array<FacetSelection>>;
  facetedSearch?: Maybe<Scalars['Boolean']>;
  ticketPriorities?: Maybe<Array<TicketPriority>>;
  consumerIds?: Maybe<Array<Scalars['UserId']>>;
  ticketQueues?: Maybe<Array<TicketQueue>>;
  ticketStates?: Maybe<Array<TicketState>>;
  actionOverdue?: Maybe<Scalars['Boolean']>;
  includeChildTickets?: Maybe<Scalars['Boolean']>;
};

export enum TicketSearchSort {
  CREATED_AT = 'CREATED_AT',
  UPDATED_AT = 'UPDATED_AT',
  DUE_AT = 'DUE_AT'
}

export type TicketsMergedActivity = TicketActivityDetail & {
  __typename: 'TicketsMergedActivity';
  type: TicketActivityType;
  mergedTickets: Array<Ticket>;
  reasonForMerging: Scalars['String'];
};

export type TicketSnooze = {
  __typename: 'TicketSnooze';
  snoozeUntil: Scalars['Date'];
  comment?: Maybe<Scalars['String']>;
};

export type TicketSnoozeChangedActivity = TicketActivityDetail & {
  __typename: 'TicketSnoozeChangedActivity';
  type: TicketActivityType;
  oldSnooze?: Maybe<TicketSnooze>;
  newSnooze?: Maybe<TicketSnooze>;
  comment?: Maybe<Scalars['String']>;
  reason?: Maybe<TicketSnoozeChangeReason>;
};

export enum TicketSnoozeChangeReason {
  BACK_ORDERED = 'BACK_ORDERED',
  MERCHANT_RESPONSE = 'MERCHANT_RESPONSE',
  EXPERT_RESPONSE = 'EXPERT_RESPONSE',
  CONSUMER_RESPONSE = 'CONSUMER_RESPONSE',
  REFUND_REQUEST_UPDATE = 'REFUND_REQUEST_UPDATE'
}

export type TicketsPagination = {
  __typename: 'TicketsPagination';
  tickets: Array<Ticket>;
  facets: Array<DisplayFacet>;
  count: Scalars['Long'];
};

export enum TicketState {
  OPEN = 'OPEN',
  BLOCKED = 'BLOCKED',
  ACTIVE = 'ACTIVE',
  SNOOZED = 'SNOOZED',
  CLOSED = 'CLOSED'
}

export type TicketTimeline = {
  __typename: 'TicketTimeline';
  ticketId: Scalars['TicketId'];
  timelineItems: Array<TicketTimelineItem>;
};

export type TicketTimelineCustomFilterInput = {
  type?: Maybe<TicketTimelineFilterType>;
  orderLineItemIds?: Maybe<Array<Scalars['OrderLineItemId']>>;
};

export enum TicketTimelineFilterType {
  ORDER_LINE_ITEM_ID = 'ORDER_LINE_ITEM_ID'
}

export type TicketTimelineItem = {
  type: TicketTimelineItemType;
  occurredAt: Scalars['Date'];
};

export enum TicketTimelineItemType {
  COMMENT = 'COMMENT',
  WORKLOG = 'WORKLOG',
  TICKET_ACTIVITY = 'TICKET_ACTIVITY',
  ORDER_ACTIVITY = 'ORDER_ACTIVITY'
}

export type TicketTimelineRequestInput = {
  ticketId: Scalars['TicketId'];
  ticketActivityTypes: Array<TicketActivityType>;
  orderActivityDetailTypes: Array<OrderActivityDetailType>;
  includeComments: Scalars['Boolean'];
  includeWorklogs: Scalars['Boolean'];
  sortAsc: Scalars['Boolean'];
  customFilter?: Maybe<TicketTimelineCustomFilterInput>;
};

export enum TicketType {
  LINE_ITEM_CLAIM = 'LINE_ITEM_CLAIM',
  UPDATE_TRACKING_INFO = 'UPDATE_TRACKING_INFO',
  ORDER_VERIFICATION = 'ORDER_VERIFICATION',
  PRODUCT_RETURN = 'PRODUCT_RETURN',
  CONSUMER_REFUND = 'CONSUMER_REFUND',
  MERCHANT_REFUND = 'MERCHANT_REFUND',
  ITEM_UNAVAILABLE = 'ITEM_UNAVAILABLE',
  MISSING_SPECS = 'MISSING_SPECS',
  ORDER_ADJUSTMENT = 'ORDER_ADJUSTMENT',
  CANCELLATION = 'CANCELLATION',
  RETURN = 'RETURN',
  EXCHANGE = 'EXCHANGE',
  MISSING_ITEM = 'MISSING_ITEM',
  TRACKING_INQUIRY = 'TRACKING_INQUIRY',
  ORDER_INFORMATION = 'ORDER_INFORMATION',
  OTHER = 'OTHER',
  FOLLOWUP_ACTION_REQUEST = 'FOLLOWUP_ACTION_REQUEST',
  GROUPED_ITEM_CLAIMS = 'GROUPED_ITEM_CLAIMS'
}

export type TicketUnassignedActivity = TicketActivityDetail & {
  __typename: 'TicketUnassignedActivity';
  type: TicketActivityType;
  reason?: Maybe<TicketUnassignedReason>;
};

export enum TicketUnassignedReason {
  SHIFT_ENDED = 'SHIFT_ENDED'
}

export type TicketUser = Operator;

export type TicketWithErrorPayload = {
  __typename: 'TicketWithErrorPayload';
  ticket?: Maybe<Ticket>;
  hasError: Scalars['Boolean'];
  error?: Maybe<Scalars['String']>;
};

export type TicketWorkLog = {
  __typename: 'TicketWorkLog';
  author: TicketAuthor;
  createdAt: Scalars['Date'];
  note?: Maybe<Scalars['String']>;
  startedAt?: Maybe<Scalars['Date']>;
  workDuration?: Maybe<Duration>;
  actionType: TicketActionType;
  contactType?: Maybe<ContactType>;
};

export type TicketWorklogTimelineItem = TicketTimelineItem & {
  __typename: 'TicketWorklogTimelineItem';
  type: TicketTimelineItemType;
  occurredAt: Scalars['Date'];
  worklog: TicketWorkLog;
};


export type TipMethod = {
  type: TipMethodType;
};

export type TipMethodFixedAmount = TipMethod & {
  __typename: 'TipMethodFixedAmount';
  type: TipMethodType;
  options: Array<MonetaryAmount>;
  customAmountAllowed: Scalars['Boolean'];
};

export type TipMethodPercentOfAmount = TipMethod & {
  __typename: 'TipMethodPercentOfAmount';
  type: TipMethodType;
  options: Array<TipMethodPercentOption>;
};

export type TipMethodPercentOption = {
  __typename: 'TipMethodPercentOption';
  rate: Scalars['BigDecimal'];
  minimumAmount: MonetaryAmount;
  maximumAmount: MonetaryAmount;
};

export enum TipMethodType {
  PERCENT_OF_AMOUNT = 'PERCENT_OF_AMOUNT',
  FIXED_AMOUNT = 'FIXED_AMOUNT'
}

export type TogglePathEditorNodeExpansionInput = {
  id: Scalars['AnyId'];
  editorStateId?: Maybe<Scalars['PathEditorStateId']>;
  targetPathNodeId: Scalars['PathNodeId'];
  desiredExpanderSetting: PathNodeExpanderSetting;
};

export type TogglePathEditorNodeExpansionPayload = CommonPathEditorPayload & {
  __typename: 'TogglePathEditorNodeExpansionPayload';
  pathEditorContext: PathEditorContext;
  errorMessage?: Maybe<Scalars['String']>;
  hasError: Scalars['Boolean'];
};

export type TopRecommendationAndSimilarUserSystemCuratedItemSource = SystemCuratedItemSource & {
  __typename: 'TopRecommendationAndSimilarUserSystemCuratedItemSource';
  type?: Maybe<SystemCuratedItemType>;
  recentExpertCuratedItemFromSimilarUserSource?: Maybe<RecentExpertCuratedItemFromSimilarUserSystemCuratedItemSource>;
  topRecommendedListSystemCuratedItemSource?: Maybe<TopRecommendedListSystemCuratedItemSource>;
};

export type TopRecommendedListSystemCuratedItemSource = SystemCuratedItemSource & {
  __typename: 'TopRecommendedListSystemCuratedItemSource';
  type?: Maybe<SystemCuratedItemType>;
  recommendedListDefinition: RecommendedListDefinition;
  dealRequest: DealRequest;
};

export type TotalCostForOfferInput = {
  id: Scalars['BroadcastOfferId'];
  address?: Maybe<AddressInput>;
  tip?: Maybe<MonetaryAmountInput>;
};

export type TotalCostForOfferPayload = {
  __typename: 'TotalCostForOfferPayload';
  address?: Maybe<Address>;
  price: MonetaryAmount;
  tax: MonetaryAmount;
  shippingCost: MonetaryAmount;
  totalCost: MonetaryAmount;
  tip?: Maybe<MonetaryAmount>;
};

export type TrackingGroupedOrderLineItems = GroupedOrderLineItems & {
  __typename: 'TrackingGroupedOrderLineItems';
  type: OrderLineItemsGroupingType;
  shipmentTracking?: Maybe<ShipmentTracking>;
  orderLineItems: Array<OrderLineItem>;
};

export type TrackingInquiryTicket = TicketDetail & {
  __typename: 'TrackingInquiryTicket';
  type: TicketType;
  consumer: User;
  order: Order;
  orderLineItemIds: Array<Scalars['OrderLineItemId']>;
};

export type TrackOnlineActivityInput = {
  id: Scalars['AnyId'];
};

export type TrackOnlineActivityPayload = {
  __typename: 'TrackOnlineActivityPayload';
  hasError: Scalars['Boolean'];
};

export type Transaction = {
  __typename: 'Transaction';
  id: Scalars['TransactionId'];
  createdAt: Scalars['Date'];
  updatedAt?: Maybe<Scalars['Date']>;
  orderId: Scalars['OrderId'];
  order: Order;
  status: TransactionStatus;
  type: TransactionType;
  request: TransactionRequest;
  response?: Maybe<TransactionResponse>;
};


export type TransactionRequest = {
  __typename: 'TransactionRequest';
  chargeAmount: MonetaryAmount;
  statementDescriptor: Scalars['String'];
  fullDescription?: Maybe<Scalars['String']>;
  paymentSourceType: PaymentProcessorType;
  paymentProcessorPlatformSourceId: Scalars['String'];
  paymentSourceUsage: PaymentSourceUsage;
};

export type TransactionResponse = {
  __typename: 'TransactionResponse';
  paymentProcessorTransactionId?: Maybe<Scalars['String']>;
  paymentSource?: Maybe<PaymentSource>;
  errorMessage?: Maybe<Scalars['String']>;
  userFriendlyErrorMessage?: Maybe<Scalars['String']>;
  sourceAccount?: Maybe<PaymentProcessorAccount>;
  destinationAccount?: Maybe<PaymentProcessorAccount>;
  /**
   * Statement descriptor is a protected field and only accessible to the admin.
   * this statement descriptor can be different from one in TransactionRequest and is specific to the PaymentProcessor.
   * It may be truncated or have additional metadata addded to it.
   */
  statementDescriptor?: Maybe<Scalars['String']>;
  /** the updating operator if this transaction was manually updated */
  updatedBy?: Maybe<Operator>;
  paymentVerificationMethod?: Maybe<PaymentVerificationMethod>;
};

export enum TransactionStatus {
  SUCCESS = 'SUCCESS',
  PENDING = 'PENDING',
  IN_REVIEW = 'IN_REVIEW',
  FAILURE = 'FAILURE',
  REFUNDED = 'REFUNDED',
  OFFLINE = 'OFFLINE',
  CANCELED = 'CANCELED'
}

export enum TransactionType {
  CUSTOMER = 'CUSTOMER',
  MERCHANT = 'MERCHANT'
}

export type TransferTicketInput = {
  ticketId: Scalars['TicketId'];
  transferToQueue: TicketQueue;
  comment?: Maybe<Scalars['String']>;
  reason: TransferTicketReason;
};

export enum TransferTicketReason {
  NEED_TO_CONTACT_CUSTOMER = 'NEED_TO_CONTACT_CUSTOMER',
  NEED_TO_CONTACT_MERCHANT = 'NEED_TO_CONTACT_MERCHANT',
  OTHER = 'OTHER',
  CUSTOMER_EXCEPTION = 'CUSTOMER_EXCEPTION',
  CLAIM_ITEM = 'CLAIM_ITEM',
  UNABLE_TO_VERIFY = 'UNABLE_TO_VERIFY'
}

export type TreatmentDefinition = {
  __typename: 'TreatmentDefinition';
  value: Scalars['String'];
  description: Scalars['String'];
};

export type TreatmentDefinitionInput = {
  value: Scalars['String'];
  description?: Maybe<Scalars['String']>;
};

export type Trigger = {
  __typename: 'Trigger';
  id: Scalars['TriggerId'];
  name: Scalars['String'];
  groupName: Scalars['String'];
  description: Scalars['String'];
  triggeredBy: TriggerEventMeta;
  entityMeta: TriggerEntityMeta;
  supportedActions: Array<TriggerActionMeta>;
  waitableEvents: Array<TriggerEventMeta>;
  nodes: Array<TriggerNode>;
  state: TriggerState;
  createdAt: Scalars['Date'];
  updatedAt: Scalars['Date'];
  publishedAt?: Maybe<Scalars['Date']>;
  deactivatedAt?: Maybe<Scalars['Date']>;
  namedQueries: Array<TemplateNamedQueryMeta>;
  campaign?: Maybe<CampaignUnion>;
  superseded?: Maybe<Trigger>;
  pendingDraft?: Maybe<Trigger>;
  versionNumber: Scalars['Int'];
  historyId?: Maybe<Scalars['TriggerVersionHistoryId']>;
  changes: Array<TriggerChange>;
  lastChangedBy?: Maybe<Operator>;
  parents: Array<TriggerParent>;
  rootTrigger: Scalars['Boolean'];
  synchronizationKey?: Maybe<TriggerParameter>;
  customQueueId: Array<TriggerParameter>;
};

export type TriggerAction = TriggerNode & {
  __typename: 'TriggerAction';
  id: Scalars['TriggerNodeId'];
  type: TriggerNodeType;
  name: Scalars['String'];
  parameters: Array<TriggerNamedParameter>;
  nextNodeId?: Maybe<Scalars['TriggerNodeId']>;
  templateType?: Maybe<CommTemplateType>;
};

export type TriggerActionMeta = {
  __typename: 'TriggerActionMeta';
  name: Scalars['String'];
  displayName: Scalars['String'];
  parameters: Array<TriggerParameterMeta>;
  internal: Scalars['Boolean'];
};

export type TriggerBinaryCondition = TriggerCondition & {
  __typename: 'TriggerBinaryCondition';
  type: TriggerConditionType;
  leftOperand: TriggerParameter;
  rightOperand: TriggerParameter;
  binaryOperator: TriggerFieldOperator;
};

export type TriggerBinaryConditionInput = {
  leftOperand: TriggerParameterInput;
  rightOperand: TriggerParameterInput;
  binaryOperator: Scalars['String'];
};

export type TriggerBranch = TriggerNode & {
  __typename: 'TriggerBranch';
  id: Scalars['TriggerNodeId'];
  type: TriggerNodeType;
  condition?: Maybe<TriggerCondition>;
  nodeIdIfTrue?: Maybe<Scalars['TriggerNodeId']>;
  nodeIdIfFalse?: Maybe<Scalars['TriggerNodeId']>;
};

export type TriggerChange = {
  __typename: 'TriggerChange';
  occurredAt: Scalars['Date'];
  notes?: Maybe<Scalars['String']>;
  type: TriggerChangeType;
  changedBy?: Maybe<Operator>;
};

export enum TriggerChangeType {
  CREATED = 'CREATED',
  PUBLISHED = 'PUBLISHED',
  DEACTIVATED = 'DEACTIVATED',
  ARCHIVED = 'ARCHIVED',
  IMPORTED = 'IMPORTED'
}

export type TriggerCondition = {
  type: TriggerConditionType;
};

export type TriggerConditionInput = {
  logicalCondition?: Maybe<TriggerLogicalConditionInput>;
  binaryCondition?: Maybe<TriggerBinaryConditionInput>;
  experimentCondition?: Maybe<TriggerExperimentConditionInput>;
};

export enum TriggerConditionType {
  LOGICAL = 'LOGICAL',
  BINARY = 'BINARY',
  EXPERIMENT = 'EXPERIMENT'
}

export type TriggerDelay = TriggerNode & {
  __typename: 'TriggerDelay';
  id: Scalars['TriggerNodeId'];
  type: TriggerNodeType;
  interval: TriggerDelayInterval;
  nextNodeId?: Maybe<Scalars['TriggerNodeId']>;
};

export type TriggerDelayDynamicInterval = TriggerDelayInterval & {
  __typename: 'TriggerDelayDynamicInterval';
  type: TriggerDelayIntervalType;
  timeParameter: TriggerParameter;
  before: Scalars['Boolean'];
  timeDifference: TriggerDuration;
};

export type TriggerDelayDynamicIntervalInput = {
  timeDifference: TriggerDurationInput;
  before: Scalars['Boolean'];
  timeParameter: TriggerParameterInput;
};

export type TriggerDelayFixedInterval = TriggerDelayInterval & {
  __typename: 'TriggerDelayFixedInterval';
  type: TriggerDelayIntervalType;
  minimalWaitTime: TriggerDuration;
  waitUntilLocalTime?: Maybe<TriggerLocalTimeRange>;
};

export type TriggerDelayFixedIntervalInput = {
  minimalWaitTime: TriggerDurationInput;
  waitUtilLocalTime?: Maybe<TriggerLocalTimeRangeInput>;
};

export type TriggerDelayInterval = {
  type: TriggerDelayIntervalType;
};

export type TriggerDelayIntervalTreatment = {
  __typename: 'TriggerDelayIntervalTreatment';
  treatments: Array<Scalars['String']>;
  interval: TriggerDelayFixedInterval;
};

export type TriggerDelayIntervalTreatmentInput = {
  treatments: Array<Scalars['String']>;
  fixedInterval: TriggerDelayFixedIntervalInput;
};

export enum TriggerDelayIntervalType {
  FIXED = 'FIXED',
  DYNAMIC = 'DYNAMIC',
  WITH_EXPERIMENT = 'WITH_EXPERIMENT'
}

export type TriggerDelayWithExperiment = TriggerDelayInterval & {
  __typename: 'TriggerDelayWithExperiment';
  type: TriggerDelayIntervalType;
  experiment: Scalars['String'];
  key: TriggerParameter;
  intervals: Array<TriggerDelayIntervalTreatment>;
};

export type TriggerDelayWithExperimentInput = {
  experiment: Scalars['String'];
  key: TriggerParameterInput;
  intervals: Array<TriggerDelayIntervalTreatmentInput>;
};

export type TriggerDuration = {
  __typename: 'TriggerDuration';
  unit: TriggerDurationUnit;
  amount: Scalars['Int'];
};

export type TriggerDurationInput = {
  unit: TriggerDurationUnit;
  amount: Scalars['Int'];
};

export enum TriggerDurationUnit {
  SECONDS = 'SECONDS',
  MINUTES = 'MINUTES',
  HOURS = 'HOURS',
  DAYS = 'DAYS'
}

export type TriggerEdge = {
  __typename: 'TriggerEdge';
  node: Trigger;
  cursor: Scalars['String'];
};

/** fields exists on an trigger entity */
export type TriggerEntityFieldMeta = {
  __typename: 'TriggerEntityFieldMeta';
  name: Scalars['String'];
  displayName: Scalars['String'];
  type: TriggerFieldType;
  idType?: Maybe<Scalars['String']>;
  enumValues?: Maybe<Array<Scalars['String']>>;
  experimentKey: Scalars['Boolean'];
  immutableField: Scalars['Boolean'];
  supportedOperators: Array<TriggerFieldOperator>;
  stringFieldType?: Maybe<StringFieldType>;
};

export type TriggerEntityFieldReference = {
  __typename: 'TriggerEntityFieldReference';
  type: TriggerParameterType;
  field: Scalars['String'];
};

/** Entities we can create trigger on, like User, Lead, Order and etc */
export type TriggerEntityMeta = {
  __typename: 'TriggerEntityMeta';
  name: Scalars['String'];
  displayName: Scalars['String'];
  fields: Array<TriggerEntityFieldMeta>;
};

export type TriggerEventMeta = {
  __typename: 'TriggerEventMeta';
  name: Scalars['String'];
  displayName: Scalars['String'];
  parameters: Array<TriggerParameterMeta>;
  entityId: TriggerParameterMeta;
  waitableEventAdditionalLookupKey?: Maybe<TriggerParameterMeta>;
  waitable: Scalars['Boolean'];
  groupName: Scalars['String'];
};

export type TriggerEventParameterReference = {
  __typename: 'TriggerEventParameterReference';
  type: TriggerParameterType;
  parameterName: Scalars['String'];
};

export type TriggerExperimentCondition = TriggerCondition & {
  __typename: 'TriggerExperimentCondition';
  type: TriggerConditionType;
  key: TriggerParameter;
  experiment: Scalars['String'];
  treatments: Array<Scalars['String']>;
};

export type TriggerExperimentConditionInput = {
  experiment: Scalars['String'];
  treatments: Array<Scalars['String']>;
  key: TriggerParameterInput;
};

export type TriggerExperimentUsage = ExperimentUsage & {
  __typename: 'TriggerExperimentUsage';
  type: ExperimentUsageType;
  triggerId: Scalars['TriggerId'];
  trigger: Trigger;
};

/**
 * operator supported for each trigger field type
 * for example, equals, greater_than
 */
export type TriggerFieldOperator = {
  __typename: 'TriggerFieldOperator';
  name: Scalars['String'];
  displayName: Scalars['String'];
  leftOperandType: TriggerFieldType;
  rightOperandType: TriggerFieldType;
};

/**
 * =============================
 * Trigger metadata.
 * =============================
 */
export enum TriggerFieldType {
  BOOLEAN = 'BOOLEAN',
  INTEGER = 'INTEGER',
  DECIMAL = 'DECIMAL',
  STRING = 'STRING',
  STRING_LIST = 'STRING_LIST',
  DATE = 'DATE',
  ID = 'ID',
  ID_LIST = 'ID_LIST'
}

export type TriggerFilter = TriggerNode & {
  __typename: 'TriggerFilter';
  id: Scalars['TriggerNodeId'];
  type: TriggerNodeType;
  condition?: Maybe<TriggerCondition>;
  nextNodeId?: Maybe<Scalars['TriggerNodeId']>;
};


export type TriggerJump = TriggerNode & {
  __typename: 'TriggerJump';
  id: Scalars['TriggerNodeId'];
  type: TriggerNodeType;
  jumpTo?: Maybe<Trigger>;
};

export type TriggerLiteralBooleanValue = {
  __typename: 'TriggerLiteralBooleanValue';
  type: TriggerParameterType;
  booleanValue: Scalars['Boolean'];
};

export type TriggerLiteralDateValue = {
  __typename: 'TriggerLiteralDateValue';
  type: TriggerParameterType;
  dateValue: Scalars['Date'];
};

export type TriggerLiteralDecimalValue = {
  __typename: 'TriggerLiteralDecimalValue';
  type: TriggerParameterType;
  decimalValue: Scalars['BigDecimal'];
};

export type TriggerLiteralIdListValue = {
  __typename: 'TriggerLiteralIdListValue';
  type: TriggerParameterType;
  idListValue: Array<Scalars['AnyId']>;
};

export type TriggerLiteralIdValue = {
  __typename: 'TriggerLiteralIdValue';
  type: TriggerParameterType;
  idValue: Scalars['AnyId'];
};

export type TriggerLiteralIntegerValue = {
  __typename: 'TriggerLiteralIntegerValue';
  type: TriggerParameterType;
  integerValue: Scalars['Int'];
};

export type TriggerLiteralStringListValue = {
  __typename: 'TriggerLiteralStringListValue';
  type: TriggerParameterType;
  stringListValue: Array<Scalars['String']>;
};

export type TriggerLiteralStringValue = {
  __typename: 'TriggerLiteralStringValue';
  type: TriggerParameterType;
  stringValue: Scalars['String'];
};

export type TriggerLiteralValue = TriggerLiteralBooleanValue | TriggerLiteralIntegerValue | TriggerLiteralDecimalValue | TriggerLiteralStringValue | TriggerLiteralStringListValue | TriggerLiteralDateValue | TriggerLiteralIdValue | TriggerLiteralIdListValue;

export type TriggerLocalTime = {
  __typename: 'TriggerLocalTime';
  /** 0-23 */
  hour: Scalars['Int'];
  minute: Scalars['Int'];
};

export type TriggerLocalTimeInput = {
  /** 0-23 */
  hour: Scalars['Int'];
  minute: Scalars['Int'];
};

export type TriggerLocalTimeRange = {
  __typename: 'TriggerLocalTimeRange';
  beginTime: TriggerLocalTime;
  endTime?: Maybe<TriggerLocalTime>;
  timeZone: TriggerParameter;
};

export type TriggerLocalTimeRangeInput = {
  beginTime: TriggerLocalTimeInput;
  endTime?: Maybe<TriggerLocalTimeInput>;
  timeZone: TriggerParameterInput;
};

export type TriggerLogicalCondition = TriggerCondition & {
  __typename: 'TriggerLogicalCondition';
  type: TriggerConditionType;
  conditions: Array<TriggerCondition>;
  logicalOperator: LogicalOperator;
};

export type TriggerLogicalConditionInput = {
  conditions: Array<TriggerConditionInput>;
  logicalOperator: LogicalOperator;
};

export type TriggerNamedParameter = {
  __typename: 'TriggerNamedParameter';
  name: Scalars['String'];
  value: TriggerParameter;
};

export type TriggerNamedParameterInput = {
  name: Scalars['String'];
  parameter: TriggerParameterInput;
};

export type TriggerNode = {
  id: Scalars['TriggerNodeId'];
  type: TriggerNodeType;
};

export enum TriggerNodeEdgeType {
  NEXT = 'NEXT',
  TRUE = 'TRUE',
  FALSE = 'FALSE'
}


export enum TriggerNodeType {
  DELAY = 'DELAY',
  FILTER = 'FILTER',
  BRANCH = 'BRANCH',
  ACTION = 'ACTION',
  WAIT = 'WAIT',
  JUMP = 'JUMP'
}

export type TriggerParameter = TriggerEntityFieldReference | TriggerEventParameterReference | TriggerLiteralBooleanValue | TriggerLiteralIntegerValue | TriggerLiteralDecimalValue | TriggerLiteralStringValue | TriggerLiteralStringListValue | TriggerLiteralDateValue | TriggerLiteralIdValue | TriggerLiteralIdListValue;

export type TriggerParameterInput = {
  type: TriggerParameterType;
  fieldName?: Maybe<Scalars['String']>;
  eventParameter?: Maybe<Scalars['String']>;
  booleanValue?: Maybe<Scalars['Boolean']>;
  stringValue?: Maybe<Scalars['String']>;
  integerValue?: Maybe<Scalars['Int']>;
  decimalValue?: Maybe<Scalars['BigDecimal']>;
  dateValue?: Maybe<Scalars['Date']>;
  idValue?: Maybe<Scalars['AnyId']>;
  stringListValue?: Maybe<Array<Scalars['String']>>;
  idListValue?: Maybe<Array<Scalars['AnyId']>>;
};

export type TriggerParameterMeta = {
  __typename: 'TriggerParameterMeta';
  name: Scalars['String'];
  displayName: Scalars['String'];
  type: TriggerFieldType;
  idType?: Maybe<Scalars['String']>;
  enumValues?: Maybe<Array<Scalars['String']>>;
  supportedOperators: Array<TriggerFieldOperator>;
  /** only applicable to TriggerActionMeta, N/A for TriggerEventMeta */
  required: Scalars['Boolean'];
  deprecated: Scalars['Boolean'];
  defaultValue?: Maybe<TriggerLiteralValue>;
  stringFieldType?: Maybe<StringFieldType>;
};

export enum TriggerParameterType {
  ENTITY_FIELD = 'ENTITY_FIELD',
  EVENT_PARAMETER = 'EVENT_PARAMETER',
  LITERAL_VALUE = 'LITERAL_VALUE'
}

export type TriggerParent = {
  __typename: 'TriggerParent';
  parent: Trigger;
  parentNodes: Array<TriggerNode>;
};

export type TriggerQuery = {
  eventName?: Maybe<Scalars['String']>;
  state?: Maybe<TriggerState>;
};

export type TriggersConnection = {
  __typename: 'TriggersConnection';
  facets: Array<DisplayFacet>;
  edges: Array<TriggerEdge>;
  pageInfo: PageInfo;
  count: Scalars['Int'];
};

export type TriggerSearchRequestInput = {
  keywords?: Maybe<Scalars['String']>;
  facets: Array<FacetSelection>;
  includeCampaignTriggers: Scalars['Boolean'];
  state?: Maybe<TriggerState>;
};

export enum TriggerSearchSort {
  CREATED_AT = 'CREATED_AT',
  PUBLISHED_AT = 'PUBLISHED_AT',
  TITLE = 'TITLE'
}

/**
 * =============================
 * Trigger instance
 * =============================
 */
export enum TriggerState {
  DRAFT = 'DRAFT',
  TEST = 'TEST',
  PUBLISHED = 'PUBLISHED',
  DEACTIVATED = 'DEACTIVATED',
  ARCHIVED = 'ARCHIVED'
}

export type TriggerValidationEntity = Trigger | CommTemplateType;

export type TriggerValidationErrors = {
  __typename: 'TriggerValidationErrors';
  entity: TriggerValidationEntity;
  errors: Array<Scalars['String']>;
};


export type TriggerWait = TriggerNode & {
  __typename: 'TriggerWait';
  id: Scalars['TriggerNodeId'];
  type: TriggerNodeType;
  eventName?: Maybe<Scalars['String']>;
  eventEntityId?: Maybe<TriggerParameter>;
  eventAdditionalLookupKey?: Maybe<TriggerNamedParameter>;
  maxWaitTime: TriggerDuration;
  nodeIdIfTrue?: Maybe<Scalars['TriggerNodeId']>;
  nodeIdIfFalse?: Maybe<Scalars['TriggerNodeId']>;
};

export type UnarchiveExperimentInput = {
  id: Scalars['ExperimentId'];
};

export type UnarchiveExperimentPayload = {
  __typename: 'UnarchiveExperimentPayload';
  experiment: ExperimentDefinition;
  errorMessage?: Maybe<Scalars['String']>;
  hasError: Scalars['Boolean'];
};

export type UnassignSupportTaskActivity = SupportTaskActivity & {
  __typename: 'UnassignSupportTaskActivity';
  id: Scalars['SupportTaskActivityId'];
  supportTask: SupportTask;
  action: SupportTaskAction;
  actor: SupportTaskActor;
  consumer: User;
  lead?: Maybe<Lead>;
  occurredAt: Scalars['Date'];
};

export type UnassignTicketInput = {
  ticketId: Scalars['TicketId'];
};

export type UnregisterFirebaseCloudMessagingTokenInput = {
  fcmToken: Scalars['String'];
};

export type UnregisterFirebaseCloudMessagingTokenPayload = {
  __typename: 'UnregisterFirebaseCloudMessagingTokenPayload';
  unregistered?: Maybe<Scalars['Boolean']>;
};

export type UnregisterWebPushSubscriptionInput = {
  subscription: Scalars['String'];
};

export type UnregisterWebPushSubscriptionPayload = {
  __typename: 'UnregisterWebPushSubscriptionPayload';
  unregistered: Scalars['Boolean'];
};

export enum UnsavedSellableReason {
  NOT_INTERESTED = 'NOT_INTERESTED',
  TOO_EXPENSIVE = 'TOO_EXPENSIVE',
  LOW_QUALITY = 'LOW_QUALITY',
  UGLY = 'UGLY',
  DONT_NEED = 'DONT_NEED',
  BOUGHT_ELSEWHERE = 'BOUGHT_ELSEWHERE'
}

export type UnsaveSavedSellableInput = {
  sellableId: Scalars['SellableId'];
  reason?: Maybe<UnsavedSellableReason>;
};

export type UnsaveSavedSellablePayload = {
  __typename: 'UnsaveSavedSellablePayload';
  savedSellable: SavedSellable;
};

export type UnsnoozeSupportTaskActivity = SupportTaskActivity & {
  __typename: 'UnsnoozeSupportTaskActivity';
  id: Scalars['SupportTaskActivityId'];
  supportTask: SupportTask;
  action: SupportTaskAction;
  actor: SupportTaskActor;
  consumer: User;
  lead?: Maybe<Lead>;
  occurredAt: Scalars['Date'];
  snoozedSupportTask: SupportTask;
};

export type UnsupportedNoteStateExpertCuratedItemNoteEditError = ErrorMessage & {
  __typename: 'UnsupportedNoteStateExpertCuratedItemNoteEditError';
  errorMessage: Scalars['String'];
  state: ExpertCuratedItemNoteState;
};

/** Updates only supports minimal field updates, the core address fields are immutable */
export type UpdateAddressPreferencesInput = {
  addressId: Scalars['AddressId'];
  userId: Scalars['UserId'];
  userFriendlyName?: Maybe<Scalars['String']>;
  isDefault?: Maybe<Scalars['Boolean']>;
};

export type UpdateAddressPreferencesPayload = {
  __typename: 'UpdateAddressPreferencesPayload';
  updatedAddress?: Maybe<Address>;
  error?: Maybe<Scalars['String']>;
};

export type UpdateAdHocSellablePriceInput = {
  sellableId: Scalars['SellableId'];
  salePrice?: Maybe<MonetaryAmountInput>;
};

export type UpdateAdHocSellablePricePayload = {
  __typename: 'UpdateAdHocSellablePricePayload';
  sellable?: Maybe<Sellable>;
  error?: Maybe<Scalars['String']>;
};

export type UpdateAlreadyExistsExpertCuratedItemEditError = ErrorMessage & {
  __typename: 'UpdateAlreadyExistsExpertCuratedItemEditError';
  errorMessage: Scalars['String'];
};

export type UpdateApprovalRequestSubmitDraftDependencyInput = {
  id: Scalars['AnyId'];
  markAsIncluded: Scalars['Boolean'];
};

export type UpdateApprovalRequestSubmitDraftInput = {
  id: Scalars['ApprovalRequestSubmitDraftId'];
  description?: Maybe<Scalars['String']>;
  dependency?: Maybe<UpdateApprovalRequestSubmitDraftDependencyInput>;
};

export type UpdateApprovalRequestSubmitDraftPayload = {
  __typename: 'UpdateApprovalRequestSubmitDraftPayload';
  approvalRequestSubmitDraft?: Maybe<ApprovalRequestSubmitDraft>;
  error?: Maybe<ApprovalRequestSubmitDraftEditError>;
};

export type UpdateArticleRevisionContentBlockInput = {
  id: Scalars['ArticleRevisionId'];
  contentBlockId: Scalars['ArticleContentBlockId'];
  contentBlock: ArticleContentBlockInput;
};

export type UpdateAttributeSchemaRevisionInput = {
  id: Scalars['AttributeSchemaRevisionId'];
  displayName?: Maybe<Scalars['String']>;
  description?: Maybe<Scalars['String']>;
  attributeFunctions?: Maybe<Array<AttributeFunction>>;
  attributeSearchFunctions?: Maybe<Array<AttributeSearchFunction>>;
  categoryIds?: Maybe<Array<Scalars['CategoryId']>>;
  displayTemplate?: Maybe<Scalars['String']>;
};

export type UpdateAttributeSchemaRevisionPayload = AttributeSchemaRevisionPayload & {
  __typename: 'UpdateAttributeSchemaRevisionPayload';
  hasError: Scalars['Boolean'];
  errorMessage?: Maybe<Scalars['String']>;
  attributeSchemaRevision?: Maybe<AttributeSchemaRevision>;
};

export type UpdateBusinessUserInput = {
  id: Scalars['BusinessUserId'];
  departmentId?: Maybe<Scalars['DepartmentId']>;
  phone?: Maybe<Scalars['String']>;
  email?: Maybe<Scalars['String']>;
  avatarUrl?: Maybe<Scalars['String']>;
  expertAttributes?: Maybe<ExpertAttributeInput>;
  teamId?: Maybe<Scalars['BusinessUserTeamId']>;
  payStructureId?: Maybe<Scalars['PayStructureId']>;
  featured?: Maybe<Scalars['Boolean']>;
  delisted?: Maybe<Scalars['Boolean']>;
  spotlightExpert?: Maybe<Scalars['Boolean']>;
  timeZone?: Maybe<Scalars['String']>;
};

export type UpdateBusinessUserPayload = {
  __typename: 'UpdateBusinessUserPayload';
  errors?: Maybe<Array<Scalars['String']>>;
  businessUser?: Maybe<BusinessUser>;
};

export type UpdateBusinessUserTeamInput = {
  teamId: Scalars['BusinessUserTeamId'];
  name?: Maybe<Scalars['String']>;
  teamLeadCommissionEligible?: Maybe<Scalars['Boolean']>;
};

export type UpdateBusinessUserTeamPayload = {
  __typename: 'UpdateBusinessUserTeamPayload';
  error?: Maybe<Scalars['String']>;
  businessUserTeam?: Maybe<BusinessUserTeam>;
};

export type UpdateBusinessUserVanityIdInput = {
  id: Scalars['BusinessUserId'];
};

export type UpdateCampaignAudienceInput = {
  id: Scalars['CampaignAudienceId'];
  name?: Maybe<Scalars['String']>;
  description?: Maybe<Scalars['String']>;
  keywords?: Maybe<Scalars['String']>;
  conditions?: Maybe<Array<SearchFilterFieldInput>>;
  tags?: Maybe<Array<Scalars['String']>>;
};

export type UpdateCampaignAudienceIntegrationInput = {
  campaignAudienceId: Scalars['CampaignAudienceId'];
  integrationId: Scalars['CampaignAudienceIntegrationId'];
  externalPlatform: CampaignAudienceExternalPlatform;
  facebook?: Maybe<CampaignAudienceFacebookIntegrationInput>;
};

export type UpdateCampaignAudienceIntegrationPayload = {
  __typename: 'UpdateCampaignAudienceIntegrationPayload';
  campaignAudience: CampaignAudience;
  hasError: Scalars['Boolean'];
  errorMessage?: Maybe<Scalars['String']>;
};

export type UpdateCampaignAudiencePayload = {
  __typename: 'UpdateCampaignAudiencePayload';
  campaignAudience: CampaignAudience;
  hasError: Scalars['Boolean'];
  errorMessage?: Maybe<Scalars['String']>;
};

export type UpdateCampaignInput = {
  id: Scalars['CampaignId'];
  name?: Maybe<Scalars['String']>;
  description?: Maybe<Scalars['String']>;
  maximumRecipients?: Maybe<Scalars['Int']>;
  leadCampaignSettings?: Maybe<LeadCampaignSettingsInput>;
  deliveryFrequency?: Maybe<CampaignDeliveryFrequency>;
  conditions?: Maybe<Array<SearchFilterFieldInput>>;
  audienceId?: Maybe<Scalars['CampaignAudienceId']>;
  keywords?: Maybe<Scalars['String']>;
  stopDeliveryAt?: Maybe<Scalars['Date']>;
};

export type UpdateCampaignPayload = {
  __typename: 'UpdateCampaignPayload';
  campaign?: Maybe<Campaign>;
  error?: Maybe<Scalars['String']>;
};

export type UpdateChannelTemplateInput = {
  templateId: Scalars['CommTemplateId'];
  channelType: ChannelType;
  emailTemplate?: Maybe<EmailTemplateInput>;
  smsTemplate?: Maybe<SmsTemplateInput>;
  inAppTemplate?: Maybe<InAppTemplateInput>;
  pushNotificationTemplate?: Maybe<PushNotificationTemplateInput>;
  slackTemplate?: Maybe<SlackTemplateInput>;
  facebookTemplate?: Maybe<FacebookTemplateInput>;
};

export type UpdateConfigInput = {
  domain: Scalars['String'];
  key: Scalars['String'];
  value: Scalars['String'];
};

export type UpdateConfigPayload = {
  __typename: 'UpdateConfigPayload';
  config?: Maybe<Config>;
  hasError: Scalars['Boolean'];
  errorMessage?: Maybe<Scalars['String']>;
};

export type UpdateConsumerExpertReviewInput = {
  id: Scalars['ConsumerExpertReviewId'];
  active?: Maybe<Scalars['Boolean']>;
  rating?: Maybe<Scalars['Int']>;
  headline?: Maybe<Scalars['String']>;
  comments?: Maybe<Scalars['String']>;
  goodQualities?: Maybe<Array<Scalars['String']>>;
  featured?: Maybe<Scalars['Boolean']>;
  spotlight?: Maybe<Scalars['Boolean']>;
};

export type UpdateConsumerExpertReviewPayload = {
  __typename: 'UpdateConsumerExpertReviewPayload';
  review: ConsumerExpertReview;
};

export type UpdateContentSelectionRuleInput = {
  ruleId: Scalars['ContentSelectionRuleId'];
  title?: Maybe<Scalars['String']>;
  pageKey?: Maybe<Scalars['String']>;
  deviceTypes?: Maybe<Array<ContentSelectionDeviceType>>;
  keyword?: Maybe<Scalars['String']>;
  guestOnly?: Maybe<Scalars['Boolean']>;
  active?: Maybe<Scalars['Boolean']>;
  adLevel?: Maybe<ContentSelectionAdLevel>;
  adValues?: Maybe<Array<Scalars['String']>>;
  selectionMethod?: Maybe<ContentSelectionMethodInput>;
  categoryIds?: Maybe<Array<Scalars['CategoryId']>>;
};

export type UpdateContentSelectionRulePayload = {
  __typename: 'UpdateContentSelectionRulePayload';
  errors?: Maybe<Array<Scalars['String']>>;
  rule?: Maybe<ContentSelectionRule>;
};

export type UpdatedCuratedItemsRichCard = MessageRichCard & {
  __typename: 'UpdatedCuratedItemsRichCard';
  type: MessageRichCardType;
  expertCuratedItemActivationId: Scalars['ExpertCuratedItemActivationId'];
};

export type UpdateDescriptionInput = {
  ticketId: Scalars['TicketId'];
  description: Scalars['String'];
};

export type UpdateDraftArticleRevisionInput = {
  id: Scalars['ArticleRevisionId'];
  title?: Maybe<Scalars['String']>;
  updateSlug?: Maybe<Scalars['Boolean']>;
  featuredImage?: Maybe<ArticleMediaInput>;
  summaryText?: Maybe<Scalars['String']>;
  authorIds?: Maybe<Array<Scalars['AnyId']>>;
  categoryIds?: Maybe<Array<Scalars['CategoryId']>>;
  brandIds?: Maybe<Array<Scalars['BrandId']>>;
};

export type UpdateDraftArticleRevisionPayload = {
  __typename: 'UpdateDraftArticleRevisionPayload';
  articleRevision: ArticleRevision;
  errorMessage?: Maybe<Scalars['String']>;
  hasError: Scalars['Boolean'];
};

export type UpdateExperimentInput = {
  id: Scalars['ExperimentId'];
  description?: Maybe<Scalars['String']>;
  backendOnly?: Maybe<Scalars['Boolean']>;
  treatments?: Maybe<Array<TreatmentDefinitionInput>>;
  rules?: Maybe<Array<RuleDefinitionInput>>;
};

export type UpdateExperimentPayload = {
  __typename: 'UpdateExperimentPayload';
  experiment: ExperimentDefinition;
  errorMessage?: Maybe<Scalars['String']>;
  hasError: Scalars['Boolean'];
};

export type UpdateExpertApplicationInput = {
  applicationId: Scalars['ExpertApplicationId'];
  tagsToAdd?: Maybe<Array<Scalars['String']>>;
  tagsToRemove?: Maybe<Array<Scalars['String']>>;
  videoInterviewUrl?: Maybe<Scalars['String']>;
  expectedCompletionDate?: Maybe<Scalars['LocalDate']>;
};

export type UpdateExpertApplicationPayload = {
  __typename: 'UpdateExpertApplicationPayload';
  error?: Maybe<Scalars['String']>;
  application?: Maybe<ExpertApplication>;
};

export type UpdateExpertApplicationTagsInput = {
  applicationId: Scalars['ExpertApplicationId'];
  tagsToAdd: Array<Scalars['String']>;
  tagsToRemove: Array<Scalars['String']>;
};

export type UpdateExpertApplicationTaskStatusInput = {
  applicationId: Scalars['ExpertApplicationId'];
  task: ExpertApplicationTaskType;
  status: Scalars['String'];
  externalId?: Maybe<Scalars['String']>;
};

export type UpdateExpertApplicationTaskStatusPayload = {
  __typename: 'UpdateExpertApplicationTaskStatusPayload';
  application: ExpertApplication;
};

export type UpdateExpertCuratedItemCustomizationInput = {
  id: Scalars['SellableId'];
  title?: Maybe<Scalars['String']>;
  price?: Maybe<MonetaryAmountInput>;
};

export type UpdateExpertCuratedItemFulfillmentNotesInput = {
  id: Scalars['ExpertCuratedItemId'];
  notes?: Maybe<Scalars['String']>;
};

export type UpdateExpertCuratedItemFulfillmentNotesPayload = {
  __typename: 'UpdateExpertCuratedItemFulfillmentNotesPayload';
  expertCuratedItem?: Maybe<ExpertCuratedItem>;
  error?: Maybe<Scalars['String']>;
};

export type UpdateExpertCuratedItemInput = {
  id: Scalars['ExpertCuratedItemId'];
  sellableId?: Maybe<Scalars['SellableId']>;
  priceOverride?: Maybe<MonetaryAmountInput>;
  discount?: Maybe<MonetaryAmountInput>;
  tag?: Maybe<ExpertCuratedItemTagInput>;
  shouldAddToCartOnActive?: Maybe<Scalars['Boolean']>;
  isBuiltFromRecommendation?: Maybe<Scalars['Boolean']>;
  draftNote?: Maybe<Scalars['String']>;
  noteId?: Maybe<Scalars['ExpertCuratedItemNoteId']>;
  fulfillmentNotes?: Maybe<ExpertCuratedItemFulfillmentNotesInput>;
  /** add or update customizations, matching on `SellableId` to determine if it's an insert or update */
  upsertCustomizations?: Maybe<Array<UpdateExpertCuratedItemCustomizationInput>>;
  /** remove customizations for matching `SellableId`s */
  removeCustomizations?: Maybe<Array<Scalars['SellableId']>>;
  /** Whehter to move item up or down in list */
  rankChange?: Maybe<ExpertCuratedItemRankChangeType>;
  /** convenience input to handle the logic for creating vs updating note */
  note?: Maybe<UpdateOrCreateExpertNoteInput>;
  bestOfferPrice?: Maybe<Scalars['Boolean']>;
};

export type UpdateExpertCuratedItemNoteAttributesInput = {
  id: Scalars['ExpertCuratedItemNoteId'];
  attributes: Array<AttributeInput>;
};

export type UpdateExpertCuratedItemNoteAttributesPayload = {
  __typename: 'UpdateExpertCuratedItemNoteAttributesPayload';
  expertCuratedItemNote?: Maybe<ExpertCuratedItemNote>;
  hasError: Scalars['Boolean'];
  errorMessage?: Maybe<Scalars['String']>;
};

export type UpdateExpertCuratedItemNoteInput = {
  id: Scalars['ExpertCuratedItemNoteId'];
  attributes: Array<AttributeInput>;
  prosAndCons?: Maybe<ExpertCuratedItemProsAndConsInput>;
};

export type UpdateExpertCuratedItemNotePayload = {
  __typename: 'UpdateExpertCuratedItemNotePayload';
  expertCuratedItemNote: ExpertCuratedItemNote;
  errorMessage?: Maybe<Scalars['String']>;
  hasError: Scalars['Boolean'];
  error?: Maybe<ExpertCuratedItemNoteEditError>;
};

export type UpdateExpertCuratedItemPayload = {
  __typename: 'UpdateExpertCuratedItemPayload';
  /**
   * The entity that as ultimately modified; may be a new/existing draft that's staged to replace the targeted curated
   * item
   */
  updated?: Maybe<ExpertCuratedItem>;
  /**
   * The entity that was targeted for update being staged to be removed once `updated` is activated (converted to non
   * draft status)
   */
  superseded?: Maybe<ExpertCuratedItem>;
  /** Deprecated. */
  errorType?: Maybe<ExpertCuratedItemWriteErrorType>;
  expertCuratedItemsForLead?: Maybe<ExpertCuratedItemsForLeadPayload>;
  expertCuratedItemsByCategories: ExpertCuratedItemsByCategories;
  hasError: Scalars['Boolean'];
  error?: Maybe<ExpertCuratedItemEditError>;
};


export type UpdateExpertCuratedItemPayloadExpertCuratedItemsForLeadArgs = {
  onlyFetchIfError: Scalars['Boolean'];
};

export type UpdateExpertCuratedOrderTermsInput = {
  id: Scalars['ExpertCuratedOrderId'];
  serviceStartsAt?: Maybe<Scalars['Date']>;
  availableForPurchaseDurationMinutes?: Maybe<Scalars['Int']>;
  minimumDepositPercent?: Maybe<Scalars['Int']>;
  prepaidIncidentalPercent?: Maybe<Scalars['Int']>;
  fullPaymentDueBeforeServiceStartDays?: Maybe<Scalars['Int']>;
  flightPlanId?: Maybe<Scalars['FlightPlanId']>;
  defaultManualTaxAdjustment?: Maybe<ExpertCuratedOrderManualTaxAdjustmentInput>;
  inPreview?: Maybe<Scalars['Boolean']>;
  expertNote?: Maybe<Scalars['String']>;
};

export type UpdateExpertCuratedOrderTermsPayload = {
  __typename: 'UpdateExpertCuratedOrderTermsPayload';
  expertCuratedOrder: ExpertCuratedOrder;
};

export type UpdateExpertCuratedOrderVariationOptionInput = {
  id: Scalars['SellableId'];
  price?: Maybe<MonetaryAmountInput>;
  enabled?: Maybe<Scalars['Boolean']>;
  selected?: Maybe<Scalars['Boolean']>;
  manualTaxAdjustment?: Maybe<ExpertCuratedOrderManualTaxAdjustmentInput>;
};

export type UpdateExpertCuratedOrderVariationOptionsInput = {
  id: Scalars['ExpertCuratedOrderId'];
  options: Array<UpdateExpertCuratedOrderVariationOptionInput>;
};

export type UpdateExpertCuratedOrderVariationOptionsPayload = {
  __typename: 'UpdateExpertCuratedOrderVariationOptionsPayload';
  expertCuratedOrder: ExpertCuratedOrder;
};

export type UpdateExpertLeadGateInput = {
  expertId: Scalars['BusinessUserId'];
  broadcastLeadClaimDisabled: Scalars['Boolean'];
  newLeadClaimDisabled: Scalars['Boolean'];
  message: Scalars['String'];
  detailedMessage?: Maybe<Scalars['String']>;
};

export type UpdateExpertProfileInput = {
  expertProfileId: Scalars['ExpertProfileId'];
  displayName?: Maybe<Scalars['String']>;
  /** @deprecated(reason: "Use displayName") */
  firstName?: Maybe<Scalars['String']>;
  /** @deprecated(reason: "Use displayName") */
  lastName?: Maybe<Scalars['String']>;
  profilePhotoId?: Maybe<Scalars['MediaId']>;
  headline?: Maybe<Scalars['String']>;
  background?: Maybe<Scalars['String']>;
  backgroundRichText?: Maybe<Scalars['String']>;
  quotes?: Maybe<Array<Scalars['String']>>;
  socialMediaUrls?: Maybe<Array<Scalars['String']>>;
  gallery?: Maybe<Array<MediaWithCaptionInput>>;
  recentArticles?: Maybe<Array<ExternalContentInput>>;
  highlights?: Maybe<Array<ProfileHighlightInput>>;
  introductionVideoUrl?: Maybe<Scalars['String']>;
  socialMediaAccessTokens?: Maybe<Array<SocialMediaAccessTokenInput>>;
  currentGearIds?: Maybe<Array<Scalars['SellableId']>>;
  favoriteBrandIds?: Maybe<Array<Scalars['BrandId']>>;
  gender?: Maybe<ExpertGender>;
  portraitVideoId?: Maybe<Scalars['MediaId']>;
  introductionVideoId?: Maybe<Scalars['MediaId']>;
  introductionVideo?: Maybe<ExternalVideoLinkInput>;
  spotlightHeadline?: Maybe<Scalars['String']>;
};

export type UpdateExpertProfilePayload = {
  __typename: 'UpdateExpertProfilePayload';
  expertProfile?: Maybe<ExpertProfile>;
  errors?: Maybe<Array<Scalars['String']>>;
};

export type UpdateExpertSpecialCareTagPayload = {
  __typename: 'UpdateExpertSpecialCareTagPayload';
  expert: BusinessUser;
};

export type UpdateExternalAdCampaignInput = {
  adCampaignId: Scalars['ExternalAdCampaignId'];
  status: ExternalAdStatus;
  normalizedBudget: Scalars['BigDecimal'];
};

export type UpdateExternalAdCampaignPayload = {
  __typename: 'UpdateExternalAdCampaignPayload';
  adCampaign: ExternalAdCampaign;
};

export type UpdateExternalAdGroupInput = {
  adGroupId: Scalars['ExternalAdGroupId'];
  status: ExternalAdStatus;
  normalizedBudget?: Maybe<Scalars['BigDecimal']>;
  campaignNormalizedBudget?: Maybe<Scalars['BigDecimal']>;
};

export type UpdateExternalAdGroupPayload = {
  __typename: 'UpdateExternalAdGroupPayload';
  adGroup: ExternalAdGroup;
};

export type UpdateFulfillmentChannelBlacklistInput = {
  id: Scalars['FulfillmentChannelId'];
  blacklisted: Scalars['Boolean'];
};

export type UpdateFulfillmentChannelMetadataInput = {
  id: Scalars['FulfillmentChannelId'];
  name: Scalars['String'];
  marginPercent?: Maybe<Scalars['Int']>;
  partnerSince?: Maybe<Scalars['Date']>;
  shipmentPricingTierType?: Maybe<ShipmentPricingTierType>;
  partnerCategoryIds?: Maybe<Array<Scalars['CategoryId']>>;
};

export type UpdateFulfillmentChannelPayload = {
  __typename: 'UpdateFulfillmentChannelPayload';
  fulfillmentChannel: FulfillmentChannel;
};

export type UpdateFulfillmentInstructionsInput = {
  id: Scalars['FulfillmentChannelId'];
  instructions: Scalars['String'];
};

export type UpdateFulfillmentTicketPayload = {
  __typename: 'UpdateFulfillmentTicketPayload';
  ticket: Ticket;
};

export type UpdateGiftCardOrderLineItemInput = {
  id: Scalars['OrderId'];
  lineItemId: Scalars['OrderLineItemId'];
  amount: MonetaryAmountInput;
  details?: Maybe<GiftCardDetailsInput>;
};

export type UpdateGiftCardOrderLineItemPayload = {
  __typename: 'UpdateGiftCardOrderLineItemPayload';
  order: Order;
};

export type UpdateGuestConversationSequenceInput = {
  id: Scalars['GuestConversationSequenceId'];
  name: Scalars['String'];
  messages: Array<GuestConversationSequenceMessageInput>;
};

export type UpdateGuestConversationSequencePayload = {
  __typename: 'UpdateGuestConversationSequencePayload';
  sequence: GuestConversationSequence;
};

export type UpdateLeadNoteInput = {
  id: Scalars['LeadNoteId'];
  text: Scalars['String'];
};

export type UpdateLeadNotePayload = {
  __typename: 'UpdateLeadNotePayload';
  note: SavedLeadNote;
};

export type UpdateLeadPayload = {
  __typename: 'UpdateLeadPayload';
  error?: Maybe<Scalars['String']>;
  lead?: Maybe<Lead>;
};

export type UpdateLeadSpecialCareTagPayload = {
  __typename: 'UpdateLeadSpecialCareTagPayload';
  lead: Lead;
};

export type UpdateLeadTrainingScenarioInput = {
  id: Scalars['LeadTrainingScenarioId'];
  title?: Maybe<Scalars['String']>;
  description?: Maybe<Scalars['String']>;
  active?: Maybe<Scalars['Boolean']>;
};

export type UpdateLeadTrainingScenarioPayload = {
  __typename: 'UpdateLeadTrainingScenarioPayload';
  trainingScenario?: Maybe<LeadTrainingScenario>;
  error?: Maybe<Scalars['String']>;
};

export type UpdateLineItemClaimInput = {
  fulfillmentOrderId: Scalars['FulfillmentOrderId'];
  lineItemCosts: Array<LineItemFulfillmentCostInput>;
  orderQuote: MonetaryAmountInput;
  shippingCost: MonetaryAmountInput;
  tax: MonetaryAmountInput;
  merchantEta?: Maybe<Scalars['Date']>;
  merchantMaxEta?: Maybe<Scalars['Date']>;
  merchantOrderId?: Maybe<Scalars['String']>;
};

export type UpdateMerchantInput = {
  id: Scalars['MerchantId'];
  /** Name cannot be unset; it must either be omitted, or set with a non-null value */
  name?: Maybe<Scalars['String']>;
  website?: Maybe<Scalars['String']>;
  address?: Maybe<PostalAddressInput>;
  logoUrl?: Maybe<Scalars['String']>;
  shippingNotificationsEmail?: Maybe<Scalars['String']>;
  state?: Maybe<MerchantState>;
  internal?: Maybe<Scalars['Boolean']>;
  estimatedMarginPercent?: Maybe<Scalars['Int']>;
  defaultCurrency?: Maybe<Scalars['String']>;
  fulfillmentChannelId?: Maybe<Scalars['FulfillmentChannelId']>;
};

export type UpdateMerchantPayload = {
  __typename: 'UpdateMerchantPayload';
  merchant: Merchant;
};

export type UpdateMerchantRefundInput = {
  orderRefundId: Scalars['OrderRefundId'];
  refundedAmount?: Maybe<MonetaryAmountInput>;
  lineItemRefunds?: Maybe<Array<OrderLineItemRefundInput>>;
  refundTax?: Maybe<MonetaryAmountInput>;
  refundShipping?: Maybe<MonetaryAmountInput>;
  refundedAt?: Maybe<Scalars['Date']>;
  refundNote?: Maybe<Scalars['String']>;
};

export type UpdateNoteForSavedExpertCuratedItemInput = {
  id: Scalars['SavedExpertCuratedItemsId'];
  itemId: Scalars['SellableId'];
  attributes: Array<AttributeInput>;
  prosAndCons?: Maybe<ExpertCuratedItemProsAndConsInput>;
};

export type UpdateNoteForSavedExpertCuratedItemPayload = {
  __typename: 'UpdateNoteForSavedExpertCuratedItemPayload';
  savedExpertCuratedItems?: Maybe<SavedExpertCuratedItems>;
  error?: Maybe<Scalars['String']>;
  hasError: Scalars['Boolean'];
  editError?: Maybe<SavedExpertCuratedItemsEditExpertCuratedItemNoteError>;
};

export type UpdateOperatorInput = {
  operatorId: Scalars['OperatorId'];
  active: Scalars['Boolean'];
  firstName?: Maybe<Scalars['String']>;
  lastName?: Maybe<Scalars['String']>;
  phone?: Maybe<Scalars['String']>;
  email?: Maybe<Scalars['String']>;
  roles: Array<OperatorRole>;
  /** @deprecated Use roles */
  isAdmin?: Maybe<Scalars['Boolean']>;
};

export type UpdateOperatorPayload = {
  __typename: 'UpdateOperatorPayload';
  operator?: Maybe<Operator>;
};

export type UpdateOrCreateExpertNoteInput = {
  attributes: Array<AttributeInput>;
  prosAndCons?: Maybe<ExpertCuratedItemProsAndConsInput>;
};

export type UpdateOrderEscalationPayload = {
  __typename: 'UpdateOrderEscalationPayload';
  orderEscalation: OrderEscalation;
};

export type UpdateOrderExpertContributionsInput = {
  orderId: Scalars['OrderId'];
  contributions: Array<OrderExpertContributionInput>;
  updateTips?: Maybe<Scalars['Boolean']>;
  orderEligibleForCommission?: Maybe<Scalars['Boolean']>;
};

export type UpdateOrderExpertContributionsPayload = {
  __typename: 'UpdateOrderExpertContributionsPayload';
  order: Order;
};

export type UpdateOrderPayload = {
  __typename: 'UpdateOrderPayload';
  order?: Maybe<Order>;
  hasError: Scalars['Boolean'];
  errors?: Maybe<Array<Scalars['String']>>;
};

export type UpdateOrderRefundPayload = {
  __typename: 'UpdateOrderRefundPayload';
  orderRefund: OrderRefundWithError;
};

export type UpdateOrderShippingAddressInput = {
  orderId: Scalars['OrderId'];
  shippingAddress?: Maybe<AddressInput>;
};

export type UpdateOrderShippingAddressPayload = {
  __typename: 'UpdateOrderShippingAddressPayload';
  order: Order;
  hasError: Scalars['Boolean'];
  errorMessage?: Maybe<Scalars['String']>;
};

export type UpdateOrderStateInput = {
  orderId: Scalars['OrderId'];
  newOrderState: OrderState;
};

export type UpdateOrderStatePayload = {
  __typename: 'UpdateOrderStatePayload';
  order?: Maybe<Order>;
  error?: Maybe<Scalars['String']>;
};

export type UpdatePaymentSourceInput = {
  id: Scalars['PaymentSourceId'];
  billingAddress: AddressInput;
  isDefault?: Maybe<Scalars['Boolean']>;
};

export type UpdatePaymentSourcePayload = {
  __typename: 'UpdatePaymentSourcePayload';
  paymentSource: PaymentSource;
};

export type UpdatePayoutPayload = {
  __typename: 'UpdatePayoutPayload';
  payout?: Maybe<Payout>;
  error?: Maybe<Scalars['String']>;
};

export type UpdatePayStructureRevisionInput = {
  id: Scalars['PayStructureRevisionId'];
  components: Array<PayComponentRuleInput>;
};

export type UpdatePayStructureRevisionPayload = {
  __typename: 'UpdatePayStructureRevisionPayload';
  revision?: Maybe<PayStructureRevision>;
  error?: Maybe<Scalars['String']>;
};

export type UpdateProductCatalogDraftInput = {
  revisionId: Scalars['ProductCatalogRevisionId'];
  requestedById: Scalars['AnyId'];
  title?: Maybe<Scalars['String']>;
  updateSlug?: Maybe<Scalars['Boolean']>;
  description?: Maybe<Scalars['String']>;
  brandId?: Maybe<Scalars['BrandId']>;
  imageIds?: Maybe<Array<Scalars['MediaId']>>;
  categoryIds?: Maybe<Array<Scalars['CategoryId']>>;
  titleVariationDimension?: Maybe<Scalars['Boolean']>;
  attributeVariationDimensions?: Maybe<Array<Scalars['String']>>;
  groupId?: Maybe<Scalars['ProductCatalogGroupId']>;
  gtin?: Maybe<Scalars['String']>;
  mpn?: Maybe<Scalars['String']>;
  listPrice?: Maybe<MonetaryAmountInput>;
  minimumAdvertisedPrice?: Maybe<MonetaryAmountInput>;
  salePriceOverride?: Maybe<MonetaryAmountInput>;
};

export type UpdateProductCatalogDraftPayload = {
  __typename: 'UpdateProductCatalogDraftPayload';
  revision: ProductCatalogRevision;
  error?: Maybe<ProductCatalogUpdateDraftError>;
};

export type UpdateProductCatalogGroupDraftInput = {
  revisionId: Scalars['ProductCatalogGroupRevisionId'];
  requestedById: Scalars['AnyId'];
  title?: Maybe<Scalars['String']>;
  updateSlug?: Maybe<Scalars['Boolean']>;
  description?: Maybe<Scalars['String']>;
  brandId?: Maybe<Scalars['BrandId']>;
  imageIds?: Maybe<Array<Scalars['MediaId']>>;
  categoryIds?: Maybe<Array<Scalars['CategoryId']>>;
  groupSku?: Maybe<Scalars['String']>;
};

export type UpdateProductCatalogGroupDraftPayload = {
  __typename: 'UpdateProductCatalogGroupDraftPayload';
  revision: ProductCatalogGroupRevision;
  error?: Maybe<ProductCatalogGroupUpdateDraftError>;
};

export type UpdateProductReturnDestinationInput = {
  ticketId: Scalars['TicketId'];
  destination: ProductReturnDestination;
  note: Scalars['String'];
};

export type UpdatePromotionInput = {
  id: Scalars['PromotionId'];
  /** If omitted, this field won't be modified. */
  code?: Maybe<Scalars['String']>;
  /** If omitted, this field won't be modified. */
  description?: Maybe<Scalars['String']>;
  /** If omitted, this field won't be modified. */
  template?: Maybe<Scalars['Boolean']>;
  /** If omitted, this field won't be modified. If set to null, usageLimit will be removed. */
  usageLimit?: Maybe<Scalars['Int']>;
  /** If omitted, this field won't be modified. If set to null, expiresAt will be removed. */
  expiresAt?: Maybe<Scalars['Date']>;
};

export type UpdatePromotionPayload = {
  __typename: 'UpdatePromotionPayload';
  promotion: Promotion;
};

export type UpdateQuantityForOrderInput = {
  /** If omitted, user context will be assumed and the user's current cart will be operated on */
  id?: Maybe<Scalars['OrderId']>;
  lineItems: Array<UpdateQuantityForOrderLineItemInput>;
};

export type UpdateQuantityForOrderLineItemInput = {
  id: Scalars['OrderLineItemId'];
  quantity: Scalars['Int'];
};

export type UpdateQuantityForOrderPayload = {
  __typename: 'UpdateQuantityForOrderPayload';
  order: Order;
};

export type UpdateQuickReplyInput = {
  id: Scalars['QuickReplyId'];
  name: Scalars['String'];
  text: Scalars['String'];
};

export type UpdateQuickReplyPayload = {
  __typename: 'UpdateQuickReplyPayload';
  quickReply: QuickReply;
};

export type UpdateRawSellableSourceInput = {
  id: Scalars['RawSellableSourceId'];
  name: Scalars['String'];
  merchantName?: Maybe<Scalars['String']>;
  state: RawSellableSourceState;
  fulfillmentChannelId?: Maybe<Scalars['FulfillmentChannelId']>;
  filter?: Maybe<RawSellableStandardizationRuleConditionInput>;
  spider?: Maybe<RawSellableSourceSpiderInput>;
  googleShoppingFeed?: Maybe<RawSellableSourceGoogleShoppingFeedInput>;
  googleShoppingSearch?: Maybe<RawSellableSourceGoogleShoppingSearchInput>;
  levelNineFeed?: Maybe<RawSellableSourceLevelNineFeedInput>;
  shopify?: Maybe<RawSellableSourceShopifyInput>;
  walmart?: Maybe<RawSellableSourceWalmartInput>;
  impact?: Maybe<RawSellableSourceImpactInput>;
};

export type UpdateRawSellableSourcePayload = {
  __typename: 'UpdateRawSellableSourcePayload';
  source?: Maybe<RawSellableSource>;
  hasError: Scalars['Boolean'];
  errors?: Maybe<Array<Scalars['String']>>;
};

export type UpdateRawSellableStandardizationRuleInput = {
  id: Scalars['RawSellableStandardizationRuleId'];
  name: Scalars['String'];
  sourceId?: Maybe<Scalars['RawSellableSourceId']>;
  priority: Scalars['Int'];
  condition: RawSellableStandardizationRuleConditionInput;
  actions: Array<RawSellableStandardizationActionInput>;
  state: RawSellableStandardizationRuleState;
};

export type UpdateRawSellableStandardizationRulePayload = {
  __typename: 'UpdateRawSellableStandardizationRulePayload';
  rule?: Maybe<RawSellableStandardizationRule>;
  hasError: Scalars['Boolean'];
  errors?: Maybe<Array<Scalars['String']>>;
};

export type UpdateRecommendedListDefinitionInput = {
  id: Scalars['RecommendedListDefinitionId'];
  /** User friendly name for this recommended list definition */
  name?: Maybe<Scalars['String']>;
  /**
   * The title template that will be used to build the RecommendedList title shown to the consumer.
   * The template should use the freemarker style `${variable}` format for inserting any dynamic values in the resolved title.
   * For example: "Because you like ${attribute.brands}"
   * Note, the querable attributes from the title will be used as a hard filter in the RecommenedList result.
   * For example, if the title said "Because you like
   * ${attribute.brands.displayName}", then the result will only include
   * recommendations
   * that strictly match the brands
   */
  titleTemplate?: Maybe<Scalars['String']>;
  /**
   * The subtitle template that will be used to build the RecommendedList's subtitle shown to the consumer
   * The template should use the freemarker style `${variable}` format for
   * inserting any dynamic values in the resolved subtitle.
   * This is mainly used to provide some additional context the recommended list
   * and for display purpose only with the resolved string.
   */
  subTitleTemplate?: Maybe<Scalars['String']>;
  active?: Maybe<Scalars['Boolean']>;
  /**
   * The relative rank of the RecommendedList built using this definition compared to other RecommendedList
   * when the user sees a list of RecommendedList
   */
  rank?: Maybe<Scalars['Int']>;
  /** The categories for which this RecommendedListDefinition is being built. */
  categoryIds?: Maybe<Array<Scalars['CategoryId']>>;
  /** The filtering facets to refine recommended list results */
  queryFacets?: Maybe<Array<RecommendedListFacetSelectionInput>>;
  /** defaults to relevance based sorting */
  sortOptions?: Maybe<Array<RecommendedListSortOrderInput>>;
};

export type UpdateRecommendedListDefinitionPayload = {
  __typename: 'UpdateRecommendedListDefinitionPayload';
  recommendedListDefinition: RecommendedListDefinition;
};

export type UpdateReportInput = {
  reportId: Scalars['ReportId'];
  title: Scalars['String'];
  /** Must be globally unique if specified */
  internalName?: Maybe<Scalars['String']>;
  query: Scalars['String'];
  columns: Array<ReportColumnInput>;
  scope: ReportAccessScope;
  /** If specified, the columns from the schema are automatically added to the columns */
  schemaType?: Maybe<ReportSchemaType>;
};

export type UpdateReportPayload = {
  __typename: 'UpdateReportPayload';
  report: Report;
  errors?: Maybe<Array<Maybe<Scalars['String']>>>;
};

export type UpdateSavedCurationCuratedItemInput = {
  id: Scalars['SavedExpertCuratedItemsId'];
  itemId: Scalars['SellableId'];
  rankChange?: Maybe<ExpertCuratedItemRankChangeType>;
  tag?: Maybe<ExpertCuratedItemTagInput>;
  fulfillmentNotes?: Maybe<ExpertCuratedItemFulfillmentNotesInput>;
};

export type UpdateSavedCurationCuratedItemPayload = {
  __typename: 'UpdateSavedCurationCuratedItemPayload';
  savedExpertCuratedItems?: Maybe<SavedExpertCuratedItems>;
  error?: Maybe<Scalars['String']>;
  hasError: Scalars['Boolean'];
};

export type UpdateSavedExpertCuratedItemsInput = {
  id: Scalars['SavedExpertCuratedItemsId'];
  name?: Maybe<Scalars['String']>;
  /** Optional description for this curation */
  description?: Maybe<Scalars['String']>;
  taggedRequestAttributes?: Maybe<Array<AttributeInput>>;
};

export type UpdateSavedExpertCuratedItemsPayload = {
  __typename: 'UpdateSavedExpertCuratedItemsPayload';
  data?: Maybe<SavedExpertCuratedItems>;
  error?: Maybe<Scalars['String']>;
  hasError: Scalars['Boolean'];
};

export type UpdateSchedulingDemandForecastInput = {
  id: Scalars['SchedulingDemandForecastId'];
  startsAt: Scalars['Date'];
  endsAt: Scalars['Date'];
  shiftsRequired: Scalars['Int'];
};

export type UpdateSchedulingDemandForecastPayload = {
  __typename: 'UpdateSchedulingDemandForecastPayload';
  error?: Maybe<Scalars['String']>;
  forecast?: Maybe<SchedulingDemandForecast>;
};

export type UpdateSchedulingTypeInput = {
  schedulingTypeId: Scalars['SchedulingTypeId'];
  settings: Array<SchedulingUserSettingsInput>;
};

export type UpdateSchedulingTypePayload = {
  __typename: 'UpdateSchedulingTypePayload';
  error?: Maybe<Scalars['String']>;
  schedulingType?: Maybe<SchedulingType>;
};

export type UpdateSchedulingUserPayload = {
  __typename: 'UpdateSchedulingUserPayload';
  schedulingUser?: Maybe<SchedulingUser>;
  error?: Maybe<Scalars['String']>;
};

export type UpdateSchedulingUserProfileInput = {
  userId: Scalars['AnyId'];
  schedulingTypeId: Scalars['SchedulingTypeId'];
  weeklyMaxShiftsOverride?: Maybe<Scalars['Int']>;
  dailyMaxShiftsOverride?: Maybe<Scalars['Int']>;
  priorityOverride?: Maybe<Scalars['Int']>;
};

export type UpdateSchedulingUserRolesInput = {
  schedulingUserId: Scalars['AnyId'];
  roles: Array<SchedulingUserRole>;
  daysDisabledForShifts?: Maybe<Array<DayOfWeek>>;
};

export type UpdateSellableCustomOfferRuleInput = {
  ruleId: Scalars['SellableCustomOfferRuleId'];
  departmentId?: Maybe<Scalars['DepartmentId']>;
  type?: Maybe<SellableCustomOfferRuleType>;
  sourceUrl?: Maybe<Scalars['String']>;
  sourceName?: Maybe<Scalars['String']>;
  blacklist?: Maybe<Scalars['Boolean']>;
  active?: Maybe<Scalars['Boolean']>;
};

export type UpdateSellableCustomOfferRulePayload = {
  __typename: 'UpdateSellableCustomOfferRulePayload';
  rule?: Maybe<SellableCustomOfferRule>;
  error?: Maybe<Scalars['String']>;
};

export type UpdateSellableInput = {
  id: Scalars['SellableId'];
  /** strike out price of this sellable */
  originalPrice?: Maybe<MonetaryAmountInput>;
  /** default price we sell to consumer */
  salePrice?: Maybe<MonetaryAmountInput>;
  /** best offer price we sell to consumer which is not publically shown */
  bestOfferPrice?: Maybe<MonetaryAmountInput>;
  /** title */
  title?: Maybe<Scalars['String']>;
  /** description in markdown format */
  descriptionMarkdown?: Maybe<Scalars['String']>;
  /** images */
  imageIds?: Maybe<Array<Scalars['MediaId']>>;
  /** external videos */
  externalVideoUrls?: Maybe<Array<Scalars['String']>>;
  /** brochure */
  brochureUrl?: Maybe<Scalars['String']>;
  /** update slug to the title, may update even if the title is not updated */
  updateSlug?: Maybe<Scalars['Boolean']>;
  /** if the update should be applied to all other variants in the group */
  allVariants?: Maybe<Scalars['Boolean']>;
};

export type UpdateSellablePayload = {
  __typename: 'UpdateSellablePayload';
  sellable: Sellable;
  errorMessage?: Maybe<Scalars['String']>;
  hasError: Scalars['Boolean'];
};

export type UpdateSellableQuestionInput = {
  id: Scalars['SellableQuestionId'];
  state?: Maybe<SellableQuestionState>;
};

export type UpdateSellableQuestionPayload = {
  __typename: 'UpdateSellableQuestionPayload';
  question: SellableQuestion;
  errorMessage?: Maybe<Scalars['String']>;
};

export type UpdateSellableTopListInput = {
  id: Scalars['SellableTopListDefinitionId'];
  title?: Maybe<Scalars['String']>;
  description?: Maybe<Scalars['String']>;
  facets?: Maybe<Array<FacetSelection>>;
  featuredImage?: Maybe<MediaWithCaptionInput>;
  titleForSlug?: Maybe<Scalars['String']>;
  featured?: Maybe<Scalars['Boolean']>;
  departmentId?: Maybe<Scalars['DepartmentId']>;
};

export type UpdateSellableTopListPayload = {
  __typename: 'UpdateSellableTopListPayload';
  definition?: Maybe<SellableTopListDefinition>;
  errorMessage?: Maybe<Scalars['String']>;
};

/** `address` or `rawAddress` is required */
export type UpdateServiceLocationExpertCuratedOrderInput = {
  id: Scalars['ExpertCuratedOrderId'];
  address?: Maybe<PostalAddressInput>;
  /**
   * If entered, this will be geolocated and standardized into a `PostalAddress`. On geolocation failure, the
   * payload will have an appropriate errorCode and message.
   */
  rawAddress?: Maybe<Scalars['String']>;
};

export type UpdateServiceLocationExpertCuratedOrderPayload = {
  __typename: 'UpdateServiceLocationExpertCuratedOrderPayload';
  expertCuratedOrder: ExpertCuratedOrder;
  errorCode?: Maybe<ExpertCuratedOrderServiceLocationErrorCode>;
  hasError: Scalars['Boolean'];
  errorMessage?: Maybe<Scalars['String']>;
};

export type UpdateShiftInput = {
  shiftSlotId: Scalars['ShiftSlotId'];
};

export type UpdateShiftPayload = {
  __typename: 'UpdateShiftPayload';
  error?: Maybe<Scalars['String']>;
  shiftSlotUserView?: Maybe<ShiftSlotUserView>;
};

export type UpdateShipmentPricingModelInput = {
  id: Scalars['ShipmentPricingModelId'];
  regularOrderProcessingDays?: Maybe<Scalars['Int']>;
  customOrderProcessingDays?: Maybe<Scalars['Int']>;
  departmentId: Scalars['DepartmentId'];
  tierType: ShipmentPricingTierType;
  pricingOptionsInputs: Array<ShipmentPricingOptionInput>;
};

export type UpdateShipmentPricingModelPayload = {
  __typename: 'UpdateShipmentPricingModelPayload';
  shipmentPricingModel?: Maybe<ShipmentPricingModel>;
  error?: Maybe<Scalars['String']>;
};

export type UpdateShippingMethodInput = {
  orderId: Scalars['OrderId'];
  shippingMethod: ShippingMethod;
};

export type UpdateShippingMethodPayload = {
  __typename: 'UpdateShippingMethodPayload';
  order: Order;
};

export type UpdateShippingOptionsInput = {
  orderId: Scalars['OrderId'];
  shippingOptionsInput: Array<ShippingOptionInput>;
};

export type UpdateSupportConversationPayload = {
  __typename: 'UpdateSupportConversationPayload';
  supportConversation: SupportConversation;
};

export type UpdateTemplateFragmentInput = {
  id: Scalars['CommTemplateFragmentId'];
  title?: Maybe<Scalars['String']>;
  description?: Maybe<Scalars['String']>;
  content?: Maybe<Scalars['String']>;
  type?: Maybe<TemplateFragmentType>;
  nestedContentAllowed?: Maybe<Scalars['Boolean']>;
  nestedContentExample?: Maybe<Scalars['String']>;
  parameters?: Maybe<Array<Maybe<TemplateFragmentParameterInput>>>;
};

export type UpdateTemplateFragmentPayload = {
  __typename: 'UpdateTemplateFragmentPayload';
  fragment?: Maybe<CommTemplateFragment>;
  errors?: Maybe<Array<Scalars['String']>>;
};

export type UpdateTemplateInput = {
  templateId: Scalars['CommTemplateId'];
  title?: Maybe<Scalars['String']>;
  categoryId?: Maybe<Scalars['CategoryId']>;
  categoryType?: Maybe<CategoryType>;
  experimentKey?: Maybe<Scalars['String']>;
  treatments?: Maybe<Array<Scalars['String']>>;
  tagSyntax?: Maybe<TemplateTagSyntax>;
  emailFromAddress?: Maybe<Scalars['String']>;
};

export type UpdateTemplatePayload = {
  __typename: 'UpdateTemplatePayload';
  multiLocaleTemplate?: Maybe<MultiLocaleTemplateSet>;
  errors?: Maybe<Array<Scalars['String']>>;
};

export type UpdateTemplateTypeInput = {
  templateTypeId: Scalars['CommTemplateTypeId'];
  group: TemplateTypeGroup;
  unsubscribeTag?: Maybe<MessageUnsubscribeTag>;
  notificationType?: Maybe<NotificationType>;
  displayName: Scalars['String'];
  description: Scalars['String'];
  richCardType?: Maybe<MessageRichCardType>;
  richCardDataModel?: Maybe<MessageRichCardDataModelInput>;
  dataModel: TemplateDataModelInput;
  frequencyCaps?: Maybe<Array<TemplateMessageFrequencyCapRuleInput>>;
};

export type UpdateTemplateTypePayload = {
  __typename: 'UpdateTemplateTypePayload';
  error?: Maybe<Scalars['String']>;
  templateType?: Maybe<CommTemplateType>;
};

export type UpdateTicketPayload = {
  __typename: 'UpdateTicketPayload';
  ticket: Ticket;
};

export type UpdateTriggerActionInput = {
  triggerId: Scalars['TriggerId'];
  nodeId: Scalars['TriggerNodeId'];
  actionName: Scalars['String'];
  parameters: Array<TriggerNamedParameterInput>;
};

export type UpdateTriggerBranchInput = {
  triggerId: Scalars['TriggerId'];
  nodeId: Scalars['TriggerNodeId'];
  condition: TriggerConditionInput;
};

export type UpdateTriggerDelayInput = {
  triggerId: Scalars['TriggerId'];
  nodeId: Scalars['TriggerNodeId'];
  fixedInterval?: Maybe<TriggerDelayFixedIntervalInput>;
  delayWithExperiment?: Maybe<TriggerDelayWithExperimentInput>;
  dynamicInterval?: Maybe<TriggerDelayDynamicIntervalInput>;
};

export type UpdateTriggerEdgeInput = {
  triggerId: Scalars['TriggerId'];
  nodeId: Scalars['TriggerNodeId'];
  edgeType: TriggerNodeEdgeType;
  nextNodeId: Scalars['TriggerNodeId'];
};

export type UpdateTriggerFilterInput = {
  triggerId: Scalars['TriggerId'];
  nodeId: Scalars['TriggerNodeId'];
  condition: TriggerConditionInput;
};

export type UpdateTriggerInput = {
  triggerId: Scalars['TriggerId'];
  name?: Maybe<Scalars['String']>;
  groupName?: Maybe<Scalars['String']>;
  description?: Maybe<Scalars['String']>;
  synchronizationKey?: Maybe<TriggerParameterInput>;
  customQueueId?: Maybe<Array<TriggerParameterInput>>;
};

export type UpdateTriggerPayload = {
  __typename: 'UpdateTriggerPayload';
  trigger: Trigger;
};

export type UpdateTriggerWaitInput = {
  triggerId: Scalars['TriggerId'];
  nodeId: Scalars['TriggerNodeId'];
  eventName: Scalars['String'];
  eventEntityId: TriggerParameterInput;
  eventAdditionalLookupKey?: Maybe<TriggerNamedParameterInput>;
  maxWaitTime: TriggerDurationInput;
};

export type UpdateUserProfileInput = {
  userId?: Maybe<Scalars['UserId']>;
  firstName?: Maybe<Scalars['String']>;
  lastName?: Maybe<Scalars['String']>;
  phone?: Maybe<Scalars['String']>;
  email?: Maybe<Scalars['String']>;
  address?: Maybe<PostalAddressInput>;
  /** @deprecated use address */
  addressLine1?: Maybe<Scalars['String']>;
  /** @deprecated use address */
  addressLine2?: Maybe<Scalars['String']>;
  /** @deprecated use address */
  city?: Maybe<Scalars['String']>;
  /** @deprecated use address */
  state?: Maybe<Scalars['String']>;
  /** @deprecated use address */
  postalCode?: Maybe<Scalars['String']>;
  /** @deprecated use address */
  country?: Maybe<Scalars['String']>;
  notificationSettings?: Maybe<Array<NotificationSettingInput>>;
};

export type UpdateUserProfilePayload = {
  __typename: 'UpdateUserProfilePayload';
  user: User;
  errorCode?: Maybe<UserEditErrorCode>;
  hasError: Scalars['Boolean'];
  errors: Array<Scalars['String']>;
};

export type UpdateUserSourceInput = {
  userId: Scalars['UserId'];
  type: EditableUserSourceType;
};

export type UpdateUserSourcePayload = {
  __typename: 'UpdateUserSourcePayload';
  user: User;
  errorCode?: Maybe<UserEditErrorCode>;
  hasError: Scalars['Boolean'];
  errors: Array<Scalars['String']>;
};

export enum UpdateUserSourceToReferralErrorCode {
  NOT_ELIGIBLE = 'NOT_ELIGIBLE',
  REFERRER_NOT_FOUND = 'REFERRER_NOT_FOUND'
}

export type UpdateUserSourceToReferralResult = {
  __typename: 'UpdateUserSourceToReferralResult';
  consumer: User;
  hasError: Scalars['Boolean'];
  errorCode?: Maybe<UpdateUserSourceToReferralErrorCode>;
  errorMessage?: Maybe<Scalars['String']>;
};


export type UploadBrandsInput = {
  googleSpreadsheetId: Scalars['String'];
};

export type UploadBrandsPayload = {
  __typename: 'UploadBrandsPayload';
  task?: Maybe<FrontendTask>;
};

export type UploadExpertDiscountCashInput = {
  googleSpreadsheetId: Scalars['String'];
};

export type UploadExpertDiscountCashPayload = {
  __typename: 'UploadExpertDiscountCashPayload';
  task?: Maybe<FrontendTask>;
};

export type UploadFeaturedSellableContentInput = {
  mediaId: Scalars['MediaId'];
};

export type UploadFeaturedSellableContentPayload = {
  __typename: 'UploadFeaturedSellableContentPayload';
  task?: Maybe<FrontendTask>;
};

export type UploadInvoicedShippingCostInput = {
  googleSpreadsheetId: Scalars['String'];
};

export type UploadInvoicedShippingCostPayload = {
  __typename: 'UploadInvoicedShippingCostPayload';
  task?: Maybe<FrontendTask>;
};

export type UploadMediaError = UploadMediaNoFileError;

export type UploadMediaInput = {
  /** This parameter is not required because of the iOS graphql client limitation */
  file?: Maybe<Scalars['Upload']>;
  persist?: Maybe<Scalars['Boolean']>;
  mimeType?: Maybe<Scalars['String']>;
};

export type UploadMediaNoFileError = ErrorMessage & {
  __typename: 'UploadMediaNoFileError';
  errorMessage: Scalars['String'];
};

export type UploadMediaPayload = {
  __typename: 'UploadMediaPayload';
  mediaFile?: Maybe<MediaFile>;
  error?: Maybe<UploadMediaError>;
};

export type UploadMerchantsInput = {
  googleSpreadsheetId: Scalars['String'];
  categoryId: Scalars['CategoryId'];
};

export type UploadMerchantsPayload = {
  __typename: 'UploadMerchantsPayload';
  task?: Maybe<FrontendTask>;
};

export type UploadSellableDeactivationsInput = {
  googleSpreadsheetId: Scalars['String'];
  deactivateVariations?: Maybe<Scalars['Boolean']>;
};

export type UploadSellableDeactivationsPayload = {
  __typename: 'UploadSellableDeactivationsPayload';
  task?: Maybe<FrontendTask>;
};

export type UploadSellableInventoryInput = {
  googleSpreadsheetId: Scalars['String'];
  categoryId: Scalars['CategoryId'];
  fulfillmentCenterId?: Maybe<Scalars['FulfillmentCenterId']>;
  /** UPS sheet download is not generated for multiple tab uploads */
  multiTabUpload?: Maybe<Scalars['Boolean']>;
  /**
   * Partner inventory like dropshipped products are managed on a different shopify instance.
   * They are also not saved in our database during import as a SellableInventoryItem
   */
  partnerInventory?: Maybe<Scalars['Boolean']>;
  /**
   * If the uploaded sheet is for items were previously ordered.
   * This has implications on how the PurchaseOrder details are saved. In case of re-orders a new entry is created
   * otherwise, any existing purchase order information is overwritten with the new details in the sheet.
   */
  reOrderedInventory?: Maybe<Scalars['Boolean']>;
};

export type UploadSellableInventoryPayload = {
  __typename: 'UploadSellableInventoryPayload';
  task?: Maybe<FrontendTask>;
};

export type UploadSellablePriceInput = {
  googleSpreadsheetId: Scalars['String'];
  /** this field is deprecated and ignored */
  categoryId?: Maybe<Scalars['CategoryId']>;
};

export type UploadSellablePricePayload = {
  __typename: 'UploadSellablePricePayload';
  task?: Maybe<FrontendTask>;
};

export type UploadSellablesInput = {
  googleSpreadsheetId: Scalars['String'];
  filterGoogleSpreadsheetId?: Maybe<Scalars['String']>;
  categoryId: Scalars['CategoryId'];
};

export type UploadSellablesPayload = {
  __typename: 'UploadSellablesPayload';
  task?: Maybe<FrontendTask>;
};

export type UploadSellableUpdatesInput = {
  googleSpreadsheetId: Scalars['String'];
};

export type UploadSellableUpdatesPayload = {
  __typename: 'UploadSellableUpdatesPayload';
  task?: Maybe<FrontendTask>;
};

export type UpsertActionIntoPromotionInput = {
  id: Scalars['PromotionId'];
  /** If specified, the existing action with this same expectedReference id will be updated */
  referenceId?: Maybe<Scalars['PromotionActionReferenceId']>;
  action: PromotionActionReferenceInput;
};

export type UpsertActionIntoPromotionPayload = {
  __typename: 'UpsertActionIntoPromotionPayload';
  promotion: Promotion;
};

export type UpsertEnumEntriesIntoAttributeSchemaRevisionInput = {
  id: Scalars['AttributeSchemaRevisionId'];
  enumEntries: Array<UpsertEnumEntryIntoAttributeSchemaRevisionInput>;
};

export type UpsertEnumEntriesIntoAttributeSchemaRevisionPayload = AttributeSchemaRevisionPayload & {
  __typename: 'UpsertEnumEntriesIntoAttributeSchemaRevisionPayload';
  hasError: Scalars['Boolean'];
  errorMessage?: Maybe<Scalars['String']>;
  attributeSchemaRevision?: Maybe<AttributeSchemaRevision>;
};

export type UpsertEnumEntryIntoAttributeSchemaRevisionInput = {
  name: Scalars['String'];
  displayName?: Maybe<Scalars['String']>;
  subDisplayName?: Maybe<Scalars['String']>;
  categoryId?: Maybe<Scalars['CategoryId']>;
  proCon?: Maybe<Scalars['Boolean']>;
  proConDisplayName?: Maybe<Scalars['String']>;
  deprecateWithMessage?: Maybe<Scalars['String']>;
};

export type UpsertExpertCuratedLeadItineraryInput = {
  id: Scalars['LeadId'];
  contentfulVariation: Scalars['String'];
};

export type UpsertExpertCuratedLeadItineraryPayload = {
  __typename: 'UpsertExpertCuratedLeadItineraryPayload';
  expertCuratedLeadItinerary: ExpertCuratedLeadItinerary;
};

export type UpsertItemInExpertCuratedOrderInput = {
  id: Scalars['SellableId'];
  title?: Maybe<Scalars['String']>;
  price?: Maybe<MonetaryAmountInput>;
  /** Defaults to true */
  taxable?: Maybe<Scalars['Boolean']>;
  /** Defaults to true */
  optional?: Maybe<Scalars['Boolean']>;
  manualTaxAdjustment?: Maybe<ExpertCuratedOrderManualTaxAdjustmentInput>;
};

export type UpsertItemsInExpertCuratedOrderInput = {
  id: Scalars['ExpertCuratedOrderId'];
  items: Array<UpsertItemInExpertCuratedOrderInput>;
};

export type UpsertItemsInExpertCuratedOrderPayload = {
  __typename: 'UpsertItemsInExpertCuratedOrderPayload';
  expertCuratedOrder: ExpertCuratedOrder;
};

export type UpsertLegsIntoFlightPlanInput = {
  id: Scalars['FlightPlanId'];
  legs: Array<FlightPlanLegUpsertRequestInput>;
};

export type UpsertLegsIntoFlightPlanPayload = {
  __typename: 'UpsertLegsIntoFlightPlanPayload';
  flightPlan: FlightPlan;
  errorCode?: Maybe<FlightPlanEditErrorCode>;
  hasError: Scalars['Boolean'];
  errorMessage?: Maybe<Scalars['String']>;
};

export type UpsertMetadataIntoAttributeSchemaRevisionInput = {
  id: Scalars['AttributeSchemaRevisionId'];
  metadata: AttributeSchemaMetadataInput;
};

export type UpsertMetadataIntoAttributeSchemaRevisionPayload = AttributeSchemaRevisionPayload & {
  __typename: 'UpsertMetadataIntoAttributeSchemaRevisionPayload';
  hasError: Scalars['Boolean'];
  errorMessage?: Maybe<Scalars['String']>;
  attributeSchemaRevision?: Maybe<AttributeSchemaRevision>;
};

export type UpsertRuleIntoPromotionInput = {
  id: Scalars['PromotionId'];
  /** If specified, the existing rule with this same expectedReference id will be updated */
  referenceId?: Maybe<Scalars['PromotionRuleReferenceId']>;
  rule: PromotionRuleReferenceInput;
};

export type UpsertRuleIntoPromotionPayload = {
  __typename: 'UpsertRuleIntoPromotionPayload';
  promotion: Promotion;
};

export type UpsertValidatorIntoAttributeSchemaRevisionInput = {
  id: Scalars['AttributeSchemaRevisionId'];
  /** If specified, the existing validator reference  with this same referenceId will be updated */
  referenceId?: Maybe<Scalars['AttributeValidatorReferenceId']>;
  validatorReference: AttributeValidatorReferenceInput;
};

export type UpsertValidatorIntoAttributeSchemaRevisionPayload = AttributeSchemaRevisionPayload & {
  __typename: 'UpsertValidatorIntoAttributeSchemaRevisionPayload';
  hasError: Scalars['Boolean'];
  errorMessage?: Maybe<Scalars['String']>;
  attributeSchemaRevision?: Maybe<AttributeSchemaRevision>;
};

export type User = {
  __typename: 'User';
  /**
   * This needs to AnyId instead of UserId since it is used with other identity objects such as BusinessUser
   * in a few union type.  Graphql will complain if the same field return different types
   */
  id: Scalars['AnyId'];
  firstName?: Maybe<Scalars['String']>;
  /** AUTH | Only current user and operator */
  lastName?: Maybe<Scalars['String']>;
  /** AUTH | Only current user and operator */
  contacts: Array<Contact>;
  /** AUTH | Only current user */
  roles: Array<Scalars['String']>;
  /**
   * AUTH | Only current user
   * @deprecated Use messagingUser.id
   */
  messagingUserId: Scalars['AnyId'];
  messagingUser: MessagingUser;
  /** AUTH | Only current user, merchant, or operator */
  profilePhoto?: Maybe<MediaFile>;
  /** AUTH | Only current user, operator.  address saved on the user profile. */
  address?: Maybe<PostalAddress>;
  /** AUTH | Only current user, operator.  addressed saved for payment */
  savedAddresses: Array<Address>;
  /** AUTH | Only current user, operator */
  assignedOperatorSeat?: Maybe<Operator>;
  assignedBusinessUsers: Array<BusinessUser>;
  externalProfiles: Array<ExternalProfile>;
  presence: PresenceStatus;
  anonymous: Scalars['Boolean'];
  pathUrl: Scalars['String'];
  browseUrl: Scalars['String'];
  recentCompletedPathIds: Array<Scalars['PathFlowId']>;
  recentIncompletePathIds: Array<Scalars['PathFlowId']>;
  firstCompletedRequest?: Maybe<DealRequest>;
  mostRecentRequest?: Maybe<DealRequest>;
  /** most recent lead sorted by activity time or creation date */
  mostRecentLead?: Maybe<Lead>;
  zoneId: Scalars['String'];
  /**
   * use hasPhoneNumber instead of phoneNumber to check if the user has phone number
   * since phoneNumber can be null if the viewer doesn't have  permission
   */
  hasPhoneNumber: Scalars['Boolean'];
  /**
   * use hasEmail instead of email to check if the user has phone number
   * since email can be null if the viewer doesn't have  permission
   */
  hasEmail: Scalars['Boolean'];
  phoneNumber?: Maybe<Scalars['String']>;
  email?: Maybe<Scalars['String']>;
  facebookMessengerId?: Maybe<Scalars['String']>;
  referredBy?: Maybe<User>;
  vip: Scalars['Boolean'];
  organic: Scalars['Boolean'];
  referral: Scalars['Boolean'];
  internal: Scalars['Boolean'];
  orders: Array<Order>;
  source?: Maybe<UserSource>;
  ipBasedData?: Maybe<IpBasedUserData>;
  adminUrl: Scalars['String'];
  /** Globally unique referral code */
  referralCode?: Maybe<Scalars['String']>;
  experimentUserId: Scalars['AnyId'];
  isAllowedToRefer: Scalars['Boolean'];
  sourceHistory: Array<UserSource>;
  experimentAttributes: Array<ExperimentSubjectAttribute>;
  registrationChannel?: Maybe<UserRegistrationChannel>;
  tickets: Array<Ticket>;
  storeCreditAccount: LedgerAccount;
  internalLeadTrainingUser: Scalars['Boolean'];
  createdAt: Scalars['Date'];
  notificationSettings: Array<NotificationSetting>;
  consumerExpertReviewConnection: ConsumerExpertReviewConnection;
  expertReviews: Array<ConsumerExpertReview>;
  viewSellableActivities: Array<ViewSellableUserActivity>;
  summarizedViewSellableActivities: Array<SummarizedViewSellableUserActivity>;
  summarizedActivities: Array<SummarizedUserActivity>;
  userJourneyStages: Array<UserJourneyStage>;
  referredByReferralCode?: Maybe<ReferralCode>;
};


export type UserExternalProfilesArgs = {
  type?: Maybe<ExternalProfileType>;
  premium?: Maybe<Scalars['Boolean']>;
};


export type UserPathUrlArgs = {
  pathFlowId: Scalars['PathFlowId'];
};


export type UserBrowseUrlArgs = {
  pathFlowId: Scalars['PathFlowId'];
};


export type UserMostRecentLeadArgs = {
  sortBy?: Maybe<LeadSortOrder>;
};


export type UserTicketsArgs = {
  states?: Maybe<Array<TicketState>>;
  limit?: Maybe<Scalars['Int']>;
};


export type UserConsumerExpertReviewConnectionArgs = {
  expertId?: Maybe<Scalars['BusinessUserId']>;
  after?: Maybe<Scalars['String']>;
  first?: Maybe<Scalars['Int']>;
  before?: Maybe<Scalars['String']>;
  last?: Maybe<Scalars['Int']>;
};


export type UserExpertReviewsArgs = {
  expertId?: Maybe<Scalars['BusinessUserId']>;
};


export type UserViewSellableActivitiesArgs = {
  categoryId?: Maybe<Scalars['CategoryId']>;
  categoryIds?: Maybe<Array<Scalars['CategoryId']>>;
  occurredSince?: Maybe<Scalars['Date']>;
  limit?: Maybe<Scalars['Int']>;
};


export type UserSummarizedViewSellableActivitiesArgs = {
  categoryId?: Maybe<Scalars['CategoryId']>;
  categoryIds?: Maybe<Array<Scalars['CategoryId']>>;
  occurredSince?: Maybe<Scalars['Date']>;
  limit?: Maybe<Scalars['Int']>;
};


export type UserSummarizedActivitiesArgs = {
  categoryIds?: Maybe<Array<Scalars['CategoryId']>>;
  leadIds?: Maybe<Array<Scalars['LeadId']>>;
  occurredSince?: Maybe<Scalars['Date']>;
  occurredBefore?: Maybe<Scalars['Date']>;
  limit?: Maybe<Scalars['Int']>;
};

export type UserActivity = {
  id: Scalars['UserActivityId'];
  userId: Scalars['UserId'];
  type: UserActivityType;
  occurredAt: Scalars['Date'];
};


export enum UserActivityType {
  ADD_SELLABLE = 'ADD_SELLABLE',
  CHECKOUT_STARTED = 'CHECKOUT_STARTED',
  COMPLETE_ORDER = 'COMPLETE_ORDER',
  CURATED_LIST_VIEWED = 'CURATED_LIST_VIEWED',
  PAYMENT_INFO_ENTERED = 'PAYMENT_INFO_ENTERED',
  REMOVE_SELLABLE = 'REMOVE_SELLABLE',
  SEARCH_SELLABLES = 'SEARCH_SELLABLES',
  VIEW_CART = 'VIEW_CART',
  VIEW_SELLABLE = 'VIEW_SELLABLE',
  VOICE_CALL = 'VOICE_CALL',
  SAVED_SELLABLE = 'SAVED_SELLABLE',
  UNSAVED_SELLABLE = 'UNSAVED_SELLABLE'
}

/** ====== UserContactPathFlowQuestion */
export type UserContactPathFlowQuestion = PathFlowQuestion & {
  __typename: 'UserContactPathFlowQuestion';
  internalName: Scalars['String'];
  questionText?: Maybe<TextViewModel>;
  questionSubText?: Maybe<TextViewModel>;
  required: Scalars['Boolean'];
  inputIconImage?: Maybe<ImageViewModel>;
  inputLabel?: Maybe<TextViewModel>;
  attributes: Array<Attribute>;
  attribute?: Maybe<Attribute>;
  firstName?: Maybe<EmbeddedInputTextPathFlowQuestion>;
  lastName?: Maybe<EmbeddedInputTextPathFlowQuestion>;
  phoneNumber?: Maybe<EmbeddedInputTextPathFlowQuestion>;
  /** If reloading a question answered by the user, this is their previous input */
  userContactUserInput: SubmitUserContactPathFlowQuestionInputTypeCopy;
};


/** ====== UserContactPathFlowQuestion */
export type UserContactPathFlowQuestionAttributeArgs = {
  attributeName?: Maybe<Scalars['String']>;
};

export enum UserEditErrorCode {
  FIRST_NAME_REQUIRED = 'FIRST_NAME_REQUIRED',
  INVALID_CONTACT = 'INVALID_CONTACT'
}


export type UserJourneyLeadStage = UserJourneyStage & {
  __typename: 'UserJourneyLeadStage';
  type: UserJourneyStageType;
  leadStageStatus: UserJourneyLeadStageStatus;
  lead: Lead;
};

export enum UserJourneyLeadStageStatus {
  NO_CURATION = 'NO_CURATION',
  CURATION_READY = 'CURATION_READY',
  OLD_CURATION = 'OLD_CURATION'
}

export type UserJourneyNewStage = UserJourneyStage & {
  __typename: 'UserJourneyNewStage';
  type: UserJourneyStageType;
};

export type UserJourneyOrderStage = UserJourneyStage & {
  __typename: 'UserJourneyOrderStage';
  type: UserJourneyStageType;
  orderStageStatus: UserJourneyOrderStageStatus;
  order: Order;
};

export enum UserJourneyOrderStageStatus {
  PLACED = 'PLACED',
  IN_TRANSIT = 'IN_TRANSIT',
  DELIVERED = 'DELIVERED'
}

export type UserJourneyStage = {
  type: UserJourneyStageType;
};

export enum UserJourneyStageType {
  NEW = 'NEW',
  LEAD = 'LEAD',
  ORDER = 'ORDER'
}

export type UserLocation = {
  __typename: 'UserLocation';
  city?: Maybe<Scalars['String']>;
  state?: Maybe<Scalars['String']>;
  country: Scalars['String'];
  postalCode: Scalars['String'];
};

export type UserRegistration = {
  __typename: 'UserRegistration';
  id: Scalars['UserRegistrationId'];
  startedAt: Scalars['Date'];
  completedAt?: Maybe<Scalars['Date']>;
  channel: UserRegistrationChannel;
  user?: Maybe<User>;
  phoneNumber?: Maybe<Scalars['String']>;
  email?: Maybe<Scalars['String']>;
  category: Category;
};

export enum UserRegistrationChannel {
  PRE_FILLED_SMS = 'PRE_FILLED_SMS'
}


export type UserSearchQuery = {
  keywords?: Maybe<Scalars['String']>;
  firstName?: Maybe<Scalars['String']>;
  lastName?: Maybe<Scalars['String']>;
  email?: Maybe<Scalars['String']>;
  phone?: Maybe<Scalars['String']>;
};

export type UserSource = {
  __typename: 'UserSource';
  type: UserSourceType;
  initialUrl?: Maybe<Scalars['String']>;
  referrerUrl?: Maybe<Scalars['String']>;
  attributes: Array<UserSourceAttribute>;
  landingPageKey?: Maybe<Scalars['String']>;
  /**
   * ONLY to be used for the campaign side as a means of marking the department at the time of the user's registration.
   * This is not a reliable means of deriving the user's first or last touch attribution.
   */
  registrationDepartment?: Maybe<Department>;
  referralCode?: Maybe<ReferralCode>;
  occurredAt?: Maybe<Scalars['Date']>;
};

export type UserSourceAttribute = {
  __typename: 'UserSourceAttribute';
  name: Scalars['String'];
  value: Scalars['String'];
};

export enum UserSourceType {
  ADS = 'ADS',
  REFERRAL = 'REFERRAL',
  EXPERT_REFERRAL = 'EXPERT_REFERRAL',
  PHONE_CALL = 'PHONE_CALL',
  SMS = 'SMS',
  EMAIL = 'EMAIL',
  INVESTOR = 'INVESTOR',
  PARTNER = 'PARTNER',
  ORGANIC = 'ORGANIC'
}

export type UsersPagination = {
  __typename: 'UsersPagination';
  totalCount: Scalars['Long'];
  users: Array<User>;
  count: Scalars['Long'];
};

/** Limit the amount of times a user can use a given promotion */
export type UserUsageLimitPromotionRuleReference = PromotionRuleReference & {
  __typename: 'UserUsageLimitPromotionRuleReference';
  id: Scalars['PromotionRuleReferenceId'];
  type: PromotionRuleType;
  /** The maximum amount of times the user can utilize this promotion. */
  limit: Scalars['Int'];
};

/** See `UserUsageLimitPromotionRuleReference` for documentation */
export type UserUsageLimitPromotionRuleReferenceInput = {
  limit: Scalars['Int'];
};

export type ValidateSmsPromotionRegistrationInput = {
  registrationId: Scalars['String'];
};

export type ValidateSmsPromotionRegistrationPayload = {
  __typename: 'ValidateSmsPromotionRegistrationPayload';
  valid: Scalars['Boolean'];
};

export type ValidateTriggerInput = {
  triggerId: Scalars['TriggerId'];
};

export type ValidateTriggerPayload = {
  __typename: 'ValidateTriggerPayload';
  errors: Array<TriggerValidationErrors>;
};

export type ValidEmailAddressAttributeValidatorReference = AttributeValidatorReference & {
  __typename: 'ValidEmailAddressAttributeValidatorReference';
  id: Scalars['AttributeValidatorReferenceId'];
  type: AttributeValidatorType;
};

export type ValidEmailAddressAttributeValidatorReferenceInput = {
  _?: Maybe<Scalars['Boolean']>;
};

export type VariationDimensionSellableRemoveAttributeError = ErrorMessage & {
  __typename: 'VariationDimensionSellableRemoveAttributeError';
  errorMessage: Scalars['String'];
};

/**
 * A matrix of related sellables.
 * 
 * There are three hierarchies to this data structure; this variation matrix, the set of dimensions it contains, and
 * vectors for each dimension. Rather than defining these in abstract terms, lets work off of a simple example sellable.
 * 
 * Lets assume there's a parent sellable for "Nike T-Shirt", and it can vary on color (red, blue) and size (small,
 * medium, large). To understand the vocabulary used here, envision a matrix with two axis, "Color" on X, and "Size" on
 * Y. Each column will be marked with a color (red or blue), and each row will be marked with a size (small, medium, or
 * large). Each cell is a unique sellable variant (e.g.: Large Red Nike T-Shirt).
 * 
 * This is how the above concept is represented with the variation matrix data structures:
 * 
 * - VariationMatrix: This class which represents the entire matrix. This only contains variations, so in our example
 *   this will contain "Medium Red" and "Small Blue" T-Shirts, but doesn't contain the top level "Nike T-Shirt" sellable.
 * - VariationMatrixDimension: A dimension (axis) which a sellable can vary. In our example, there
 *   will be two dimensions; Size and Color. These are the axis on our matrix.
 * - VariationMatrixVector: For each of the dimensions, there will be a vector (a row or column) in the matrix that
 *   represents a unique value for that dimension. For example, if the dimension is "Color", a Vector may be labled with
 *   "red". Note that this is not a "cell" of a matrix which would represent a single SellableId (like "Medium Red"), this
 *   represents the entire column/row. So for the "red" vector, it will contain three SellableIds: "Small red", "Medium
 *   red", and "Large red". See following sections for how to use this data.
 * 
 * To allow for seamless client UIs that don't require network communication when flipping between variants, API calls
 * are not required to compute what variants are applicable as variants or selected, or to get the final sellable id
 * after all variants are selected. Instead, two things are provided:
 * 
 * 
 * - All of the related SellableIds that are part of this variation matrix (via sellables property). This is guaranteed
 *   to contain all variations, so it's possible to pre-load these sellables to provide a seamless UI that show details of
 *   sellables as variants are selected / moused over without going back to the network.
 * - For each vector (e.g.: color red), the SellableIds that match that criteria (via VariationMatrixVector.sellableIds).
 * 
 * To compute what sellables (if any) are applicable, take the intersection of the SellableIds for each selected vector
 * in each dimension (there should only be one selected vector per dimension). This computation will result in zero or
 * one SellableIds - zero if there are no sellables for that variation combination, or one which will be the sellable for
 * that variation combination.
 */
export type VariationMatrix = {
  __typename: 'VariationMatrix';
  /**
   * Dimensions for this variation matrix; a dimension is something like "color", "size", "gender", etc.
   * Each dimension will contain at least one vector
   */
  dimensions: Array<VariationMatrixDimension>;
  /** All of the sellable ids that are inside of this variation matrix, excluding the parent sellable. */
  sellables: Array<Sellable>;
  /**
   * The price range across only in-stock sellables in the variation matrix;
   * or the price range across all sellables in the variation matrix if none of the sellables are in-stock,
   */
  priceRange?: Maybe<VariationMatrixPriceRange>;
  /**
   * The MSRP price range across only in-stock sellables in the variation matrix;
   * or the MSRP price range across all sellables in the variation matrix if none of the sellables are in-stock,
   */
  originalPriceRange?: Maybe<VariationMatrixPriceRange>;
  /** The preferred sellable variant to show by default */
  defaultVariant: Sellable;
  /**
   * Variant that has the maximum delta between original price (MSRP) and sale price. If none of the variants provide
   * savings over MSRP, this will be the cheapest variant
   */
  maximumSavingsVariant: Sellable;
  /**
   * The maximum delta between original price (MSRP) and sale price across all variations. If none of the variants
   * provide savings over MSRP, this will be null.
   */
  maximumSavingsAmount?: Maybe<MonetaryAmount>;
  /**
   * The maximum percent savings between original price (MSRP) and sale price across all variations. If none of the
   * variants provide savings over MSRP, this will be null.
   */
  maximumSavingsPercent?: Maybe<Scalars['Float']>;
  /** All out of stock sellables that are inside of this variation matrix. */
  outOfStockSellables: Array<Sellable>;
};

/** Dimensions represent categories of things that are varied on, like color, size, gender, etc. */
export type VariationMatrixDimension = {
  __typename: 'VariationMatrixDimension';
  /** Internal name for this variation matrix dimension; not intended to be displayed in the UI */
  name: Scalars['String'];
  /**
   * Display name for this dimension.
   * This may be something like "Color", "Length", where it effectively serves as a title for the vectors within this
   * dimension. Note that this display name is not required. For example, if there is only one dimension, and that's a
   * title dimension, the grouping may not be titled. For title dimensions, each vector may be the shortened product
   * title, e.g.: "Red Special Edition", "Anniversary Edition", "Game of the year bundle".
   */
  displayName?: Maybe<Scalars['String']>;
  /**
   * Vectors (unique options) within this dimension.
   * 
   * If this dimension is color, vectors will represent concrete values like "Red", "Blue", "Black", etc.
   */
  vectors: Array<VariationMatrixVector>;
};

export type VariationMatrixPriceRange = {
  __typename: 'VariationMatrixPriceRange';
  min: MonetaryAmount;
  max: MonetaryAmount;
};

/**
 * A unique option within a dimension.
 * For example, if this vector is contained inside of the "color" dimension, this may represent the color "red".
 */
export type VariationMatrixVector = {
  __typename: 'VariationMatrixVector';
  /** Internal value for this vector; not to be displayed in the UI. Expect this to be things like "RED", "123", "WOMAN", etc. */
  value: Scalars['String'];
  /**
   * Display value formatted as sanitized HTML. To match with the value property examples, expect this to be things like
   * "Red", "123cm", "Woman", etc.
   */
  displayValueHtml: Scalars['String'];
  /**
   * All of the sellable ids (subset of VariationMatrix.sellables) that fall into this vector.
   * See the docs associated with VariationMatrix to see how these SellableIds should be used.
   */
  sellableIds: Array<Scalars['SellableId']>;
};

export type VerifyHandleChallengeInput = {
  /** handle/handleType or handleId must be present */
  handle?: Maybe<Scalars['String']>;
  handleType?: Maybe<HandleType>;
  handleId?: Maybe<Scalars['AnyId']>;
  challenge: Scalars['String'];
};

export type VerifyHandleChallengePayload = {
  __typename: 'VerifyHandleChallengePayload';
  success: Scalars['Boolean'];
  message?: Maybe<Scalars['String']>;
};

export type VerifyOrderInput = {
  orderId: Scalars['OrderId'];
  orderLineItemId: Scalars['OrderLineItemId'];
  note: Scalars['String'];
  verificationSuccessful: Scalars['Boolean'];
};

export type VerifyPaymentTransactionInput = {
  orderId: Scalars['OrderId'];
  transactionId: Scalars['TransactionId'];
  code?: Maybe<Scalars['String']>;
  amount?: Maybe<MonetaryAmountInput>;
  approvedByAdminId?: Maybe<Scalars['OperatorId']>;
};

export type VerifyPaymentTransactionPayload = {
  __typename: 'VerifyPaymentTransactionPayload';
  order: Order;
  verified: Scalars['Boolean'];
  error?: Maybe<Scalars['String']>;
};

export enum VerifyPendingAccessContactErrorCode {
  INVALID_TOKEN = 'INVALID_TOKEN'
}

export type VerifyPendingAccessContactInput = {
  id: Scalars['PendingAccessContactId'];
  token: Scalars['String'];
};

export type VerifyPendingAccessContactPayload = {
  __typename: 'VerifyPendingAccessContactPayload';
  pendingAccessContact?: Maybe<PendingAccessContact>;
  hasError: Scalars['Boolean'];
  errorCode?: Maybe<VerifyPendingAccessContactErrorCode>;
  errorMessage?: Maybe<Scalars['String']>;
};

export type VerifyResetPasswordChallengeInput = {
  handle?: Maybe<Scalars['String']>;
  handleType?: Maybe<HandleType>;
  challenge: Scalars['String'];
};

export type VerifyResetPasswordChallengePayload = {
  __typename: 'VerifyResetPasswordChallengePayload';
  success: Scalars['Boolean'];
  message?: Maybe<Scalars['String']>;
  session: Session;
};

export type ViewSellableUserActivity = UserActivity & {
  __typename: 'ViewSellableUserActivity';
  id: Scalars['UserActivityId'];
  userId: Scalars['UserId'];
  type: UserActivityType;
  occurredAt: Scalars['Date'];
  endedAt?: Maybe<Scalars['Date']>;
  sellable: Sellable;
};

export type VisitPathGraphFlowInput = {
  id: Scalars['PathGraphFlowId'];
};

export type VisitPathGraphFlowPayload = EncodedAuthenticationTokensPayload & {
  __typename: 'VisitPathGraphFlowPayload';
  pathGraphFlow?: Maybe<PathGraphFlow>;
  encodedAuthenticationTokens?: Maybe<EncodedAuthenticationTokens>;
  error?: Maybe<NavigatePathGraphFlowError>;
};

export type VoiceCallUserActivity = UserActivity & {
  __typename: 'VoiceCallUserActivity';
  id: Scalars['UserActivityId'];
  userId: Scalars['UserId'];
  type: UserActivityType;
  expertId: Scalars['BusinessUserId'];
  userPhoneNumber: Scalars['String'];
  status: Scalars['String'];
  callId: Scalars['String'];
  occurredAt: Scalars['Date'];
};

export type WireTransferPaymentEntity = PaymentEntity & {
  __typename: 'WireTransferPaymentEntity';
  paymentMethod: PaymentMethod;
  accountNumber: Scalars['String'];
  bankName: Scalars['String'];
  routingNumber: Scalars['String'];
  swiftCode: Scalars['String'];
  beneficiaryName: Scalars['String'];
  beneficiaryAddress: WireTransferPaymentEntityBeneficiaryAddress;
  chargeableAmount: MonetaryAmount;
};

export type WireTransferPaymentEntityBeneficiaryAddress = {
  __typename: 'WireTransferPaymentEntityBeneficiaryAddress';
  line1: Scalars['String'];
  line2?: Maybe<Scalars['String']>;
  city: Scalars['String'];
  state: Scalars['String'];
  country: Scalars['String'];
  postalCode: Scalars['String'];
};

export type WokeUpFromSnoozeActivity = LeadActivity & {
  __typename: 'WokeUpFromSnoozeActivity';
  id: Scalars['LeadActivityId'];
  type: LeadActivityType;
  lead: Lead;
  occurredAt: Scalars['Date'];
  snooze: LeadSnooze;
  performedBy: Identity;
};

export enum WorkflowFailureResolution {
  RETRY_WORKFLOW = 'RETRY_WORKFLOW',
  AUTO_ESCALATE = 'AUTO_ESCALATE',
  MANUAL_ESCALATE = 'MANUAL_ESCALATE'
}

export enum WorkflowType {
  BASIC = 'BASIC',
  FULFILLMENT = 'FULFILLMENT'
}

export type YadavSellablePriceSource = SellablePriceSource & {
  __typename: 'YadavSellablePriceSource';
  id: Scalars['SellablePriceSourceId'];
  type: SellablePriceSourceType;
  sellable: Sellable;
  price?: Maybe<MonetaryAmount>;
  bestOfferPrice?: Maybe<MonetaryAmount>;
  cost?: Maybe<MonetaryAmount>;
  expiresAt?: Maybe<Scalars['Date']>;
  fulfillmentChannel?: Maybe<FulfillmentChannel>;
  canRefresh: Scalars['Boolean'];
  willRefresh: Scalars['Boolean'];
  externalId: Scalars['String'];
  certificateUrl?: Maybe<Scalars['String']>;
  estimatedAvailableAt?: Maybe<Scalars['Date']>;
};
